import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _uuid: { input: any; output: any; }
  bigint: { input: any; output: any; }
  citext: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']['input']>;
  _gt?: InputMaybe<Scalars['_uuid']['input']>;
  _gte?: InputMaybe<Scalars['_uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['_uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_uuid']['input']>;
  _lte?: InputMaybe<Scalars['_uuid']['input']>;
  _neq?: InputMaybe<Scalars['_uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']['input']>>;
};

/** columns and relationships of "activity" */
export type Activity = {
  __typename?: 'activity';
  /** An array relationship */
  activity_ratings: Array<Activity_Rating>;
  /** An aggregate relationship */
  activity_ratings_aggregate: Activity_Rating_Aggregate;
  category: Enum_Activity_Category_Enum;
  created_at: Scalars['timestamp']['output'];
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  display_order?: Maybe<Scalars['Int']['output']>;
  header_uri?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  sub_category_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "activity" */
export type ActivityActivity_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


/** columns and relationships of "activity" */
export type ActivityActivity_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};

/** aggregated selection of "activity" */
export type Activity_Aggregate = {
  __typename?: 'activity_aggregate';
  aggregate?: Maybe<Activity_Aggregate_Fields>;
  nodes: Array<Activity>;
};

/** aggregate fields of "activity" */
export type Activity_Aggregate_Fields = {
  __typename?: 'activity_aggregate_fields';
  avg?: Maybe<Activity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Max_Fields>;
  min?: Maybe<Activity_Min_Fields>;
  stddev?: Maybe<Activity_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Sum_Fields>;
  var_pop?: Maybe<Activity_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Var_Samp_Fields>;
  variance?: Maybe<Activity_Variance_Fields>;
};


/** aggregate fields of "activity" */
export type Activity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Activity_Avg_Fields = {
  __typename?: 'activity_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "activity". All fields are combined with a logical 'AND'. */
export type Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Bool_Exp>>;
  _not?: InputMaybe<Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Bool_Exp>>;
  activity_ratings?: InputMaybe<Activity_Rating_Bool_Exp>;
  activity_ratings_aggregate?: InputMaybe<Activity_Rating_Aggregate_Bool_Exp>;
  category?: InputMaybe<Enum_Activity_Category_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  header_uri?: InputMaybe<String_Comparison_Exp>;
  icon_uri?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sub_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity" */
export enum Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityPkey = 'activity_pkey'
}

/** input type for incrementing numeric columns in table "activity" */
export type Activity_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "activity" */
export type Activity_Insert_Input = {
  activity_ratings?: InputMaybe<Activity_Rating_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Enum_Activity_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header_uri?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sub_category_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Activity_Max_Fields = {
  __typename?: 'activity_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header_uri?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sub_category_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Activity_Min_Fields = {
  __typename?: 'activity_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header_uri?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  sub_category_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "activity" */
export type Activity_Mutation_Response = {
  __typename?: 'activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity>;
};

/** input type for inserting object relation for remote table "activity" */
export type Activity_Obj_Rel_Insert_Input = {
  data: Activity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};

/** on_conflict condition type for table "activity" */
export type Activity_On_Conflict = {
  constraint: Activity_Constraint;
  update_columns?: Array<Activity_Update_Column>;
  where?: InputMaybe<Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "activity". */
export type Activity_Order_By = {
  activity_ratings_aggregate?: InputMaybe<Activity_Rating_Aggregate_Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header_uri?: InputMaybe<Order_By>;
  icon_uri?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sub_category_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity */
export type Activity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "activity_rating" */
export type Activity_Rating = {
  __typename?: 'activity_rating';
  activity_id: Scalars['uuid']['output'];
  /** An object relationship */
  activity_selected: Activity;
  client_created_at: Scalars['timestamp']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamp']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  value: Scalars['Int']['output'];
};

/** aggregated selection of "activity_rating" */
export type Activity_Rating_Aggregate = {
  __typename?: 'activity_rating_aggregate';
  aggregate?: Maybe<Activity_Rating_Aggregate_Fields>;
  nodes: Array<Activity_Rating>;
};

export type Activity_Rating_Aggregate_Bool_Exp = {
  count?: InputMaybe<Activity_Rating_Aggregate_Bool_Exp_Count>;
};

export type Activity_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activity_rating" */
export type Activity_Rating_Aggregate_Fields = {
  __typename?: 'activity_rating_aggregate_fields';
  avg?: Maybe<Activity_Rating_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Rating_Max_Fields>;
  min?: Maybe<Activity_Rating_Min_Fields>;
  stddev?: Maybe<Activity_Rating_Stddev_Fields>;
  stddev_pop?: Maybe<Activity_Rating_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Activity_Rating_Stddev_Samp_Fields>;
  sum?: Maybe<Activity_Rating_Sum_Fields>;
  var_pop?: Maybe<Activity_Rating_Var_Pop_Fields>;
  var_samp?: Maybe<Activity_Rating_Var_Samp_Fields>;
  variance?: Maybe<Activity_Rating_Variance_Fields>;
};


/** aggregate fields of "activity_rating" */
export type Activity_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activity_rating" */
export type Activity_Rating_Aggregate_Order_By = {
  avg?: InputMaybe<Activity_Rating_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activity_Rating_Max_Order_By>;
  min?: InputMaybe<Activity_Rating_Min_Order_By>;
  stddev?: InputMaybe<Activity_Rating_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Activity_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Activity_Rating_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Activity_Rating_Sum_Order_By>;
  var_pop?: InputMaybe<Activity_Rating_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Activity_Rating_Var_Samp_Order_By>;
  variance?: InputMaybe<Activity_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "activity_rating" */
export type Activity_Rating_Arr_Rel_Insert_Input = {
  data: Array<Activity_Rating_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_Rating_On_Conflict>;
};

/** aggregate avg on columns */
export type Activity_Rating_Avg_Fields = {
  __typename?: 'activity_rating_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "activity_rating" */
export type Activity_Rating_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "activity_rating". All fields are combined with a logical 'AND'. */
export type Activity_Rating_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Rating_Bool_Exp>>;
  _not?: InputMaybe<Activity_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Rating_Bool_Exp>>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  activity_selected?: InputMaybe<Activity_Bool_Exp>;
  client_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_rating" */
export enum Activity_Rating_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityRatingPkey = 'activity_rating_pkey'
}

/** input type for incrementing numeric columns in table "activity_rating" */
export type Activity_Rating_Inc_Input = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "activity_rating" */
export type Activity_Rating_Insert_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_selected?: InputMaybe<Activity_Obj_Rel_Insert_Input>;
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Activity_Rating_Max_Fields = {
  __typename?: 'activity_rating_max_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  client_created_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "activity_rating" */
export type Activity_Rating_Max_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activity_Rating_Min_Fields = {
  __typename?: 'activity_rating_min_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  client_created_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "activity_rating" */
export type Activity_Rating_Min_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activity_rating" */
export type Activity_Rating_Mutation_Response = {
  __typename?: 'activity_rating_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Rating>;
};

/** on_conflict condition type for table "activity_rating" */
export type Activity_Rating_On_Conflict = {
  constraint: Activity_Rating_Constraint;
  update_columns?: Array<Activity_Rating_Update_Column>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_rating". */
export type Activity_Rating_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  activity_selected?: InputMaybe<Activity_Order_By>;
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_rating */
export type Activity_Rating_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_rating" */
export enum Activity_Rating_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "activity_rating" */
export type Activity_Rating_Set_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Activity_Rating_Stddev_Fields = {
  __typename?: 'activity_rating_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "activity_rating" */
export type Activity_Rating_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Activity_Rating_Stddev_Pop_Fields = {
  __typename?: 'activity_rating_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "activity_rating" */
export type Activity_Rating_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Activity_Rating_Stddev_Samp_Fields = {
  __typename?: 'activity_rating_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "activity_rating" */
export type Activity_Rating_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "activity_rating" */
export type Activity_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Rating_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Activity_Rating_Sum_Fields = {
  __typename?: 'activity_rating_sum_fields';
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "activity_rating" */
export type Activity_Rating_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "activity_rating" */
export enum Activity_Rating_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Activity_Rating_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Rating_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Rating_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Rating_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Rating_Var_Pop_Fields = {
  __typename?: 'activity_rating_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "activity_rating" */
export type Activity_Rating_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Activity_Rating_Var_Samp_Fields = {
  __typename?: 'activity_rating_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "activity_rating" */
export type Activity_Rating_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Activity_Rating_Variance_Fields = {
  __typename?: 'activity_rating_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "activity_rating" */
export type Activity_Rating_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "activity_resource" */
export type Activity_Resource = {
  __typename?: 'activity_resource';
  activity_id: Scalars['uuid']['output'];
  activity_resource_category_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
  uri: Scalars['String']['output'];
};

/** aggregated selection of "activity_resource" */
export type Activity_Resource_Aggregate = {
  __typename?: 'activity_resource_aggregate';
  aggregate?: Maybe<Activity_Resource_Aggregate_Fields>;
  nodes: Array<Activity_Resource>;
};

/** aggregate fields of "activity_resource" */
export type Activity_Resource_Aggregate_Fields = {
  __typename?: 'activity_resource_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Resource_Max_Fields>;
  min?: Maybe<Activity_Resource_Min_Fields>;
};


/** aggregate fields of "activity_resource" */
export type Activity_Resource_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Resource_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_resource". All fields are combined with a logical 'AND'. */
export type Activity_Resource_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Resource_Bool_Exp>>;
  _not?: InputMaybe<Activity_Resource_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Resource_Bool_Exp>>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  activity_resource_category_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  uri?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "activity_resource_category" */
export type Activity_Resource_Category = {
  __typename?: 'activity_resource_category';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon_name?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  resource_type: Enum_Activity_Resource_Type_Enum;
};

/** aggregated selection of "activity_resource_category" */
export type Activity_Resource_Category_Aggregate = {
  __typename?: 'activity_resource_category_aggregate';
  aggregate?: Maybe<Activity_Resource_Category_Aggregate_Fields>;
  nodes: Array<Activity_Resource_Category>;
};

/** aggregate fields of "activity_resource_category" */
export type Activity_Resource_Category_Aggregate_Fields = {
  __typename?: 'activity_resource_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Resource_Category_Max_Fields>;
  min?: Maybe<Activity_Resource_Category_Min_Fields>;
};


/** aggregate fields of "activity_resource_category" */
export type Activity_Resource_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Resource_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_resource_category". All fields are combined with a logical 'AND'. */
export type Activity_Resource_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Resource_Category_Bool_Exp>>;
  _not?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Resource_Category_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  icon_name?: InputMaybe<String_Comparison_Exp>;
  icon_uri?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<Enum_Activity_Resource_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_resource_category" */
export enum Activity_Resource_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityResourceCategoryPkey = 'activity_resource_category_pkey'
}

/** input type for inserting data into table "activity_resource_category" */
export type Activity_Resource_Category_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon_name?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Enum_Activity_Resource_Type_Enum>;
};

/** aggregate max on columns */
export type Activity_Resource_Category_Max_Fields = {
  __typename?: 'activity_resource_category_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon_name?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Activity_Resource_Category_Min_Fields = {
  __typename?: 'activity_resource_category_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon_name?: Maybe<Scalars['String']['output']>;
  icon_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "activity_resource_category" */
export type Activity_Resource_Category_Mutation_Response = {
  __typename?: 'activity_resource_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Resource_Category>;
};

/** on_conflict condition type for table "activity_resource_category" */
export type Activity_Resource_Category_On_Conflict = {
  constraint: Activity_Resource_Category_Constraint;
  update_columns?: Array<Activity_Resource_Category_Update_Column>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_resource_category". */
export type Activity_Resource_Category_Order_By = {
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  icon_name?: InputMaybe<Order_By>;
  icon_uri?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_resource_category */
export type Activity_Resource_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_resource_category" */
export enum Activity_Resource_Category_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  IconName = 'icon_name',
  /** column name */
  IconUri = 'icon_uri',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceType = 'resource_type'
}

/** input type for updating data in table "activity_resource_category" */
export type Activity_Resource_Category_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon_name?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Enum_Activity_Resource_Type_Enum>;
};

/** Streaming cursor of the table "activity_resource_category" */
export type Activity_Resource_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Resource_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Resource_Category_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon_name?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  resource_type?: InputMaybe<Enum_Activity_Resource_Type_Enum>;
};

/** update columns of table "activity_resource_category" */
export enum Activity_Resource_Category_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  IconName = 'icon_name',
  /** column name */
  IconUri = 'icon_uri',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceType = 'resource_type'
}

export type Activity_Resource_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Resource_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Resource_Category_Bool_Exp;
};

/** unique or primary key constraints on table "activity_resource" */
export enum Activity_Resource_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivityResourcePkey = 'activity_resource_pkey'
}

/** input type for inserting data into table "activity_resource" */
export type Activity_Resource_Insert_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_resource_category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Activity_Resource_Max_Fields = {
  __typename?: 'activity_resource_max_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  activity_resource_category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Activity_Resource_Min_Fields = {
  __typename?: 'activity_resource_min_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  activity_resource_category_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "activity_resource" */
export type Activity_Resource_Mutation_Response = {
  __typename?: 'activity_resource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Resource>;
};

/** on_conflict condition type for table "activity_resource" */
export type Activity_Resource_On_Conflict = {
  constraint: Activity_Resource_Constraint;
  update_columns?: Array<Activity_Resource_Update_Column>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_resource". */
export type Activity_Resource_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  activity_resource_category_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uri?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_resource */
export type Activity_Resource_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_resource" */
export enum Activity_Resource_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityResourceCategoryId = 'activity_resource_category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri'
}

/** input type for updating data in table "activity_resource" */
export type Activity_Resource_Set_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_resource_category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activity_resource" */
export type Activity_Resource_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Resource_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Resource_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_resource_category_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "activity_resource" */
export enum Activity_Resource_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityResourceCategoryId = 'activity_resource_category_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Uri = 'uri'
}

export type Activity_Resource_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Resource_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Resource_Bool_Exp;
};

/** select columns of table "activity" */
export enum Activity_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  HeaderUri = 'header_uri',
  /** column name */
  IconUri = 'icon_uri',
  /** column name */
  Id = 'id',
  /** column name */
  SubCategoryId = 'sub_category_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "activity" */
export type Activity_Set_Input = {
  category?: InputMaybe<Enum_Activity_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header_uri?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sub_category_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Activity_Stddev_Fields = {
  __typename?: 'activity_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Activity_Stddev_Pop_Fields = {
  __typename?: 'activity_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Activity_Stddev_Samp_Fields = {
  __typename?: 'activity_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "activity" */
export type Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Enum_Activity_Category_Enum>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header_uri?: InputMaybe<Scalars['String']['input']>;
  icon_uri?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  sub_category_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** columns and relationships of "activity_sub_category" */
export type Activity_Sub_Category = {
  __typename?: 'activity_sub_category';
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "activity_sub_category" */
export type Activity_Sub_Category_Aggregate = {
  __typename?: 'activity_sub_category_aggregate';
  aggregate?: Maybe<Activity_Sub_Category_Aggregate_Fields>;
  nodes: Array<Activity_Sub_Category>;
};

/** aggregate fields of "activity_sub_category" */
export type Activity_Sub_Category_Aggregate_Fields = {
  __typename?: 'activity_sub_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Sub_Category_Max_Fields>;
  min?: Maybe<Activity_Sub_Category_Min_Fields>;
};


/** aggregate fields of "activity_sub_category" */
export type Activity_Sub_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Sub_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_sub_category". All fields are combined with a logical 'AND'. */
export type Activity_Sub_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Sub_Category_Bool_Exp>>;
  _not?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Sub_Category_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_sub_category" */
export enum Activity_Sub_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivitySubCategoryPkey = 'activity_sub_category_pkey'
}

/** input type for inserting data into table "activity_sub_category" */
export type Activity_Sub_Category_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Activity_Sub_Category_Max_Fields = {
  __typename?: 'activity_sub_category_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Activity_Sub_Category_Min_Fields = {
  __typename?: 'activity_sub_category_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "activity_sub_category" */
export type Activity_Sub_Category_Mutation_Response = {
  __typename?: 'activity_sub_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Sub_Category>;
};

/** on_conflict condition type for table "activity_sub_category" */
export type Activity_Sub_Category_On_Conflict = {
  constraint: Activity_Sub_Category_Constraint;
  update_columns?: Array<Activity_Sub_Category_Update_Column>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_sub_category". */
export type Activity_Sub_Category_Order_By = {
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_sub_category */
export type Activity_Sub_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_sub_category" */
export enum Activity_Sub_Category_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "activity_sub_category" */
export type Activity_Sub_Category_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "activity_sub_category" */
export type Activity_Sub_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Sub_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Sub_Category_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "activity_sub_category" */
export enum Activity_Sub_Category_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

export type Activity_Sub_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Sub_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Sub_Category_Bool_Exp;
};

/** columns and relationships of "activity_suggested_activities" */
export type Activity_Suggested_Activities = {
  __typename?: 'activity_suggested_activities';
  activity_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  response: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "activity_suggested_activities" */
export type Activity_Suggested_Activities_Aggregate = {
  __typename?: 'activity_suggested_activities_aggregate';
  aggregate?: Maybe<Activity_Suggested_Activities_Aggregate_Fields>;
  nodes: Array<Activity_Suggested_Activities>;
};

/** aggregate fields of "activity_suggested_activities" */
export type Activity_Suggested_Activities_Aggregate_Fields = {
  __typename?: 'activity_suggested_activities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Suggested_Activities_Max_Fields>;
  min?: Maybe<Activity_Suggested_Activities_Min_Fields>;
};


/** aggregate fields of "activity_suggested_activities" */
export type Activity_Suggested_Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Suggested_Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_suggested_activities". All fields are combined with a logical 'AND'. */
export type Activity_Suggested_Activities_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Suggested_Activities_Bool_Exp>>;
  _not?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Suggested_Activities_Bool_Exp>>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  response?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "activity_suggested_activities" */
export enum Activity_Suggested_Activities_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivitySuggestedActivitiesPkey = 'activity_suggested_activities_pkey'
}

/** input type for inserting data into table "activity_suggested_activities" */
export type Activity_Suggested_Activities_Insert_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Activity_Suggested_Activities_Max_Fields = {
  __typename?: 'activity_suggested_activities_max_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Activity_Suggested_Activities_Min_Fields = {
  __typename?: 'activity_suggested_activities_min_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "activity_suggested_activities" */
export type Activity_Suggested_Activities_Mutation_Response = {
  __typename?: 'activity_suggested_activities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_Suggested_Activities>;
};

/** on_conflict condition type for table "activity_suggested_activities" */
export type Activity_Suggested_Activities_On_Conflict = {
  constraint: Activity_Suggested_Activities_Constraint;
  update_columns?: Array<Activity_Suggested_Activities_Update_Column>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "activity_suggested_activities". */
export type Activity_Suggested_Activities_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activity_suggested_activities */
export type Activity_Suggested_Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activity_suggested_activities" */
export enum Activity_Suggested_Activities_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Response = 'response',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "activity_suggested_activities" */
export type Activity_Suggested_Activities_Set_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "activity_suggested_activities" */
export type Activity_Suggested_Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Suggested_Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Suggested_Activities_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "activity_suggested_activities" */
export enum Activity_Suggested_Activities_Update_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Response = 'response',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Activity_Suggested_Activities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Suggested_Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Suggested_Activities_Bool_Exp;
};

/** aggregate sum on columns */
export type Activity_Sum_Fields = {
  __typename?: 'activity_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "activity" */
export enum Activity_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  HeaderUri = 'header_uri',
  /** column name */
  IconUri = 'icon_uri',
  /** column name */
  Id = 'id',
  /** column name */
  SubCategoryId = 'sub_category_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Activity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Activity_Var_Pop_Fields = {
  __typename?: 'activity_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Activity_Var_Samp_Fields = {
  __typename?: 'activity_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Activity_Variance_Fields = {
  __typename?: 'activity_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Store individual question responses */
export type Assessment_Answers = {
  __typename?: 'assessment_answers';
  /** The question result (stringified; empty string allowed for note questions) */
  answer: Scalars['String']['output'];
  /** When user answered the question on device */
  client_created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  custom_prompt?: Maybe<Assessment_Question_Custom_Prompt>;
  custom_prompt_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  question: Assessment_Questions;
  question_id: Scalars['uuid']['output'];
  /** An object relationship */
  take: Assessment_Takes;
  take_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "assessment_answers" */
export type Assessment_Answers_Aggregate = {
  __typename?: 'assessment_answers_aggregate';
  aggregate?: Maybe<Assessment_Answers_Aggregate_Fields>;
  nodes: Array<Assessment_Answers>;
};

export type Assessment_Answers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assessment_Answers_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Answers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Answers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assessment_answers" */
export type Assessment_Answers_Aggregate_Fields = {
  __typename?: 'assessment_answers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Answers_Max_Fields>;
  min?: Maybe<Assessment_Answers_Min_Fields>;
};


/** aggregate fields of "assessment_answers" */
export type Assessment_Answers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assessment_answers" */
export type Assessment_Answers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Answers_Max_Order_By>;
  min?: InputMaybe<Assessment_Answers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "assessment_answers" */
export type Assessment_Answers_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Answers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Answers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "assessment_answers". All fields are combined with a logical 'AND'. */
export type Assessment_Answers_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Answers_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Answers_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Answers_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  client_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_prompt?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
  custom_prompt_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Assessment_Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  take?: InputMaybe<Assessment_Takes_Bool_Exp>;
  take_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_answers" */
export enum Assessment_Answers_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentAnswersPkey = 'assessment_answers_pkey'
}

/** input type for inserting data into table "assessment_answers" */
export type Assessment_Answers_Insert_Input = {
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** When user answered the question on device */
  client_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_prompt?: InputMaybe<Assessment_Question_Custom_Prompt_Obj_Rel_Insert_Input>;
  custom_prompt_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question?: InputMaybe<Assessment_Questions_Obj_Rel_Insert_Input>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  take?: InputMaybe<Assessment_Takes_Obj_Rel_Insert_Input>;
  take_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessment_Answers_Max_Fields = {
  __typename?: 'assessment_answers_max_fields';
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: Maybe<Scalars['String']['output']>;
  /** When user answered the question on device */
  client_created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_prompt_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  take_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "assessment_answers" */
export type Assessment_Answers_Max_Order_By = {
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: InputMaybe<Order_By>;
  /** When user answered the question on device */
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_prompt_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  take_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Answers_Min_Fields = {
  __typename?: 'assessment_answers_min_fields';
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: Maybe<Scalars['String']['output']>;
  /** When user answered the question on device */
  client_created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  custom_prompt_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  take_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "assessment_answers" */
export type Assessment_Answers_Min_Order_By = {
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: InputMaybe<Order_By>;
  /** When user answered the question on device */
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_prompt_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question_id?: InputMaybe<Order_By>;
  take_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment_answers" */
export type Assessment_Answers_Mutation_Response = {
  __typename?: 'assessment_answers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Answers>;
};

/** on_conflict condition type for table "assessment_answers" */
export type Assessment_Answers_On_Conflict = {
  constraint: Assessment_Answers_Constraint;
  update_columns?: Array<Assessment_Answers_Update_Column>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_answers". */
export type Assessment_Answers_Order_By = {
  answer?: InputMaybe<Order_By>;
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_prompt?: InputMaybe<Assessment_Question_Custom_Prompt_Order_By>;
  custom_prompt_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Assessment_Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  take?: InputMaybe<Assessment_Takes_Order_By>;
  take_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_answers */
export type Assessment_Answers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_answers" */
export enum Assessment_Answers_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomPromptId = 'custom_prompt_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  TakeId = 'take_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assessment_answers" */
export type Assessment_Answers_Set_Input = {
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** When user answered the question on device */
  client_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_prompt_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  take_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "assessment_answers" */
export type Assessment_Answers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Answers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Answers_Stream_Cursor_Value_Input = {
  /** The question result (stringified; empty string allowed for note questions) */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** When user answered the question on device */
  client_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_prompt_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  take_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "assessment_answers" */
export enum Assessment_Answers_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomPromptId = 'custom_prompt_id',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  TakeId = 'take_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessment_Answers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Answers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Answers_Bool_Exp;
};

/** Conditional navigation logic based on question answers */
export type Assessment_Branching_Rules = {
  __typename?: 'assessment_branching_rules';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  next_page: Assessment_Pages;
  /** Target page ID */
  next_page_id: Scalars['uuid']['output'];
  /** An object relationship */
  page: Assessment_Pages;
  /** Source page */
  page_id: Scalars['uuid']['output'];
  /** Evaluation order (lower = higher priority) */
  priority: Scalars['Int']['output'];
  /** An object relationship */
  question: Assessment_Questions;
  /** Question driving the branch */
  question_id: Scalars['uuid']['output'];
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type: Scalars['String']['output'];
  /** Comparison value ("true", "5") */
  rule_value: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "assessment_branching_rules" */
export type Assessment_Branching_Rules_Aggregate = {
  __typename?: 'assessment_branching_rules_aggregate';
  aggregate?: Maybe<Assessment_Branching_Rules_Aggregate_Fields>;
  nodes: Array<Assessment_Branching_Rules>;
};

/** aggregate fields of "assessment_branching_rules" */
export type Assessment_Branching_Rules_Aggregate_Fields = {
  __typename?: 'assessment_branching_rules_aggregate_fields';
  avg?: Maybe<Assessment_Branching_Rules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Branching_Rules_Max_Fields>;
  min?: Maybe<Assessment_Branching_Rules_Min_Fields>;
  stddev?: Maybe<Assessment_Branching_Rules_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Branching_Rules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Branching_Rules_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Branching_Rules_Sum_Fields>;
  var_pop?: Maybe<Assessment_Branching_Rules_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Branching_Rules_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Branching_Rules_Variance_Fields>;
};


/** aggregate fields of "assessment_branching_rules" */
export type Assessment_Branching_Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Branching_Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Assessment_Branching_Rules_Avg_Fields = {
  __typename?: 'assessment_branching_rules_avg_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "assessment_branching_rules". All fields are combined with a logical 'AND'. */
export type Assessment_Branching_Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Branching_Rules_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Branching_Rules_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  next_page?: InputMaybe<Assessment_Pages_Bool_Exp>;
  next_page_id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Assessment_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<Assessment_Questions_Bool_Exp>;
  question_id?: InputMaybe<Uuid_Comparison_Exp>;
  rule_type?: InputMaybe<String_Comparison_Exp>;
  rule_value?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_branching_rules" */
export enum Assessment_Branching_Rules_Constraint {
  /** unique or primary key constraint on columns "page_id", "priority" */
  AssessmentBranchingRulesPagePriorityKey = 'assessment_branching_rules_page_priority_key',
  /** unique or primary key constraint on columns "id" */
  AssessmentBranchingRulesPkey = 'assessment_branching_rules_pkey'
}

/** input type for incrementing numeric columns in table "assessment_branching_rules" */
export type Assessment_Branching_Rules_Inc_Input = {
  /** Evaluation order (lower = higher priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assessment_branching_rules" */
export type Assessment_Branching_Rules_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  next_page?: InputMaybe<Assessment_Pages_Obj_Rel_Insert_Input>;
  /** Target page ID */
  next_page_id?: InputMaybe<Scalars['uuid']['input']>;
  page?: InputMaybe<Assessment_Pages_Obj_Rel_Insert_Input>;
  /** Source page */
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Evaluation order (lower = higher priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Assessment_Questions_Obj_Rel_Insert_Input>;
  /** Question driving the branch */
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type?: InputMaybe<Scalars['String']['input']>;
  /** Comparison value ("true", "5") */
  rule_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessment_Branching_Rules_Max_Fields = {
  __typename?: 'assessment_branching_rules_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Target page ID */
  next_page_id?: Maybe<Scalars['uuid']['output']>;
  /** Source page */
  page_id?: Maybe<Scalars['uuid']['output']>;
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Question driving the branch */
  question_id?: Maybe<Scalars['uuid']['output']>;
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type?: Maybe<Scalars['String']['output']>;
  /** Comparison value ("true", "5") */
  rule_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Assessment_Branching_Rules_Min_Fields = {
  __typename?: 'assessment_branching_rules_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Target page ID */
  next_page_id?: Maybe<Scalars['uuid']['output']>;
  /** Source page */
  page_id?: Maybe<Scalars['uuid']['output']>;
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Int']['output']>;
  /** Question driving the branch */
  question_id?: Maybe<Scalars['uuid']['output']>;
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type?: Maybe<Scalars['String']['output']>;
  /** Comparison value ("true", "5") */
  rule_value?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "assessment_branching_rules" */
export type Assessment_Branching_Rules_Mutation_Response = {
  __typename?: 'assessment_branching_rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Branching_Rules>;
};

/** on_conflict condition type for table "assessment_branching_rules" */
export type Assessment_Branching_Rules_On_Conflict = {
  constraint: Assessment_Branching_Rules_Constraint;
  update_columns?: Array<Assessment_Branching_Rules_Update_Column>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_branching_rules". */
export type Assessment_Branching_Rules_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_page?: InputMaybe<Assessment_Pages_Order_By>;
  next_page_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Assessment_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  question?: InputMaybe<Assessment_Questions_Order_By>;
  question_id?: InputMaybe<Order_By>;
  rule_type?: InputMaybe<Order_By>;
  rule_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_branching_rules */
export type Assessment_Branching_Rules_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_branching_rules" */
export enum Assessment_Branching_Rules_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NextPageId = 'next_page_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RuleType = 'rule_type',
  /** column name */
  RuleValue = 'rule_value',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assessment_branching_rules" */
export type Assessment_Branching_Rules_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Target page ID */
  next_page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Source page */
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Evaluation order (lower = higher priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Question driving the branch */
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type?: InputMaybe<Scalars['String']['input']>;
  /** Comparison value ("true", "5") */
  rule_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Assessment_Branching_Rules_Stddev_Fields = {
  __typename?: 'assessment_branching_rules_stddev_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Branching_Rules_Stddev_Pop_Fields = {
  __typename?: 'assessment_branching_rules_stddev_pop_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Branching_Rules_Stddev_Samp_Fields = {
  __typename?: 'assessment_branching_rules_stddev_samp_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "assessment_branching_rules" */
export type Assessment_Branching_Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Branching_Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Branching_Rules_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Target page ID */
  next_page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Source page */
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Evaluation order (lower = higher priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Question driving the branch */
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Operator: eq, neq, gt, lt, gte, lte */
  rule_type?: InputMaybe<Scalars['String']['input']>;
  /** Comparison value ("true", "5") */
  rule_value?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Assessment_Branching_Rules_Sum_Fields = {
  __typename?: 'assessment_branching_rules_sum_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "assessment_branching_rules" */
export enum Assessment_Branching_Rules_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NextPageId = 'next_page_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  QuestionId = 'question_id',
  /** column name */
  RuleType = 'rule_type',
  /** column name */
  RuleValue = 'rule_value',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessment_Branching_Rules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessment_Branching_Rules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Branching_Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Branching_Rules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessment_Branching_Rules_Var_Pop_Fields = {
  __typename?: 'assessment_branching_rules_var_pop_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Assessment_Branching_Rules_Var_Samp_Fields = {
  __typename?: 'assessment_branching_rules_var_samp_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Assessment_Branching_Rules_Variance_Fields = {
  __typename?: 'assessment_branching_rules_variance_fields';
  /** Evaluation order (lower = higher priority) */
  priority?: Maybe<Scalars['Float']['output']>;
};

/** Pages within each assessment */
export type Assessment_Pages = {
  __typename?: 'assessment_pages';
  /** An object relationship */
  assessment: Assessments;
  assessment_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Zero-based order for progress display */
  display_order: Scalars['Int']['output'];
  /** Application page identifier ("page_1") */
  id: Scalars['uuid']['output'];
  /** An array relationship */
  questions: Array<Assessment_Questions>;
  /** An aggregate relationship */
  questions_aggregate: Assessment_Questions_Aggregate;
  /** Display warning on page completion */
  show_caution_modal: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Pages within each assessment */
export type Assessment_PagesQuestionsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


/** Pages within each assessment */
export type Assessment_PagesQuestions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};

/** aggregated selection of "assessment_pages" */
export type Assessment_Pages_Aggregate = {
  __typename?: 'assessment_pages_aggregate';
  aggregate?: Maybe<Assessment_Pages_Aggregate_Fields>;
  nodes: Array<Assessment_Pages>;
};

export type Assessment_Pages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Assessment_Pages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Assessment_Pages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Assessment_Pages_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Pages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Assessment_Pages_Select_Column_Assessment_Pages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Pages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assessment_Pages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Assessment_Pages_Select_Column_Assessment_Pages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Pages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Assessment_Pages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Pages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assessment_pages" */
export type Assessment_Pages_Aggregate_Fields = {
  __typename?: 'assessment_pages_aggregate_fields';
  avg?: Maybe<Assessment_Pages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Pages_Max_Fields>;
  min?: Maybe<Assessment_Pages_Min_Fields>;
  stddev?: Maybe<Assessment_Pages_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Pages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Pages_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Pages_Sum_Fields>;
  var_pop?: Maybe<Assessment_Pages_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Pages_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Pages_Variance_Fields>;
};


/** aggregate fields of "assessment_pages" */
export type Assessment_Pages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assessment_pages" */
export type Assessment_Pages_Aggregate_Order_By = {
  avg?: InputMaybe<Assessment_Pages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Pages_Max_Order_By>;
  min?: InputMaybe<Assessment_Pages_Min_Order_By>;
  stddev?: InputMaybe<Assessment_Pages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assessment_Pages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assessment_Pages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assessment_Pages_Sum_Order_By>;
  var_pop?: InputMaybe<Assessment_Pages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assessment_Pages_Var_Samp_Order_By>;
  variance?: InputMaybe<Assessment_Pages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assessment_pages" */
export type Assessment_Pages_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Pages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Pages_On_Conflict>;
};

/** aggregate avg on columns */
export type Assessment_Pages_Avg_Fields = {
  __typename?: 'assessment_pages_avg_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assessment_pages" */
export type Assessment_Pages_Avg_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assessment_pages". All fields are combined with a logical 'AND'. */
export type Assessment_Pages_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Pages_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Pages_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Pages_Bool_Exp>>;
  assessment?: InputMaybe<Assessments_Bool_Exp>;
  assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questions?: InputMaybe<Assessment_Questions_Bool_Exp>;
  questions_aggregate?: InputMaybe<Assessment_Questions_Aggregate_Bool_Exp>;
  show_caution_modal?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_pages" */
export enum Assessment_Pages_Constraint {
  /** unique or primary key constraint on columns "assessment_id", "id" */
  AssessmentPagesAssessmentIdIdKey = 'assessment_pages_assessment_id_id_key',
  /** unique or primary key constraint on columns "id" */
  AssessmentPagesPkey = 'assessment_pages_pkey'
}

/** input type for incrementing numeric columns in table "assessment_pages" */
export type Assessment_Pages_Inc_Input = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assessment_pages" */
export type Assessment_Pages_Insert_Input = {
  assessment?: InputMaybe<Assessments_Obj_Rel_Insert_Input>;
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Application page identifier ("page_1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  questions?: InputMaybe<Assessment_Questions_Arr_Rel_Insert_Input>;
  /** Display warning on page completion */
  show_caution_modal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessment_Pages_Max_Fields = {
  __typename?: 'assessment_pages_max_fields';
  assessment_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Int']['output']>;
  /** Application page identifier ("page_1") */
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "assessment_pages" */
export type Assessment_Pages_Max_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
  /** Application page identifier ("page_1") */
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Pages_Min_Fields = {
  __typename?: 'assessment_pages_min_fields';
  assessment_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Int']['output']>;
  /** Application page identifier ("page_1") */
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "assessment_pages" */
export type Assessment_Pages_Min_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
  /** Application page identifier ("page_1") */
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment_pages" */
export type Assessment_Pages_Mutation_Response = {
  __typename?: 'assessment_pages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Pages>;
};

/** input type for inserting object relation for remote table "assessment_pages" */
export type Assessment_Pages_Obj_Rel_Insert_Input = {
  data: Assessment_Pages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Pages_On_Conflict>;
};

/** on_conflict condition type for table "assessment_pages" */
export type Assessment_Pages_On_Conflict = {
  constraint: Assessment_Pages_Constraint;
  update_columns?: Array<Assessment_Pages_Update_Column>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_pages". */
export type Assessment_Pages_Order_By = {
  assessment?: InputMaybe<Assessments_Order_By>;
  assessment_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questions_aggregate?: InputMaybe<Assessment_Questions_Aggregate_Order_By>;
  show_caution_modal?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_pages */
export type Assessment_Pages_Pk_Columns_Input = {
  /** Application page identifier ("page_1") */
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_pages" */
export enum Assessment_Pages_Select_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ShowCautionModal = 'show_caution_modal',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "assessment_pages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assessment_pages" */
export enum Assessment_Pages_Select_Column_Assessment_Pages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ShowCautionModal = 'show_caution_modal'
}

/** select "assessment_pages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assessment_pages" */
export enum Assessment_Pages_Select_Column_Assessment_Pages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ShowCautionModal = 'show_caution_modal'
}

/** input type for updating data in table "assessment_pages" */
export type Assessment_Pages_Set_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Application page identifier ("page_1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Display warning on page completion */
  show_caution_modal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Assessment_Pages_Stddev_Fields = {
  __typename?: 'assessment_pages_stddev_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assessment_pages" */
export type Assessment_Pages_Stddev_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Pages_Stddev_Pop_Fields = {
  __typename?: 'assessment_pages_stddev_pop_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assessment_pages" */
export type Assessment_Pages_Stddev_Pop_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Pages_Stddev_Samp_Fields = {
  __typename?: 'assessment_pages_stddev_samp_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assessment_pages" */
export type Assessment_Pages_Stddev_Samp_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assessment_pages" */
export type Assessment_Pages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Pages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Pages_Stream_Cursor_Value_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Application page identifier ("page_1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Display warning on page completion */
  show_caution_modal?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Assessment_Pages_Sum_Fields = {
  __typename?: 'assessment_pages_sum_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "assessment_pages" */
export type Assessment_Pages_Sum_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "assessment_pages" */
export enum Assessment_Pages_Update_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ShowCautionModal = 'show_caution_modal',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessment_Pages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessment_Pages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Pages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Pages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessment_Pages_Var_Pop_Fields = {
  __typename?: 'assessment_pages_var_pop_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assessment_pages" */
export type Assessment_Pages_Var_Pop_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assessment_Pages_Var_Samp_Fields = {
  __typename?: 'assessment_pages_var_samp_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assessment_pages" */
export type Assessment_Pages_Var_Samp_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assessment_Pages_Variance_Fields = {
  __typename?: 'assessment_pages_variance_fields';
  /** Zero-based order for progress display */
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assessment_pages" */
export type Assessment_Pages_Variance_Order_By = {
  /** Zero-based order for progress display */
  display_order?: InputMaybe<Order_By>;
};

/** Per-client custom urge text for assessment questions */
export type Assessment_Question_Custom_Prompt = {
  __typename?: 'assessment_question_custom_prompt';
  /** An object relationship */
  assessment_question: Assessment_Questions;
  assessment_question_id: Scalars['uuid']['output'];
  /** An object relationship */
  client: Users;
  client_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  practitioner: Users;
  practitioner_id: Scalars['uuid']['output'];
  /** Text displayed to the client in Vira Mobile */
  text: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Aggregate = {
  __typename?: 'assessment_question_custom_prompt_aggregate';
  aggregate?: Maybe<Assessment_Question_Custom_Prompt_Aggregate_Fields>;
  nodes: Array<Assessment_Question_Custom_Prompt>;
};

/** aggregate fields of "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Aggregate_Fields = {
  __typename?: 'assessment_question_custom_prompt_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Question_Custom_Prompt_Max_Fields>;
  min?: Maybe<Assessment_Question_Custom_Prompt_Min_Fields>;
};


/** aggregate fields of "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "assessment_question_custom_prompt". All fields are combined with a logical 'AND'. */
export type Assessment_Question_Custom_Prompt_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Bool_Exp>>;
  assessment_question?: InputMaybe<Assessment_Questions_Bool_Exp>;
  assessment_question_id?: InputMaybe<Uuid_Comparison_Exp>;
  client?: InputMaybe<Users_Bool_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  explanation_text?: InputMaybe<String_Comparison_Exp>;
  header?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_question_custom_prompt" */
export enum Assessment_Question_Custom_Prompt_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentQuestionCustomPromptPkey = 'assessment_question_custom_prompt_pkey'
}

/** input type for inserting data into table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Insert_Input = {
  assessment_question?: InputMaybe<Assessment_Questions_Obj_Rel_Insert_Input>;
  assessment_question_id?: InputMaybe<Scalars['uuid']['input']>;
  client?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Text displayed to the client in Vira Mobile */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessment_Question_Custom_Prompt_Max_Fields = {
  __typename?: 'assessment_question_custom_prompt_max_fields';
  assessment_question_id?: Maybe<Scalars['uuid']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  /** Text displayed to the client in Vira Mobile */
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Assessment_Question_Custom_Prompt_Min_Fields = {
  __typename?: 'assessment_question_custom_prompt_min_fields';
  assessment_question_id?: Maybe<Scalars['uuid']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  /** Text displayed to the client in Vira Mobile */
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Mutation_Response = {
  __typename?: 'assessment_question_custom_prompt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Question_Custom_Prompt>;
};

/** input type for inserting object relation for remote table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Obj_Rel_Insert_Input = {
  data: Assessment_Question_Custom_Prompt_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Question_Custom_Prompt_On_Conflict>;
};

/** on_conflict condition type for table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_On_Conflict = {
  constraint: Assessment_Question_Custom_Prompt_Constraint;
  update_columns?: Array<Assessment_Question_Custom_Prompt_Update_Column>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_question_custom_prompt". */
export type Assessment_Question_Custom_Prompt_Order_By = {
  assessment_question?: InputMaybe<Assessment_Questions_Order_By>;
  assessment_question_id?: InputMaybe<Order_By>;
  client?: InputMaybe<Users_Order_By>;
  client_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  explanation_text?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_question_custom_prompt */
export type Assessment_Question_Custom_Prompt_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_question_custom_prompt" */
export enum Assessment_Question_Custom_Prompt_Select_Column {
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExplanationText = 'explanation_text',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Set_Input = {
  assessment_question_id?: InputMaybe<Scalars['uuid']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Text displayed to the client in Vira Mobile */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "assessment_question_custom_prompt" */
export type Assessment_Question_Custom_Prompt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Question_Custom_Prompt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Question_Custom_Prompt_Stream_Cursor_Value_Input = {
  assessment_question_id?: InputMaybe<Scalars['uuid']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Text to display in the DBT table in Vira Pro */
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Text displayed to the client in Vira Mobile */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "assessment_question_custom_prompt" */
export enum Assessment_Question_Custom_Prompt_Update_Column {
  /** column name */
  AssessmentQuestionId = 'assessment_question_id',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExplanationText = 'explanation_text',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessment_Question_Custom_Prompt_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Question_Custom_Prompt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Question_Custom_Prompt_Bool_Exp;
};

/** Individual questions per page */
export type Assessment_Questions = {
  __typename?: 'assessment_questions';
  created_at: Scalars['timestamptz']['output'];
  display_order: Scalars['Int']['output'];
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Application question identifier ("q1") */
  id: Scalars['uuid']['output'];
  /** An object relationship */
  page: Assessment_Pages;
  page_id: Scalars['uuid']['output'];
  /** Type-specific configuration (options, min/max) */
  properties?: Maybe<Scalars['jsonb']['output']>;
  /** Type: boolean, time, select, switchboard, note, scale, number */
  question_type: Enum_Question_Type_Enum;
  /** Question prompt */
  text: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Individual questions per page */
export type Assessment_QuestionsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "assessment_questions" */
export type Assessment_Questions_Aggregate = {
  __typename?: 'assessment_questions_aggregate';
  aggregate?: Maybe<Assessment_Questions_Aggregate_Fields>;
  nodes: Array<Assessment_Questions>;
};

export type Assessment_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assessment_Questions_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assessment_questions" */
export type Assessment_Questions_Aggregate_Fields = {
  __typename?: 'assessment_questions_aggregate_fields';
  avg?: Maybe<Assessment_Questions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Questions_Max_Fields>;
  min?: Maybe<Assessment_Questions_Min_Fields>;
  stddev?: Maybe<Assessment_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Assessment_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessment_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Assessment_Questions_Sum_Fields>;
  var_pop?: Maybe<Assessment_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Assessment_Questions_Var_Samp_Fields>;
  variance?: Maybe<Assessment_Questions_Variance_Fields>;
};


/** aggregate fields of "assessment_questions" */
export type Assessment_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assessment_questions" */
export type Assessment_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Assessment_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Questions_Max_Order_By>;
  min?: InputMaybe<Assessment_Questions_Min_Order_By>;
  stddev?: InputMaybe<Assessment_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assessment_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assessment_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assessment_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Assessment_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assessment_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Assessment_Questions_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Assessment_Questions_Append_Input = {
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "assessment_questions" */
export type Assessment_Questions_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Assessment_Questions_Avg_Fields = {
  __typename?: 'assessment_questions_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "assessment_questions" */
export type Assessment_Questions_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assessment_questions". All fields are combined with a logical 'AND'. */
export type Assessment_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Questions_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Questions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  explanation_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Assessment_Pages_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  properties?: InputMaybe<Jsonb_Comparison_Exp>;
  question_type?: InputMaybe<Enum_Question_Type_Enum_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_questions" */
export enum Assessment_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentQuestionsPkey = 'assessment_questions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Assessment_Questions_Delete_At_Path_Input = {
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Assessment_Questions_Delete_Elem_Input = {
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Assessment_Questions_Delete_Key_Input = {
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "assessment_questions" */
export type Assessment_Questions_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assessment_questions" */
export type Assessment_Questions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Application question identifier ("q1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  page?: InputMaybe<Assessment_Pages_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  /** Type: boolean, time, select, switchboard, note, scale, number */
  question_type?: InputMaybe<Enum_Question_Type_Enum>;
  /** Question prompt */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessment_Questions_Max_Fields = {
  __typename?: 'assessment_questions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Application question identifier ("q1") */
  id?: Maybe<Scalars['uuid']['output']>;
  page_id?: Maybe<Scalars['uuid']['output']>;
  /** Question prompt */
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "assessment_questions" */
export type Assessment_Questions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Order_By>;
  /** Application question identifier ("q1") */
  id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  /** Question prompt */
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Questions_Min_Fields = {
  __typename?: 'assessment_questions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  /** Additional context or instructions */
  explanation_text?: Maybe<Scalars['String']['output']>;
  /** Application question identifier ("q1") */
  id?: Maybe<Scalars['uuid']['output']>;
  page_id?: Maybe<Scalars['uuid']['output']>;
  /** Question prompt */
  text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "assessment_questions" */
export type Assessment_Questions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Order_By>;
  /** Application question identifier ("q1") */
  id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  /** Question prompt */
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment_questions" */
export type Assessment_Questions_Mutation_Response = {
  __typename?: 'assessment_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Questions>;
};

/** input type for inserting object relation for remote table "assessment_questions" */
export type Assessment_Questions_Obj_Rel_Insert_Input = {
  data: Assessment_Questions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Questions_On_Conflict>;
};

/** on_conflict condition type for table "assessment_questions" */
export type Assessment_Questions_On_Conflict = {
  constraint: Assessment_Questions_Constraint;
  update_columns?: Array<Assessment_Questions_Update_Column>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_questions". */
export type Assessment_Questions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  explanation_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page?: InputMaybe<Assessment_Pages_Order_By>;
  page_id?: InputMaybe<Order_By>;
  properties?: InputMaybe<Order_By>;
  question_type?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_questions */
export type Assessment_Questions_Pk_Columns_Input = {
  /** Application question identifier ("q1") */
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Assessment_Questions_Prepend_Input = {
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "assessment_questions" */
export enum Assessment_Questions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  ExplanationText = 'explanation_text',
  /** column name */
  Id = 'id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Properties = 'properties',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assessment_questions" */
export type Assessment_Questions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Application question identifier ("q1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  /** Type: boolean, time, select, switchboard, note, scale, number */
  question_type?: InputMaybe<Enum_Question_Type_Enum>;
  /** Question prompt */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Assessment_Questions_Stddev_Fields = {
  __typename?: 'assessment_questions_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "assessment_questions" */
export type Assessment_Questions_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assessment_Questions_Stddev_Pop_Fields = {
  __typename?: 'assessment_questions_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "assessment_questions" */
export type Assessment_Questions_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assessment_Questions_Stddev_Samp_Fields = {
  __typename?: 'assessment_questions_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "assessment_questions" */
export type Assessment_Questions_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assessment_questions" */
export type Assessment_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Questions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  /** Additional context or instructions */
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  /** Application question identifier ("q1") */
  id?: InputMaybe<Scalars['uuid']['input']>;
  page_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Type-specific configuration (options, min/max) */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  /** Type: boolean, time, select, switchboard, note, scale, number */
  question_type?: InputMaybe<Enum_Question_Type_Enum>;
  /** Question prompt */
  text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Assessment_Questions_Sum_Fields = {
  __typename?: 'assessment_questions_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "assessment_questions" */
export type Assessment_Questions_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "assessment_questions" */
export enum Assessment_Questions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  ExplanationText = 'explanation_text',
  /** column name */
  Id = 'id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Properties = 'properties',
  /** column name */
  QuestionType = 'question_type',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessment_Questions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Assessment_Questions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Assessment_Questions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Assessment_Questions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Assessment_Questions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessment_Questions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Assessment_Questions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessment_Questions_Var_Pop_Fields = {
  __typename?: 'assessment_questions_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "assessment_questions" */
export type Assessment_Questions_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assessment_Questions_Var_Samp_Fields = {
  __typename?: 'assessment_questions_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "assessment_questions" */
export type Assessment_Questions_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assessment_Questions_Variance_Fields = {
  __typename?: 'assessment_questions_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "assessment_questions" */
export type Assessment_Questions_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Track individual user completion attempts (assessment runs) */
export type Assessment_Takes = {
  __typename?: 'assessment_takes';
  /** An array relationship */
  answers: Array<Assessment_Answers>;
  /** An aggregate relationship */
  answers_aggregate: Assessment_Answers_Aggregate;
  /** An object relationship */
  assessment: Assessments;
  assessment_id: Scalars['uuid']['output'];
  /** When user finished */
  completed_at: Scalars['timestamptz']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** When user began assessment */
  started_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** Track individual user completion attempts (assessment runs) */
export type Assessment_TakesAnswersArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


/** Track individual user completion attempts (assessment runs) */
export type Assessment_TakesAnswers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};

/** aggregated selection of "assessment_takes" */
export type Assessment_Takes_Aggregate = {
  __typename?: 'assessment_takes_aggregate';
  aggregate?: Maybe<Assessment_Takes_Aggregate_Fields>;
  nodes: Array<Assessment_Takes>;
};

export type Assessment_Takes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assessment_Takes_Aggregate_Bool_Exp_Count>;
};

export type Assessment_Takes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Assessment_Takes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assessment_takes" */
export type Assessment_Takes_Aggregate_Fields = {
  __typename?: 'assessment_takes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Assessment_Takes_Max_Fields>;
  min?: Maybe<Assessment_Takes_Min_Fields>;
};


/** aggregate fields of "assessment_takes" */
export type Assessment_Takes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assessment_takes" */
export type Assessment_Takes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assessment_Takes_Max_Order_By>;
  min?: InputMaybe<Assessment_Takes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "assessment_takes" */
export type Assessment_Takes_Arr_Rel_Insert_Input = {
  data: Array<Assessment_Takes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Takes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "assessment_takes". All fields are combined with a logical 'AND'. */
export type Assessment_Takes_Bool_Exp = {
  _and?: InputMaybe<Array<Assessment_Takes_Bool_Exp>>;
  _not?: InputMaybe<Assessment_Takes_Bool_Exp>;
  _or?: InputMaybe<Array<Assessment_Takes_Bool_Exp>>;
  answers?: InputMaybe<Assessment_Answers_Bool_Exp>;
  answers_aggregate?: InputMaybe<Assessment_Answers_Aggregate_Bool_Exp>;
  assessment?: InputMaybe<Assessments_Bool_Exp>;
  assessment_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessment_takes" */
export enum Assessment_Takes_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentTakesPkey = 'assessment_takes_pkey'
}

/** input type for inserting data into table "assessment_takes" */
export type Assessment_Takes_Insert_Input = {
  answers?: InputMaybe<Assessment_Answers_Arr_Rel_Insert_Input>;
  assessment?: InputMaybe<Assessments_Obj_Rel_Insert_Input>;
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user finished */
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user began assessment */
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Assessment_Takes_Max_Fields = {
  __typename?: 'assessment_takes_max_fields';
  assessment_id?: Maybe<Scalars['uuid']['output']>;
  /** When user finished */
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** When user began assessment */
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "assessment_takes" */
export type Assessment_Takes_Max_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  /** When user finished */
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** When user began assessment */
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assessment_Takes_Min_Fields = {
  __typename?: 'assessment_takes_min_fields';
  assessment_id?: Maybe<Scalars['uuid']['output']>;
  /** When user finished */
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** When user began assessment */
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "assessment_takes" */
export type Assessment_Takes_Min_Order_By = {
  assessment_id?: InputMaybe<Order_By>;
  /** When user finished */
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** When user began assessment */
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assessment_takes" */
export type Assessment_Takes_Mutation_Response = {
  __typename?: 'assessment_takes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessment_Takes>;
};

/** input type for inserting object relation for remote table "assessment_takes" */
export type Assessment_Takes_Obj_Rel_Insert_Input = {
  data: Assessment_Takes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessment_Takes_On_Conflict>;
};

/** on_conflict condition type for table "assessment_takes" */
export type Assessment_Takes_On_Conflict = {
  constraint: Assessment_Takes_Constraint;
  update_columns?: Array<Assessment_Takes_Update_Column>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};

/** Ordering options when selecting data from "assessment_takes". */
export type Assessment_Takes_Order_By = {
  answers_aggregate?: InputMaybe<Assessment_Answers_Aggregate_Order_By>;
  assessment?: InputMaybe<Assessments_Order_By>;
  assessment_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessment_takes */
export type Assessment_Takes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_takes" */
export enum Assessment_Takes_Select_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "assessment_takes" */
export type Assessment_Takes_Set_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user finished */
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user began assessment */
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "assessment_takes" */
export type Assessment_Takes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessment_Takes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessment_Takes_Stream_Cursor_Value_Input = {
  assessment_id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user finished */
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** When user began assessment */
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "assessment_takes" */
export enum Assessment_Takes_Update_Column {
  /** column name */
  AssessmentId = 'assessment_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Assessment_Takes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessment_Takes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessment_Takes_Bool_Exp;
};

/** Top-level assessment metadata (e.g., DBT diary, weekly check-in) */
export type Assessments = {
  __typename?: 'assessments';
  /** Number of pages (for progress indicators) */
  assessment_length: Scalars['Int']['output'];
  /** An array relationship */
  assessments_assessment_pages: Array<Assessment_Pages>;
  /** An aggregate relationship */
  assessments_assessment_pages_aggregate: Assessment_Pages_Aggregate;
  /** An array relationship */
  assessments_assessment_takes: Array<Assessment_Takes>;
  /** An aggregate relationship */
  assessments_assessment_takes_aggregate: Assessment_Takes_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Entry point page identifier */
  first_page_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** Schema version for migrations */
  schema_version: Scalars['Int']['output'];
  /** Descriptive tagline */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Display name ("Daily Survey") */
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Top-level assessment metadata (e.g., DBT diary, weekly check-in) */
export type AssessmentsAssessments_Assessment_PagesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


/** Top-level assessment metadata (e.g., DBT diary, weekly check-in) */
export type AssessmentsAssessments_Assessment_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


/** Top-level assessment metadata (e.g., DBT diary, weekly check-in) */
export type AssessmentsAssessments_Assessment_TakesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


/** Top-level assessment metadata (e.g., DBT diary, weekly check-in) */
export type AssessmentsAssessments_Assessment_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};

/** aggregated selection of "assessments" */
export type Assessments_Aggregate = {
  __typename?: 'assessments_aggregate';
  aggregate?: Maybe<Assessments_Aggregate_Fields>;
  nodes: Array<Assessments>;
};

/** aggregate fields of "assessments" */
export type Assessments_Aggregate_Fields = {
  __typename?: 'assessments_aggregate_fields';
  avg?: Maybe<Assessments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Assessments_Max_Fields>;
  min?: Maybe<Assessments_Min_Fields>;
  stddev?: Maybe<Assessments_Stddev_Fields>;
  stddev_pop?: Maybe<Assessments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assessments_Stddev_Samp_Fields>;
  sum?: Maybe<Assessments_Sum_Fields>;
  var_pop?: Maybe<Assessments_Var_Pop_Fields>;
  var_samp?: Maybe<Assessments_Var_Samp_Fields>;
  variance?: Maybe<Assessments_Variance_Fields>;
};


/** aggregate fields of "assessments" */
export type Assessments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assessments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Assessments_Avg_Fields = {
  __typename?: 'assessments_avg_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "assessments". All fields are combined with a logical 'AND'. */
export type Assessments_Bool_Exp = {
  _and?: InputMaybe<Array<Assessments_Bool_Exp>>;
  _not?: InputMaybe<Assessments_Bool_Exp>;
  _or?: InputMaybe<Array<Assessments_Bool_Exp>>;
  assessment_length?: InputMaybe<Int_Comparison_Exp>;
  assessments_assessment_pages?: InputMaybe<Assessment_Pages_Bool_Exp>;
  assessments_assessment_pages_aggregate?: InputMaybe<Assessment_Pages_Aggregate_Bool_Exp>;
  assessments_assessment_takes?: InputMaybe<Assessment_Takes_Bool_Exp>;
  assessments_assessment_takes_aggregate?: InputMaybe<Assessment_Takes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_page_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  schema_version?: InputMaybe<Int_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "assessments" */
export enum Assessments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssessmentsPkey = 'assessments_pkey'
}

/** input type for incrementing numeric columns in table "assessments" */
export type Assessments_Inc_Input = {
  /** Number of pages (for progress indicators) */
  assessment_length?: InputMaybe<Scalars['Int']['input']>;
  /** Schema version for migrations */
  schema_version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "assessments" */
export type Assessments_Insert_Input = {
  /** Number of pages (for progress indicators) */
  assessment_length?: InputMaybe<Scalars['Int']['input']>;
  assessments_assessment_pages?: InputMaybe<Assessment_Pages_Arr_Rel_Insert_Input>;
  assessments_assessment_takes?: InputMaybe<Assessment_Takes_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Entry point page identifier */
  first_page_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Schema version for migrations */
  schema_version?: InputMaybe<Scalars['Int']['input']>;
  /** Descriptive tagline */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Display name ("Daily Survey") */
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Assessments_Max_Fields = {
  __typename?: 'assessments_max_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Entry point page identifier */
  first_page_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Int']['output']>;
  /** Descriptive tagline */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Display name ("Daily Survey") */
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Assessments_Min_Fields = {
  __typename?: 'assessments_min_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Entry point page identifier */
  first_page_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Int']['output']>;
  /** Descriptive tagline */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Display name ("Daily Survey") */
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "assessments" */
export type Assessments_Mutation_Response = {
  __typename?: 'assessments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessments>;
};

/** input type for inserting object relation for remote table "assessments" */
export type Assessments_Obj_Rel_Insert_Input = {
  data: Assessments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assessments_On_Conflict>;
};

/** on_conflict condition type for table "assessments" */
export type Assessments_On_Conflict = {
  constraint: Assessments_Constraint;
  update_columns?: Array<Assessments_Update_Column>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};

/** Ordering options when selecting data from "assessments". */
export type Assessments_Order_By = {
  assessment_length?: InputMaybe<Order_By>;
  assessments_assessment_pages_aggregate?: InputMaybe<Assessment_Pages_Aggregate_Order_By>;
  assessments_assessment_takes_aggregate?: InputMaybe<Assessment_Takes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  first_page_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assessments */
export type Assessments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessments" */
export enum Assessments_Select_Column {
  /** column name */
  AssessmentLength = 'assessment_length',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstPageId = 'first_page_id',
  /** column name */
  Id = 'id',
  /** column name */
  SchemaVersion = 'schema_version',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "assessments" */
export type Assessments_Set_Input = {
  /** Number of pages (for progress indicators) */
  assessment_length?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Entry point page identifier */
  first_page_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Schema version for migrations */
  schema_version?: InputMaybe<Scalars['Int']['input']>;
  /** Descriptive tagline */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Display name ("Daily Survey") */
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Assessments_Stddev_Fields = {
  __typename?: 'assessments_stddev_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Assessments_Stddev_Pop_Fields = {
  __typename?: 'assessments_stddev_pop_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Assessments_Stddev_Samp_Fields = {
  __typename?: 'assessments_stddev_samp_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "assessments" */
export type Assessments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assessments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assessments_Stream_Cursor_Value_Input = {
  /** Number of pages (for progress indicators) */
  assessment_length?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Soft-delete timestamp (NULL means active) */
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Entry point page identifier */
  first_page_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** Schema version for migrations */
  schema_version?: InputMaybe<Scalars['Int']['input']>;
  /** Descriptive tagline */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** Display name ("Daily Survey") */
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Assessments_Sum_Fields = {
  __typename?: 'assessments_sum_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Int']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "assessments" */
export enum Assessments_Update_Column {
  /** column name */
  AssessmentLength = 'assessment_length',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FirstPageId = 'first_page_id',
  /** column name */
  Id = 'id',
  /** column name */
  SchemaVersion = 'schema_version',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Assessments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assessments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assessments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assessments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assessments_Var_Pop_Fields = {
  __typename?: 'assessments_var_pop_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Assessments_Var_Samp_Fields = {
  __typename?: 'assessments_var_samp_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Assessments_Variance_Fields = {
  __typename?: 'assessments_variance_fields';
  /** Number of pages (for progress indicators) */
  assessment_length?: Maybe<Scalars['Float']['output']>;
  /** Schema version for migrations */
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "auth.account_migration_log" */
export type Auth_Account_Migration_Log = {
  __typename?: 'auth_account_migration_log';
  account_id: Scalars['uuid']['output'];
  /** An object relationship */
  account_migration_log_account: Auth_Accounts;
  attempted_at: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
};

/** aggregated selection of "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Aggregate = {
  __typename?: 'auth_account_migration_log_aggregate';
  aggregate?: Maybe<Auth_Account_Migration_Log_Aggregate_Fields>;
  nodes: Array<Auth_Account_Migration_Log>;
};

export type Auth_Account_Migration_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Account_Migration_Log_Aggregate_Bool_Exp_Count>;
};

export type Auth_Account_Migration_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Aggregate_Fields = {
  __typename?: 'auth_account_migration_log_aggregate_fields';
  avg?: Maybe<Auth_Account_Migration_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Account_Migration_Log_Max_Fields>;
  min?: Maybe<Auth_Account_Migration_Log_Min_Fields>;
  stddev?: Maybe<Auth_Account_Migration_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Auth_Account_Migration_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Auth_Account_Migration_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Auth_Account_Migration_Log_Sum_Fields>;
  var_pop?: Maybe<Auth_Account_Migration_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Auth_Account_Migration_Log_Var_Samp_Fields>;
  variance?: Maybe<Auth_Account_Migration_Log_Variance_Fields>;
};


/** aggregate fields of "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Auth_Account_Migration_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Account_Migration_Log_Max_Order_By>;
  min?: InputMaybe<Auth_Account_Migration_Log_Min_Order_By>;
  stddev?: InputMaybe<Auth_Account_Migration_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Auth_Account_Migration_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Auth_Account_Migration_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Auth_Account_Migration_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Auth_Account_Migration_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Auth_Account_Migration_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Auth_Account_Migration_Log_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Arr_Rel_Insert_Input = {
  data: Array<Auth_Account_Migration_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Account_Migration_Log_On_Conflict>;
};

/** aggregate avg on columns */
export type Auth_Account_Migration_Log_Avg_Fields = {
  __typename?: 'auth_account_migration_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "auth.account_migration_log". All fields are combined with a logical 'AND'. */
export type Auth_Account_Migration_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Account_Migration_Log_Bool_Exp>>;
  _not?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Account_Migration_Log_Bool_Exp>>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  account_migration_log_account?: InputMaybe<Auth_Accounts_Bool_Exp>;
  attempted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.account_migration_log" */
export enum Auth_Account_Migration_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountMigrationLogPkey = 'account_migration_log_pkey'
}

/** input type for incrementing numeric columns in table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Insert_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  account_migration_log_account?: InputMaybe<Auth_Accounts_Obj_Rel_Insert_Input>;
  attempted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Auth_Account_Migration_Log_Max_Fields = {
  __typename?: 'auth_account_migration_log_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  attempted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  attempted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Account_Migration_Log_Min_Fields = {
  __typename?: 'auth_account_migration_log_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  attempted_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  attempted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Mutation_Response = {
  __typename?: 'auth_account_migration_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Account_Migration_Log>;
};

/** on_conflict condition type for table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_On_Conflict = {
  constraint: Auth_Account_Migration_Log_Constraint;
  update_columns?: Array<Auth_Account_Migration_Log_Update_Column>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.account_migration_log". */
export type Auth_Account_Migration_Log_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_migration_log_account?: InputMaybe<Auth_Accounts_Order_By>;
  attempted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.account_migration_log */
export type Auth_Account_Migration_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "auth.account_migration_log" */
export enum Auth_Account_Migration_Log_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AttemptedAt = 'attempted_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  attempted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Auth_Account_Migration_Log_Stddev_Fields = {
  __typename?: 'auth_account_migration_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Auth_Account_Migration_Log_Stddev_Pop_Fields = {
  __typename?: 'auth_account_migration_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Auth_Account_Migration_Log_Stddev_Samp_Fields = {
  __typename?: 'auth_account_migration_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "auth_account_migration_log" */
export type Auth_Account_Migration_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Account_Migration_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Account_Migration_Log_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  attempted_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Auth_Account_Migration_Log_Sum_Fields = {
  __typename?: 'auth_account_migration_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "auth.account_migration_log" */
export enum Auth_Account_Migration_Log_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AttemptedAt = 'attempted_at',
  /** column name */
  Id = 'id'
}

export type Auth_Account_Migration_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Auth_Account_Migration_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Account_Migration_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Account_Migration_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Auth_Account_Migration_Log_Var_Pop_Fields = {
  __typename?: 'auth_account_migration_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Auth_Account_Migration_Log_Var_Samp_Fields = {
  __typename?: 'auth_account_migration_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Auth_Account_Migration_Log_Variance_Fields = {
  __typename?: 'auth_account_migration_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.account_migration_log" */
export type Auth_Account_Migration_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "auth.account_providers" */
export type Auth_Account_Providers = {
  __typename?: 'auth_account_providers';
  /** An object relationship */
  account: Auth_Accounts;
  account_id: Scalars['uuid']['output'];
  auth_provider: Scalars['String']['output'];
  auth_provider_unique_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: Auth_Providers;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "auth.account_providers" */
export type Auth_Account_Providers_Aggregate = {
  __typename?: 'auth_account_providers_aggregate';
  aggregate?: Maybe<Auth_Account_Providers_Aggregate_Fields>;
  nodes: Array<Auth_Account_Providers>;
};

export type Auth_Account_Providers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Account_Providers_Aggregate_Bool_Exp_Count>;
};

export type Auth_Account_Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.account_providers" */
export type Auth_Account_Providers_Aggregate_Fields = {
  __typename?: 'auth_account_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Account_Providers_Max_Fields>;
  min?: Maybe<Auth_Account_Providers_Min_Fields>;
};


/** aggregate fields of "auth.account_providers" */
export type Auth_Account_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.account_providers" */
export type Auth_Account_Providers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Account_Providers_Max_Order_By>;
  min?: InputMaybe<Auth_Account_Providers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.account_providers" */
export type Auth_Account_Providers_Arr_Rel_Insert_Input = {
  data: Array<Auth_Account_Providers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Account_Providers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export type Auth_Account_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Account_Providers_Bool_Exp>>;
  _not?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Account_Providers_Bool_Exp>>;
  account?: InputMaybe<Auth_Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  auth_provider?: InputMaybe<String_Comparison_Exp>;
  auth_provider_unique_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  provider?: InputMaybe<Auth_Providers_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.account_providers" */
export enum Auth_Account_Providers_Constraint {
  /** unique or primary key constraint on columns "auth_provider", "account_id" */
  AccountProvidersAccountIdAuthProviderKey = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint on columns "auth_provider", "auth_provider_unique_id" */
  AccountProvidersAuthProviderAuthProviderUniqueIdKey = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint on columns "id" */
  AccountProvidersPkey = 'account_providers_pkey'
}

/** input type for inserting data into table "auth.account_providers" */
export type Auth_Account_Providers_Insert_Input = {
  account?: InputMaybe<Auth_Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_provider?: InputMaybe<Scalars['String']['input']>;
  auth_provider_unique_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<Auth_Providers_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Auth_Account_Providers_Max_Fields = {
  __typename?: 'auth_account_providers_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  auth_provider?: Maybe<Scalars['String']['output']>;
  auth_provider_unique_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.account_providers" */
export type Auth_Account_Providers_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  auth_provider?: InputMaybe<Order_By>;
  auth_provider_unique_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Account_Providers_Min_Fields = {
  __typename?: 'auth_account_providers_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  auth_provider?: Maybe<Scalars['String']['output']>;
  auth_provider_unique_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.account_providers" */
export type Auth_Account_Providers_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  auth_provider?: InputMaybe<Order_By>;
  auth_provider_unique_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.account_providers" */
export type Auth_Account_Providers_Mutation_Response = {
  __typename?: 'auth_account_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Account_Providers>;
};

/** on_conflict condition type for table "auth.account_providers" */
export type Auth_Account_Providers_On_Conflict = {
  constraint: Auth_Account_Providers_Constraint;
  update_columns?: Array<Auth_Account_Providers_Update_Column>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.account_providers". */
export type Auth_Account_Providers_Order_By = {
  account?: InputMaybe<Auth_Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  auth_provider?: InputMaybe<Order_By>;
  auth_provider_unique_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Auth_Providers_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.account_providers */
export type Auth_Account_Providers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.account_providers" */
export enum Auth_Account_Providers_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AuthProvider = 'auth_provider',
  /** column name */
  AuthProviderUniqueId = 'auth_provider_unique_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "auth.account_providers" */
export type Auth_Account_Providers_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_provider?: InputMaybe<Scalars['String']['input']>;
  auth_provider_unique_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "auth_account_providers" */
export type Auth_Account_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Account_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Account_Providers_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  auth_provider?: InputMaybe<Scalars['String']['input']>;
  auth_provider_unique_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.account_providers" */
export enum Auth_Account_Providers_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AuthProvider = 'auth_provider',
  /** column name */
  AuthProviderUniqueId = 'auth_provider_unique_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Auth_Account_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Account_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Account_Providers_Bool_Exp;
};

/** columns and relationships of "auth.account_roles" */
export type Auth_Account_Roles = {
  __typename?: 'auth_account_roles';
  /** An object relationship */
  account: Auth_Accounts;
  account_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByRole: Auth_Roles;
};

/** aggregated selection of "auth.account_roles" */
export type Auth_Account_Roles_Aggregate = {
  __typename?: 'auth_account_roles_aggregate';
  aggregate?: Maybe<Auth_Account_Roles_Aggregate_Fields>;
  nodes: Array<Auth_Account_Roles>;
};

export type Auth_Account_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Account_Roles_Aggregate_Bool_Exp_Count>;
};

export type Auth_Account_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.account_roles" */
export type Auth_Account_Roles_Aggregate_Fields = {
  __typename?: 'auth_account_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Account_Roles_Max_Fields>;
  min?: Maybe<Auth_Account_Roles_Min_Fields>;
};


/** aggregate fields of "auth.account_roles" */
export type Auth_Account_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.account_roles" */
export type Auth_Account_Roles_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Account_Roles_Max_Order_By>;
  min?: InputMaybe<Auth_Account_Roles_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.account_roles" */
export type Auth_Account_Roles_Arr_Rel_Insert_Input = {
  data: Array<Auth_Account_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Account_Roles_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export type Auth_Account_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Account_Roles_Bool_Exp>>;
  _not?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Account_Roles_Bool_Exp>>;
  account?: InputMaybe<Auth_Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roleByRole?: InputMaybe<Auth_Roles_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.account_roles" */
export enum Auth_Account_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccountRolesPkey = 'account_roles_pkey',
  /** unique or primary key constraint on columns "role", "account_id" */
  UserRolesAccountIdRoleKey = 'user_roles_account_id_role_key'
}

/** input type for inserting data into table "auth.account_roles" */
export type Auth_Account_Roles_Insert_Input = {
  account?: InputMaybe<Auth_Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByRole?: InputMaybe<Auth_Roles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Account_Roles_Max_Fields = {
  __typename?: 'auth_account_roles_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "auth.account_roles" */
export type Auth_Account_Roles_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Account_Roles_Min_Fields = {
  __typename?: 'auth_account_roles_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "auth.account_roles" */
export type Auth_Account_Roles_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.account_roles" */
export type Auth_Account_Roles_Mutation_Response = {
  __typename?: 'auth_account_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Account_Roles>;
};

/** on_conflict condition type for table "auth.account_roles" */
export type Auth_Account_Roles_On_Conflict = {
  constraint: Auth_Account_Roles_Constraint;
  update_columns?: Array<Auth_Account_Roles_Update_Column>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.account_roles". */
export type Auth_Account_Roles_Order_By = {
  account?: InputMaybe<Auth_Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  roleByRole?: InputMaybe<Auth_Roles_Order_By>;
};

/** primary key columns input for table: auth.account_roles */
export type Auth_Account_Roles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.account_roles" */
export enum Auth_Account_Roles_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.account_roles" */
export type Auth_Account_Roles_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_account_roles" */
export type Auth_Account_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Account_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Account_Roles_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.account_roles" */
export enum Auth_Account_Roles_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role'
}

export type Auth_Account_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Account_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Account_Roles_Bool_Exp;
};

/** columns and relationships of "auth.accounts" */
export type Auth_Accounts = {
  __typename?: 'auth_accounts';
  /** An array relationship */
  account_providers: Array<Auth_Account_Providers>;
  /** An aggregate relationship */
  account_providers_aggregate: Auth_Account_Providers_Aggregate;
  /** An array relationship */
  account_roles: Array<Auth_Account_Roles>;
  /** An aggregate relationship */
  account_roles_aggregate: Auth_Account_Roles_Aggregate;
  /** An array relationship */
  accounts_account_migration_logs: Array<Auth_Account_Migration_Log>;
  /** An aggregate relationship */
  accounts_account_migration_logs_aggregate: Auth_Account_Migration_Log_Aggregate;
  active: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  custom_register_data?: Maybe<Scalars['jsonb']['output']>;
  default_role: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  id: Scalars['uuid']['output'];
  is_anonymous: Scalars['Boolean']['output'];
  mfa_enabled: Scalars['Boolean']['output'];
  migrated_at?: Maybe<Scalars['timestamp']['output']>;
  new_email?: Maybe<Scalars['citext']['output']>;
  otp_secret?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refresh_tokens: Array<Auth_Refresh_Tokens>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: Auth_Refresh_Tokens_Aggregate;
  /** An object relationship */
  role: Auth_Roles;
  ticket: Scalars['uuid']['output'];
  ticket_expires_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccount_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccount_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccount_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccount_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccounts_Account_Migration_LogsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsAccounts_Account_Migration_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsCustom_Register_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsRefresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


/** columns and relationships of "auth.accounts" */
export type Auth_AccountsRefresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};

/** aggregated selection of "auth.accounts" */
export type Auth_Accounts_Aggregate = {
  __typename?: 'auth_accounts_aggregate';
  aggregate?: Maybe<Auth_Accounts_Aggregate_Fields>;
  nodes: Array<Auth_Accounts>;
};

export type Auth_Accounts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Auth_Accounts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Auth_Accounts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Auth_Accounts_Aggregate_Bool_Exp_Count>;
};

export type Auth_Accounts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Auth_Accounts_Select_Column_Auth_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Auth_Accounts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Auth_Accounts_Select_Column_Auth_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Accounts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Auth_Accounts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Accounts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.accounts" */
export type Auth_Accounts_Aggregate_Fields = {
  __typename?: 'auth_accounts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Accounts_Max_Fields>;
  min?: Maybe<Auth_Accounts_Min_Fields>;
};


/** aggregate fields of "auth.accounts" */
export type Auth_Accounts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.accounts" */
export type Auth_Accounts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Accounts_Max_Order_By>;
  min?: InputMaybe<Auth_Accounts_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Auth_Accounts_Append_Input = {
  custom_register_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.accounts" */
export type Auth_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Auth_Accounts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Accounts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export type Auth_Accounts_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Accounts_Bool_Exp>>;
  _not?: InputMaybe<Auth_Accounts_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Accounts_Bool_Exp>>;
  account_providers?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
  account_providers_aggregate?: InputMaybe<Auth_Account_Providers_Aggregate_Bool_Exp>;
  account_roles?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
  account_roles_aggregate?: InputMaybe<Auth_Account_Roles_Aggregate_Bool_Exp>;
  accounts_account_migration_logs?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
  accounts_account_migration_logs_aggregate?: InputMaybe<Auth_Account_Migration_Log_Aggregate_Bool_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_register_data?: InputMaybe<Jsonb_Comparison_Exp>;
  default_role?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_anonymous?: InputMaybe<Boolean_Comparison_Exp>;
  mfa_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  migrated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  new_email?: InputMaybe<Citext_Comparison_Exp>;
  otp_secret?: InputMaybe<String_Comparison_Exp>;
  password_hash?: InputMaybe<String_Comparison_Exp>;
  refresh_tokens?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
  refresh_tokens_aggregate?: InputMaybe<Auth_Refresh_Tokens_Aggregate_Bool_Exp>;
  role?: InputMaybe<Auth_Roles_Bool_Exp>;
  ticket?: InputMaybe<Uuid_Comparison_Exp>;
  ticket_expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.accounts" */
export enum Auth_Accounts_Constraint {
  /** unique or primary key constraint on columns "email" */
  AccountsEmailKey = 'accounts_email_key',
  /** unique or primary key constraint on columns "new_email" */
  AccountsNewEmailKey = 'accounts_new_email_key',
  /** unique or primary key constraint on columns "id" */
  AccountsPkey = 'accounts_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AccountsUserIdKey = 'accounts_user_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Auth_Accounts_Delete_At_Path_Input = {
  custom_register_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Auth_Accounts_Delete_Elem_Input = {
  custom_register_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Auth_Accounts_Delete_Key_Input = {
  custom_register_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.accounts" */
export type Auth_Accounts_Insert_Input = {
  account_providers?: InputMaybe<Auth_Account_Providers_Arr_Rel_Insert_Input>;
  account_roles?: InputMaybe<Auth_Account_Roles_Arr_Rel_Insert_Input>;
  accounts_account_migration_logs?: InputMaybe<Auth_Account_Migration_Log_Arr_Rel_Insert_Input>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_register_data?: InputMaybe<Scalars['jsonb']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_at?: InputMaybe<Scalars['timestamp']['input']>;
  new_email?: InputMaybe<Scalars['citext']['input']>;
  otp_secret?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  refresh_tokens?: InputMaybe<Auth_Refresh_Tokens_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Auth_Roles_Obj_Rel_Insert_Input>;
  ticket?: InputMaybe<Scalars['uuid']['input']>;
  ticket_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Auth_Accounts_Max_Fields = {
  __typename?: 'auth_accounts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_role?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  migrated_at?: Maybe<Scalars['timestamp']['output']>;
  new_email?: Maybe<Scalars['citext']['output']>;
  otp_secret?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['uuid']['output']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.accounts" */
export type Auth_Accounts_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  migrated_at?: InputMaybe<Order_By>;
  new_email?: InputMaybe<Order_By>;
  otp_secret?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_expires_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Accounts_Min_Fields = {
  __typename?: 'auth_accounts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_role?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  migrated_at?: Maybe<Scalars['timestamp']['output']>;
  new_email?: Maybe<Scalars['citext']['output']>;
  otp_secret?: Maybe<Scalars['String']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['uuid']['output']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.accounts" */
export type Auth_Accounts_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  migrated_at?: InputMaybe<Order_By>;
  new_email?: InputMaybe<Order_By>;
  otp_secret?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_expires_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.accounts" */
export type Auth_Accounts_Mutation_Response = {
  __typename?: 'auth_accounts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Accounts>;
};

/** input type for inserting object relation for remote table "auth.accounts" */
export type Auth_Accounts_Obj_Rel_Insert_Input = {
  data: Auth_Accounts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Accounts_On_Conflict>;
};

/** on_conflict condition type for table "auth.accounts" */
export type Auth_Accounts_On_Conflict = {
  constraint: Auth_Accounts_Constraint;
  update_columns?: Array<Auth_Accounts_Update_Column>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.accounts". */
export type Auth_Accounts_Order_By = {
  account_providers_aggregate?: InputMaybe<Auth_Account_Providers_Aggregate_Order_By>;
  account_roles_aggregate?: InputMaybe<Auth_Account_Roles_Aggregate_Order_By>;
  accounts_account_migration_logs_aggregate?: InputMaybe<Auth_Account_Migration_Log_Aggregate_Order_By>;
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_register_data?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_anonymous?: InputMaybe<Order_By>;
  mfa_enabled?: InputMaybe<Order_By>;
  migrated_at?: InputMaybe<Order_By>;
  new_email?: InputMaybe<Order_By>;
  otp_secret?: InputMaybe<Order_By>;
  password_hash?: InputMaybe<Order_By>;
  refresh_tokens_aggregate?: InputMaybe<Auth_Refresh_Tokens_Aggregate_Order_By>;
  role?: InputMaybe<Auth_Roles_Order_By>;
  ticket?: InputMaybe<Order_By>;
  ticket_expires_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.accounts */
export type Auth_Accounts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Auth_Accounts_Prepend_Input = {
  custom_register_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.accounts" */
export enum Auth_Accounts_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRegisterData = 'custom_register_data',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MigratedAt = 'migrated_at',
  /** column name */
  NewEmail = 'new_email',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticket_expires_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "auth_accounts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.accounts" */
export enum Auth_Accounts_Select_Column_Auth_Accounts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** select "auth_accounts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.accounts" */
export enum Auth_Accounts_Select_Column_Auth_Accounts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  MfaEnabled = 'mfa_enabled'
}

/** input type for updating data in table "auth.accounts" */
export type Auth_Accounts_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_register_data?: InputMaybe<Scalars['jsonb']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_at?: InputMaybe<Scalars['timestamp']['input']>;
  new_email?: InputMaybe<Scalars['citext']['input']>;
  otp_secret?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<Scalars['uuid']['input']>;
  ticket_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "auth_accounts" */
export type Auth_Accounts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Accounts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Accounts_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_register_data?: InputMaybe<Scalars['jsonb']['input']>;
  default_role?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  migrated_at?: InputMaybe<Scalars['timestamp']['input']>;
  new_email?: InputMaybe<Scalars['citext']['input']>;
  otp_secret?: InputMaybe<Scalars['String']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  ticket?: InputMaybe<Scalars['uuid']['input']>;
  ticket_expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.accounts" */
export enum Auth_Accounts_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomRegisterData = 'custom_register_data',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  MfaEnabled = 'mfa_enabled',
  /** column name */
  MigratedAt = 'migrated_at',
  /** column name */
  NewEmail = 'new_email',
  /** column name */
  OtpSecret = 'otp_secret',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  Ticket = 'ticket',
  /** column name */
  TicketExpiresAt = 'ticket_expires_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Auth_Accounts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Auth_Accounts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Auth_Accounts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Auth_Accounts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Auth_Accounts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Auth_Accounts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Accounts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Accounts_Bool_Exp;
};

/** columns and relationships of "auth.providers" */
export type Auth_Providers = {
  __typename?: 'auth_providers';
  /** An array relationship */
  account_providers: Array<Auth_Account_Providers>;
  /** An aggregate relationship */
  account_providers_aggregate: Auth_Account_Providers_Aggregate;
  provider: Scalars['String']['output'];
};


/** columns and relationships of "auth.providers" */
export type Auth_ProvidersAccount_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


/** columns and relationships of "auth.providers" */
export type Auth_ProvidersAccount_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};

/** aggregated selection of "auth.providers" */
export type Auth_Providers_Aggregate = {
  __typename?: 'auth_providers_aggregate';
  aggregate?: Maybe<Auth_Providers_Aggregate_Fields>;
  nodes: Array<Auth_Providers>;
};

/** aggregate fields of "auth.providers" */
export type Auth_Providers_Aggregate_Fields = {
  __typename?: 'auth_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Providers_Max_Fields>;
  min?: Maybe<Auth_Providers_Min_Fields>;
};


/** aggregate fields of "auth.providers" */
export type Auth_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type Auth_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Providers_Bool_Exp>>;
  _not?: InputMaybe<Auth_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Providers_Bool_Exp>>;
  account_providers?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
  account_providers_aggregate?: InputMaybe<Auth_Account_Providers_Aggregate_Bool_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum Auth_Providers_Constraint {
  /** unique or primary key constraint on columns "provider" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type Auth_Providers_Insert_Input = {
  account_providers?: InputMaybe<Auth_Account_Providers_Arr_Rel_Insert_Input>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Providers_Max_Fields = {
  __typename?: 'auth_providers_max_fields';
  provider?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Providers_Min_Fields = {
  __typename?: 'auth_providers_min_fields';
  provider?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type Auth_Providers_Mutation_Response = {
  __typename?: 'auth_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Providers>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type Auth_Providers_Obj_Rel_Insert_Input = {
  data: Auth_Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Providers_On_Conflict>;
};

/** on_conflict condition type for table "auth.providers" */
export type Auth_Providers_On_Conflict = {
  constraint: Auth_Providers_Constraint;
  update_columns?: Array<Auth_Providers_Update_Column>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.providers". */
export type Auth_Providers_Order_By = {
  account_providers_aggregate?: InputMaybe<Auth_Account_Providers_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.providers */
export type Auth_Providers_Pk_Columns_Input = {
  provider: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum Auth_Providers_Select_Column {
  /** column name */
  Provider = 'provider'
}

/** input type for updating data in table "auth.providers" */
export type Auth_Providers_Set_Input = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_providers" */
export type Auth_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Providers_Stream_Cursor_Value_Input = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum Auth_Providers_Update_Column {
  /** column name */
  Provider = 'provider'
}

export type Auth_Providers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Providers_Bool_Exp;
};

/** columns and relationships of "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log = {
  __typename?: 'auth_refresh_token_usage_log';
  id: Scalars['uuid']['output'];
  refresh_token_hash: Scalars['String']['output'];
  used_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Aggregate = {
  __typename?: 'auth_refresh_token_usage_log_aggregate';
  aggregate?: Maybe<Auth_Refresh_Token_Usage_Log_Aggregate_Fields>;
  nodes: Array<Auth_Refresh_Token_Usage_Log>;
};

export type Auth_Refresh_Token_Usage_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Auth_Refresh_Token_Usage_Log_Aggregate_Bool_Exp_Count>;
};

export type Auth_Refresh_Token_Usage_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Aggregate_Fields = {
  __typename?: 'auth_refresh_token_usage_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Refresh_Token_Usage_Log_Max_Fields>;
  min?: Maybe<Auth_Refresh_Token_Usage_Log_Min_Fields>;
};


/** aggregate fields of "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Refresh_Token_Usage_Log_Max_Order_By>;
  min?: InputMaybe<Auth_Refresh_Token_Usage_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Arr_Rel_Insert_Input = {
  data: Array<Auth_Refresh_Token_Usage_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Refresh_Token_Usage_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_usage_log". All fields are combined with a logical 'AND'. */
export type Auth_Refresh_Token_Usage_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Bool_Exp>>;
  _not?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  refresh_token_hash?: InputMaybe<String_Comparison_Exp>;
  used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_token_usage_log" */
export enum Auth_Refresh_Token_Usage_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefreshTokenUsageLogPkey = 'refresh_token_usage_log_pkey'
}

/** input type for inserting data into table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
  used_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Auth_Refresh_Token_Usage_Log_Max_Fields = {
  __typename?: 'auth_refresh_token_usage_log_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  refresh_token_hash?: Maybe<Scalars['String']['output']>;
  used_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
  used_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Refresh_Token_Usage_Log_Min_Fields = {
  __typename?: 'auth_refresh_token_usage_log_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  refresh_token_hash?: Maybe<Scalars['String']['output']>;
  used_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
  used_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Mutation_Response = {
  __typename?: 'auth_refresh_token_usage_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Refresh_Token_Usage_Log>;
};

/** on_conflict condition type for table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_On_Conflict = {
  constraint: Auth_Refresh_Token_Usage_Log_Constraint;
  update_columns?: Array<Auth_Refresh_Token_Usage_Log_Update_Column>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_token_usage_log". */
export type Auth_Refresh_Token_Usage_Log_Order_By = {
  id?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
  used_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.refresh_token_usage_log */
export type Auth_Refresh_Token_Usage_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.refresh_token_usage_log" */
export enum Auth_Refresh_Token_Usage_Log_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RefreshTokenHash = 'refresh_token_hash',
  /** column name */
  UsedAt = 'used_at'
}

/** input type for updating data in table "auth.refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
  used_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "auth_refresh_token_usage_log" */
export type Auth_Refresh_Token_Usage_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Refresh_Token_Usage_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Refresh_Token_Usage_Log_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
  used_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.refresh_token_usage_log" */
export enum Auth_Refresh_Token_Usage_Log_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  RefreshTokenHash = 'refresh_token_hash',
  /** column name */
  UsedAt = 'used_at'
}

export type Auth_Refresh_Token_Usage_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Refresh_Token_Usage_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Refresh_Token_Usage_Log_Bool_Exp;
};

/** columns and relationships of "auth.refresh_tokens" */
export type Auth_Refresh_Tokens = {
  __typename?: 'auth_refresh_tokens';
  /** An object relationship */
  account: Auth_Accounts;
  account_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  expires_at: Scalars['timestamptz']['output'];
  invalid: Scalars['Boolean']['output'];
  refresh_token_hash: Scalars['String']['output'];
  /** An array relationship */
  refresh_token_usage_log: Array<Auth_Refresh_Token_Usage_Log>;
  /** An aggregate relationship */
  refresh_token_usage_log_aggregate: Auth_Refresh_Token_Usage_Log_Aggregate;
};


/** columns and relationships of "auth.refresh_tokens" */
export type Auth_Refresh_TokensRefresh_Token_Usage_LogArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


/** columns and relationships of "auth.refresh_tokens" */
export type Auth_Refresh_TokensRefresh_Token_Usage_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Aggregate = {
  __typename?: 'auth_refresh_tokens_aggregate';
  aggregate?: Maybe<Auth_Refresh_Tokens_Aggregate_Fields>;
  nodes: Array<Auth_Refresh_Tokens>;
};

export type Auth_Refresh_Tokens_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Auth_Refresh_Tokens_Aggregate_Bool_Exp_Count>;
};

export type Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And = {
  arguments: Auth_Refresh_Tokens_Select_Column_Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Auth_Refresh_Tokens_Select_Column_Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Auth_Refresh_Tokens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Aggregate_Fields = {
  __typename?: 'auth_refresh_tokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Refresh_Tokens_Max_Fields>;
  min?: Maybe<Auth_Refresh_Tokens_Min_Fields>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Auth_Refresh_Tokens_Max_Order_By>;
  min?: InputMaybe<Auth_Refresh_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Auth_Refresh_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Refresh_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type Auth_Refresh_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Refresh_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Refresh_Tokens_Bool_Exp>>;
  account?: InputMaybe<Auth_Accounts_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invalid?: InputMaybe<Boolean_Comparison_Exp>;
  refresh_token_hash?: InputMaybe<String_Comparison_Exp>;
  refresh_token_usage_log?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
  refresh_token_usage_log_aggregate?: InputMaybe<Auth_Refresh_Token_Usage_Log_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum Auth_Refresh_Tokens_Constraint {
  /** unique or primary key constraint on columns "refresh_token_hash" */
  RefreshTokensPkey = 'refresh_tokens_pkey'
}

/** input type for inserting data into table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Insert_Input = {
  account?: InputMaybe<Auth_Accounts_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
  refresh_token_usage_log?: InputMaybe<Auth_Refresh_Token_Usage_Log_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Auth_Refresh_Tokens_Max_Fields = {
  __typename?: 'auth_refresh_tokens_max_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  refresh_token_hash?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Auth_Refresh_Tokens_Min_Fields = {
  __typename?: 'auth_refresh_tokens_min_fields';
  account_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  refresh_token_hash?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Mutation_Response = {
  __typename?: 'auth_refresh_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Refresh_Tokens>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_On_Conflict = {
  constraint: Auth_Refresh_Tokens_Constraint;
  update_columns?: Array<Auth_Refresh_Tokens_Update_Column>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type Auth_Refresh_Tokens_Order_By = {
  account?: InputMaybe<Auth_Accounts_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  invalid?: InputMaybe<Order_By>;
  refresh_token_hash?: InputMaybe<Order_By>;
  refresh_token_usage_log_aggregate?: InputMaybe<Auth_Refresh_Token_Usage_Log_Aggregate_Order_By>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type Auth_Refresh_Tokens_Pk_Columns_Input = {
  refresh_token_hash: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_tokens" */
export enum Auth_Refresh_Tokens_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  RefreshTokenHash = 'refresh_token_hash'
}

/** select "auth_refresh_tokens_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.refresh_tokens" */
export enum Auth_Refresh_Tokens_Select_Column_Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Invalid = 'invalid'
}

/** select "auth_refresh_tokens_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.refresh_tokens" */
export enum Auth_Refresh_Tokens_Select_Column_Auth_Refresh_Tokens_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Invalid = 'invalid'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type Auth_Refresh_Tokens_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_refresh_tokens" */
export type Auth_Refresh_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Refresh_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Refresh_Tokens_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  refresh_token_hash?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum Auth_Refresh_Tokens_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  RefreshTokenHash = 'refresh_token_hash'
}

export type Auth_Refresh_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Refresh_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Refresh_Tokens_Bool_Exp;
};

/** columns and relationships of "auth.roles" */
export type Auth_Roles = {
  __typename?: 'auth_roles';
  /** An array relationship */
  account_roles: Array<Auth_Account_Roles>;
  /** An aggregate relationship */
  account_roles_aggregate: Auth_Account_Roles_Aggregate;
  /** An array relationship */
  accounts: Array<Auth_Accounts>;
  /** An aggregate relationship */
  accounts_aggregate: Auth_Accounts_Aggregate;
  role: Scalars['String']['output'];
};


/** columns and relationships of "auth.roles" */
export type Auth_RolesAccount_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "auth.roles" */
export type Auth_RolesAccount_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


/** columns and relationships of "auth.roles" */
export type Auth_RolesAccountsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


/** columns and relationships of "auth.roles" */
export type Auth_RolesAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};

/** aggregated selection of "auth.roles" */
export type Auth_Roles_Aggregate = {
  __typename?: 'auth_roles_aggregate';
  aggregate?: Maybe<Auth_Roles_Aggregate_Fields>;
  nodes: Array<Auth_Roles>;
};

/** aggregate fields of "auth.roles" */
export type Auth_Roles_Aggregate_Fields = {
  __typename?: 'auth_roles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Auth_Roles_Max_Fields>;
  min?: Maybe<Auth_Roles_Min_Fields>;
};


/** aggregate fields of "auth.roles" */
export type Auth_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Auth_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type Auth_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Auth_Roles_Bool_Exp>>;
  _not?: InputMaybe<Auth_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Auth_Roles_Bool_Exp>>;
  account_roles?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
  account_roles_aggregate?: InputMaybe<Auth_Account_Roles_Aggregate_Bool_Exp>;
  accounts?: InputMaybe<Auth_Accounts_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Auth_Accounts_Aggregate_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum Auth_Roles_Constraint {
  /** unique or primary key constraint on columns "role" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type Auth_Roles_Insert_Input = {
  account_roles?: InputMaybe<Auth_Account_Roles_Arr_Rel_Insert_Input>;
  accounts?: InputMaybe<Auth_Accounts_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Auth_Roles_Max_Fields = {
  __typename?: 'auth_roles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Auth_Roles_Min_Fields = {
  __typename?: 'auth_roles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type Auth_Roles_Mutation_Response = {
  __typename?: 'auth_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Auth_Roles>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type Auth_Roles_Obj_Rel_Insert_Input = {
  data: Auth_Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Auth_Roles_On_Conflict>;
};

/** on_conflict condition type for table "auth.roles" */
export type Auth_Roles_On_Conflict = {
  constraint: Auth_Roles_Constraint;
  update_columns?: Array<Auth_Roles_Update_Column>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "auth.roles". */
export type Auth_Roles_Order_By = {
  account_roles_aggregate?: InputMaybe<Auth_Account_Roles_Aggregate_Order_By>;
  accounts_aggregate?: InputMaybe<Auth_Accounts_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: auth.roles */
export type Auth_Roles_Pk_Columns_Input = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum Auth_Roles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "auth.roles" */
export type Auth_Roles_Set_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auth_roles" */
export type Auth_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Auth_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Auth_Roles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum Auth_Roles_Update_Column {
  /** column name */
  Role = 'role'
}

export type Auth_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Auth_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Auth_Roles_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "casemix_category" */
export type Casemix_Category = {
  __typename?: 'casemix_category';
  category: Scalars['String']['output'];
  display_color: Scalars['String']['output'];
  display_order: Scalars['Int']['output'];
};

/** aggregated selection of "casemix_category" */
export type Casemix_Category_Aggregate = {
  __typename?: 'casemix_category_aggregate';
  aggregate?: Maybe<Casemix_Category_Aggregate_Fields>;
  nodes: Array<Casemix_Category>;
};

/** aggregate fields of "casemix_category" */
export type Casemix_Category_Aggregate_Fields = {
  __typename?: 'casemix_category_aggregate_fields';
  avg?: Maybe<Casemix_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Casemix_Category_Max_Fields>;
  min?: Maybe<Casemix_Category_Min_Fields>;
  stddev?: Maybe<Casemix_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Casemix_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Casemix_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Casemix_Category_Sum_Fields>;
  var_pop?: Maybe<Casemix_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Casemix_Category_Var_Samp_Fields>;
  variance?: Maybe<Casemix_Category_Variance_Fields>;
};


/** aggregate fields of "casemix_category" */
export type Casemix_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Casemix_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Casemix_Category_Avg_Fields = {
  __typename?: 'casemix_category_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "casemix_category". All fields are combined with a logical 'AND'. */
export type Casemix_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Casemix_Category_Bool_Exp>>;
  _not?: InputMaybe<Casemix_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Casemix_Category_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  display_color?: InputMaybe<String_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "casemix_category" */
export enum Casemix_Category_Constraint {
  /** unique or primary key constraint on columns "display_color" */
  CasemixCategoryDisplayColorKey = 'casemix_category_display_color_key',
  /** unique or primary key constraint on columns "display_order" */
  CasemixCategoryDisplayOrderKey = 'casemix_category_display_order_key',
  /** unique or primary key constraint on columns "category" */
  CasemixCategoryPkey = 'casemix_category_pkey'
}

/** input type for incrementing numeric columns in table "casemix_category" */
export type Casemix_Category_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "casemix_category" */
export type Casemix_Category_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Casemix_Category_Max_Fields = {
  __typename?: 'casemix_category_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  display_color?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Casemix_Category_Min_Fields = {
  __typename?: 'casemix_category_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  display_color?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "casemix_category" */
export type Casemix_Category_Mutation_Response = {
  __typename?: 'casemix_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Casemix_Category>;
};

/** on_conflict condition type for table "casemix_category" */
export type Casemix_Category_On_Conflict = {
  constraint: Casemix_Category_Constraint;
  update_columns?: Array<Casemix_Category_Update_Column>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "casemix_category". */
export type Casemix_Category_Order_By = {
  category?: InputMaybe<Order_By>;
  display_color?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: casemix_category */
export type Casemix_Category_Pk_Columns_Input = {
  category: Scalars['String']['input'];
};

/** select columns of table "casemix_category" */
export enum Casemix_Category_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  DisplayColor = 'display_color',
  /** column name */
  DisplayOrder = 'display_order'
}

/** input type for updating data in table "casemix_category" */
export type Casemix_Category_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Casemix_Category_Stddev_Fields = {
  __typename?: 'casemix_category_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Casemix_Category_Stddev_Pop_Fields = {
  __typename?: 'casemix_category_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Casemix_Category_Stddev_Samp_Fields = {
  __typename?: 'casemix_category_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "casemix_category" */
export type Casemix_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Casemix_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Casemix_Category_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Casemix_Category_Sum_Fields = {
  __typename?: 'casemix_category_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "casemix_category" */
export enum Casemix_Category_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  DisplayColor = 'display_color',
  /** column name */
  DisplayOrder = 'display_order'
}

export type Casemix_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Casemix_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Casemix_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Casemix_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Casemix_Category_Var_Pop_Fields = {
  __typename?: 'casemix_category_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Casemix_Category_Var_Samp_Fields = {
  __typename?: 'casemix_category_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Casemix_Category_Variance_Fields = {
  __typename?: 'casemix_category_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "client_demographics" */
export type Client_Demographics = {
  __typename?: 'client_demographics';
  birth_year?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Enum_Gender_Enum>;
  id: Scalars['uuid']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  practitioner_id: Scalars['uuid']['output'];
  racial_ethnic?: Maybe<Enum_Racial_Ethnic_Enum>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "client_demographics" */
export type Client_Demographics_Aggregate = {
  __typename?: 'client_demographics_aggregate';
  aggregate?: Maybe<Client_Demographics_Aggregate_Fields>;
  nodes: Array<Client_Demographics>;
};

export type Client_Demographics_Aggregate_Bool_Exp = {
  count?: InputMaybe<Client_Demographics_Aggregate_Bool_Exp_Count>;
};

export type Client_Demographics_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Client_Demographics_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "client_demographics" */
export type Client_Demographics_Aggregate_Fields = {
  __typename?: 'client_demographics_aggregate_fields';
  avg?: Maybe<Client_Demographics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Client_Demographics_Max_Fields>;
  min?: Maybe<Client_Demographics_Min_Fields>;
  stddev?: Maybe<Client_Demographics_Stddev_Fields>;
  stddev_pop?: Maybe<Client_Demographics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Client_Demographics_Stddev_Samp_Fields>;
  sum?: Maybe<Client_Demographics_Sum_Fields>;
  var_pop?: Maybe<Client_Demographics_Var_Pop_Fields>;
  var_samp?: Maybe<Client_Demographics_Var_Samp_Fields>;
  variance?: Maybe<Client_Demographics_Variance_Fields>;
};


/** aggregate fields of "client_demographics" */
export type Client_Demographics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "client_demographics" */
export type Client_Demographics_Aggregate_Order_By = {
  avg?: InputMaybe<Client_Demographics_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Demographics_Max_Order_By>;
  min?: InputMaybe<Client_Demographics_Min_Order_By>;
  stddev?: InputMaybe<Client_Demographics_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Client_Demographics_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Client_Demographics_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Client_Demographics_Sum_Order_By>;
  var_pop?: InputMaybe<Client_Demographics_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Client_Demographics_Var_Samp_Order_By>;
  variance?: InputMaybe<Client_Demographics_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "client_demographics" */
export type Client_Demographics_Arr_Rel_Insert_Input = {
  data: Array<Client_Demographics_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_Demographics_On_Conflict>;
};

/** aggregate avg on columns */
export type Client_Demographics_Avg_Fields = {
  __typename?: 'client_demographics_avg_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "client_demographics" */
export type Client_Demographics_Avg_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "client_demographics". All fields are combined with a logical 'AND'. */
export type Client_Demographics_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Demographics_Bool_Exp>>;
  _not?: InputMaybe<Client_Demographics_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Demographics_Bool_Exp>>;
  birth_year?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Enum_Gender_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  racial_ethnic?: InputMaybe<Enum_Racial_Ethnic_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_demographics" */
export enum Client_Demographics_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientDemographicsPkey = 'client_demographics_pkey',
  /** unique or primary key constraint on columns "practitioner_id", "user_id" */
  UniqueUserIdPractitionerId = 'unique_user_id_practitioner_id'
}

/** input type for incrementing numeric columns in table "client_demographics" */
export type Client_Demographics_Inc_Input = {
  birth_year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "client_demographics" */
export type Client_Demographics_Insert_Input = {
  birth_year?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Enum_Gender_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  racial_ethnic?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Client_Demographics_Max_Fields = {
  __typename?: 'client_demographics_max_fields';
  birth_year?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "client_demographics" */
export type Client_Demographics_Max_Order_By = {
  birth_year?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Client_Demographics_Min_Fields = {
  __typename?: 'client_demographics_min_fields';
  birth_year?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "client_demographics" */
export type Client_Demographics_Min_Order_By = {
  birth_year?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client_demographics" */
export type Client_Demographics_Mutation_Response = {
  __typename?: 'client_demographics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Client_Demographics>;
};

/** on_conflict condition type for table "client_demographics" */
export type Client_Demographics_On_Conflict = {
  constraint: Client_Demographics_Constraint;
  update_columns?: Array<Client_Demographics_Update_Column>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};

/** Ordering options when selecting data from "client_demographics". */
export type Client_Demographics_Order_By = {
  birth_year?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  racial_ethnic?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_demographics */
export type Client_Demographics_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "client_demographics" */
export enum Client_Demographics_Select_Column {
  /** column name */
  BirthYear = 'birth_year',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RacialEthnic = 'racial_ethnic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "client_demographics" */
export type Client_Demographics_Set_Input = {
  birth_year?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Enum_Gender_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  racial_ethnic?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Client_Demographics_Stddev_Fields = {
  __typename?: 'client_demographics_stddev_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "client_demographics" */
export type Client_Demographics_Stddev_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Client_Demographics_Stddev_Pop_Fields = {
  __typename?: 'client_demographics_stddev_pop_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "client_demographics" */
export type Client_Demographics_Stddev_Pop_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Client_Demographics_Stddev_Samp_Fields = {
  __typename?: 'client_demographics_stddev_samp_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "client_demographics" */
export type Client_Demographics_Stddev_Samp_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "client_demographics" */
export type Client_Demographics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Demographics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Demographics_Stream_Cursor_Value_Input = {
  birth_year?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Enum_Gender_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  racial_ethnic?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Client_Demographics_Sum_Fields = {
  __typename?: 'client_demographics_sum_fields';
  birth_year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "client_demographics" */
export type Client_Demographics_Sum_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** update columns of table "client_demographics" */
export enum Client_Demographics_Update_Column {
  /** column name */
  BirthYear = 'birth_year',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RacialEthnic = 'racial_ethnic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Client_Demographics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Client_Demographics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Client_Demographics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Demographics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Client_Demographics_Var_Pop_Fields = {
  __typename?: 'client_demographics_var_pop_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "client_demographics" */
export type Client_Demographics_Var_Pop_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Client_Demographics_Var_Samp_Fields = {
  __typename?: 'client_demographics_var_samp_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "client_demographics" */
export type Client_Demographics_Var_Samp_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Client_Demographics_Variance_Fields = {
  __typename?: 'client_demographics_variance_fields';
  birth_year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "client_demographics" */
export type Client_Demographics_Variance_Order_By = {
  birth_year?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "daily_features" */
export type Daily_Features = {
  __typename?: 'daily_features';
  create_date: Scalars['timestamptz']['output'];
  direction: Enum_Trend_Direction_Enum;
  feature_date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  is_user_reported_accurate?: Maybe<Scalars['Boolean']['output']>;
  key: Enum_Feature_Type_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "daily_features" */
export type Daily_Features_Aggregate = {
  __typename?: 'daily_features_aggregate';
  aggregate?: Maybe<Daily_Features_Aggregate_Fields>;
  nodes: Array<Daily_Features>;
};

export type Daily_Features_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Daily_Features_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Daily_Features_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Daily_Features_Aggregate_Bool_Exp_Count>;
};

export type Daily_Features_Aggregate_Bool_Exp_Bool_And = {
  arguments: Daily_Features_Select_Column_Daily_Features_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Daily_Features_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Daily_Features_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Daily_Features_Select_Column_Daily_Features_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Daily_Features_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Daily_Features_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Daily_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Daily_Features_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "daily_features" */
export type Daily_Features_Aggregate_Fields = {
  __typename?: 'daily_features_aggregate_fields';
  avg?: Maybe<Daily_Features_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Daily_Features_Max_Fields>;
  min?: Maybe<Daily_Features_Min_Fields>;
  stddev?: Maybe<Daily_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Daily_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daily_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Daily_Features_Sum_Fields>;
  var_pop?: Maybe<Daily_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Daily_Features_Var_Samp_Fields>;
  variance?: Maybe<Daily_Features_Variance_Fields>;
};


/** aggregate fields of "daily_features" */
export type Daily_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Daily_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "daily_features" */
export type Daily_Features_Aggregate_Order_By = {
  avg?: InputMaybe<Daily_Features_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Daily_Features_Max_Order_By>;
  min?: InputMaybe<Daily_Features_Min_Order_By>;
  stddev?: InputMaybe<Daily_Features_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Daily_Features_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Daily_Features_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Daily_Features_Sum_Order_By>;
  var_pop?: InputMaybe<Daily_Features_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Daily_Features_Var_Samp_Order_By>;
  variance?: InputMaybe<Daily_Features_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "daily_features" */
export type Daily_Features_Arr_Rel_Insert_Input = {
  data: Array<Daily_Features_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Daily_Features_On_Conflict>;
};

/** aggregate avg on columns */
export type Daily_Features_Avg_Fields = {
  __typename?: 'daily_features_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "daily_features" */
export type Daily_Features_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "daily_features". All fields are combined with a logical 'AND'. */
export type Daily_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Daily_Features_Bool_Exp>>;
  _not?: InputMaybe<Daily_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Daily_Features_Bool_Exp>>;
  create_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  direction?: InputMaybe<Enum_Trend_Direction_Enum_Comparison_Exp>;
  feature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_user_reported_accurate?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "daily_features" */
export enum Daily_Features_Constraint {
  /** unique or primary key constraint on columns "id" */
  DailyFeaturesPkey = 'daily_features_pkey'
}

/** input type for incrementing numeric columns in table "daily_features" */
export type Daily_Features_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "daily_features" */
export type Daily_Features_Insert_Input = {
  create_date?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Enum_Trend_Direction_Enum>;
  feature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_user_reported_accurate?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Daily_Features_Max_Fields = {
  __typename?: 'daily_features_max_fields';
  create_date?: Maybe<Scalars['timestamptz']['output']>;
  feature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "daily_features" */
export type Daily_Features_Max_Order_By = {
  create_date?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Daily_Features_Min_Fields = {
  __typename?: 'daily_features_min_fields';
  create_date?: Maybe<Scalars['timestamptz']['output']>;
  feature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "daily_features" */
export type Daily_Features_Min_Order_By = {
  create_date?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "daily_features" */
export type Daily_Features_Mutation_Response = {
  __typename?: 'daily_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Daily_Features>;
};

/** on_conflict condition type for table "daily_features" */
export type Daily_Features_On_Conflict = {
  constraint: Daily_Features_Constraint;
  update_columns?: Array<Daily_Features_Update_Column>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "daily_features". */
export type Daily_Features_Order_By = {
  create_date?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_user_reported_accurate?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: daily_features */
export type Daily_Features_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "daily_features" */
export enum Daily_Features_Select_Column {
  /** column name */
  CreateDate = 'create_date',
  /** column name */
  Direction = 'direction',
  /** column name */
  FeatureDate = 'feature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsUserReportedAccurate = 'is_user_reported_accurate',
  /** column name */
  Key = 'key',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** select "daily_features_aggregate_bool_exp_bool_and_arguments_columns" columns of table "daily_features" */
export enum Daily_Features_Select_Column_Daily_Features_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsUserReportedAccurate = 'is_user_reported_accurate'
}

/** select "daily_features_aggregate_bool_exp_bool_or_arguments_columns" columns of table "daily_features" */
export enum Daily_Features_Select_Column_Daily_Features_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsUserReportedAccurate = 'is_user_reported_accurate'
}

/** input type for updating data in table "daily_features" */
export type Daily_Features_Set_Input = {
  create_date?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Enum_Trend_Direction_Enum>;
  feature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_user_reported_accurate?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Daily_Features_Stddev_Fields = {
  __typename?: 'daily_features_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "daily_features" */
export type Daily_Features_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Daily_Features_Stddev_Pop_Fields = {
  __typename?: 'daily_features_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "daily_features" */
export type Daily_Features_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Daily_Features_Stddev_Samp_Fields = {
  __typename?: 'daily_features_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "daily_features" */
export type Daily_Features_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "daily_features" */
export type Daily_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Daily_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Daily_Features_Stream_Cursor_Value_Input = {
  create_date?: InputMaybe<Scalars['timestamptz']['input']>;
  direction?: InputMaybe<Enum_Trend_Direction_Enum>;
  feature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_user_reported_accurate?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Daily_Features_Sum_Fields = {
  __typename?: 'daily_features_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "daily_features" */
export type Daily_Features_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "daily_features" */
export enum Daily_Features_Update_Column {
  /** column name */
  CreateDate = 'create_date',
  /** column name */
  Direction = 'direction',
  /** column name */
  FeatureDate = 'feature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsUserReportedAccurate = 'is_user_reported_accurate',
  /** column name */
  Key = 'key',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type Daily_Features_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Daily_Features_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Daily_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Daily_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Daily_Features_Var_Pop_Fields = {
  __typename?: 'daily_features_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "daily_features" */
export type Daily_Features_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Daily_Features_Var_Samp_Fields = {
  __typename?: 'daily_features_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "daily_features" */
export type Daily_Features_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Daily_Features_Variance_Fields = {
  __typename?: 'daily_features_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "daily_features" */
export type Daily_Features_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes = {
  __typename?: 'ehr_client_invite_codes';
  code: Scalars['String']['output'];
  created_at: Scalars['timestamp']['output'];
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_sent_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  phone_contacted_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  practitioner_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Aggregate = {
  __typename?: 'ehr_client_invite_codes_aggregate';
  aggregate?: Maybe<Ehr_Client_Invite_Codes_Aggregate_Fields>;
  nodes: Array<Ehr_Client_Invite_Codes>;
};

/** aggregate fields of "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Aggregate_Fields = {
  __typename?: 'ehr_client_invite_codes_aggregate_fields';
  avg?: Maybe<Ehr_Client_Invite_Codes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ehr_Client_Invite_Codes_Max_Fields>;
  min?: Maybe<Ehr_Client_Invite_Codes_Min_Fields>;
  stddev?: Maybe<Ehr_Client_Invite_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Ehr_Client_Invite_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ehr_Client_Invite_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Ehr_Client_Invite_Codes_Sum_Fields>;
  var_pop?: Maybe<Ehr_Client_Invite_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Ehr_Client_Invite_Codes_Var_Samp_Fields>;
  variance?: Maybe<Ehr_Client_Invite_Codes_Variance_Fields>;
};


/** aggregate fields of "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Client_Invite_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ehr_Client_Invite_Codes_Avg_Fields = {
  __typename?: 'ehr_client_invite_codes_avg_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "ehr.client_invite_codes". All fields are combined with a logical 'AND'. */
export type Ehr_Client_Invite_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Client_Invite_Codes_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Client_Invite_Codes_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  minutes_to_expiration?: InputMaybe<Int_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  phone_contacted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr.client_invite_codes" */
export enum Ehr_Client_Invite_Codes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientInviteCodesPkey = 'client_invite_codes_pkey'
}

/** input type for incrementing numeric columns in table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Inc_Input = {
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Insert_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  phone_contacted_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Ehr_Client_Invite_Codes_Max_Fields = {
  __typename?: 'ehr_client_invite_codes_max_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_sent_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  phone_contacted_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Ehr_Client_Invite_Codes_Min_Fields = {
  __typename?: 'ehr_client_invite_codes_min_fields';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deleted_at?: Maybe<Scalars['timestamp']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_sent_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  phone_contacted_at?: Maybe<Scalars['timestamp']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Mutation_Response = {
  __typename?: 'ehr_client_invite_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Client_Invite_Codes>;
};

/** input type for inserting object relation for remote table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Obj_Rel_Insert_Input = {
  data: Ehr_Client_Invite_Codes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ehr_Client_Invite_Codes_On_Conflict>;
};

/** on_conflict condition type for table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_On_Conflict = {
  constraint: Ehr_Client_Invite_Codes_Constraint;
  update_columns?: Array<Ehr_Client_Invite_Codes_Update_Column>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr.client_invite_codes". */
export type Ehr_Client_Invite_Codes_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  phone_contacted_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr.client_invite_codes */
export type Ehr_Client_Invite_Codes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ehr.client_invite_codes" */
export enum Ehr_Client_Invite_Codes_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailSentAt = 'email_sent_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PhoneContactedAt = 'phone_contacted_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "ehr.client_invite_codes" */
export type Ehr_Client_Invite_Codes_Set_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  phone_contacted_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Ehr_Client_Invite_Codes_Stddev_Fields = {
  __typename?: 'ehr_client_invite_codes_stddev_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ehr_Client_Invite_Codes_Stddev_Pop_Fields = {
  __typename?: 'ehr_client_invite_codes_stddev_pop_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ehr_Client_Invite_Codes_Stddev_Samp_Fields = {
  __typename?: 'ehr_client_invite_codes_stddev_samp_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "ehr_client_invite_codes" */
export type Ehr_Client_Invite_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Client_Invite_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Client_Invite_Codes_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  phone_contacted_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Ehr_Client_Invite_Codes_Sum_Fields = {
  __typename?: 'ehr_client_invite_codes_sum_fields';
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "ehr.client_invite_codes" */
export enum Ehr_Client_Invite_Codes_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailSentAt = 'email_sent_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PhoneContactedAt = 'phone_contacted_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Ehr_Client_Invite_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ehr_Client_Invite_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Client_Invite_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Client_Invite_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ehr_Client_Invite_Codes_Var_Pop_Fields = {
  __typename?: 'ehr_client_invite_codes_var_pop_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ehr_Client_Invite_Codes_Var_Samp_Fields = {
  __typename?: 'ehr_client_invite_codes_var_samp_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ehr_Client_Invite_Codes_Variance_Fields = {
  __typename?: 'ehr_client_invite_codes_variance_fields';
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map = {
  __typename?: 'ehr_ehr_practitioner_map';
  created_at: Scalars['timestamp']['output'];
  ehr_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  practitioner_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Aggregate = {
  __typename?: 'ehr_ehr_practitioner_map_aggregate';
  aggregate?: Maybe<Ehr_Ehr_Practitioner_Map_Aggregate_Fields>;
  nodes: Array<Ehr_Ehr_Practitioner_Map>;
};

/** aggregate fields of "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Aggregate_Fields = {
  __typename?: 'ehr_ehr_practitioner_map_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ehr_Ehr_Practitioner_Map_Max_Fields>;
  min?: Maybe<Ehr_Ehr_Practitioner_Map_Min_Fields>;
};


/** aggregate fields of "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ehr.ehr_practitioner_map". All fields are combined with a logical 'AND'. */
export type Ehr_Ehr_Practitioner_Map_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ehr_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr.ehr_practitioner_map" */
export enum Ehr_Ehr_Practitioner_Map_Constraint {
  /** unique or primary key constraint on columns "id" */
  XealthPractitionerMapPkey = 'xealth_practitioner_map_pkey'
}

/** input type for inserting data into table "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ehr_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ehr_Ehr_Practitioner_Map_Max_Fields = {
  __typename?: 'ehr_ehr_practitioner_map_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ehr_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Ehr_Ehr_Practitioner_Map_Min_Fields = {
  __typename?: 'ehr_ehr_practitioner_map_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ehr_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Mutation_Response = {
  __typename?: 'ehr_ehr_practitioner_map_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Ehr_Practitioner_Map>;
};

/** on_conflict condition type for table "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_On_Conflict = {
  constraint: Ehr_Ehr_Practitioner_Map_Constraint;
  update_columns?: Array<Ehr_Ehr_Practitioner_Map_Update_Column>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr.ehr_practitioner_map". */
export type Ehr_Ehr_Practitioner_Map_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ehr_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr.ehr_practitioner_map */
export type Ehr_Ehr_Practitioner_Map_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ehr.ehr_practitioner_map" */
export enum Ehr_Ehr_Practitioner_Map_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EhrId = 'ehr_id',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ehr.ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ehr_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "ehr_ehr_practitioner_map" */
export type Ehr_Ehr_Practitioner_Map_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Ehr_Practitioner_Map_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Ehr_Practitioner_Map_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ehr_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "ehr.ehr_practitioner_map" */
export enum Ehr_Ehr_Practitioner_Map_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EhrId = 'ehr_id',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ehr_Ehr_Practitioner_Map_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Ehr_Practitioner_Map_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Ehr_Practitioner_Map_Bool_Exp;
};

/** columns and relationships of "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification = {
  __typename?: 'ehr_xealth_event_notification';
  created_at: Scalars['timestamp']['output'];
  deployment: Scalars['String']['output'];
  event_context: Scalars['String']['output'];
  event_id: Scalars['String']['output'];
  event_timestamp: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  order_id: Scalars['String']['output'];
  partner_id: Scalars['String']['output'];
  patient_identity: Scalars['jsonb']['output'];
  program_id: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_NotificationPatient_IdentityArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Aggregate = {
  __typename?: 'ehr_xealth_event_notification_aggregate';
  aggregate?: Maybe<Ehr_Xealth_Event_Notification_Aggregate_Fields>;
  nodes: Array<Ehr_Xealth_Event_Notification>;
};

/** aggregate fields of "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Aggregate_Fields = {
  __typename?: 'ehr_xealth_event_notification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ehr_Xealth_Event_Notification_Max_Fields>;
  min?: Maybe<Ehr_Xealth_Event_Notification_Min_Fields>;
};


/** aggregate fields of "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Xealth_Event_Notification_Append_Input = {
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "ehr.xealth_event_notification". All fields are combined with a logical 'AND'. */
export type Ehr_Xealth_Event_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  deployment?: InputMaybe<String_Comparison_Exp>;
  event_context?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<String_Comparison_Exp>;
  event_timestamp?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  partner_id?: InputMaybe<String_Comparison_Exp>;
  patient_identity?: InputMaybe<Jsonb_Comparison_Exp>;
  program_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr.xealth_event_notification" */
export enum Ehr_Xealth_Event_Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  XealthEventNotificationPkey = 'xealth_event_notification_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ehr_Xealth_Event_Notification_Delete_At_Path_Input = {
  patient_identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ehr_Xealth_Event_Notification_Delete_Elem_Input = {
  patient_identity?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ehr_Xealth_Event_Notification_Delete_Key_Input = {
  patient_identity?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  event_timestamp?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['String']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ehr_Xealth_Event_Notification_Max_Fields = {
  __typename?: 'ehr_xealth_event_notification_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deployment?: Maybe<Scalars['String']['output']>;
  event_context?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_timestamp?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Ehr_Xealth_Event_Notification_Min_Fields = {
  __typename?: 'ehr_xealth_event_notification_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  deployment?: Maybe<Scalars['String']['output']>;
  event_context?: Maybe<Scalars['String']['output']>;
  event_id?: Maybe<Scalars['String']['output']>;
  event_timestamp?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  partner_id?: Maybe<Scalars['String']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Mutation_Response = {
  __typename?: 'ehr_xealth_event_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Xealth_Event_Notification>;
};

/** on_conflict condition type for table "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_On_Conflict = {
  constraint: Ehr_Xealth_Event_Notification_Constraint;
  update_columns?: Array<Ehr_Xealth_Event_Notification_Update_Column>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr.xealth_event_notification". */
export type Ehr_Xealth_Event_Notification_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deployment?: InputMaybe<Order_By>;
  event_context?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  event_timestamp?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  partner_id?: InputMaybe<Order_By>;
  patient_identity?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr.xealth_event_notification */
export type Ehr_Xealth_Event_Notification_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Xealth_Event_Notification_Prepend_Input = {
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ehr.xealth_event_notification" */
export enum Ehr_Xealth_Event_Notification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deployment = 'deployment',
  /** column name */
  EventContext = 'event_context',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTimestamp = 'event_timestamp',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PatientIdentity = 'patient_identity',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ehr.xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  event_timestamp?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['String']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "ehr_xealth_event_notification" */
export type Ehr_Xealth_Event_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Xealth_Event_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Xealth_Event_Notification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  event_timestamp?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  partner_id?: InputMaybe<Scalars['String']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "ehr.xealth_event_notification" */
export enum Ehr_Xealth_Event_Notification_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deployment = 'deployment',
  /** column name */
  EventContext = 'event_context',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTimestamp = 'event_timestamp',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  PartnerId = 'partner_id',
  /** column name */
  PatientIdentity = 'patient_identity',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ehr_Xealth_Event_Notification_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ehr_Xealth_Event_Notification_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ehr_Xealth_Event_Notification_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Xealth_Event_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Xealth_Event_Notification_Bool_Exp;
};

/** columns and relationships of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form = {
  __typename?: 'ehr_xealth_preorder_form';
  created_at: Scalars['timestamp']['output'];
  data_tracking_id: Scalars['uuid']['output'];
  deployment: Scalars['String']['output'];
  ehr_user_v1: Scalars['jsonb']['output'];
  event_context: Scalars['String']['output'];
  event_type: Scalars['String']['output'];
  form_data?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  patient_identity: Scalars['jsonb']['output'];
  program_id: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_FormEhr_User_V1Args = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_FormForm_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_FormPatient_IdentityArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Aggregate = {
  __typename?: 'ehr_xealth_preorder_form_aggregate';
  aggregate?: Maybe<Ehr_Xealth_Preorder_Form_Aggregate_Fields>;
  nodes: Array<Ehr_Xealth_Preorder_Form>;
};

/** aggregate fields of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Aggregate_Fields = {
  __typename?: 'ehr_xealth_preorder_form_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ehr_Xealth_Preorder_Form_Max_Fields>;
  min?: Maybe<Ehr_Xealth_Preorder_Form_Min_Fields>;
};


/** aggregate fields of "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Xealth_Preorder_Form_Append_Input = {
  ehr_user_v1?: InputMaybe<Scalars['jsonb']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "ehr.xealth_preorder_form". All fields are combined with a logical 'AND'. */
export type Ehr_Xealth_Preorder_Form_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data_tracking_id?: InputMaybe<Uuid_Comparison_Exp>;
  deployment?: InputMaybe<String_Comparison_Exp>;
  ehr_user_v1?: InputMaybe<Jsonb_Comparison_Exp>;
  event_context?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  form_data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  patient_identity?: InputMaybe<Jsonb_Comparison_Exp>;
  program_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr.xealth_preorder_form" */
export enum Ehr_Xealth_Preorder_Form_Constraint {
  /** unique or primary key constraint on columns "id" */
  XealthPreorderFormPkey = 'xealth_preorder_form_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ehr_Xealth_Preorder_Form_Delete_At_Path_Input = {
  ehr_user_v1?: InputMaybe<Array<Scalars['String']['input']>>;
  form_data?: InputMaybe<Array<Scalars['String']['input']>>;
  patient_identity?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ehr_Xealth_Preorder_Form_Delete_Elem_Input = {
  ehr_user_v1?: InputMaybe<Scalars['Int']['input']>;
  form_data?: InputMaybe<Scalars['Int']['input']>;
  patient_identity?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ehr_Xealth_Preorder_Form_Delete_Key_Input = {
  ehr_user_v1?: InputMaybe<Scalars['String']['input']>;
  form_data?: InputMaybe<Scalars['String']['input']>;
  patient_identity?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data_tracking_id?: InputMaybe<Scalars['uuid']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  ehr_user_v1?: InputMaybe<Scalars['jsonb']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ehr_Xealth_Preorder_Form_Max_Fields = {
  __typename?: 'ehr_xealth_preorder_form_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data_tracking_id?: Maybe<Scalars['uuid']['output']>;
  deployment?: Maybe<Scalars['String']['output']>;
  event_context?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Ehr_Xealth_Preorder_Form_Min_Fields = {
  __typename?: 'ehr_xealth_preorder_form_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  data_tracking_id?: Maybe<Scalars['uuid']['output']>;
  deployment?: Maybe<Scalars['String']['output']>;
  event_context?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  program_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Mutation_Response = {
  __typename?: 'ehr_xealth_preorder_form_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Xealth_Preorder_Form>;
};

/** on_conflict condition type for table "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_On_Conflict = {
  constraint: Ehr_Xealth_Preorder_Form_Constraint;
  update_columns?: Array<Ehr_Xealth_Preorder_Form_Update_Column>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr.xealth_preorder_form". */
export type Ehr_Xealth_Preorder_Form_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data_tracking_id?: InputMaybe<Order_By>;
  deployment?: InputMaybe<Order_By>;
  ehr_user_v1?: InputMaybe<Order_By>;
  event_context?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  form_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  patient_identity?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr.xealth_preorder_form */
export type Ehr_Xealth_Preorder_Form_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ehr_Xealth_Preorder_Form_Prepend_Input = {
  ehr_user_v1?: InputMaybe<Scalars['jsonb']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ehr.xealth_preorder_form" */
export enum Ehr_Xealth_Preorder_Form_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataTrackingId = 'data_tracking_id',
  /** column name */
  Deployment = 'deployment',
  /** column name */
  EhrUserV1 = 'ehr_user_v1',
  /** column name */
  EventContext = 'event_context',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FormData = 'form_data',
  /** column name */
  Id = 'id',
  /** column name */
  PatientIdentity = 'patient_identity',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ehr.xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data_tracking_id?: InputMaybe<Scalars['uuid']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  ehr_user_v1?: InputMaybe<Scalars['jsonb']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "ehr_xealth_preorder_form" */
export type Ehr_Xealth_Preorder_Form_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Xealth_Preorder_Form_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Xealth_Preorder_Form_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  data_tracking_id?: InputMaybe<Scalars['uuid']['input']>;
  deployment?: InputMaybe<Scalars['String']['input']>;
  ehr_user_v1?: InputMaybe<Scalars['jsonb']['input']>;
  event_context?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  form_data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patient_identity?: InputMaybe<Scalars['jsonb']['input']>;
  program_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "ehr.xealth_preorder_form" */
export enum Ehr_Xealth_Preorder_Form_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataTrackingId = 'data_tracking_id',
  /** column name */
  Deployment = 'deployment',
  /** column name */
  EhrUserV1 = 'ehr_user_v1',
  /** column name */
  EventContext = 'event_context',
  /** column name */
  EventType = 'event_type',
  /** column name */
  FormData = 'form_data',
  /** column name */
  Id = 'id',
  /** column name */
  PatientIdentity = 'patient_identity',
  /** column name */
  ProgramId = 'program_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ehr_Xealth_Preorder_Form_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ehr_Xealth_Preorder_Form_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ehr_Xealth_Preorder_Form_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Xealth_Preorder_Form_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Xealth_Preorder_Form_Bool_Exp;
};

/** columns and relationships of "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map = {
  __typename?: 'ehr_xealth_preorder_invite_map';
  /** An object relationship */
  client_invite_code: Ehr_Client_Invite_Codes;
  client_invite_code_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  order_id: Scalars['String']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Aggregate = {
  __typename?: 'ehr_xealth_preorder_invite_map_aggregate';
  aggregate?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Aggregate_Fields>;
  nodes: Array<Ehr_Xealth_Preorder_Invite_Map>;
};

/** aggregate fields of "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Aggregate_Fields = {
  __typename?: 'ehr_xealth_preorder_invite_map_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Max_Fields>;
  min?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Min_Fields>;
};


/** aggregate fields of "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "ehr.xealth_preorder_invite_map". All fields are combined with a logical 'AND'. */
export type Ehr_Xealth_Preorder_Invite_Map_Bool_Exp = {
  _and?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>>;
  _not?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
  _or?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>>;
  client_invite_code?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
  client_invite_code_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "ehr.xealth_preorder_invite_map" */
export enum Ehr_Xealth_Preorder_Invite_Map_Constraint {
  /** unique or primary key constraint on columns "id" */
  XealthPreorderInviteMapPkey = 'xealth_preorder_invite_map_pkey'
}

/** input type for inserting data into table "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Insert_Input = {
  client_invite_code?: InputMaybe<Ehr_Client_Invite_Codes_Obj_Rel_Insert_Input>;
  client_invite_code_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Ehr_Xealth_Preorder_Invite_Map_Max_Fields = {
  __typename?: 'ehr_xealth_preorder_invite_map_max_fields';
  client_invite_code_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Ehr_Xealth_Preorder_Invite_Map_Min_Fields = {
  __typename?: 'ehr_xealth_preorder_invite_map_min_fields';
  client_invite_code_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Mutation_Response = {
  __typename?: 'ehr_xealth_preorder_invite_map_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ehr_Xealth_Preorder_Invite_Map>;
};

/** on_conflict condition type for table "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_On_Conflict = {
  constraint: Ehr_Xealth_Preorder_Invite_Map_Constraint;
  update_columns?: Array<Ehr_Xealth_Preorder_Invite_Map_Update_Column>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};

/** Ordering options when selecting data from "ehr.xealth_preorder_invite_map". */
export type Ehr_Xealth_Preorder_Invite_Map_Order_By = {
  client_invite_code?: InputMaybe<Ehr_Client_Invite_Codes_Order_By>;
  client_invite_code_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ehr.xealth_preorder_invite_map */
export type Ehr_Xealth_Preorder_Invite_Map_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ehr.xealth_preorder_invite_map" */
export enum Ehr_Xealth_Preorder_Invite_Map_Select_Column {
  /** column name */
  ClientInviteCodeId = 'client_invite_code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ehr.xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Set_Input = {
  client_invite_code_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "ehr_xealth_preorder_invite_map" */
export type Ehr_Xealth_Preorder_Invite_Map_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ehr_Xealth_Preorder_Invite_Map_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ehr_Xealth_Preorder_Invite_Map_Stream_Cursor_Value_Input = {
  client_invite_code_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "ehr.xealth_preorder_invite_map" */
export enum Ehr_Xealth_Preorder_Invite_Map_Update_Column {
  /** column name */
  ClientInviteCodeId = 'client_invite_code_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ehr_Xealth_Preorder_Invite_Map_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ehr_Xealth_Preorder_Invite_Map_Bool_Exp;
};

/** columns and relationships of "enum_activity_category" */
export type Enum_Activity_Category = {
  __typename?: 'enum_activity_category';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_activity_category" */
export type Enum_Activity_Category_Aggregate = {
  __typename?: 'enum_activity_category_aggregate';
  aggregate?: Maybe<Enum_Activity_Category_Aggregate_Fields>;
  nodes: Array<Enum_Activity_Category>;
};

/** aggregate fields of "enum_activity_category" */
export type Enum_Activity_Category_Aggregate_Fields = {
  __typename?: 'enum_activity_category_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Activity_Category_Max_Fields>;
  min?: Maybe<Enum_Activity_Category_Min_Fields>;
};


/** aggregate fields of "enum_activity_category" */
export type Enum_Activity_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Activity_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_activity_category". All fields are combined with a logical 'AND'. */
export type Enum_Activity_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Activity_Category_Bool_Exp>>;
  _not?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Activity_Category_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_activity_category" */
export enum Enum_Activity_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumActivityCategoryPkey = 'enum_activity_category_pkey'
}

export enum Enum_Activity_Category_Enum {
  Distraction = 'distraction',
  KeepMeCalm = 'keep_me_calm',
  KeepMeSafe = 'keep_me_safe'
}

/** Boolean expression to compare columns of type "enum_activity_category_enum". All fields are combined with logical 'AND'. */
export type Enum_Activity_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Activity_Category_Enum>;
  _in?: InputMaybe<Array<Enum_Activity_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Activity_Category_Enum>;
  _nin?: InputMaybe<Array<Enum_Activity_Category_Enum>>;
};

/** input type for inserting data into table "enum_activity_category" */
export type Enum_Activity_Category_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Activity_Category_Max_Fields = {
  __typename?: 'enum_activity_category_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Activity_Category_Min_Fields = {
  __typename?: 'enum_activity_category_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_activity_category" */
export type Enum_Activity_Category_Mutation_Response = {
  __typename?: 'enum_activity_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Activity_Category>;
};

/** on_conflict condition type for table "enum_activity_category" */
export type Enum_Activity_Category_On_Conflict = {
  constraint: Enum_Activity_Category_Constraint;
  update_columns?: Array<Enum_Activity_Category_Update_Column>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_activity_category". */
export type Enum_Activity_Category_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_activity_category */
export type Enum_Activity_Category_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_activity_category" */
export enum Enum_Activity_Category_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_activity_category" */
export type Enum_Activity_Category_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_activity_category" */
export type Enum_Activity_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Activity_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Activity_Category_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_activity_category" */
export enum Enum_Activity_Category_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Activity_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Activity_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Activity_Category_Bool_Exp;
};

/** columns and relationships of "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type = {
  __typename?: 'enum_activity_resource_type';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Aggregate = {
  __typename?: 'enum_activity_resource_type_aggregate';
  aggregate?: Maybe<Enum_Activity_Resource_Type_Aggregate_Fields>;
  nodes: Array<Enum_Activity_Resource_Type>;
};

/** aggregate fields of "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Aggregate_Fields = {
  __typename?: 'enum_activity_resource_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Activity_Resource_Type_Max_Fields>;
  min?: Maybe<Enum_Activity_Resource_Type_Min_Fields>;
};


/** aggregate fields of "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Activity_Resource_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_activity_resource_type". All fields are combined with a logical 'AND'. */
export type Enum_Activity_Resource_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Activity_Resource_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Activity_Resource_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_activity_resource_type" */
export enum Enum_Activity_Resource_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumActivityResourceTypePkey = 'enum_activity_resource_type_pkey'
}

export enum Enum_Activity_Resource_Type_Enum {
  /** Audio resource type */
  Audio = 'audio',
  /** Image resource type */
  Image = 'image',
  /** Video resource type */
  Video = 'video',
  /** Web resource type */
  Web = 'web'
}

/** Boolean expression to compare columns of type "enum_activity_resource_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Activity_Resource_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Activity_Resource_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Activity_Resource_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Activity_Resource_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Activity_Resource_Type_Enum>>;
};

/** input type for inserting data into table "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Activity_Resource_Type_Max_Fields = {
  __typename?: 'enum_activity_resource_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Activity_Resource_Type_Min_Fields = {
  __typename?: 'enum_activity_resource_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Mutation_Response = {
  __typename?: 'enum_activity_resource_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Activity_Resource_Type>;
};

/** on_conflict condition type for table "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_On_Conflict = {
  constraint: Enum_Activity_Resource_Type_Constraint;
  update_columns?: Array<Enum_Activity_Resource_Type_Update_Column>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_activity_resource_type". */
export type Enum_Activity_Resource_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_activity_resource_type */
export type Enum_Activity_Resource_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_activity_resource_type" */
export enum Enum_Activity_Resource_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_activity_resource_type" */
export type Enum_Activity_Resource_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Activity_Resource_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Activity_Resource_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_activity_resource_type" */
export enum Enum_Activity_Resource_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Activity_Resource_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Activity_Resource_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Activity_Resource_Type_Bool_Exp;
};

/** columns and relationships of "enum_completion_status" */
export type Enum_Completion_Status = {
  __typename?: 'enum_completion_status';
  text: Scalars['String']['output'];
};

/** aggregated selection of "enum_completion_status" */
export type Enum_Completion_Status_Aggregate = {
  __typename?: 'enum_completion_status_aggregate';
  aggregate?: Maybe<Enum_Completion_Status_Aggregate_Fields>;
  nodes: Array<Enum_Completion_Status>;
};

/** aggregate fields of "enum_completion_status" */
export type Enum_Completion_Status_Aggregate_Fields = {
  __typename?: 'enum_completion_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Completion_Status_Max_Fields>;
  min?: Maybe<Enum_Completion_Status_Min_Fields>;
};


/** aggregate fields of "enum_completion_status" */
export type Enum_Completion_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Completion_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_completion_status". All fields are combined with a logical 'AND'. */
export type Enum_Completion_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Completion_Status_Bool_Exp>>;
  _not?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Completion_Status_Bool_Exp>>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_completion_status" */
export enum Enum_Completion_Status_Constraint {
  /** unique or primary key constraint on columns "text" */
  EnumCompletionStatusPkey = 'enum_completion_status_pkey'
}

export enum Enum_Completion_Status_Enum {
  Complete = 'complete',
  Missed = 'missed',
  MissedIncomplete = 'missed_incomplete',
  Pending = 'pending',
  PendingIncomplete = 'pending_incomplete'
}

/** Boolean expression to compare columns of type "enum_completion_status_enum". All fields are combined with logical 'AND'. */
export type Enum_Completion_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Completion_Status_Enum>;
  _in?: InputMaybe<Array<Enum_Completion_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Completion_Status_Enum>;
  _nin?: InputMaybe<Array<Enum_Completion_Status_Enum>>;
};

/** input type for inserting data into table "enum_completion_status" */
export type Enum_Completion_Status_Insert_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Completion_Status_Max_Fields = {
  __typename?: 'enum_completion_status_max_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Completion_Status_Min_Fields = {
  __typename?: 'enum_completion_status_min_fields';
  text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_completion_status" */
export type Enum_Completion_Status_Mutation_Response = {
  __typename?: 'enum_completion_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Completion_Status>;
};

/** on_conflict condition type for table "enum_completion_status" */
export type Enum_Completion_Status_On_Conflict = {
  constraint: Enum_Completion_Status_Constraint;
  update_columns?: Array<Enum_Completion_Status_Update_Column>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_completion_status". */
export type Enum_Completion_Status_Order_By = {
  text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_completion_status */
export type Enum_Completion_Status_Pk_Columns_Input = {
  text: Scalars['String']['input'];
};

/** select columns of table "enum_completion_status" */
export enum Enum_Completion_Status_Select_Column {
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "enum_completion_status" */
export type Enum_Completion_Status_Set_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_completion_status" */
export type Enum_Completion_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Completion_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Completion_Status_Stream_Cursor_Value_Input = {
  text?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_completion_status" */
export enum Enum_Completion_Status_Update_Column {
  /** column name */
  Text = 'text'
}

export type Enum_Completion_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Completion_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Completion_Status_Bool_Exp;
};

/** columns and relationships of "enum_feature_direction" */
export type Enum_Feature_Direction = {
  __typename?: 'enum_feature_direction';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_feature_direction" */
export type Enum_Feature_Direction_Aggregate = {
  __typename?: 'enum_feature_direction_aggregate';
  aggregate?: Maybe<Enum_Feature_Direction_Aggregate_Fields>;
  nodes: Array<Enum_Feature_Direction>;
};

/** aggregate fields of "enum_feature_direction" */
export type Enum_Feature_Direction_Aggregate_Fields = {
  __typename?: 'enum_feature_direction_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Feature_Direction_Max_Fields>;
  min?: Maybe<Enum_Feature_Direction_Min_Fields>;
};


/** aggregate fields of "enum_feature_direction" */
export type Enum_Feature_Direction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Feature_Direction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_feature_direction". All fields are combined with a logical 'AND'. */
export type Enum_Feature_Direction_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Feature_Direction_Bool_Exp>>;
  _not?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Feature_Direction_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_feature_direction" */
export enum Enum_Feature_Direction_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumFeatureDirectionPkey = 'enum_feature_direction_pkey'
}

export enum Enum_Feature_Direction_Enum {
  /** earlier in the day */
  Earlier = 'EARLIER',
  /** utilized by feature variance insights */
  High = 'HIGH',
  /** later in the day */
  Later = 'LATER',
  /** The user needs LESS of this feature */
  Less = 'LESS',
  /** utilized by feature variance insights */
  Low = 'LOW',
  /** The user needs MORE of this feature */
  More = 'MORE',
  /** utilized by generic insights */
  NotApplicable = 'not_applicable',
  /** utilized by generic insights */
  NotEnoughData = 'not_enough_data'
}

/** Boolean expression to compare columns of type "enum_feature_direction_enum". All fields are combined with logical 'AND'. */
export type Enum_Feature_Direction_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Feature_Direction_Enum>;
  _in?: InputMaybe<Array<Enum_Feature_Direction_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Feature_Direction_Enum>;
  _nin?: InputMaybe<Array<Enum_Feature_Direction_Enum>>;
};

/** input type for inserting data into table "enum_feature_direction" */
export type Enum_Feature_Direction_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Feature_Direction_Max_Fields = {
  __typename?: 'enum_feature_direction_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Feature_Direction_Min_Fields = {
  __typename?: 'enum_feature_direction_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_feature_direction" */
export type Enum_Feature_Direction_Mutation_Response = {
  __typename?: 'enum_feature_direction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Feature_Direction>;
};

/** input type for inserting object relation for remote table "enum_feature_direction" */
export type Enum_Feature_Direction_Obj_Rel_Insert_Input = {
  data: Enum_Feature_Direction_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enum_Feature_Direction_On_Conflict>;
};

/** on_conflict condition type for table "enum_feature_direction" */
export type Enum_Feature_Direction_On_Conflict = {
  constraint: Enum_Feature_Direction_Constraint;
  update_columns?: Array<Enum_Feature_Direction_Update_Column>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_feature_direction". */
export type Enum_Feature_Direction_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_feature_direction */
export type Enum_Feature_Direction_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_feature_direction" */
export enum Enum_Feature_Direction_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_feature_direction" */
export type Enum_Feature_Direction_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_feature_direction" */
export type Enum_Feature_Direction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Feature_Direction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Feature_Direction_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_feature_direction" */
export enum Enum_Feature_Direction_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Feature_Direction_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Feature_Direction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Feature_Direction_Bool_Exp;
};

/** columns and relationships of "enum_feature_type" */
export type Enum_Feature_Type = {
  __typename?: 'enum_feature_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  daily_features: Array<Daily_Features>;
  /** An aggregate relationship */
  daily_features_aggregate: Daily_Features_Aggregate;
  /** An array relationship */
  insight_resources: Array<Insight_Resources>;
  /** An aggregate relationship */
  insight_resources_aggregate: Insight_Resources_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "enum_feature_type" */
export type Enum_Feature_TypeDaily_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


/** columns and relationships of "enum_feature_type" */
export type Enum_Feature_TypeDaily_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


/** columns and relationships of "enum_feature_type" */
export type Enum_Feature_TypeInsight_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


/** columns and relationships of "enum_feature_type" */
export type Enum_Feature_TypeInsight_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};

/** aggregated selection of "enum_feature_type" */
export type Enum_Feature_Type_Aggregate = {
  __typename?: 'enum_feature_type_aggregate';
  aggregate?: Maybe<Enum_Feature_Type_Aggregate_Fields>;
  nodes: Array<Enum_Feature_Type>;
};

/** aggregate fields of "enum_feature_type" */
export type Enum_Feature_Type_Aggregate_Fields = {
  __typename?: 'enum_feature_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Feature_Type_Max_Fields>;
  min?: Maybe<Enum_Feature_Type_Min_Fields>;
};


/** aggregate fields of "enum_feature_type" */
export type Enum_Feature_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Feature_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_feature_type". All fields are combined with a logical 'AND'. */
export type Enum_Feature_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Feature_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Feature_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  daily_features?: InputMaybe<Daily_Features_Bool_Exp>;
  daily_features_aggregate?: InputMaybe<Daily_Features_Aggregate_Bool_Exp>;
  insight_resources?: InputMaybe<Insight_Resources_Bool_Exp>;
  insight_resources_aggregate?: InputMaybe<Insight_Resources_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_feature_type" */
export enum Enum_Feature_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumFeatureTypePkey = 'enum_feature_type_pkey'
}

export enum Enum_Feature_Type_Enum {
  AmtAutomotiveDayMin = 'amt_automotive_day_min',
  AmtExerciseDayMin = 'amt_exercise_day_min',
  AmtSleepDayMin = 'amt_sleep_day_min',
  AmtStationaryDayMin = 'amt_stationary_day_min',
  AmtWalkingDayMin = 'amt_walking_day_min',
  InvalidNotEnoughData = 'invalid_not_enough_data',
  NCharDay = 'n_char_day',
  NWordDay = 'n_word_day',
  /** utilized by generic insights */
  NotApplicable = 'not_applicable',
  PropGpsDayHome = 'prop_gps_day_home',
  PropWordAbsDay = 'prop_word_abs_day',
  PropWordIDay = 'prop_word_i_day',
  PropWordNegDay = 'prop_word_neg_day',
  PropWordPosDay = 'prop_word_pos_day',
  ValBedtimeOffsetHour = 'val_bedtime_offset_hour',
  ValEnjoyment = 'val_enjoyment',
  ValGrowth = 'val_growth',
  /** how morningish you are */
  ValMorningness = 'val_morningness',
  ValWaketimeOffsetHour = 'val_waketime_offset_hour'
}

/** Boolean expression to compare columns of type "enum_feature_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Feature_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Feature_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Feature_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Feature_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Feature_Type_Enum>>;
};

/** input type for inserting data into table "enum_feature_type" */
export type Enum_Feature_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  daily_features?: InputMaybe<Daily_Features_Arr_Rel_Insert_Input>;
  insight_resources?: InputMaybe<Insight_Resources_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Feature_Type_Max_Fields = {
  __typename?: 'enum_feature_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Feature_Type_Min_Fields = {
  __typename?: 'enum_feature_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_feature_type" */
export type Enum_Feature_Type_Mutation_Response = {
  __typename?: 'enum_feature_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Feature_Type>;
};

/** input type for inserting object relation for remote table "enum_feature_type" */
export type Enum_Feature_Type_Obj_Rel_Insert_Input = {
  data: Enum_Feature_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enum_Feature_Type_On_Conflict>;
};

/** on_conflict condition type for table "enum_feature_type" */
export type Enum_Feature_Type_On_Conflict = {
  constraint: Enum_Feature_Type_Constraint;
  update_columns?: Array<Enum_Feature_Type_Update_Column>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_feature_type". */
export type Enum_Feature_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  daily_features_aggregate?: InputMaybe<Daily_Features_Aggregate_Order_By>;
  insight_resources_aggregate?: InputMaybe<Insight_Resources_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_feature_type */
export type Enum_Feature_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_feature_type" */
export enum Enum_Feature_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_feature_type" */
export type Enum_Feature_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_feature_type" */
export type Enum_Feature_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Feature_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Feature_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_feature_type" */
export enum Enum_Feature_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Feature_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Feature_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Feature_Type_Bool_Exp;
};

/** columns and relationships of "enum_gender" */
export type Enum_Gender = {
  __typename?: 'enum_gender';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_gender" */
export type Enum_Gender_Aggregate = {
  __typename?: 'enum_gender_aggregate';
  aggregate?: Maybe<Enum_Gender_Aggregate_Fields>;
  nodes: Array<Enum_Gender>;
};

/** aggregate fields of "enum_gender" */
export type Enum_Gender_Aggregate_Fields = {
  __typename?: 'enum_gender_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Gender_Max_Fields>;
  min?: Maybe<Enum_Gender_Min_Fields>;
};


/** aggregate fields of "enum_gender" */
export type Enum_Gender_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Gender_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_gender". All fields are combined with a logical 'AND'. */
export type Enum_Gender_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Gender_Bool_Exp>>;
  _not?: InputMaybe<Enum_Gender_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Gender_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_gender" */
export enum Enum_Gender_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumGenderPkey = 'enum_gender_pkey'
}

export enum Enum_Gender_Enum {
  /** Female */
  Female = 'female',
  /** Male */
  Male = 'male',
  /** Not Specified */
  NotSpecified = 'not_specified',
  /** Queer/Non-conforming */
  QueerNonConforming = 'queer_non_conforming',
  /** Trans-Man */
  TransMan = 'trans_man',
  /** Trans-Woman */
  TransWoman = 'trans_woman'
}

/** Boolean expression to compare columns of type "enum_gender_enum". All fields are combined with logical 'AND'. */
export type Enum_Gender_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Gender_Enum>;
  _in?: InputMaybe<Array<Enum_Gender_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Gender_Enum>;
  _nin?: InputMaybe<Array<Enum_Gender_Enum>>;
};

/** input type for inserting data into table "enum_gender" */
export type Enum_Gender_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Gender_Max_Fields = {
  __typename?: 'enum_gender_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Gender_Min_Fields = {
  __typename?: 'enum_gender_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_gender" */
export type Enum_Gender_Mutation_Response = {
  __typename?: 'enum_gender_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Gender>;
};

/** on_conflict condition type for table "enum_gender" */
export type Enum_Gender_On_Conflict = {
  constraint: Enum_Gender_Constraint;
  update_columns?: Array<Enum_Gender_Update_Column>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_gender". */
export type Enum_Gender_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_gender */
export type Enum_Gender_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_gender" */
export enum Enum_Gender_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_gender" */
export type Enum_Gender_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_gender" */
export type Enum_Gender_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Gender_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Gender_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_gender" */
export enum Enum_Gender_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Gender_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Gender_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Gender_Bool_Exp;
};

/** columns and relationships of "enum_insight_content_type" */
export type Enum_Insight_Content_Type = {
  __typename?: 'enum_insight_content_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Aggregate = {
  __typename?: 'enum_insight_content_type_aggregate';
  aggregate?: Maybe<Enum_Insight_Content_Type_Aggregate_Fields>;
  nodes: Array<Enum_Insight_Content_Type>;
};

/** aggregate fields of "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Aggregate_Fields = {
  __typename?: 'enum_insight_content_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Insight_Content_Type_Max_Fields>;
  min?: Maybe<Enum_Insight_Content_Type_Min_Fields>;
};


/** aggregate fields of "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Insight_Content_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_insight_content_type". All fields are combined with a logical 'AND'. */
export type Enum_Insight_Content_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Insight_Content_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Insight_Content_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_insight_content_type" */
export enum Enum_Insight_Content_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumInsightContentTypePkey = 'enum_insight_content_type_pkey'
}

export enum Enum_Insight_Content_Type_Enum {
  Html = 'html',
  Link = 'link',
  Text = 'text'
}

/** Boolean expression to compare columns of type "enum_insight_content_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Insight_Content_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Insight_Content_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Insight_Content_Type_Enum>>;
};

/** input type for inserting data into table "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Insight_Content_Type_Max_Fields = {
  __typename?: 'enum_insight_content_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Insight_Content_Type_Min_Fields = {
  __typename?: 'enum_insight_content_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Mutation_Response = {
  __typename?: 'enum_insight_content_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Insight_Content_Type>;
};

/** on_conflict condition type for table "enum_insight_content_type" */
export type Enum_Insight_Content_Type_On_Conflict = {
  constraint: Enum_Insight_Content_Type_Constraint;
  update_columns?: Array<Enum_Insight_Content_Type_Update_Column>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_insight_content_type". */
export type Enum_Insight_Content_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_insight_content_type */
export type Enum_Insight_Content_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_insight_content_type" */
export enum Enum_Insight_Content_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_insight_content_type" */
export type Enum_Insight_Content_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Insight_Content_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Insight_Content_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_insight_content_type" */
export enum Enum_Insight_Content_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Enum_Insight_Content_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Insight_Content_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Insight_Content_Type_Bool_Exp;
};

/** columns and relationships of "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status = {
  __typename?: 'enum_mobile_permission_status';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Aggregate = {
  __typename?: 'enum_mobile_permission_status_aggregate';
  aggregate?: Maybe<Enum_Mobile_Permission_Status_Aggregate_Fields>;
  nodes: Array<Enum_Mobile_Permission_Status>;
};

/** aggregate fields of "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Aggregate_Fields = {
  __typename?: 'enum_mobile_permission_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Mobile_Permission_Status_Max_Fields>;
  min?: Maybe<Enum_Mobile_Permission_Status_Min_Fields>;
};


/** aggregate fields of "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Mobile_Permission_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_mobile_permission_status". All fields are combined with a logical 'AND'. */
export type Enum_Mobile_Permission_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Mobile_Permission_Status_Bool_Exp>>;
  _not?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Mobile_Permission_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_mobile_permission_status" */
export enum Enum_Mobile_Permission_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumMobilePermissionStatusPkey = 'enum_mobile_permission_status_pkey'
}

export enum Enum_Mobile_Permission_Status_Enum {
  /** Permission status is always */
  Always = 'always',
  /** Permission has been denied */
  Denied = 'denied',
  /** Permission has been granted */
  Granted = 'granted',
  /** Permission status is undetermined */
  Undetermined = 'undetermined',
  /** Permission status is whileInUse */
  WhileInUse = 'whileInUse'
}

/** Boolean expression to compare columns of type "enum_mobile_permission_status_enum". All fields are combined with logical 'AND'. */
export type Enum_Mobile_Permission_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Mobile_Permission_Status_Enum>;
  _in?: InputMaybe<Array<Enum_Mobile_Permission_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Mobile_Permission_Status_Enum>;
  _nin?: InputMaybe<Array<Enum_Mobile_Permission_Status_Enum>>;
};

/** input type for inserting data into table "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Mobile_Permission_Status_Max_Fields = {
  __typename?: 'enum_mobile_permission_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Mobile_Permission_Status_Min_Fields = {
  __typename?: 'enum_mobile_permission_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Mutation_Response = {
  __typename?: 'enum_mobile_permission_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Mobile_Permission_Status>;
};

/** on_conflict condition type for table "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_On_Conflict = {
  constraint: Enum_Mobile_Permission_Status_Constraint;
  update_columns?: Array<Enum_Mobile_Permission_Status_Update_Column>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_mobile_permission_status". */
export type Enum_Mobile_Permission_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_mobile_permission_status */
export type Enum_Mobile_Permission_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_mobile_permission_status" */
export enum Enum_Mobile_Permission_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_mobile_permission_status" */
export type Enum_Mobile_Permission_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Mobile_Permission_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Mobile_Permission_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_mobile_permission_status" */
export enum Enum_Mobile_Permission_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Mobile_Permission_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Mobile_Permission_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Mobile_Permission_Status_Bool_Exp;
};

/** columns and relationships of "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type = {
  __typename?: 'enum_mobile_permission_type';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Aggregate = {
  __typename?: 'enum_mobile_permission_type_aggregate';
  aggregate?: Maybe<Enum_Mobile_Permission_Type_Aggregate_Fields>;
  nodes: Array<Enum_Mobile_Permission_Type>;
};

/** aggregate fields of "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Aggregate_Fields = {
  __typename?: 'enum_mobile_permission_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Mobile_Permission_Type_Max_Fields>;
  min?: Maybe<Enum_Mobile_Permission_Type_Min_Fields>;
};


/** aggregate fields of "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Mobile_Permission_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_mobile_permission_type". All fields are combined with a logical 'AND'. */
export type Enum_Mobile_Permission_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Mobile_Permission_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Mobile_Permission_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_mobile_permission_type" */
export enum Enum_Mobile_Permission_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumMobilePermissionTypePkey = 'enum_mobile_permission_type_pkey'
}

export enum Enum_Mobile_Permission_Type_Enum {
  /** Permission to access GPS location */
  Gps = 'gps',
  /** Permission to access keyboard */
  Keyboard = 'keyboard',
  /** Permission to access motion sensors */
  Motion = 'motion',
  /** Permission to send notifications */
  Notification = 'notification'
}

/** Boolean expression to compare columns of type "enum_mobile_permission_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Mobile_Permission_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Mobile_Permission_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Mobile_Permission_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Mobile_Permission_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Mobile_Permission_Type_Enum>>;
};

/** input type for inserting data into table "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Mobile_Permission_Type_Max_Fields = {
  __typename?: 'enum_mobile_permission_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Mobile_Permission_Type_Min_Fields = {
  __typename?: 'enum_mobile_permission_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Mutation_Response = {
  __typename?: 'enum_mobile_permission_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Mobile_Permission_Type>;
};

/** on_conflict condition type for table "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_On_Conflict = {
  constraint: Enum_Mobile_Permission_Type_Constraint;
  update_columns?: Array<Enum_Mobile_Permission_Type_Update_Column>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_mobile_permission_type". */
export type Enum_Mobile_Permission_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_mobile_permission_type */
export type Enum_Mobile_Permission_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_mobile_permission_type" */
export enum Enum_Mobile_Permission_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_mobile_permission_type" */
export type Enum_Mobile_Permission_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Mobile_Permission_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Mobile_Permission_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_mobile_permission_type" */
export enum Enum_Mobile_Permission_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Mobile_Permission_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Mobile_Permission_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Mobile_Permission_Type_Bool_Exp;
};

/** columns and relationships of "enum_outcome" */
export type Enum_Outcome = {
  __typename?: 'enum_outcome';
  comment: Scalars['String']['output'];
  /** An array relationship */
  feature_reports: Array<Feature_Reports>;
  /** An aggregate relationship */
  feature_reports_aggregate: Feature_Reports_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "enum_outcome" */
export type Enum_OutcomeFeature_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


/** columns and relationships of "enum_outcome" */
export type Enum_OutcomeFeature_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};

/** aggregated selection of "enum_outcome" */
export type Enum_Outcome_Aggregate = {
  __typename?: 'enum_outcome_aggregate';
  aggregate?: Maybe<Enum_Outcome_Aggregate_Fields>;
  nodes: Array<Enum_Outcome>;
};

/** aggregate fields of "enum_outcome" */
export type Enum_Outcome_Aggregate_Fields = {
  __typename?: 'enum_outcome_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Outcome_Max_Fields>;
  min?: Maybe<Enum_Outcome_Min_Fields>;
};


/** aggregate fields of "enum_outcome" */
export type Enum_Outcome_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Outcome_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_outcome". All fields are combined with a logical 'AND'. */
export type Enum_Outcome_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Outcome_Bool_Exp>>;
  _not?: InputMaybe<Enum_Outcome_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Outcome_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  feature_reports?: InputMaybe<Feature_Reports_Bool_Exp>;
  feature_reports_aggregate?: InputMaybe<Feature_Reports_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_outcome" */
export enum Enum_Outcome_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumOutcomePkey = 'enum_outcome_pkey'
}

export enum Enum_Outcome_Enum {
  /** Indicates enjoyment */
  Enjoyment = 'ENJOYMENT',
  /** Indicates growth */
  Growth = 'GROWTH',
  /** Generic insight to be displayed */
  InstructionOnboarding = 'instruction_onboarding',
  /** Utilized by feature variance insights */
  NotApplicable = 'not_applicable'
}

/** Boolean expression to compare columns of type "enum_outcome_enum". All fields are combined with logical 'AND'. */
export type Enum_Outcome_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Outcome_Enum>;
  _in?: InputMaybe<Array<Enum_Outcome_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Outcome_Enum>;
  _nin?: InputMaybe<Array<Enum_Outcome_Enum>>;
};

/** input type for inserting data into table "enum_outcome" */
export type Enum_Outcome_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  feature_reports?: InputMaybe<Feature_Reports_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Outcome_Max_Fields = {
  __typename?: 'enum_outcome_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Outcome_Min_Fields = {
  __typename?: 'enum_outcome_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_outcome" */
export type Enum_Outcome_Mutation_Response = {
  __typename?: 'enum_outcome_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Outcome>;
};

/** input type for inserting object relation for remote table "enum_outcome" */
export type Enum_Outcome_Obj_Rel_Insert_Input = {
  data: Enum_Outcome_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enum_Outcome_On_Conflict>;
};

/** on_conflict condition type for table "enum_outcome" */
export type Enum_Outcome_On_Conflict = {
  constraint: Enum_Outcome_Constraint;
  update_columns?: Array<Enum_Outcome_Update_Column>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_outcome". */
export type Enum_Outcome_Order_By = {
  comment?: InputMaybe<Order_By>;
  feature_reports_aggregate?: InputMaybe<Feature_Reports_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_outcome */
export type Enum_Outcome_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_outcome" */
export enum Enum_Outcome_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_outcome" */
export type Enum_Outcome_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_outcome" */
export type Enum_Outcome_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Outcome_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Outcome_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_outcome" */
export enum Enum_Outcome_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Outcome_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Outcome_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Outcome_Bool_Exp;
};

/** columns and relationships of "enum_question_type" */
export type Enum_Question_Type = {
  __typename?: 'enum_question_type';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_question_type" */
export type Enum_Question_Type_Aggregate = {
  __typename?: 'enum_question_type_aggregate';
  aggregate?: Maybe<Enum_Question_Type_Aggregate_Fields>;
  nodes: Array<Enum_Question_Type>;
};

/** aggregate fields of "enum_question_type" */
export type Enum_Question_Type_Aggregate_Fields = {
  __typename?: 'enum_question_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Question_Type_Max_Fields>;
  min?: Maybe<Enum_Question_Type_Min_Fields>;
};


/** aggregate fields of "enum_question_type" */
export type Enum_Question_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Question_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_question_type". All fields are combined with a logical 'AND'. */
export type Enum_Question_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Question_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Question_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Question_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_question_type" */
export enum Enum_Question_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumQuestionTypePkey = 'enum_question_type_pkey'
}

export enum Enum_Question_Type_Enum {
  /** Boolean (yes/no) */
  Boolean = 'boolean',
  /** Question type for assessing user goals with ability to amend previous answers */
  Goal = 'goal',
  /** Free-text note */
  Note = 'note',
  /** Numeric input */
  Number = 'number',
  /** Scaled response (e.g., 1-5) */
  Scale = 'scale',
  /** Single-choice selection */
  Select = 'select',
  /** Multi-choice selection */
  Switchboard = 'switchboard',
  /** Time input (HH:MM) */
  Time = 'time'
}

/** Boolean expression to compare columns of type "enum_question_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Question_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Question_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Question_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Question_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Question_Type_Enum>>;
};

/** input type for inserting data into table "enum_question_type" */
export type Enum_Question_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Question_Type_Max_Fields = {
  __typename?: 'enum_question_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Question_Type_Min_Fields = {
  __typename?: 'enum_question_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_question_type" */
export type Enum_Question_Type_Mutation_Response = {
  __typename?: 'enum_question_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Question_Type>;
};

/** on_conflict condition type for table "enum_question_type" */
export type Enum_Question_Type_On_Conflict = {
  constraint: Enum_Question_Type_Constraint;
  update_columns?: Array<Enum_Question_Type_Update_Column>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_question_type". */
export type Enum_Question_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_question_type */
export type Enum_Question_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_question_type" */
export enum Enum_Question_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_question_type" */
export type Enum_Question_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_question_type" */
export type Enum_Question_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Question_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Question_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_question_type" */
export enum Enum_Question_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Question_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Question_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Question_Type_Bool_Exp;
};

/** columns and relationships of "enum_racial_ethnic" */
export type Enum_Racial_Ethnic = {
  __typename?: 'enum_racial_ethnic';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Aggregate = {
  __typename?: 'enum_racial_ethnic_aggregate';
  aggregate?: Maybe<Enum_Racial_Ethnic_Aggregate_Fields>;
  nodes: Array<Enum_Racial_Ethnic>;
};

/** aggregate fields of "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Aggregate_Fields = {
  __typename?: 'enum_racial_ethnic_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Racial_Ethnic_Max_Fields>;
  min?: Maybe<Enum_Racial_Ethnic_Min_Fields>;
};


/** aggregate fields of "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Racial_Ethnic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_racial_ethnic". All fields are combined with a logical 'AND'. */
export type Enum_Racial_Ethnic_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Racial_Ethnic_Bool_Exp>>;
  _not?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Racial_Ethnic_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_racial_ethnic" */
export enum Enum_Racial_Ethnic_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumRacialEthnicPkey = 'enum_racial_ethnic_pkey'
}

export enum Enum_Racial_Ethnic_Enum {
  /** Asian */
  Asian = 'asian',
  /** Black */
  Black = 'black',
  /** Hispanic/Latino */
  HispanicLatino = 'hispanic_latino',
  /** Multi-Racial */
  MultiRacial = 'multi_racial',
  /** Native American/Alaskan Native */
  NativeAmericanAlaskanNative = 'native_american_alaskan_native',
  /** Native Hawaiian/Pacific Islander */
  NativeHawaiianPacificIslander = 'native_hawaiian_pacific_islander',
  /** Not Specified */
  NotSpecified = 'not_specified',
  /** Other */
  Other = 'other',
  /** Caucasian/White */
  White = 'white'
}

/** Boolean expression to compare columns of type "enum_racial_ethnic_enum". All fields are combined with logical 'AND'. */
export type Enum_Racial_Ethnic_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  _in?: InputMaybe<Array<Enum_Racial_Ethnic_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  _nin?: InputMaybe<Array<Enum_Racial_Ethnic_Enum>>;
};

/** input type for inserting data into table "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Racial_Ethnic_Max_Fields = {
  __typename?: 'enum_racial_ethnic_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Racial_Ethnic_Min_Fields = {
  __typename?: 'enum_racial_ethnic_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Mutation_Response = {
  __typename?: 'enum_racial_ethnic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Racial_Ethnic>;
};

/** on_conflict condition type for table "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_On_Conflict = {
  constraint: Enum_Racial_Ethnic_Constraint;
  update_columns?: Array<Enum_Racial_Ethnic_Update_Column>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_racial_ethnic". */
export type Enum_Racial_Ethnic_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_racial_ethnic */
export type Enum_Racial_Ethnic_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_racial_ethnic" */
export enum Enum_Racial_Ethnic_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_racial_ethnic" */
export type Enum_Racial_Ethnic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Racial_Ethnic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Racial_Ethnic_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_racial_ethnic" */
export enum Enum_Racial_Ethnic_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Racial_Ethnic_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Racial_Ethnic_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Racial_Ethnic_Bool_Exp;
};

/** columns and relationships of "enum_resource_type" */
export type Enum_Resource_Type = {
  __typename?: 'enum_resource_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_resource_type" */
export type Enum_Resource_Type_Aggregate = {
  __typename?: 'enum_resource_type_aggregate';
  aggregate?: Maybe<Enum_Resource_Type_Aggregate_Fields>;
  nodes: Array<Enum_Resource_Type>;
};

/** aggregate fields of "enum_resource_type" */
export type Enum_Resource_Type_Aggregate_Fields = {
  __typename?: 'enum_resource_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Resource_Type_Max_Fields>;
  min?: Maybe<Enum_Resource_Type_Min_Fields>;
};


/** aggregate fields of "enum_resource_type" */
export type Enum_Resource_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Resource_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_resource_type". All fields are combined with a logical 'AND'. */
export type Enum_Resource_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Resource_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Resource_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_resource_type" */
export enum Enum_Resource_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumResourceTypePkey = 'enum_resource_type_pkey'
}

/** input type for inserting data into table "enum_resource_type" */
export type Enum_Resource_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Resource_Type_Max_Fields = {
  __typename?: 'enum_resource_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Resource_Type_Min_Fields = {
  __typename?: 'enum_resource_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_resource_type" */
export type Enum_Resource_Type_Mutation_Response = {
  __typename?: 'enum_resource_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Resource_Type>;
};

/** on_conflict condition type for table "enum_resource_type" */
export type Enum_Resource_Type_On_Conflict = {
  constraint: Enum_Resource_Type_Constraint;
  update_columns?: Array<Enum_Resource_Type_Update_Column>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_resource_type". */
export type Enum_Resource_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_resource_type */
export type Enum_Resource_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_resource_type" */
export enum Enum_Resource_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_resource_type" */
export type Enum_Resource_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_resource_type" */
export type Enum_Resource_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Resource_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Resource_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_resource_type" */
export enum Enum_Resource_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Enum_Resource_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Resource_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Resource_Type_Bool_Exp;
};

/** columns and relationships of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type = {
  __typename?: 'enum_safety_plan_section_category_type';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  safety_plan_section_category: Array<Safety_Plan_Section_Category>;
  /** An aggregate relationship */
  safety_plan_section_category_aggregate: Safety_Plan_Section_Category_Aggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_TypeSafety_Plan_Section_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


/** columns and relationships of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_TypeSafety_Plan_Section_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};

/** aggregated selection of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Aggregate = {
  __typename?: 'enum_safety_plan_section_category_type_aggregate';
  aggregate?: Maybe<Enum_Safety_Plan_Section_Category_Type_Aggregate_Fields>;
  nodes: Array<Enum_Safety_Plan_Section_Category_Type>;
};

/** aggregate fields of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Aggregate_Fields = {
  __typename?: 'enum_safety_plan_section_category_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Safety_Plan_Section_Category_Type_Max_Fields>;
  min?: Maybe<Enum_Safety_Plan_Section_Category_Type_Min_Fields>;
};


/** aggregate fields of "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_safety_plan_section_category_type". All fields are combined with a logical 'AND'. */
export type Enum_Safety_Plan_Section_Category_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
  safety_plan_section_category_aggregate?: InputMaybe<Safety_Plan_Section_Category_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_safety_plan_section_category_type" */
export enum Enum_Safety_Plan_Section_Category_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumSafetyPlanSectionCategoryTypePkey = 'enum_safety_plan_section_category_type_pkey'
}

export enum Enum_Safety_Plan_Section_Category_Type_Enum {
  Checklist = 'checklist',
  Contact = 'contact',
  CustomSelectAll = 'custom_select_all',
  Place = 'place',
  Radio = 'radio',
  Reasons = 'reasons',
  RiskyPlace = 'risky_place',
  SafePlace = 'safe_place',
  SelectAll = 'select_all',
  TextArea = 'text_area',
  TextBox = 'text_box'
}

/** Boolean expression to compare columns of type "enum_safety_plan_section_category_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Safety_Plan_Section_Category_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Enum>>;
};

/** input type for inserting data into table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Safety_Plan_Section_Category_Type_Max_Fields = {
  __typename?: 'enum_safety_plan_section_category_type_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Safety_Plan_Section_Category_Type_Min_Fields = {
  __typename?: 'enum_safety_plan_section_category_type_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Mutation_Response = {
  __typename?: 'enum_safety_plan_section_category_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Safety_Plan_Section_Category_Type>;
};

/** input type for inserting object relation for remote table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Obj_Rel_Insert_Input = {
  data: Enum_Safety_Plan_Section_Category_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_On_Conflict>;
};

/** on_conflict condition type for table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_On_Conflict = {
  constraint: Enum_Safety_Plan_Section_Category_Type_Constraint;
  update_columns?: Array<Enum_Safety_Plan_Section_Category_Type_Update_Column>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_safety_plan_section_category_type". */
export type Enum_Safety_Plan_Section_Category_Type_Order_By = {
  comment?: InputMaybe<Order_By>;
  safety_plan_section_category_aggregate?: InputMaybe<Safety_Plan_Section_Category_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_safety_plan_section_category_type */
export type Enum_Safety_Plan_Section_Category_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_safety_plan_section_category_type" */
export enum Enum_Safety_Plan_Section_Category_Type_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_safety_plan_section_category_type" */
export type Enum_Safety_Plan_Section_Category_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Safety_Plan_Section_Category_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Safety_Plan_Section_Category_Type_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_safety_plan_section_category_type" */
export enum Enum_Safety_Plan_Section_Category_Type_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Safety_Plan_Section_Category_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Safety_Plan_Section_Category_Type_Bool_Exp;
};

/** columns and relationships of "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons = {
  __typename?: 'enum_safety_plan_section_icons';
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Aggregate = {
  __typename?: 'enum_safety_plan_section_icons_aggregate';
  aggregate?: Maybe<Enum_Safety_Plan_Section_Icons_Aggregate_Fields>;
  nodes: Array<Enum_Safety_Plan_Section_Icons>;
};

/** aggregate fields of "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Aggregate_Fields = {
  __typename?: 'enum_safety_plan_section_icons_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Safety_Plan_Section_Icons_Max_Fields>;
  min?: Maybe<Enum_Safety_Plan_Section_Icons_Min_Fields>;
};


/** aggregate fields of "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_safety_plan_section_icons". All fields are combined with a logical 'AND'. */
export type Enum_Safety_Plan_Section_Icons_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Bool_Exp>>;
  _not?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_safety_plan_section_icons" */
export enum Enum_Safety_Plan_Section_Icons_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumSafetyPlanSectionIconsPkey = 'enum_safety_plan_section_icons_pkey'
}

export enum Enum_Safety_Plan_Section_Icons_Enum {
  Bell = 'bell',
  LocationArrow = 'location_arrow',
  LocationDot = 'location_dot',
  MugSaucer = 'mug_saucer',
  Paw = 'paw',
  Shield = 'shield',
  Stethoscope = 'stethoscope',
  Tracks = 'tracks',
  TriangleExclamation = 'triangle_exclamation',
  UserGroup = 'user_group'
}

/** Boolean expression to compare columns of type "enum_safety_plan_section_icons_enum". All fields are combined with logical 'AND'. */
export type Enum_Safety_Plan_Section_Icons_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum>;
  _in?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum>;
  _nin?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Enum>>;
};

/** input type for inserting data into table "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Safety_Plan_Section_Icons_Max_Fields = {
  __typename?: 'enum_safety_plan_section_icons_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Safety_Plan_Section_Icons_Min_Fields = {
  __typename?: 'enum_safety_plan_section_icons_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Mutation_Response = {
  __typename?: 'enum_safety_plan_section_icons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Safety_Plan_Section_Icons>;
};

/** on_conflict condition type for table "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_On_Conflict = {
  constraint: Enum_Safety_Plan_Section_Icons_Constraint;
  update_columns?: Array<Enum_Safety_Plan_Section_Icons_Update_Column>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_safety_plan_section_icons". */
export type Enum_Safety_Plan_Section_Icons_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_safety_plan_section_icons */
export type Enum_Safety_Plan_Section_Icons_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_safety_plan_section_icons" */
export enum Enum_Safety_Plan_Section_Icons_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_safety_plan_section_icons" */
export type Enum_Safety_Plan_Section_Icons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Safety_Plan_Section_Icons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Safety_Plan_Section_Icons_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_safety_plan_section_icons" */
export enum Enum_Safety_Plan_Section_Icons_Update_Column {
  /** column name */
  Value = 'value'
}

export type Enum_Safety_Plan_Section_Icons_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Safety_Plan_Section_Icons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Safety_Plan_Section_Icons_Bool_Exp;
};

/** columns and relationships of "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status = {
  __typename?: 'enum_safety_plan_status';
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Aggregate = {
  __typename?: 'enum_safety_plan_status_aggregate';
  aggregate?: Maybe<Enum_Safety_Plan_Status_Aggregate_Fields>;
  nodes: Array<Enum_Safety_Plan_Status>;
};

/** aggregate fields of "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Aggregate_Fields = {
  __typename?: 'enum_safety_plan_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Safety_Plan_Status_Max_Fields>;
  min?: Maybe<Enum_Safety_Plan_Status_Min_Fields>;
};


/** aggregate fields of "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Safety_Plan_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_safety_plan_status". All fields are combined with a logical 'AND'. */
export type Enum_Safety_Plan_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Safety_Plan_Status_Bool_Exp>>;
  _not?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Safety_Plan_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_safety_plan_status" */
export enum Enum_Safety_Plan_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumSafetyPlanStatusPkey = 'enum_safety_plan_status_pkey'
}

export enum Enum_Safety_Plan_Status_Enum {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "enum_safety_plan_status_enum". All fields are combined with logical 'AND'. */
export type Enum_Safety_Plan_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Safety_Plan_Status_Enum>;
  _in?: InputMaybe<Array<Enum_Safety_Plan_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Safety_Plan_Status_Enum>;
  _nin?: InputMaybe<Array<Enum_Safety_Plan_Status_Enum>>;
};

/** input type for inserting data into table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Safety_Plan_Status_Max_Fields = {
  __typename?: 'enum_safety_plan_status_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Safety_Plan_Status_Min_Fields = {
  __typename?: 'enum_safety_plan_status_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Mutation_Response = {
  __typename?: 'enum_safety_plan_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Safety_Plan_Status>;
};

/** input type for inserting object relation for remote table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Obj_Rel_Insert_Input = {
  data: Enum_Safety_Plan_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enum_Safety_Plan_Status_On_Conflict>;
};

/** on_conflict condition type for table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_On_Conflict = {
  constraint: Enum_Safety_Plan_Status_Constraint;
  update_columns?: Array<Enum_Safety_Plan_Status_Update_Column>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_safety_plan_status". */
export type Enum_Safety_Plan_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_safety_plan_status */
export type Enum_Safety_Plan_Status_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_safety_plan_status" */
export enum Enum_Safety_Plan_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_safety_plan_status" */
export type Enum_Safety_Plan_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Safety_Plan_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Safety_Plan_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_safety_plan_status" */
export enum Enum_Safety_Plan_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Safety_Plan_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Safety_Plan_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Safety_Plan_Status_Bool_Exp;
};

/** columns and relationships of "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type = {
  __typename?: 'enum_safety_plan_type';
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Aggregate = {
  __typename?: 'enum_safety_plan_type_aggregate';
  aggregate?: Maybe<Enum_Safety_Plan_Type_Aggregate_Fields>;
  nodes: Array<Enum_Safety_Plan_Type>;
};

/** aggregate fields of "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Aggregate_Fields = {
  __typename?: 'enum_safety_plan_type_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Safety_Plan_Type_Max_Fields>;
  min?: Maybe<Enum_Safety_Plan_Type_Min_Fields>;
};


/** aggregate fields of "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Safety_Plan_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_safety_plan_type". All fields are combined with a logical 'AND'. */
export type Enum_Safety_Plan_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Safety_Plan_Type_Bool_Exp>>;
  _not?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Safety_Plan_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_safety_plan_type" */
export enum Enum_Safety_Plan_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumSafetyPlanTypePkey = 'enum_safety_plan_type_pkey'
}

export enum Enum_Safety_Plan_Type_Enum {
  RelapsePrevention = 'relapse_prevention',
  Safety = 'safety'
}

/** Boolean expression to compare columns of type "enum_safety_plan_type_enum". All fields are combined with logical 'AND'. */
export type Enum_Safety_Plan_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Safety_Plan_Type_Enum>;
  _in?: InputMaybe<Array<Enum_Safety_Plan_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Safety_Plan_Type_Enum>;
  _nin?: InputMaybe<Array<Enum_Safety_Plan_Type_Enum>>;
};

/** input type for inserting data into table "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Insert_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Safety_Plan_Type_Max_Fields = {
  __typename?: 'enum_safety_plan_type_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Safety_Plan_Type_Min_Fields = {
  __typename?: 'enum_safety_plan_type_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Mutation_Response = {
  __typename?: 'enum_safety_plan_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Safety_Plan_Type>;
};

/** on_conflict condition type for table "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_On_Conflict = {
  constraint: Enum_Safety_Plan_Type_Constraint;
  update_columns?: Array<Enum_Safety_Plan_Type_Update_Column>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_safety_plan_type". */
export type Enum_Safety_Plan_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_safety_plan_type */
export type Enum_Safety_Plan_Type_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_safety_plan_type" */
export enum Enum_Safety_Plan_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_safety_plan_type" */
export type Enum_Safety_Plan_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Safety_Plan_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Safety_Plan_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_safety_plan_type" */
export enum Enum_Safety_Plan_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Enum_Safety_Plan_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Safety_Plan_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Safety_Plan_Type_Bool_Exp;
};

/** columns and relationships of "enum_trend_direction" */
export type Enum_Trend_Direction = {
  __typename?: 'enum_trend_direction';
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "enum_trend_direction" */
export type Enum_Trend_Direction_Aggregate = {
  __typename?: 'enum_trend_direction_aggregate';
  aggregate?: Maybe<Enum_Trend_Direction_Aggregate_Fields>;
  nodes: Array<Enum_Trend_Direction>;
};

/** aggregate fields of "enum_trend_direction" */
export type Enum_Trend_Direction_Aggregate_Fields = {
  __typename?: 'enum_trend_direction_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Enum_Trend_Direction_Max_Fields>;
  min?: Maybe<Enum_Trend_Direction_Min_Fields>;
};


/** aggregate fields of "enum_trend_direction" */
export type Enum_Trend_Direction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Trend_Direction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "enum_trend_direction". All fields are combined with a logical 'AND'. */
export type Enum_Trend_Direction_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Trend_Direction_Bool_Exp>>;
  _not?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Trend_Direction_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_trend_direction" */
export enum Enum_Trend_Direction_Constraint {
  /** unique or primary key constraint on columns "value" */
  EnumTrendDirectionPkey = 'enum_trend_direction_pkey'
}

export enum Enum_Trend_Direction_Enum {
  /** trending down */
  Down = 'DOWN',
  /** trending hasnt changed */
  NoChange = 'NO_CHANGE',
  /** trending up */
  Up = 'UP'
}

/** Boolean expression to compare columns of type "enum_trend_direction_enum". All fields are combined with logical 'AND'. */
export type Enum_Trend_Direction_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Trend_Direction_Enum>;
  _in?: InputMaybe<Array<Enum_Trend_Direction_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enum_Trend_Direction_Enum>;
  _nin?: InputMaybe<Array<Enum_Trend_Direction_Enum>>;
};

/** input type for inserting data into table "enum_trend_direction" */
export type Enum_Trend_Direction_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Enum_Trend_Direction_Max_Fields = {
  __typename?: 'enum_trend_direction_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Enum_Trend_Direction_Min_Fields = {
  __typename?: 'enum_trend_direction_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "enum_trend_direction" */
export type Enum_Trend_Direction_Mutation_Response = {
  __typename?: 'enum_trend_direction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Trend_Direction>;
};

/** on_conflict condition type for table "enum_trend_direction" */
export type Enum_Trend_Direction_On_Conflict = {
  constraint: Enum_Trend_Direction_Constraint;
  update_columns?: Array<Enum_Trend_Direction_Update_Column>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_trend_direction". */
export type Enum_Trend_Direction_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_trend_direction */
export type Enum_Trend_Direction_Pk_Columns_Input = {
  value: Scalars['String']['input'];
};

/** select columns of table "enum_trend_direction" */
export enum Enum_Trend_Direction_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "enum_trend_direction" */
export type Enum_Trend_Direction_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enum_trend_direction" */
export type Enum_Trend_Direction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enum_Trend_Direction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enum_Trend_Direction_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "enum_trend_direction" */
export enum Enum_Trend_Direction_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Enum_Trend_Direction_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enum_Trend_Direction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enum_Trend_Direction_Bool_Exp;
};

/** columns and relationships of "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients = {
  __typename?: 'feature_report_feature_coefficients';
  /** An object relationship */
  feature_report: Feature_Reports;
  feature_report_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Enum_Feature_Type_Enum;
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Aggregate = {
  __typename?: 'feature_report_feature_coefficients_aggregate';
  aggregate?: Maybe<Feature_Report_Feature_Coefficients_Aggregate_Fields>;
  nodes: Array<Feature_Report_Feature_Coefficients>;
};

/** aggregate fields of "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Aggregate_Fields = {
  __typename?: 'feature_report_feature_coefficients_aggregate_fields';
  avg?: Maybe<Feature_Report_Feature_Coefficients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Report_Feature_Coefficients_Max_Fields>;
  min?: Maybe<Feature_Report_Feature_Coefficients_Min_Fields>;
  stddev?: Maybe<Feature_Report_Feature_Coefficients_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Report_Feature_Coefficients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Report_Feature_Coefficients_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Report_Feature_Coefficients_Sum_Fields>;
  var_pop?: Maybe<Feature_Report_Feature_Coefficients_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Report_Feature_Coefficients_Var_Samp_Fields>;
  variance?: Maybe<Feature_Report_Feature_Coefficients_Variance_Fields>;
};


/** aggregate fields of "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Feature_Report_Feature_Coefficients_Avg_Fields = {
  __typename?: 'feature_report_feature_coefficients_avg_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "feature_report_feature_coefficients". All fields are combined with a logical 'AND'. */
export type Feature_Report_Feature_Coefficients_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Bool_Exp>>;
  _not?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Bool_Exp>>;
  feature_report?: InputMaybe<Feature_Reports_Bool_Exp>;
  feature_report_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_report_feature_coefficients" */
export enum Feature_Report_Feature_Coefficients_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeatureReportFeatureCoefficientsPkey = 'feature_report_feature_coefficients_pkey'
}

/** input type for incrementing numeric columns in table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Inc_Input = {
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Insert_Input = {
  feature_report?: InputMaybe<Feature_Reports_Obj_Rel_Insert_Input>;
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Feature_Report_Feature_Coefficients_Max_Fields = {
  __typename?: 'feature_report_feature_coefficients_max_fields';
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type Feature_Report_Feature_Coefficients_Min_Fields = {
  __typename?: 'feature_report_feature_coefficients_min_fields';
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** response of any mutation on the table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Mutation_Response = {
  __typename?: 'feature_report_feature_coefficients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Report_Feature_Coefficients>;
};

/** on_conflict condition type for table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_On_Conflict = {
  constraint: Feature_Report_Feature_Coefficients_Constraint;
  update_columns?: Array<Feature_Report_Feature_Coefficients_Update_Column>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_report_feature_coefficients". */
export type Feature_Report_Feature_Coefficients_Order_By = {
  feature_report?: InputMaybe<Feature_Reports_Order_By>;
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_report_feature_coefficients */
export type Feature_Report_Feature_Coefficients_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "feature_report_feature_coefficients" */
export enum Feature_Report_Feature_Coefficients_Select_Column {
  /** column name */
  FeatureReportId = 'feature_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Set_Input = {
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Feature_Report_Feature_Coefficients_Stddev_Fields = {
  __typename?: 'feature_report_feature_coefficients_stddev_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Feature_Report_Feature_Coefficients_Stddev_Pop_Fields = {
  __typename?: 'feature_report_feature_coefficients_stddev_pop_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Feature_Report_Feature_Coefficients_Stddev_Samp_Fields = {
  __typename?: 'feature_report_feature_coefficients_stddev_samp_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "feature_report_feature_coefficients" */
export type Feature_Report_Feature_Coefficients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Report_Feature_Coefficients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Report_Feature_Coefficients_Stream_Cursor_Value_Input = {
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Feature_Report_Feature_Coefficients_Sum_Fields = {
  __typename?: 'feature_report_feature_coefficients_sum_fields';
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "feature_report_feature_coefficients" */
export enum Feature_Report_Feature_Coefficients_Update_Column {
  /** column name */
  FeatureReportId = 'feature_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Value = 'value'
}

export type Feature_Report_Feature_Coefficients_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Report_Feature_Coefficients_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Report_Feature_Coefficients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Report_Feature_Coefficients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Report_Feature_Coefficients_Var_Pop_Fields = {
  __typename?: 'feature_report_feature_coefficients_var_pop_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Feature_Report_Feature_Coefficients_Var_Samp_Fields = {
  __typename?: 'feature_report_feature_coefficients_var_samp_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Feature_Report_Feature_Coefficients_Variance_Fields = {
  __typename?: 'feature_report_feature_coefficients_variance_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "feature_report_features" */
export type Feature_Report_Features = {
  __typename?: 'feature_report_features';
  created_on: Scalars['timestamptz']['output'];
  /** An object relationship */
  enum_feature_direction: Enum_Feature_Direction;
  /** An object relationship */
  enum_feature_type: Enum_Feature_Type;
  /** An object relationship */
  feature_report: Feature_Reports;
  feature_report_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Enum_Feature_Type_Enum;
  more_less: Enum_Feature_Direction_Enum;
  value: Scalars['numeric']['output'];
};

/** aggregated selection of "feature_report_features" */
export type Feature_Report_Features_Aggregate = {
  __typename?: 'feature_report_features_aggregate';
  aggregate?: Maybe<Feature_Report_Features_Aggregate_Fields>;
  nodes: Array<Feature_Report_Features>;
};

export type Feature_Report_Features_Aggregate_Bool_Exp = {
  count?: InputMaybe<Feature_Report_Features_Aggregate_Bool_Exp_Count>;
};

export type Feature_Report_Features_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Feature_Report_Features_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feature_report_features" */
export type Feature_Report_Features_Aggregate_Fields = {
  __typename?: 'feature_report_features_aggregate_fields';
  avg?: Maybe<Feature_Report_Features_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Report_Features_Max_Fields>;
  min?: Maybe<Feature_Report_Features_Min_Fields>;
  stddev?: Maybe<Feature_Report_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Report_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Report_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Report_Features_Sum_Fields>;
  var_pop?: Maybe<Feature_Report_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Report_Features_Var_Samp_Fields>;
  variance?: Maybe<Feature_Report_Features_Variance_Fields>;
};


/** aggregate fields of "feature_report_features" */
export type Feature_Report_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "feature_report_features" */
export type Feature_Report_Features_Aggregate_Order_By = {
  avg?: InputMaybe<Feature_Report_Features_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feature_Report_Features_Max_Order_By>;
  min?: InputMaybe<Feature_Report_Features_Min_Order_By>;
  stddev?: InputMaybe<Feature_Report_Features_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Feature_Report_Features_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Feature_Report_Features_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Feature_Report_Features_Sum_Order_By>;
  var_pop?: InputMaybe<Feature_Report_Features_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Feature_Report_Features_Var_Samp_Order_By>;
  variance?: InputMaybe<Feature_Report_Features_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "feature_report_features" */
export type Feature_Report_Features_Arr_Rel_Insert_Input = {
  data: Array<Feature_Report_Features_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_Report_Features_On_Conflict>;
};

/** aggregate avg on columns */
export type Feature_Report_Features_Avg_Fields = {
  __typename?: 'feature_report_features_avg_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "feature_report_features" */
export type Feature_Report_Features_Avg_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feature_report_features". All fields are combined with a logical 'AND'. */
export type Feature_Report_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Report_Features_Bool_Exp>>;
  _not?: InputMaybe<Feature_Report_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Report_Features_Bool_Exp>>;
  created_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
  feature_report?: InputMaybe<Feature_Reports_Bool_Exp>;
  feature_report_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  key?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  more_less?: InputMaybe<Enum_Feature_Direction_Enum_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_report_features" */
export enum Feature_Report_Features_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeatureReportFeaturesPkey = 'feature_report_features_pkey'
}

/** input type for incrementing numeric columns in table "feature_report_features" */
export type Feature_Report_Features_Inc_Input = {
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "feature_report_features" */
export type Feature_Report_Features_Insert_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Obj_Rel_Insert_Input>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Obj_Rel_Insert_Input>;
  feature_report?: InputMaybe<Feature_Reports_Obj_Rel_Insert_Input>;
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  more_less?: InputMaybe<Enum_Feature_Direction_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Feature_Report_Features_Max_Fields = {
  __typename?: 'feature_report_features_max_fields';
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "feature_report_features" */
export type Feature_Report_Features_Max_Order_By = {
  created_on?: InputMaybe<Order_By>;
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feature_Report_Features_Min_Fields = {
  __typename?: 'feature_report_features_min_fields';
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "feature_report_features" */
export type Feature_Report_Features_Min_Order_By = {
  created_on?: InputMaybe<Order_By>;
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feature_report_features" */
export type Feature_Report_Features_Mutation_Response = {
  __typename?: 'feature_report_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Report_Features>;
};

/** on_conflict condition type for table "feature_report_features" */
export type Feature_Report_Features_On_Conflict = {
  constraint: Feature_Report_Features_Constraint;
  update_columns?: Array<Feature_Report_Features_Update_Column>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_report_features". */
export type Feature_Report_Features_Order_By = {
  created_on?: InputMaybe<Order_By>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Order_By>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Order_By>;
  feature_report?: InputMaybe<Feature_Reports_Order_By>;
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  more_less?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_report_features */
export type Feature_Report_Features_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "feature_report_features" */
export enum Feature_Report_Features_Select_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  FeatureReportId = 'feature_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MoreLess = 'more_less',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "feature_report_features" */
export type Feature_Report_Features_Set_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  more_less?: InputMaybe<Enum_Feature_Direction_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Feature_Report_Features_Stddev_Fields = {
  __typename?: 'feature_report_features_stddev_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "feature_report_features" */
export type Feature_Report_Features_Stddev_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feature_Report_Features_Stddev_Pop_Fields = {
  __typename?: 'feature_report_features_stddev_pop_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "feature_report_features" */
export type Feature_Report_Features_Stddev_Pop_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feature_Report_Features_Stddev_Samp_Fields = {
  __typename?: 'feature_report_features_stddev_samp_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "feature_report_features" */
export type Feature_Report_Features_Stddev_Samp_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "feature_report_features" */
export type Feature_Report_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Report_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Report_Features_Stream_Cursor_Value_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_report_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Enum_Feature_Type_Enum>;
  more_less?: InputMaybe<Enum_Feature_Direction_Enum>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Feature_Report_Features_Sum_Fields = {
  __typename?: 'feature_report_features_sum_fields';
  feature_report_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "feature_report_features" */
export type Feature_Report_Features_Sum_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** update columns of table "feature_report_features" */
export enum Feature_Report_Features_Update_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  FeatureReportId = 'feature_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MoreLess = 'more_less',
  /** column name */
  Value = 'value'
}

export type Feature_Report_Features_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Report_Features_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Report_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Report_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Report_Features_Var_Pop_Fields = {
  __typename?: 'feature_report_features_var_pop_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "feature_report_features" */
export type Feature_Report_Features_Var_Pop_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feature_Report_Features_Var_Samp_Fields = {
  __typename?: 'feature_report_features_var_samp_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "feature_report_features" */
export type Feature_Report_Features_Var_Samp_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Feature_Report_Features_Variance_Fields = {
  __typename?: 'feature_report_features_variance_fields';
  feature_report_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "feature_report_features" */
export type Feature_Report_Features_Variance_Order_By = {
  feature_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "feature_reports" */
export type Feature_Reports = {
  __typename?: 'feature_reports';
  created_on: Scalars['timestamptz']['output'];
  displayable_on: Scalars['timestamptz']['output'];
  /** An array relationship */
  feature_report_features: Array<Feature_Report_Features>;
  /** An aggregate relationship */
  feature_report_features_aggregate: Feature_Report_Features_Aggregate;
  id: Scalars['Int']['output'];
  outcome: Enum_Outcome_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "feature_reports" */
export type Feature_ReportsFeature_Report_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


/** columns and relationships of "feature_reports" */
export type Feature_ReportsFeature_Report_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};

/** aggregated selection of "feature_reports" */
export type Feature_Reports_Aggregate = {
  __typename?: 'feature_reports_aggregate';
  aggregate?: Maybe<Feature_Reports_Aggregate_Fields>;
  nodes: Array<Feature_Reports>;
};

export type Feature_Reports_Aggregate_Bool_Exp = {
  count?: InputMaybe<Feature_Reports_Aggregate_Bool_Exp_Count>;
};

export type Feature_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Feature_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "feature_reports" */
export type Feature_Reports_Aggregate_Fields = {
  __typename?: 'feature_reports_aggregate_fields';
  avg?: Maybe<Feature_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Feature_Reports_Max_Fields>;
  min?: Maybe<Feature_Reports_Min_Fields>;
  stddev?: Maybe<Feature_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Feature_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feature_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Feature_Reports_Sum_Fields>;
  var_pop?: Maybe<Feature_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Feature_Reports_Var_Samp_Fields>;
  variance?: Maybe<Feature_Reports_Variance_Fields>;
};


/** aggregate fields of "feature_reports" */
export type Feature_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "feature_reports" */
export type Feature_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Feature_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Feature_Reports_Max_Order_By>;
  min?: InputMaybe<Feature_Reports_Min_Order_By>;
  stddev?: InputMaybe<Feature_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Feature_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Feature_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Feature_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Feature_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Feature_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Feature_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "feature_reports" */
export type Feature_Reports_Arr_Rel_Insert_Input = {
  data: Array<Feature_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Feature_Reports_Avg_Fields = {
  __typename?: 'feature_reports_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "feature_reports" */
export type Feature_Reports_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "feature_reports". All fields are combined with a logical 'AND'. */
export type Feature_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Reports_Bool_Exp>>;
  _not?: InputMaybe<Feature_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Reports_Bool_Exp>>;
  created_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayable_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  feature_report_features?: InputMaybe<Feature_Report_Features_Bool_Exp>;
  feature_report_features_aggregate?: InputMaybe<Feature_Report_Features_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  outcome?: InputMaybe<Enum_Outcome_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "feature_reports" */
export enum Feature_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  FeatureReportsPkey = 'feature_reports_pkey'
}

/** input type for incrementing numeric columns in table "feature_reports" */
export type Feature_Reports_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "feature_reports" */
export type Feature_Reports_Insert_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  displayable_on?: InputMaybe<Scalars['timestamptz']['input']>;
  feature_report_features?: InputMaybe<Feature_Report_Features_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Feature_Reports_Max_Fields = {
  __typename?: 'feature_reports_max_fields';
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  displayable_on?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "feature_reports" */
export type Feature_Reports_Max_Order_By = {
  created_on?: InputMaybe<Order_By>;
  displayable_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Feature_Reports_Min_Fields = {
  __typename?: 'feature_reports_min_fields';
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  displayable_on?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "feature_reports" */
export type Feature_Reports_Min_Order_By = {
  created_on?: InputMaybe<Order_By>;
  displayable_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "feature_reports" */
export type Feature_Reports_Mutation_Response = {
  __typename?: 'feature_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Feature_Reports>;
};

/** input type for inserting object relation for remote table "feature_reports" */
export type Feature_Reports_Obj_Rel_Insert_Input = {
  data: Feature_Reports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Feature_Reports_On_Conflict>;
};

/** on_conflict condition type for table "feature_reports" */
export type Feature_Reports_On_Conflict = {
  constraint: Feature_Reports_Constraint;
  update_columns?: Array<Feature_Reports_Update_Column>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "feature_reports". */
export type Feature_Reports_Order_By = {
  created_on?: InputMaybe<Order_By>;
  displayable_on?: InputMaybe<Order_By>;
  feature_report_features_aggregate?: InputMaybe<Feature_Report_Features_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feature_reports */
export type Feature_Reports_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "feature_reports" */
export enum Feature_Reports_Select_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  DisplayableOn = 'displayable_on',
  /** column name */
  Id = 'id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "feature_reports" */
export type Feature_Reports_Set_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  displayable_on?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Feature_Reports_Stddev_Fields = {
  __typename?: 'feature_reports_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "feature_reports" */
export type Feature_Reports_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Feature_Reports_Stddev_Pop_Fields = {
  __typename?: 'feature_reports_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "feature_reports" */
export type Feature_Reports_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Feature_Reports_Stddev_Samp_Fields = {
  __typename?: 'feature_reports_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "feature_reports" */
export type Feature_Reports_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "feature_reports" */
export type Feature_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Reports_Stream_Cursor_Value_Input = {
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  displayable_on?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Feature_Reports_Sum_Fields = {
  __typename?: 'feature_reports_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "feature_reports" */
export type Feature_Reports_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "feature_reports" */
export enum Feature_Reports_Update_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  DisplayableOn = 'displayable_on',
  /** column name */
  Id = 'id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  UserId = 'user_id'
}

export type Feature_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feature_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feature_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feature_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feature_Reports_Var_Pop_Fields = {
  __typename?: 'feature_reports_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "feature_reports" */
export type Feature_Reports_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Feature_Reports_Var_Samp_Fields = {
  __typename?: 'feature_reports_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "feature_reports" */
export type Feature_Reports_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Feature_Reports_Variance_Fields = {
  __typename?: 'feature_reports_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "feature_reports" */
export type Feature_Reports_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "group_code" */
export type Group_Code = {
  __typename?: 'group_code';
  code: Scalars['citext']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "group_code" */
export type Group_Code_Aggregate = {
  __typename?: 'group_code_aggregate';
  aggregate?: Maybe<Group_Code_Aggregate_Fields>;
  nodes: Array<Group_Code>;
};

/** aggregate fields of "group_code" */
export type Group_Code_Aggregate_Fields = {
  __typename?: 'group_code_aggregate_fields';
  avg?: Maybe<Group_Code_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Group_Code_Max_Fields>;
  min?: Maybe<Group_Code_Min_Fields>;
  stddev?: Maybe<Group_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Group_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Group_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Group_Code_Sum_Fields>;
  var_pop?: Maybe<Group_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Group_Code_Var_Samp_Fields>;
  variance?: Maybe<Group_Code_Variance_Fields>;
};


/** aggregate fields of "group_code" */
export type Group_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Group_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Group_Code_Avg_Fields = {
  __typename?: 'group_code_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "group_code". All fields are combined with a logical 'AND'. */
export type Group_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Group_Code_Bool_Exp>>;
  _not?: InputMaybe<Group_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Group_Code_Bool_Exp>>;
  code?: InputMaybe<Citext_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "group_code" */
export enum Group_Code_Constraint {
  /** unique or primary key constraint on columns "code" */
  GroupCodeCodeKey = 'group_code_code_key',
  /** unique or primary key constraint on columns "id" */
  GroupCodePkey = 'group_code_pkey'
}

/** input type for incrementing numeric columns in table "group_code" */
export type Group_Code_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "group_code" */
export type Group_Code_Insert_Input = {
  code?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Group_Code_Max_Fields = {
  __typename?: 'group_code_max_fields';
  code?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Group_Code_Min_Fields = {
  __typename?: 'group_code_min_fields';
  code?: Maybe<Scalars['citext']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "group_code" */
export type Group_Code_Mutation_Response = {
  __typename?: 'group_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Group_Code>;
};

/** on_conflict condition type for table "group_code" */
export type Group_Code_On_Conflict = {
  constraint: Group_Code_Constraint;
  update_columns?: Array<Group_Code_Update_Column>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "group_code". */
export type Group_Code_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: group_code */
export type Group_Code_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "group_code" */
export enum Group_Code_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "group_code" */
export type Group_Code_Set_Input = {
  code?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Group_Code_Stddev_Fields = {
  __typename?: 'group_code_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Group_Code_Stddev_Pop_Fields = {
  __typename?: 'group_code_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Group_Code_Stddev_Samp_Fields = {
  __typename?: 'group_code_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "group_code" */
export type Group_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Group_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Group_Code_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['citext']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Group_Code_Sum_Fields = {
  __typename?: 'group_code_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "group_code" */
export enum Group_Code_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Group_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Group_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Group_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Group_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Group_Code_Var_Pop_Fields = {
  __typename?: 'group_code_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Group_Code_Var_Samp_Fields = {
  __typename?: 'group_code_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Group_Code_Variance_Fields = {
  __typename?: 'group_code_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "insight_articles" */
export type Insight_Articles = {
  __typename?: 'insight_articles';
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_recipe: Insight_Recipes;
  insight_recipe_id: Scalars['Int']['output'];
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  resource: Resources;
  resource_id: Scalars['Int']['output'];
};

/** aggregated selection of "insight_articles" */
export type Insight_Articles_Aggregate = {
  __typename?: 'insight_articles_aggregate';
  aggregate?: Maybe<Insight_Articles_Aggregate_Fields>;
  nodes: Array<Insight_Articles>;
};

export type Insight_Articles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Articles_Aggregate_Bool_Exp_Count>;
};

export type Insight_Articles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Articles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_articles" */
export type Insight_Articles_Aggregate_Fields = {
  __typename?: 'insight_articles_aggregate_fields';
  avg?: Maybe<Insight_Articles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Articles_Max_Fields>;
  min?: Maybe<Insight_Articles_Min_Fields>;
  stddev?: Maybe<Insight_Articles_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Articles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Articles_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Articles_Sum_Fields>;
  var_pop?: Maybe<Insight_Articles_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Articles_Var_Samp_Fields>;
  variance?: Maybe<Insight_Articles_Variance_Fields>;
};


/** aggregate fields of "insight_articles" */
export type Insight_Articles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_articles" */
export type Insight_Articles_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Articles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Articles_Max_Order_By>;
  min?: InputMaybe<Insight_Articles_Min_Order_By>;
  stddev?: InputMaybe<Insight_Articles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Articles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Articles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Articles_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Articles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Articles_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Articles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_articles" */
export type Insight_Articles_Arr_Rel_Insert_Input = {
  data: Array<Insight_Articles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Articles_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Articles_Avg_Fields = {
  __typename?: 'insight_articles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_articles" */
export type Insight_Articles_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_articles". All fields are combined with a logical 'AND'. */
export type Insight_Articles_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Articles_Bool_Exp>>;
  _not?: InputMaybe<Insight_Articles_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Articles_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  insight_why_id?: InputMaybe<Int_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_articles" */
export enum Insight_Articles_Constraint {
  /** unique or primary key constraint on columns "id" */
  InsightArticlesPkey = 'insight_articles_pkey'
}

/** input type for incrementing numeric columns in table "insight_articles" */
export type Insight_Articles_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_articles" */
export type Insight_Articles_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Articles_Max_Fields = {
  __typename?: 'insight_articles_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_articles" */
export type Insight_Articles_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Articles_Min_Fields = {
  __typename?: 'insight_articles_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_articles" */
export type Insight_Articles_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_articles" */
export type Insight_Articles_Mutation_Response = {
  __typename?: 'insight_articles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Articles>;
};

/** on_conflict condition type for table "insight_articles" */
export type Insight_Articles_On_Conflict = {
  constraint: Insight_Articles_Constraint;
  update_columns?: Array<Insight_Articles_Update_Column>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_articles". */
export type Insight_Articles_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_articles */
export type Insight_Articles_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_articles" */
export enum Insight_Articles_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  InsightWhyId = 'insight_why_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_articles" */
export type Insight_Articles_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Articles_Stddev_Fields = {
  __typename?: 'insight_articles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_articles" */
export type Insight_Articles_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Articles_Stddev_Pop_Fields = {
  __typename?: 'insight_articles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_articles" */
export type Insight_Articles_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Articles_Stddev_Samp_Fields = {
  __typename?: 'insight_articles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_articles" */
export type Insight_Articles_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_articles" */
export type Insight_Articles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Articles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Articles_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Articles_Sum_Fields = {
  __typename?: 'insight_articles_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_articles" */
export type Insight_Articles_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_articles" */
export enum Insight_Articles_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  InsightWhyId = 'insight_why_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Articles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Articles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Articles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Articles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Articles_Var_Pop_Fields = {
  __typename?: 'insight_articles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_articles" */
export type Insight_Articles_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Articles_Var_Samp_Fields = {
  __typename?: 'insight_articles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_articles" */
export type Insight_Articles_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Articles_Variance_Fields = {
  __typename?: 'insight_articles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_articles" */
export type Insight_Articles_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_combos" */
export type Insight_Combos = {
  __typename?: 'insight_combos';
  direction: Enum_Feature_Direction_Enum;
  display_text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  enum_feature_direction: Enum_Feature_Direction;
  /** An object relationship */
  enum_feature_type: Enum_Feature_Type;
  /** An object relationship */
  enum_outcome: Enum_Outcome;
  feature: Enum_Feature_Type_Enum;
  id: Scalars['Int']['output'];
  /** An array relationship */
  insight_recipes: Array<Insight_Recipes>;
  /** An aggregate relationship */
  insight_recipes_aggregate: Insight_Recipes_Aggregate;
  insight_type?: Maybe<Scalars['String']['output']>;
  observe_text?: Maybe<Scalars['String']['output']>;
  outcome: Enum_Outcome_Enum;
  /** An array relationship */
  user_insights: Array<User_Insights>;
  /** An aggregate relationship */
  user_insights_aggregate: User_Insights_Aggregate;
};


/** columns and relationships of "insight_combos" */
export type Insight_CombosInsight_RecipesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_combos" */
export type Insight_CombosInsight_Recipes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_combos" */
export type Insight_CombosUser_InsightsArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


/** columns and relationships of "insight_combos" */
export type Insight_CombosUser_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};

/** aggregated selection of "insight_combos" */
export type Insight_Combos_Aggregate = {
  __typename?: 'insight_combos_aggregate';
  aggregate?: Maybe<Insight_Combos_Aggregate_Fields>;
  nodes: Array<Insight_Combos>;
};

/** aggregate fields of "insight_combos" */
export type Insight_Combos_Aggregate_Fields = {
  __typename?: 'insight_combos_aggregate_fields';
  avg?: Maybe<Insight_Combos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Combos_Max_Fields>;
  min?: Maybe<Insight_Combos_Min_Fields>;
  stddev?: Maybe<Insight_Combos_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Combos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Combos_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Combos_Sum_Fields>;
  var_pop?: Maybe<Insight_Combos_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Combos_Var_Samp_Fields>;
  variance?: Maybe<Insight_Combos_Variance_Fields>;
};


/** aggregate fields of "insight_combos" */
export type Insight_Combos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Combos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Insight_Combos_Avg_Fields = {
  __typename?: 'insight_combos_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "insight_combos". All fields are combined with a logical 'AND'. */
export type Insight_Combos_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Combos_Bool_Exp>>;
  _not?: InputMaybe<Insight_Combos_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Combos_Bool_Exp>>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum_Comparison_Exp>;
  display_text?: InputMaybe<String_Comparison_Exp>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
  enum_outcome?: InputMaybe<Enum_Outcome_Bool_Exp>;
  feature?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipes?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipes_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp>;
  insight_type?: InputMaybe<String_Comparison_Exp>;
  observe_text?: InputMaybe<String_Comparison_Exp>;
  outcome?: InputMaybe<Enum_Outcome_Enum_Comparison_Exp>;
  user_insights?: InputMaybe<User_Insights_Bool_Exp>;
  user_insights_aggregate?: InputMaybe<User_Insights_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "insight_combos" */
export enum Insight_Combos_Constraint {
  /** unique or primary key constraint on columns "feature", "direction", "outcome" */
  InsightCombosFeatureDirectionOutcomeKey = 'insight_combos_feature_direction_outcome_key',
  /** unique or primary key constraint on columns "id" */
  InsightCombosPkey = 'insight_combos_pkey'
}

/** input type for incrementing numeric columns in table "insight_combos" */
export type Insight_Combos_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_combos" */
export type Insight_Combos_Insert_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  display_text?: InputMaybe<Scalars['String']['input']>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Obj_Rel_Insert_Input>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Obj_Rel_Insert_Input>;
  enum_outcome?: InputMaybe<Enum_Outcome_Obj_Rel_Insert_Input>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipes?: InputMaybe<Insight_Recipes_Arr_Rel_Insert_Input>;
  insight_type?: InputMaybe<Scalars['String']['input']>;
  observe_text?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
  user_insights?: InputMaybe<User_Insights_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Insight_Combos_Max_Fields = {
  __typename?: 'insight_combos_max_fields';
  display_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_type?: Maybe<Scalars['String']['output']>;
  observe_text?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Insight_Combos_Min_Fields = {
  __typename?: 'insight_combos_min_fields';
  display_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_type?: Maybe<Scalars['String']['output']>;
  observe_text?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "insight_combos" */
export type Insight_Combos_Mutation_Response = {
  __typename?: 'insight_combos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Combos>;
};

/** input type for inserting object relation for remote table "insight_combos" */
export type Insight_Combos_Obj_Rel_Insert_Input = {
  data: Insight_Combos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Combos_On_Conflict>;
};

/** on_conflict condition type for table "insight_combos" */
export type Insight_Combos_On_Conflict = {
  constraint: Insight_Combos_Constraint;
  update_columns?: Array<Insight_Combos_Update_Column>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_combos". */
export type Insight_Combos_Order_By = {
  direction?: InputMaybe<Order_By>;
  display_text?: InputMaybe<Order_By>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Order_By>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Order_By>;
  enum_outcome?: InputMaybe<Enum_Outcome_Order_By>;
  feature?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipes_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Order_By>;
  insight_type?: InputMaybe<Order_By>;
  observe_text?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  user_insights_aggregate?: InputMaybe<User_Insights_Aggregate_Order_By>;
};

/** primary key columns input for table: insight_combos */
export type Insight_Combos_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_combos" */
export enum Insight_Combos_Select_Column {
  /** column name */
  Direction = 'direction',
  /** column name */
  DisplayText = 'display_text',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  InsightType = 'insight_type',
  /** column name */
  ObserveText = 'observe_text',
  /** column name */
  Outcome = 'outcome'
}

/** input type for updating data in table "insight_combos" */
export type Insight_Combos_Set_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  display_text?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_type?: InputMaybe<Scalars['String']['input']>;
  observe_text?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
};

/** aggregate stddev on columns */
export type Insight_Combos_Stddev_Fields = {
  __typename?: 'insight_combos_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Insight_Combos_Stddev_Pop_Fields = {
  __typename?: 'insight_combos_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Insight_Combos_Stddev_Samp_Fields = {
  __typename?: 'insight_combos_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "insight_combos" */
export type Insight_Combos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Combos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Combos_Stream_Cursor_Value_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  display_text?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_type?: InputMaybe<Scalars['String']['input']>;
  observe_text?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Enum_Outcome_Enum>;
};

/** aggregate sum on columns */
export type Insight_Combos_Sum_Fields = {
  __typename?: 'insight_combos_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "insight_combos" */
export enum Insight_Combos_Update_Column {
  /** column name */
  Direction = 'direction',
  /** column name */
  DisplayText = 'display_text',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  InsightType = 'insight_type',
  /** column name */
  ObserveText = 'observe_text',
  /** column name */
  Outcome = 'outcome'
}

export type Insight_Combos_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Combos_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Combos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Combos_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Combos_Var_Pop_Fields = {
  __typename?: 'insight_combos_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Insight_Combos_Var_Samp_Fields = {
  __typename?: 'insight_combos_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Insight_Combos_Variance_Fields = {
  __typename?: 'insight_combos_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "insight_hows" */
export type Insight_Hows = {
  __typename?: 'insight_hows';
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_recipe: Insight_Recipes;
  insight_recipe_id: Scalars['Int']['output'];
  /** An object relationship */
  resource: Resources;
  resource_id: Scalars['Int']['output'];
};

/** aggregated selection of "insight_hows" */
export type Insight_Hows_Aggregate = {
  __typename?: 'insight_hows_aggregate';
  aggregate?: Maybe<Insight_Hows_Aggregate_Fields>;
  nodes: Array<Insight_Hows>;
};

export type Insight_Hows_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Hows_Aggregate_Bool_Exp_Count>;
};

export type Insight_Hows_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Hows_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_hows" */
export type Insight_Hows_Aggregate_Fields = {
  __typename?: 'insight_hows_aggregate_fields';
  avg?: Maybe<Insight_Hows_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Hows_Max_Fields>;
  min?: Maybe<Insight_Hows_Min_Fields>;
  stddev?: Maybe<Insight_Hows_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Hows_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Hows_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Hows_Sum_Fields>;
  var_pop?: Maybe<Insight_Hows_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Hows_Var_Samp_Fields>;
  variance?: Maybe<Insight_Hows_Variance_Fields>;
};


/** aggregate fields of "insight_hows" */
export type Insight_Hows_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_hows" */
export type Insight_Hows_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Hows_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Hows_Max_Order_By>;
  min?: InputMaybe<Insight_Hows_Min_Order_By>;
  stddev?: InputMaybe<Insight_Hows_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Hows_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Hows_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Hows_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Hows_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Hows_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Hows_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_hows" */
export type Insight_Hows_Arr_Rel_Insert_Input = {
  data: Array<Insight_Hows_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Hows_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Hows_Avg_Fields = {
  __typename?: 'insight_hows_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_hows" */
export type Insight_Hows_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_hows". All fields are combined with a logical 'AND'. */
export type Insight_Hows_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Hows_Bool_Exp>>;
  _not?: InputMaybe<Insight_Hows_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Hows_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_hows" */
export enum Insight_Hows_Constraint {
  /** unique or primary key constraint on columns "id" */
  InsightHowsPkey = 'insight_hows_pkey'
}

/** input type for incrementing numeric columns in table "insight_hows" */
export type Insight_Hows_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_hows" */
export type Insight_Hows_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Hows_Max_Fields = {
  __typename?: 'insight_hows_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_hows" */
export type Insight_Hows_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Hows_Min_Fields = {
  __typename?: 'insight_hows_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_hows" */
export type Insight_Hows_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_hows" */
export type Insight_Hows_Mutation_Response = {
  __typename?: 'insight_hows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Hows>;
};

/** on_conflict condition type for table "insight_hows" */
export type Insight_Hows_On_Conflict = {
  constraint: Insight_Hows_Constraint;
  update_columns?: Array<Insight_Hows_Update_Column>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_hows". */
export type Insight_Hows_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_hows */
export type Insight_Hows_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_hows" */
export enum Insight_Hows_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_hows" */
export type Insight_Hows_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Hows_Stddev_Fields = {
  __typename?: 'insight_hows_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_hows" */
export type Insight_Hows_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Hows_Stddev_Pop_Fields = {
  __typename?: 'insight_hows_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_hows" */
export type Insight_Hows_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Hows_Stddev_Samp_Fields = {
  __typename?: 'insight_hows_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_hows" */
export type Insight_Hows_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_hows" */
export type Insight_Hows_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Hows_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Hows_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Hows_Sum_Fields = {
  __typename?: 'insight_hows_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_hows" */
export type Insight_Hows_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_hows" */
export enum Insight_Hows_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Hows_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Hows_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Hows_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Hows_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Hows_Var_Pop_Fields = {
  __typename?: 'insight_hows_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_hows" */
export type Insight_Hows_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Hows_Var_Samp_Fields = {
  __typename?: 'insight_hows_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_hows" */
export type Insight_Hows_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Hows_Variance_Fields = {
  __typename?: 'insight_hows_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_hows" */
export type Insight_Hows_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_plan_article" */
export type Insight_Plan_Article = {
  __typename?: 'insight_plan_article';
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_plan: Insight_Plans;
  insight_plan_id: Scalars['Int']['output'];
  /** An object relationship */
  resource: Resources;
  resource_id: Scalars['Int']['output'];
};

/** aggregated selection of "insight_plan_article" */
export type Insight_Plan_Article_Aggregate = {
  __typename?: 'insight_plan_article_aggregate';
  aggregate?: Maybe<Insight_Plan_Article_Aggregate_Fields>;
  nodes: Array<Insight_Plan_Article>;
};

export type Insight_Plan_Article_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Plan_Article_Aggregate_Bool_Exp_Count>;
};

export type Insight_Plan_Article_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_plan_article" */
export type Insight_Plan_Article_Aggregate_Fields = {
  __typename?: 'insight_plan_article_aggregate_fields';
  avg?: Maybe<Insight_Plan_Article_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Plan_Article_Max_Fields>;
  min?: Maybe<Insight_Plan_Article_Min_Fields>;
  stddev?: Maybe<Insight_Plan_Article_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Plan_Article_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Plan_Article_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Plan_Article_Sum_Fields>;
  var_pop?: Maybe<Insight_Plan_Article_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Plan_Article_Var_Samp_Fields>;
  variance?: Maybe<Insight_Plan_Article_Variance_Fields>;
};


/** aggregate fields of "insight_plan_article" */
export type Insight_Plan_Article_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_plan_article" */
export type Insight_Plan_Article_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Plan_Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Plan_Article_Max_Order_By>;
  min?: InputMaybe<Insight_Plan_Article_Min_Order_By>;
  stddev?: InputMaybe<Insight_Plan_Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Plan_Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Plan_Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Plan_Article_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Plan_Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Plan_Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Plan_Article_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_plan_article" */
export type Insight_Plan_Article_Arr_Rel_Insert_Input = {
  data: Array<Insight_Plan_Article_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Plan_Article_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Plan_Article_Avg_Fields = {
  __typename?: 'insight_plan_article_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_plan_article". All fields are combined with a logical 'AND'. */
export type Insight_Plan_Article_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Plan_Article_Bool_Exp>>;
  _not?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Plan_Article_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_plan?: InputMaybe<Insight_Plans_Bool_Exp>;
  insight_plan_id?: InputMaybe<Int_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_plan_article" */
export enum Insight_Plan_Article_Constraint {
  /** unique or primary key constraint on columns "insight_plan_id", "resource_id" */
  InsightPlanArticleInsightPlanIdResourceIdKey = 'insight_plan_article_insight_plan_id_resource_id_key',
  /** unique or primary key constraint on columns "id" */
  InsightPlanArticlePkey = 'insight_plan_article_pkey'
}

/** input type for incrementing numeric columns in table "insight_plan_article" */
export type Insight_Plan_Article_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_plan_article" */
export type Insight_Plan_Article_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan?: InputMaybe<Insight_Plans_Obj_Rel_Insert_Input>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Plan_Article_Max_Fields = {
  __typename?: 'insight_plan_article_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Plan_Article_Min_Fields = {
  __typename?: 'insight_plan_article_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_plan_article" */
export type Insight_Plan_Article_Mutation_Response = {
  __typename?: 'insight_plan_article_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Plan_Article>;
};

/** on_conflict condition type for table "insight_plan_article" */
export type Insight_Plan_Article_On_Conflict = {
  constraint: Insight_Plan_Article_Constraint;
  update_columns?: Array<Insight_Plan_Article_Update_Column>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_plan_article". */
export type Insight_Plan_Article_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan?: InputMaybe<Insight_Plans_Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_plan_article */
export type Insight_Plan_Article_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_plan_article" */
export enum Insight_Plan_Article_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightPlanId = 'insight_plan_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_plan_article" */
export type Insight_Plan_Article_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Plan_Article_Stddev_Fields = {
  __typename?: 'insight_plan_article_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Plan_Article_Stddev_Pop_Fields = {
  __typename?: 'insight_plan_article_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Plan_Article_Stddev_Samp_Fields = {
  __typename?: 'insight_plan_article_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_plan_article" */
export type Insight_Plan_Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Plan_Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Plan_Article_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Plan_Article_Sum_Fields = {
  __typename?: 'insight_plan_article_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_plan_article" */
export enum Insight_Plan_Article_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightPlanId = 'insight_plan_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Plan_Article_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Plan_Article_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Plan_Article_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Plan_Article_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Plan_Article_Var_Pop_Fields = {
  __typename?: 'insight_plan_article_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Plan_Article_Var_Samp_Fields = {
  __typename?: 'insight_plan_article_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Plan_Article_Variance_Fields = {
  __typename?: 'insight_plan_article_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_plan_article" */
export type Insight_Plan_Article_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_plan_text" */
export type Insight_Plan_Text = {
  __typename?: 'insight_plan_text';
  content: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_plan: Insight_Plans;
  insight_plan_id: Scalars['Int']['output'];
  /** An object relationship */
  insight_text: Insight_Texts;
};

/** aggregated selection of "insight_plan_text" */
export type Insight_Plan_Text_Aggregate = {
  __typename?: 'insight_plan_text_aggregate';
  aggregate?: Maybe<Insight_Plan_Text_Aggregate_Fields>;
  nodes: Array<Insight_Plan_Text>;
};

export type Insight_Plan_Text_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Plan_Text_Aggregate_Bool_Exp_Count>;
};

export type Insight_Plan_Text_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_plan_text" */
export type Insight_Plan_Text_Aggregate_Fields = {
  __typename?: 'insight_plan_text_aggregate_fields';
  avg?: Maybe<Insight_Plan_Text_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Plan_Text_Max_Fields>;
  min?: Maybe<Insight_Plan_Text_Min_Fields>;
  stddev?: Maybe<Insight_Plan_Text_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Plan_Text_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Plan_Text_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Plan_Text_Sum_Fields>;
  var_pop?: Maybe<Insight_Plan_Text_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Plan_Text_Var_Samp_Fields>;
  variance?: Maybe<Insight_Plan_Text_Variance_Fields>;
};


/** aggregate fields of "insight_plan_text" */
export type Insight_Plan_Text_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_plan_text" */
export type Insight_Plan_Text_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Plan_Text_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Plan_Text_Max_Order_By>;
  min?: InputMaybe<Insight_Plan_Text_Min_Order_By>;
  stddev?: InputMaybe<Insight_Plan_Text_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Plan_Text_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Plan_Text_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Plan_Text_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Plan_Text_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Plan_Text_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Plan_Text_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_plan_text" */
export type Insight_Plan_Text_Arr_Rel_Insert_Input = {
  data: Array<Insight_Plan_Text_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Plan_Text_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Plan_Text_Avg_Fields = {
  __typename?: 'insight_plan_text_avg_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Avg_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_plan_text". All fields are combined with a logical 'AND'. */
export type Insight_Plan_Text_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Plan_Text_Bool_Exp>>;
  _not?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Plan_Text_Bool_Exp>>;
  content?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_plan?: InputMaybe<Insight_Plans_Bool_Exp>;
  insight_plan_id?: InputMaybe<Int_Comparison_Exp>;
  insight_text?: InputMaybe<Insight_Texts_Bool_Exp>;
};

/** unique or primary key constraints on table "insight_plan_text" */
export enum Insight_Plan_Text_Constraint {
  /** unique or primary key constraint on columns "insight_plan_id", "content" */
  InsightPlanTextInsightPlanIdContentKey = 'insight_plan_text_insight_plan_id_content_key',
  /** unique or primary key constraint on columns "id" */
  InsightPlanTextPkey = 'insight_plan_text_pkey'
}

/** input type for incrementing numeric columns in table "insight_plan_text" */
export type Insight_Plan_Text_Inc_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_plan_text" */
export type Insight_Plan_Text_Insert_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan?: InputMaybe<Insight_Plans_Obj_Rel_Insert_Input>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
  insight_text?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Insight_Plan_Text_Max_Fields = {
  __typename?: 'insight_plan_text_max_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Plan_Text_Min_Fields = {
  __typename?: 'insight_plan_text_min_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_plan_text" */
export type Insight_Plan_Text_Mutation_Response = {
  __typename?: 'insight_plan_text_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Plan_Text>;
};

/** on_conflict condition type for table "insight_plan_text" */
export type Insight_Plan_Text_On_Conflict = {
  constraint: Insight_Plan_Text_Constraint;
  update_columns?: Array<Insight_Plan_Text_Update_Column>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_plan_text". */
export type Insight_Plan_Text_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan?: InputMaybe<Insight_Plans_Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
  insight_text?: InputMaybe<Insight_Texts_Order_By>;
};

/** primary key columns input for table: insight_plan_text */
export type Insight_Plan_Text_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_plan_text" */
export enum Insight_Plan_Text_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  InsightPlanId = 'insight_plan_id'
}

/** input type for updating data in table "insight_plan_text" */
export type Insight_Plan_Text_Set_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Plan_Text_Stddev_Fields = {
  __typename?: 'insight_plan_text_stddev_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Stddev_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Plan_Text_Stddev_Pop_Fields = {
  __typename?: 'insight_plan_text_stddev_pop_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Stddev_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Plan_Text_Stddev_Samp_Fields = {
  __typename?: 'insight_plan_text_stddev_samp_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Stddev_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_plan_text" */
export type Insight_Plan_Text_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Plan_Text_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Plan_Text_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Plan_Text_Sum_Fields = {
  __typename?: 'insight_plan_text_sum_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_plan_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Sum_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_plan_text" */
export enum Insight_Plan_Text_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  InsightPlanId = 'insight_plan_id'
}

export type Insight_Plan_Text_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Plan_Text_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Plan_Text_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Plan_Text_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Plan_Text_Var_Pop_Fields = {
  __typename?: 'insight_plan_text_var_pop_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Var_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Plan_Text_Var_Samp_Fields = {
  __typename?: 'insight_plan_text_var_samp_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Var_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Plan_Text_Variance_Fields = {
  __typename?: 'insight_plan_text_variance_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_plan_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_plan_text" */
export type Insight_Plan_Text_Variance_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_plans" */
export type Insight_Plans = {
  __typename?: 'insight_plans';
  id: Scalars['Int']['output'];
  /** An array relationship */
  insight_plan_articles: Array<Insight_Plan_Article>;
  /** An aggregate relationship */
  insight_plan_articles_aggregate: Insight_Plan_Article_Aggregate;
  /** An array relationship */
  insight_plan_texts: Array<Insight_Plan_Text>;
  /** An aggregate relationship */
  insight_plan_texts_aggregate: Insight_Plan_Text_Aggregate;
  /** An object relationship */
  insight_recipe?: Maybe<Insight_Recipes>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  responseText?: Maybe<Insight_Texts>;
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "insight_plans" */
export type Insight_PlansInsight_Plan_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


/** columns and relationships of "insight_plans" */
export type Insight_PlansInsight_Plan_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


/** columns and relationships of "insight_plans" */
export type Insight_PlansInsight_Plan_TextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


/** columns and relationships of "insight_plans" */
export type Insight_PlansInsight_Plan_Texts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};

/** aggregated selection of "insight_plans" */
export type Insight_Plans_Aggregate = {
  __typename?: 'insight_plans_aggregate';
  aggregate?: Maybe<Insight_Plans_Aggregate_Fields>;
  nodes: Array<Insight_Plans>;
};

export type Insight_Plans_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Plans_Aggregate_Bool_Exp_Count>;
};

export type Insight_Plans_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Plans_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_plans" */
export type Insight_Plans_Aggregate_Fields = {
  __typename?: 'insight_plans_aggregate_fields';
  avg?: Maybe<Insight_Plans_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Plans_Max_Fields>;
  min?: Maybe<Insight_Plans_Min_Fields>;
  stddev?: Maybe<Insight_Plans_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Plans_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Plans_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Plans_Sum_Fields>;
  var_pop?: Maybe<Insight_Plans_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Plans_Var_Samp_Fields>;
  variance?: Maybe<Insight_Plans_Variance_Fields>;
};


/** aggregate fields of "insight_plans" */
export type Insight_Plans_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_plans" */
export type Insight_Plans_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Plans_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Plans_Max_Order_By>;
  min?: InputMaybe<Insight_Plans_Min_Order_By>;
  stddev?: InputMaybe<Insight_Plans_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Plans_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Plans_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Plans_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Plans_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Plans_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Plans_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_plans" */
export type Insight_Plans_Arr_Rel_Insert_Input = {
  data: Array<Insight_Plans_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Plans_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Plans_Avg_Fields = {
  __typename?: 'insight_plans_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_plans" */
export type Insight_Plans_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_plans". All fields are combined with a logical 'AND'. */
export type Insight_Plans_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Plans_Bool_Exp>>;
  _not?: InputMaybe<Insight_Plans_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Plans_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_plan_articles?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
  insight_plan_articles_aggregate?: InputMaybe<Insight_Plan_Article_Aggregate_Bool_Exp>;
  insight_plan_texts?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
  insight_plan_texts_aggregate?: InputMaybe<Insight_Plan_Text_Aggregate_Bool_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  response?: InputMaybe<Int_Comparison_Exp>;
  responseText?: InputMaybe<Insight_Texts_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_plans" */
export enum Insight_Plans_Constraint {
  /** unique or primary key constraint on columns "response", "insight_recipe_id" */
  InsightPlansInsightRecipeIdResponseKey = 'insight_plans_insight_recipe_id_response_key',
  /** unique or primary key constraint on columns "id" */
  InsightPlansPkey = 'insight_plans_pkey'
}

/** input type for incrementing numeric columns in table "insight_plans" */
export type Insight_Plans_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_plans" */
export type Insight_Plans_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_articles?: InputMaybe<Insight_Plan_Article_Arr_Rel_Insert_Input>;
  insight_plan_texts?: InputMaybe<Insight_Plan_Text_Arr_Rel_Insert_Input>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  responseText?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Insight_Plans_Max_Fields = {
  __typename?: 'insight_plans_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "insight_plans" */
export type Insight_Plans_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Plans_Min_Fields = {
  __typename?: 'insight_plans_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "insight_plans" */
export type Insight_Plans_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_plans" */
export type Insight_Plans_Mutation_Response = {
  __typename?: 'insight_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Plans>;
};

/** input type for inserting object relation for remote table "insight_plans" */
export type Insight_Plans_Obj_Rel_Insert_Input = {
  data: Insight_Plans_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Plans_On_Conflict>;
};

/** on_conflict condition type for table "insight_plans" */
export type Insight_Plans_On_Conflict = {
  constraint: Insight_Plans_Constraint;
  update_columns?: Array<Insight_Plans_Update_Column>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_plans". */
export type Insight_Plans_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_plan_articles_aggregate?: InputMaybe<Insight_Plan_Article_Aggregate_Order_By>;
  insight_plan_texts_aggregate?: InputMaybe<Insight_Plan_Text_Aggregate_Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  responseText?: InputMaybe<Insight_Texts_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_plans */
export type Insight_Plans_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_plans" */
export enum Insight_Plans_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  Response = 'response',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "insight_plans" */
export type Insight_Plans_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Plans_Stddev_Fields = {
  __typename?: 'insight_plans_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_plans" */
export type Insight_Plans_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Plans_Stddev_Pop_Fields = {
  __typename?: 'insight_plans_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_plans" */
export type Insight_Plans_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Plans_Stddev_Samp_Fields = {
  __typename?: 'insight_plans_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_plans" */
export type Insight_Plans_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_plans" */
export type Insight_Plans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Plans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Plans_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Insight_Plans_Sum_Fields = {
  __typename?: 'insight_plans_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_plans" */
export type Insight_Plans_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** update columns of table "insight_plans" */
export enum Insight_Plans_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  Response = 'response',
  /** column name */
  Type = 'type'
}

export type Insight_Plans_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Plans_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Plans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Plans_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Plans_Var_Pop_Fields = {
  __typename?: 'insight_plans_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_plans" */
export type Insight_Plans_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Plans_Var_Samp_Fields = {
  __typename?: 'insight_plans_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_plans" */
export type Insight_Plans_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Plans_Variance_Fields = {
  __typename?: 'insight_plans_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_plans" */
export type Insight_Plans_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_questions" */
export type Insight_Questions = {
  __typename?: 'insight_questions';
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_recipe?: Maybe<Insight_Recipes>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  resource?: Maybe<Resources>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "insight_questions" */
export type Insight_Questions_Aggregate = {
  __typename?: 'insight_questions_aggregate';
  aggregate?: Maybe<Insight_Questions_Aggregate_Fields>;
  nodes: Array<Insight_Questions>;
};

export type Insight_Questions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Questions_Aggregate_Bool_Exp_Count>;
};

export type Insight_Questions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Questions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_questions" */
export type Insight_Questions_Aggregate_Fields = {
  __typename?: 'insight_questions_aggregate_fields';
  avg?: Maybe<Insight_Questions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Questions_Max_Fields>;
  min?: Maybe<Insight_Questions_Min_Fields>;
  stddev?: Maybe<Insight_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Questions_Sum_Fields>;
  var_pop?: Maybe<Insight_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Questions_Var_Samp_Fields>;
  variance?: Maybe<Insight_Questions_Variance_Fields>;
};


/** aggregate fields of "insight_questions" */
export type Insight_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_questions" */
export type Insight_Questions_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Questions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Questions_Max_Order_By>;
  min?: InputMaybe<Insight_Questions_Min_Order_By>;
  stddev?: InputMaybe<Insight_Questions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Questions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Questions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Questions_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Questions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Questions_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Questions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_questions" */
export type Insight_Questions_Arr_Rel_Insert_Input = {
  data: Array<Insight_Questions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Questions_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Questions_Avg_Fields = {
  __typename?: 'insight_questions_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_questions" */
export type Insight_Questions_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_questions". All fields are combined with a logical 'AND'. */
export type Insight_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Questions_Bool_Exp>>;
  _not?: InputMaybe<Insight_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Questions_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  insight_reflect_id?: InputMaybe<Int_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_questions" */
export enum Insight_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  InsightQuestionsPkey = 'insight_questions_pkey'
}

/** input type for incrementing numeric columns in table "insight_questions" */
export type Insight_Questions_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_questions" */
export type Insight_Questions_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Questions_Max_Fields = {
  __typename?: 'insight_questions_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_questions" */
export type Insight_Questions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Questions_Min_Fields = {
  __typename?: 'insight_questions_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_questions" */
export type Insight_Questions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_questions" */
export type Insight_Questions_Mutation_Response = {
  __typename?: 'insight_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Questions>;
};

/** on_conflict condition type for table "insight_questions" */
export type Insight_Questions_On_Conflict = {
  constraint: Insight_Questions_Constraint;
  update_columns?: Array<Insight_Questions_Update_Column>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_questions". */
export type Insight_Questions_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_questions */
export type Insight_Questions_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_questions" */
export enum Insight_Questions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  InsightReflectId = 'insight_reflect_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_questions" */
export type Insight_Questions_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Questions_Stddev_Fields = {
  __typename?: 'insight_questions_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_questions" */
export type Insight_Questions_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Questions_Stddev_Pop_Fields = {
  __typename?: 'insight_questions_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_questions" */
export type Insight_Questions_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Questions_Stddev_Samp_Fields = {
  __typename?: 'insight_questions_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_questions" */
export type Insight_Questions_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_questions" */
export type Insight_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Questions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Questions_Sum_Fields = {
  __typename?: 'insight_questions_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_questions" */
export type Insight_Questions_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_questions" */
export enum Insight_Questions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  InsightReflectId = 'insight_reflect_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Questions_Var_Pop_Fields = {
  __typename?: 'insight_questions_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_questions" */
export type Insight_Questions_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Questions_Var_Samp_Fields = {
  __typename?: 'insight_questions_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_questions" */
export type Insight_Questions_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Questions_Variance_Fields = {
  __typename?: 'insight_questions_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_questions" */
export type Insight_Questions_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_recipes" */
export type Insight_Recipes = {
  __typename?: 'insight_recipes';
  id: Scalars['Int']['output'];
  /** An array relationship */
  insight_articles: Array<Insight_Articles>;
  /** An aggregate relationship */
  insight_articles_aggregate: Insight_Articles_Aggregate;
  /** An object relationship */
  insight_combo: Insight_Combos;
  insight_combo_id: Scalars['Int']['output'];
  /** An array relationship */
  insight_hows: Array<Insight_Hows>;
  /** An aggregate relationship */
  insight_hows_aggregate: Insight_Hows_Aggregate;
  /** An array relationship */
  insight_plans: Array<Insight_Plans>;
  /** An aggregate relationship */
  insight_plans_aggregate: Insight_Plans_Aggregate;
  /** An array relationship */
  insight_questions: Array<Insight_Questions>;
  /** An aggregate relationship */
  insight_questions_aggregate: Insight_Questions_Aggregate;
  /** An array relationship */
  insight_reflects: Array<Insight_Reflect>;
  /** An aggregate relationship */
  insight_reflects_aggregate: Insight_Reflect_Aggregate;
  /** An array relationship */
  insight_whys: Array<Insight_Whys>;
  /** An aggregate relationship */
  insight_whys_aggregate: Insight_Whys_Aggregate;
  observe?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  observeText?: Maybe<Insight_Texts>;
  /** An object relationship */
  org?: Maybe<Organizations>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['Int']['output']>;
  planImageURL?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  planText?: Maybe<Insight_Texts>;
  public: Scalars['Boolean']['output'];
  reflect?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  reflectText?: Maybe<Insight_Texts>;
  schema_version?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_HowsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Hows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_PlansArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_ReflectsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Reflects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_WhysArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


/** columns and relationships of "insight_recipes" */
export type Insight_RecipesInsight_Whys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};

/** aggregated selection of "insight_recipes" */
export type Insight_Recipes_Aggregate = {
  __typename?: 'insight_recipes_aggregate';
  aggregate?: Maybe<Insight_Recipes_Aggregate_Fields>;
  nodes: Array<Insight_Recipes>;
};

export type Insight_Recipes_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp_Count>;
};

export type Insight_Recipes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Insight_Recipes_Select_Column_Insight_Recipes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Recipes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Insight_Recipes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Insight_Recipes_Select_Column_Insight_Recipes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Recipes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Insight_Recipes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Recipes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_recipes" */
export type Insight_Recipes_Aggregate_Fields = {
  __typename?: 'insight_recipes_aggregate_fields';
  avg?: Maybe<Insight_Recipes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Recipes_Max_Fields>;
  min?: Maybe<Insight_Recipes_Min_Fields>;
  stddev?: Maybe<Insight_Recipes_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Recipes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Recipes_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Recipes_Sum_Fields>;
  var_pop?: Maybe<Insight_Recipes_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Recipes_Var_Samp_Fields>;
  variance?: Maybe<Insight_Recipes_Variance_Fields>;
};


/** aggregate fields of "insight_recipes" */
export type Insight_Recipes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_recipes" */
export type Insight_Recipes_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Recipes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Recipes_Max_Order_By>;
  min?: InputMaybe<Insight_Recipes_Min_Order_By>;
  stddev?: InputMaybe<Insight_Recipes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Recipes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Recipes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Recipes_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Recipes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Recipes_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Recipes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_recipes" */
export type Insight_Recipes_Arr_Rel_Insert_Input = {
  data: Array<Insight_Recipes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Recipes_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Recipes_Avg_Fields = {
  __typename?: 'insight_recipes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_recipes" */
export type Insight_Recipes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_recipes". All fields are combined with a logical 'AND'. */
export type Insight_Recipes_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Recipes_Bool_Exp>>;
  _not?: InputMaybe<Insight_Recipes_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Recipes_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_articles?: InputMaybe<Insight_Articles_Bool_Exp>;
  insight_articles_aggregate?: InputMaybe<Insight_Articles_Aggregate_Bool_Exp>;
  insight_combo?: InputMaybe<Insight_Combos_Bool_Exp>;
  insight_combo_id?: InputMaybe<Int_Comparison_Exp>;
  insight_hows?: InputMaybe<Insight_Hows_Bool_Exp>;
  insight_hows_aggregate?: InputMaybe<Insight_Hows_Aggregate_Bool_Exp>;
  insight_plans?: InputMaybe<Insight_Plans_Bool_Exp>;
  insight_plans_aggregate?: InputMaybe<Insight_Plans_Aggregate_Bool_Exp>;
  insight_questions?: InputMaybe<Insight_Questions_Bool_Exp>;
  insight_questions_aggregate?: InputMaybe<Insight_Questions_Aggregate_Bool_Exp>;
  insight_reflects?: InputMaybe<Insight_Reflect_Bool_Exp>;
  insight_reflects_aggregate?: InputMaybe<Insight_Reflect_Aggregate_Bool_Exp>;
  insight_whys?: InputMaybe<Insight_Whys_Bool_Exp>;
  insight_whys_aggregate?: InputMaybe<Insight_Whys_Aggregate_Bool_Exp>;
  observe?: InputMaybe<Int_Comparison_Exp>;
  observeText?: InputMaybe<Insight_Texts_Bool_Exp>;
  org?: InputMaybe<Organizations_Bool_Exp>;
  owner_org_id?: InputMaybe<Int_Comparison_Exp>;
  plan?: InputMaybe<Int_Comparison_Exp>;
  planImageURL?: InputMaybe<String_Comparison_Exp>;
  planText?: InputMaybe<Insight_Texts_Bool_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  reflect?: InputMaybe<Int_Comparison_Exp>;
  reflectText?: InputMaybe<Insight_Texts_Bool_Exp>;
  schema_version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_recipes" */
export enum Insight_Recipes_Constraint {
  /** unique or primary key constraint on columns "owner_org_id", "schema_version", "insight_combo_id" */
  InsightRecipesInsightComboIdOwnerOrgIdSchemaVersionKe = 'insight_recipes_insight_combo_id_owner_org_id_schema_version_ke',
  /** unique or primary key constraint on columns "id" */
  InsightRecipesPkey = 'insight_recipes_pkey'
}

/** input type for incrementing numeric columns in table "insight_recipes" */
export type Insight_Recipes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  observe?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  reflect?: InputMaybe<Scalars['Int']['input']>;
  schema_version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_recipes" */
export type Insight_Recipes_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_articles?: InputMaybe<Insight_Articles_Arr_Rel_Insert_Input>;
  insight_combo?: InputMaybe<Insight_Combos_Obj_Rel_Insert_Input>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  insight_hows?: InputMaybe<Insight_Hows_Arr_Rel_Insert_Input>;
  insight_plans?: InputMaybe<Insight_Plans_Arr_Rel_Insert_Input>;
  insight_questions?: InputMaybe<Insight_Questions_Arr_Rel_Insert_Input>;
  insight_reflects?: InputMaybe<Insight_Reflect_Arr_Rel_Insert_Input>;
  insight_whys?: InputMaybe<Insight_Whys_Arr_Rel_Insert_Input>;
  observe?: InputMaybe<Scalars['Int']['input']>;
  observeText?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
  org?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  planImageURL?: InputMaybe<Scalars['String']['input']>;
  planText?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  reflect?: InputMaybe<Scalars['Int']['input']>;
  reflectText?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
  schema_version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Recipes_Max_Fields = {
  __typename?: 'insight_recipes_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  observe?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['Int']['output']>;
  planImageURL?: Maybe<Scalars['String']['output']>;
  reflect?: Maybe<Scalars['Int']['output']>;
  schema_version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_recipes" */
export type Insight_Recipes_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  planImageURL?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Recipes_Min_Fields = {
  __typename?: 'insight_recipes_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  observe?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['Int']['output']>;
  planImageURL?: Maybe<Scalars['String']['output']>;
  reflect?: Maybe<Scalars['Int']['output']>;
  schema_version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_recipes" */
export type Insight_Recipes_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  planImageURL?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_recipes" */
export type Insight_Recipes_Mutation_Response = {
  __typename?: 'insight_recipes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Recipes>;
};

/** input type for inserting object relation for remote table "insight_recipes" */
export type Insight_Recipes_Obj_Rel_Insert_Input = {
  data: Insight_Recipes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Recipes_On_Conflict>;
};

/** on_conflict condition type for table "insight_recipes" */
export type Insight_Recipes_On_Conflict = {
  constraint: Insight_Recipes_Constraint;
  update_columns?: Array<Insight_Recipes_Update_Column>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_recipes". */
export type Insight_Recipes_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_articles_aggregate?: InputMaybe<Insight_Articles_Aggregate_Order_By>;
  insight_combo?: InputMaybe<Insight_Combos_Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_hows_aggregate?: InputMaybe<Insight_Hows_Aggregate_Order_By>;
  insight_plans_aggregate?: InputMaybe<Insight_Plans_Aggregate_Order_By>;
  insight_questions_aggregate?: InputMaybe<Insight_Questions_Aggregate_Order_By>;
  insight_reflects_aggregate?: InputMaybe<Insight_Reflect_Aggregate_Order_By>;
  insight_whys_aggregate?: InputMaybe<Insight_Whys_Aggregate_Order_By>;
  observe?: InputMaybe<Order_By>;
  observeText?: InputMaybe<Insight_Texts_Order_By>;
  org?: InputMaybe<Organizations_Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  planImageURL?: InputMaybe<Order_By>;
  planText?: InputMaybe<Insight_Texts_Order_By>;
  public?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  reflectText?: InputMaybe<Insight_Texts_Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_recipes */
export type Insight_Recipes_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_recipes" */
export enum Insight_Recipes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightComboId = 'insight_combo_id',
  /** column name */
  Observe = 'observe',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Plan = 'plan',
  /** column name */
  PlanImageUrl = 'planImageURL',
  /** column name */
  Public = 'public',
  /** column name */
  Reflect = 'reflect',
  /** column name */
  SchemaVersion = 'schema_version'
}

/** select "insight_recipes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "insight_recipes" */
export enum Insight_Recipes_Select_Column_Insight_Recipes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** select "insight_recipes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "insight_recipes" */
export enum Insight_Recipes_Select_Column_Insight_Recipes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** input type for updating data in table "insight_recipes" */
export type Insight_Recipes_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  observe?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  planImageURL?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  reflect?: InputMaybe<Scalars['Int']['input']>;
  schema_version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Recipes_Stddev_Fields = {
  __typename?: 'insight_recipes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_recipes" */
export type Insight_Recipes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Recipes_Stddev_Pop_Fields = {
  __typename?: 'insight_recipes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_recipes" */
export type Insight_Recipes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Recipes_Stddev_Samp_Fields = {
  __typename?: 'insight_recipes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_recipes" */
export type Insight_Recipes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_recipes" */
export type Insight_Recipes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Recipes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Recipes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  observe?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['Int']['input']>;
  planImageURL?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  reflect?: InputMaybe<Scalars['Int']['input']>;
  schema_version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Recipes_Sum_Fields = {
  __typename?: 'insight_recipes_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  observe?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['Int']['output']>;
  reflect?: Maybe<Scalars['Int']['output']>;
  schema_version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_recipes" */
export type Insight_Recipes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** update columns of table "insight_recipes" */
export enum Insight_Recipes_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightComboId = 'insight_combo_id',
  /** column name */
  Observe = 'observe',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Plan = 'plan',
  /** column name */
  PlanImageUrl = 'planImageURL',
  /** column name */
  Public = 'public',
  /** column name */
  Reflect = 'reflect',
  /** column name */
  SchemaVersion = 'schema_version'
}

export type Insight_Recipes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Recipes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Recipes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Recipes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Recipes_Var_Pop_Fields = {
  __typename?: 'insight_recipes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_recipes" */
export type Insight_Recipes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Recipes_Var_Samp_Fields = {
  __typename?: 'insight_recipes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_recipes" */
export type Insight_Recipes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Recipes_Variance_Fields = {
  __typename?: 'insight_recipes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  observe?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  plan?: Maybe<Scalars['Float']['output']>;
  reflect?: Maybe<Scalars['Float']['output']>;
  schema_version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_recipes" */
export type Insight_Recipes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  observe?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  reflect?: InputMaybe<Order_By>;
  schema_version?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_reflect" */
export type Insight_Reflect = {
  __typename?: 'insight_reflect';
  heading?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  insight_questions: Array<Insight_Questions>;
  /** An aggregate relationship */
  insight_questions_aggregate: Insight_Questions_Aggregate;
  /** An object relationship */
  insight_recipe?: Maybe<Insight_Recipes>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  insight_reflect_texts: Array<Insight_Reflect_Text>;
  /** An aggregate relationship */
  insight_reflect_texts_aggregate: Insight_Reflect_Text_Aggregate;
  /** An object relationship */
  reflectHeading?: Maybe<Insight_Texts>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "insight_reflect" */
export type Insight_ReflectInsight_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


/** columns and relationships of "insight_reflect" */
export type Insight_ReflectInsight_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


/** columns and relationships of "insight_reflect" */
export type Insight_ReflectInsight_Reflect_TextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


/** columns and relationships of "insight_reflect" */
export type Insight_ReflectInsight_Reflect_Texts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};

/** aggregated selection of "insight_reflect" */
export type Insight_Reflect_Aggregate = {
  __typename?: 'insight_reflect_aggregate';
  aggregate?: Maybe<Insight_Reflect_Aggregate_Fields>;
  nodes: Array<Insight_Reflect>;
};

export type Insight_Reflect_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Reflect_Aggregate_Bool_Exp_Count>;
};

export type Insight_Reflect_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Reflect_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_reflect" */
export type Insight_Reflect_Aggregate_Fields = {
  __typename?: 'insight_reflect_aggregate_fields';
  avg?: Maybe<Insight_Reflect_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Reflect_Max_Fields>;
  min?: Maybe<Insight_Reflect_Min_Fields>;
  stddev?: Maybe<Insight_Reflect_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Reflect_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Reflect_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Reflect_Sum_Fields>;
  var_pop?: Maybe<Insight_Reflect_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Reflect_Var_Samp_Fields>;
  variance?: Maybe<Insight_Reflect_Variance_Fields>;
};


/** aggregate fields of "insight_reflect" */
export type Insight_Reflect_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_reflect" */
export type Insight_Reflect_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Reflect_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Reflect_Max_Order_By>;
  min?: InputMaybe<Insight_Reflect_Min_Order_By>;
  stddev?: InputMaybe<Insight_Reflect_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Reflect_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Reflect_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Reflect_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Reflect_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Reflect_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Reflect_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_reflect" */
export type Insight_Reflect_Arr_Rel_Insert_Input = {
  data: Array<Insight_Reflect_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Reflect_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Reflect_Avg_Fields = {
  __typename?: 'insight_reflect_avg_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_reflect" */
export type Insight_Reflect_Avg_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_reflect". All fields are combined with a logical 'AND'. */
export type Insight_Reflect_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Reflect_Bool_Exp>>;
  _not?: InputMaybe<Insight_Reflect_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Reflect_Bool_Exp>>;
  heading?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_questions?: InputMaybe<Insight_Questions_Bool_Exp>;
  insight_questions_aggregate?: InputMaybe<Insight_Questions_Aggregate_Bool_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  insight_reflect_texts?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
  insight_reflect_texts_aggregate?: InputMaybe<Insight_Reflect_Text_Aggregate_Bool_Exp>;
  reflectHeading?: InputMaybe<Insight_Texts_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_reflect" */
export enum Insight_Reflect_Constraint {
  /** unique or primary key constraint on columns "heading", "insight_recipe_id" */
  InsightReflectInsightRecipeIdHeadingKey = 'insight_reflect_insight_recipe_id_heading_key',
  /** unique or primary key constraint on columns "id" */
  InsightReflectPkey = 'insight_reflect_pkey'
}

/** input type for incrementing numeric columns in table "insight_reflect" */
export type Insight_Reflect_Inc_Input = {
  heading?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_reflect" */
export type Insight_Reflect_Insert_Input = {
  heading?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_questions?: InputMaybe<Insight_Questions_Arr_Rel_Insert_Input>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_texts?: InputMaybe<Insight_Reflect_Text_Arr_Rel_Insert_Input>;
  reflectHeading?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Reflect_Max_Fields = {
  __typename?: 'insight_reflect_max_fields';
  heading?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_reflect" */
export type Insight_Reflect_Max_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Reflect_Min_Fields = {
  __typename?: 'insight_reflect_min_fields';
  heading?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_reflect" */
export type Insight_Reflect_Min_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_reflect" */
export type Insight_Reflect_Mutation_Response = {
  __typename?: 'insight_reflect_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Reflect>;
};

/** input type for inserting object relation for remote table "insight_reflect" */
export type Insight_Reflect_Obj_Rel_Insert_Input = {
  data: Insight_Reflect_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Reflect_On_Conflict>;
};

/** on_conflict condition type for table "insight_reflect" */
export type Insight_Reflect_On_Conflict = {
  constraint: Insight_Reflect_Constraint;
  update_columns?: Array<Insight_Reflect_Update_Column>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_reflect". */
export type Insight_Reflect_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_questions_aggregate?: InputMaybe<Insight_Questions_Aggregate_Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  insight_reflect_texts_aggregate?: InputMaybe<Insight_Reflect_Text_Aggregate_Order_By>;
  reflectHeading?: InputMaybe<Insight_Texts_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_reflect */
export type Insight_Reflect_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_reflect" */
export enum Insight_Reflect_Select_Column {
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_reflect" */
export type Insight_Reflect_Set_Input = {
  heading?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Reflect_Stddev_Fields = {
  __typename?: 'insight_reflect_stddev_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_reflect" */
export type Insight_Reflect_Stddev_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Reflect_Stddev_Pop_Fields = {
  __typename?: 'insight_reflect_stddev_pop_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_reflect" */
export type Insight_Reflect_Stddev_Pop_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Reflect_Stddev_Samp_Fields = {
  __typename?: 'insight_reflect_stddev_samp_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_reflect" */
export type Insight_Reflect_Stddev_Samp_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_reflect" */
export type Insight_Reflect_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Reflect_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Reflect_Stream_Cursor_Value_Input = {
  heading?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Reflect_Sum_Fields = {
  __typename?: 'insight_reflect_sum_fields';
  heading?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_reflect" */
export type Insight_Reflect_Sum_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_reflect_text" */
export type Insight_Reflect_Text = {
  __typename?: 'insight_reflect_text';
  content: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_reflect: Insight_Reflect;
  insight_reflect_id: Scalars['Int']['output'];
  /** An object relationship */
  insight_text: Insight_Texts;
};

/** aggregated selection of "insight_reflect_text" */
export type Insight_Reflect_Text_Aggregate = {
  __typename?: 'insight_reflect_text_aggregate';
  aggregate?: Maybe<Insight_Reflect_Text_Aggregate_Fields>;
  nodes: Array<Insight_Reflect_Text>;
};

export type Insight_Reflect_Text_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Reflect_Text_Aggregate_Bool_Exp_Count>;
};

export type Insight_Reflect_Text_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_reflect_text" */
export type Insight_Reflect_Text_Aggregate_Fields = {
  __typename?: 'insight_reflect_text_aggregate_fields';
  avg?: Maybe<Insight_Reflect_Text_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Reflect_Text_Max_Fields>;
  min?: Maybe<Insight_Reflect_Text_Min_Fields>;
  stddev?: Maybe<Insight_Reflect_Text_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Reflect_Text_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Reflect_Text_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Reflect_Text_Sum_Fields>;
  var_pop?: Maybe<Insight_Reflect_Text_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Reflect_Text_Var_Samp_Fields>;
  variance?: Maybe<Insight_Reflect_Text_Variance_Fields>;
};


/** aggregate fields of "insight_reflect_text" */
export type Insight_Reflect_Text_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_reflect_text" */
export type Insight_Reflect_Text_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Reflect_Text_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Reflect_Text_Max_Order_By>;
  min?: InputMaybe<Insight_Reflect_Text_Min_Order_By>;
  stddev?: InputMaybe<Insight_Reflect_Text_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Reflect_Text_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Reflect_Text_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Reflect_Text_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Reflect_Text_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Reflect_Text_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Reflect_Text_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_reflect_text" */
export type Insight_Reflect_Text_Arr_Rel_Insert_Input = {
  data: Array<Insight_Reflect_Text_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Reflect_Text_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Reflect_Text_Avg_Fields = {
  __typename?: 'insight_reflect_text_avg_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Avg_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_reflect_text". All fields are combined with a logical 'AND'. */
export type Insight_Reflect_Text_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Reflect_Text_Bool_Exp>>;
  _not?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Reflect_Text_Bool_Exp>>;
  content?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_reflect?: InputMaybe<Insight_Reflect_Bool_Exp>;
  insight_reflect_id?: InputMaybe<Int_Comparison_Exp>;
  insight_text?: InputMaybe<Insight_Texts_Bool_Exp>;
};

/** unique or primary key constraints on table "insight_reflect_text" */
export enum Insight_Reflect_Text_Constraint {
  /** unique or primary key constraint on columns "insight_reflect_id", "content" */
  InsightReflectTextInsightReflectIdContentKey = 'insight_reflect_text_insight_reflect_id_content_key',
  /** unique or primary key constraint on columns "id" */
  InsightReflectTextPkey = 'insight_reflect_text_pkey'
}

/** input type for incrementing numeric columns in table "insight_reflect_text" */
export type Insight_Reflect_Text_Inc_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_reflect_text" */
export type Insight_Reflect_Text_Insert_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect?: InputMaybe<Insight_Reflect_Obj_Rel_Insert_Input>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
  insight_text?: InputMaybe<Insight_Texts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Insight_Reflect_Text_Max_Fields = {
  __typename?: 'insight_reflect_text_max_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Reflect_Text_Min_Fields = {
  __typename?: 'insight_reflect_text_min_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_reflect_text" */
export type Insight_Reflect_Text_Mutation_Response = {
  __typename?: 'insight_reflect_text_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Reflect_Text>;
};

/** on_conflict condition type for table "insight_reflect_text" */
export type Insight_Reflect_Text_On_Conflict = {
  constraint: Insight_Reflect_Text_Constraint;
  update_columns?: Array<Insight_Reflect_Text_Update_Column>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_reflect_text". */
export type Insight_Reflect_Text_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect?: InputMaybe<Insight_Reflect_Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
  insight_text?: InputMaybe<Insight_Texts_Order_By>;
};

/** primary key columns input for table: insight_reflect_text */
export type Insight_Reflect_Text_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_reflect_text" */
export enum Insight_Reflect_Text_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  InsightReflectId = 'insight_reflect_id'
}

/** input type for updating data in table "insight_reflect_text" */
export type Insight_Reflect_Text_Set_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Reflect_Text_Stddev_Fields = {
  __typename?: 'insight_reflect_text_stddev_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Stddev_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Reflect_Text_Stddev_Pop_Fields = {
  __typename?: 'insight_reflect_text_stddev_pop_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Stddev_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Reflect_Text_Stddev_Samp_Fields = {
  __typename?: 'insight_reflect_text_stddev_samp_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Stddev_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_reflect_text" */
export type Insight_Reflect_Text_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Reflect_Text_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Reflect_Text_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_reflect_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Reflect_Text_Sum_Fields = {
  __typename?: 'insight_reflect_text_sum_fields';
  content?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_reflect_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Sum_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_reflect_text" */
export enum Insight_Reflect_Text_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  InsightReflectId = 'insight_reflect_id'
}

export type Insight_Reflect_Text_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Reflect_Text_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Reflect_Text_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Reflect_Text_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Reflect_Text_Var_Pop_Fields = {
  __typename?: 'insight_reflect_text_var_pop_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Var_Pop_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Reflect_Text_Var_Samp_Fields = {
  __typename?: 'insight_reflect_text_var_samp_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Var_Samp_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Reflect_Text_Variance_Fields = {
  __typename?: 'insight_reflect_text_variance_fields';
  content?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_reflect_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_reflect_text" */
export type Insight_Reflect_Text_Variance_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_reflect_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_reflect" */
export enum Insight_Reflect_Update_Column {
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Reflect_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Reflect_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Reflect_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Reflect_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Reflect_Var_Pop_Fields = {
  __typename?: 'insight_reflect_var_pop_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_reflect" */
export type Insight_Reflect_Var_Pop_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Reflect_Var_Samp_Fields = {
  __typename?: 'insight_reflect_var_samp_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_reflect" */
export type Insight_Reflect_Var_Samp_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Reflect_Variance_Fields = {
  __typename?: 'insight_reflect_variance_fields';
  heading?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_reflect" */
export type Insight_Reflect_Variance_Order_By = {
  heading?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_resources" */
export type Insight_Resources = {
  __typename?: 'insight_resources';
  direction: Enum_Feature_Direction_Enum;
  /** An object relationship */
  enum_feature_direction: Enum_Feature_Direction;
  /** An object relationship */
  enum_feature_type: Enum_Feature_Type;
  feature: Enum_Feature_Type_Enum;
  /** An object relationship */
  resource: Resources;
  resources_id: Scalars['Int']['output'];
};

/** aggregated selection of "insight_resources" */
export type Insight_Resources_Aggregate = {
  __typename?: 'insight_resources_aggregate';
  aggregate?: Maybe<Insight_Resources_Aggregate_Fields>;
  nodes: Array<Insight_Resources>;
};

export type Insight_Resources_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Resources_Aggregate_Bool_Exp_Count>;
};

export type Insight_Resources_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Resources_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_resources" */
export type Insight_Resources_Aggregate_Fields = {
  __typename?: 'insight_resources_aggregate_fields';
  avg?: Maybe<Insight_Resources_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Resources_Max_Fields>;
  min?: Maybe<Insight_Resources_Min_Fields>;
  stddev?: Maybe<Insight_Resources_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Resources_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Resources_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Resources_Sum_Fields>;
  var_pop?: Maybe<Insight_Resources_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Resources_Var_Samp_Fields>;
  variance?: Maybe<Insight_Resources_Variance_Fields>;
};


/** aggregate fields of "insight_resources" */
export type Insight_Resources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_resources" */
export type Insight_Resources_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Resources_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Resources_Max_Order_By>;
  min?: InputMaybe<Insight_Resources_Min_Order_By>;
  stddev?: InputMaybe<Insight_Resources_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Resources_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Resources_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Resources_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Resources_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Resources_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Resources_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_resources" */
export type Insight_Resources_Arr_Rel_Insert_Input = {
  data: Array<Insight_Resources_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Resources_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Resources_Avg_Fields = {
  __typename?: 'insight_resources_avg_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_resources" */
export type Insight_Resources_Avg_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_resources". All fields are combined with a logical 'AND'. */
export type Insight_Resources_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Resources_Bool_Exp>>;
  _not?: InputMaybe<Insight_Resources_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Resources_Bool_Exp>>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum_Comparison_Exp>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
  feature?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resources_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_resources" */
export enum Insight_Resources_Constraint {
  /** unique or primary key constraint on columns "resources_id", "feature", "direction" */
  InsightResourcesPkey = 'insight_resources_pkey'
}

/** input type for incrementing numeric columns in table "insight_resources" */
export type Insight_Resources_Inc_Input = {
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_resources" */
export type Insight_Resources_Insert_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Obj_Rel_Insert_Input>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Obj_Rel_Insert_Input>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Resources_Max_Fields = {
  __typename?: 'insight_resources_max_fields';
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_resources" */
export type Insight_Resources_Max_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Resources_Min_Fields = {
  __typename?: 'insight_resources_min_fields';
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_resources" */
export type Insight_Resources_Min_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_resources" */
export type Insight_Resources_Mutation_Response = {
  __typename?: 'insight_resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Resources>;
};

/** on_conflict condition type for table "insight_resources" */
export type Insight_Resources_On_Conflict = {
  constraint: Insight_Resources_Constraint;
  update_columns?: Array<Insight_Resources_Update_Column>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_resources". */
export type Insight_Resources_Order_By = {
  direction?: InputMaybe<Order_By>;
  enum_feature_direction?: InputMaybe<Enum_Feature_Direction_Order_By>;
  enum_feature_type?: InputMaybe<Enum_Feature_Type_Order_By>;
  feature?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_resources */
export type Insight_Resources_Pk_Columns_Input = {
  direction: Enum_Feature_Direction_Enum;
  feature: Enum_Feature_Type_Enum;
  resources_id: Scalars['Int']['input'];
};

/** select columns of table "insight_resources" */
export enum Insight_Resources_Select_Column {
  /** column name */
  Direction = 'direction',
  /** column name */
  Feature = 'feature',
  /** column name */
  ResourcesId = 'resources_id'
}

/** input type for updating data in table "insight_resources" */
export type Insight_Resources_Set_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Resources_Stddev_Fields = {
  __typename?: 'insight_resources_stddev_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_resources" */
export type Insight_Resources_Stddev_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Resources_Stddev_Pop_Fields = {
  __typename?: 'insight_resources_stddev_pop_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_resources" */
export type Insight_Resources_Stddev_Pop_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Resources_Stddev_Samp_Fields = {
  __typename?: 'insight_resources_stddev_samp_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_resources" */
export type Insight_Resources_Stddev_Samp_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_resources" */
export type Insight_Resources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Resources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Resources_Stream_Cursor_Value_Input = {
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Resources_Sum_Fields = {
  __typename?: 'insight_resources_sum_fields';
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_resources" */
export type Insight_Resources_Sum_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_resources" */
export enum Insight_Resources_Update_Column {
  /** column name */
  Direction = 'direction',
  /** column name */
  Feature = 'feature',
  /** column name */
  ResourcesId = 'resources_id'
}

export type Insight_Resources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Resources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Resources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Resources_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Resources_Var_Pop_Fields = {
  __typename?: 'insight_resources_var_pop_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_resources" */
export type Insight_Resources_Var_Pop_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Resources_Var_Samp_Fields = {
  __typename?: 'insight_resources_var_samp_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_resources" */
export type Insight_Resources_Var_Samp_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Resources_Variance_Fields = {
  __typename?: 'insight_resources_variance_fields';
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_resources" */
export type Insight_Resources_Variance_Order_By = {
  resources_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "insight_texts" */
export type Insight_Texts = {
  __typename?: 'insight_texts';
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageURL?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  insight_plan?: Maybe<Insight_Plans>;
  /** An array relationship */
  planResponse: Array<Insight_Plans>;
  /** An aggregate relationship */
  planResponse_aggregate: Insight_Plans_Aggregate;
  /** An array relationship */
  planTexts: Array<Insight_Plan_Text>;
  /** An aggregate relationship */
  planTexts_aggregate: Insight_Plan_Text_Aggregate;
  /** An array relationship */
  recipeObserve: Array<Insight_Recipes>;
  /** An aggregate relationship */
  recipeObserve_aggregate: Insight_Recipes_Aggregate;
  /** An array relationship */
  recipePlan: Array<Insight_Recipes>;
  /** An aggregate relationship */
  recipePlan_aggregate: Insight_Recipes_Aggregate;
  /** An array relationship */
  recipeReflect: Array<Insight_Recipes>;
  /** An aggregate relationship */
  recipeReflect_aggregate: Insight_Recipes_Aggregate;
  /** An object relationship */
  reflectHeading?: Maybe<Insight_Reflect>;
  /** An array relationship */
  reflectTexts: Array<Insight_Reflect_Text>;
  /** An aggregate relationship */
  reflectTexts_aggregate: Insight_Reflect_Text_Aggregate;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsPlanResponseArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsPlanResponse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsPlanTextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsPlanTexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipeObserveArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipeObserve_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipePlanArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipePlan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipeReflectArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsRecipeReflect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsReflectTextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


/** columns and relationships of "insight_texts" */
export type Insight_TextsReflectTexts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};

/** aggregated selection of "insight_texts" */
export type Insight_Texts_Aggregate = {
  __typename?: 'insight_texts_aggregate';
  aggregate?: Maybe<Insight_Texts_Aggregate_Fields>;
  nodes: Array<Insight_Texts>;
};

/** aggregate fields of "insight_texts" */
export type Insight_Texts_Aggregate_Fields = {
  __typename?: 'insight_texts_aggregate_fields';
  avg?: Maybe<Insight_Texts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Texts_Max_Fields>;
  min?: Maybe<Insight_Texts_Min_Fields>;
  stddev?: Maybe<Insight_Texts_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Texts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Texts_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Texts_Sum_Fields>;
  var_pop?: Maybe<Insight_Texts_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Texts_Var_Samp_Fields>;
  variance?: Maybe<Insight_Texts_Variance_Fields>;
};


/** aggregate fields of "insight_texts" */
export type Insight_Texts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Texts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Insight_Texts_Avg_Fields = {
  __typename?: 'insight_texts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "insight_texts". All fields are combined with a logical 'AND'. */
export type Insight_Texts_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Texts_Bool_Exp>>;
  _not?: InputMaybe<Insight_Texts_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Texts_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imageURL?: InputMaybe<String_Comparison_Exp>;
  insight_plan?: InputMaybe<Insight_Plans_Bool_Exp>;
  planResponse?: InputMaybe<Insight_Plans_Bool_Exp>;
  planResponse_aggregate?: InputMaybe<Insight_Plans_Aggregate_Bool_Exp>;
  planTexts?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
  planTexts_aggregate?: InputMaybe<Insight_Plan_Text_Aggregate_Bool_Exp>;
  recipeObserve?: InputMaybe<Insight_Recipes_Bool_Exp>;
  recipeObserve_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp>;
  recipePlan?: InputMaybe<Insight_Recipes_Bool_Exp>;
  recipePlan_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp>;
  recipeReflect?: InputMaybe<Insight_Recipes_Bool_Exp>;
  recipeReflect_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Bool_Exp>;
  reflectHeading?: InputMaybe<Insight_Reflect_Bool_Exp>;
  reflectTexts?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
  reflectTexts_aggregate?: InputMaybe<Insight_Reflect_Text_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "insight_texts" */
export enum Insight_Texts_Constraint {
  /** unique or primary key constraint on columns "content" */
  InsightTextsContentKey = 'insight_texts_content_key',
  /** unique or primary key constraint on columns "id" */
  InsightTextsPkey = 'insight_texts_pkey'
}

/** input type for incrementing numeric columns in table "insight_texts" */
export type Insight_Texts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_texts" */
export type Insight_Texts_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  insight_plan?: InputMaybe<Insight_Plans_Obj_Rel_Insert_Input>;
  planResponse?: InputMaybe<Insight_Plans_Arr_Rel_Insert_Input>;
  planTexts?: InputMaybe<Insight_Plan_Text_Arr_Rel_Insert_Input>;
  recipeObserve?: InputMaybe<Insight_Recipes_Arr_Rel_Insert_Input>;
  recipePlan?: InputMaybe<Insight_Recipes_Arr_Rel_Insert_Input>;
  recipeReflect?: InputMaybe<Insight_Recipes_Arr_Rel_Insert_Input>;
  reflectHeading?: InputMaybe<Insight_Reflect_Obj_Rel_Insert_Input>;
  reflectTexts?: InputMaybe<Insight_Reflect_Text_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Insight_Texts_Max_Fields = {
  __typename?: 'insight_texts_max_fields';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Insight_Texts_Min_Fields = {
  __typename?: 'insight_texts_min_fields';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageURL?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "insight_texts" */
export type Insight_Texts_Mutation_Response = {
  __typename?: 'insight_texts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Texts>;
};

/** input type for inserting object relation for remote table "insight_texts" */
export type Insight_Texts_Obj_Rel_Insert_Input = {
  data: Insight_Texts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Texts_On_Conflict>;
};

/** on_conflict condition type for table "insight_texts" */
export type Insight_Texts_On_Conflict = {
  constraint: Insight_Texts_Constraint;
  update_columns?: Array<Insight_Texts_Update_Column>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_texts". */
export type Insight_Texts_Order_By = {
  content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageURL?: InputMaybe<Order_By>;
  insight_plan?: InputMaybe<Insight_Plans_Order_By>;
  planResponse_aggregate?: InputMaybe<Insight_Plans_Aggregate_Order_By>;
  planTexts_aggregate?: InputMaybe<Insight_Plan_Text_Aggregate_Order_By>;
  recipeObserve_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Order_By>;
  recipePlan_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Order_By>;
  recipeReflect_aggregate?: InputMaybe<Insight_Recipes_Aggregate_Order_By>;
  reflectHeading?: InputMaybe<Insight_Reflect_Order_By>;
  reflectTexts_aggregate?: InputMaybe<Insight_Reflect_Text_Aggregate_Order_By>;
};

/** primary key columns input for table: insight_texts */
export type Insight_Texts_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_texts" */
export enum Insight_Texts_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageURL'
}

/** input type for updating data in table "insight_texts" */
export type Insight_Texts_Set_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Texts_Stddev_Fields = {
  __typename?: 'insight_texts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Insight_Texts_Stddev_Pop_Fields = {
  __typename?: 'insight_texts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Insight_Texts_Stddev_Samp_Fields = {
  __typename?: 'insight_texts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "insight_texts" */
export type Insight_Texts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Texts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Texts_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Insight_Texts_Sum_Fields = {
  __typename?: 'insight_texts_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "insight_texts" */
export enum Insight_Texts_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageURL'
}

export type Insight_Texts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Texts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Texts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Texts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Texts_Var_Pop_Fields = {
  __typename?: 'insight_texts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Insight_Texts_Var_Samp_Fields = {
  __typename?: 'insight_texts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Insight_Texts_Variance_Fields = {
  __typename?: 'insight_texts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "insight_tips" */
export type Insight_Tips = {
  __typename?: 'insight_tips';
  id: Scalars['Int']['output'];
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "insight_tips" */
export type Insight_Tips_Aggregate = {
  __typename?: 'insight_tips_aggregate';
  aggregate?: Maybe<Insight_Tips_Aggregate_Fields>;
  nodes: Array<Insight_Tips>;
};

/** aggregate fields of "insight_tips" */
export type Insight_Tips_Aggregate_Fields = {
  __typename?: 'insight_tips_aggregate_fields';
  avg?: Maybe<Insight_Tips_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Tips_Max_Fields>;
  min?: Maybe<Insight_Tips_Min_Fields>;
  stddev?: Maybe<Insight_Tips_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Tips_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Tips_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Tips_Sum_Fields>;
  var_pop?: Maybe<Insight_Tips_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Tips_Var_Samp_Fields>;
  variance?: Maybe<Insight_Tips_Variance_Fields>;
};


/** aggregate fields of "insight_tips" */
export type Insight_Tips_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Tips_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Insight_Tips_Avg_Fields = {
  __typename?: 'insight_tips_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "insight_tips". All fields are combined with a logical 'AND'. */
export type Insight_Tips_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Tips_Bool_Exp>>;
  _not?: InputMaybe<Insight_Tips_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Tips_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_why_id?: InputMaybe<Int_Comparison_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_tips" */
export enum Insight_Tips_Constraint {
  /** unique or primary key constraint on columns "id" */
  InsightTipsPkey = 'insight_tips_pkey'
}

/** input type for incrementing numeric columns in table "insight_tips" */
export type Insight_Tips_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_tips" */
export type Insight_Tips_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Tips_Max_Fields = {
  __typename?: 'insight_tips_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Insight_Tips_Min_Fields = {
  __typename?: 'insight_tips_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "insight_tips" */
export type Insight_Tips_Mutation_Response = {
  __typename?: 'insight_tips_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Tips>;
};

/** on_conflict condition type for table "insight_tips" */
export type Insight_Tips_On_Conflict = {
  constraint: Insight_Tips_Constraint;
  update_columns?: Array<Insight_Tips_Update_Column>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_tips". */
export type Insight_Tips_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_why_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_tips */
export type Insight_Tips_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_tips" */
export enum Insight_Tips_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightWhyId = 'insight_why_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_tips" */
export type Insight_Tips_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Tips_Stddev_Fields = {
  __typename?: 'insight_tips_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Insight_Tips_Stddev_Pop_Fields = {
  __typename?: 'insight_tips_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Insight_Tips_Stddev_Samp_Fields = {
  __typename?: 'insight_tips_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "insight_tips" */
export type Insight_Tips_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Tips_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Tips_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_why_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Tips_Sum_Fields = {
  __typename?: 'insight_tips_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_why_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "insight_tips" */
export enum Insight_Tips_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightWhyId = 'insight_why_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Tips_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Tips_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Tips_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Tips_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Tips_Var_Pop_Fields = {
  __typename?: 'insight_tips_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Insight_Tips_Var_Samp_Fields = {
  __typename?: 'insight_tips_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Insight_Tips_Variance_Fields = {
  __typename?: 'insight_tips_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_why_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "insight_whys" */
export type Insight_Whys = {
  __typename?: 'insight_whys';
  id: Scalars['Int']['output'];
  /** An object relationship */
  insight_recipe: Insight_Recipes;
  insight_recipe_id: Scalars['Int']['output'];
  /** An object relationship */
  resource?: Maybe<Resources>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "insight_whys" */
export type Insight_Whys_Aggregate = {
  __typename?: 'insight_whys_aggregate';
  aggregate?: Maybe<Insight_Whys_Aggregate_Fields>;
  nodes: Array<Insight_Whys>;
};

export type Insight_Whys_Aggregate_Bool_Exp = {
  count?: InputMaybe<Insight_Whys_Aggregate_Bool_Exp_Count>;
};

export type Insight_Whys_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Insight_Whys_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "insight_whys" */
export type Insight_Whys_Aggregate_Fields = {
  __typename?: 'insight_whys_aggregate_fields';
  avg?: Maybe<Insight_Whys_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Insight_Whys_Max_Fields>;
  min?: Maybe<Insight_Whys_Min_Fields>;
  stddev?: Maybe<Insight_Whys_Stddev_Fields>;
  stddev_pop?: Maybe<Insight_Whys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Insight_Whys_Stddev_Samp_Fields>;
  sum?: Maybe<Insight_Whys_Sum_Fields>;
  var_pop?: Maybe<Insight_Whys_Var_Pop_Fields>;
  var_samp?: Maybe<Insight_Whys_Var_Samp_Fields>;
  variance?: Maybe<Insight_Whys_Variance_Fields>;
};


/** aggregate fields of "insight_whys" */
export type Insight_Whys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "insight_whys" */
export type Insight_Whys_Aggregate_Order_By = {
  avg?: InputMaybe<Insight_Whys_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Insight_Whys_Max_Order_By>;
  min?: InputMaybe<Insight_Whys_Min_Order_By>;
  stddev?: InputMaybe<Insight_Whys_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Insight_Whys_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Insight_Whys_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Insight_Whys_Sum_Order_By>;
  var_pop?: InputMaybe<Insight_Whys_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Insight_Whys_Var_Samp_Order_By>;
  variance?: InputMaybe<Insight_Whys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "insight_whys" */
export type Insight_Whys_Arr_Rel_Insert_Input = {
  data: Array<Insight_Whys_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Insight_Whys_On_Conflict>;
};

/** aggregate avg on columns */
export type Insight_Whys_Avg_Fields = {
  __typename?: 'insight_whys_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "insight_whys" */
export type Insight_Whys_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "insight_whys". All fields are combined with a logical 'AND'. */
export type Insight_Whys_Bool_Exp = {
  _and?: InputMaybe<Array<Insight_Whys_Bool_Exp>>;
  _not?: InputMaybe<Insight_Whys_Bool_Exp>;
  _or?: InputMaybe<Array<Insight_Whys_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_recipe_id?: InputMaybe<Int_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "insight_whys" */
export enum Insight_Whys_Constraint {
  /** unique or primary key constraint on columns "id" */
  InsightWhysPkey = 'insight_whys_pkey'
}

/** input type for incrementing numeric columns in table "insight_whys" */
export type Insight_Whys_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "insight_whys" */
export type Insight_Whys_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Insight_Whys_Max_Fields = {
  __typename?: 'insight_whys_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "insight_whys" */
export type Insight_Whys_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Insight_Whys_Min_Fields = {
  __typename?: 'insight_whys_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "insight_whys" */
export type Insight_Whys_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "insight_whys" */
export type Insight_Whys_Mutation_Response = {
  __typename?: 'insight_whys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Insight_Whys>;
};

/** on_conflict condition type for table "insight_whys" */
export type Insight_Whys_On_Conflict = {
  constraint: Insight_Whys_Constraint;
  update_columns?: Array<Insight_Whys_Update_Column>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};

/** Ordering options when selecting data from "insight_whys". */
export type Insight_Whys_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: insight_whys */
export type Insight_Whys_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "insight_whys" */
export enum Insight_Whys_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

/** input type for updating data in table "insight_whys" */
export type Insight_Whys_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Insight_Whys_Stddev_Fields = {
  __typename?: 'insight_whys_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "insight_whys" */
export type Insight_Whys_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Insight_Whys_Stddev_Pop_Fields = {
  __typename?: 'insight_whys_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "insight_whys" */
export type Insight_Whys_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Insight_Whys_Stddev_Samp_Fields = {
  __typename?: 'insight_whys_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "insight_whys" */
export type Insight_Whys_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "insight_whys" */
export type Insight_Whys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Insight_Whys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Insight_Whys_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Insight_Whys_Sum_Fields = {
  __typename?: 'insight_whys_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_recipe_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "insight_whys" */
export type Insight_Whys_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** update columns of table "insight_whys" */
export enum Insight_Whys_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InsightRecipeId = 'insight_recipe_id',
  /** column name */
  ResourceId = 'resource_id'
}

export type Insight_Whys_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Insight_Whys_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Insight_Whys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Insight_Whys_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Insight_Whys_Var_Pop_Fields = {
  __typename?: 'insight_whys_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "insight_whys" */
export type Insight_Whys_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Insight_Whys_Var_Samp_Fields = {
  __typename?: 'insight_whys_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "insight_whys" */
export type Insight_Whys_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Insight_Whys_Variance_Fields = {
  __typename?: 'insight_whys_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_recipe_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "insight_whys" */
export type Insight_Whys_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_recipe_id?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "invite_codes" */
export type Invite_Codes = {
  __typename?: 'invite_codes';
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  client_id: Scalars['uuid']['output'];
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at_tz?: Maybe<Scalars['timestamptz']['output']>;
  ended_on?: Maybe<Scalars['date']['output']>;
  expiration_code?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['Int']['output'];
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userByPractitionerId?: Maybe<Users>;
};

/** aggregated selection of "invite_codes" */
export type Invite_Codes_Aggregate = {
  __typename?: 'invite_codes_aggregate';
  aggregate?: Maybe<Invite_Codes_Aggregate_Fields>;
  nodes: Array<Invite_Codes>;
};

export type Invite_Codes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invite_Codes_Aggregate_Bool_Exp_Count>;
};

export type Invite_Codes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invite_Codes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invite_codes" */
export type Invite_Codes_Aggregate_Fields = {
  __typename?: 'invite_codes_aggregate_fields';
  avg?: Maybe<Invite_Codes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invite_Codes_Max_Fields>;
  min?: Maybe<Invite_Codes_Min_Fields>;
  stddev?: Maybe<Invite_Codes_Stddev_Fields>;
  stddev_pop?: Maybe<Invite_Codes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invite_Codes_Stddev_Samp_Fields>;
  sum?: Maybe<Invite_Codes_Sum_Fields>;
  var_pop?: Maybe<Invite_Codes_Var_Pop_Fields>;
  var_samp?: Maybe<Invite_Codes_Var_Samp_Fields>;
  variance?: Maybe<Invite_Codes_Variance_Fields>;
};


/** aggregate fields of "invite_codes" */
export type Invite_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invite_codes" */
export type Invite_Codes_Aggregate_Order_By = {
  avg?: InputMaybe<Invite_Codes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invite_Codes_Max_Order_By>;
  min?: InputMaybe<Invite_Codes_Min_Order_By>;
  stddev?: InputMaybe<Invite_Codes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invite_Codes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invite_Codes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invite_Codes_Sum_Order_By>;
  var_pop?: InputMaybe<Invite_Codes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invite_Codes_Var_Samp_Order_By>;
  variance?: InputMaybe<Invite_Codes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "invite_codes" */
export type Invite_Codes_Arr_Rel_Insert_Input = {
  data: Array<Invite_Codes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invite_Codes_On_Conflict>;
};

/** aggregate avg on columns */
export type Invite_Codes_Avg_Fields = {
  __typename?: 'invite_codes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invite_codes" */
export type Invite_Codes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invite_codes". All fields are combined with a logical 'AND'. */
export type Invite_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Invite_Codes_Bool_Exp>>;
  _not?: InputMaybe<Invite_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Invite_Codes_Bool_Exp>>;
  claimed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ended_at_tz?: InputMaybe<Timestamptz_Comparison_Exp>;
  ended_on?: InputMaybe<Date_Comparison_Exp>;
  expiration_code?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userByPractitionerId?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "invite_codes" */
export enum Invite_Codes_Constraint {
  /** unique or primary key constraint on columns "practitioner_id", "client_id" */
  InviteCodesClientIdPractitionerIdKey = 'invite_codes_client_id_practitioner_id_key',
  /** unique or primary key constraint on columns "code", "expiration_code" */
  InviteCodesCodeExpirationCodeKey = 'invite_codes_code_expiration_code_key',
  /** unique or primary key constraint on columns "id" */
  InviteCodesPkey = 'invite_codes_pkey'
}

/** input type for incrementing numeric columns in table "invite_codes" */
export type Invite_Codes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "invite_codes" */
export type Invite_Codes_Insert_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  expiration_code?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userByPractitionerId?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Invite_Codes_Max_Fields = {
  __typename?: 'invite_codes_max_fields';
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at_tz?: Maybe<Scalars['timestamptz']['output']>;
  ended_on?: Maybe<Scalars['date']['output']>;
  expiration_code?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "invite_codes" */
export type Invite_Codes_Max_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  ended_at_tz?: InputMaybe<Order_By>;
  ended_on?: InputMaybe<Order_By>;
  expiration_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invite_Codes_Min_Fields = {
  __typename?: 'invite_codes_min_fields';
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at_tz?: Maybe<Scalars['timestamptz']['output']>;
  ended_on?: Maybe<Scalars['date']['output']>;
  expiration_code?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "invite_codes" */
export type Invite_Codes_Min_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  ended_at_tz?: InputMaybe<Order_By>;
  ended_on?: InputMaybe<Order_By>;
  expiration_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invite_codes" */
export type Invite_Codes_Mutation_Response = {
  __typename?: 'invite_codes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite_Codes>;
};

/** on_conflict condition type for table "invite_codes" */
export type Invite_Codes_On_Conflict = {
  constraint: Invite_Codes_Constraint;
  update_columns?: Array<Invite_Codes_Update_Column>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};

/** Ordering options when selecting data from "invite_codes". */
export type Invite_Codes_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  client_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  ended_at_tz?: InputMaybe<Order_By>;
  ended_on?: InputMaybe<Order_By>;
  expiration_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userByPractitionerId?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: invite_codes */
export type Invite_Codes_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "invite_codes" */
export enum Invite_Codes_Select_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  EndedAtTz = 'ended_at_tz',
  /** column name */
  EndedOn = 'ended_on',
  /** column name */
  ExpirationCode = 'expiration_code',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "invite_codes" */
export type Invite_Codes_Set_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  expiration_code?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Invite_Codes_Stddev_Fields = {
  __typename?: 'invite_codes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invite_codes" */
export type Invite_Codes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invite_Codes_Stddev_Pop_Fields = {
  __typename?: 'invite_codes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invite_codes" */
export type Invite_Codes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invite_Codes_Stddev_Samp_Fields = {
  __typename?: 'invite_codes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invite_codes" */
export type Invite_Codes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invite_codes" */
export type Invite_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invite_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invite_Codes_Stream_Cursor_Value_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at_tz?: InputMaybe<Scalars['timestamptz']['input']>;
  ended_on?: InputMaybe<Scalars['date']['input']>;
  expiration_code?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Invite_Codes_Sum_Fields = {
  __typename?: 'invite_codes_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "invite_codes" */
export type Invite_Codes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "invite_codes" */
export enum Invite_Codes_Update_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  ExpirationCode = 'expiration_code',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  Status = 'status'
}

export type Invite_Codes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invite_Codes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Codes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invite_Codes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invite_Codes_Var_Pop_Fields = {
  __typename?: 'invite_codes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invite_codes" */
export type Invite_Codes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invite_Codes_Var_Samp_Fields = {
  __typename?: 'invite_codes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invite_codes" */
export type Invite_Codes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invite_Codes_Variance_Fields = {
  __typename?: 'invite_codes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invite_codes" */
export type Invite_Codes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'logs';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "logs" */
export type Logs_Aggregate = {
  __typename?: 'logs_aggregate';
  aggregate?: Maybe<Logs_Aggregate_Fields>;
  nodes: Array<Logs>;
};

export type Logs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Logs_Aggregate_Bool_Exp_Count>;
};

export type Logs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Logs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "logs" */
export type Logs_Aggregate_Fields = {
  __typename?: 'logs_aggregate_fields';
  avg?: Maybe<Logs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Logs_Max_Fields>;
  min?: Maybe<Logs_Min_Fields>;
  stddev?: Maybe<Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Logs_Sum_Fields>;
  var_pop?: Maybe<Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Logs_Var_Samp_Fields>;
  variance?: Maybe<Logs_Variance_Fields>;
};


/** aggregate fields of "logs" */
export type Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "logs" */
export type Logs_Aggregate_Order_By = {
  avg?: InputMaybe<Logs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Logs_Max_Order_By>;
  min?: InputMaybe<Logs_Min_Order_By>;
  stddev?: InputMaybe<Logs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Logs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Logs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Logs_Sum_Order_By>;
  var_pop?: InputMaybe<Logs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Logs_Var_Samp_Order_By>;
  variance?: InputMaybe<Logs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "logs" */
export type Logs_Arr_Rel_Insert_Input = {
  data: Array<Logs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};

/** aggregate avg on columns */
export type Logs_Avg_Fields = {
  __typename?: 'logs_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "logs" */
export type Logs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Logs_Bool_Exp>>;
  _not?: InputMaybe<Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Logs_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs" */
export enum Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogsPkey = 'logs_pkey'
}

/** input type for incrementing numeric columns in table "logs" */
export type Logs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "logs" */
export type Logs_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Logs_Max_Fields = {
  __typename?: 'logs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "logs" */
export type Logs_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Logs_Min_Fields = {
  __typename?: 'logs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "logs" */
export type Logs_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "logs" */
export type Logs_Mutation_Response = {
  __typename?: 'logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs>;
};

/** on_conflict condition type for table "logs" */
export type Logs_On_Conflict = {
  constraint: Logs_Constraint;
  update_columns?: Array<Logs_Update_Column>;
  where?: InputMaybe<Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "logs". */
export type Logs_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: logs */
export type Logs_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "logs" */
export enum Logs_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "logs" */
export type Logs_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Logs_Stddev_Fields = {
  __typename?: 'logs_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "logs" */
export type Logs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Logs_Stddev_Pop_Fields = {
  __typename?: 'logs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "logs" */
export type Logs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Logs_Stddev_Samp_Fields = {
  __typename?: 'logs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "logs" */
export type Logs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "logs" */
export type Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Logs_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Logs_Sum_Fields = {
  __typename?: 'logs_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "logs" */
export type Logs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "logs" */
export enum Logs_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Logs_Var_Pop_Fields = {
  __typename?: 'logs_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "logs" */
export type Logs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Logs_Var_Samp_Fields = {
  __typename?: 'logs_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "logs" */
export type Logs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Logs_Variance_Fields = {
  __typename?: 'logs_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "logs" */
export type Logs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mobile_device_data" */
export type Mobile_Device_Data = {
  __typename?: 'mobile_device_data';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  devicePermissionsByUser: Array<Mobile_Permissions>;
  /** An aggregate relationship */
  devicePermissionsByUser_aggregate: Mobile_Permissions_Aggregate;
  device_make: Scalars['String']['output'];
  device_model: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  os_version: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "mobile_device_data" */
export type Mobile_Device_DataDevicePermissionsByUserArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


/** columns and relationships of "mobile_device_data" */
export type Mobile_Device_DataDevicePermissionsByUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};

/** aggregated selection of "mobile_device_data" */
export type Mobile_Device_Data_Aggregate = {
  __typename?: 'mobile_device_data_aggregate';
  aggregate?: Maybe<Mobile_Device_Data_Aggregate_Fields>;
  nodes: Array<Mobile_Device_Data>;
};

export type Mobile_Device_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mobile_Device_Data_Aggregate_Bool_Exp_Count>;
};

export type Mobile_Device_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mobile_device_data" */
export type Mobile_Device_Data_Aggregate_Fields = {
  __typename?: 'mobile_device_data_aggregate_fields';
  avg?: Maybe<Mobile_Device_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mobile_Device_Data_Max_Fields>;
  min?: Maybe<Mobile_Device_Data_Min_Fields>;
  stddev?: Maybe<Mobile_Device_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Mobile_Device_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mobile_Device_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Mobile_Device_Data_Sum_Fields>;
  var_pop?: Maybe<Mobile_Device_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Mobile_Device_Data_Var_Samp_Fields>;
  variance?: Maybe<Mobile_Device_Data_Variance_Fields>;
};


/** aggregate fields of "mobile_device_data" */
export type Mobile_Device_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mobile_device_data" */
export type Mobile_Device_Data_Aggregate_Order_By = {
  avg?: InputMaybe<Mobile_Device_Data_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mobile_Device_Data_Max_Order_By>;
  min?: InputMaybe<Mobile_Device_Data_Min_Order_By>;
  stddev?: InputMaybe<Mobile_Device_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mobile_Device_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mobile_Device_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mobile_Device_Data_Sum_Order_By>;
  var_pop?: InputMaybe<Mobile_Device_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mobile_Device_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<Mobile_Device_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mobile_device_data" */
export type Mobile_Device_Data_Arr_Rel_Insert_Input = {
  data: Array<Mobile_Device_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mobile_Device_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Mobile_Device_Data_Avg_Fields = {
  __typename?: 'mobile_device_data_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mobile_device_data". All fields are combined with a logical 'AND'. */
export type Mobile_Device_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Device_Data_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Device_Data_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  devicePermissionsByUser?: InputMaybe<Mobile_Permissions_Bool_Exp>;
  devicePermissionsByUser_aggregate?: InputMaybe<Mobile_Permissions_Aggregate_Bool_Exp>;
  device_make?: InputMaybe<String_Comparison_Exp>;
  device_model?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  os_version?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "mobile_device_data" */
export enum Mobile_Device_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  MobileDeviceDataPkey = 'mobile_device_data_pkey'
}

/** input type for incrementing numeric columns in table "mobile_device_data" */
export type Mobile_Device_Data_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mobile_device_data" */
export type Mobile_Device_Data_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  devicePermissionsByUser?: InputMaybe<Mobile_Permissions_Arr_Rel_Insert_Input>;
  device_make?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mobile_Device_Data_Max_Fields = {
  __typename?: 'mobile_device_data_max_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_make?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_make?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mobile_Device_Data_Min_Fields = {
  __typename?: 'mobile_device_data_min_fields';
  app_version?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_make?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  os_version?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_make?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mobile_device_data" */
export type Mobile_Device_Data_Mutation_Response = {
  __typename?: 'mobile_device_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mobile_Device_Data>;
};

/** on_conflict condition type for table "mobile_device_data" */
export type Mobile_Device_Data_On_Conflict = {
  constraint: Mobile_Device_Data_Constraint;
  update_columns?: Array<Mobile_Device_Data_Update_Column>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "mobile_device_data". */
export type Mobile_Device_Data_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  devicePermissionsByUser_aggregate?: InputMaybe<Mobile_Permissions_Aggregate_Order_By>;
  device_make?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mobile_device_data */
export type Mobile_Device_Data_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "mobile_device_data" */
export enum Mobile_Device_Data_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceMake = 'device_make',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  Id = 'id',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "mobile_device_data" */
export type Mobile_Device_Data_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_make?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Mobile_Device_Data_Stddev_Fields = {
  __typename?: 'mobile_device_data_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mobile_Device_Data_Stddev_Pop_Fields = {
  __typename?: 'mobile_device_data_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mobile_Device_Data_Stddev_Samp_Fields = {
  __typename?: 'mobile_device_data_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mobile_device_data" */
export type Mobile_Device_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Device_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Device_Data_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_make?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Mobile_Device_Data_Sum_Fields = {
  __typename?: 'mobile_device_data_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "mobile_device_data" */
export enum Mobile_Device_Data_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceMake = 'device_make',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  Id = 'id',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Mobile_Device_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mobile_Device_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mobile_Device_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mobile_Device_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mobile_Device_Data_Var_Pop_Fields = {
  __typename?: 'mobile_device_data_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mobile_Device_Data_Var_Samp_Fields = {
  __typename?: 'mobile_device_data_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mobile_Device_Data_Variance_Fields = {
  __typename?: 'mobile_device_data_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mobile_device_data" */
export type Mobile_Device_Data_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "mobile_permissions" */
export type Mobile_Permissions = {
  __typename?: 'mobile_permissions';
  client_created_at: Scalars['timestamp']['output'];
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mobile_permissions_user: Users;
  permission_status: Enum_Mobile_Permission_Status_Enum;
  permission_type: Enum_Mobile_Permission_Type_Enum;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "mobile_permissions" */
export type Mobile_Permissions_Aggregate = {
  __typename?: 'mobile_permissions_aggregate';
  aggregate?: Maybe<Mobile_Permissions_Aggregate_Fields>;
  nodes: Array<Mobile_Permissions>;
};

export type Mobile_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mobile_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Mobile_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mobile_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mobile_permissions" */
export type Mobile_Permissions_Aggregate_Fields = {
  __typename?: 'mobile_permissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Mobile_Permissions_Max_Fields>;
  min?: Maybe<Mobile_Permissions_Min_Fields>;
};


/** aggregate fields of "mobile_permissions" */
export type Mobile_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mobile_permissions" */
export type Mobile_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mobile_Permissions_Max_Order_By>;
  min?: InputMaybe<Mobile_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "mobile_permissions" */
export type Mobile_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Mobile_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mobile_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mobile_permissions". All fields are combined with a logical 'AND'. */
export type Mobile_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Permissions_Bool_Exp>>;
  client_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile_permissions_user?: InputMaybe<Users_Bool_Exp>;
  permission_status?: InputMaybe<Enum_Mobile_Permission_Status_Enum_Comparison_Exp>;
  permission_type?: InputMaybe<Enum_Mobile_Permission_Type_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "mobile_permissions" */
export enum Mobile_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  MobilePermissionsPkey = 'mobile_permissions_pkey'
}

/** input type for inserting data into table "mobile_permissions" */
export type Mobile_Permissions_Insert_Input = {
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mobile_permissions_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  permission_status?: InputMaybe<Enum_Mobile_Permission_Status_Enum>;
  permission_type?: InputMaybe<Enum_Mobile_Permission_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mobile_Permissions_Max_Fields = {
  __typename?: 'mobile_permissions_max_fields';
  client_created_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "mobile_permissions" */
export type Mobile_Permissions_Max_Order_By = {
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mobile_Permissions_Min_Fields = {
  __typename?: 'mobile_permissions_min_fields';
  client_created_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "mobile_permissions" */
export type Mobile_Permissions_Min_Order_By = {
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mobile_permissions" */
export type Mobile_Permissions_Mutation_Response = {
  __typename?: 'mobile_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mobile_Permissions>;
};

/** on_conflict condition type for table "mobile_permissions" */
export type Mobile_Permissions_On_Conflict = {
  constraint: Mobile_Permissions_Constraint;
  update_columns?: Array<Mobile_Permissions_Update_Column>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "mobile_permissions". */
export type Mobile_Permissions_Order_By = {
  client_created_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_permissions_user?: InputMaybe<Users_Order_By>;
  permission_status?: InputMaybe<Order_By>;
  permission_type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mobile_permissions */
export type Mobile_Permissions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mobile_permissions" */
export enum Mobile_Permissions_Select_Column {
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionStatus = 'permission_status',
  /** column name */
  PermissionType = 'permission_type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "mobile_permissions" */
export type Mobile_Permissions_Set_Input = {
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  permission_status?: InputMaybe<Enum_Mobile_Permission_Status_Enum>;
  permission_type?: InputMaybe<Enum_Mobile_Permission_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "mobile_permissions" */
export type Mobile_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Permissions_Stream_Cursor_Value_Input = {
  client_created_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  permission_status?: InputMaybe<Enum_Mobile_Permission_Status_Enum>;
  permission_type?: InputMaybe<Enum_Mobile_Permission_Type_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "mobile_permissions" */
export enum Mobile_Permissions_Update_Column {
  /** column name */
  ClientCreatedAt = 'client_created_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PermissionStatus = 'permission_status',
  /** column name */
  PermissionType = 'permission_type',
  /** column name */
  UserId = 'user_id'
}

export type Mobile_Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mobile_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mobile_Permissions_Bool_Exp;
};

/** columns and relationships of "mobile_upload_log" */
export type Mobile_Upload_Log = {
  __typename?: 'mobile_upload_log';
  completed: Scalars['Boolean']['output'];
  created_at: Scalars['timestamp']['output'];
  dataType: Scalars['citext']['output'];
  endTime?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startTime: Scalars['timestamptz']['output'];
  totalRecordsAtEnd?: Maybe<Scalars['Int']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "mobile_upload_log" */
export type Mobile_Upload_Log_Aggregate = {
  __typename?: 'mobile_upload_log_aggregate';
  aggregate?: Maybe<Mobile_Upload_Log_Aggregate_Fields>;
  nodes: Array<Mobile_Upload_Log>;
};

/** aggregate fields of "mobile_upload_log" */
export type Mobile_Upload_Log_Aggregate_Fields = {
  __typename?: 'mobile_upload_log_aggregate_fields';
  avg?: Maybe<Mobile_Upload_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mobile_Upload_Log_Max_Fields>;
  min?: Maybe<Mobile_Upload_Log_Min_Fields>;
  stddev?: Maybe<Mobile_Upload_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Mobile_Upload_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mobile_Upload_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Mobile_Upload_Log_Sum_Fields>;
  var_pop?: Maybe<Mobile_Upload_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Mobile_Upload_Log_Var_Samp_Fields>;
  variance?: Maybe<Mobile_Upload_Log_Variance_Fields>;
};


/** aggregate fields of "mobile_upload_log" */
export type Mobile_Upload_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mobile_Upload_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mobile_Upload_Log_Avg_Fields = {
  __typename?: 'mobile_upload_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mobile_upload_log". All fields are combined with a logical 'AND'. */
export type Mobile_Upload_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Upload_Log_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Upload_Log_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dataType?: InputMaybe<Citext_Comparison_Exp>;
  endTime?: InputMaybe<Timestamptz_Comparison_Exp>;
  errorMessage?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  startTime?: InputMaybe<Timestamptz_Comparison_Exp>;
  totalRecordsAtEnd?: InputMaybe<Int_Comparison_Exp>;
  totalRecordsAtStart?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "mobile_upload_log" */
export enum Mobile_Upload_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  MobileUploadLogPkey = 'mobile_upload_log_pkey'
}

/** input type for incrementing numeric columns in table "mobile_upload_log" */
export type Mobile_Upload_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  totalRecordsAtEnd?: InputMaybe<Scalars['Int']['input']>;
  totalRecordsAtStart?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mobile_upload_log" */
export type Mobile_Upload_Log_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dataType?: InputMaybe<Scalars['citext']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
  totalRecordsAtEnd?: InputMaybe<Scalars['Int']['input']>;
  totalRecordsAtStart?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mobile_Upload_Log_Max_Fields = {
  __typename?: 'mobile_upload_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dataType?: Maybe<Scalars['citext']['output']>;
  endTime?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['timestamptz']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Int']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Mobile_Upload_Log_Min_Fields = {
  __typename?: 'mobile_upload_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  dataType?: Maybe<Scalars['citext']['output']>;
  endTime?: Maybe<Scalars['timestamptz']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['timestamptz']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Int']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "mobile_upload_log" */
export type Mobile_Upload_Log_Mutation_Response = {
  __typename?: 'mobile_upload_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mobile_Upload_Log>;
};

/** on_conflict condition type for table "mobile_upload_log" */
export type Mobile_Upload_Log_On_Conflict = {
  constraint: Mobile_Upload_Log_Constraint;
  update_columns?: Array<Mobile_Upload_Log_Update_Column>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "mobile_upload_log". */
export type Mobile_Upload_Log_Order_By = {
  completed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dataType?: InputMaybe<Order_By>;
  endTime?: InputMaybe<Order_By>;
  errorMessage?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  totalRecordsAtEnd?: InputMaybe<Order_By>;
  totalRecordsAtStart?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mobile_upload_log */
export type Mobile_Upload_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "mobile_upload_log" */
export enum Mobile_Upload_Log_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataType = 'dataType',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  ErrorMessage = 'errorMessage',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  TotalRecordsAtEnd = 'totalRecordsAtEnd',
  /** column name */
  TotalRecordsAtStart = 'totalRecordsAtStart',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "mobile_upload_log" */
export type Mobile_Upload_Log_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dataType?: InputMaybe<Scalars['citext']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
  totalRecordsAtEnd?: InputMaybe<Scalars['Int']['input']>;
  totalRecordsAtStart?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Mobile_Upload_Log_Stddev_Fields = {
  __typename?: 'mobile_upload_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mobile_Upload_Log_Stddev_Pop_Fields = {
  __typename?: 'mobile_upload_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mobile_Upload_Log_Stddev_Samp_Fields = {
  __typename?: 'mobile_upload_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mobile_upload_log" */
export type Mobile_Upload_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Upload_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Upload_Log_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  dataType?: InputMaybe<Scalars['citext']['input']>;
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['timestamptz']['input']>;
  totalRecordsAtEnd?: InputMaybe<Scalars['Int']['input']>;
  totalRecordsAtStart?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Mobile_Upload_Log_Sum_Fields = {
  __typename?: 'mobile_upload_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Int']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "mobile_upload_log" */
export enum Mobile_Upload_Log_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataType = 'dataType',
  /** column name */
  EndTime = 'endTime',
  /** column name */
  ErrorMessage = 'errorMessage',
  /** column name */
  Id = 'id',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  TotalRecordsAtEnd = 'totalRecordsAtEnd',
  /** column name */
  TotalRecordsAtStart = 'totalRecordsAtStart',
  /** column name */
  UserId = 'userId'
}

export type Mobile_Upload_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mobile_Upload_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mobile_Upload_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mobile_Upload_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mobile_Upload_Log_Var_Pop_Fields = {
  __typename?: 'mobile_upload_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mobile_Upload_Log_Var_Samp_Fields = {
  __typename?: 'mobile_upload_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mobile_Upload_Log_Variance_Fields = {
  __typename?: 'mobile_upload_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtEnd?: Maybe<Scalars['Float']['output']>;
  totalRecordsAtStart?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mood_measurements" */
export type Mood_Measurements = {
  __typename?: 'mood_measurements';
  client_created_on?: Maybe<Scalars['String']['output']>;
  cravings?: Maybe<Scalars['Int']['output']>;
  created_on: Scalars['timestamptz']['output'];
  enjoyment: Scalars['Int']['output'];
  growth?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "mood_measurements" */
export type Mood_Measurements_Aggregate = {
  __typename?: 'mood_measurements_aggregate';
  aggregate?: Maybe<Mood_Measurements_Aggregate_Fields>;
  nodes: Array<Mood_Measurements>;
};

export type Mood_Measurements_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mood_Measurements_Aggregate_Bool_Exp_Count>;
};

export type Mood_Measurements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mood_Measurements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mood_measurements" */
export type Mood_Measurements_Aggregate_Fields = {
  __typename?: 'mood_measurements_aggregate_fields';
  avg?: Maybe<Mood_Measurements_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mood_Measurements_Max_Fields>;
  min?: Maybe<Mood_Measurements_Min_Fields>;
  stddev?: Maybe<Mood_Measurements_Stddev_Fields>;
  stddev_pop?: Maybe<Mood_Measurements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mood_Measurements_Stddev_Samp_Fields>;
  sum?: Maybe<Mood_Measurements_Sum_Fields>;
  var_pop?: Maybe<Mood_Measurements_Var_Pop_Fields>;
  var_samp?: Maybe<Mood_Measurements_Var_Samp_Fields>;
  variance?: Maybe<Mood_Measurements_Variance_Fields>;
};


/** aggregate fields of "mood_measurements" */
export type Mood_Measurements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mood_measurements" */
export type Mood_Measurements_Aggregate_Order_By = {
  avg?: InputMaybe<Mood_Measurements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mood_Measurements_Max_Order_By>;
  min?: InputMaybe<Mood_Measurements_Min_Order_By>;
  stddev?: InputMaybe<Mood_Measurements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Mood_Measurements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Mood_Measurements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Mood_Measurements_Sum_Order_By>;
  var_pop?: InputMaybe<Mood_Measurements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Mood_Measurements_Var_Samp_Order_By>;
  variance?: InputMaybe<Mood_Measurements_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "mood_measurements" */
export type Mood_Measurements_Arr_Rel_Insert_Input = {
  data: Array<Mood_Measurements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mood_Measurements_On_Conflict>;
};

/** aggregate avg on columns */
export type Mood_Measurements_Avg_Fields = {
  __typename?: 'mood_measurements_avg_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "mood_measurements" */
export type Mood_Measurements_Avg_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "mood_measurements". All fields are combined with a logical 'AND'. */
export type Mood_Measurements_Bool_Exp = {
  _and?: InputMaybe<Array<Mood_Measurements_Bool_Exp>>;
  _not?: InputMaybe<Mood_Measurements_Bool_Exp>;
  _or?: InputMaybe<Array<Mood_Measurements_Bool_Exp>>;
  client_created_on?: InputMaybe<String_Comparison_Exp>;
  cravings?: InputMaybe<Int_Comparison_Exp>;
  created_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  enjoyment?: InputMaybe<Int_Comparison_Exp>;
  growth?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "mood_measurements" */
export enum Mood_Measurements_Constraint {
  /** unique or primary key constraint on columns "client_created_on", "user_id" */
  MoodMeasurementsClientCreatedOnUserIdKey = 'mood_measurements_client_created_on_user_id_key',
  /** unique or primary key constraint on columns "id" */
  MoodMeasurementsPkey = 'mood_measurements_pkey'
}

/** input type for incrementing numeric columns in table "mood_measurements" */
export type Mood_Measurements_Inc_Input = {
  cravings?: InputMaybe<Scalars['Int']['input']>;
  enjoyment?: InputMaybe<Scalars['Int']['input']>;
  growth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "mood_measurements" */
export type Mood_Measurements_Insert_Input = {
  client_created_on?: InputMaybe<Scalars['String']['input']>;
  cravings?: InputMaybe<Scalars['Int']['input']>;
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  enjoyment?: InputMaybe<Scalars['Int']['input']>;
  growth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mood_Measurements_Max_Fields = {
  __typename?: 'mood_measurements_max_fields';
  client_created_on?: Maybe<Scalars['String']['output']>;
  cravings?: Maybe<Scalars['Int']['output']>;
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  enjoyment?: Maybe<Scalars['Int']['output']>;
  growth?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "mood_measurements" */
export type Mood_Measurements_Max_Order_By = {
  client_created_on?: InputMaybe<Order_By>;
  cravings?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mood_Measurements_Min_Fields = {
  __typename?: 'mood_measurements_min_fields';
  client_created_on?: Maybe<Scalars['String']['output']>;
  cravings?: Maybe<Scalars['Int']['output']>;
  created_on?: Maybe<Scalars['timestamptz']['output']>;
  enjoyment?: Maybe<Scalars['Int']['output']>;
  growth?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "mood_measurements" */
export type Mood_Measurements_Min_Order_By = {
  client_created_on?: InputMaybe<Order_By>;
  cravings?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mood_measurements" */
export type Mood_Measurements_Mutation_Response = {
  __typename?: 'mood_measurements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mood_Measurements>;
};

/** on_conflict condition type for table "mood_measurements" */
export type Mood_Measurements_On_Conflict = {
  constraint: Mood_Measurements_Constraint;
  update_columns?: Array<Mood_Measurements_Update_Column>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};

/** Ordering options when selecting data from "mood_measurements". */
export type Mood_Measurements_Order_By = {
  client_created_on?: InputMaybe<Order_By>;
  cravings?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mood_measurements */
export type Mood_Measurements_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "mood_measurements" */
export enum Mood_Measurements_Select_Column {
  /** column name */
  ClientCreatedOn = 'client_created_on',
  /** column name */
  Cravings = 'cravings',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Enjoyment = 'enjoyment',
  /** column name */
  Growth = 'growth',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "mood_measurements" */
export type Mood_Measurements_Set_Input = {
  client_created_on?: InputMaybe<Scalars['String']['input']>;
  cravings?: InputMaybe<Scalars['Int']['input']>;
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  enjoyment?: InputMaybe<Scalars['Int']['input']>;
  growth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Mood_Measurements_Stddev_Fields = {
  __typename?: 'mood_measurements_stddev_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "mood_measurements" */
export type Mood_Measurements_Stddev_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Mood_Measurements_Stddev_Pop_Fields = {
  __typename?: 'mood_measurements_stddev_pop_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "mood_measurements" */
export type Mood_Measurements_Stddev_Pop_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Mood_Measurements_Stddev_Samp_Fields = {
  __typename?: 'mood_measurements_stddev_samp_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "mood_measurements" */
export type Mood_Measurements_Stddev_Samp_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "mood_measurements" */
export type Mood_Measurements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mood_Measurements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mood_Measurements_Stream_Cursor_Value_Input = {
  client_created_on?: InputMaybe<Scalars['String']['input']>;
  cravings?: InputMaybe<Scalars['Int']['input']>;
  created_on?: InputMaybe<Scalars['timestamptz']['input']>;
  enjoyment?: InputMaybe<Scalars['Int']['input']>;
  growth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Mood_Measurements_Sum_Fields = {
  __typename?: 'mood_measurements_sum_fields';
  cravings?: Maybe<Scalars['Int']['output']>;
  enjoyment?: Maybe<Scalars['Int']['output']>;
  growth?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "mood_measurements" */
export type Mood_Measurements_Sum_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "mood_measurements" */
export enum Mood_Measurements_Update_Column {
  /** column name */
  ClientCreatedOn = 'client_created_on',
  /** column name */
  Cravings = 'cravings',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Enjoyment = 'enjoyment',
  /** column name */
  Growth = 'growth',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Mood_Measurements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Mood_Measurements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mood_Measurements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mood_Measurements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Mood_Measurements_Var_Pop_Fields = {
  __typename?: 'mood_measurements_var_pop_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "mood_measurements" */
export type Mood_Measurements_Var_Pop_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Mood_Measurements_Var_Samp_Fields = {
  __typename?: 'mood_measurements_var_samp_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "mood_measurements" */
export type Mood_Measurements_Var_Samp_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Mood_Measurements_Variance_Fields = {
  __typename?: 'mood_measurements_variance_fields';
  cravings?: Maybe<Scalars['Float']['output']>;
  enjoyment?: Maybe<Scalars['Float']['output']>;
  growth?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "mood_measurements" */
export type Mood_Measurements_Variance_Order_By = {
  cravings?: InputMaybe<Order_By>;
  enjoyment?: InputMaybe<Order_By>;
  growth?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "activity" */
  delete_activity?: Maybe<Activity_Mutation_Response>;
  /** delete single row from the table: "activity" */
  delete_activity_by_pk?: Maybe<Activity>;
  /** delete data from the table: "activity_rating" */
  delete_activity_rating?: Maybe<Activity_Rating_Mutation_Response>;
  /** delete single row from the table: "activity_rating" */
  delete_activity_rating_by_pk?: Maybe<Activity_Rating>;
  /** delete data from the table: "activity_resource" */
  delete_activity_resource?: Maybe<Activity_Resource_Mutation_Response>;
  /** delete single row from the table: "activity_resource" */
  delete_activity_resource_by_pk?: Maybe<Activity_Resource>;
  /** delete data from the table: "activity_resource_category" */
  delete_activity_resource_category?: Maybe<Activity_Resource_Category_Mutation_Response>;
  /** delete single row from the table: "activity_resource_category" */
  delete_activity_resource_category_by_pk?: Maybe<Activity_Resource_Category>;
  /** delete data from the table: "activity_sub_category" */
  delete_activity_sub_category?: Maybe<Activity_Sub_Category_Mutation_Response>;
  /** delete single row from the table: "activity_sub_category" */
  delete_activity_sub_category_by_pk?: Maybe<Activity_Sub_Category>;
  /** delete data from the table: "activity_suggested_activities" */
  delete_activity_suggested_activities?: Maybe<Activity_Suggested_Activities_Mutation_Response>;
  /** delete single row from the table: "activity_suggested_activities" */
  delete_activity_suggested_activities_by_pk?: Maybe<Activity_Suggested_Activities>;
  /** delete data from the table: "assessment_answers" */
  delete_assessment_answers?: Maybe<Assessment_Answers_Mutation_Response>;
  /** delete single row from the table: "assessment_answers" */
  delete_assessment_answers_by_pk?: Maybe<Assessment_Answers>;
  /** delete data from the table: "assessment_branching_rules" */
  delete_assessment_branching_rules?: Maybe<Assessment_Branching_Rules_Mutation_Response>;
  /** delete single row from the table: "assessment_branching_rules" */
  delete_assessment_branching_rules_by_pk?: Maybe<Assessment_Branching_Rules>;
  /** delete data from the table: "assessment_pages" */
  delete_assessment_pages?: Maybe<Assessment_Pages_Mutation_Response>;
  /** delete single row from the table: "assessment_pages" */
  delete_assessment_pages_by_pk?: Maybe<Assessment_Pages>;
  /** delete data from the table: "assessment_question_custom_prompt" */
  delete_assessment_question_custom_prompt?: Maybe<Assessment_Question_Custom_Prompt_Mutation_Response>;
  /** delete single row from the table: "assessment_question_custom_prompt" */
  delete_assessment_question_custom_prompt_by_pk?: Maybe<Assessment_Question_Custom_Prompt>;
  /** delete data from the table: "assessment_questions" */
  delete_assessment_questions?: Maybe<Assessment_Questions_Mutation_Response>;
  /** delete single row from the table: "assessment_questions" */
  delete_assessment_questions_by_pk?: Maybe<Assessment_Questions>;
  /** delete data from the table: "assessment_takes" */
  delete_assessment_takes?: Maybe<Assessment_Takes_Mutation_Response>;
  /** delete single row from the table: "assessment_takes" */
  delete_assessment_takes_by_pk?: Maybe<Assessment_Takes>;
  /** delete data from the table: "assessments" */
  delete_assessments?: Maybe<Assessments_Mutation_Response>;
  /** delete single row from the table: "assessments" */
  delete_assessments_by_pk?: Maybe<Assessments>;
  /** delete data from the table: "auth.account_migration_log" */
  delete_auth_account_migration_log?: Maybe<Auth_Account_Migration_Log_Mutation_Response>;
  /** delete single row from the table: "auth.account_migration_log" */
  delete_auth_account_migration_log_by_pk?: Maybe<Auth_Account_Migration_Log>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: Maybe<Auth_Account_Providers_Mutation_Response>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: Maybe<Auth_Account_Providers>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: Maybe<Auth_Account_Roles_Mutation_Response>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: Maybe<Auth_Account_Roles>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: Maybe<Auth_Accounts_Mutation_Response>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: Maybe<Auth_Accounts>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: Maybe<Auth_Providers_Mutation_Response>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: Maybe<Auth_Providers>;
  /** delete data from the table: "auth.refresh_token_usage_log" */
  delete_auth_refresh_token_usage_log?: Maybe<Auth_Refresh_Token_Usage_Log_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_token_usage_log" */
  delete_auth_refresh_token_usage_log_by_pk?: Maybe<Auth_Refresh_Token_Usage_Log>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: Maybe<Auth_Refresh_Tokens_Mutation_Response>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: Maybe<Auth_Refresh_Tokens>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: Maybe<Auth_Roles_Mutation_Response>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: Maybe<Auth_Roles>;
  /** delete data from the table: "casemix_category" */
  delete_casemix_category?: Maybe<Casemix_Category_Mutation_Response>;
  /** delete single row from the table: "casemix_category" */
  delete_casemix_category_by_pk?: Maybe<Casemix_Category>;
  /** delete data from the table: "client_demographics" */
  delete_client_demographics?: Maybe<Client_Demographics_Mutation_Response>;
  /** delete single row from the table: "client_demographics" */
  delete_client_demographics_by_pk?: Maybe<Client_Demographics>;
  /** delete data from the table: "daily_features" */
  delete_daily_features?: Maybe<Daily_Features_Mutation_Response>;
  /** delete single row from the table: "daily_features" */
  delete_daily_features_by_pk?: Maybe<Daily_Features>;
  /** delete data from the table: "ehr.client_invite_codes" */
  delete_ehr_client_invite_codes?: Maybe<Ehr_Client_Invite_Codes_Mutation_Response>;
  /** delete single row from the table: "ehr.client_invite_codes" */
  delete_ehr_client_invite_codes_by_pk?: Maybe<Ehr_Client_Invite_Codes>;
  /** delete data from the table: "ehr.ehr_practitioner_map" */
  delete_ehr_ehr_practitioner_map?: Maybe<Ehr_Ehr_Practitioner_Map_Mutation_Response>;
  /** delete single row from the table: "ehr.ehr_practitioner_map" */
  delete_ehr_ehr_practitioner_map_by_pk?: Maybe<Ehr_Ehr_Practitioner_Map>;
  /** delete data from the table: "ehr.xealth_event_notification" */
  delete_ehr_xealth_event_notification?: Maybe<Ehr_Xealth_Event_Notification_Mutation_Response>;
  /** delete single row from the table: "ehr.xealth_event_notification" */
  delete_ehr_xealth_event_notification_by_pk?: Maybe<Ehr_Xealth_Event_Notification>;
  /** delete data from the table: "ehr.xealth_preorder_form" */
  delete_ehr_xealth_preorder_form?: Maybe<Ehr_Xealth_Preorder_Form_Mutation_Response>;
  /** delete single row from the table: "ehr.xealth_preorder_form" */
  delete_ehr_xealth_preorder_form_by_pk?: Maybe<Ehr_Xealth_Preorder_Form>;
  /** delete data from the table: "ehr.xealth_preorder_invite_map" */
  delete_ehr_xealth_preorder_invite_map?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Mutation_Response>;
  /** delete single row from the table: "ehr.xealth_preorder_invite_map" */
  delete_ehr_xealth_preorder_invite_map_by_pk?: Maybe<Ehr_Xealth_Preorder_Invite_Map>;
  /** delete data from the table: "enum_activity_category" */
  delete_enum_activity_category?: Maybe<Enum_Activity_Category_Mutation_Response>;
  /** delete single row from the table: "enum_activity_category" */
  delete_enum_activity_category_by_pk?: Maybe<Enum_Activity_Category>;
  /** delete data from the table: "enum_activity_resource_type" */
  delete_enum_activity_resource_type?: Maybe<Enum_Activity_Resource_Type_Mutation_Response>;
  /** delete single row from the table: "enum_activity_resource_type" */
  delete_enum_activity_resource_type_by_pk?: Maybe<Enum_Activity_Resource_Type>;
  /** delete data from the table: "enum_completion_status" */
  delete_enum_completion_status?: Maybe<Enum_Completion_Status_Mutation_Response>;
  /** delete single row from the table: "enum_completion_status" */
  delete_enum_completion_status_by_pk?: Maybe<Enum_Completion_Status>;
  /** delete data from the table: "enum_feature_direction" */
  delete_enum_feature_direction?: Maybe<Enum_Feature_Direction_Mutation_Response>;
  /** delete single row from the table: "enum_feature_direction" */
  delete_enum_feature_direction_by_pk?: Maybe<Enum_Feature_Direction>;
  /** delete data from the table: "enum_feature_type" */
  delete_enum_feature_type?: Maybe<Enum_Feature_Type_Mutation_Response>;
  /** delete single row from the table: "enum_feature_type" */
  delete_enum_feature_type_by_pk?: Maybe<Enum_Feature_Type>;
  /** delete data from the table: "enum_gender" */
  delete_enum_gender?: Maybe<Enum_Gender_Mutation_Response>;
  /** delete single row from the table: "enum_gender" */
  delete_enum_gender_by_pk?: Maybe<Enum_Gender>;
  /** delete data from the table: "enum_insight_content_type" */
  delete_enum_insight_content_type?: Maybe<Enum_Insight_Content_Type_Mutation_Response>;
  /** delete single row from the table: "enum_insight_content_type" */
  delete_enum_insight_content_type_by_pk?: Maybe<Enum_Insight_Content_Type>;
  /** delete data from the table: "enum_mobile_permission_status" */
  delete_enum_mobile_permission_status?: Maybe<Enum_Mobile_Permission_Status_Mutation_Response>;
  /** delete single row from the table: "enum_mobile_permission_status" */
  delete_enum_mobile_permission_status_by_pk?: Maybe<Enum_Mobile_Permission_Status>;
  /** delete data from the table: "enum_mobile_permission_type" */
  delete_enum_mobile_permission_type?: Maybe<Enum_Mobile_Permission_Type_Mutation_Response>;
  /** delete single row from the table: "enum_mobile_permission_type" */
  delete_enum_mobile_permission_type_by_pk?: Maybe<Enum_Mobile_Permission_Type>;
  /** delete data from the table: "enum_outcome" */
  delete_enum_outcome?: Maybe<Enum_Outcome_Mutation_Response>;
  /** delete single row from the table: "enum_outcome" */
  delete_enum_outcome_by_pk?: Maybe<Enum_Outcome>;
  /** delete data from the table: "enum_question_type" */
  delete_enum_question_type?: Maybe<Enum_Question_Type_Mutation_Response>;
  /** delete single row from the table: "enum_question_type" */
  delete_enum_question_type_by_pk?: Maybe<Enum_Question_Type>;
  /** delete data from the table: "enum_racial_ethnic" */
  delete_enum_racial_ethnic?: Maybe<Enum_Racial_Ethnic_Mutation_Response>;
  /** delete single row from the table: "enum_racial_ethnic" */
  delete_enum_racial_ethnic_by_pk?: Maybe<Enum_Racial_Ethnic>;
  /** delete data from the table: "enum_resource_type" */
  delete_enum_resource_type?: Maybe<Enum_Resource_Type_Mutation_Response>;
  /** delete single row from the table: "enum_resource_type" */
  delete_enum_resource_type_by_pk?: Maybe<Enum_Resource_Type>;
  /** delete data from the table: "enum_safety_plan_section_category_type" */
  delete_enum_safety_plan_section_category_type?: Maybe<Enum_Safety_Plan_Section_Category_Type_Mutation_Response>;
  /** delete single row from the table: "enum_safety_plan_section_category_type" */
  delete_enum_safety_plan_section_category_type_by_pk?: Maybe<Enum_Safety_Plan_Section_Category_Type>;
  /** delete data from the table: "enum_safety_plan_section_icons" */
  delete_enum_safety_plan_section_icons?: Maybe<Enum_Safety_Plan_Section_Icons_Mutation_Response>;
  /** delete single row from the table: "enum_safety_plan_section_icons" */
  delete_enum_safety_plan_section_icons_by_pk?: Maybe<Enum_Safety_Plan_Section_Icons>;
  /** delete data from the table: "enum_safety_plan_status" */
  delete_enum_safety_plan_status?: Maybe<Enum_Safety_Plan_Status_Mutation_Response>;
  /** delete single row from the table: "enum_safety_plan_status" */
  delete_enum_safety_plan_status_by_pk?: Maybe<Enum_Safety_Plan_Status>;
  /** delete data from the table: "enum_safety_plan_type" */
  delete_enum_safety_plan_type?: Maybe<Enum_Safety_Plan_Type_Mutation_Response>;
  /** delete single row from the table: "enum_safety_plan_type" */
  delete_enum_safety_plan_type_by_pk?: Maybe<Enum_Safety_Plan_Type>;
  /** delete data from the table: "enum_trend_direction" */
  delete_enum_trend_direction?: Maybe<Enum_Trend_Direction_Mutation_Response>;
  /** delete single row from the table: "enum_trend_direction" */
  delete_enum_trend_direction_by_pk?: Maybe<Enum_Trend_Direction>;
  /** delete data from the table: "feature_report_feature_coefficients" */
  delete_feature_report_feature_coefficients?: Maybe<Feature_Report_Feature_Coefficients_Mutation_Response>;
  /** delete single row from the table: "feature_report_feature_coefficients" */
  delete_feature_report_feature_coefficients_by_pk?: Maybe<Feature_Report_Feature_Coefficients>;
  /** delete data from the table: "feature_report_features" */
  delete_feature_report_features?: Maybe<Feature_Report_Features_Mutation_Response>;
  /** delete single row from the table: "feature_report_features" */
  delete_feature_report_features_by_pk?: Maybe<Feature_Report_Features>;
  /** delete data from the table: "feature_reports" */
  delete_feature_reports?: Maybe<Feature_Reports_Mutation_Response>;
  /** delete single row from the table: "feature_reports" */
  delete_feature_reports_by_pk?: Maybe<Feature_Reports>;
  /** delete data from the table: "group_code" */
  delete_group_code?: Maybe<Group_Code_Mutation_Response>;
  /** delete single row from the table: "group_code" */
  delete_group_code_by_pk?: Maybe<Group_Code>;
  /** delete data from the table: "insight_articles" */
  delete_insight_articles?: Maybe<Insight_Articles_Mutation_Response>;
  /** delete single row from the table: "insight_articles" */
  delete_insight_articles_by_pk?: Maybe<Insight_Articles>;
  /** delete data from the table: "insight_combos" */
  delete_insight_combos?: Maybe<Insight_Combos_Mutation_Response>;
  /** delete single row from the table: "insight_combos" */
  delete_insight_combos_by_pk?: Maybe<Insight_Combos>;
  /** delete data from the table: "insight_hows" */
  delete_insight_hows?: Maybe<Insight_Hows_Mutation_Response>;
  /** delete single row from the table: "insight_hows" */
  delete_insight_hows_by_pk?: Maybe<Insight_Hows>;
  /** delete data from the table: "insight_plan_article" */
  delete_insight_plan_article?: Maybe<Insight_Plan_Article_Mutation_Response>;
  /** delete single row from the table: "insight_plan_article" */
  delete_insight_plan_article_by_pk?: Maybe<Insight_Plan_Article>;
  /** delete data from the table: "insight_plan_text" */
  delete_insight_plan_text?: Maybe<Insight_Plan_Text_Mutation_Response>;
  /** delete single row from the table: "insight_plan_text" */
  delete_insight_plan_text_by_pk?: Maybe<Insight_Plan_Text>;
  /** delete data from the table: "insight_plans" */
  delete_insight_plans?: Maybe<Insight_Plans_Mutation_Response>;
  /** delete single row from the table: "insight_plans" */
  delete_insight_plans_by_pk?: Maybe<Insight_Plans>;
  /** delete data from the table: "insight_questions" */
  delete_insight_questions?: Maybe<Insight_Questions_Mutation_Response>;
  /** delete single row from the table: "insight_questions" */
  delete_insight_questions_by_pk?: Maybe<Insight_Questions>;
  /** delete data from the table: "insight_recipes" */
  delete_insight_recipes?: Maybe<Insight_Recipes_Mutation_Response>;
  /** delete single row from the table: "insight_recipes" */
  delete_insight_recipes_by_pk?: Maybe<Insight_Recipes>;
  /** delete data from the table: "insight_reflect" */
  delete_insight_reflect?: Maybe<Insight_Reflect_Mutation_Response>;
  /** delete single row from the table: "insight_reflect" */
  delete_insight_reflect_by_pk?: Maybe<Insight_Reflect>;
  /** delete data from the table: "insight_reflect_text" */
  delete_insight_reflect_text?: Maybe<Insight_Reflect_Text_Mutation_Response>;
  /** delete single row from the table: "insight_reflect_text" */
  delete_insight_reflect_text_by_pk?: Maybe<Insight_Reflect_Text>;
  /** delete data from the table: "insight_resources" */
  delete_insight_resources?: Maybe<Insight_Resources_Mutation_Response>;
  /** delete single row from the table: "insight_resources" */
  delete_insight_resources_by_pk?: Maybe<Insight_Resources>;
  /** delete data from the table: "insight_texts" */
  delete_insight_texts?: Maybe<Insight_Texts_Mutation_Response>;
  /** delete single row from the table: "insight_texts" */
  delete_insight_texts_by_pk?: Maybe<Insight_Texts>;
  /** delete data from the table: "insight_tips" */
  delete_insight_tips?: Maybe<Insight_Tips_Mutation_Response>;
  /** delete single row from the table: "insight_tips" */
  delete_insight_tips_by_pk?: Maybe<Insight_Tips>;
  /** delete data from the table: "insight_whys" */
  delete_insight_whys?: Maybe<Insight_Whys_Mutation_Response>;
  /** delete single row from the table: "insight_whys" */
  delete_insight_whys_by_pk?: Maybe<Insight_Whys>;
  /** delete data from the table: "invite_codes" */
  delete_invite_codes?: Maybe<Invite_Codes_Mutation_Response>;
  /** delete single row from the table: "invite_codes" */
  delete_invite_codes_by_pk?: Maybe<Invite_Codes>;
  /** delete data from the table: "logs" */
  delete_logs?: Maybe<Logs_Mutation_Response>;
  /** delete single row from the table: "logs" */
  delete_logs_by_pk?: Maybe<Logs>;
  /** delete data from the table: "mobile_device_data" */
  delete_mobile_device_data?: Maybe<Mobile_Device_Data_Mutation_Response>;
  /** delete single row from the table: "mobile_device_data" */
  delete_mobile_device_data_by_pk?: Maybe<Mobile_Device_Data>;
  /** delete data from the table: "mobile_permissions" */
  delete_mobile_permissions?: Maybe<Mobile_Permissions_Mutation_Response>;
  /** delete single row from the table: "mobile_permissions" */
  delete_mobile_permissions_by_pk?: Maybe<Mobile_Permissions>;
  /** delete data from the table: "mobile_upload_log" */
  delete_mobile_upload_log?: Maybe<Mobile_Upload_Log_Mutation_Response>;
  /** delete single row from the table: "mobile_upload_log" */
  delete_mobile_upload_log_by_pk?: Maybe<Mobile_Upload_Log>;
  /** delete data from the table: "mood_measurements" */
  delete_mood_measurements?: Maybe<Mood_Measurements_Mutation_Response>;
  /** delete single row from the table: "mood_measurements" */
  delete_mood_measurements_by_pk?: Maybe<Mood_Measurements>;
  /** delete data from the table: "nudge_schedules" */
  delete_nudge_schedules?: Maybe<Nudge_Schedules_Mutation_Response>;
  /** delete single row from the table: "nudge_schedules" */
  delete_nudge_schedules_by_pk?: Maybe<Nudge_Schedules>;
  /** delete data from the table: "nudge_takes" */
  delete_nudge_takes?: Maybe<Nudge_Takes_Mutation_Response>;
  /** delete single row from the table: "nudge_takes" */
  delete_nudge_takes_by_pk?: Maybe<Nudge_Takes>;
  /** delete data from the table: "nudges" */
  delete_nudges?: Maybe<Nudges_Mutation_Response>;
  /** delete single row from the table: "nudges" */
  delete_nudges_by_pk?: Maybe<Nudges>;
  /** delete data from the table: "organization_admins" */
  delete_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** delete single row from the table: "organization_admins" */
  delete_organization_admins_by_pk?: Maybe<Organization_Admins>;
  /** delete data from the table: "organization_features" */
  delete_organization_features?: Maybe<Organization_Features_Mutation_Response>;
  /** delete single row from the table: "organization_features" */
  delete_organization_features_by_pk?: Maybe<Organization_Features>;
  /** delete data from the table: "organization_member_roles" */
  delete_organization_member_roles?: Maybe<Organization_Member_Roles_Mutation_Response>;
  /** delete single row from the table: "organization_member_roles" */
  delete_organization_member_roles_by_pk?: Maybe<Organization_Member_Roles>;
  /** delete data from the table: "organization_members" */
  delete_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** delete single row from the table: "organization_members" */
  delete_organization_members_by_pk?: Maybe<Organization_Members>;
  /** delete data from the table: "organization_supervisees" */
  delete_organization_supervisees?: Maybe<Organization_Supervisees_Mutation_Response>;
  /** delete single row from the table: "organization_supervisees" */
  delete_organization_supervisees_by_pk?: Maybe<Organization_Supervisees>;
  /** delete data from the table: "organization_supervisors" */
  delete_organization_supervisors?: Maybe<Organization_Supervisors_Mutation_Response>;
  /** delete single row from the table: "organization_supervisors" */
  delete_organization_supervisors_by_pk?: Maybe<Organization_Supervisors>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "organizations" */
  delete_organizations_by_pk?: Maybe<Organizations>;
  /** delete data from the table: "questionnaire_items" */
  delete_questionnaire_items?: Maybe<Questionnaire_Items_Mutation_Response>;
  /** delete single row from the table: "questionnaire_items" */
  delete_questionnaire_items_by_pk?: Maybe<Questionnaire_Items>;
  /** delete data from the table: "questionnaire_response_options" */
  delete_questionnaire_response_options?: Maybe<Questionnaire_Response_Options_Mutation_Response>;
  /** delete single row from the table: "questionnaire_response_options" */
  delete_questionnaire_response_options_by_pk?: Maybe<Questionnaire_Response_Options>;
  /** delete data from the table: "questionnaire_responses" */
  delete_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** delete single row from the table: "questionnaire_responses" */
  delete_questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** delete data from the table: "questionnaire_risk_alert_contacts" */
  delete_questionnaire_risk_alert_contacts?: Maybe<Questionnaire_Risk_Alert_Contacts_Mutation_Response>;
  /** delete single row from the table: "questionnaire_risk_alert_contacts" */
  delete_questionnaire_risk_alert_contacts_by_pk?: Maybe<Questionnaire_Risk_Alert_Contacts>;
  /** delete data from the table: "questionnaire_schedules" */
  delete_questionnaire_schedules?: Maybe<Questionnaire_Schedules_Mutation_Response>;
  /** delete single row from the table: "questionnaire_schedules" */
  delete_questionnaire_schedules_by_pk?: Maybe<Questionnaire_Schedules>;
  /** delete data from the table: "questionnaire_scoring" */
  delete_questionnaire_scoring?: Maybe<Questionnaire_Scoring_Mutation_Response>;
  /** delete single row from the table: "questionnaire_scoring" */
  delete_questionnaire_scoring_by_pk?: Maybe<Questionnaire_Scoring>;
  /** delete data from the table: "questionnaire_takes" */
  delete_questionnaire_takes?: Maybe<Questionnaire_Takes_Mutation_Response>;
  /** delete single row from the table: "questionnaire_takes" */
  delete_questionnaire_takes_by_pk?: Maybe<Questionnaire_Takes>;
  /** delete data from the table: "questionnaires" */
  delete_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** delete single row from the table: "questionnaires" */
  delete_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** delete data from the table: "relapse_prevention_place_visits" */
  delete_relapse_prevention_place_visits?: Maybe<Relapse_Prevention_Place_Visits_Mutation_Response>;
  /** delete single row from the table: "relapse_prevention_place_visits" */
  delete_relapse_prevention_place_visits_by_pk?: Maybe<Relapse_Prevention_Place_Visits>;
  /** delete data from the table: "relapse_prevention_places" */
  delete_relapse_prevention_places?: Maybe<Relapse_Prevention_Places_Mutation_Response>;
  /** delete single row from the table: "relapse_prevention_places" */
  delete_relapse_prevention_places_by_pk?: Maybe<Relapse_Prevention_Places>;
  /** delete data from the table: "resources" */
  delete_resources?: Maybe<Resources_Mutation_Response>;
  /** delete single row from the table: "resources" */
  delete_resources_by_pk?: Maybe<Resources>;
  /** delete data from the table: "resources_orgs" */
  delete_resources_orgs?: Maybe<Resources_Orgs_Mutation_Response>;
  /** delete single row from the table: "resources_orgs" */
  delete_resources_orgs_by_pk?: Maybe<Resources_Orgs>;
  /** delete data from the table: "risk_alerts_log" */
  delete_risk_alerts_log?: Maybe<Risk_Alerts_Log_Mutation_Response>;
  /** delete single row from the table: "risk_alerts_log" */
  delete_risk_alerts_log_by_pk?: Maybe<Risk_Alerts_Log>;
  /** delete data from the table: "risk_alerts_recipients_log" */
  delete_risk_alerts_recipients_log?: Maybe<Risk_Alerts_Recipients_Log_Mutation_Response>;
  /** delete single row from the table: "risk_alerts_recipients_log" */
  delete_risk_alerts_recipients_log_by_pk?: Maybe<Risk_Alerts_Recipients_Log>;
  /** delete data from the table: "role_capabilities" */
  delete_role_capabilities?: Maybe<Role_Capabilities_Mutation_Response>;
  /** delete single row from the table: "role_capabilities" */
  delete_role_capabilities_by_pk?: Maybe<Role_Capabilities>;
  /** delete data from the table: "safety_checklist_recipients_log" */
  delete_safety_checklist_recipients_log?: Maybe<Safety_Checklist_Recipients_Log_Mutation_Response>;
  /** delete single row from the table: "safety_checklist_recipients_log" */
  delete_safety_checklist_recipients_log_by_pk?: Maybe<Safety_Checklist_Recipients_Log>;
  /** delete data from the table: "safety_plan" */
  delete_safety_plan?: Maybe<Safety_Plan_Mutation_Response>;
  /** delete single row from the table: "safety_plan" */
  delete_safety_plan_by_pk?: Maybe<Safety_Plan>;
  /** delete data from the table: "safety_plan_checklist_items" */
  delete_safety_plan_checklist_items?: Maybe<Safety_Plan_Checklist_Items_Mutation_Response>;
  /** delete single row from the table: "safety_plan_checklist_items" */
  delete_safety_plan_checklist_items_by_pk?: Maybe<Safety_Plan_Checklist_Items>;
  /** delete data from the table: "safety_plan_response_options" */
  delete_safety_plan_response_options?: Maybe<Safety_Plan_Response_Options_Mutation_Response>;
  /** delete single row from the table: "safety_plan_response_options" */
  delete_safety_plan_response_options_by_pk?: Maybe<Safety_Plan_Response_Options>;
  /** delete data from the table: "safety_plan_section_category" */
  delete_safety_plan_section_category?: Maybe<Safety_Plan_Section_Category_Mutation_Response>;
  /** delete single row from the table: "safety_plan_section_category" */
  delete_safety_plan_section_category_by_pk?: Maybe<Safety_Plan_Section_Category>;
  /** delete data from the table: "safety_plan_sections" */
  delete_safety_plan_sections?: Maybe<Safety_Plan_Sections_Mutation_Response>;
  /** delete single row from the table: "safety_plan_sections" */
  delete_safety_plan_sections_by_pk?: Maybe<Safety_Plan_Sections>;
  /** delete data from the table: "safety_plan_template" */
  delete_safety_plan_template?: Maybe<Safety_Plan_Template_Mutation_Response>;
  /** delete single row from the table: "safety_plan_template" */
  delete_safety_plan_template_by_pk?: Maybe<Safety_Plan_Template>;
  /** delete data from the table: "schedule_blackout_dates" */
  delete_schedule_blackout_dates?: Maybe<Schedule_Blackout_Dates_Mutation_Response>;
  /** delete single row from the table: "schedule_blackout_dates" */
  delete_schedule_blackout_dates_by_pk?: Maybe<Schedule_Blackout_Dates>;
  /** delete data from the table: "transcript.action_plans" */
  delete_transcript_action_plans?: Maybe<Transcript_Action_Plans_Mutation_Response>;
  /** delete single row from the table: "transcript.action_plans" */
  delete_transcript_action_plans_by_pk?: Maybe<Transcript_Action_Plans>;
  /** delete data from the table: "transcript.progress_notes" */
  delete_transcript_progress_notes?: Maybe<Transcript_Progress_Notes_Mutation_Response>;
  /** delete single row from the table: "transcript.progress_notes" */
  delete_transcript_progress_notes_by_pk?: Maybe<Transcript_Progress_Notes>;
  /** delete data from the table: "transcript.score_results" */
  delete_transcript_score_results?: Maybe<Transcript_Score_Results_Mutation_Response>;
  /** delete single row from the table: "transcript.score_results" */
  delete_transcript_score_results_by_pk?: Maybe<Transcript_Score_Results>;
  /** delete data from the table: "transcript.sessions" */
  delete_transcript_sessions?: Maybe<Transcript_Sessions_Mutation_Response>;
  /** delete single row from the table: "transcript.sessions" */
  delete_transcript_sessions_by_pk?: Maybe<Transcript_Sessions>;
  /** delete data from the table: "transcript.transcripts" */
  delete_transcript_transcripts?: Maybe<Transcript_Transcripts_Mutation_Response>;
  /** delete single row from the table: "transcript.transcripts" */
  delete_transcript_transcripts_by_pk?: Maybe<Transcript_Transcripts>;
  /** delete data from the table: "user_feature_flag" */
  delete_user_feature_flag?: Maybe<User_Feature_Flag_Mutation_Response>;
  /** delete single row from the table: "user_feature_flag" */
  delete_user_feature_flag_by_pk?: Maybe<User_Feature_Flag>;
  /** delete data from the table: "user_group_code" */
  delete_user_group_code?: Maybe<User_Group_Code_Mutation_Response>;
  /** delete single row from the table: "user_group_code" */
  delete_user_group_code_by_pk?: Maybe<User_Group_Code>;
  /** delete data from the table: "user_insights" */
  delete_user_insights?: Maybe<User_Insights_Mutation_Response>;
  /** delete single row from the table: "user_insights" */
  delete_user_insights_by_pk?: Maybe<User_Insights>;
  /** delete data from the table: "user_invites" */
  delete_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** delete single row from the table: "user_invites" */
  delete_user_invites_by_pk?: Maybe<User_Invites>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "users_insights_display_status" */
  delete_users_insights_display_status?: Maybe<Users_Insights_Display_Status_Mutation_Response>;
  /** delete single row from the table: "users_insights_display_status" */
  delete_users_insights_display_status_by_pk?: Maybe<Users_Insights_Display_Status>;
  /** insert data into the table: "activity" */
  insert_activity?: Maybe<Activity_Mutation_Response>;
  /** insert a single row into the table: "activity" */
  insert_activity_one?: Maybe<Activity>;
  /** insert data into the table: "activity_rating" */
  insert_activity_rating?: Maybe<Activity_Rating_Mutation_Response>;
  /** insert a single row into the table: "activity_rating" */
  insert_activity_rating_one?: Maybe<Activity_Rating>;
  /** insert data into the table: "activity_resource" */
  insert_activity_resource?: Maybe<Activity_Resource_Mutation_Response>;
  /** insert data into the table: "activity_resource_category" */
  insert_activity_resource_category?: Maybe<Activity_Resource_Category_Mutation_Response>;
  /** insert a single row into the table: "activity_resource_category" */
  insert_activity_resource_category_one?: Maybe<Activity_Resource_Category>;
  /** insert a single row into the table: "activity_resource" */
  insert_activity_resource_one?: Maybe<Activity_Resource>;
  /** insert data into the table: "activity_sub_category" */
  insert_activity_sub_category?: Maybe<Activity_Sub_Category_Mutation_Response>;
  /** insert a single row into the table: "activity_sub_category" */
  insert_activity_sub_category_one?: Maybe<Activity_Sub_Category>;
  /** insert data into the table: "activity_suggested_activities" */
  insert_activity_suggested_activities?: Maybe<Activity_Suggested_Activities_Mutation_Response>;
  /** insert a single row into the table: "activity_suggested_activities" */
  insert_activity_suggested_activities_one?: Maybe<Activity_Suggested_Activities>;
  /** insert data into the table: "assessment_answers" */
  insert_assessment_answers?: Maybe<Assessment_Answers_Mutation_Response>;
  /** insert a single row into the table: "assessment_answers" */
  insert_assessment_answers_one?: Maybe<Assessment_Answers>;
  /** insert data into the table: "assessment_branching_rules" */
  insert_assessment_branching_rules?: Maybe<Assessment_Branching_Rules_Mutation_Response>;
  /** insert a single row into the table: "assessment_branching_rules" */
  insert_assessment_branching_rules_one?: Maybe<Assessment_Branching_Rules>;
  /** insert data into the table: "assessment_pages" */
  insert_assessment_pages?: Maybe<Assessment_Pages_Mutation_Response>;
  /** insert a single row into the table: "assessment_pages" */
  insert_assessment_pages_one?: Maybe<Assessment_Pages>;
  /** insert data into the table: "assessment_question_custom_prompt" */
  insert_assessment_question_custom_prompt?: Maybe<Assessment_Question_Custom_Prompt_Mutation_Response>;
  /** insert a single row into the table: "assessment_question_custom_prompt" */
  insert_assessment_question_custom_prompt_one?: Maybe<Assessment_Question_Custom_Prompt>;
  /** insert data into the table: "assessment_questions" */
  insert_assessment_questions?: Maybe<Assessment_Questions_Mutation_Response>;
  /** insert a single row into the table: "assessment_questions" */
  insert_assessment_questions_one?: Maybe<Assessment_Questions>;
  /** insert data into the table: "assessment_takes" */
  insert_assessment_takes?: Maybe<Assessment_Takes_Mutation_Response>;
  /** insert a single row into the table: "assessment_takes" */
  insert_assessment_takes_one?: Maybe<Assessment_Takes>;
  /** insert data into the table: "assessments" */
  insert_assessments?: Maybe<Assessments_Mutation_Response>;
  /** insert a single row into the table: "assessments" */
  insert_assessments_one?: Maybe<Assessments>;
  /** insert data into the table: "auth.account_migration_log" */
  insert_auth_account_migration_log?: Maybe<Auth_Account_Migration_Log_Mutation_Response>;
  /** insert a single row into the table: "auth.account_migration_log" */
  insert_auth_account_migration_log_one?: Maybe<Auth_Account_Migration_Log>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: Maybe<Auth_Account_Providers_Mutation_Response>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: Maybe<Auth_Account_Providers>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: Maybe<Auth_Account_Roles_Mutation_Response>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: Maybe<Auth_Account_Roles>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: Maybe<Auth_Accounts_Mutation_Response>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: Maybe<Auth_Accounts>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: Maybe<Auth_Providers_Mutation_Response>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: Maybe<Auth_Providers>;
  /** insert data into the table: "auth.refresh_token_usage_log" */
  insert_auth_refresh_token_usage_log?: Maybe<Auth_Refresh_Token_Usage_Log_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_token_usage_log" */
  insert_auth_refresh_token_usage_log_one?: Maybe<Auth_Refresh_Token_Usage_Log>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: Maybe<Auth_Refresh_Tokens_Mutation_Response>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: Maybe<Auth_Refresh_Tokens>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: Maybe<Auth_Roles_Mutation_Response>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: Maybe<Auth_Roles>;
  /** insert data into the table: "casemix_category" */
  insert_casemix_category?: Maybe<Casemix_Category_Mutation_Response>;
  /** insert a single row into the table: "casemix_category" */
  insert_casemix_category_one?: Maybe<Casemix_Category>;
  /** insert data into the table: "client_demographics" */
  insert_client_demographics?: Maybe<Client_Demographics_Mutation_Response>;
  /** insert a single row into the table: "client_demographics" */
  insert_client_demographics_one?: Maybe<Client_Demographics>;
  /** insert data into the table: "daily_features" */
  insert_daily_features?: Maybe<Daily_Features_Mutation_Response>;
  /** insert a single row into the table: "daily_features" */
  insert_daily_features_one?: Maybe<Daily_Features>;
  /** insert data into the table: "ehr.client_invite_codes" */
  insert_ehr_client_invite_codes?: Maybe<Ehr_Client_Invite_Codes_Mutation_Response>;
  /** insert a single row into the table: "ehr.client_invite_codes" */
  insert_ehr_client_invite_codes_one?: Maybe<Ehr_Client_Invite_Codes>;
  /** insert data into the table: "ehr.ehr_practitioner_map" */
  insert_ehr_ehr_practitioner_map?: Maybe<Ehr_Ehr_Practitioner_Map_Mutation_Response>;
  /** insert a single row into the table: "ehr.ehr_practitioner_map" */
  insert_ehr_ehr_practitioner_map_one?: Maybe<Ehr_Ehr_Practitioner_Map>;
  /** insert data into the table: "ehr.xealth_event_notification" */
  insert_ehr_xealth_event_notification?: Maybe<Ehr_Xealth_Event_Notification_Mutation_Response>;
  /** insert a single row into the table: "ehr.xealth_event_notification" */
  insert_ehr_xealth_event_notification_one?: Maybe<Ehr_Xealth_Event_Notification>;
  /** insert data into the table: "ehr.xealth_preorder_form" */
  insert_ehr_xealth_preorder_form?: Maybe<Ehr_Xealth_Preorder_Form_Mutation_Response>;
  /** insert a single row into the table: "ehr.xealth_preorder_form" */
  insert_ehr_xealth_preorder_form_one?: Maybe<Ehr_Xealth_Preorder_Form>;
  /** insert data into the table: "ehr.xealth_preorder_invite_map" */
  insert_ehr_xealth_preorder_invite_map?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Mutation_Response>;
  /** insert a single row into the table: "ehr.xealth_preorder_invite_map" */
  insert_ehr_xealth_preorder_invite_map_one?: Maybe<Ehr_Xealth_Preorder_Invite_Map>;
  /** insert data into the table: "enum_activity_category" */
  insert_enum_activity_category?: Maybe<Enum_Activity_Category_Mutation_Response>;
  /** insert a single row into the table: "enum_activity_category" */
  insert_enum_activity_category_one?: Maybe<Enum_Activity_Category>;
  /** insert data into the table: "enum_activity_resource_type" */
  insert_enum_activity_resource_type?: Maybe<Enum_Activity_Resource_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_activity_resource_type" */
  insert_enum_activity_resource_type_one?: Maybe<Enum_Activity_Resource_Type>;
  /** insert data into the table: "enum_completion_status" */
  insert_enum_completion_status?: Maybe<Enum_Completion_Status_Mutation_Response>;
  /** insert a single row into the table: "enum_completion_status" */
  insert_enum_completion_status_one?: Maybe<Enum_Completion_Status>;
  /** insert data into the table: "enum_feature_direction" */
  insert_enum_feature_direction?: Maybe<Enum_Feature_Direction_Mutation_Response>;
  /** insert a single row into the table: "enum_feature_direction" */
  insert_enum_feature_direction_one?: Maybe<Enum_Feature_Direction>;
  /** insert data into the table: "enum_feature_type" */
  insert_enum_feature_type?: Maybe<Enum_Feature_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_feature_type" */
  insert_enum_feature_type_one?: Maybe<Enum_Feature_Type>;
  /** insert data into the table: "enum_gender" */
  insert_enum_gender?: Maybe<Enum_Gender_Mutation_Response>;
  /** insert a single row into the table: "enum_gender" */
  insert_enum_gender_one?: Maybe<Enum_Gender>;
  /** insert data into the table: "enum_insight_content_type" */
  insert_enum_insight_content_type?: Maybe<Enum_Insight_Content_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_insight_content_type" */
  insert_enum_insight_content_type_one?: Maybe<Enum_Insight_Content_Type>;
  /** insert data into the table: "enum_mobile_permission_status" */
  insert_enum_mobile_permission_status?: Maybe<Enum_Mobile_Permission_Status_Mutation_Response>;
  /** insert a single row into the table: "enum_mobile_permission_status" */
  insert_enum_mobile_permission_status_one?: Maybe<Enum_Mobile_Permission_Status>;
  /** insert data into the table: "enum_mobile_permission_type" */
  insert_enum_mobile_permission_type?: Maybe<Enum_Mobile_Permission_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_mobile_permission_type" */
  insert_enum_mobile_permission_type_one?: Maybe<Enum_Mobile_Permission_Type>;
  /** insert data into the table: "enum_outcome" */
  insert_enum_outcome?: Maybe<Enum_Outcome_Mutation_Response>;
  /** insert a single row into the table: "enum_outcome" */
  insert_enum_outcome_one?: Maybe<Enum_Outcome>;
  /** insert data into the table: "enum_question_type" */
  insert_enum_question_type?: Maybe<Enum_Question_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_question_type" */
  insert_enum_question_type_one?: Maybe<Enum_Question_Type>;
  /** insert data into the table: "enum_racial_ethnic" */
  insert_enum_racial_ethnic?: Maybe<Enum_Racial_Ethnic_Mutation_Response>;
  /** insert a single row into the table: "enum_racial_ethnic" */
  insert_enum_racial_ethnic_one?: Maybe<Enum_Racial_Ethnic>;
  /** insert data into the table: "enum_resource_type" */
  insert_enum_resource_type?: Maybe<Enum_Resource_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_resource_type" */
  insert_enum_resource_type_one?: Maybe<Enum_Resource_Type>;
  /** insert data into the table: "enum_safety_plan_section_category_type" */
  insert_enum_safety_plan_section_category_type?: Maybe<Enum_Safety_Plan_Section_Category_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_safety_plan_section_category_type" */
  insert_enum_safety_plan_section_category_type_one?: Maybe<Enum_Safety_Plan_Section_Category_Type>;
  /** insert data into the table: "enum_safety_plan_section_icons" */
  insert_enum_safety_plan_section_icons?: Maybe<Enum_Safety_Plan_Section_Icons_Mutation_Response>;
  /** insert a single row into the table: "enum_safety_plan_section_icons" */
  insert_enum_safety_plan_section_icons_one?: Maybe<Enum_Safety_Plan_Section_Icons>;
  /** insert data into the table: "enum_safety_plan_status" */
  insert_enum_safety_plan_status?: Maybe<Enum_Safety_Plan_Status_Mutation_Response>;
  /** insert a single row into the table: "enum_safety_plan_status" */
  insert_enum_safety_plan_status_one?: Maybe<Enum_Safety_Plan_Status>;
  /** insert data into the table: "enum_safety_plan_type" */
  insert_enum_safety_plan_type?: Maybe<Enum_Safety_Plan_Type_Mutation_Response>;
  /** insert a single row into the table: "enum_safety_plan_type" */
  insert_enum_safety_plan_type_one?: Maybe<Enum_Safety_Plan_Type>;
  /** insert data into the table: "enum_trend_direction" */
  insert_enum_trend_direction?: Maybe<Enum_Trend_Direction_Mutation_Response>;
  /** insert a single row into the table: "enum_trend_direction" */
  insert_enum_trend_direction_one?: Maybe<Enum_Trend_Direction>;
  /** insert data into the table: "feature_report_feature_coefficients" */
  insert_feature_report_feature_coefficients?: Maybe<Feature_Report_Feature_Coefficients_Mutation_Response>;
  /** insert a single row into the table: "feature_report_feature_coefficients" */
  insert_feature_report_feature_coefficients_one?: Maybe<Feature_Report_Feature_Coefficients>;
  /** insert data into the table: "feature_report_features" */
  insert_feature_report_features?: Maybe<Feature_Report_Features_Mutation_Response>;
  /** insert a single row into the table: "feature_report_features" */
  insert_feature_report_features_one?: Maybe<Feature_Report_Features>;
  /** insert data into the table: "feature_reports" */
  insert_feature_reports?: Maybe<Feature_Reports_Mutation_Response>;
  /** insert a single row into the table: "feature_reports" */
  insert_feature_reports_one?: Maybe<Feature_Reports>;
  /** insert data into the table: "group_code" */
  insert_group_code?: Maybe<Group_Code_Mutation_Response>;
  /** insert a single row into the table: "group_code" */
  insert_group_code_one?: Maybe<Group_Code>;
  /** insert data into the table: "insight_articles" */
  insert_insight_articles?: Maybe<Insight_Articles_Mutation_Response>;
  /** insert a single row into the table: "insight_articles" */
  insert_insight_articles_one?: Maybe<Insight_Articles>;
  /** insert data into the table: "insight_combos" */
  insert_insight_combos?: Maybe<Insight_Combos_Mutation_Response>;
  /** insert a single row into the table: "insight_combos" */
  insert_insight_combos_one?: Maybe<Insight_Combos>;
  /** insert data into the table: "insight_hows" */
  insert_insight_hows?: Maybe<Insight_Hows_Mutation_Response>;
  /** insert a single row into the table: "insight_hows" */
  insert_insight_hows_one?: Maybe<Insight_Hows>;
  /** insert data into the table: "insight_plan_article" */
  insert_insight_plan_article?: Maybe<Insight_Plan_Article_Mutation_Response>;
  /** insert a single row into the table: "insight_plan_article" */
  insert_insight_plan_article_one?: Maybe<Insight_Plan_Article>;
  /** insert data into the table: "insight_plan_text" */
  insert_insight_plan_text?: Maybe<Insight_Plan_Text_Mutation_Response>;
  /** insert a single row into the table: "insight_plan_text" */
  insert_insight_plan_text_one?: Maybe<Insight_Plan_Text>;
  /** insert data into the table: "insight_plans" */
  insert_insight_plans?: Maybe<Insight_Plans_Mutation_Response>;
  /** insert a single row into the table: "insight_plans" */
  insert_insight_plans_one?: Maybe<Insight_Plans>;
  /** insert data into the table: "insight_questions" */
  insert_insight_questions?: Maybe<Insight_Questions_Mutation_Response>;
  /** insert a single row into the table: "insight_questions" */
  insert_insight_questions_one?: Maybe<Insight_Questions>;
  /** insert data into the table: "insight_recipes" */
  insert_insight_recipes?: Maybe<Insight_Recipes_Mutation_Response>;
  /** insert a single row into the table: "insight_recipes" */
  insert_insight_recipes_one?: Maybe<Insight_Recipes>;
  /** insert data into the table: "insight_reflect" */
  insert_insight_reflect?: Maybe<Insight_Reflect_Mutation_Response>;
  /** insert a single row into the table: "insight_reflect" */
  insert_insight_reflect_one?: Maybe<Insight_Reflect>;
  /** insert data into the table: "insight_reflect_text" */
  insert_insight_reflect_text?: Maybe<Insight_Reflect_Text_Mutation_Response>;
  /** insert a single row into the table: "insight_reflect_text" */
  insert_insight_reflect_text_one?: Maybe<Insight_Reflect_Text>;
  /** insert data into the table: "insight_resources" */
  insert_insight_resources?: Maybe<Insight_Resources_Mutation_Response>;
  /** insert a single row into the table: "insight_resources" */
  insert_insight_resources_one?: Maybe<Insight_Resources>;
  /** insert data into the table: "insight_texts" */
  insert_insight_texts?: Maybe<Insight_Texts_Mutation_Response>;
  /** insert a single row into the table: "insight_texts" */
  insert_insight_texts_one?: Maybe<Insight_Texts>;
  /** insert data into the table: "insight_tips" */
  insert_insight_tips?: Maybe<Insight_Tips_Mutation_Response>;
  /** insert a single row into the table: "insight_tips" */
  insert_insight_tips_one?: Maybe<Insight_Tips>;
  /** insert data into the table: "insight_whys" */
  insert_insight_whys?: Maybe<Insight_Whys_Mutation_Response>;
  /** insert a single row into the table: "insight_whys" */
  insert_insight_whys_one?: Maybe<Insight_Whys>;
  /** insert data into the table: "invite_codes" */
  insert_invite_codes?: Maybe<Invite_Codes_Mutation_Response>;
  /** insert a single row into the table: "invite_codes" */
  insert_invite_codes_one?: Maybe<Invite_Codes>;
  /** insert data into the table: "logs" */
  insert_logs?: Maybe<Logs_Mutation_Response>;
  /** insert a single row into the table: "logs" */
  insert_logs_one?: Maybe<Logs>;
  /** insert data into the table: "mobile_device_data" */
  insert_mobile_device_data?: Maybe<Mobile_Device_Data_Mutation_Response>;
  /** insert a single row into the table: "mobile_device_data" */
  insert_mobile_device_data_one?: Maybe<Mobile_Device_Data>;
  /** insert data into the table: "mobile_permissions" */
  insert_mobile_permissions?: Maybe<Mobile_Permissions_Mutation_Response>;
  /** insert a single row into the table: "mobile_permissions" */
  insert_mobile_permissions_one?: Maybe<Mobile_Permissions>;
  /** insert data into the table: "mobile_upload_log" */
  insert_mobile_upload_log?: Maybe<Mobile_Upload_Log_Mutation_Response>;
  /** insert a single row into the table: "mobile_upload_log" */
  insert_mobile_upload_log_one?: Maybe<Mobile_Upload_Log>;
  /** insert data into the table: "mood_measurements" */
  insert_mood_measurements?: Maybe<Mood_Measurements_Mutation_Response>;
  /** insert a single row into the table: "mood_measurements" */
  insert_mood_measurements_one?: Maybe<Mood_Measurements>;
  /** insert data into the table: "nudge_schedules" */
  insert_nudge_schedules?: Maybe<Nudge_Schedules_Mutation_Response>;
  /** insert a single row into the table: "nudge_schedules" */
  insert_nudge_schedules_one?: Maybe<Nudge_Schedules>;
  /** insert data into the table: "nudge_takes" */
  insert_nudge_takes?: Maybe<Nudge_Takes_Mutation_Response>;
  /** insert a single row into the table: "nudge_takes" */
  insert_nudge_takes_one?: Maybe<Nudge_Takes>;
  /** insert data into the table: "nudges" */
  insert_nudges?: Maybe<Nudges_Mutation_Response>;
  /** insert a single row into the table: "nudges" */
  insert_nudges_one?: Maybe<Nudges>;
  /** insert data into the table: "organization_admins" */
  insert_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** insert a single row into the table: "organization_admins" */
  insert_organization_admins_one?: Maybe<Organization_Admins>;
  /** insert data into the table: "organization_features" */
  insert_organization_features?: Maybe<Organization_Features_Mutation_Response>;
  /** insert a single row into the table: "organization_features" */
  insert_organization_features_one?: Maybe<Organization_Features>;
  /** insert data into the table: "organization_member_roles" */
  insert_organization_member_roles?: Maybe<Organization_Member_Roles_Mutation_Response>;
  /** insert a single row into the table: "organization_member_roles" */
  insert_organization_member_roles_one?: Maybe<Organization_Member_Roles>;
  /** insert data into the table: "organization_members" */
  insert_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** insert a single row into the table: "organization_members" */
  insert_organization_members_one?: Maybe<Organization_Members>;
  /** insert data into the table: "organization_supervisees" */
  insert_organization_supervisees?: Maybe<Organization_Supervisees_Mutation_Response>;
  /** insert a single row into the table: "organization_supervisees" */
  insert_organization_supervisees_one?: Maybe<Organization_Supervisees>;
  /** insert data into the table: "organization_supervisors" */
  insert_organization_supervisors?: Maybe<Organization_Supervisors_Mutation_Response>;
  /** insert a single row into the table: "organization_supervisors" */
  insert_organization_supervisors_one?: Maybe<Organization_Supervisors>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert a single row into the table: "organizations" */
  insert_organizations_one?: Maybe<Organizations>;
  /** insert data into the table: "questionnaire_items" */
  insert_questionnaire_items?: Maybe<Questionnaire_Items_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_items" */
  insert_questionnaire_items_one?: Maybe<Questionnaire_Items>;
  /** insert data into the table: "questionnaire_response_options" */
  insert_questionnaire_response_options?: Maybe<Questionnaire_Response_Options_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_response_options" */
  insert_questionnaire_response_options_one?: Maybe<Questionnaire_Response_Options>;
  /** insert data into the table: "questionnaire_responses" */
  insert_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_responses" */
  insert_questionnaire_responses_one?: Maybe<Questionnaire_Responses>;
  /** insert data into the table: "questionnaire_risk_alert_contacts" */
  insert_questionnaire_risk_alert_contacts?: Maybe<Questionnaire_Risk_Alert_Contacts_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_risk_alert_contacts" */
  insert_questionnaire_risk_alert_contacts_one?: Maybe<Questionnaire_Risk_Alert_Contacts>;
  /** insert data into the table: "questionnaire_schedules" */
  insert_questionnaire_schedules?: Maybe<Questionnaire_Schedules_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_schedules" */
  insert_questionnaire_schedules_one?: Maybe<Questionnaire_Schedules>;
  /** insert data into the table: "questionnaire_scoring" */
  insert_questionnaire_scoring?: Maybe<Questionnaire_Scoring_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_scoring" */
  insert_questionnaire_scoring_one?: Maybe<Questionnaire_Scoring>;
  /** insert data into the table: "questionnaire_takes" */
  insert_questionnaire_takes?: Maybe<Questionnaire_Takes_Mutation_Response>;
  /** insert a single row into the table: "questionnaire_takes" */
  insert_questionnaire_takes_one?: Maybe<Questionnaire_Takes>;
  /** insert data into the table: "questionnaires" */
  insert_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** insert a single row into the table: "questionnaires" */
  insert_questionnaires_one?: Maybe<Questionnaires>;
  /** insert data into the table: "relapse_prevention_place_visits" */
  insert_relapse_prevention_place_visits?: Maybe<Relapse_Prevention_Place_Visits_Mutation_Response>;
  /** insert a single row into the table: "relapse_prevention_place_visits" */
  insert_relapse_prevention_place_visits_one?: Maybe<Relapse_Prevention_Place_Visits>;
  /** insert data into the table: "relapse_prevention_places" */
  insert_relapse_prevention_places?: Maybe<Relapse_Prevention_Places_Mutation_Response>;
  /** insert a single row into the table: "relapse_prevention_places" */
  insert_relapse_prevention_places_one?: Maybe<Relapse_Prevention_Places>;
  /** insert data into the table: "resources" */
  insert_resources?: Maybe<Resources_Mutation_Response>;
  /** insert a single row into the table: "resources" */
  insert_resources_one?: Maybe<Resources>;
  /** insert data into the table: "resources_orgs" */
  insert_resources_orgs?: Maybe<Resources_Orgs_Mutation_Response>;
  /** insert a single row into the table: "resources_orgs" */
  insert_resources_orgs_one?: Maybe<Resources_Orgs>;
  /** insert data into the table: "risk_alerts_log" */
  insert_risk_alerts_log?: Maybe<Risk_Alerts_Log_Mutation_Response>;
  /** insert a single row into the table: "risk_alerts_log" */
  insert_risk_alerts_log_one?: Maybe<Risk_Alerts_Log>;
  /** insert data into the table: "risk_alerts_recipients_log" */
  insert_risk_alerts_recipients_log?: Maybe<Risk_Alerts_Recipients_Log_Mutation_Response>;
  /** insert a single row into the table: "risk_alerts_recipients_log" */
  insert_risk_alerts_recipients_log_one?: Maybe<Risk_Alerts_Recipients_Log>;
  /** insert data into the table: "role_capabilities" */
  insert_role_capabilities?: Maybe<Role_Capabilities_Mutation_Response>;
  /** insert a single row into the table: "role_capabilities" */
  insert_role_capabilities_one?: Maybe<Role_Capabilities>;
  /** insert data into the table: "safety_checklist_recipients_log" */
  insert_safety_checklist_recipients_log?: Maybe<Safety_Checklist_Recipients_Log_Mutation_Response>;
  /** insert a single row into the table: "safety_checklist_recipients_log" */
  insert_safety_checklist_recipients_log_one?: Maybe<Safety_Checklist_Recipients_Log>;
  /** insert data into the table: "safety_plan" */
  insert_safety_plan?: Maybe<Safety_Plan_Mutation_Response>;
  /** insert data into the table: "safety_plan_checklist_items" */
  insert_safety_plan_checklist_items?: Maybe<Safety_Plan_Checklist_Items_Mutation_Response>;
  /** insert a single row into the table: "safety_plan_checklist_items" */
  insert_safety_plan_checklist_items_one?: Maybe<Safety_Plan_Checklist_Items>;
  /** insert a single row into the table: "safety_plan" */
  insert_safety_plan_one?: Maybe<Safety_Plan>;
  /** insert data into the table: "safety_plan_response_options" */
  insert_safety_plan_response_options?: Maybe<Safety_Plan_Response_Options_Mutation_Response>;
  /** insert a single row into the table: "safety_plan_response_options" */
  insert_safety_plan_response_options_one?: Maybe<Safety_Plan_Response_Options>;
  /** insert data into the table: "safety_plan_section_category" */
  insert_safety_plan_section_category?: Maybe<Safety_Plan_Section_Category_Mutation_Response>;
  /** insert a single row into the table: "safety_plan_section_category" */
  insert_safety_plan_section_category_one?: Maybe<Safety_Plan_Section_Category>;
  /** insert data into the table: "safety_plan_sections" */
  insert_safety_plan_sections?: Maybe<Safety_Plan_Sections_Mutation_Response>;
  /** insert a single row into the table: "safety_plan_sections" */
  insert_safety_plan_sections_one?: Maybe<Safety_Plan_Sections>;
  /** insert data into the table: "safety_plan_template" */
  insert_safety_plan_template?: Maybe<Safety_Plan_Template_Mutation_Response>;
  /** insert a single row into the table: "safety_plan_template" */
  insert_safety_plan_template_one?: Maybe<Safety_Plan_Template>;
  /** insert data into the table: "schedule_blackout_dates" */
  insert_schedule_blackout_dates?: Maybe<Schedule_Blackout_Dates_Mutation_Response>;
  /** insert a single row into the table: "schedule_blackout_dates" */
  insert_schedule_blackout_dates_one?: Maybe<Schedule_Blackout_Dates>;
  /** insert data into the table: "transcript.action_plans" */
  insert_transcript_action_plans?: Maybe<Transcript_Action_Plans_Mutation_Response>;
  /** insert a single row into the table: "transcript.action_plans" */
  insert_transcript_action_plans_one?: Maybe<Transcript_Action_Plans>;
  /** insert data into the table: "transcript.progress_notes" */
  insert_transcript_progress_notes?: Maybe<Transcript_Progress_Notes_Mutation_Response>;
  /** insert a single row into the table: "transcript.progress_notes" */
  insert_transcript_progress_notes_one?: Maybe<Transcript_Progress_Notes>;
  /** insert data into the table: "transcript.score_results" */
  insert_transcript_score_results?: Maybe<Transcript_Score_Results_Mutation_Response>;
  /** insert a single row into the table: "transcript.score_results" */
  insert_transcript_score_results_one?: Maybe<Transcript_Score_Results>;
  /** insert data into the table: "transcript.sessions" */
  insert_transcript_sessions?: Maybe<Transcript_Sessions_Mutation_Response>;
  /** insert a single row into the table: "transcript.sessions" */
  insert_transcript_sessions_one?: Maybe<Transcript_Sessions>;
  /** insert data into the table: "transcript.transcripts" */
  insert_transcript_transcripts?: Maybe<Transcript_Transcripts_Mutation_Response>;
  /** insert a single row into the table: "transcript.transcripts" */
  insert_transcript_transcripts_one?: Maybe<Transcript_Transcripts>;
  /** insert data into the table: "user_feature_flag" */
  insert_user_feature_flag?: Maybe<User_Feature_Flag_Mutation_Response>;
  /** insert a single row into the table: "user_feature_flag" */
  insert_user_feature_flag_one?: Maybe<User_Feature_Flag>;
  /** insert data into the table: "user_group_code" */
  insert_user_group_code?: Maybe<User_Group_Code_Mutation_Response>;
  /** insert a single row into the table: "user_group_code" */
  insert_user_group_code_one?: Maybe<User_Group_Code>;
  /** insert data into the table: "user_insights" */
  insert_user_insights?: Maybe<User_Insights_Mutation_Response>;
  /** insert a single row into the table: "user_insights" */
  insert_user_insights_one?: Maybe<User_Insights>;
  /** insert data into the table: "user_invites" */
  insert_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** insert a single row into the table: "user_invites" */
  insert_user_invites_one?: Maybe<User_Invites>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "users_insights_display_status" */
  insert_users_insights_display_status?: Maybe<Users_Insights_Display_Status_Mutation_Response>;
  /** insert a single row into the table: "users_insights_display_status" */
  insert_users_insights_display_status_one?: Maybe<Users_Insights_Display_Status>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "activity" */
  update_activity?: Maybe<Activity_Mutation_Response>;
  /** update single row of the table: "activity" */
  update_activity_by_pk?: Maybe<Activity>;
  /** update multiples rows of table: "activity" */
  update_activity_many?: Maybe<Array<Maybe<Activity_Mutation_Response>>>;
  /** update data of the table: "activity_rating" */
  update_activity_rating?: Maybe<Activity_Rating_Mutation_Response>;
  /** update single row of the table: "activity_rating" */
  update_activity_rating_by_pk?: Maybe<Activity_Rating>;
  /** update multiples rows of table: "activity_rating" */
  update_activity_rating_many?: Maybe<Array<Maybe<Activity_Rating_Mutation_Response>>>;
  /** update data of the table: "activity_resource" */
  update_activity_resource?: Maybe<Activity_Resource_Mutation_Response>;
  /** update single row of the table: "activity_resource" */
  update_activity_resource_by_pk?: Maybe<Activity_Resource>;
  /** update data of the table: "activity_resource_category" */
  update_activity_resource_category?: Maybe<Activity_Resource_Category_Mutation_Response>;
  /** update single row of the table: "activity_resource_category" */
  update_activity_resource_category_by_pk?: Maybe<Activity_Resource_Category>;
  /** update multiples rows of table: "activity_resource_category" */
  update_activity_resource_category_many?: Maybe<Array<Maybe<Activity_Resource_Category_Mutation_Response>>>;
  /** update multiples rows of table: "activity_resource" */
  update_activity_resource_many?: Maybe<Array<Maybe<Activity_Resource_Mutation_Response>>>;
  /** update data of the table: "activity_sub_category" */
  update_activity_sub_category?: Maybe<Activity_Sub_Category_Mutation_Response>;
  /** update single row of the table: "activity_sub_category" */
  update_activity_sub_category_by_pk?: Maybe<Activity_Sub_Category>;
  /** update multiples rows of table: "activity_sub_category" */
  update_activity_sub_category_many?: Maybe<Array<Maybe<Activity_Sub_Category_Mutation_Response>>>;
  /** update data of the table: "activity_suggested_activities" */
  update_activity_suggested_activities?: Maybe<Activity_Suggested_Activities_Mutation_Response>;
  /** update single row of the table: "activity_suggested_activities" */
  update_activity_suggested_activities_by_pk?: Maybe<Activity_Suggested_Activities>;
  /** update multiples rows of table: "activity_suggested_activities" */
  update_activity_suggested_activities_many?: Maybe<Array<Maybe<Activity_Suggested_Activities_Mutation_Response>>>;
  /** update data of the table: "assessment_answers" */
  update_assessment_answers?: Maybe<Assessment_Answers_Mutation_Response>;
  /** update single row of the table: "assessment_answers" */
  update_assessment_answers_by_pk?: Maybe<Assessment_Answers>;
  /** update multiples rows of table: "assessment_answers" */
  update_assessment_answers_many?: Maybe<Array<Maybe<Assessment_Answers_Mutation_Response>>>;
  /** update data of the table: "assessment_branching_rules" */
  update_assessment_branching_rules?: Maybe<Assessment_Branching_Rules_Mutation_Response>;
  /** update single row of the table: "assessment_branching_rules" */
  update_assessment_branching_rules_by_pk?: Maybe<Assessment_Branching_Rules>;
  /** update multiples rows of table: "assessment_branching_rules" */
  update_assessment_branching_rules_many?: Maybe<Array<Maybe<Assessment_Branching_Rules_Mutation_Response>>>;
  /** update data of the table: "assessment_pages" */
  update_assessment_pages?: Maybe<Assessment_Pages_Mutation_Response>;
  /** update single row of the table: "assessment_pages" */
  update_assessment_pages_by_pk?: Maybe<Assessment_Pages>;
  /** update multiples rows of table: "assessment_pages" */
  update_assessment_pages_many?: Maybe<Array<Maybe<Assessment_Pages_Mutation_Response>>>;
  /** update data of the table: "assessment_question_custom_prompt" */
  update_assessment_question_custom_prompt?: Maybe<Assessment_Question_Custom_Prompt_Mutation_Response>;
  /** update single row of the table: "assessment_question_custom_prompt" */
  update_assessment_question_custom_prompt_by_pk?: Maybe<Assessment_Question_Custom_Prompt>;
  /** update multiples rows of table: "assessment_question_custom_prompt" */
  update_assessment_question_custom_prompt_many?: Maybe<Array<Maybe<Assessment_Question_Custom_Prompt_Mutation_Response>>>;
  /** update data of the table: "assessment_questions" */
  update_assessment_questions?: Maybe<Assessment_Questions_Mutation_Response>;
  /** update single row of the table: "assessment_questions" */
  update_assessment_questions_by_pk?: Maybe<Assessment_Questions>;
  /** update multiples rows of table: "assessment_questions" */
  update_assessment_questions_many?: Maybe<Array<Maybe<Assessment_Questions_Mutation_Response>>>;
  /** update data of the table: "assessment_takes" */
  update_assessment_takes?: Maybe<Assessment_Takes_Mutation_Response>;
  /** update single row of the table: "assessment_takes" */
  update_assessment_takes_by_pk?: Maybe<Assessment_Takes>;
  /** update multiples rows of table: "assessment_takes" */
  update_assessment_takes_many?: Maybe<Array<Maybe<Assessment_Takes_Mutation_Response>>>;
  /** update data of the table: "assessments" */
  update_assessments?: Maybe<Assessments_Mutation_Response>;
  /** update single row of the table: "assessments" */
  update_assessments_by_pk?: Maybe<Assessments>;
  /** update multiples rows of table: "assessments" */
  update_assessments_many?: Maybe<Array<Maybe<Assessments_Mutation_Response>>>;
  /** update data of the table: "auth.account_migration_log" */
  update_auth_account_migration_log?: Maybe<Auth_Account_Migration_Log_Mutation_Response>;
  /** update single row of the table: "auth.account_migration_log" */
  update_auth_account_migration_log_by_pk?: Maybe<Auth_Account_Migration_Log>;
  /** update multiples rows of table: "auth.account_migration_log" */
  update_auth_account_migration_log_many?: Maybe<Array<Maybe<Auth_Account_Migration_Log_Mutation_Response>>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: Maybe<Auth_Account_Providers_Mutation_Response>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: Maybe<Auth_Account_Providers>;
  /** update multiples rows of table: "auth.account_providers" */
  update_auth_account_providers_many?: Maybe<Array<Maybe<Auth_Account_Providers_Mutation_Response>>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: Maybe<Auth_Account_Roles_Mutation_Response>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: Maybe<Auth_Account_Roles>;
  /** update multiples rows of table: "auth.account_roles" */
  update_auth_account_roles_many?: Maybe<Array<Maybe<Auth_Account_Roles_Mutation_Response>>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: Maybe<Auth_Accounts_Mutation_Response>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: Maybe<Auth_Accounts>;
  /** update multiples rows of table: "auth.accounts" */
  update_auth_accounts_many?: Maybe<Array<Maybe<Auth_Accounts_Mutation_Response>>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: Maybe<Auth_Providers_Mutation_Response>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: Maybe<Auth_Providers>;
  /** update multiples rows of table: "auth.providers" */
  update_auth_providers_many?: Maybe<Array<Maybe<Auth_Providers_Mutation_Response>>>;
  /** update data of the table: "auth.refresh_token_usage_log" */
  update_auth_refresh_token_usage_log?: Maybe<Auth_Refresh_Token_Usage_Log_Mutation_Response>;
  /** update single row of the table: "auth.refresh_token_usage_log" */
  update_auth_refresh_token_usage_log_by_pk?: Maybe<Auth_Refresh_Token_Usage_Log>;
  /** update multiples rows of table: "auth.refresh_token_usage_log" */
  update_auth_refresh_token_usage_log_many?: Maybe<Array<Maybe<Auth_Refresh_Token_Usage_Log_Mutation_Response>>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: Maybe<Auth_Refresh_Tokens_Mutation_Response>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: Maybe<Auth_Refresh_Tokens>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_many?: Maybe<Array<Maybe<Auth_Refresh_Tokens_Mutation_Response>>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: Maybe<Auth_Roles_Mutation_Response>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: Maybe<Auth_Roles>;
  /** update multiples rows of table: "auth.roles" */
  update_auth_roles_many?: Maybe<Array<Maybe<Auth_Roles_Mutation_Response>>>;
  /** update data of the table: "casemix_category" */
  update_casemix_category?: Maybe<Casemix_Category_Mutation_Response>;
  /** update single row of the table: "casemix_category" */
  update_casemix_category_by_pk?: Maybe<Casemix_Category>;
  /** update multiples rows of table: "casemix_category" */
  update_casemix_category_many?: Maybe<Array<Maybe<Casemix_Category_Mutation_Response>>>;
  /** update data of the table: "client_demographics" */
  update_client_demographics?: Maybe<Client_Demographics_Mutation_Response>;
  /** update single row of the table: "client_demographics" */
  update_client_demographics_by_pk?: Maybe<Client_Demographics>;
  /** update multiples rows of table: "client_demographics" */
  update_client_demographics_many?: Maybe<Array<Maybe<Client_Demographics_Mutation_Response>>>;
  /** update data of the table: "daily_features" */
  update_daily_features?: Maybe<Daily_Features_Mutation_Response>;
  /** update single row of the table: "daily_features" */
  update_daily_features_by_pk?: Maybe<Daily_Features>;
  /** update multiples rows of table: "daily_features" */
  update_daily_features_many?: Maybe<Array<Maybe<Daily_Features_Mutation_Response>>>;
  /** update data of the table: "ehr.client_invite_codes" */
  update_ehr_client_invite_codes?: Maybe<Ehr_Client_Invite_Codes_Mutation_Response>;
  /** update single row of the table: "ehr.client_invite_codes" */
  update_ehr_client_invite_codes_by_pk?: Maybe<Ehr_Client_Invite_Codes>;
  /** update multiples rows of table: "ehr.client_invite_codes" */
  update_ehr_client_invite_codes_many?: Maybe<Array<Maybe<Ehr_Client_Invite_Codes_Mutation_Response>>>;
  /** update data of the table: "ehr.ehr_practitioner_map" */
  update_ehr_ehr_practitioner_map?: Maybe<Ehr_Ehr_Practitioner_Map_Mutation_Response>;
  /** update single row of the table: "ehr.ehr_practitioner_map" */
  update_ehr_ehr_practitioner_map_by_pk?: Maybe<Ehr_Ehr_Practitioner_Map>;
  /** update multiples rows of table: "ehr.ehr_practitioner_map" */
  update_ehr_ehr_practitioner_map_many?: Maybe<Array<Maybe<Ehr_Ehr_Practitioner_Map_Mutation_Response>>>;
  /** update data of the table: "ehr.xealth_event_notification" */
  update_ehr_xealth_event_notification?: Maybe<Ehr_Xealth_Event_Notification_Mutation_Response>;
  /** update single row of the table: "ehr.xealth_event_notification" */
  update_ehr_xealth_event_notification_by_pk?: Maybe<Ehr_Xealth_Event_Notification>;
  /** update multiples rows of table: "ehr.xealth_event_notification" */
  update_ehr_xealth_event_notification_many?: Maybe<Array<Maybe<Ehr_Xealth_Event_Notification_Mutation_Response>>>;
  /** update data of the table: "ehr.xealth_preorder_form" */
  update_ehr_xealth_preorder_form?: Maybe<Ehr_Xealth_Preorder_Form_Mutation_Response>;
  /** update single row of the table: "ehr.xealth_preorder_form" */
  update_ehr_xealth_preorder_form_by_pk?: Maybe<Ehr_Xealth_Preorder_Form>;
  /** update multiples rows of table: "ehr.xealth_preorder_form" */
  update_ehr_xealth_preorder_form_many?: Maybe<Array<Maybe<Ehr_Xealth_Preorder_Form_Mutation_Response>>>;
  /** update data of the table: "ehr.xealth_preorder_invite_map" */
  update_ehr_xealth_preorder_invite_map?: Maybe<Ehr_Xealth_Preorder_Invite_Map_Mutation_Response>;
  /** update single row of the table: "ehr.xealth_preorder_invite_map" */
  update_ehr_xealth_preorder_invite_map_by_pk?: Maybe<Ehr_Xealth_Preorder_Invite_Map>;
  /** update multiples rows of table: "ehr.xealth_preorder_invite_map" */
  update_ehr_xealth_preorder_invite_map_many?: Maybe<Array<Maybe<Ehr_Xealth_Preorder_Invite_Map_Mutation_Response>>>;
  /** update data of the table: "enum_activity_category" */
  update_enum_activity_category?: Maybe<Enum_Activity_Category_Mutation_Response>;
  /** update single row of the table: "enum_activity_category" */
  update_enum_activity_category_by_pk?: Maybe<Enum_Activity_Category>;
  /** update multiples rows of table: "enum_activity_category" */
  update_enum_activity_category_many?: Maybe<Array<Maybe<Enum_Activity_Category_Mutation_Response>>>;
  /** update data of the table: "enum_activity_resource_type" */
  update_enum_activity_resource_type?: Maybe<Enum_Activity_Resource_Type_Mutation_Response>;
  /** update single row of the table: "enum_activity_resource_type" */
  update_enum_activity_resource_type_by_pk?: Maybe<Enum_Activity_Resource_Type>;
  /** update multiples rows of table: "enum_activity_resource_type" */
  update_enum_activity_resource_type_many?: Maybe<Array<Maybe<Enum_Activity_Resource_Type_Mutation_Response>>>;
  /** update data of the table: "enum_completion_status" */
  update_enum_completion_status?: Maybe<Enum_Completion_Status_Mutation_Response>;
  /** update single row of the table: "enum_completion_status" */
  update_enum_completion_status_by_pk?: Maybe<Enum_Completion_Status>;
  /** update multiples rows of table: "enum_completion_status" */
  update_enum_completion_status_many?: Maybe<Array<Maybe<Enum_Completion_Status_Mutation_Response>>>;
  /** update data of the table: "enum_feature_direction" */
  update_enum_feature_direction?: Maybe<Enum_Feature_Direction_Mutation_Response>;
  /** update single row of the table: "enum_feature_direction" */
  update_enum_feature_direction_by_pk?: Maybe<Enum_Feature_Direction>;
  /** update multiples rows of table: "enum_feature_direction" */
  update_enum_feature_direction_many?: Maybe<Array<Maybe<Enum_Feature_Direction_Mutation_Response>>>;
  /** update data of the table: "enum_feature_type" */
  update_enum_feature_type?: Maybe<Enum_Feature_Type_Mutation_Response>;
  /** update single row of the table: "enum_feature_type" */
  update_enum_feature_type_by_pk?: Maybe<Enum_Feature_Type>;
  /** update multiples rows of table: "enum_feature_type" */
  update_enum_feature_type_many?: Maybe<Array<Maybe<Enum_Feature_Type_Mutation_Response>>>;
  /** update data of the table: "enum_gender" */
  update_enum_gender?: Maybe<Enum_Gender_Mutation_Response>;
  /** update single row of the table: "enum_gender" */
  update_enum_gender_by_pk?: Maybe<Enum_Gender>;
  /** update multiples rows of table: "enum_gender" */
  update_enum_gender_many?: Maybe<Array<Maybe<Enum_Gender_Mutation_Response>>>;
  /** update data of the table: "enum_insight_content_type" */
  update_enum_insight_content_type?: Maybe<Enum_Insight_Content_Type_Mutation_Response>;
  /** update single row of the table: "enum_insight_content_type" */
  update_enum_insight_content_type_by_pk?: Maybe<Enum_Insight_Content_Type>;
  /** update multiples rows of table: "enum_insight_content_type" */
  update_enum_insight_content_type_many?: Maybe<Array<Maybe<Enum_Insight_Content_Type_Mutation_Response>>>;
  /** update data of the table: "enum_mobile_permission_status" */
  update_enum_mobile_permission_status?: Maybe<Enum_Mobile_Permission_Status_Mutation_Response>;
  /** update single row of the table: "enum_mobile_permission_status" */
  update_enum_mobile_permission_status_by_pk?: Maybe<Enum_Mobile_Permission_Status>;
  /** update multiples rows of table: "enum_mobile_permission_status" */
  update_enum_mobile_permission_status_many?: Maybe<Array<Maybe<Enum_Mobile_Permission_Status_Mutation_Response>>>;
  /** update data of the table: "enum_mobile_permission_type" */
  update_enum_mobile_permission_type?: Maybe<Enum_Mobile_Permission_Type_Mutation_Response>;
  /** update single row of the table: "enum_mobile_permission_type" */
  update_enum_mobile_permission_type_by_pk?: Maybe<Enum_Mobile_Permission_Type>;
  /** update multiples rows of table: "enum_mobile_permission_type" */
  update_enum_mobile_permission_type_many?: Maybe<Array<Maybe<Enum_Mobile_Permission_Type_Mutation_Response>>>;
  /** update data of the table: "enum_outcome" */
  update_enum_outcome?: Maybe<Enum_Outcome_Mutation_Response>;
  /** update single row of the table: "enum_outcome" */
  update_enum_outcome_by_pk?: Maybe<Enum_Outcome>;
  /** update multiples rows of table: "enum_outcome" */
  update_enum_outcome_many?: Maybe<Array<Maybe<Enum_Outcome_Mutation_Response>>>;
  /** update data of the table: "enum_question_type" */
  update_enum_question_type?: Maybe<Enum_Question_Type_Mutation_Response>;
  /** update single row of the table: "enum_question_type" */
  update_enum_question_type_by_pk?: Maybe<Enum_Question_Type>;
  /** update multiples rows of table: "enum_question_type" */
  update_enum_question_type_many?: Maybe<Array<Maybe<Enum_Question_Type_Mutation_Response>>>;
  /** update data of the table: "enum_racial_ethnic" */
  update_enum_racial_ethnic?: Maybe<Enum_Racial_Ethnic_Mutation_Response>;
  /** update single row of the table: "enum_racial_ethnic" */
  update_enum_racial_ethnic_by_pk?: Maybe<Enum_Racial_Ethnic>;
  /** update multiples rows of table: "enum_racial_ethnic" */
  update_enum_racial_ethnic_many?: Maybe<Array<Maybe<Enum_Racial_Ethnic_Mutation_Response>>>;
  /** update data of the table: "enum_resource_type" */
  update_enum_resource_type?: Maybe<Enum_Resource_Type_Mutation_Response>;
  /** update single row of the table: "enum_resource_type" */
  update_enum_resource_type_by_pk?: Maybe<Enum_Resource_Type>;
  /** update multiples rows of table: "enum_resource_type" */
  update_enum_resource_type_many?: Maybe<Array<Maybe<Enum_Resource_Type_Mutation_Response>>>;
  /** update data of the table: "enum_safety_plan_section_category_type" */
  update_enum_safety_plan_section_category_type?: Maybe<Enum_Safety_Plan_Section_Category_Type_Mutation_Response>;
  /** update single row of the table: "enum_safety_plan_section_category_type" */
  update_enum_safety_plan_section_category_type_by_pk?: Maybe<Enum_Safety_Plan_Section_Category_Type>;
  /** update multiples rows of table: "enum_safety_plan_section_category_type" */
  update_enum_safety_plan_section_category_type_many?: Maybe<Array<Maybe<Enum_Safety_Plan_Section_Category_Type_Mutation_Response>>>;
  /** update data of the table: "enum_safety_plan_section_icons" */
  update_enum_safety_plan_section_icons?: Maybe<Enum_Safety_Plan_Section_Icons_Mutation_Response>;
  /** update single row of the table: "enum_safety_plan_section_icons" */
  update_enum_safety_plan_section_icons_by_pk?: Maybe<Enum_Safety_Plan_Section_Icons>;
  /** update multiples rows of table: "enum_safety_plan_section_icons" */
  update_enum_safety_plan_section_icons_many?: Maybe<Array<Maybe<Enum_Safety_Plan_Section_Icons_Mutation_Response>>>;
  /** update data of the table: "enum_safety_plan_status" */
  update_enum_safety_plan_status?: Maybe<Enum_Safety_Plan_Status_Mutation_Response>;
  /** update single row of the table: "enum_safety_plan_status" */
  update_enum_safety_plan_status_by_pk?: Maybe<Enum_Safety_Plan_Status>;
  /** update multiples rows of table: "enum_safety_plan_status" */
  update_enum_safety_plan_status_many?: Maybe<Array<Maybe<Enum_Safety_Plan_Status_Mutation_Response>>>;
  /** update data of the table: "enum_safety_plan_type" */
  update_enum_safety_plan_type?: Maybe<Enum_Safety_Plan_Type_Mutation_Response>;
  /** update single row of the table: "enum_safety_plan_type" */
  update_enum_safety_plan_type_by_pk?: Maybe<Enum_Safety_Plan_Type>;
  /** update multiples rows of table: "enum_safety_plan_type" */
  update_enum_safety_plan_type_many?: Maybe<Array<Maybe<Enum_Safety_Plan_Type_Mutation_Response>>>;
  /** update data of the table: "enum_trend_direction" */
  update_enum_trend_direction?: Maybe<Enum_Trend_Direction_Mutation_Response>;
  /** update single row of the table: "enum_trend_direction" */
  update_enum_trend_direction_by_pk?: Maybe<Enum_Trend_Direction>;
  /** update multiples rows of table: "enum_trend_direction" */
  update_enum_trend_direction_many?: Maybe<Array<Maybe<Enum_Trend_Direction_Mutation_Response>>>;
  /** update data of the table: "feature_report_feature_coefficients" */
  update_feature_report_feature_coefficients?: Maybe<Feature_Report_Feature_Coefficients_Mutation_Response>;
  /** update single row of the table: "feature_report_feature_coefficients" */
  update_feature_report_feature_coefficients_by_pk?: Maybe<Feature_Report_Feature_Coefficients>;
  /** update multiples rows of table: "feature_report_feature_coefficients" */
  update_feature_report_feature_coefficients_many?: Maybe<Array<Maybe<Feature_Report_Feature_Coefficients_Mutation_Response>>>;
  /** update data of the table: "feature_report_features" */
  update_feature_report_features?: Maybe<Feature_Report_Features_Mutation_Response>;
  /** update single row of the table: "feature_report_features" */
  update_feature_report_features_by_pk?: Maybe<Feature_Report_Features>;
  /** update multiples rows of table: "feature_report_features" */
  update_feature_report_features_many?: Maybe<Array<Maybe<Feature_Report_Features_Mutation_Response>>>;
  /** update data of the table: "feature_reports" */
  update_feature_reports?: Maybe<Feature_Reports_Mutation_Response>;
  /** update single row of the table: "feature_reports" */
  update_feature_reports_by_pk?: Maybe<Feature_Reports>;
  /** update multiples rows of table: "feature_reports" */
  update_feature_reports_many?: Maybe<Array<Maybe<Feature_Reports_Mutation_Response>>>;
  /** update data of the table: "group_code" */
  update_group_code?: Maybe<Group_Code_Mutation_Response>;
  /** update single row of the table: "group_code" */
  update_group_code_by_pk?: Maybe<Group_Code>;
  /** update multiples rows of table: "group_code" */
  update_group_code_many?: Maybe<Array<Maybe<Group_Code_Mutation_Response>>>;
  /** update data of the table: "insight_articles" */
  update_insight_articles?: Maybe<Insight_Articles_Mutation_Response>;
  /** update single row of the table: "insight_articles" */
  update_insight_articles_by_pk?: Maybe<Insight_Articles>;
  /** update multiples rows of table: "insight_articles" */
  update_insight_articles_many?: Maybe<Array<Maybe<Insight_Articles_Mutation_Response>>>;
  /** update data of the table: "insight_combos" */
  update_insight_combos?: Maybe<Insight_Combos_Mutation_Response>;
  /** update single row of the table: "insight_combos" */
  update_insight_combos_by_pk?: Maybe<Insight_Combos>;
  /** update multiples rows of table: "insight_combos" */
  update_insight_combos_many?: Maybe<Array<Maybe<Insight_Combos_Mutation_Response>>>;
  /** update data of the table: "insight_hows" */
  update_insight_hows?: Maybe<Insight_Hows_Mutation_Response>;
  /** update single row of the table: "insight_hows" */
  update_insight_hows_by_pk?: Maybe<Insight_Hows>;
  /** update multiples rows of table: "insight_hows" */
  update_insight_hows_many?: Maybe<Array<Maybe<Insight_Hows_Mutation_Response>>>;
  /** update data of the table: "insight_plan_article" */
  update_insight_plan_article?: Maybe<Insight_Plan_Article_Mutation_Response>;
  /** update single row of the table: "insight_plan_article" */
  update_insight_plan_article_by_pk?: Maybe<Insight_Plan_Article>;
  /** update multiples rows of table: "insight_plan_article" */
  update_insight_plan_article_many?: Maybe<Array<Maybe<Insight_Plan_Article_Mutation_Response>>>;
  /** update data of the table: "insight_plan_text" */
  update_insight_plan_text?: Maybe<Insight_Plan_Text_Mutation_Response>;
  /** update single row of the table: "insight_plan_text" */
  update_insight_plan_text_by_pk?: Maybe<Insight_Plan_Text>;
  /** update multiples rows of table: "insight_plan_text" */
  update_insight_plan_text_many?: Maybe<Array<Maybe<Insight_Plan_Text_Mutation_Response>>>;
  /** update data of the table: "insight_plans" */
  update_insight_plans?: Maybe<Insight_Plans_Mutation_Response>;
  /** update single row of the table: "insight_plans" */
  update_insight_plans_by_pk?: Maybe<Insight_Plans>;
  /** update multiples rows of table: "insight_plans" */
  update_insight_plans_many?: Maybe<Array<Maybe<Insight_Plans_Mutation_Response>>>;
  /** update data of the table: "insight_questions" */
  update_insight_questions?: Maybe<Insight_Questions_Mutation_Response>;
  /** update single row of the table: "insight_questions" */
  update_insight_questions_by_pk?: Maybe<Insight_Questions>;
  /** update multiples rows of table: "insight_questions" */
  update_insight_questions_many?: Maybe<Array<Maybe<Insight_Questions_Mutation_Response>>>;
  /** update data of the table: "insight_recipes" */
  update_insight_recipes?: Maybe<Insight_Recipes_Mutation_Response>;
  /** update single row of the table: "insight_recipes" */
  update_insight_recipes_by_pk?: Maybe<Insight_Recipes>;
  /** update multiples rows of table: "insight_recipes" */
  update_insight_recipes_many?: Maybe<Array<Maybe<Insight_Recipes_Mutation_Response>>>;
  /** update data of the table: "insight_reflect" */
  update_insight_reflect?: Maybe<Insight_Reflect_Mutation_Response>;
  /** update single row of the table: "insight_reflect" */
  update_insight_reflect_by_pk?: Maybe<Insight_Reflect>;
  /** update multiples rows of table: "insight_reflect" */
  update_insight_reflect_many?: Maybe<Array<Maybe<Insight_Reflect_Mutation_Response>>>;
  /** update data of the table: "insight_reflect_text" */
  update_insight_reflect_text?: Maybe<Insight_Reflect_Text_Mutation_Response>;
  /** update single row of the table: "insight_reflect_text" */
  update_insight_reflect_text_by_pk?: Maybe<Insight_Reflect_Text>;
  /** update multiples rows of table: "insight_reflect_text" */
  update_insight_reflect_text_many?: Maybe<Array<Maybe<Insight_Reflect_Text_Mutation_Response>>>;
  /** update data of the table: "insight_resources" */
  update_insight_resources?: Maybe<Insight_Resources_Mutation_Response>;
  /** update single row of the table: "insight_resources" */
  update_insight_resources_by_pk?: Maybe<Insight_Resources>;
  /** update multiples rows of table: "insight_resources" */
  update_insight_resources_many?: Maybe<Array<Maybe<Insight_Resources_Mutation_Response>>>;
  /** update data of the table: "insight_texts" */
  update_insight_texts?: Maybe<Insight_Texts_Mutation_Response>;
  /** update single row of the table: "insight_texts" */
  update_insight_texts_by_pk?: Maybe<Insight_Texts>;
  /** update multiples rows of table: "insight_texts" */
  update_insight_texts_many?: Maybe<Array<Maybe<Insight_Texts_Mutation_Response>>>;
  /** update data of the table: "insight_tips" */
  update_insight_tips?: Maybe<Insight_Tips_Mutation_Response>;
  /** update single row of the table: "insight_tips" */
  update_insight_tips_by_pk?: Maybe<Insight_Tips>;
  /** update multiples rows of table: "insight_tips" */
  update_insight_tips_many?: Maybe<Array<Maybe<Insight_Tips_Mutation_Response>>>;
  /** update data of the table: "insight_whys" */
  update_insight_whys?: Maybe<Insight_Whys_Mutation_Response>;
  /** update single row of the table: "insight_whys" */
  update_insight_whys_by_pk?: Maybe<Insight_Whys>;
  /** update multiples rows of table: "insight_whys" */
  update_insight_whys_many?: Maybe<Array<Maybe<Insight_Whys_Mutation_Response>>>;
  /** update data of the table: "invite_codes" */
  update_invite_codes?: Maybe<Invite_Codes_Mutation_Response>;
  /** update single row of the table: "invite_codes" */
  update_invite_codes_by_pk?: Maybe<Invite_Codes>;
  /** update multiples rows of table: "invite_codes" */
  update_invite_codes_many?: Maybe<Array<Maybe<Invite_Codes_Mutation_Response>>>;
  /** update data of the table: "logs" */
  update_logs?: Maybe<Logs_Mutation_Response>;
  /** update single row of the table: "logs" */
  update_logs_by_pk?: Maybe<Logs>;
  /** update multiples rows of table: "logs" */
  update_logs_many?: Maybe<Array<Maybe<Logs_Mutation_Response>>>;
  /** update data of the table: "mobile_device_data" */
  update_mobile_device_data?: Maybe<Mobile_Device_Data_Mutation_Response>;
  /** update single row of the table: "mobile_device_data" */
  update_mobile_device_data_by_pk?: Maybe<Mobile_Device_Data>;
  /** update multiples rows of table: "mobile_device_data" */
  update_mobile_device_data_many?: Maybe<Array<Maybe<Mobile_Device_Data_Mutation_Response>>>;
  /** update data of the table: "mobile_permissions" */
  update_mobile_permissions?: Maybe<Mobile_Permissions_Mutation_Response>;
  /** update single row of the table: "mobile_permissions" */
  update_mobile_permissions_by_pk?: Maybe<Mobile_Permissions>;
  /** update multiples rows of table: "mobile_permissions" */
  update_mobile_permissions_many?: Maybe<Array<Maybe<Mobile_Permissions_Mutation_Response>>>;
  /** update data of the table: "mobile_upload_log" */
  update_mobile_upload_log?: Maybe<Mobile_Upload_Log_Mutation_Response>;
  /** update single row of the table: "mobile_upload_log" */
  update_mobile_upload_log_by_pk?: Maybe<Mobile_Upload_Log>;
  /** update multiples rows of table: "mobile_upload_log" */
  update_mobile_upload_log_many?: Maybe<Array<Maybe<Mobile_Upload_Log_Mutation_Response>>>;
  /** update data of the table: "mood_measurements" */
  update_mood_measurements?: Maybe<Mood_Measurements_Mutation_Response>;
  /** update single row of the table: "mood_measurements" */
  update_mood_measurements_by_pk?: Maybe<Mood_Measurements>;
  /** update multiples rows of table: "mood_measurements" */
  update_mood_measurements_many?: Maybe<Array<Maybe<Mood_Measurements_Mutation_Response>>>;
  /** update data of the table: "nudge_schedules" */
  update_nudge_schedules?: Maybe<Nudge_Schedules_Mutation_Response>;
  /** update single row of the table: "nudge_schedules" */
  update_nudge_schedules_by_pk?: Maybe<Nudge_Schedules>;
  /** update multiples rows of table: "nudge_schedules" */
  update_nudge_schedules_many?: Maybe<Array<Maybe<Nudge_Schedules_Mutation_Response>>>;
  /** update data of the table: "nudge_takes" */
  update_nudge_takes?: Maybe<Nudge_Takes_Mutation_Response>;
  /** update single row of the table: "nudge_takes" */
  update_nudge_takes_by_pk?: Maybe<Nudge_Takes>;
  /** update multiples rows of table: "nudge_takes" */
  update_nudge_takes_many?: Maybe<Array<Maybe<Nudge_Takes_Mutation_Response>>>;
  /** update data of the table: "nudges" */
  update_nudges?: Maybe<Nudges_Mutation_Response>;
  /** update single row of the table: "nudges" */
  update_nudges_by_pk?: Maybe<Nudges>;
  /** update multiples rows of table: "nudges" */
  update_nudges_many?: Maybe<Array<Maybe<Nudges_Mutation_Response>>>;
  /** update data of the table: "organization_admins" */
  update_organization_admins?: Maybe<Organization_Admins_Mutation_Response>;
  /** update single row of the table: "organization_admins" */
  update_organization_admins_by_pk?: Maybe<Organization_Admins>;
  /** update multiples rows of table: "organization_admins" */
  update_organization_admins_many?: Maybe<Array<Maybe<Organization_Admins_Mutation_Response>>>;
  /** update data of the table: "organization_features" */
  update_organization_features?: Maybe<Organization_Features_Mutation_Response>;
  /** update single row of the table: "organization_features" */
  update_organization_features_by_pk?: Maybe<Organization_Features>;
  /** update multiples rows of table: "organization_features" */
  update_organization_features_many?: Maybe<Array<Maybe<Organization_Features_Mutation_Response>>>;
  /** update data of the table: "organization_member_roles" */
  update_organization_member_roles?: Maybe<Organization_Member_Roles_Mutation_Response>;
  /** update single row of the table: "organization_member_roles" */
  update_organization_member_roles_by_pk?: Maybe<Organization_Member_Roles>;
  /** update multiples rows of table: "organization_member_roles" */
  update_organization_member_roles_many?: Maybe<Array<Maybe<Organization_Member_Roles_Mutation_Response>>>;
  /** update data of the table: "organization_members" */
  update_organization_members?: Maybe<Organization_Members_Mutation_Response>;
  /** update single row of the table: "organization_members" */
  update_organization_members_by_pk?: Maybe<Organization_Members>;
  /** update multiples rows of table: "organization_members" */
  update_organization_members_many?: Maybe<Array<Maybe<Organization_Members_Mutation_Response>>>;
  /** update data of the table: "organization_supervisees" */
  update_organization_supervisees?: Maybe<Organization_Supervisees_Mutation_Response>;
  /** update single row of the table: "organization_supervisees" */
  update_organization_supervisees_by_pk?: Maybe<Organization_Supervisees>;
  /** update multiples rows of table: "organization_supervisees" */
  update_organization_supervisees_many?: Maybe<Array<Maybe<Organization_Supervisees_Mutation_Response>>>;
  /** update data of the table: "organization_supervisors" */
  update_organization_supervisors?: Maybe<Organization_Supervisors_Mutation_Response>;
  /** update single row of the table: "organization_supervisors" */
  update_organization_supervisors_by_pk?: Maybe<Organization_Supervisors>;
  /** update multiples rows of table: "organization_supervisors" */
  update_organization_supervisors_many?: Maybe<Array<Maybe<Organization_Supervisors_Mutation_Response>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<Organizations_Mutation_Response>>>;
  /** update data of the table: "questionnaire_items" */
  update_questionnaire_items?: Maybe<Questionnaire_Items_Mutation_Response>;
  /** update single row of the table: "questionnaire_items" */
  update_questionnaire_items_by_pk?: Maybe<Questionnaire_Items>;
  /** update multiples rows of table: "questionnaire_items" */
  update_questionnaire_items_many?: Maybe<Array<Maybe<Questionnaire_Items_Mutation_Response>>>;
  /** update data of the table: "questionnaire_response_options" */
  update_questionnaire_response_options?: Maybe<Questionnaire_Response_Options_Mutation_Response>;
  /** update single row of the table: "questionnaire_response_options" */
  update_questionnaire_response_options_by_pk?: Maybe<Questionnaire_Response_Options>;
  /** update multiples rows of table: "questionnaire_response_options" */
  update_questionnaire_response_options_many?: Maybe<Array<Maybe<Questionnaire_Response_Options_Mutation_Response>>>;
  /** update data of the table: "questionnaire_responses" */
  update_questionnaire_responses?: Maybe<Questionnaire_Responses_Mutation_Response>;
  /** update single row of the table: "questionnaire_responses" */
  update_questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** update multiples rows of table: "questionnaire_responses" */
  update_questionnaire_responses_many?: Maybe<Array<Maybe<Questionnaire_Responses_Mutation_Response>>>;
  /** update data of the table: "questionnaire_risk_alert_contacts" */
  update_questionnaire_risk_alert_contacts?: Maybe<Questionnaire_Risk_Alert_Contacts_Mutation_Response>;
  /** update single row of the table: "questionnaire_risk_alert_contacts" */
  update_questionnaire_risk_alert_contacts_by_pk?: Maybe<Questionnaire_Risk_Alert_Contacts>;
  /** update multiples rows of table: "questionnaire_risk_alert_contacts" */
  update_questionnaire_risk_alert_contacts_many?: Maybe<Array<Maybe<Questionnaire_Risk_Alert_Contacts_Mutation_Response>>>;
  /** update data of the table: "questionnaire_schedules" */
  update_questionnaire_schedules?: Maybe<Questionnaire_Schedules_Mutation_Response>;
  /** update single row of the table: "questionnaire_schedules" */
  update_questionnaire_schedules_by_pk?: Maybe<Questionnaire_Schedules>;
  /** update multiples rows of table: "questionnaire_schedules" */
  update_questionnaire_schedules_many?: Maybe<Array<Maybe<Questionnaire_Schedules_Mutation_Response>>>;
  /** update data of the table: "questionnaire_scoring" */
  update_questionnaire_scoring?: Maybe<Questionnaire_Scoring_Mutation_Response>;
  /** update single row of the table: "questionnaire_scoring" */
  update_questionnaire_scoring_by_pk?: Maybe<Questionnaire_Scoring>;
  /** update multiples rows of table: "questionnaire_scoring" */
  update_questionnaire_scoring_many?: Maybe<Array<Maybe<Questionnaire_Scoring_Mutation_Response>>>;
  /** update data of the table: "questionnaire_takes" */
  update_questionnaire_takes?: Maybe<Questionnaire_Takes_Mutation_Response>;
  /** update single row of the table: "questionnaire_takes" */
  update_questionnaire_takes_by_pk?: Maybe<Questionnaire_Takes>;
  /** update multiples rows of table: "questionnaire_takes" */
  update_questionnaire_takes_many?: Maybe<Array<Maybe<Questionnaire_Takes_Mutation_Response>>>;
  /** update data of the table: "questionnaires" */
  update_questionnaires?: Maybe<Questionnaires_Mutation_Response>;
  /** update single row of the table: "questionnaires" */
  update_questionnaires_by_pk?: Maybe<Questionnaires>;
  /** update multiples rows of table: "questionnaires" */
  update_questionnaires_many?: Maybe<Array<Maybe<Questionnaires_Mutation_Response>>>;
  /** update data of the table: "relapse_prevention_place_visits" */
  update_relapse_prevention_place_visits?: Maybe<Relapse_Prevention_Place_Visits_Mutation_Response>;
  /** update single row of the table: "relapse_prevention_place_visits" */
  update_relapse_prevention_place_visits_by_pk?: Maybe<Relapse_Prevention_Place_Visits>;
  /** update multiples rows of table: "relapse_prevention_place_visits" */
  update_relapse_prevention_place_visits_many?: Maybe<Array<Maybe<Relapse_Prevention_Place_Visits_Mutation_Response>>>;
  /** update data of the table: "relapse_prevention_places" */
  update_relapse_prevention_places?: Maybe<Relapse_Prevention_Places_Mutation_Response>;
  /** update single row of the table: "relapse_prevention_places" */
  update_relapse_prevention_places_by_pk?: Maybe<Relapse_Prevention_Places>;
  /** update multiples rows of table: "relapse_prevention_places" */
  update_relapse_prevention_places_many?: Maybe<Array<Maybe<Relapse_Prevention_Places_Mutation_Response>>>;
  /** update data of the table: "resources" */
  update_resources?: Maybe<Resources_Mutation_Response>;
  /** update single row of the table: "resources" */
  update_resources_by_pk?: Maybe<Resources>;
  /** update multiples rows of table: "resources" */
  update_resources_many?: Maybe<Array<Maybe<Resources_Mutation_Response>>>;
  /** update data of the table: "resources_orgs" */
  update_resources_orgs?: Maybe<Resources_Orgs_Mutation_Response>;
  /** update single row of the table: "resources_orgs" */
  update_resources_orgs_by_pk?: Maybe<Resources_Orgs>;
  /** update multiples rows of table: "resources_orgs" */
  update_resources_orgs_many?: Maybe<Array<Maybe<Resources_Orgs_Mutation_Response>>>;
  /** update data of the table: "risk_alerts_log" */
  update_risk_alerts_log?: Maybe<Risk_Alerts_Log_Mutation_Response>;
  /** update single row of the table: "risk_alerts_log" */
  update_risk_alerts_log_by_pk?: Maybe<Risk_Alerts_Log>;
  /** update multiples rows of table: "risk_alerts_log" */
  update_risk_alerts_log_many?: Maybe<Array<Maybe<Risk_Alerts_Log_Mutation_Response>>>;
  /** update data of the table: "risk_alerts_recipients_log" */
  update_risk_alerts_recipients_log?: Maybe<Risk_Alerts_Recipients_Log_Mutation_Response>;
  /** update single row of the table: "risk_alerts_recipients_log" */
  update_risk_alerts_recipients_log_by_pk?: Maybe<Risk_Alerts_Recipients_Log>;
  /** update multiples rows of table: "risk_alerts_recipients_log" */
  update_risk_alerts_recipients_log_many?: Maybe<Array<Maybe<Risk_Alerts_Recipients_Log_Mutation_Response>>>;
  /** update data of the table: "role_capabilities" */
  update_role_capabilities?: Maybe<Role_Capabilities_Mutation_Response>;
  /** update single row of the table: "role_capabilities" */
  update_role_capabilities_by_pk?: Maybe<Role_Capabilities>;
  /** update multiples rows of table: "role_capabilities" */
  update_role_capabilities_many?: Maybe<Array<Maybe<Role_Capabilities_Mutation_Response>>>;
  /** update data of the table: "safety_checklist_recipients_log" */
  update_safety_checklist_recipients_log?: Maybe<Safety_Checklist_Recipients_Log_Mutation_Response>;
  /** update single row of the table: "safety_checklist_recipients_log" */
  update_safety_checklist_recipients_log_by_pk?: Maybe<Safety_Checklist_Recipients_Log>;
  /** update multiples rows of table: "safety_checklist_recipients_log" */
  update_safety_checklist_recipients_log_many?: Maybe<Array<Maybe<Safety_Checklist_Recipients_Log_Mutation_Response>>>;
  /** update data of the table: "safety_plan" */
  update_safety_plan?: Maybe<Safety_Plan_Mutation_Response>;
  /** update single row of the table: "safety_plan" */
  update_safety_plan_by_pk?: Maybe<Safety_Plan>;
  /** update data of the table: "safety_plan_checklist_items" */
  update_safety_plan_checklist_items?: Maybe<Safety_Plan_Checklist_Items_Mutation_Response>;
  /** update single row of the table: "safety_plan_checklist_items" */
  update_safety_plan_checklist_items_by_pk?: Maybe<Safety_Plan_Checklist_Items>;
  /** update multiples rows of table: "safety_plan_checklist_items" */
  update_safety_plan_checklist_items_many?: Maybe<Array<Maybe<Safety_Plan_Checklist_Items_Mutation_Response>>>;
  /** update multiples rows of table: "safety_plan" */
  update_safety_plan_many?: Maybe<Array<Maybe<Safety_Plan_Mutation_Response>>>;
  /** update data of the table: "safety_plan_response_options" */
  update_safety_plan_response_options?: Maybe<Safety_Plan_Response_Options_Mutation_Response>;
  /** update single row of the table: "safety_plan_response_options" */
  update_safety_plan_response_options_by_pk?: Maybe<Safety_Plan_Response_Options>;
  /** update multiples rows of table: "safety_plan_response_options" */
  update_safety_plan_response_options_many?: Maybe<Array<Maybe<Safety_Plan_Response_Options_Mutation_Response>>>;
  /** update data of the table: "safety_plan_section_category" */
  update_safety_plan_section_category?: Maybe<Safety_Plan_Section_Category_Mutation_Response>;
  /** update single row of the table: "safety_plan_section_category" */
  update_safety_plan_section_category_by_pk?: Maybe<Safety_Plan_Section_Category>;
  /** update multiples rows of table: "safety_plan_section_category" */
  update_safety_plan_section_category_many?: Maybe<Array<Maybe<Safety_Plan_Section_Category_Mutation_Response>>>;
  /** update data of the table: "safety_plan_sections" */
  update_safety_plan_sections?: Maybe<Safety_Plan_Sections_Mutation_Response>;
  /** update single row of the table: "safety_plan_sections" */
  update_safety_plan_sections_by_pk?: Maybe<Safety_Plan_Sections>;
  /** update multiples rows of table: "safety_plan_sections" */
  update_safety_plan_sections_many?: Maybe<Array<Maybe<Safety_Plan_Sections_Mutation_Response>>>;
  /** update data of the table: "safety_plan_template" */
  update_safety_plan_template?: Maybe<Safety_Plan_Template_Mutation_Response>;
  /** update single row of the table: "safety_plan_template" */
  update_safety_plan_template_by_pk?: Maybe<Safety_Plan_Template>;
  /** update multiples rows of table: "safety_plan_template" */
  update_safety_plan_template_many?: Maybe<Array<Maybe<Safety_Plan_Template_Mutation_Response>>>;
  /** update data of the table: "schedule_blackout_dates" */
  update_schedule_blackout_dates?: Maybe<Schedule_Blackout_Dates_Mutation_Response>;
  /** update single row of the table: "schedule_blackout_dates" */
  update_schedule_blackout_dates_by_pk?: Maybe<Schedule_Blackout_Dates>;
  /** update multiples rows of table: "schedule_blackout_dates" */
  update_schedule_blackout_dates_many?: Maybe<Array<Maybe<Schedule_Blackout_Dates_Mutation_Response>>>;
  /** update data of the table: "transcript.action_plans" */
  update_transcript_action_plans?: Maybe<Transcript_Action_Plans_Mutation_Response>;
  /** update single row of the table: "transcript.action_plans" */
  update_transcript_action_plans_by_pk?: Maybe<Transcript_Action_Plans>;
  /** update multiples rows of table: "transcript.action_plans" */
  update_transcript_action_plans_many?: Maybe<Array<Maybe<Transcript_Action_Plans_Mutation_Response>>>;
  /** update data of the table: "transcript.progress_notes" */
  update_transcript_progress_notes?: Maybe<Transcript_Progress_Notes_Mutation_Response>;
  /** update single row of the table: "transcript.progress_notes" */
  update_transcript_progress_notes_by_pk?: Maybe<Transcript_Progress_Notes>;
  /** update multiples rows of table: "transcript.progress_notes" */
  update_transcript_progress_notes_many?: Maybe<Array<Maybe<Transcript_Progress_Notes_Mutation_Response>>>;
  /** update data of the table: "transcript.score_results" */
  update_transcript_score_results?: Maybe<Transcript_Score_Results_Mutation_Response>;
  /** update single row of the table: "transcript.score_results" */
  update_transcript_score_results_by_pk?: Maybe<Transcript_Score_Results>;
  /** update multiples rows of table: "transcript.score_results" */
  update_transcript_score_results_many?: Maybe<Array<Maybe<Transcript_Score_Results_Mutation_Response>>>;
  /** update data of the table: "transcript.sessions" */
  update_transcript_sessions?: Maybe<Transcript_Sessions_Mutation_Response>;
  /** update single row of the table: "transcript.sessions" */
  update_transcript_sessions_by_pk?: Maybe<Transcript_Sessions>;
  /** update multiples rows of table: "transcript.sessions" */
  update_transcript_sessions_many?: Maybe<Array<Maybe<Transcript_Sessions_Mutation_Response>>>;
  /** update data of the table: "transcript.transcripts" */
  update_transcript_transcripts?: Maybe<Transcript_Transcripts_Mutation_Response>;
  /** update single row of the table: "transcript.transcripts" */
  update_transcript_transcripts_by_pk?: Maybe<Transcript_Transcripts>;
  /** update multiples rows of table: "transcript.transcripts" */
  update_transcript_transcripts_many?: Maybe<Array<Maybe<Transcript_Transcripts_Mutation_Response>>>;
  /** update data of the table: "user_feature_flag" */
  update_user_feature_flag?: Maybe<User_Feature_Flag_Mutation_Response>;
  /** update single row of the table: "user_feature_flag" */
  update_user_feature_flag_by_pk?: Maybe<User_Feature_Flag>;
  /** update multiples rows of table: "user_feature_flag" */
  update_user_feature_flag_many?: Maybe<Array<Maybe<User_Feature_Flag_Mutation_Response>>>;
  /** update data of the table: "user_group_code" */
  update_user_group_code?: Maybe<User_Group_Code_Mutation_Response>;
  /** update single row of the table: "user_group_code" */
  update_user_group_code_by_pk?: Maybe<User_Group_Code>;
  /** update multiples rows of table: "user_group_code" */
  update_user_group_code_many?: Maybe<Array<Maybe<User_Group_Code_Mutation_Response>>>;
  /** update data of the table: "user_insights" */
  update_user_insights?: Maybe<User_Insights_Mutation_Response>;
  /** update single row of the table: "user_insights" */
  update_user_insights_by_pk?: Maybe<User_Insights>;
  /** update multiples rows of table: "user_insights" */
  update_user_insights_many?: Maybe<Array<Maybe<User_Insights_Mutation_Response>>>;
  /** update data of the table: "user_invites" */
  update_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** update single row of the table: "user_invites" */
  update_user_invites_by_pk?: Maybe<User_Invites>;
  /** update multiples rows of table: "user_invites" */
  update_user_invites_many?: Maybe<Array<Maybe<User_Invites_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "users_insights_display_status" */
  update_users_insights_display_status?: Maybe<Users_Insights_Display_Status_Mutation_Response>;
  /** update single row of the table: "users_insights_display_status" */
  update_users_insights_display_status_by_pk?: Maybe<Users_Insights_Display_Status>;
  /** update multiples rows of table: "users_insights_display_status" */
  update_users_insights_display_status_many?: Maybe<Array<Maybe<Users_Insights_Display_Status_Mutation_Response>>>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_ActivityArgs = {
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_RatingArgs = {
  where: Activity_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Rating_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_ResourceArgs = {
  where: Activity_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_Resource_CategoryArgs = {
  where: Activity_Resource_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Resource_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_Sub_CategoryArgs = {
  where: Activity_Sub_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Sub_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_Suggested_ActivitiesArgs = {
  where: Activity_Suggested_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activity_Suggested_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_AnswersArgs = {
  where: Assessment_Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Answers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Branching_RulesArgs = {
  where: Assessment_Branching_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Branching_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_PagesArgs = {
  where: Assessment_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Pages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Question_Custom_PromptArgs = {
  where: Assessment_Question_Custom_Prompt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Question_Custom_Prompt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_QuestionsArgs = {
  where: Assessment_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Questions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Assessment_TakesArgs = {
  where: Assessment_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessment_Takes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AssessmentsArgs = {
  where: Assessments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Assessments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_Migration_LogArgs = {
  where: Auth_Account_Migration_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_Migration_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_ProvidersArgs = {
  where: Auth_Account_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_RolesArgs = {
  where: Auth_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Account_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_AccountsArgs = {
  where: Auth_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_ProvidersArgs = {
  where: Auth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Providers_By_PkArgs = {
  provider: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Refresh_Token_Usage_LogArgs = {
  where: Auth_Refresh_Token_Usage_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Refresh_Token_Usage_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_Refresh_TokensArgs = {
  where: Auth_Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Refresh_Tokens_By_PkArgs = {
  refresh_token_hash: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Auth_RolesArgs = {
  where: Auth_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Auth_Roles_By_PkArgs = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Casemix_CategoryArgs = {
  where: Casemix_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Casemix_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Client_DemographicsArgs = {
  where: Client_Demographics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_Demographics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Daily_FeaturesArgs = {
  where: Daily_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daily_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Client_Invite_CodesArgs = {
  where: Ehr_Client_Invite_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Client_Invite_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Ehr_Practitioner_MapArgs = {
  where: Ehr_Ehr_Practitioner_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Ehr_Practitioner_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Event_NotificationArgs = {
  where: Ehr_Xealth_Event_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Event_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Preorder_FormArgs = {
  where: Ehr_Xealth_Preorder_Form_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Preorder_Form_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Preorder_Invite_MapArgs = {
  where: Ehr_Xealth_Preorder_Invite_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ehr_Xealth_Preorder_Invite_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Activity_CategoryArgs = {
  where: Enum_Activity_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Activity_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Activity_Resource_TypeArgs = {
  where: Enum_Activity_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Activity_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Completion_StatusArgs = {
  where: Enum_Completion_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Completion_Status_By_PkArgs = {
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Feature_DirectionArgs = {
  where: Enum_Feature_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Feature_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Feature_TypeArgs = {
  where: Enum_Feature_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Feature_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_GenderArgs = {
  where: Enum_Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Gender_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Insight_Content_TypeArgs = {
  where: Enum_Insight_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Insight_Content_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Mobile_Permission_StatusArgs = {
  where: Enum_Mobile_Permission_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Mobile_Permission_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Mobile_Permission_TypeArgs = {
  where: Enum_Mobile_Permission_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Mobile_Permission_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_OutcomeArgs = {
  where: Enum_Outcome_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Outcome_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Question_TypeArgs = {
  where: Enum_Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Question_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Racial_EthnicArgs = {
  where: Enum_Racial_Ethnic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Racial_Ethnic_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Resource_TypeArgs = {
  where: Enum_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Section_Category_TypeArgs = {
  where: Enum_Safety_Plan_Section_Category_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Section_Category_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Section_IconsArgs = {
  where: Enum_Safety_Plan_Section_Icons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Section_Icons_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_StatusArgs = {
  where: Enum_Safety_Plan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_TypeArgs = {
  where: Enum_Safety_Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Safety_Plan_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Trend_DirectionArgs = {
  where: Enum_Trend_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Trend_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_Report_Feature_CoefficientsArgs = {
  where: Feature_Report_Feature_Coefficients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Report_Feature_Coefficients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_Report_FeaturesArgs = {
  where: Feature_Report_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Report_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Feature_ReportsArgs = {
  where: Feature_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feature_Reports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Group_CodeArgs = {
  where: Group_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Group_Code_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_ArticlesArgs = {
  where: Insight_Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Articles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_CombosArgs = {
  where: Insight_Combos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Combos_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_HowsArgs = {
  where: Insight_Hows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Hows_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_Plan_ArticleArgs = {
  where: Insight_Plan_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Plan_Article_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_Plan_TextArgs = {
  where: Insight_Plan_Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Plan_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_PlansArgs = {
  where: Insight_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_QuestionsArgs = {
  where: Insight_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_RecipesArgs = {
  where: Insight_Recipes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Recipes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_ReflectArgs = {
  where: Insight_Reflect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Reflect_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_Reflect_TextArgs = {
  where: Insight_Reflect_Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Reflect_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_ResourcesArgs = {
  where: Insight_Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Resources_By_PkArgs = {
  direction: Enum_Feature_Direction_Enum;
  feature: Enum_Feature_Type_Enum;
  resources_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_TextsArgs = {
  where: Insight_Texts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Texts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_TipsArgs = {
  where: Insight_Tips_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Tips_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Insight_WhysArgs = {
  where: Insight_Whys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Insight_Whys_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Invite_CodesArgs = {
  where: Invite_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invite_Codes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LogsArgs = {
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Device_DataArgs = {
  where: Mobile_Device_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Device_Data_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mobile_PermissionsArgs = {
  where: Mobile_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Upload_LogArgs = {
  where: Mobile_Upload_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Upload_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mood_MeasurementsArgs = {
  where: Mood_Measurements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mood_Measurements_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nudge_SchedulesArgs = {
  where: Nudge_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nudge_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nudge_TakesArgs = {
  where: Nudge_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nudge_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NudgesArgs = {
  where: Nudges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nudges_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_AdminsArgs = {
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Admins_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_FeaturesArgs = {
  where: Organization_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Member_RolesArgs = {
  where: Organization_Member_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Member_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_MembersArgs = {
  where: Organization_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Members_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_SuperviseesArgs = {
  where: Organization_Supervisees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Supervisees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_SupervisorsArgs = {
  where: Organization_Supervisors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Supervisors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_ItemsArgs = {
  where: Questionnaire_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Items_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Response_OptionsArgs = {
  where: Questionnaire_Response_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Response_Options_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_ResponsesArgs = {
  where: Questionnaire_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Responses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Risk_Alert_ContactsArgs = {
  where: Questionnaire_Risk_Alert_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Risk_Alert_Contacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_SchedulesArgs = {
  where: Questionnaire_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_ScoringArgs = {
  where: Questionnaire_Scoring_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Scoring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_TakesArgs = {
  where: Questionnaire_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaire_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionnairesArgs = {
  where: Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Questionnaires_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Relapse_Prevention_Place_VisitsArgs = {
  where: Relapse_Prevention_Place_Visits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relapse_Prevention_Place_Visits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Relapse_Prevention_PlacesArgs = {
  where: Relapse_Prevention_Places_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relapse_Prevention_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ResourcesArgs = {
  where: Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resources_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Resources_OrgsArgs = {
  where: Resources_Orgs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resources_Orgs_By_PkArgs = {
  org_id: Scalars['Int']['input'];
  resources_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Alerts_LogArgs = {
  where: Risk_Alerts_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Alerts_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Risk_Alerts_Recipients_LogArgs = {
  where: Risk_Alerts_Recipients_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Risk_Alerts_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Role_CapabilitiesArgs = {
  where: Role_Capabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Capabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Checklist_Recipients_LogArgs = {
  where: Safety_Checklist_Recipients_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Checklist_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_PlanArgs = {
  where: Safety_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Checklist_ItemsArgs = {
  where: Safety_Plan_Checklist_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Checklist_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Response_OptionsArgs = {
  where: Safety_Plan_Response_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Response_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Section_CategoryArgs = {
  where: Safety_Plan_Section_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Section_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_SectionsArgs = {
  where: Safety_Plan_Sections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_TemplateArgs = {
  where: Safety_Plan_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safety_Plan_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Schedule_Blackout_DatesArgs = {
  where: Schedule_Blackout_Dates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Schedule_Blackout_Dates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Action_PlansArgs = {
  where: Transcript_Action_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Action_Plans_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Progress_NotesArgs = {
  where: Transcript_Progress_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Progress_Notes_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Score_ResultsArgs = {
  where: Transcript_Score_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Score_Results_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_SessionsArgs = {
  where: Transcript_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Sessions_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transcript_TranscriptsArgs = {
  where: Transcript_Transcripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transcript_Transcripts_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Feature_FlagArgs = {
  where: User_Feature_Flag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Feature_Flag_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Group_CodeArgs = {
  where: User_Group_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Group_Code_By_PkArgs = {
  group_code_id: Scalars['Int']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_InsightsArgs = {
  where: User_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Insights_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_InvitesArgs = {
  where: User_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Invites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Insights_Display_StatusArgs = {
  where: Users_Insights_Display_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Insights_Display_Status_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootInsert_ActivityArgs = {
  objects: Array<Activity_Insert_Input>;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_OneArgs = {
  object: Activity_Insert_Input;
  on_conflict?: InputMaybe<Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_RatingArgs = {
  objects: Array<Activity_Rating_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Rating_OneArgs = {
  object: Activity_Rating_Insert_Input;
  on_conflict?: InputMaybe<Activity_Rating_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_ResourceArgs = {
  objects: Array<Activity_Resource_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Resource_CategoryArgs = {
  objects: Array<Activity_Resource_Category_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Resource_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Resource_Category_OneArgs = {
  object: Activity_Resource_Category_Insert_Input;
  on_conflict?: InputMaybe<Activity_Resource_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Resource_OneArgs = {
  object: Activity_Resource_Insert_Input;
  on_conflict?: InputMaybe<Activity_Resource_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Sub_CategoryArgs = {
  objects: Array<Activity_Sub_Category_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Sub_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Sub_Category_OneArgs = {
  object: Activity_Sub_Category_Insert_Input;
  on_conflict?: InputMaybe<Activity_Sub_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Suggested_ActivitiesArgs = {
  objects: Array<Activity_Suggested_Activities_Insert_Input>;
  on_conflict?: InputMaybe<Activity_Suggested_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_Suggested_Activities_OneArgs = {
  object: Activity_Suggested_Activities_Insert_Input;
  on_conflict?: InputMaybe<Activity_Suggested_Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_AnswersArgs = {
  objects: Array<Assessment_Answers_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Answers_OneArgs = {
  object: Assessment_Answers_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Branching_RulesArgs = {
  objects: Array<Assessment_Branching_Rules_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Branching_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Branching_Rules_OneArgs = {
  object: Assessment_Branching_Rules_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Branching_Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_PagesArgs = {
  objects: Array<Assessment_Pages_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Pages_OneArgs = {
  object: Assessment_Pages_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Pages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Question_Custom_PromptArgs = {
  objects: Array<Assessment_Question_Custom_Prompt_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Question_Custom_Prompt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Question_Custom_Prompt_OneArgs = {
  object: Assessment_Question_Custom_Prompt_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Question_Custom_Prompt_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_QuestionsArgs = {
  objects: Array<Assessment_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Questions_OneArgs = {
  object: Assessment_Questions_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_TakesArgs = {
  objects: Array<Assessment_Takes_Insert_Input>;
  on_conflict?: InputMaybe<Assessment_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessment_Takes_OneArgs = {
  object: Assessment_Takes_Insert_Input;
  on_conflict?: InputMaybe<Assessment_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AssessmentsArgs = {
  objects: Array<Assessments_Insert_Input>;
  on_conflict?: InputMaybe<Assessments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Assessments_OneArgs = {
  object: Assessments_Insert_Input;
  on_conflict?: InputMaybe<Assessments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_Migration_LogArgs = {
  objects: Array<Auth_Account_Migration_Log_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Account_Migration_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_Migration_Log_OneArgs = {
  object: Auth_Account_Migration_Log_Insert_Input;
  on_conflict?: InputMaybe<Auth_Account_Migration_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_ProvidersArgs = {
  objects: Array<Auth_Account_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Account_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_Providers_OneArgs = {
  object: Auth_Account_Providers_Insert_Input;
  on_conflict?: InputMaybe<Auth_Account_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_RolesArgs = {
  objects: Array<Auth_Account_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Account_Roles_OneArgs = {
  object: Auth_Account_Roles_Insert_Input;
  on_conflict?: InputMaybe<Auth_Account_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_AccountsArgs = {
  objects: Array<Auth_Accounts_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Accounts_OneArgs = {
  object: Auth_Accounts_Insert_Input;
  on_conflict?: InputMaybe<Auth_Accounts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_ProvidersArgs = {
  objects: Array<Auth_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Providers_OneArgs = {
  object: Auth_Providers_Insert_Input;
  on_conflict?: InputMaybe<Auth_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Refresh_Token_Usage_LogArgs = {
  objects: Array<Auth_Refresh_Token_Usage_Log_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Refresh_Token_Usage_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Refresh_Token_Usage_Log_OneArgs = {
  object: Auth_Refresh_Token_Usage_Log_Insert_Input;
  on_conflict?: InputMaybe<Auth_Refresh_Token_Usage_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Refresh_TokensArgs = {
  objects: Array<Auth_Refresh_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Refresh_Tokens_OneArgs = {
  object: Auth_Refresh_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Auth_Refresh_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_RolesArgs = {
  objects: Array<Auth_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Auth_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Auth_Roles_OneArgs = {
  object: Auth_Roles_Insert_Input;
  on_conflict?: InputMaybe<Auth_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casemix_CategoryArgs = {
  objects: Array<Casemix_Category_Insert_Input>;
  on_conflict?: InputMaybe<Casemix_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Casemix_Category_OneArgs = {
  object: Casemix_Category_Insert_Input;
  on_conflict?: InputMaybe<Casemix_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_DemographicsArgs = {
  objects: Array<Client_Demographics_Insert_Input>;
  on_conflict?: InputMaybe<Client_Demographics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_Demographics_OneArgs = {
  object: Client_Demographics_Insert_Input;
  on_conflict?: InputMaybe<Client_Demographics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_FeaturesArgs = {
  objects: Array<Daily_Features_Insert_Input>;
  on_conflict?: InputMaybe<Daily_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daily_Features_OneArgs = {
  object: Daily_Features_Insert_Input;
  on_conflict?: InputMaybe<Daily_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Client_Invite_CodesArgs = {
  objects: Array<Ehr_Client_Invite_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Client_Invite_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Client_Invite_Codes_OneArgs = {
  object: Ehr_Client_Invite_Codes_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Client_Invite_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Ehr_Practitioner_MapArgs = {
  objects: Array<Ehr_Ehr_Practitioner_Map_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Ehr_Practitioner_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Ehr_Practitioner_Map_OneArgs = {
  object: Ehr_Ehr_Practitioner_Map_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Ehr_Practitioner_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Event_NotificationArgs = {
  objects: Array<Ehr_Xealth_Event_Notification_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Xealth_Event_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Event_Notification_OneArgs = {
  object: Ehr_Xealth_Event_Notification_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Xealth_Event_Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Preorder_FormArgs = {
  objects: Array<Ehr_Xealth_Preorder_Form_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Xealth_Preorder_Form_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Preorder_Form_OneArgs = {
  object: Ehr_Xealth_Preorder_Form_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Xealth_Preorder_Form_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Preorder_Invite_MapArgs = {
  objects: Array<Ehr_Xealth_Preorder_Invite_Map_Insert_Input>;
  on_conflict?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ehr_Xealth_Preorder_Invite_Map_OneArgs = {
  object: Ehr_Xealth_Preorder_Invite_Map_Insert_Input;
  on_conflict?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Activity_CategoryArgs = {
  objects: Array<Enum_Activity_Category_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Activity_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Activity_Category_OneArgs = {
  object: Enum_Activity_Category_Insert_Input;
  on_conflict?: InputMaybe<Enum_Activity_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Activity_Resource_TypeArgs = {
  objects: Array<Enum_Activity_Resource_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Activity_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Activity_Resource_Type_OneArgs = {
  object: Enum_Activity_Resource_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Activity_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Completion_StatusArgs = {
  objects: Array<Enum_Completion_Status_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Completion_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Completion_Status_OneArgs = {
  object: Enum_Completion_Status_Insert_Input;
  on_conflict?: InputMaybe<Enum_Completion_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Feature_DirectionArgs = {
  objects: Array<Enum_Feature_Direction_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Feature_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Feature_Direction_OneArgs = {
  object: Enum_Feature_Direction_Insert_Input;
  on_conflict?: InputMaybe<Enum_Feature_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Feature_TypeArgs = {
  objects: Array<Enum_Feature_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Feature_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Feature_Type_OneArgs = {
  object: Enum_Feature_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Feature_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_GenderArgs = {
  objects: Array<Enum_Gender_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Gender_OneArgs = {
  object: Enum_Gender_Insert_Input;
  on_conflict?: InputMaybe<Enum_Gender_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Insight_Content_TypeArgs = {
  objects: Array<Enum_Insight_Content_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Insight_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Insight_Content_Type_OneArgs = {
  object: Enum_Insight_Content_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Insight_Content_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Mobile_Permission_StatusArgs = {
  objects: Array<Enum_Mobile_Permission_Status_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Mobile_Permission_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Mobile_Permission_Status_OneArgs = {
  object: Enum_Mobile_Permission_Status_Insert_Input;
  on_conflict?: InputMaybe<Enum_Mobile_Permission_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Mobile_Permission_TypeArgs = {
  objects: Array<Enum_Mobile_Permission_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Mobile_Permission_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Mobile_Permission_Type_OneArgs = {
  object: Enum_Mobile_Permission_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Mobile_Permission_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_OutcomeArgs = {
  objects: Array<Enum_Outcome_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Outcome_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Outcome_OneArgs = {
  object: Enum_Outcome_Insert_Input;
  on_conflict?: InputMaybe<Enum_Outcome_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Question_TypeArgs = {
  objects: Array<Enum_Question_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Question_Type_OneArgs = {
  object: Enum_Question_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Racial_EthnicArgs = {
  objects: Array<Enum_Racial_Ethnic_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Racial_Ethnic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Racial_Ethnic_OneArgs = {
  object: Enum_Racial_Ethnic_Insert_Input;
  on_conflict?: InputMaybe<Enum_Racial_Ethnic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Resource_TypeArgs = {
  objects: Array<Enum_Resource_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Resource_Type_OneArgs = {
  object: Enum_Resource_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Resource_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Section_Category_TypeArgs = {
  objects: Array<Enum_Safety_Plan_Section_Category_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Section_Category_Type_OneArgs = {
  object: Enum_Safety_Plan_Section_Category_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Section_IconsArgs = {
  objects: Array<Enum_Safety_Plan_Section_Icons_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Section_Icons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Section_Icons_OneArgs = {
  object: Enum_Safety_Plan_Section_Icons_Insert_Input;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Section_Icons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_StatusArgs = {
  objects: Array<Enum_Safety_Plan_Status_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Status_OneArgs = {
  object: Enum_Safety_Plan_Status_Insert_Input;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_TypeArgs = {
  objects: Array<Enum_Safety_Plan_Type_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Safety_Plan_Type_OneArgs = {
  object: Enum_Safety_Plan_Type_Insert_Input;
  on_conflict?: InputMaybe<Enum_Safety_Plan_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Trend_DirectionArgs = {
  objects: Array<Enum_Trend_Direction_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Trend_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Trend_Direction_OneArgs = {
  object: Enum_Trend_Direction_Insert_Input;
  on_conflict?: InputMaybe<Enum_Trend_Direction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Report_Feature_CoefficientsArgs = {
  objects: Array<Feature_Report_Feature_Coefficients_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Report_Feature_Coefficients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Report_Feature_Coefficients_OneArgs = {
  object: Feature_Report_Feature_Coefficients_Insert_Input;
  on_conflict?: InputMaybe<Feature_Report_Feature_Coefficients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Report_FeaturesArgs = {
  objects: Array<Feature_Report_Features_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Report_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Report_Features_OneArgs = {
  object: Feature_Report_Features_Insert_Input;
  on_conflict?: InputMaybe<Feature_Report_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_ReportsArgs = {
  objects: Array<Feature_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Feature_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feature_Reports_OneArgs = {
  object: Feature_Reports_Insert_Input;
  on_conflict?: InputMaybe<Feature_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_CodeArgs = {
  objects: Array<Group_Code_Insert_Input>;
  on_conflict?: InputMaybe<Group_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Group_Code_OneArgs = {
  object: Group_Code_Insert_Input;
  on_conflict?: InputMaybe<Group_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_ArticlesArgs = {
  objects: Array<Insight_Articles_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Articles_OneArgs = {
  object: Insight_Articles_Insert_Input;
  on_conflict?: InputMaybe<Insight_Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_CombosArgs = {
  objects: Array<Insight_Combos_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Combos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Combos_OneArgs = {
  object: Insight_Combos_Insert_Input;
  on_conflict?: InputMaybe<Insight_Combos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_HowsArgs = {
  objects: Array<Insight_Hows_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Hows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Hows_OneArgs = {
  object: Insight_Hows_Insert_Input;
  on_conflict?: InputMaybe<Insight_Hows_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Plan_ArticleArgs = {
  objects: Array<Insight_Plan_Article_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Plan_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Plan_Article_OneArgs = {
  object: Insight_Plan_Article_Insert_Input;
  on_conflict?: InputMaybe<Insight_Plan_Article_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Plan_TextArgs = {
  objects: Array<Insight_Plan_Text_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Plan_Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Plan_Text_OneArgs = {
  object: Insight_Plan_Text_Insert_Input;
  on_conflict?: InputMaybe<Insight_Plan_Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_PlansArgs = {
  objects: Array<Insight_Plans_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Plans_OneArgs = {
  object: Insight_Plans_Insert_Input;
  on_conflict?: InputMaybe<Insight_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_QuestionsArgs = {
  objects: Array<Insight_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Questions_OneArgs = {
  object: Insight_Questions_Insert_Input;
  on_conflict?: InputMaybe<Insight_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_RecipesArgs = {
  objects: Array<Insight_Recipes_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Recipes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Recipes_OneArgs = {
  object: Insight_Recipes_Insert_Input;
  on_conflict?: InputMaybe<Insight_Recipes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_ReflectArgs = {
  objects: Array<Insight_Reflect_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Reflect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Reflect_OneArgs = {
  object: Insight_Reflect_Insert_Input;
  on_conflict?: InputMaybe<Insight_Reflect_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Reflect_TextArgs = {
  objects: Array<Insight_Reflect_Text_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Reflect_Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Reflect_Text_OneArgs = {
  object: Insight_Reflect_Text_Insert_Input;
  on_conflict?: InputMaybe<Insight_Reflect_Text_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_ResourcesArgs = {
  objects: Array<Insight_Resources_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Resources_OneArgs = {
  object: Insight_Resources_Insert_Input;
  on_conflict?: InputMaybe<Insight_Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_TextsArgs = {
  objects: Array<Insight_Texts_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Texts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Texts_OneArgs = {
  object: Insight_Texts_Insert_Input;
  on_conflict?: InputMaybe<Insight_Texts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_TipsArgs = {
  objects: Array<Insight_Tips_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Tips_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Tips_OneArgs = {
  object: Insight_Tips_Insert_Input;
  on_conflict?: InputMaybe<Insight_Tips_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_WhysArgs = {
  objects: Array<Insight_Whys_Insert_Input>;
  on_conflict?: InputMaybe<Insight_Whys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Insight_Whys_OneArgs = {
  object: Insight_Whys_Insert_Input;
  on_conflict?: InputMaybe<Insight_Whys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_CodesArgs = {
  objects: Array<Invite_Codes_Insert_Input>;
  on_conflict?: InputMaybe<Invite_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invite_Codes_OneArgs = {
  object: Invite_Codes_Insert_Input;
  on_conflict?: InputMaybe<Invite_Codes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LogsArgs = {
  objects: Array<Logs_Insert_Input>;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_OneArgs = {
  object: Logs_Insert_Input;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Device_DataArgs = {
  objects: Array<Mobile_Device_Data_Insert_Input>;
  on_conflict?: InputMaybe<Mobile_Device_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Device_Data_OneArgs = {
  object: Mobile_Device_Data_Insert_Input;
  on_conflict?: InputMaybe<Mobile_Device_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_PermissionsArgs = {
  objects: Array<Mobile_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Mobile_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Permissions_OneArgs = {
  object: Mobile_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Mobile_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Upload_LogArgs = {
  objects: Array<Mobile_Upload_Log_Insert_Input>;
  on_conflict?: InputMaybe<Mobile_Upload_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Upload_Log_OneArgs = {
  object: Mobile_Upload_Log_Insert_Input;
  on_conflict?: InputMaybe<Mobile_Upload_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mood_MeasurementsArgs = {
  objects: Array<Mood_Measurements_Insert_Input>;
  on_conflict?: InputMaybe<Mood_Measurements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mood_Measurements_OneArgs = {
  object: Mood_Measurements_Insert_Input;
  on_conflict?: InputMaybe<Mood_Measurements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nudge_SchedulesArgs = {
  objects: Array<Nudge_Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Nudge_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nudge_Schedules_OneArgs = {
  object: Nudge_Schedules_Insert_Input;
  on_conflict?: InputMaybe<Nudge_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nudge_TakesArgs = {
  objects: Array<Nudge_Takes_Insert_Input>;
  on_conflict?: InputMaybe<Nudge_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nudge_Takes_OneArgs = {
  object: Nudge_Takes_Insert_Input;
  on_conflict?: InputMaybe<Nudge_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NudgesArgs = {
  objects: Array<Nudges_Insert_Input>;
  on_conflict?: InputMaybe<Nudges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nudges_OneArgs = {
  object: Nudges_Insert_Input;
  on_conflict?: InputMaybe<Nudges_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_AdminsArgs = {
  objects: Array<Organization_Admins_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Admins_OneArgs = {
  object: Organization_Admins_Insert_Input;
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_FeaturesArgs = {
  objects: Array<Organization_Features_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Features_OneArgs = {
  object: Organization_Features_Insert_Input;
  on_conflict?: InputMaybe<Organization_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Member_RolesArgs = {
  objects: Array<Organization_Member_Roles_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Member_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Member_Roles_OneArgs = {
  object: Organization_Member_Roles_Insert_Input;
  on_conflict?: InputMaybe<Organization_Member_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_MembersArgs = {
  objects: Array<Organization_Members_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Members_OneArgs = {
  object: Organization_Members_Insert_Input;
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_SuperviseesArgs = {
  objects: Array<Organization_Supervisees_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Supervisees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Supervisees_OneArgs = {
  object: Organization_Supervisees_Insert_Input;
  on_conflict?: InputMaybe<Organization_Supervisees_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_SupervisorsArgs = {
  objects: Array<Organization_Supervisors_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Supervisors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Supervisors_OneArgs = {
  object: Organization_Supervisors_Insert_Input;
  on_conflict?: InputMaybe<Organization_Supervisors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_OneArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_ItemsArgs = {
  objects: Array<Questionnaire_Items_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Items_OneArgs = {
  object: Questionnaire_Items_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Response_OptionsArgs = {
  objects: Array<Questionnaire_Response_Options_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Response_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Response_Options_OneArgs = {
  object: Questionnaire_Response_Options_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Response_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_ResponsesArgs = {
  objects: Array<Questionnaire_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Responses_OneArgs = {
  object: Questionnaire_Responses_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Risk_Alert_ContactsArgs = {
  objects: Array<Questionnaire_Risk_Alert_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Risk_Alert_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Risk_Alert_Contacts_OneArgs = {
  object: Questionnaire_Risk_Alert_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Risk_Alert_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_SchedulesArgs = {
  objects: Array<Questionnaire_Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Schedules_OneArgs = {
  object: Questionnaire_Schedules_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_ScoringArgs = {
  objects: Array<Questionnaire_Scoring_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Scoring_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Scoring_OneArgs = {
  object: Questionnaire_Scoring_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Scoring_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_TakesArgs = {
  objects: Array<Questionnaire_Takes_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaire_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaire_Takes_OneArgs = {
  object: Questionnaire_Takes_Insert_Input;
  on_conflict?: InputMaybe<Questionnaire_Takes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionnairesArgs = {
  objects: Array<Questionnaires_Insert_Input>;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Questionnaires_OneArgs = {
  object: Questionnaires_Insert_Input;
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relapse_Prevention_Place_VisitsArgs = {
  objects: Array<Relapse_Prevention_Place_Visits_Insert_Input>;
  on_conflict?: InputMaybe<Relapse_Prevention_Place_Visits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relapse_Prevention_Place_Visits_OneArgs = {
  object: Relapse_Prevention_Place_Visits_Insert_Input;
  on_conflict?: InputMaybe<Relapse_Prevention_Place_Visits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relapse_Prevention_PlacesArgs = {
  objects: Array<Relapse_Prevention_Places_Insert_Input>;
  on_conflict?: InputMaybe<Relapse_Prevention_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relapse_Prevention_Places_OneArgs = {
  object: Relapse_Prevention_Places_Insert_Input;
  on_conflict?: InputMaybe<Relapse_Prevention_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ResourcesArgs = {
  objects: Array<Resources_Insert_Input>;
  on_conflict?: InputMaybe<Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resources_OneArgs = {
  object: Resources_Insert_Input;
  on_conflict?: InputMaybe<Resources_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resources_OrgsArgs = {
  objects: Array<Resources_Orgs_Insert_Input>;
  on_conflict?: InputMaybe<Resources_Orgs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resources_Orgs_OneArgs = {
  object: Resources_Orgs_Insert_Input;
  on_conflict?: InputMaybe<Resources_Orgs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Alerts_LogArgs = {
  objects: Array<Risk_Alerts_Log_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Alerts_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Alerts_Log_OneArgs = {
  object: Risk_Alerts_Log_Insert_Input;
  on_conflict?: InputMaybe<Risk_Alerts_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Alerts_Recipients_LogArgs = {
  objects: Array<Risk_Alerts_Recipients_Log_Insert_Input>;
  on_conflict?: InputMaybe<Risk_Alerts_Recipients_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Risk_Alerts_Recipients_Log_OneArgs = {
  object: Risk_Alerts_Recipients_Log_Insert_Input;
  on_conflict?: InputMaybe<Risk_Alerts_Recipients_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_CapabilitiesArgs = {
  objects: Array<Role_Capabilities_Insert_Input>;
  on_conflict?: InputMaybe<Role_Capabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Capabilities_OneArgs = {
  object: Role_Capabilities_Insert_Input;
  on_conflict?: InputMaybe<Role_Capabilities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Checklist_Recipients_LogArgs = {
  objects: Array<Safety_Checklist_Recipients_Log_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Checklist_Recipients_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Checklist_Recipients_Log_OneArgs = {
  object: Safety_Checklist_Recipients_Log_Insert_Input;
  on_conflict?: InputMaybe<Safety_Checklist_Recipients_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_PlanArgs = {
  objects: Array<Safety_Plan_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Checklist_ItemsArgs = {
  objects: Array<Safety_Plan_Checklist_Items_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_Checklist_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Checklist_Items_OneArgs = {
  object: Safety_Plan_Checklist_Items_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_Checklist_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_OneArgs = {
  object: Safety_Plan_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Response_OptionsArgs = {
  objects: Array<Safety_Plan_Response_Options_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_Response_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Response_Options_OneArgs = {
  object: Safety_Plan_Response_Options_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_Response_Options_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Section_CategoryArgs = {
  objects: Array<Safety_Plan_Section_Category_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_Section_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Section_Category_OneArgs = {
  object: Safety_Plan_Section_Category_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_Section_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_SectionsArgs = {
  objects: Array<Safety_Plan_Sections_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_Sections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Sections_OneArgs = {
  object: Safety_Plan_Sections_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_Sections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_TemplateArgs = {
  objects: Array<Safety_Plan_Template_Insert_Input>;
  on_conflict?: InputMaybe<Safety_Plan_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safety_Plan_Template_OneArgs = {
  object: Safety_Plan_Template_Insert_Input;
  on_conflict?: InputMaybe<Safety_Plan_Template_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schedule_Blackout_DatesArgs = {
  objects: Array<Schedule_Blackout_Dates_Insert_Input>;
  on_conflict?: InputMaybe<Schedule_Blackout_Dates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Schedule_Blackout_Dates_OneArgs = {
  object: Schedule_Blackout_Dates_Insert_Input;
  on_conflict?: InputMaybe<Schedule_Blackout_Dates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Action_PlansArgs = {
  objects: Array<Transcript_Action_Plans_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Action_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Action_Plans_OneArgs = {
  object: Transcript_Action_Plans_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Action_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Progress_NotesArgs = {
  objects: Array<Transcript_Progress_Notes_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Progress_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Progress_Notes_OneArgs = {
  object: Transcript_Progress_Notes_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Progress_Notes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Score_ResultsArgs = {
  objects: Array<Transcript_Score_Results_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Score_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Score_Results_OneArgs = {
  object: Transcript_Score_Results_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Score_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_SessionsArgs = {
  objects: Array<Transcript_Sessions_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Sessions_OneArgs = {
  object: Transcript_Sessions_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Sessions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_TranscriptsArgs = {
  objects: Array<Transcript_Transcripts_Insert_Input>;
  on_conflict?: InputMaybe<Transcript_Transcripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transcript_Transcripts_OneArgs = {
  object: Transcript_Transcripts_Insert_Input;
  on_conflict?: InputMaybe<Transcript_Transcripts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feature_FlagArgs = {
  objects: Array<User_Feature_Flag_Insert_Input>;
  on_conflict?: InputMaybe<User_Feature_Flag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feature_Flag_OneArgs = {
  object: User_Feature_Flag_Insert_Input;
  on_conflict?: InputMaybe<User_Feature_Flag_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_CodeArgs = {
  objects: Array<User_Group_Code_Insert_Input>;
  on_conflict?: InputMaybe<User_Group_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Group_Code_OneArgs = {
  object: User_Group_Code_Insert_Input;
  on_conflict?: InputMaybe<User_Group_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_InsightsArgs = {
  objects: Array<User_Insights_Insert_Input>;
  on_conflict?: InputMaybe<User_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Insights_OneArgs = {
  object: User_Insights_Insert_Input;
  on_conflict?: InputMaybe<User_Insights_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_InvitesArgs = {
  objects: Array<User_Invites_Insert_Input>;
  on_conflict?: InputMaybe<User_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Invites_OneArgs = {
  object: User_Invites_Insert_Input;
  on_conflict?: InputMaybe<User_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Insights_Display_StatusArgs = {
  objects: Array<Users_Insights_Display_Status_Insert_Input>;
  on_conflict?: InputMaybe<Users_Insights_Display_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Insights_Display_Status_OneArgs = {
  object: Users_Insights_Display_Status_Insert_Input;
  on_conflict?: InputMaybe<Users_Insights_Display_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  where: Activity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_By_PkArgs = {
  _inc?: InputMaybe<Activity_Inc_Input>;
  _set?: InputMaybe<Activity_Set_Input>;
  pk_columns: Activity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_ManyArgs = {
  updates: Array<Activity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_RatingArgs = {
  _inc?: InputMaybe<Activity_Rating_Inc_Input>;
  _set?: InputMaybe<Activity_Rating_Set_Input>;
  where: Activity_Rating_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Rating_By_PkArgs = {
  _inc?: InputMaybe<Activity_Rating_Inc_Input>;
  _set?: InputMaybe<Activity_Rating_Set_Input>;
  pk_columns: Activity_Rating_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Rating_ManyArgs = {
  updates: Array<Activity_Rating_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_ResourceArgs = {
  _set?: InputMaybe<Activity_Resource_Set_Input>;
  where: Activity_Resource_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Resource_By_PkArgs = {
  _set?: InputMaybe<Activity_Resource_Set_Input>;
  pk_columns: Activity_Resource_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Resource_CategoryArgs = {
  _set?: InputMaybe<Activity_Resource_Category_Set_Input>;
  where: Activity_Resource_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Resource_Category_By_PkArgs = {
  _set?: InputMaybe<Activity_Resource_Category_Set_Input>;
  pk_columns: Activity_Resource_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Resource_Category_ManyArgs = {
  updates: Array<Activity_Resource_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Resource_ManyArgs = {
  updates: Array<Activity_Resource_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Sub_CategoryArgs = {
  _set?: InputMaybe<Activity_Sub_Category_Set_Input>;
  where: Activity_Sub_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Sub_Category_By_PkArgs = {
  _set?: InputMaybe<Activity_Sub_Category_Set_Input>;
  pk_columns: Activity_Sub_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Sub_Category_ManyArgs = {
  updates: Array<Activity_Sub_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Suggested_ActivitiesArgs = {
  _set?: InputMaybe<Activity_Suggested_Activities_Set_Input>;
  where: Activity_Suggested_Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Suggested_Activities_By_PkArgs = {
  _set?: InputMaybe<Activity_Suggested_Activities_Set_Input>;
  pk_columns: Activity_Suggested_Activities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_Suggested_Activities_ManyArgs = {
  updates: Array<Activity_Suggested_Activities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_AnswersArgs = {
  _set?: InputMaybe<Assessment_Answers_Set_Input>;
  where: Assessment_Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Answers_By_PkArgs = {
  _set?: InputMaybe<Assessment_Answers_Set_Input>;
  pk_columns: Assessment_Answers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Answers_ManyArgs = {
  updates: Array<Assessment_Answers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Branching_RulesArgs = {
  _inc?: InputMaybe<Assessment_Branching_Rules_Inc_Input>;
  _set?: InputMaybe<Assessment_Branching_Rules_Set_Input>;
  where: Assessment_Branching_Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Branching_Rules_By_PkArgs = {
  _inc?: InputMaybe<Assessment_Branching_Rules_Inc_Input>;
  _set?: InputMaybe<Assessment_Branching_Rules_Set_Input>;
  pk_columns: Assessment_Branching_Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Branching_Rules_ManyArgs = {
  updates: Array<Assessment_Branching_Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_PagesArgs = {
  _inc?: InputMaybe<Assessment_Pages_Inc_Input>;
  _set?: InputMaybe<Assessment_Pages_Set_Input>;
  where: Assessment_Pages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Pages_By_PkArgs = {
  _inc?: InputMaybe<Assessment_Pages_Inc_Input>;
  _set?: InputMaybe<Assessment_Pages_Set_Input>;
  pk_columns: Assessment_Pages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Pages_ManyArgs = {
  updates: Array<Assessment_Pages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Question_Custom_PromptArgs = {
  _set?: InputMaybe<Assessment_Question_Custom_Prompt_Set_Input>;
  where: Assessment_Question_Custom_Prompt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Question_Custom_Prompt_By_PkArgs = {
  _set?: InputMaybe<Assessment_Question_Custom_Prompt_Set_Input>;
  pk_columns: Assessment_Question_Custom_Prompt_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Question_Custom_Prompt_ManyArgs = {
  updates: Array<Assessment_Question_Custom_Prompt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_QuestionsArgs = {
  _append?: InputMaybe<Assessment_Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Assessment_Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assessment_Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assessment_Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Assessment_Questions_Inc_Input>;
  _prepend?: InputMaybe<Assessment_Questions_Prepend_Input>;
  _set?: InputMaybe<Assessment_Questions_Set_Input>;
  where: Assessment_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Questions_By_PkArgs = {
  _append?: InputMaybe<Assessment_Questions_Append_Input>;
  _delete_at_path?: InputMaybe<Assessment_Questions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assessment_Questions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assessment_Questions_Delete_Key_Input>;
  _inc?: InputMaybe<Assessment_Questions_Inc_Input>;
  _prepend?: InputMaybe<Assessment_Questions_Prepend_Input>;
  _set?: InputMaybe<Assessment_Questions_Set_Input>;
  pk_columns: Assessment_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Questions_ManyArgs = {
  updates: Array<Assessment_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_TakesArgs = {
  _set?: InputMaybe<Assessment_Takes_Set_Input>;
  where: Assessment_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Takes_By_PkArgs = {
  _set?: InputMaybe<Assessment_Takes_Set_Input>;
  pk_columns: Assessment_Takes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessment_Takes_ManyArgs = {
  updates: Array<Assessment_Takes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssessmentsArgs = {
  _inc?: InputMaybe<Assessments_Inc_Input>;
  _set?: InputMaybe<Assessments_Set_Input>;
  where: Assessments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Assessments_By_PkArgs = {
  _inc?: InputMaybe<Assessments_Inc_Input>;
  _set?: InputMaybe<Assessments_Set_Input>;
  pk_columns: Assessments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Assessments_ManyArgs = {
  updates: Array<Assessments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Migration_LogArgs = {
  _inc?: InputMaybe<Auth_Account_Migration_Log_Inc_Input>;
  _set?: InputMaybe<Auth_Account_Migration_Log_Set_Input>;
  where: Auth_Account_Migration_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Migration_Log_By_PkArgs = {
  _inc?: InputMaybe<Auth_Account_Migration_Log_Inc_Input>;
  _set?: InputMaybe<Auth_Account_Migration_Log_Set_Input>;
  pk_columns: Auth_Account_Migration_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Migration_Log_ManyArgs = {
  updates: Array<Auth_Account_Migration_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_ProvidersArgs = {
  _set?: InputMaybe<Auth_Account_Providers_Set_Input>;
  where: Auth_Account_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Providers_By_PkArgs = {
  _set?: InputMaybe<Auth_Account_Providers_Set_Input>;
  pk_columns: Auth_Account_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Providers_ManyArgs = {
  updates: Array<Auth_Account_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_RolesArgs = {
  _set?: InputMaybe<Auth_Account_Roles_Set_Input>;
  where: Auth_Account_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Roles_By_PkArgs = {
  _set?: InputMaybe<Auth_Account_Roles_Set_Input>;
  pk_columns: Auth_Account_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Account_Roles_ManyArgs = {
  updates: Array<Auth_Account_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_AccountsArgs = {
  _append?: InputMaybe<Auth_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Auth_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Auth_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Auth_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Auth_Accounts_Prepend_Input>;
  _set?: InputMaybe<Auth_Accounts_Set_Input>;
  where: Auth_Accounts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Accounts_By_PkArgs = {
  _append?: InputMaybe<Auth_Accounts_Append_Input>;
  _delete_at_path?: InputMaybe<Auth_Accounts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Auth_Accounts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Auth_Accounts_Delete_Key_Input>;
  _prepend?: InputMaybe<Auth_Accounts_Prepend_Input>;
  _set?: InputMaybe<Auth_Accounts_Set_Input>;
  pk_columns: Auth_Accounts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Accounts_ManyArgs = {
  updates: Array<Auth_Accounts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_ProvidersArgs = {
  _set?: InputMaybe<Auth_Providers_Set_Input>;
  where: Auth_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Providers_By_PkArgs = {
  _set?: InputMaybe<Auth_Providers_Set_Input>;
  pk_columns: Auth_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Providers_ManyArgs = {
  updates: Array<Auth_Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_Token_Usage_LogArgs = {
  _set?: InputMaybe<Auth_Refresh_Token_Usage_Log_Set_Input>;
  where: Auth_Refresh_Token_Usage_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_Token_Usage_Log_By_PkArgs = {
  _set?: InputMaybe<Auth_Refresh_Token_Usage_Log_Set_Input>;
  pk_columns: Auth_Refresh_Token_Usage_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_Token_Usage_Log_ManyArgs = {
  updates: Array<Auth_Refresh_Token_Usage_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_TokensArgs = {
  _set?: InputMaybe<Auth_Refresh_Tokens_Set_Input>;
  where: Auth_Refresh_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_Tokens_By_PkArgs = {
  _set?: InputMaybe<Auth_Refresh_Tokens_Set_Input>;
  pk_columns: Auth_Refresh_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Refresh_Tokens_ManyArgs = {
  updates: Array<Auth_Refresh_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_RolesArgs = {
  _set?: InputMaybe<Auth_Roles_Set_Input>;
  where: Auth_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Roles_By_PkArgs = {
  _set?: InputMaybe<Auth_Roles_Set_Input>;
  pk_columns: Auth_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Auth_Roles_ManyArgs = {
  updates: Array<Auth_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Casemix_CategoryArgs = {
  _inc?: InputMaybe<Casemix_Category_Inc_Input>;
  _set?: InputMaybe<Casemix_Category_Set_Input>;
  where: Casemix_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Casemix_Category_By_PkArgs = {
  _inc?: InputMaybe<Casemix_Category_Inc_Input>;
  _set?: InputMaybe<Casemix_Category_Set_Input>;
  pk_columns: Casemix_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Casemix_Category_ManyArgs = {
  updates: Array<Casemix_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Client_DemographicsArgs = {
  _inc?: InputMaybe<Client_Demographics_Inc_Input>;
  _set?: InputMaybe<Client_Demographics_Set_Input>;
  where: Client_Demographics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Demographics_By_PkArgs = {
  _inc?: InputMaybe<Client_Demographics_Inc_Input>;
  _set?: InputMaybe<Client_Demographics_Set_Input>;
  pk_columns: Client_Demographics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_Demographics_ManyArgs = {
  updates: Array<Client_Demographics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_FeaturesArgs = {
  _inc?: InputMaybe<Daily_Features_Inc_Input>;
  _set?: InputMaybe<Daily_Features_Set_Input>;
  where: Daily_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Features_By_PkArgs = {
  _inc?: InputMaybe<Daily_Features_Inc_Input>;
  _set?: InputMaybe<Daily_Features_Set_Input>;
  pk_columns: Daily_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Daily_Features_ManyArgs = {
  updates: Array<Daily_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Client_Invite_CodesArgs = {
  _inc?: InputMaybe<Ehr_Client_Invite_Codes_Inc_Input>;
  _set?: InputMaybe<Ehr_Client_Invite_Codes_Set_Input>;
  where: Ehr_Client_Invite_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Client_Invite_Codes_By_PkArgs = {
  _inc?: InputMaybe<Ehr_Client_Invite_Codes_Inc_Input>;
  _set?: InputMaybe<Ehr_Client_Invite_Codes_Set_Input>;
  pk_columns: Ehr_Client_Invite_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Client_Invite_Codes_ManyArgs = {
  updates: Array<Ehr_Client_Invite_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Ehr_Practitioner_MapArgs = {
  _set?: InputMaybe<Ehr_Ehr_Practitioner_Map_Set_Input>;
  where: Ehr_Ehr_Practitioner_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Ehr_Practitioner_Map_By_PkArgs = {
  _set?: InputMaybe<Ehr_Ehr_Practitioner_Map_Set_Input>;
  pk_columns: Ehr_Ehr_Practitioner_Map_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Ehr_Practitioner_Map_ManyArgs = {
  updates: Array<Ehr_Ehr_Practitioner_Map_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Event_NotificationArgs = {
  _append?: InputMaybe<Ehr_Xealth_Event_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Xealth_Event_Notification_Prepend_Input>;
  _set?: InputMaybe<Ehr_Xealth_Event_Notification_Set_Input>;
  where: Ehr_Xealth_Event_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Event_Notification_By_PkArgs = {
  _append?: InputMaybe<Ehr_Xealth_Event_Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Xealth_Event_Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Xealth_Event_Notification_Prepend_Input>;
  _set?: InputMaybe<Ehr_Xealth_Event_Notification_Set_Input>;
  pk_columns: Ehr_Xealth_Event_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Event_Notification_ManyArgs = {
  updates: Array<Ehr_Xealth_Event_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_FormArgs = {
  _append?: InputMaybe<Ehr_Xealth_Preorder_Form_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Xealth_Preorder_Form_Prepend_Input>;
  _set?: InputMaybe<Ehr_Xealth_Preorder_Form_Set_Input>;
  where: Ehr_Xealth_Preorder_Form_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_Form_By_PkArgs = {
  _append?: InputMaybe<Ehr_Xealth_Preorder_Form_Append_Input>;
  _delete_at_path?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ehr_Xealth_Preorder_Form_Delete_Key_Input>;
  _prepend?: InputMaybe<Ehr_Xealth_Preorder_Form_Prepend_Input>;
  _set?: InputMaybe<Ehr_Xealth_Preorder_Form_Set_Input>;
  pk_columns: Ehr_Xealth_Preorder_Form_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_Form_ManyArgs = {
  updates: Array<Ehr_Xealth_Preorder_Form_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_Invite_MapArgs = {
  _set?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Set_Input>;
  where: Ehr_Xealth_Preorder_Invite_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_Invite_Map_By_PkArgs = {
  _set?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Set_Input>;
  pk_columns: Ehr_Xealth_Preorder_Invite_Map_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ehr_Xealth_Preorder_Invite_Map_ManyArgs = {
  updates: Array<Ehr_Xealth_Preorder_Invite_Map_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_CategoryArgs = {
  _set?: InputMaybe<Enum_Activity_Category_Set_Input>;
  where: Enum_Activity_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_Category_By_PkArgs = {
  _set?: InputMaybe<Enum_Activity_Category_Set_Input>;
  pk_columns: Enum_Activity_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_Category_ManyArgs = {
  updates: Array<Enum_Activity_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_Resource_TypeArgs = {
  _set?: InputMaybe<Enum_Activity_Resource_Type_Set_Input>;
  where: Enum_Activity_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_Resource_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Activity_Resource_Type_Set_Input>;
  pk_columns: Enum_Activity_Resource_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Activity_Resource_Type_ManyArgs = {
  updates: Array<Enum_Activity_Resource_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Completion_StatusArgs = {
  _set?: InputMaybe<Enum_Completion_Status_Set_Input>;
  where: Enum_Completion_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Completion_Status_By_PkArgs = {
  _set?: InputMaybe<Enum_Completion_Status_Set_Input>;
  pk_columns: Enum_Completion_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Completion_Status_ManyArgs = {
  updates: Array<Enum_Completion_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_DirectionArgs = {
  _set?: InputMaybe<Enum_Feature_Direction_Set_Input>;
  where: Enum_Feature_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_Direction_By_PkArgs = {
  _set?: InputMaybe<Enum_Feature_Direction_Set_Input>;
  pk_columns: Enum_Feature_Direction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_Direction_ManyArgs = {
  updates: Array<Enum_Feature_Direction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_TypeArgs = {
  _set?: InputMaybe<Enum_Feature_Type_Set_Input>;
  where: Enum_Feature_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Feature_Type_Set_Input>;
  pk_columns: Enum_Feature_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Feature_Type_ManyArgs = {
  updates: Array<Enum_Feature_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_GenderArgs = {
  _set?: InputMaybe<Enum_Gender_Set_Input>;
  where: Enum_Gender_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Gender_By_PkArgs = {
  _set?: InputMaybe<Enum_Gender_Set_Input>;
  pk_columns: Enum_Gender_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Gender_ManyArgs = {
  updates: Array<Enum_Gender_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Insight_Content_TypeArgs = {
  _set?: InputMaybe<Enum_Insight_Content_Type_Set_Input>;
  where: Enum_Insight_Content_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Insight_Content_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Insight_Content_Type_Set_Input>;
  pk_columns: Enum_Insight_Content_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Insight_Content_Type_ManyArgs = {
  updates: Array<Enum_Insight_Content_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_StatusArgs = {
  _set?: InputMaybe<Enum_Mobile_Permission_Status_Set_Input>;
  where: Enum_Mobile_Permission_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_Status_By_PkArgs = {
  _set?: InputMaybe<Enum_Mobile_Permission_Status_Set_Input>;
  pk_columns: Enum_Mobile_Permission_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_Status_ManyArgs = {
  updates: Array<Enum_Mobile_Permission_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_TypeArgs = {
  _set?: InputMaybe<Enum_Mobile_Permission_Type_Set_Input>;
  where: Enum_Mobile_Permission_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Mobile_Permission_Type_Set_Input>;
  pk_columns: Enum_Mobile_Permission_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Mobile_Permission_Type_ManyArgs = {
  updates: Array<Enum_Mobile_Permission_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_OutcomeArgs = {
  _set?: InputMaybe<Enum_Outcome_Set_Input>;
  where: Enum_Outcome_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Outcome_By_PkArgs = {
  _set?: InputMaybe<Enum_Outcome_Set_Input>;
  pk_columns: Enum_Outcome_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Outcome_ManyArgs = {
  updates: Array<Enum_Outcome_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Question_TypeArgs = {
  _set?: InputMaybe<Enum_Question_Type_Set_Input>;
  where: Enum_Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Question_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Question_Type_Set_Input>;
  pk_columns: Enum_Question_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Question_Type_ManyArgs = {
  updates: Array<Enum_Question_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Racial_EthnicArgs = {
  _set?: InputMaybe<Enum_Racial_Ethnic_Set_Input>;
  where: Enum_Racial_Ethnic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Racial_Ethnic_By_PkArgs = {
  _set?: InputMaybe<Enum_Racial_Ethnic_Set_Input>;
  pk_columns: Enum_Racial_Ethnic_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Racial_Ethnic_ManyArgs = {
  updates: Array<Enum_Racial_Ethnic_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Resource_TypeArgs = {
  _set?: InputMaybe<Enum_Resource_Type_Set_Input>;
  where: Enum_Resource_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Resource_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Resource_Type_Set_Input>;
  pk_columns: Enum_Resource_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Resource_Type_ManyArgs = {
  updates: Array<Enum_Resource_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_Category_TypeArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Set_Input>;
  where: Enum_Safety_Plan_Section_Category_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_Category_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Set_Input>;
  pk_columns: Enum_Safety_Plan_Section_Category_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_Category_Type_ManyArgs = {
  updates: Array<Enum_Safety_Plan_Section_Category_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_IconsArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Section_Icons_Set_Input>;
  where: Enum_Safety_Plan_Section_Icons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_Icons_By_PkArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Section_Icons_Set_Input>;
  pk_columns: Enum_Safety_Plan_Section_Icons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Section_Icons_ManyArgs = {
  updates: Array<Enum_Safety_Plan_Section_Icons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_StatusArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Status_Set_Input>;
  where: Enum_Safety_Plan_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Status_By_PkArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Status_Set_Input>;
  pk_columns: Enum_Safety_Plan_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Status_ManyArgs = {
  updates: Array<Enum_Safety_Plan_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_TypeArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Type_Set_Input>;
  where: Enum_Safety_Plan_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Type_By_PkArgs = {
  _set?: InputMaybe<Enum_Safety_Plan_Type_Set_Input>;
  pk_columns: Enum_Safety_Plan_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Safety_Plan_Type_ManyArgs = {
  updates: Array<Enum_Safety_Plan_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Trend_DirectionArgs = {
  _set?: InputMaybe<Enum_Trend_Direction_Set_Input>;
  where: Enum_Trend_Direction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Trend_Direction_By_PkArgs = {
  _set?: InputMaybe<Enum_Trend_Direction_Set_Input>;
  pk_columns: Enum_Trend_Direction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Trend_Direction_ManyArgs = {
  updates: Array<Enum_Trend_Direction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_Feature_CoefficientsArgs = {
  _inc?: InputMaybe<Feature_Report_Feature_Coefficients_Inc_Input>;
  _set?: InputMaybe<Feature_Report_Feature_Coefficients_Set_Input>;
  where: Feature_Report_Feature_Coefficients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_Feature_Coefficients_By_PkArgs = {
  _inc?: InputMaybe<Feature_Report_Feature_Coefficients_Inc_Input>;
  _set?: InputMaybe<Feature_Report_Feature_Coefficients_Set_Input>;
  pk_columns: Feature_Report_Feature_Coefficients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_Feature_Coefficients_ManyArgs = {
  updates: Array<Feature_Report_Feature_Coefficients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_FeaturesArgs = {
  _inc?: InputMaybe<Feature_Report_Features_Inc_Input>;
  _set?: InputMaybe<Feature_Report_Features_Set_Input>;
  where: Feature_Report_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_Features_By_PkArgs = {
  _inc?: InputMaybe<Feature_Report_Features_Inc_Input>;
  _set?: InputMaybe<Feature_Report_Features_Set_Input>;
  pk_columns: Feature_Report_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Report_Features_ManyArgs = {
  updates: Array<Feature_Report_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_ReportsArgs = {
  _inc?: InputMaybe<Feature_Reports_Inc_Input>;
  _set?: InputMaybe<Feature_Reports_Set_Input>;
  where: Feature_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Reports_By_PkArgs = {
  _inc?: InputMaybe<Feature_Reports_Inc_Input>;
  _set?: InputMaybe<Feature_Reports_Set_Input>;
  pk_columns: Feature_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feature_Reports_ManyArgs = {
  updates: Array<Feature_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Group_CodeArgs = {
  _inc?: InputMaybe<Group_Code_Inc_Input>;
  _set?: InputMaybe<Group_Code_Set_Input>;
  where: Group_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Code_By_PkArgs = {
  _inc?: InputMaybe<Group_Code_Inc_Input>;
  _set?: InputMaybe<Group_Code_Set_Input>;
  pk_columns: Group_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Group_Code_ManyArgs = {
  updates: Array<Group_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_ArticlesArgs = {
  _inc?: InputMaybe<Insight_Articles_Inc_Input>;
  _set?: InputMaybe<Insight_Articles_Set_Input>;
  where: Insight_Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Articles_By_PkArgs = {
  _inc?: InputMaybe<Insight_Articles_Inc_Input>;
  _set?: InputMaybe<Insight_Articles_Set_Input>;
  pk_columns: Insight_Articles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Articles_ManyArgs = {
  updates: Array<Insight_Articles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_CombosArgs = {
  _inc?: InputMaybe<Insight_Combos_Inc_Input>;
  _set?: InputMaybe<Insight_Combos_Set_Input>;
  where: Insight_Combos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Combos_By_PkArgs = {
  _inc?: InputMaybe<Insight_Combos_Inc_Input>;
  _set?: InputMaybe<Insight_Combos_Set_Input>;
  pk_columns: Insight_Combos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Combos_ManyArgs = {
  updates: Array<Insight_Combos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_HowsArgs = {
  _inc?: InputMaybe<Insight_Hows_Inc_Input>;
  _set?: InputMaybe<Insight_Hows_Set_Input>;
  where: Insight_Hows_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Hows_By_PkArgs = {
  _inc?: InputMaybe<Insight_Hows_Inc_Input>;
  _set?: InputMaybe<Insight_Hows_Set_Input>;
  pk_columns: Insight_Hows_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Hows_ManyArgs = {
  updates: Array<Insight_Hows_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_ArticleArgs = {
  _inc?: InputMaybe<Insight_Plan_Article_Inc_Input>;
  _set?: InputMaybe<Insight_Plan_Article_Set_Input>;
  where: Insight_Plan_Article_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_Article_By_PkArgs = {
  _inc?: InputMaybe<Insight_Plan_Article_Inc_Input>;
  _set?: InputMaybe<Insight_Plan_Article_Set_Input>;
  pk_columns: Insight_Plan_Article_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_Article_ManyArgs = {
  updates: Array<Insight_Plan_Article_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_TextArgs = {
  _inc?: InputMaybe<Insight_Plan_Text_Inc_Input>;
  _set?: InputMaybe<Insight_Plan_Text_Set_Input>;
  where: Insight_Plan_Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_Text_By_PkArgs = {
  _inc?: InputMaybe<Insight_Plan_Text_Inc_Input>;
  _set?: InputMaybe<Insight_Plan_Text_Set_Input>;
  pk_columns: Insight_Plan_Text_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plan_Text_ManyArgs = {
  updates: Array<Insight_Plan_Text_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_PlansArgs = {
  _inc?: InputMaybe<Insight_Plans_Inc_Input>;
  _set?: InputMaybe<Insight_Plans_Set_Input>;
  where: Insight_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plans_By_PkArgs = {
  _inc?: InputMaybe<Insight_Plans_Inc_Input>;
  _set?: InputMaybe<Insight_Plans_Set_Input>;
  pk_columns: Insight_Plans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Plans_ManyArgs = {
  updates: Array<Insight_Plans_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_QuestionsArgs = {
  _inc?: InputMaybe<Insight_Questions_Inc_Input>;
  _set?: InputMaybe<Insight_Questions_Set_Input>;
  where: Insight_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Questions_By_PkArgs = {
  _inc?: InputMaybe<Insight_Questions_Inc_Input>;
  _set?: InputMaybe<Insight_Questions_Set_Input>;
  pk_columns: Insight_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Questions_ManyArgs = {
  updates: Array<Insight_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_RecipesArgs = {
  _inc?: InputMaybe<Insight_Recipes_Inc_Input>;
  _set?: InputMaybe<Insight_Recipes_Set_Input>;
  where: Insight_Recipes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Recipes_By_PkArgs = {
  _inc?: InputMaybe<Insight_Recipes_Inc_Input>;
  _set?: InputMaybe<Insight_Recipes_Set_Input>;
  pk_columns: Insight_Recipes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Recipes_ManyArgs = {
  updates: Array<Insight_Recipes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_ReflectArgs = {
  _inc?: InputMaybe<Insight_Reflect_Inc_Input>;
  _set?: InputMaybe<Insight_Reflect_Set_Input>;
  where: Insight_Reflect_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Reflect_By_PkArgs = {
  _inc?: InputMaybe<Insight_Reflect_Inc_Input>;
  _set?: InputMaybe<Insight_Reflect_Set_Input>;
  pk_columns: Insight_Reflect_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Reflect_ManyArgs = {
  updates: Array<Insight_Reflect_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Reflect_TextArgs = {
  _inc?: InputMaybe<Insight_Reflect_Text_Inc_Input>;
  _set?: InputMaybe<Insight_Reflect_Text_Set_Input>;
  where: Insight_Reflect_Text_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Reflect_Text_By_PkArgs = {
  _inc?: InputMaybe<Insight_Reflect_Text_Inc_Input>;
  _set?: InputMaybe<Insight_Reflect_Text_Set_Input>;
  pk_columns: Insight_Reflect_Text_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Reflect_Text_ManyArgs = {
  updates: Array<Insight_Reflect_Text_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_ResourcesArgs = {
  _inc?: InputMaybe<Insight_Resources_Inc_Input>;
  _set?: InputMaybe<Insight_Resources_Set_Input>;
  where: Insight_Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Resources_By_PkArgs = {
  _inc?: InputMaybe<Insight_Resources_Inc_Input>;
  _set?: InputMaybe<Insight_Resources_Set_Input>;
  pk_columns: Insight_Resources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Resources_ManyArgs = {
  updates: Array<Insight_Resources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_TextsArgs = {
  _inc?: InputMaybe<Insight_Texts_Inc_Input>;
  _set?: InputMaybe<Insight_Texts_Set_Input>;
  where: Insight_Texts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Texts_By_PkArgs = {
  _inc?: InputMaybe<Insight_Texts_Inc_Input>;
  _set?: InputMaybe<Insight_Texts_Set_Input>;
  pk_columns: Insight_Texts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Texts_ManyArgs = {
  updates: Array<Insight_Texts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_TipsArgs = {
  _inc?: InputMaybe<Insight_Tips_Inc_Input>;
  _set?: InputMaybe<Insight_Tips_Set_Input>;
  where: Insight_Tips_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Tips_By_PkArgs = {
  _inc?: InputMaybe<Insight_Tips_Inc_Input>;
  _set?: InputMaybe<Insight_Tips_Set_Input>;
  pk_columns: Insight_Tips_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Tips_ManyArgs = {
  updates: Array<Insight_Tips_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_WhysArgs = {
  _inc?: InputMaybe<Insight_Whys_Inc_Input>;
  _set?: InputMaybe<Insight_Whys_Set_Input>;
  where: Insight_Whys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Whys_By_PkArgs = {
  _inc?: InputMaybe<Insight_Whys_Inc_Input>;
  _set?: InputMaybe<Insight_Whys_Set_Input>;
  pk_columns: Insight_Whys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Insight_Whys_ManyArgs = {
  updates: Array<Insight_Whys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_CodesArgs = {
  _inc?: InputMaybe<Invite_Codes_Inc_Input>;
  _set?: InputMaybe<Invite_Codes_Set_Input>;
  where: Invite_Codes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Codes_By_PkArgs = {
  _inc?: InputMaybe<Invite_Codes_Inc_Input>;
  _set?: InputMaybe<Invite_Codes_Set_Input>;
  pk_columns: Invite_Codes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invite_Codes_ManyArgs = {
  updates: Array<Invite_Codes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LogsArgs = {
  _inc?: InputMaybe<Logs_Inc_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_By_PkArgs = {
  _inc?: InputMaybe<Logs_Inc_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  pk_columns: Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_ManyArgs = {
  updates: Array<Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Device_DataArgs = {
  _inc?: InputMaybe<Mobile_Device_Data_Inc_Input>;
  _set?: InputMaybe<Mobile_Device_Data_Set_Input>;
  where: Mobile_Device_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Device_Data_By_PkArgs = {
  _inc?: InputMaybe<Mobile_Device_Data_Inc_Input>;
  _set?: InputMaybe<Mobile_Device_Data_Set_Input>;
  pk_columns: Mobile_Device_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Device_Data_ManyArgs = {
  updates: Array<Mobile_Device_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_PermissionsArgs = {
  _set?: InputMaybe<Mobile_Permissions_Set_Input>;
  where: Mobile_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Permissions_By_PkArgs = {
  _set?: InputMaybe<Mobile_Permissions_Set_Input>;
  pk_columns: Mobile_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Permissions_ManyArgs = {
  updates: Array<Mobile_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Upload_LogArgs = {
  _inc?: InputMaybe<Mobile_Upload_Log_Inc_Input>;
  _set?: InputMaybe<Mobile_Upload_Log_Set_Input>;
  where: Mobile_Upload_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Upload_Log_By_PkArgs = {
  _inc?: InputMaybe<Mobile_Upload_Log_Inc_Input>;
  _set?: InputMaybe<Mobile_Upload_Log_Set_Input>;
  pk_columns: Mobile_Upload_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Upload_Log_ManyArgs = {
  updates: Array<Mobile_Upload_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mood_MeasurementsArgs = {
  _inc?: InputMaybe<Mood_Measurements_Inc_Input>;
  _set?: InputMaybe<Mood_Measurements_Set_Input>;
  where: Mood_Measurements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mood_Measurements_By_PkArgs = {
  _inc?: InputMaybe<Mood_Measurements_Inc_Input>;
  _set?: InputMaybe<Mood_Measurements_Set_Input>;
  pk_columns: Mood_Measurements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mood_Measurements_ManyArgs = {
  updates: Array<Mood_Measurements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_SchedulesArgs = {
  _inc?: InputMaybe<Nudge_Schedules_Inc_Input>;
  _set?: InputMaybe<Nudge_Schedules_Set_Input>;
  where: Nudge_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_Schedules_By_PkArgs = {
  _inc?: InputMaybe<Nudge_Schedules_Inc_Input>;
  _set?: InputMaybe<Nudge_Schedules_Set_Input>;
  pk_columns: Nudge_Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_Schedules_ManyArgs = {
  updates: Array<Nudge_Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_TakesArgs = {
  _inc?: InputMaybe<Nudge_Takes_Inc_Input>;
  _set?: InputMaybe<Nudge_Takes_Set_Input>;
  where: Nudge_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_Takes_By_PkArgs = {
  _inc?: InputMaybe<Nudge_Takes_Inc_Input>;
  _set?: InputMaybe<Nudge_Takes_Set_Input>;
  pk_columns: Nudge_Takes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nudge_Takes_ManyArgs = {
  updates: Array<Nudge_Takes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NudgesArgs = {
  _inc?: InputMaybe<Nudges_Inc_Input>;
  _set?: InputMaybe<Nudges_Set_Input>;
  where: Nudges_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nudges_By_PkArgs = {
  _inc?: InputMaybe<Nudges_Inc_Input>;
  _set?: InputMaybe<Nudges_Set_Input>;
  pk_columns: Nudges_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nudges_ManyArgs = {
  updates: Array<Nudges_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_AdminsArgs = {
  _inc?: InputMaybe<Organization_Admins_Inc_Input>;
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  where: Organization_Admins_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Admins_By_PkArgs = {
  _inc?: InputMaybe<Organization_Admins_Inc_Input>;
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  pk_columns: Organization_Admins_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Admins_ManyArgs = {
  updates: Array<Organization_Admins_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_FeaturesArgs = {
  _inc?: InputMaybe<Organization_Features_Inc_Input>;
  _set?: InputMaybe<Organization_Features_Set_Input>;
  where: Organization_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Features_By_PkArgs = {
  _inc?: InputMaybe<Organization_Features_Inc_Input>;
  _set?: InputMaybe<Organization_Features_Set_Input>;
  pk_columns: Organization_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Features_ManyArgs = {
  updates: Array<Organization_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Member_RolesArgs = {
  _inc?: InputMaybe<Organization_Member_Roles_Inc_Input>;
  _set?: InputMaybe<Organization_Member_Roles_Set_Input>;
  where: Organization_Member_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Member_Roles_By_PkArgs = {
  _inc?: InputMaybe<Organization_Member_Roles_Inc_Input>;
  _set?: InputMaybe<Organization_Member_Roles_Set_Input>;
  pk_columns: Organization_Member_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Member_Roles_ManyArgs = {
  updates: Array<Organization_Member_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_MembersArgs = {
  _inc?: InputMaybe<Organization_Members_Inc_Input>;
  _set?: InputMaybe<Organization_Members_Set_Input>;
  where: Organization_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_By_PkArgs = {
  _inc?: InputMaybe<Organization_Members_Inc_Input>;
  _set?: InputMaybe<Organization_Members_Set_Input>;
  pk_columns: Organization_Members_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Members_ManyArgs = {
  updates: Array<Organization_Members_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_SuperviseesArgs = {
  _set?: InputMaybe<Organization_Supervisees_Set_Input>;
  where: Organization_Supervisees_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Supervisees_By_PkArgs = {
  _set?: InputMaybe<Organization_Supervisees_Set_Input>;
  pk_columns: Organization_Supervisees_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Supervisees_ManyArgs = {
  updates: Array<Organization_Supervisees_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_SupervisorsArgs = {
  _inc?: InputMaybe<Organization_Supervisors_Inc_Input>;
  _set?: InputMaybe<Organization_Supervisors_Set_Input>;
  where: Organization_Supervisors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Supervisors_By_PkArgs = {
  _inc?: InputMaybe<Organization_Supervisors_Inc_Input>;
  _set?: InputMaybe<Organization_Supervisors_Set_Input>;
  pk_columns: Organization_Supervisors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Supervisors_ManyArgs = {
  updates: Array<Organization_Supervisors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_By_PkArgs = {
  _inc?: InputMaybe<Organizations_Inc_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_ManyArgs = {
  updates: Array<Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_ItemsArgs = {
  _inc?: InputMaybe<Questionnaire_Items_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Items_Set_Input>;
  where: Questionnaire_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Items_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Items_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Items_Set_Input>;
  pk_columns: Questionnaire_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Items_ManyArgs = {
  updates: Array<Questionnaire_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Response_OptionsArgs = {
  _inc?: InputMaybe<Questionnaire_Response_Options_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Response_Options_Set_Input>;
  where: Questionnaire_Response_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Response_Options_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Response_Options_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Response_Options_Set_Input>;
  pk_columns: Questionnaire_Response_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Response_Options_ManyArgs = {
  updates: Array<Questionnaire_Response_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_ResponsesArgs = {
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  where: Questionnaire_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Responses_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  pk_columns: Questionnaire_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Responses_ManyArgs = {
  updates: Array<Questionnaire_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Risk_Alert_ContactsArgs = {
  _inc?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Set_Input>;
  where: Questionnaire_Risk_Alert_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Risk_Alert_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Set_Input>;
  pk_columns: Questionnaire_Risk_Alert_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Risk_Alert_Contacts_ManyArgs = {
  updates: Array<Questionnaire_Risk_Alert_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_SchedulesArgs = {
  _inc?: InputMaybe<Questionnaire_Schedules_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Schedules_Set_Input>;
  where: Questionnaire_Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Schedules_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Schedules_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Schedules_Set_Input>;
  pk_columns: Questionnaire_Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Schedules_ManyArgs = {
  updates: Array<Questionnaire_Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_ScoringArgs = {
  _inc?: InputMaybe<Questionnaire_Scoring_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Scoring_Set_Input>;
  where: Questionnaire_Scoring_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Scoring_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Scoring_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Scoring_Set_Input>;
  pk_columns: Questionnaire_Scoring_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Scoring_ManyArgs = {
  updates: Array<Questionnaire_Scoring_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_TakesArgs = {
  _inc?: InputMaybe<Questionnaire_Takes_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Takes_Set_Input>;
  where: Questionnaire_Takes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Takes_By_PkArgs = {
  _inc?: InputMaybe<Questionnaire_Takes_Inc_Input>;
  _set?: InputMaybe<Questionnaire_Takes_Set_Input>;
  pk_columns: Questionnaire_Takes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaire_Takes_ManyArgs = {
  updates: Array<Questionnaire_Takes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionnairesArgs = {
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  _set?: InputMaybe<Questionnaires_Set_Input>;
  where: Questionnaires_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaires_By_PkArgs = {
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  _set?: InputMaybe<Questionnaires_Set_Input>;
  pk_columns: Questionnaires_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Questionnaires_ManyArgs = {
  updates: Array<Questionnaires_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_Place_VisitsArgs = {
  _set?: InputMaybe<Relapse_Prevention_Place_Visits_Set_Input>;
  where: Relapse_Prevention_Place_Visits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_Place_Visits_By_PkArgs = {
  _set?: InputMaybe<Relapse_Prevention_Place_Visits_Set_Input>;
  pk_columns: Relapse_Prevention_Place_Visits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_Place_Visits_ManyArgs = {
  updates: Array<Relapse_Prevention_Place_Visits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_PlacesArgs = {
  _inc?: InputMaybe<Relapse_Prevention_Places_Inc_Input>;
  _set?: InputMaybe<Relapse_Prevention_Places_Set_Input>;
  where: Relapse_Prevention_Places_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_Places_By_PkArgs = {
  _inc?: InputMaybe<Relapse_Prevention_Places_Inc_Input>;
  _set?: InputMaybe<Relapse_Prevention_Places_Set_Input>;
  pk_columns: Relapse_Prevention_Places_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Relapse_Prevention_Places_ManyArgs = {
  updates: Array<Relapse_Prevention_Places_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ResourcesArgs = {
  _inc?: InputMaybe<Resources_Inc_Input>;
  _set?: InputMaybe<Resources_Set_Input>;
  where: Resources_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resources_By_PkArgs = {
  _inc?: InputMaybe<Resources_Inc_Input>;
  _set?: InputMaybe<Resources_Set_Input>;
  pk_columns: Resources_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resources_ManyArgs = {
  updates: Array<Resources_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resources_OrgsArgs = {
  _inc?: InputMaybe<Resources_Orgs_Inc_Input>;
  _set?: InputMaybe<Resources_Orgs_Set_Input>;
  where: Resources_Orgs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resources_Orgs_By_PkArgs = {
  _inc?: InputMaybe<Resources_Orgs_Inc_Input>;
  _set?: InputMaybe<Resources_Orgs_Set_Input>;
  pk_columns: Resources_Orgs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resources_Orgs_ManyArgs = {
  updates: Array<Resources_Orgs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_LogArgs = {
  _inc?: InputMaybe<Risk_Alerts_Log_Inc_Input>;
  _set?: InputMaybe<Risk_Alerts_Log_Set_Input>;
  where: Risk_Alerts_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_Log_By_PkArgs = {
  _inc?: InputMaybe<Risk_Alerts_Log_Inc_Input>;
  _set?: InputMaybe<Risk_Alerts_Log_Set_Input>;
  pk_columns: Risk_Alerts_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_Log_ManyArgs = {
  updates: Array<Risk_Alerts_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_Recipients_LogArgs = {
  _set?: InputMaybe<Risk_Alerts_Recipients_Log_Set_Input>;
  where: Risk_Alerts_Recipients_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_Recipients_Log_By_PkArgs = {
  _set?: InputMaybe<Risk_Alerts_Recipients_Log_Set_Input>;
  pk_columns: Risk_Alerts_Recipients_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Risk_Alerts_Recipients_Log_ManyArgs = {
  updates: Array<Risk_Alerts_Recipients_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_CapabilitiesArgs = {
  _set?: InputMaybe<Role_Capabilities_Set_Input>;
  where: Role_Capabilities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Capabilities_By_PkArgs = {
  _set?: InputMaybe<Role_Capabilities_Set_Input>;
  pk_columns: Role_Capabilities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Capabilities_ManyArgs = {
  updates: Array<Role_Capabilities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_Recipients_LogArgs = {
  _set?: InputMaybe<Safety_Checklist_Recipients_Log_Set_Input>;
  where: Safety_Checklist_Recipients_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_Recipients_Log_By_PkArgs = {
  _set?: InputMaybe<Safety_Checklist_Recipients_Log_Set_Input>;
  pk_columns: Safety_Checklist_Recipients_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Checklist_Recipients_Log_ManyArgs = {
  updates: Array<Safety_Checklist_Recipients_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_PlanArgs = {
  _append?: InputMaybe<Safety_Plan_Append_Input>;
  _delete_at_path?: InputMaybe<Safety_Plan_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Safety_Plan_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Safety_Plan_Delete_Key_Input>;
  _prepend?: InputMaybe<Safety_Plan_Prepend_Input>;
  _set?: InputMaybe<Safety_Plan_Set_Input>;
  where: Safety_Plan_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_By_PkArgs = {
  _append?: InputMaybe<Safety_Plan_Append_Input>;
  _delete_at_path?: InputMaybe<Safety_Plan_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Safety_Plan_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Safety_Plan_Delete_Key_Input>;
  _prepend?: InputMaybe<Safety_Plan_Prepend_Input>;
  _set?: InputMaybe<Safety_Plan_Set_Input>;
  pk_columns: Safety_Plan_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Checklist_ItemsArgs = {
  _inc?: InputMaybe<Safety_Plan_Checklist_Items_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Checklist_Items_Set_Input>;
  where: Safety_Plan_Checklist_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Checklist_Items_By_PkArgs = {
  _inc?: InputMaybe<Safety_Plan_Checklist_Items_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Checklist_Items_Set_Input>;
  pk_columns: Safety_Plan_Checklist_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Checklist_Items_ManyArgs = {
  updates: Array<Safety_Plan_Checklist_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_ManyArgs = {
  updates: Array<Safety_Plan_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Response_OptionsArgs = {
  _inc?: InputMaybe<Safety_Plan_Response_Options_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Response_Options_Set_Input>;
  where: Safety_Plan_Response_Options_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Response_Options_By_PkArgs = {
  _inc?: InputMaybe<Safety_Plan_Response_Options_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Response_Options_Set_Input>;
  pk_columns: Safety_Plan_Response_Options_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Response_Options_ManyArgs = {
  updates: Array<Safety_Plan_Response_Options_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Section_CategoryArgs = {
  _inc?: InputMaybe<Safety_Plan_Section_Category_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Section_Category_Set_Input>;
  where: Safety_Plan_Section_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Section_Category_By_PkArgs = {
  _inc?: InputMaybe<Safety_Plan_Section_Category_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Section_Category_Set_Input>;
  pk_columns: Safety_Plan_Section_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Section_Category_ManyArgs = {
  updates: Array<Safety_Plan_Section_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_SectionsArgs = {
  _inc?: InputMaybe<Safety_Plan_Sections_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Sections_Set_Input>;
  where: Safety_Plan_Sections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Sections_By_PkArgs = {
  _inc?: InputMaybe<Safety_Plan_Sections_Inc_Input>;
  _set?: InputMaybe<Safety_Plan_Sections_Set_Input>;
  pk_columns: Safety_Plan_Sections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Sections_ManyArgs = {
  updates: Array<Safety_Plan_Sections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_TemplateArgs = {
  _set?: InputMaybe<Safety_Plan_Template_Set_Input>;
  where: Safety_Plan_Template_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Template_By_PkArgs = {
  _set?: InputMaybe<Safety_Plan_Template_Set_Input>;
  pk_columns: Safety_Plan_Template_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safety_Plan_Template_ManyArgs = {
  updates: Array<Safety_Plan_Template_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Schedule_Blackout_DatesArgs = {
  _inc?: InputMaybe<Schedule_Blackout_Dates_Inc_Input>;
  _set?: InputMaybe<Schedule_Blackout_Dates_Set_Input>;
  where: Schedule_Blackout_Dates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Schedule_Blackout_Dates_By_PkArgs = {
  _inc?: InputMaybe<Schedule_Blackout_Dates_Inc_Input>;
  _set?: InputMaybe<Schedule_Blackout_Dates_Set_Input>;
  pk_columns: Schedule_Blackout_Dates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Schedule_Blackout_Dates_ManyArgs = {
  updates: Array<Schedule_Blackout_Dates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Action_PlansArgs = {
  _append?: InputMaybe<Transcript_Action_Plans_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Action_Plans_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Action_Plans_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Action_Plans_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Action_Plans_Prepend_Input>;
  _set?: InputMaybe<Transcript_Action_Plans_Set_Input>;
  where: Transcript_Action_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Action_Plans_By_PkArgs = {
  _append?: InputMaybe<Transcript_Action_Plans_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Action_Plans_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Action_Plans_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Action_Plans_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Action_Plans_Prepend_Input>;
  _set?: InputMaybe<Transcript_Action_Plans_Set_Input>;
  pk_columns: Transcript_Action_Plans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Action_Plans_ManyArgs = {
  updates: Array<Transcript_Action_Plans_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Progress_NotesArgs = {
  _append?: InputMaybe<Transcript_Progress_Notes_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Progress_Notes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Progress_Notes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Progress_Notes_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Progress_Notes_Prepend_Input>;
  _set?: InputMaybe<Transcript_Progress_Notes_Set_Input>;
  where: Transcript_Progress_Notes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Progress_Notes_By_PkArgs = {
  _append?: InputMaybe<Transcript_Progress_Notes_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Progress_Notes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Progress_Notes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Progress_Notes_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Progress_Notes_Prepend_Input>;
  _set?: InputMaybe<Transcript_Progress_Notes_Set_Input>;
  pk_columns: Transcript_Progress_Notes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Progress_Notes_ManyArgs = {
  updates: Array<Transcript_Progress_Notes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Score_ResultsArgs = {
  _append?: InputMaybe<Transcript_Score_Results_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Score_Results_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Score_Results_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Score_Results_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Score_Results_Prepend_Input>;
  _set?: InputMaybe<Transcript_Score_Results_Set_Input>;
  where: Transcript_Score_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Score_Results_By_PkArgs = {
  _append?: InputMaybe<Transcript_Score_Results_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Score_Results_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Score_Results_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Score_Results_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Score_Results_Prepend_Input>;
  _set?: InputMaybe<Transcript_Score_Results_Set_Input>;
  pk_columns: Transcript_Score_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Score_Results_ManyArgs = {
  updates: Array<Transcript_Score_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_SessionsArgs = {
  _append?: InputMaybe<Transcript_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Sessions_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Sessions_Prepend_Input>;
  _set?: InputMaybe<Transcript_Sessions_Set_Input>;
  where: Transcript_Sessions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Sessions_By_PkArgs = {
  _append?: InputMaybe<Transcript_Sessions_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Sessions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Sessions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Sessions_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Sessions_Prepend_Input>;
  _set?: InputMaybe<Transcript_Sessions_Set_Input>;
  pk_columns: Transcript_Sessions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Sessions_ManyArgs = {
  updates: Array<Transcript_Sessions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_TranscriptsArgs = {
  _append?: InputMaybe<Transcript_Transcripts_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Transcripts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Transcripts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Transcripts_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Transcripts_Prepend_Input>;
  _set?: InputMaybe<Transcript_Transcripts_Set_Input>;
  where: Transcript_Transcripts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Transcripts_By_PkArgs = {
  _append?: InputMaybe<Transcript_Transcripts_Append_Input>;
  _delete_at_path?: InputMaybe<Transcript_Transcripts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Transcript_Transcripts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Transcript_Transcripts_Delete_Key_Input>;
  _prepend?: InputMaybe<Transcript_Transcripts_Prepend_Input>;
  _set?: InputMaybe<Transcript_Transcripts_Set_Input>;
  pk_columns: Transcript_Transcripts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Transcript_Transcripts_ManyArgs = {
  updates: Array<Transcript_Transcripts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_FlagArgs = {
  _set?: InputMaybe<User_Feature_Flag_Set_Input>;
  where: User_Feature_Flag_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_Flag_By_PkArgs = {
  _set?: InputMaybe<User_Feature_Flag_Set_Input>;
  pk_columns: User_Feature_Flag_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feature_Flag_ManyArgs = {
  updates: Array<User_Feature_Flag_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_CodeArgs = {
  _inc?: InputMaybe<User_Group_Code_Inc_Input>;
  _set?: InputMaybe<User_Group_Code_Set_Input>;
  where: User_Group_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_Code_By_PkArgs = {
  _inc?: InputMaybe<User_Group_Code_Inc_Input>;
  _set?: InputMaybe<User_Group_Code_Set_Input>;
  pk_columns: User_Group_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Group_Code_ManyArgs = {
  updates: Array<User_Group_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_InsightsArgs = {
  _inc?: InputMaybe<User_Insights_Inc_Input>;
  _set?: InputMaybe<User_Insights_Set_Input>;
  where: User_Insights_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Insights_By_PkArgs = {
  _inc?: InputMaybe<User_Insights_Inc_Input>;
  _set?: InputMaybe<User_Insights_Set_Input>;
  pk_columns: User_Insights_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Insights_ManyArgs = {
  updates: Array<User_Insights_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_InvitesArgs = {
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  _set?: InputMaybe<User_Invites_Set_Input>;
  where: User_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Invites_By_PkArgs = {
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  _set?: InputMaybe<User_Invites_Set_Input>;
  pk_columns: User_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Invites_ManyArgs = {
  updates: Array<User_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Insights_Display_StatusArgs = {
  _inc?: InputMaybe<Users_Insights_Display_Status_Inc_Input>;
  _set?: InputMaybe<Users_Insights_Display_Status_Set_Input>;
  where: Users_Insights_Display_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Insights_Display_Status_By_PkArgs = {
  _inc?: InputMaybe<Users_Insights_Display_Status_Inc_Input>;
  _set?: InputMaybe<Users_Insights_Display_Status_Set_Input>;
  pk_columns: Users_Insights_Display_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Insights_Display_Status_ManyArgs = {
  updates: Array<Users_Insights_Display_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** columns and relationships of "nudge_schedules" */
export type Nudge_Schedules = {
  __typename?: 'nudge_schedules';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /** An object relationship */
  nudge: Nudges;
  nudge_id: Scalars['Int']['output'];
  /** An array relationship */
  nudge_takes: Array<Nudge_Takes>;
  /** An aggregate relationship */
  nudge_takes_aggregate: Nudge_Takes_Aggregate;
  one_time?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  practitioner: Users;
  practitioner_id: Scalars['uuid']['output'];
  recurring_friday: Scalars['Boolean']['output'];
  recurring_monday: Scalars['Boolean']['output'];
  recurring_saturday: Scalars['Boolean']['output'];
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  recurring_sunday: Scalars['Boolean']['output'];
  recurring_thursday: Scalars['Boolean']['output'];
  recurring_tuesday: Scalars['Boolean']['output'];
  recurring_wednesday: Scalars['Boolean']['output'];
  /** An array relationship */
  schedule_blackout_dates: Array<Schedule_Blackout_Dates>;
  /** An aggregate relationship */
  schedule_blackout_dates_aggregate: Schedule_Blackout_Dates_Aggregate;
  scheduled_at: Scalars['timestamp']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "nudge_schedules" */
export type Nudge_SchedulesNudge_TakesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


/** columns and relationships of "nudge_schedules" */
export type Nudge_SchedulesNudge_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


/** columns and relationships of "nudge_schedules" */
export type Nudge_SchedulesSchedule_Blackout_DatesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


/** columns and relationships of "nudge_schedules" */
export type Nudge_SchedulesSchedule_Blackout_Dates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};

/** aggregated selection of "nudge_schedules" */
export type Nudge_Schedules_Aggregate = {
  __typename?: 'nudge_schedules_aggregate';
  aggregate?: Maybe<Nudge_Schedules_Aggregate_Fields>;
  nodes: Array<Nudge_Schedules>;
};

export type Nudge_Schedules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp_Count>;
};

export type Nudge_Schedules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Nudge_Schedules_Select_Column_Nudge_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Nudge_Schedules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Nudge_Schedules_Select_Column_Nudge_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Nudge_Schedules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nudge_schedules" */
export type Nudge_Schedules_Aggregate_Fields = {
  __typename?: 'nudge_schedules_aggregate_fields';
  avg?: Maybe<Nudge_Schedules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nudge_Schedules_Max_Fields>;
  min?: Maybe<Nudge_Schedules_Min_Fields>;
  stddev?: Maybe<Nudge_Schedules_Stddev_Fields>;
  stddev_pop?: Maybe<Nudge_Schedules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nudge_Schedules_Stddev_Samp_Fields>;
  sum?: Maybe<Nudge_Schedules_Sum_Fields>;
  var_pop?: Maybe<Nudge_Schedules_Var_Pop_Fields>;
  var_samp?: Maybe<Nudge_Schedules_Var_Samp_Fields>;
  variance?: Maybe<Nudge_Schedules_Variance_Fields>;
};


/** aggregate fields of "nudge_schedules" */
export type Nudge_Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "nudge_schedules" */
export type Nudge_Schedules_Aggregate_Order_By = {
  avg?: InputMaybe<Nudge_Schedules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nudge_Schedules_Max_Order_By>;
  min?: InputMaybe<Nudge_Schedules_Min_Order_By>;
  stddev?: InputMaybe<Nudge_Schedules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nudge_Schedules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nudge_Schedules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nudge_Schedules_Sum_Order_By>;
  var_pop?: InputMaybe<Nudge_Schedules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nudge_Schedules_Var_Samp_Order_By>;
  variance?: InputMaybe<Nudge_Schedules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nudge_schedules" */
export type Nudge_Schedules_Arr_Rel_Insert_Input = {
  data: Array<Nudge_Schedules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nudge_Schedules_On_Conflict>;
};

/** aggregate avg on columns */
export type Nudge_Schedules_Avg_Fields = {
  __typename?: 'nudge_schedules_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nudge_schedules". All fields are combined with a logical 'AND'. */
export type Nudge_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Nudge_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Nudge_Schedules_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  nudge?: InputMaybe<Nudges_Bool_Exp>;
  nudge_id?: InputMaybe<Int_Comparison_Exp>;
  nudge_takes?: InputMaybe<Nudge_Takes_Bool_Exp>;
  nudge_takes_aggregate?: InputMaybe<Nudge_Takes_Aggregate_Bool_Exp>;
  one_time?: InputMaybe<Boolean_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  recurring_friday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_monday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_saturday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  recurring_sunday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_thursday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_tuesday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_wednesday?: InputMaybe<Boolean_Comparison_Exp>;
  schedule_blackout_dates?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  schedule_blackout_dates_aggregate?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Bool_Exp>;
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "nudge_schedules" */
export enum Nudge_Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  NudgeSchedulesPkey = 'nudge_schedules_pkey'
}

/** input type for incrementing numeric columns in table "nudge_schedules" */
export type Nudge_Schedules_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nudge_schedules" */
export type Nudge_Schedules_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nudge?: InputMaybe<Nudges_Obj_Rel_Insert_Input>;
  nudge_id?: InputMaybe<Scalars['Int']['input']>;
  nudge_takes?: InputMaybe<Nudge_Takes_Arr_Rel_Insert_Input>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_blackout_dates?: InputMaybe<Schedule_Blackout_Dates_Arr_Rel_Insert_Input>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Nudge_Schedules_Max_Fields = {
  __typename?: 'nudge_schedules_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nudge_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nudge_Schedules_Min_Fields = {
  __typename?: 'nudge_schedules_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nudge_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nudge_schedules" */
export type Nudge_Schedules_Mutation_Response = {
  __typename?: 'nudge_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nudge_Schedules>;
};

/** input type for inserting object relation for remote table "nudge_schedules" */
export type Nudge_Schedules_Obj_Rel_Insert_Input = {
  data: Nudge_Schedules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nudge_Schedules_On_Conflict>;
};

/** on_conflict condition type for table "nudge_schedules" */
export type Nudge_Schedules_On_Conflict = {
  constraint: Nudge_Schedules_Constraint;
  update_columns?: Array<Nudge_Schedules_Update_Column>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "nudge_schedules". */
export type Nudge_Schedules_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  nudge?: InputMaybe<Nudges_Order_By>;
  nudge_id?: InputMaybe<Order_By>;
  nudge_takes_aggregate?: InputMaybe<Nudge_Takes_Aggregate_Order_By>;
  one_time?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  recurring_friday?: InputMaybe<Order_By>;
  recurring_monday?: InputMaybe<Order_By>;
  recurring_saturday?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  recurring_sunday?: InputMaybe<Order_By>;
  recurring_thursday?: InputMaybe<Order_By>;
  recurring_tuesday?: InputMaybe<Order_By>;
  recurring_wednesday?: InputMaybe<Order_By>;
  schedule_blackout_dates_aggregate?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nudge_schedules */
export type Nudge_Schedules_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nudge_schedules" */
export enum Nudge_Schedules_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NudgeId = 'nudge_id',
  /** column name */
  OneTime = 'one_time',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringStartDate = 'recurring_start_date',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "nudge_schedules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "nudge_schedules" */
export enum Nudge_Schedules_Select_Column_Nudge_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  OneTime = 'one_time',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday'
}

/** select "nudge_schedules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "nudge_schedules" */
export enum Nudge_Schedules_Select_Column_Nudge_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  OneTime = 'one_time',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday'
}

/** input type for updating data in table "nudge_schedules" */
export type Nudge_Schedules_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nudge_id?: InputMaybe<Scalars['Int']['input']>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Nudge_Schedules_Stddev_Fields = {
  __typename?: 'nudge_schedules_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nudge_Schedules_Stddev_Pop_Fields = {
  __typename?: 'nudge_schedules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nudge_Schedules_Stddev_Samp_Fields = {
  __typename?: 'nudge_schedules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nudge_schedules" */
export type Nudge_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nudge_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nudge_Schedules_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  nudge_id?: InputMaybe<Scalars['Int']['input']>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Nudge_Schedules_Sum_Fields = {
  __typename?: 'nudge_schedules_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  nudge_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** update columns of table "nudge_schedules" */
export enum Nudge_Schedules_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NudgeId = 'nudge_id',
  /** column name */
  OneTime = 'one_time',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringStartDate = 'recurring_start_date',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Nudge_Schedules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nudge_Schedules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nudge_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nudge_Schedules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nudge_Schedules_Var_Pop_Fields = {
  __typename?: 'nudge_schedules_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nudge_Schedules_Var_Samp_Fields = {
  __typename?: 'nudge_schedules_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nudge_Schedules_Variance_Fields = {
  __typename?: 'nudge_schedules_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "nudge_schedules" */
export type Nudge_Schedules_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "nudge_takes" */
export type Nudge_Takes = {
  __typename?: 'nudge_takes';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  nudge_schedule: Nudge_Schedules;
  nudge_schedule_id: Scalars['Int']['output'];
  scheduled_at: Scalars['timestamp']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "nudge_takes" */
export type Nudge_Takes_Aggregate = {
  __typename?: 'nudge_takes_aggregate';
  aggregate?: Maybe<Nudge_Takes_Aggregate_Fields>;
  nodes: Array<Nudge_Takes>;
};

export type Nudge_Takes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Nudge_Takes_Aggregate_Bool_Exp_Count>;
};

export type Nudge_Takes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Nudge_Takes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "nudge_takes" */
export type Nudge_Takes_Aggregate_Fields = {
  __typename?: 'nudge_takes_aggregate_fields';
  avg?: Maybe<Nudge_Takes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nudge_Takes_Max_Fields>;
  min?: Maybe<Nudge_Takes_Min_Fields>;
  stddev?: Maybe<Nudge_Takes_Stddev_Fields>;
  stddev_pop?: Maybe<Nudge_Takes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nudge_Takes_Stddev_Samp_Fields>;
  sum?: Maybe<Nudge_Takes_Sum_Fields>;
  var_pop?: Maybe<Nudge_Takes_Var_Pop_Fields>;
  var_samp?: Maybe<Nudge_Takes_Var_Samp_Fields>;
  variance?: Maybe<Nudge_Takes_Variance_Fields>;
};


/** aggregate fields of "nudge_takes" */
export type Nudge_Takes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "nudge_takes" */
export type Nudge_Takes_Aggregate_Order_By = {
  avg?: InputMaybe<Nudge_Takes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nudge_Takes_Max_Order_By>;
  min?: InputMaybe<Nudge_Takes_Min_Order_By>;
  stddev?: InputMaybe<Nudge_Takes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Nudge_Takes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Nudge_Takes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Nudge_Takes_Sum_Order_By>;
  var_pop?: InputMaybe<Nudge_Takes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Nudge_Takes_Var_Samp_Order_By>;
  variance?: InputMaybe<Nudge_Takes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "nudge_takes" */
export type Nudge_Takes_Arr_Rel_Insert_Input = {
  data: Array<Nudge_Takes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Nudge_Takes_On_Conflict>;
};

/** aggregate avg on columns */
export type Nudge_Takes_Avg_Fields = {
  __typename?: 'nudge_takes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "nudge_takes" */
export type Nudge_Takes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "nudge_takes". All fields are combined with a logical 'AND'. */
export type Nudge_Takes_Bool_Exp = {
  _and?: InputMaybe<Array<Nudge_Takes_Bool_Exp>>;
  _not?: InputMaybe<Nudge_Takes_Bool_Exp>;
  _or?: InputMaybe<Array<Nudge_Takes_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  nudge_schedule_id?: InputMaybe<Int_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "nudge_takes" */
export enum Nudge_Takes_Constraint {
  /** unique or primary key constraint on columns "id" */
  NudgeTakesPkey = 'nudge_takes_pkey'
}

/** input type for incrementing numeric columns in table "nudge_takes" */
export type Nudge_Takes_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedule_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nudge_takes" */
export type Nudge_Takes_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Obj_Rel_Insert_Input>;
  nudge_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Nudge_Takes_Max_Fields = {
  __typename?: 'nudge_takes_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Int']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "nudge_takes" */
export type Nudge_Takes_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Nudge_Takes_Min_Fields = {
  __typename?: 'nudge_takes_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Int']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "nudge_takes" */
export type Nudge_Takes_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "nudge_takes" */
export type Nudge_Takes_Mutation_Response = {
  __typename?: 'nudge_takes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nudge_Takes>;
};

/** on_conflict condition type for table "nudge_takes" */
export type Nudge_Takes_On_Conflict = {
  constraint: Nudge_Takes_Constraint;
  update_columns?: Array<Nudge_Takes_Update_Column>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};

/** Ordering options when selecting data from "nudge_takes". */
export type Nudge_Takes_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nudge_takes */
export type Nudge_Takes_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nudge_takes" */
export enum Nudge_Takes_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NudgeScheduleId = 'nudge_schedule_id',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "nudge_takes" */
export type Nudge_Takes_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Nudge_Takes_Stddev_Fields = {
  __typename?: 'nudge_takes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "nudge_takes" */
export type Nudge_Takes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Nudge_Takes_Stddev_Pop_Fields = {
  __typename?: 'nudge_takes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "nudge_takes" */
export type Nudge_Takes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Nudge_Takes_Stddev_Samp_Fields = {
  __typename?: 'nudge_takes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "nudge_takes" */
export type Nudge_Takes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "nudge_takes" */
export type Nudge_Takes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nudge_Takes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nudge_Takes_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Nudge_Takes_Sum_Fields = {
  __typename?: 'nudge_takes_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "nudge_takes" */
export type Nudge_Takes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** update columns of table "nudge_takes" */
export enum Nudge_Takes_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NudgeScheduleId = 'nudge_schedule_id',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UserId = 'user_id'
}

export type Nudge_Takes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nudge_Takes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nudge_Takes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nudge_Takes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nudge_Takes_Var_Pop_Fields = {
  __typename?: 'nudge_takes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "nudge_takes" */
export type Nudge_Takes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Nudge_Takes_Var_Samp_Fields = {
  __typename?: 'nudge_takes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "nudge_takes" */
export type Nudge_Takes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Nudge_Takes_Variance_Fields = {
  __typename?: 'nudge_takes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedule_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "nudge_takes" */
export type Nudge_Takes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedule_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "nudges" */
export type Nudges = {
  __typename?: 'nudges';
  active: Scalars['Boolean']['output'];
  activity_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  default_messaging: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  nudge_schedules: Array<Nudge_Schedules>;
  /** An aggregate relationship */
  nudge_schedules_aggregate: Nudge_Schedules_Aggregate;
  /** An object relationship */
  nudges_organization?: Maybe<Organizations>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  resource?: Maybe<Resources>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  technique: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "nudges" */
export type NudgesNudge_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


/** columns and relationships of "nudges" */
export type NudgesNudge_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};

/** aggregated selection of "nudges" */
export type Nudges_Aggregate = {
  __typename?: 'nudges_aggregate';
  aggregate?: Maybe<Nudges_Aggregate_Fields>;
  nodes: Array<Nudges>;
};

/** aggregate fields of "nudges" */
export type Nudges_Aggregate_Fields = {
  __typename?: 'nudges_aggregate_fields';
  avg?: Maybe<Nudges_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Nudges_Max_Fields>;
  min?: Maybe<Nudges_Min_Fields>;
  stddev?: Maybe<Nudges_Stddev_Fields>;
  stddev_pop?: Maybe<Nudges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Nudges_Stddev_Samp_Fields>;
  sum?: Maybe<Nudges_Sum_Fields>;
  var_pop?: Maybe<Nudges_Var_Pop_Fields>;
  var_samp?: Maybe<Nudges_Var_Samp_Fields>;
  variance?: Maybe<Nudges_Variance_Fields>;
};


/** aggregate fields of "nudges" */
export type Nudges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nudges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Nudges_Avg_Fields = {
  __typename?: 'nudges_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "nudges". All fields are combined with a logical 'AND'. */
export type Nudges_Bool_Exp = {
  _and?: InputMaybe<Array<Nudges_Bool_Exp>>;
  _not?: InputMaybe<Nudges_Bool_Exp>;
  _or?: InputMaybe<Array<Nudges_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  default_messaging?: InputMaybe<String_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nudge_schedules?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  nudge_schedules_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp>;
  nudges_organization?: InputMaybe<Organizations_Bool_Exp>;
  owner_org_id?: InputMaybe<Int_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
  technique?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "nudges" */
export enum Nudges_Constraint {
  /** unique or primary key constraint on columns "id" */
  NudgesPkey = 'nudges_pkey'
}

/** input type for incrementing numeric columns in table "nudges" */
export type Nudges_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "nudges" */
export type Nudges_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_messaging?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedules?: InputMaybe<Nudge_Schedules_Arr_Rel_Insert_Input>;
  nudges_organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Nudges_Max_Fields = {
  __typename?: 'nudges_max_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  default_messaging?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Nudges_Min_Fields = {
  __typename?: 'nudges_min_fields';
  activity_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  default_messaging?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "nudges" */
export type Nudges_Mutation_Response = {
  __typename?: 'nudges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nudges>;
};

/** input type for inserting object relation for remote table "nudges" */
export type Nudges_Obj_Rel_Insert_Input = {
  data: Nudges_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Nudges_On_Conflict>;
};

/** on_conflict condition type for table "nudges" */
export type Nudges_On_Conflict = {
  constraint: Nudges_Constraint;
  update_columns?: Array<Nudges_Update_Column>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};

/** Ordering options when selecting data from "nudges". */
export type Nudges_Order_By = {
  active?: InputMaybe<Order_By>;
  activity_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  default_messaging?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedules_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Order_By>;
  nudges_organization?: InputMaybe<Organizations_Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resource_id?: InputMaybe<Order_By>;
  technique?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nudges */
export type Nudges_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "nudges" */
export enum Nudges_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DefaultMessaging = 'default_messaging',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  Technique = 'technique',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "nudges" */
export type Nudges_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_messaging?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Nudges_Stddev_Fields = {
  __typename?: 'nudges_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Nudges_Stddev_Pop_Fields = {
  __typename?: 'nudges_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Nudges_Stddev_Samp_Fields = {
  __typename?: 'nudges_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "nudges" */
export type Nudges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nudges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nudges_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_messaging?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Nudges_Sum_Fields = {
  __typename?: 'nudges_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "nudges" */
export enum Nudges_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DefaultMessaging = 'default_messaging',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  Technique = 'technique',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Nudges_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nudges_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nudges_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nudges_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nudges_Var_Pop_Fields = {
  __typename?: 'nudges_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Nudges_Var_Samp_Fields = {
  __typename?: 'nudges_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Nudges_Variance_Fields = {
  __typename?: 'nudges_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organization_admins" */
export type Organization_Admins = {
  __typename?: 'organization_admins';
  /** An object relationship */
  admin: Users;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int']['output'];
  practitioner_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_admins" */
export type Organization_Admins_Aggregate = {
  __typename?: 'organization_admins_aggregate';
  aggregate?: Maybe<Organization_Admins_Aggregate_Fields>;
  nodes: Array<Organization_Admins>;
};

export type Organization_Admins_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp_Count>;
};

export type Organization_Admins_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Admins_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_Fields = {
  __typename?: 'organization_admins_aggregate_fields';
  avg?: Maybe<Organization_Admins_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Admins_Max_Fields>;
  min?: Maybe<Organization_Admins_Min_Fields>;
  stddev?: Maybe<Organization_Admins_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Admins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Admins_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Admins_Sum_Fields>;
  var_pop?: Maybe<Organization_Admins_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Admins_Var_Samp_Fields>;
  variance?: Maybe<Organization_Admins_Variance_Fields>;
};


/** aggregate fields of "organization_admins" */
export type Organization_Admins_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_admins" */
export type Organization_Admins_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Admins_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Admins_Max_Order_By>;
  min?: InputMaybe<Organization_Admins_Min_Order_By>;
  stddev?: InputMaybe<Organization_Admins_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Admins_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Admins_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Admins_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Admins_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Admins_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Admins_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_admins" */
export type Organization_Admins_Arr_Rel_Insert_Input = {
  data: Array<Organization_Admins_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Admins_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Admins_Avg_Fields = {
  __typename?: 'organization_admins_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_admins" */
export type Organization_Admins_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_admins". All fields are combined with a logical 'AND'. */
export type Organization_Admins_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  _not?: InputMaybe<Organization_Admins_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Admins_Bool_Exp>>;
  admin?: InputMaybe<Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_admins" */
export enum Organization_Admins_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationAdminsPkey = 'organization_admins_pkey'
}

/** input type for incrementing numeric columns in table "organization_admins" */
export type Organization_Admins_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_admins" */
export type Organization_Admins_Insert_Input = {
  admin?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Admins_Max_Fields = {
  __typename?: 'organization_admins_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_admins" */
export type Organization_Admins_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Admins_Min_Fields = {
  __typename?: 'organization_admins_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_admins" */
export type Organization_Admins_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_admins" */
export type Organization_Admins_Mutation_Response = {
  __typename?: 'organization_admins_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Admins>;
};

/** on_conflict condition type for table "organization_admins" */
export type Organization_Admins_On_Conflict = {
  constraint: Organization_Admins_Constraint;
  update_columns?: Array<Organization_Admins_Update_Column>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_admins". */
export type Organization_Admins_Order_By = {
  admin?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_admins */
export type Organization_Admins_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "organization_admins" */
export enum Organization_Admins_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_admins" */
export type Organization_Admins_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Admins_Stddev_Fields = {
  __typename?: 'organization_admins_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_admins" */
export type Organization_Admins_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Admins_Stddev_Pop_Fields = {
  __typename?: 'organization_admins_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_admins" */
export type Organization_Admins_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Admins_Stddev_Samp_Fields = {
  __typename?: 'organization_admins_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_admins" */
export type Organization_Admins_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_admins" */
export type Organization_Admins_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Admins_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Admins_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Organization_Admins_Sum_Fields = {
  __typename?: 'organization_admins_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization_admins" */
export type Organization_Admins_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** update columns of table "organization_admins" */
export enum Organization_Admins_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Admins_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Admins_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Admins_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Admins_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Admins_Var_Pop_Fields = {
  __typename?: 'organization_admins_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_admins" */
export type Organization_Admins_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Admins_Var_Samp_Fields = {
  __typename?: 'organization_admins_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_admins" */
export type Organization_Admins_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Admins_Variance_Fields = {
  __typename?: 'organization_admins_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_admins" */
export type Organization_Admins_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_features" */
export type Organization_Features = {
  __typename?: 'organization_features';
  ai_services_org_admins?: Maybe<Scalars['_uuid']['output']>;
  ai_services_org_members?: Maybe<Scalars['_uuid']['output']>;
  brite_features?: Maybe<Scalars['Boolean']['output']>;
  dbt_diary?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  mvp2_features?: Maybe<Scalars['Boolean']['output']>;
  org_id: Scalars['Int']['output'];
  /** An object relationship */
  organization: Organizations;
  second_checkin_question: Scalars['Boolean']['output'];
  vira_loop?: Maybe<Scalars['Boolean']['output']>;
  vira_path?: Maybe<Scalars['Boolean']['output']>;
  vira_scribe?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "organization_features" */
export type Organization_Features_Aggregate = {
  __typename?: 'organization_features_aggregate';
  aggregate?: Maybe<Organization_Features_Aggregate_Fields>;
  nodes: Array<Organization_Features>;
};

/** aggregate fields of "organization_features" */
export type Organization_Features_Aggregate_Fields = {
  __typename?: 'organization_features_aggregate_fields';
  avg?: Maybe<Organization_Features_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Features_Max_Fields>;
  min?: Maybe<Organization_Features_Min_Fields>;
  stddev?: Maybe<Organization_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Features_Sum_Fields>;
  var_pop?: Maybe<Organization_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Features_Var_Samp_Fields>;
  variance?: Maybe<Organization_Features_Variance_Fields>;
};


/** aggregate fields of "organization_features" */
export type Organization_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organization_Features_Avg_Fields = {
  __typename?: 'organization_features_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization_features". All fields are combined with a logical 'AND'. */
export type Organization_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Features_Bool_Exp>>;
  _not?: InputMaybe<Organization_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Features_Bool_Exp>>;
  ai_services_org_admins?: InputMaybe<_Uuid_Comparison_Exp>;
  ai_services_org_members?: InputMaybe<_Uuid_Comparison_Exp>;
  brite_features?: InputMaybe<Boolean_Comparison_Exp>;
  dbt_diary?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  mvp2_features?: InputMaybe<Boolean_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  second_checkin_question?: InputMaybe<Boolean_Comparison_Exp>;
  vira_loop?: InputMaybe<Boolean_Comparison_Exp>;
  vira_path?: InputMaybe<Boolean_Comparison_Exp>;
  vira_scribe?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_features" */
export enum Organization_Features_Constraint {
  /** unique or primary key constraint on columns "org_id" */
  OrganizationFeaturesOrgIdKey = 'organization_features_org_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationFeaturesPkey = 'organization_features_pkey'
}

/** input type for incrementing numeric columns in table "organization_features" */
export type Organization_Features_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_features" */
export type Organization_Features_Insert_Input = {
  ai_services_org_admins?: InputMaybe<Scalars['_uuid']['input']>;
  ai_services_org_members?: InputMaybe<Scalars['_uuid']['input']>;
  brite_features?: InputMaybe<Scalars['Boolean']['input']>;
  dbt_diary?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mvp2_features?: InputMaybe<Scalars['Boolean']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  second_checkin_question?: InputMaybe<Scalars['Boolean']['input']>;
  vira_loop?: InputMaybe<Scalars['Boolean']['input']>;
  vira_path?: InputMaybe<Scalars['Boolean']['input']>;
  vira_scribe?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Organization_Features_Max_Fields = {
  __typename?: 'organization_features_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Organization_Features_Min_Fields = {
  __typename?: 'organization_features_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "organization_features" */
export type Organization_Features_Mutation_Response = {
  __typename?: 'organization_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Features>;
};

/** input type for inserting object relation for remote table "organization_features" */
export type Organization_Features_Obj_Rel_Insert_Input = {
  data: Organization_Features_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Features_On_Conflict>;
};

/** on_conflict condition type for table "organization_features" */
export type Organization_Features_On_Conflict = {
  constraint: Organization_Features_Constraint;
  update_columns?: Array<Organization_Features_Update_Column>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_features". */
export type Organization_Features_Order_By = {
  ai_services_org_admins?: InputMaybe<Order_By>;
  ai_services_org_members?: InputMaybe<Order_By>;
  brite_features?: InputMaybe<Order_By>;
  dbt_diary?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mvp2_features?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  second_checkin_question?: InputMaybe<Order_By>;
  vira_loop?: InputMaybe<Order_By>;
  vira_path?: InputMaybe<Order_By>;
  vira_scribe?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_features */
export type Organization_Features_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "organization_features" */
export enum Organization_Features_Select_Column {
  /** column name */
  AiServicesOrgAdmins = 'ai_services_org_admins',
  /** column name */
  AiServicesOrgMembers = 'ai_services_org_members',
  /** column name */
  BriteFeatures = 'brite_features',
  /** column name */
  DbtDiary = 'dbt_diary',
  /** column name */
  Id = 'id',
  /** column name */
  Mvp2Features = 'mvp2_features',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SecondCheckinQuestion = 'second_checkin_question',
  /** column name */
  ViraLoop = 'vira_loop',
  /** column name */
  ViraPath = 'vira_path',
  /** column name */
  ViraScribe = 'vira_scribe'
}

/** input type for updating data in table "organization_features" */
export type Organization_Features_Set_Input = {
  ai_services_org_admins?: InputMaybe<Scalars['_uuid']['input']>;
  ai_services_org_members?: InputMaybe<Scalars['_uuid']['input']>;
  brite_features?: InputMaybe<Scalars['Boolean']['input']>;
  dbt_diary?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mvp2_features?: InputMaybe<Scalars['Boolean']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  second_checkin_question?: InputMaybe<Scalars['Boolean']['input']>;
  vira_loop?: InputMaybe<Scalars['Boolean']['input']>;
  vira_path?: InputMaybe<Scalars['Boolean']['input']>;
  vira_scribe?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Features_Stddev_Fields = {
  __typename?: 'organization_features_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Features_Stddev_Pop_Fields = {
  __typename?: 'organization_features_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Features_Stddev_Samp_Fields = {
  __typename?: 'organization_features_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization_features" */
export type Organization_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Features_Stream_Cursor_Value_Input = {
  ai_services_org_admins?: InputMaybe<Scalars['_uuid']['input']>;
  ai_services_org_members?: InputMaybe<Scalars['_uuid']['input']>;
  brite_features?: InputMaybe<Scalars['Boolean']['input']>;
  dbt_diary?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mvp2_features?: InputMaybe<Scalars['Boolean']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  second_checkin_question?: InputMaybe<Scalars['Boolean']['input']>;
  vira_loop?: InputMaybe<Scalars['Boolean']['input']>;
  vira_path?: InputMaybe<Scalars['Boolean']['input']>;
  vira_scribe?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Organization_Features_Sum_Fields = {
  __typename?: 'organization_features_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "organization_features" */
export enum Organization_Features_Update_Column {
  /** column name */
  AiServicesOrgAdmins = 'ai_services_org_admins',
  /** column name */
  AiServicesOrgMembers = 'ai_services_org_members',
  /** column name */
  BriteFeatures = 'brite_features',
  /** column name */
  DbtDiary = 'dbt_diary',
  /** column name */
  Id = 'id',
  /** column name */
  Mvp2Features = 'mvp2_features',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SecondCheckinQuestion = 'second_checkin_question',
  /** column name */
  ViraLoop = 'vira_loop',
  /** column name */
  ViraPath = 'vira_path',
  /** column name */
  ViraScribe = 'vira_scribe'
}

export type Organization_Features_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Features_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Features_Var_Pop_Fields = {
  __typename?: 'organization_features_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organization_Features_Var_Samp_Fields = {
  __typename?: 'organization_features_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organization_Features_Variance_Fields = {
  __typename?: 'organization_features_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "organization_member_roles" */
export type Organization_Member_Roles = {
  __typename?: 'organization_member_roles';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  org_id: Scalars['Int']['output'];
  /** An object relationship */
  organization_member_roles_role_capability: Role_Capabilities;
  practitioner_id: Scalars['uuid']['output'];
  role_capabilities_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "organization_member_roles" */
export type Organization_Member_Roles_Aggregate = {
  __typename?: 'organization_member_roles_aggregate';
  aggregate?: Maybe<Organization_Member_Roles_Aggregate_Fields>;
  nodes: Array<Organization_Member_Roles>;
};

/** aggregate fields of "organization_member_roles" */
export type Organization_Member_Roles_Aggregate_Fields = {
  __typename?: 'organization_member_roles_aggregate_fields';
  avg?: Maybe<Organization_Member_Roles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Member_Roles_Max_Fields>;
  min?: Maybe<Organization_Member_Roles_Min_Fields>;
  stddev?: Maybe<Organization_Member_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Member_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Member_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Member_Roles_Sum_Fields>;
  var_pop?: Maybe<Organization_Member_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Member_Roles_Var_Samp_Fields>;
  variance?: Maybe<Organization_Member_Roles_Variance_Fields>;
};


/** aggregate fields of "organization_member_roles" */
export type Organization_Member_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Member_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organization_Member_Roles_Avg_Fields = {
  __typename?: 'organization_member_roles_avg_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organization_member_roles". All fields are combined with a logical 'AND'. */
export type Organization_Member_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Member_Roles_Bool_Exp>>;
  _not?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Member_Roles_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  organization_member_roles_role_capability?: InputMaybe<Role_Capabilities_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  role_capabilities_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_member_roles" */
export enum Organization_Member_Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationMemberRolesPkey = 'organization_member_roles_pkey',
  /** unique or primary key constraint on columns "practitioner_id" */
  OrganizationMemberRolesPractitionerIdKey = 'organization_member_roles_practitioner_id_key'
}

/** input type for incrementing numeric columns in table "organization_member_roles" */
export type Organization_Member_Roles_Inc_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_member_roles" */
export type Organization_Member_Roles_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  organization_member_roles_role_capability?: InputMaybe<Role_Capabilities_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  role_capabilities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Organization_Member_Roles_Max_Fields = {
  __typename?: 'organization_member_roles_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  role_capabilities_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Organization_Member_Roles_Min_Fields = {
  __typename?: 'organization_member_roles_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  role_capabilities_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "organization_member_roles" */
export type Organization_Member_Roles_Mutation_Response = {
  __typename?: 'organization_member_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Member_Roles>;
};

/** on_conflict condition type for table "organization_member_roles" */
export type Organization_Member_Roles_On_Conflict = {
  constraint: Organization_Member_Roles_Constraint;
  update_columns?: Array<Organization_Member_Roles_Update_Column>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_member_roles". */
export type Organization_Member_Roles_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization_member_roles_role_capability?: InputMaybe<Role_Capabilities_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  role_capabilities_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_member_roles */
export type Organization_Member_Roles_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_member_roles" */
export enum Organization_Member_Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RoleCapabilitiesId = 'role_capabilities_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_member_roles" */
export type Organization_Member_Roles_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  role_capabilities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Member_Roles_Stddev_Fields = {
  __typename?: 'organization_member_roles_stddev_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Member_Roles_Stddev_Pop_Fields = {
  __typename?: 'organization_member_roles_stddev_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Member_Roles_Stddev_Samp_Fields = {
  __typename?: 'organization_member_roles_stddev_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organization_member_roles" */
export type Organization_Member_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Member_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Member_Roles_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  role_capabilities_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Organization_Member_Roles_Sum_Fields = {
  __typename?: 'organization_member_roles_sum_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "organization_member_roles" */
export enum Organization_Member_Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RoleCapabilitiesId = 'role_capabilities_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Member_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Member_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Member_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Member_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Member_Roles_Var_Pop_Fields = {
  __typename?: 'organization_member_roles_var_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organization_Member_Roles_Var_Samp_Fields = {
  __typename?: 'organization_member_roles_var_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organization_Member_Roles_Variance_Fields = {
  __typename?: 'organization_member_roles_variance_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "organization_members" */
export type Organization_Members = {
  __typename?: 'organization_members';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int']['output'];
  /** An object relationship */
  practitioner: Users;
  practitioner_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_members" */
export type Organization_Members_Aggregate = {
  __typename?: 'organization_members_aggregate';
  aggregate?: Maybe<Organization_Members_Aggregate_Fields>;
  nodes: Array<Organization_Members>;
};

export type Organization_Members_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Members_Aggregate_Bool_Exp_Count>;
};

export type Organization_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_members" */
export type Organization_Members_Aggregate_Fields = {
  __typename?: 'organization_members_aggregate_fields';
  avg?: Maybe<Organization_Members_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Members_Max_Fields>;
  min?: Maybe<Organization_Members_Min_Fields>;
  stddev?: Maybe<Organization_Members_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Members_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Members_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Members_Sum_Fields>;
  var_pop?: Maybe<Organization_Members_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Members_Var_Samp_Fields>;
  variance?: Maybe<Organization_Members_Variance_Fields>;
};


/** aggregate fields of "organization_members" */
export type Organization_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_members" */
export type Organization_Members_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Members_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Members_Max_Order_By>;
  min?: InputMaybe<Organization_Members_Min_Order_By>;
  stddev?: InputMaybe<Organization_Members_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Members_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Members_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Members_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Members_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Members_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Members_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_members" */
export type Organization_Members_Arr_Rel_Insert_Input = {
  data: Array<Organization_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Members_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Members_Avg_Fields = {
  __typename?: 'organization_members_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_members" */
export type Organization_Members_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_members". All fields are combined with a logical 'AND'. */
export type Organization_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Members_Bool_Exp>>;
  _not?: InputMaybe<Organization_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Members_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_members" */
export enum Organization_Members_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationMembersPkey = 'organization_members_pkey'
}

/** input type for incrementing numeric columns in table "organization_members" */
export type Organization_Members_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_members" */
export type Organization_Members_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Organization_Members_Max_Fields = {
  __typename?: 'organization_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organization_members" */
export type Organization_Members_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Members_Min_Fields = {
  __typename?: 'organization_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organization_members" */
export type Organization_Members_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_members" */
export type Organization_Members_Mutation_Response = {
  __typename?: 'organization_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Members>;
};

/** on_conflict condition type for table "organization_members" */
export type Organization_Members_On_Conflict = {
  constraint: Organization_Members_Constraint;
  update_columns?: Array<Organization_Members_Update_Column>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_members". */
export type Organization_Members_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_members */
export type Organization_Members_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "organization_members" */
export enum Organization_Members_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_members" */
export type Organization_Members_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Members_Stddev_Fields = {
  __typename?: 'organization_members_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_members" */
export type Organization_Members_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Members_Stddev_Pop_Fields = {
  __typename?: 'organization_members_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_members" */
export type Organization_Members_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Members_Stddev_Samp_Fields = {
  __typename?: 'organization_members_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_members" */
export type Organization_Members_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_members" */
export type Organization_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Members_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Organization_Members_Sum_Fields = {
  __typename?: 'organization_members_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization_members" */
export type Organization_Members_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** update columns of table "organization_members" */
export enum Organization_Members_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Members_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Members_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Members_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Members_Var_Pop_Fields = {
  __typename?: 'organization_members_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_members" */
export type Organization_Members_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Members_Var_Samp_Fields = {
  __typename?: 'organization_members_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_members" */
export type Organization_Members_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Members_Variance_Fields = {
  __typename?: 'organization_members_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_members" */
export type Organization_Members_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_supervisees" */
export type Organization_Supervisees = {
  __typename?: 'organization_supervisees';
  created_at: Scalars['timestamp']['output'];
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organization_supervisees_organization_supervisor: Organization_Supervisors;
  organization_supervisor_id: Scalars['uuid']['output'];
  practitioner_id: Scalars['uuid']['output'];
  started_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  supervisees: Users;
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "organization_supervisees" */
export type Organization_Supervisees_Aggregate = {
  __typename?: 'organization_supervisees_aggregate';
  aggregate?: Maybe<Organization_Supervisees_Aggregate_Fields>;
  nodes: Array<Organization_Supervisees>;
};

export type Organization_Supervisees_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Supervisees_Aggregate_Bool_Exp_Count>;
};

export type Organization_Supervisees_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Supervisees_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_supervisees" */
export type Organization_Supervisees_Aggregate_Fields = {
  __typename?: 'organization_supervisees_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Supervisees_Max_Fields>;
  min?: Maybe<Organization_Supervisees_Min_Fields>;
};


/** aggregate fields of "organization_supervisees" */
export type Organization_Supervisees_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_supervisees" */
export type Organization_Supervisees_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Supervisees_Max_Order_By>;
  min?: InputMaybe<Organization_Supervisees_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_supervisees" */
export type Organization_Supervisees_Arr_Rel_Insert_Input = {
  data: Array<Organization_Supervisees_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Supervisees_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_supervisees". All fields are combined with a logical 'AND'. */
export type Organization_Supervisees_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Supervisees_Bool_Exp>>;
  _not?: InputMaybe<Organization_Supervisees_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Supervisees_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_supervisees_organization_supervisor?: InputMaybe<Organization_Supervisors_Bool_Exp>;
  organization_supervisor_id?: InputMaybe<Uuid_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  supervisees?: InputMaybe<Users_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_supervisees" */
export enum Organization_Supervisees_Constraint {
  /** unique or primary key constraint on columns "organization_supervisor_id", "practitioner_id" */
  OrganizationSuperviseesOrganizationSupervisorIdPractitione = 'organization_supervisees_organization_supervisor_id_practitione',
  /** unique or primary key constraint on columns "id" */
  OrganizationSuperviseesPkey = 'organization_supervisees_pkey'
}

/** input type for inserting data into table "organization_supervisees" */
export type Organization_Supervisees_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_supervisees_organization_supervisor?: InputMaybe<Organization_Supervisors_Obj_Rel_Insert_Input>;
  organization_supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  supervisees?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Organization_Supervisees_Max_Fields = {
  __typename?: 'organization_supervisees_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_supervisor_id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "organization_supervisees" */
export type Organization_Supervisees_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_supervisor_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Supervisees_Min_Fields = {
  __typename?: 'organization_supervisees_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  organization_supervisor_id?: Maybe<Scalars['uuid']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "organization_supervisees" */
export type Organization_Supervisees_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_supervisor_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_supervisees" */
export type Organization_Supervisees_Mutation_Response = {
  __typename?: 'organization_supervisees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Supervisees>;
};

/** on_conflict condition type for table "organization_supervisees" */
export type Organization_Supervisees_On_Conflict = {
  constraint: Organization_Supervisees_Constraint;
  update_columns?: Array<Organization_Supervisees_Update_Column>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_supervisees". */
export type Organization_Supervisees_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_supervisees_organization_supervisor?: InputMaybe<Organization_Supervisors_Order_By>;
  organization_supervisor_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  supervisees?: InputMaybe<Users_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_supervisees */
export type Organization_Supervisees_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_supervisees" */
export enum Organization_Supervisees_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSupervisorId = 'organization_supervisor_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_supervisees" */
export type Organization_Supervisees_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "organization_supervisees" */
export type Organization_Supervisees_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Supervisees_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Supervisees_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organization_supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "organization_supervisees" */
export enum Organization_Supervisees_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationSupervisorId = 'organization_supervisor_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Supervisees_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Supervisees_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Supervisees_Bool_Exp;
};

/** columns and relationships of "organization_supervisors" */
export type Organization_Supervisors = {
  __typename?: 'organization_supervisors';
  created_at: Scalars['timestamp']['output'];
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  org_id: Scalars['Int']['output'];
  /** An object relationship */
  organization_supervisors_organization: Organizations;
  /** An array relationship */
  organization_supervisors_organization_supervisees: Array<Organization_Supervisees>;
  /** An aggregate relationship */
  organization_supervisors_organization_supervisees_aggregate: Organization_Supervisees_Aggregate;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  supervisor: Users;
  supervisor_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "organization_supervisors" */
export type Organization_SupervisorsOrganization_Supervisors_Organization_SuperviseesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


/** columns and relationships of "organization_supervisors" */
export type Organization_SupervisorsOrganization_Supervisors_Organization_Supervisees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};

/** aggregated selection of "organization_supervisors" */
export type Organization_Supervisors_Aggregate = {
  __typename?: 'organization_supervisors_aggregate';
  aggregate?: Maybe<Organization_Supervisors_Aggregate_Fields>;
  nodes: Array<Organization_Supervisors>;
};

export type Organization_Supervisors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Supervisors_Aggregate_Bool_Exp_Count>;
};

export type Organization_Supervisors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Organization_Supervisors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_supervisors" */
export type Organization_Supervisors_Aggregate_Fields = {
  __typename?: 'organization_supervisors_aggregate_fields';
  avg?: Maybe<Organization_Supervisors_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organization_Supervisors_Max_Fields>;
  min?: Maybe<Organization_Supervisors_Min_Fields>;
  stddev?: Maybe<Organization_Supervisors_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Supervisors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Supervisors_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Supervisors_Sum_Fields>;
  var_pop?: Maybe<Organization_Supervisors_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Supervisors_Var_Samp_Fields>;
  variance?: Maybe<Organization_Supervisors_Variance_Fields>;
};


/** aggregate fields of "organization_supervisors" */
export type Organization_Supervisors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organization_supervisors" */
export type Organization_Supervisors_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Supervisors_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Supervisors_Max_Order_By>;
  min?: InputMaybe<Organization_Supervisors_Min_Order_By>;
  stddev?: InputMaybe<Organization_Supervisors_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Supervisors_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Supervisors_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Supervisors_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Supervisors_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Supervisors_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Supervisors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_supervisors" */
export type Organization_Supervisors_Arr_Rel_Insert_Input = {
  data: Array<Organization_Supervisors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Supervisors_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Supervisors_Avg_Fields = {
  __typename?: 'organization_supervisors_avg_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Avg_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_supervisors". All fields are combined with a logical 'AND'. */
export type Organization_Supervisors_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Supervisors_Bool_Exp>>;
  _not?: InputMaybe<Organization_Supervisors_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Supervisors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  organization_supervisors_organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_supervisors_organization_supervisees?: InputMaybe<Organization_Supervisees_Bool_Exp>;
  organization_supervisors_organization_supervisees_aggregate?: InputMaybe<Organization_Supervisees_Aggregate_Bool_Exp>;
  started_at?: InputMaybe<Timestamp_Comparison_Exp>;
  supervisor?: InputMaybe<Users_Bool_Exp>;
  supervisor_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_supervisors" */
export enum Organization_Supervisors_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationSupervisorsPkey = 'organization_supervisors_pkey',
  /** unique or primary key constraint on columns "org_id", "ended_at", "started_at", "supervisor_id" */
  OrganizationSupervisorsSupervisorIdOrgIdK = 'organization_supervisors_supervisor_id_org_id_k'
}

/** input type for incrementing numeric columns in table "organization_supervisors" */
export type Organization_Supervisors_Inc_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organization_supervisors" */
export type Organization_Supervisors_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  organization_supervisors_organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_supervisors_organization_supervisees?: InputMaybe<Organization_Supervisees_Arr_Rel_Insert_Input>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  supervisor?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Organization_Supervisors_Max_Fields = {
  __typename?: 'organization_supervisors_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  supervisor_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  supervisor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Supervisors_Min_Fields = {
  __typename?: 'organization_supervisors_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  ended_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['timestamp']['output']>;
  supervisor_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  supervisor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_supervisors" */
export type Organization_Supervisors_Mutation_Response = {
  __typename?: 'organization_supervisors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Supervisors>;
};

/** input type for inserting object relation for remote table "organization_supervisors" */
export type Organization_Supervisors_Obj_Rel_Insert_Input = {
  data: Organization_Supervisors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Supervisors_On_Conflict>;
};

/** on_conflict condition type for table "organization_supervisors" */
export type Organization_Supervisors_On_Conflict = {
  constraint: Organization_Supervisors_Constraint;
  update_columns?: Array<Organization_Supervisors_Update_Column>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_supervisors". */
export type Organization_Supervisors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization_supervisors_organization?: InputMaybe<Organizations_Order_By>;
  organization_supervisors_organization_supervisees_aggregate?: InputMaybe<Organization_Supervisees_Aggregate_Order_By>;
  started_at?: InputMaybe<Order_By>;
  supervisor?: InputMaybe<Users_Order_By>;
  supervisor_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_supervisors */
export type Organization_Supervisors_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organization_supervisors" */
export enum Organization_Supervisors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  SupervisorId = 'supervisor_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_supervisors" */
export type Organization_Supervisors_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Organization_Supervisors_Stddev_Fields = {
  __typename?: 'organization_supervisors_stddev_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Stddev_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Supervisors_Stddev_Pop_Fields = {
  __typename?: 'organization_supervisors_stddev_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Stddev_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Supervisors_Stddev_Samp_Fields = {
  __typename?: 'organization_supervisors_stddev_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Stddev_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_supervisors" */
export type Organization_Supervisors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Supervisors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Supervisors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  ended_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  started_at?: InputMaybe<Scalars['timestamp']['input']>;
  supervisor_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Organization_Supervisors_Sum_Fields = {
  __typename?: 'organization_supervisors_sum_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Sum_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** update columns of table "organization_supervisors" */
export enum Organization_Supervisors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  SupervisorId = 'supervisor_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Supervisors_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Supervisors_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Supervisors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Supervisors_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Supervisors_Var_Pop_Fields = {
  __typename?: 'organization_supervisors_var_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Var_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Supervisors_Var_Samp_Fields = {
  __typename?: 'organization_supervisors_var_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Var_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Supervisors_Variance_Fields = {
  __typename?: 'organization_supervisors_variance_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organization_supervisors" */
export type Organization_Supervisors_Variance_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  /** An array relationship */
  clients: Array<Vw_User_Organization>;
  /** An aggregate relationship */
  clients_aggregate: Vw_User_Organization_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organization_admins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** An object relationship */
  organization_feature?: Maybe<Organization_Features>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  /** An array relationship */
  organization_supervisors: Array<Organization_Supervisors>;
  /** An aggregate relationship */
  organization_supervisors_aggregate: Organization_Supervisors_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_invites: Array<User_Invites>;
  /** An aggregate relationship */
  user_invites_aggregate: User_Invites_Aggregate;
};


/** columns and relationships of "organizations" */
export type OrganizationsClientsArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsClients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_SupervisorsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_Supervisors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUser_InvitesArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUser_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  avg?: Maybe<Organizations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
  stddev?: Maybe<Organizations_Stddev_Fields>;
  stddev_pop?: Maybe<Organizations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organizations_Stddev_Samp_Fields>;
  sum?: Maybe<Organizations_Sum_Fields>;
  var_pop?: Maybe<Organizations_Var_Pop_Fields>;
  var_samp?: Maybe<Organizations_Var_Samp_Fields>;
  variance?: Maybe<Organizations_Variance_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organizations_Avg_Fields = {
  __typename?: 'organizations_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  clients?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  clients_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization_admins?: InputMaybe<Organization_Admins_Bool_Exp>;
  organization_admins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp>;
  organization_feature?: InputMaybe<Organization_Features_Bool_Exp>;
  organization_members?: InputMaybe<Organization_Members_Bool_Exp>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Bool_Exp>;
  organization_supervisors?: InputMaybe<Organization_Supervisors_Bool_Exp>;
  organization_supervisors_aggregate?: InputMaybe<Organization_Supervisors_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_invites?: InputMaybe<User_Invites_Bool_Exp>;
  user_invites_aggregate?: InputMaybe<User_Invites_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey'
}

/** input type for incrementing numeric columns in table "organizations" */
export type Organizations_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  clients?: InputMaybe<Vw_User_Organization_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_admins?: InputMaybe<Organization_Admins_Arr_Rel_Insert_Input>;
  organization_feature?: InputMaybe<Organization_Features_Obj_Rel_Insert_Input>;
  organization_members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
  organization_supervisors?: InputMaybe<Organization_Supervisors_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_invites?: InputMaybe<User_Invites_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** on_conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  clients_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_admins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Order_By>;
  organization_feature?: InputMaybe<Organization_Features_Order_By>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
  organization_supervisors_aggregate?: InputMaybe<Organization_Supervisors_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_invites_aggregate?: InputMaybe<User_Invites_Aggregate_Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Organizations_Stddev_Fields = {
  __typename?: 'organizations_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organizations_Stddev_Pop_Fields = {
  __typename?: 'organizations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organizations_Stddev_Samp_Fields = {
  __typename?: 'organizations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organizations" */
export type Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Organizations_Sum_Fields = {
  __typename?: 'organizations_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organizations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organizations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organizations_Var_Pop_Fields = {
  __typename?: 'organizations_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organizations_Var_Samp_Fields = {
  __typename?: 'organizations_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organizations_Variance_Fields = {
  __typename?: 'organizations_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** An array relationship */
  activity_rating: Array<Activity_Rating>;
  /** An aggregate relationship */
  activity_rating_aggregate: Activity_Rating_Aggregate;
  /** fetch data from the table: "activity_rating" using primary key columns */
  activity_rating_by_pk?: Maybe<Activity_Rating>;
  /** fetch data from the table: "activity_resource" */
  activity_resource: Array<Activity_Resource>;
  /** fetch aggregated fields from the table: "activity_resource" */
  activity_resource_aggregate: Activity_Resource_Aggregate;
  /** fetch data from the table: "activity_resource" using primary key columns */
  activity_resource_by_pk?: Maybe<Activity_Resource>;
  /** fetch data from the table: "activity_resource_category" */
  activity_resource_category: Array<Activity_Resource_Category>;
  /** fetch aggregated fields from the table: "activity_resource_category" */
  activity_resource_category_aggregate: Activity_Resource_Category_Aggregate;
  /** fetch data from the table: "activity_resource_category" using primary key columns */
  activity_resource_category_by_pk?: Maybe<Activity_Resource_Category>;
  /** fetch data from the table: "activity_sub_category" */
  activity_sub_category: Array<Activity_Sub_Category>;
  /** fetch aggregated fields from the table: "activity_sub_category" */
  activity_sub_category_aggregate: Activity_Sub_Category_Aggregate;
  /** fetch data from the table: "activity_sub_category" using primary key columns */
  activity_sub_category_by_pk?: Maybe<Activity_Sub_Category>;
  /** fetch data from the table: "activity_suggested_activities" */
  activity_suggested_activities: Array<Activity_Suggested_Activities>;
  /** fetch aggregated fields from the table: "activity_suggested_activities" */
  activity_suggested_activities_aggregate: Activity_Suggested_Activities_Aggregate;
  /** fetch data from the table: "activity_suggested_activities" using primary key columns */
  activity_suggested_activities_by_pk?: Maybe<Activity_Suggested_Activities>;
  /** fetch data from the table: "assessment_answers" */
  assessment_answers: Array<Assessment_Answers>;
  /** fetch aggregated fields from the table: "assessment_answers" */
  assessment_answers_aggregate: Assessment_Answers_Aggregate;
  /** fetch data from the table: "assessment_answers" using primary key columns */
  assessment_answers_by_pk?: Maybe<Assessment_Answers>;
  /** fetch data from the table: "assessment_branching_rules" */
  assessment_branching_rules: Array<Assessment_Branching_Rules>;
  /** fetch aggregated fields from the table: "assessment_branching_rules" */
  assessment_branching_rules_aggregate: Assessment_Branching_Rules_Aggregate;
  /** fetch data from the table: "assessment_branching_rules" using primary key columns */
  assessment_branching_rules_by_pk?: Maybe<Assessment_Branching_Rules>;
  /** fetch data from the table: "assessment_pages" */
  assessment_pages: Array<Assessment_Pages>;
  /** fetch aggregated fields from the table: "assessment_pages" */
  assessment_pages_aggregate: Assessment_Pages_Aggregate;
  /** fetch data from the table: "assessment_pages" using primary key columns */
  assessment_pages_by_pk?: Maybe<Assessment_Pages>;
  /** fetch data from the table: "assessment_question_custom_prompt" */
  assessment_question_custom_prompt: Array<Assessment_Question_Custom_Prompt>;
  /** fetch aggregated fields from the table: "assessment_question_custom_prompt" */
  assessment_question_custom_prompt_aggregate: Assessment_Question_Custom_Prompt_Aggregate;
  /** fetch data from the table: "assessment_question_custom_prompt" using primary key columns */
  assessment_question_custom_prompt_by_pk?: Maybe<Assessment_Question_Custom_Prompt>;
  /** fetch data from the table: "assessment_questions" */
  assessment_questions: Array<Assessment_Questions>;
  /** fetch aggregated fields from the table: "assessment_questions" */
  assessment_questions_aggregate: Assessment_Questions_Aggregate;
  /** fetch data from the table: "assessment_questions" using primary key columns */
  assessment_questions_by_pk?: Maybe<Assessment_Questions>;
  /** fetch data from the table: "assessment_takes" */
  assessment_takes: Array<Assessment_Takes>;
  /** fetch aggregated fields from the table: "assessment_takes" */
  assessment_takes_aggregate: Assessment_Takes_Aggregate;
  /** fetch data from the table: "assessment_takes" using primary key columns */
  assessment_takes_by_pk?: Maybe<Assessment_Takes>;
  /** fetch data from the table: "assessments" */
  assessments: Array<Assessments>;
  /** fetch aggregated fields from the table: "assessments" */
  assessments_aggregate: Assessments_Aggregate;
  /** fetch data from the table: "assessments" using primary key columns */
  assessments_by_pk?: Maybe<Assessments>;
  /** fetch data from the table: "auth.account_migration_log" */
  auth_account_migration_log: Array<Auth_Account_Migration_Log>;
  /** fetch aggregated fields from the table: "auth.account_migration_log" */
  auth_account_migration_log_aggregate: Auth_Account_Migration_Log_Aggregate;
  /** fetch data from the table: "auth.account_migration_log" using primary key columns */
  auth_account_migration_log_by_pk?: Maybe<Auth_Account_Migration_Log>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: Array<Auth_Account_Providers>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: Auth_Account_Providers_Aggregate;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: Maybe<Auth_Account_Providers>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: Array<Auth_Account_Roles>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: Auth_Account_Roles_Aggregate;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: Maybe<Auth_Account_Roles>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: Array<Auth_Accounts>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: Auth_Accounts_Aggregate;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: Maybe<Auth_Accounts>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: Array<Auth_Providers>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: Auth_Providers_Aggregate;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: Maybe<Auth_Providers>;
  /** fetch data from the table: "auth.refresh_token_usage_log" */
  auth_refresh_token_usage_log: Array<Auth_Refresh_Token_Usage_Log>;
  /** fetch aggregated fields from the table: "auth.refresh_token_usage_log" */
  auth_refresh_token_usage_log_aggregate: Auth_Refresh_Token_Usage_Log_Aggregate;
  /** fetch data from the table: "auth.refresh_token_usage_log" using primary key columns */
  auth_refresh_token_usage_log_by_pk?: Maybe<Auth_Refresh_Token_Usage_Log>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: Array<Auth_Refresh_Tokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: Auth_Refresh_Tokens_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: Maybe<Auth_Refresh_Tokens>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: Array<Auth_Roles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: Auth_Roles_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: Maybe<Auth_Roles>;
  /** fetch data from the table: "casemix_category" */
  casemix_category: Array<Casemix_Category>;
  /** fetch aggregated fields from the table: "casemix_category" */
  casemix_category_aggregate: Casemix_Category_Aggregate;
  /** fetch data from the table: "casemix_category" using primary key columns */
  casemix_category_by_pk?: Maybe<Casemix_Category>;
  /** An array relationship */
  client_demographics: Array<Client_Demographics>;
  /** An aggregate relationship */
  client_demographics_aggregate: Client_Demographics_Aggregate;
  /** fetch data from the table: "client_demographics" using primary key columns */
  client_demographics_by_pk?: Maybe<Client_Demographics>;
  /** An array relationship */
  daily_features: Array<Daily_Features>;
  /** An aggregate relationship */
  daily_features_aggregate: Daily_Features_Aggregate;
  /** fetch data from the table: "daily_features" using primary key columns */
  daily_features_by_pk?: Maybe<Daily_Features>;
  /** fetch data from the table: "ehr.client_invite_codes" */
  ehr_client_invite_codes: Array<Ehr_Client_Invite_Codes>;
  /** fetch aggregated fields from the table: "ehr.client_invite_codes" */
  ehr_client_invite_codes_aggregate: Ehr_Client_Invite_Codes_Aggregate;
  /** fetch data from the table: "ehr.client_invite_codes" using primary key columns */
  ehr_client_invite_codes_by_pk?: Maybe<Ehr_Client_Invite_Codes>;
  /** fetch data from the table: "ehr.ehr_practitioner_map" */
  ehr_ehr_practitioner_map: Array<Ehr_Ehr_Practitioner_Map>;
  /** fetch aggregated fields from the table: "ehr.ehr_practitioner_map" */
  ehr_ehr_practitioner_map_aggregate: Ehr_Ehr_Practitioner_Map_Aggregate;
  /** fetch data from the table: "ehr.ehr_practitioner_map" using primary key columns */
  ehr_ehr_practitioner_map_by_pk?: Maybe<Ehr_Ehr_Practitioner_Map>;
  /** fetch data from the table: "ehr.xealth_event_notification" */
  ehr_xealth_event_notification: Array<Ehr_Xealth_Event_Notification>;
  /** fetch aggregated fields from the table: "ehr.xealth_event_notification" */
  ehr_xealth_event_notification_aggregate: Ehr_Xealth_Event_Notification_Aggregate;
  /** fetch data from the table: "ehr.xealth_event_notification" using primary key columns */
  ehr_xealth_event_notification_by_pk?: Maybe<Ehr_Xealth_Event_Notification>;
  /** fetch data from the table: "ehr.xealth_preorder_form" */
  ehr_xealth_preorder_form: Array<Ehr_Xealth_Preorder_Form>;
  /** fetch aggregated fields from the table: "ehr.xealth_preorder_form" */
  ehr_xealth_preorder_form_aggregate: Ehr_Xealth_Preorder_Form_Aggregate;
  /** fetch data from the table: "ehr.xealth_preorder_form" using primary key columns */
  ehr_xealth_preorder_form_by_pk?: Maybe<Ehr_Xealth_Preorder_Form>;
  /** fetch data from the table: "ehr.xealth_preorder_invite_map" */
  ehr_xealth_preorder_invite_map: Array<Ehr_Xealth_Preorder_Invite_Map>;
  /** fetch aggregated fields from the table: "ehr.xealth_preorder_invite_map" */
  ehr_xealth_preorder_invite_map_aggregate: Ehr_Xealth_Preorder_Invite_Map_Aggregate;
  /** fetch data from the table: "ehr.xealth_preorder_invite_map" using primary key columns */
  ehr_xealth_preorder_invite_map_by_pk?: Maybe<Ehr_Xealth_Preorder_Invite_Map>;
  /** fetch data from the table: "enum_activity_category" */
  enum_activity_category: Array<Enum_Activity_Category>;
  /** fetch aggregated fields from the table: "enum_activity_category" */
  enum_activity_category_aggregate: Enum_Activity_Category_Aggregate;
  /** fetch data from the table: "enum_activity_category" using primary key columns */
  enum_activity_category_by_pk?: Maybe<Enum_Activity_Category>;
  /** fetch data from the table: "enum_activity_resource_type" */
  enum_activity_resource_type: Array<Enum_Activity_Resource_Type>;
  /** fetch aggregated fields from the table: "enum_activity_resource_type" */
  enum_activity_resource_type_aggregate: Enum_Activity_Resource_Type_Aggregate;
  /** fetch data from the table: "enum_activity_resource_type" using primary key columns */
  enum_activity_resource_type_by_pk?: Maybe<Enum_Activity_Resource_Type>;
  /** fetch data from the table: "enum_completion_status" */
  enum_completion_status: Array<Enum_Completion_Status>;
  /** fetch aggregated fields from the table: "enum_completion_status" */
  enum_completion_status_aggregate: Enum_Completion_Status_Aggregate;
  /** fetch data from the table: "enum_completion_status" using primary key columns */
  enum_completion_status_by_pk?: Maybe<Enum_Completion_Status>;
  /** fetch data from the table: "enum_feature_direction" */
  enum_feature_direction: Array<Enum_Feature_Direction>;
  /** fetch aggregated fields from the table: "enum_feature_direction" */
  enum_feature_direction_aggregate: Enum_Feature_Direction_Aggregate;
  /** fetch data from the table: "enum_feature_direction" using primary key columns */
  enum_feature_direction_by_pk?: Maybe<Enum_Feature_Direction>;
  /** fetch data from the table: "enum_feature_type" */
  enum_feature_type: Array<Enum_Feature_Type>;
  /** fetch aggregated fields from the table: "enum_feature_type" */
  enum_feature_type_aggregate: Enum_Feature_Type_Aggregate;
  /** fetch data from the table: "enum_feature_type" using primary key columns */
  enum_feature_type_by_pk?: Maybe<Enum_Feature_Type>;
  /** fetch data from the table: "enum_gender" */
  enum_gender: Array<Enum_Gender>;
  /** fetch aggregated fields from the table: "enum_gender" */
  enum_gender_aggregate: Enum_Gender_Aggregate;
  /** fetch data from the table: "enum_gender" using primary key columns */
  enum_gender_by_pk?: Maybe<Enum_Gender>;
  /** fetch data from the table: "enum_insight_content_type" */
  enum_insight_content_type: Array<Enum_Insight_Content_Type>;
  /** fetch aggregated fields from the table: "enum_insight_content_type" */
  enum_insight_content_type_aggregate: Enum_Insight_Content_Type_Aggregate;
  /** fetch data from the table: "enum_insight_content_type" using primary key columns */
  enum_insight_content_type_by_pk?: Maybe<Enum_Insight_Content_Type>;
  /** fetch data from the table: "enum_mobile_permission_status" */
  enum_mobile_permission_status: Array<Enum_Mobile_Permission_Status>;
  /** fetch aggregated fields from the table: "enum_mobile_permission_status" */
  enum_mobile_permission_status_aggregate: Enum_Mobile_Permission_Status_Aggregate;
  /** fetch data from the table: "enum_mobile_permission_status" using primary key columns */
  enum_mobile_permission_status_by_pk?: Maybe<Enum_Mobile_Permission_Status>;
  /** fetch data from the table: "enum_mobile_permission_type" */
  enum_mobile_permission_type: Array<Enum_Mobile_Permission_Type>;
  /** fetch aggregated fields from the table: "enum_mobile_permission_type" */
  enum_mobile_permission_type_aggregate: Enum_Mobile_Permission_Type_Aggregate;
  /** fetch data from the table: "enum_mobile_permission_type" using primary key columns */
  enum_mobile_permission_type_by_pk?: Maybe<Enum_Mobile_Permission_Type>;
  /** fetch data from the table: "enum_outcome" */
  enum_outcome: Array<Enum_Outcome>;
  /** fetch aggregated fields from the table: "enum_outcome" */
  enum_outcome_aggregate: Enum_Outcome_Aggregate;
  /** fetch data from the table: "enum_outcome" using primary key columns */
  enum_outcome_by_pk?: Maybe<Enum_Outcome>;
  /** fetch data from the table: "enum_question_type" */
  enum_question_type: Array<Enum_Question_Type>;
  /** fetch aggregated fields from the table: "enum_question_type" */
  enum_question_type_aggregate: Enum_Question_Type_Aggregate;
  /** fetch data from the table: "enum_question_type" using primary key columns */
  enum_question_type_by_pk?: Maybe<Enum_Question_Type>;
  /** fetch data from the table: "enum_racial_ethnic" */
  enum_racial_ethnic: Array<Enum_Racial_Ethnic>;
  /** fetch aggregated fields from the table: "enum_racial_ethnic" */
  enum_racial_ethnic_aggregate: Enum_Racial_Ethnic_Aggregate;
  /** fetch data from the table: "enum_racial_ethnic" using primary key columns */
  enum_racial_ethnic_by_pk?: Maybe<Enum_Racial_Ethnic>;
  /** fetch data from the table: "enum_resource_type" */
  enum_resource_type: Array<Enum_Resource_Type>;
  /** fetch aggregated fields from the table: "enum_resource_type" */
  enum_resource_type_aggregate: Enum_Resource_Type_Aggregate;
  /** fetch data from the table: "enum_resource_type" using primary key columns */
  enum_resource_type_by_pk?: Maybe<Enum_Resource_Type>;
  /** fetch data from the table: "enum_safety_plan_section_category_type" */
  enum_safety_plan_section_category_type: Array<Enum_Safety_Plan_Section_Category_Type>;
  /** fetch aggregated fields from the table: "enum_safety_plan_section_category_type" */
  enum_safety_plan_section_category_type_aggregate: Enum_Safety_Plan_Section_Category_Type_Aggregate;
  /** fetch data from the table: "enum_safety_plan_section_category_type" using primary key columns */
  enum_safety_plan_section_category_type_by_pk?: Maybe<Enum_Safety_Plan_Section_Category_Type>;
  /** fetch data from the table: "enum_safety_plan_section_icons" */
  enum_safety_plan_section_icons: Array<Enum_Safety_Plan_Section_Icons>;
  /** fetch aggregated fields from the table: "enum_safety_plan_section_icons" */
  enum_safety_plan_section_icons_aggregate: Enum_Safety_Plan_Section_Icons_Aggregate;
  /** fetch data from the table: "enum_safety_plan_section_icons" using primary key columns */
  enum_safety_plan_section_icons_by_pk?: Maybe<Enum_Safety_Plan_Section_Icons>;
  /** fetch data from the table: "enum_safety_plan_status" */
  enum_safety_plan_status: Array<Enum_Safety_Plan_Status>;
  /** fetch aggregated fields from the table: "enum_safety_plan_status" */
  enum_safety_plan_status_aggregate: Enum_Safety_Plan_Status_Aggregate;
  /** fetch data from the table: "enum_safety_plan_status" using primary key columns */
  enum_safety_plan_status_by_pk?: Maybe<Enum_Safety_Plan_Status>;
  /** fetch data from the table: "enum_safety_plan_type" */
  enum_safety_plan_type: Array<Enum_Safety_Plan_Type>;
  /** fetch aggregated fields from the table: "enum_safety_plan_type" */
  enum_safety_plan_type_aggregate: Enum_Safety_Plan_Type_Aggregate;
  /** fetch data from the table: "enum_safety_plan_type" using primary key columns */
  enum_safety_plan_type_by_pk?: Maybe<Enum_Safety_Plan_Type>;
  /** fetch data from the table: "enum_trend_direction" */
  enum_trend_direction: Array<Enum_Trend_Direction>;
  /** fetch aggregated fields from the table: "enum_trend_direction" */
  enum_trend_direction_aggregate: Enum_Trend_Direction_Aggregate;
  /** fetch data from the table: "enum_trend_direction" using primary key columns */
  enum_trend_direction_by_pk?: Maybe<Enum_Trend_Direction>;
  /** fetch data from the table: "feature_report_feature_coefficients" */
  feature_report_feature_coefficients: Array<Feature_Report_Feature_Coefficients>;
  /** fetch aggregated fields from the table: "feature_report_feature_coefficients" */
  feature_report_feature_coefficients_aggregate: Feature_Report_Feature_Coefficients_Aggregate;
  /** fetch data from the table: "feature_report_feature_coefficients" using primary key columns */
  feature_report_feature_coefficients_by_pk?: Maybe<Feature_Report_Feature_Coefficients>;
  /** An array relationship */
  feature_report_features: Array<Feature_Report_Features>;
  /** An aggregate relationship */
  feature_report_features_aggregate: Feature_Report_Features_Aggregate;
  /** fetch data from the table: "feature_report_features" using primary key columns */
  feature_report_features_by_pk?: Maybe<Feature_Report_Features>;
  /** An array relationship */
  feature_reports: Array<Feature_Reports>;
  /** An aggregate relationship */
  feature_reports_aggregate: Feature_Reports_Aggregate;
  /** fetch data from the table: "feature_reports" using primary key columns */
  feature_reports_by_pk?: Maybe<Feature_Reports>;
  /** fetch data from the table: "group_code" */
  group_code: Array<Group_Code>;
  /** fetch aggregated fields from the table: "group_code" */
  group_code_aggregate: Group_Code_Aggregate;
  /** fetch data from the table: "group_code" using primary key columns */
  group_code_by_pk?: Maybe<Group_Code>;
  /** An array relationship */
  insight_articles: Array<Insight_Articles>;
  /** An aggregate relationship */
  insight_articles_aggregate: Insight_Articles_Aggregate;
  /** fetch data from the table: "insight_articles" using primary key columns */
  insight_articles_by_pk?: Maybe<Insight_Articles>;
  /** fetch data from the table: "insight_combos" */
  insight_combos: Array<Insight_Combos>;
  /** fetch aggregated fields from the table: "insight_combos" */
  insight_combos_aggregate: Insight_Combos_Aggregate;
  /** fetch data from the table: "insight_combos" using primary key columns */
  insight_combos_by_pk?: Maybe<Insight_Combos>;
  /** An array relationship */
  insight_hows: Array<Insight_Hows>;
  /** An aggregate relationship */
  insight_hows_aggregate: Insight_Hows_Aggregate;
  /** fetch data from the table: "insight_hows" using primary key columns */
  insight_hows_by_pk?: Maybe<Insight_Hows>;
  /** fetch data from the table: "insight_plan_article" */
  insight_plan_article: Array<Insight_Plan_Article>;
  /** fetch aggregated fields from the table: "insight_plan_article" */
  insight_plan_article_aggregate: Insight_Plan_Article_Aggregate;
  /** fetch data from the table: "insight_plan_article" using primary key columns */
  insight_plan_article_by_pk?: Maybe<Insight_Plan_Article>;
  /** fetch data from the table: "insight_plan_text" */
  insight_plan_text: Array<Insight_Plan_Text>;
  /** fetch aggregated fields from the table: "insight_plan_text" */
  insight_plan_text_aggregate: Insight_Plan_Text_Aggregate;
  /** fetch data from the table: "insight_plan_text" using primary key columns */
  insight_plan_text_by_pk?: Maybe<Insight_Plan_Text>;
  /** An array relationship */
  insight_plans: Array<Insight_Plans>;
  /** An aggregate relationship */
  insight_plans_aggregate: Insight_Plans_Aggregate;
  /** fetch data from the table: "insight_plans" using primary key columns */
  insight_plans_by_pk?: Maybe<Insight_Plans>;
  /** An array relationship */
  insight_questions: Array<Insight_Questions>;
  /** An aggregate relationship */
  insight_questions_aggregate: Insight_Questions_Aggregate;
  /** fetch data from the table: "insight_questions" using primary key columns */
  insight_questions_by_pk?: Maybe<Insight_Questions>;
  /** An array relationship */
  insight_recipes: Array<Insight_Recipes>;
  /** An aggregate relationship */
  insight_recipes_aggregate: Insight_Recipes_Aggregate;
  /** fetch data from the table: "insight_recipes" using primary key columns */
  insight_recipes_by_pk?: Maybe<Insight_Recipes>;
  /** fetch data from the table: "insight_reflect" */
  insight_reflect: Array<Insight_Reflect>;
  /** fetch aggregated fields from the table: "insight_reflect" */
  insight_reflect_aggregate: Insight_Reflect_Aggregate;
  /** fetch data from the table: "insight_reflect" using primary key columns */
  insight_reflect_by_pk?: Maybe<Insight_Reflect>;
  /** fetch data from the table: "insight_reflect_text" */
  insight_reflect_text: Array<Insight_Reflect_Text>;
  /** fetch aggregated fields from the table: "insight_reflect_text" */
  insight_reflect_text_aggregate: Insight_Reflect_Text_Aggregate;
  /** fetch data from the table: "insight_reflect_text" using primary key columns */
  insight_reflect_text_by_pk?: Maybe<Insight_Reflect_Text>;
  /** An array relationship */
  insight_resources: Array<Insight_Resources>;
  /** An aggregate relationship */
  insight_resources_aggregate: Insight_Resources_Aggregate;
  /** fetch data from the table: "insight_resources" using primary key columns */
  insight_resources_by_pk?: Maybe<Insight_Resources>;
  /** fetch data from the table: "insight_texts" */
  insight_texts: Array<Insight_Texts>;
  /** fetch aggregated fields from the table: "insight_texts" */
  insight_texts_aggregate: Insight_Texts_Aggregate;
  /** fetch data from the table: "insight_texts" using primary key columns */
  insight_texts_by_pk?: Maybe<Insight_Texts>;
  /** fetch data from the table: "insight_tips" */
  insight_tips: Array<Insight_Tips>;
  /** fetch aggregated fields from the table: "insight_tips" */
  insight_tips_aggregate: Insight_Tips_Aggregate;
  /** fetch data from the table: "insight_tips" using primary key columns */
  insight_tips_by_pk?: Maybe<Insight_Tips>;
  /** An array relationship */
  insight_whys: Array<Insight_Whys>;
  /** An aggregate relationship */
  insight_whys_aggregate: Insight_Whys_Aggregate;
  /** fetch data from the table: "insight_whys" using primary key columns */
  insight_whys_by_pk?: Maybe<Insight_Whys>;
  /** fetch data from the table: "invite_codes" */
  invite_codes: Array<Invite_Codes>;
  /** fetch aggregated fields from the table: "invite_codes" */
  invite_codes_aggregate: Invite_Codes_Aggregate;
  /** fetch data from the table: "invite_codes" using primary key columns */
  invite_codes_by_pk?: Maybe<Invite_Codes>;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** An array relationship */
  mobile_device_data: Array<Mobile_Device_Data>;
  /** An aggregate relationship */
  mobile_device_data_aggregate: Mobile_Device_Data_Aggregate;
  /** fetch data from the table: "mobile_device_data" using primary key columns */
  mobile_device_data_by_pk?: Maybe<Mobile_Device_Data>;
  /** fetch data from the table: "mobile_permissions" */
  mobile_permissions: Array<Mobile_Permissions>;
  /** fetch aggregated fields from the table: "mobile_permissions" */
  mobile_permissions_aggregate: Mobile_Permissions_Aggregate;
  /** fetch data from the table: "mobile_permissions" using primary key columns */
  mobile_permissions_by_pk?: Maybe<Mobile_Permissions>;
  /** fetch data from the table: "mobile_upload_log" */
  mobile_upload_log: Array<Mobile_Upload_Log>;
  /** fetch aggregated fields from the table: "mobile_upload_log" */
  mobile_upload_log_aggregate: Mobile_Upload_Log_Aggregate;
  /** fetch data from the table: "mobile_upload_log" using primary key columns */
  mobile_upload_log_by_pk?: Maybe<Mobile_Upload_Log>;
  /** An array relationship */
  mood_measurements: Array<Mood_Measurements>;
  /** An aggregate relationship */
  mood_measurements_aggregate: Mood_Measurements_Aggregate;
  /** fetch data from the table: "mood_measurements" using primary key columns */
  mood_measurements_by_pk?: Maybe<Mood_Measurements>;
  /** An array relationship */
  nudge_schedules: Array<Nudge_Schedules>;
  /** An aggregate relationship */
  nudge_schedules_aggregate: Nudge_Schedules_Aggregate;
  /** fetch data from the table: "nudge_schedules" using primary key columns */
  nudge_schedules_by_pk?: Maybe<Nudge_Schedules>;
  /** An array relationship */
  nudge_takes: Array<Nudge_Takes>;
  /** An aggregate relationship */
  nudge_takes_aggregate: Nudge_Takes_Aggregate;
  /** fetch data from the table: "nudge_takes" using primary key columns */
  nudge_takes_by_pk?: Maybe<Nudge_Takes>;
  /** fetch data from the table: "nudges" */
  nudges: Array<Nudges>;
  /** fetch aggregated fields from the table: "nudges" */
  nudges_aggregate: Nudges_Aggregate;
  /** fetch data from the table: "nudges" using primary key columns */
  nudges_by_pk?: Maybe<Nudges>;
  /** An array relationship */
  organization_admins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admins_by_pk?: Maybe<Organization_Admins>;
  /** fetch data from the table: "organization_features" */
  organization_features: Array<Organization_Features>;
  /** fetch aggregated fields from the table: "organization_features" */
  organization_features_aggregate: Organization_Features_Aggregate;
  /** fetch data from the table: "organization_features" using primary key columns */
  organization_features_by_pk?: Maybe<Organization_Features>;
  /** fetch data from the table: "organization_member_roles" */
  organization_member_roles: Array<Organization_Member_Roles>;
  /** fetch aggregated fields from the table: "organization_member_roles" */
  organization_member_roles_aggregate: Organization_Member_Roles_Aggregate;
  /** fetch data from the table: "organization_member_roles" using primary key columns */
  organization_member_roles_by_pk?: Maybe<Organization_Member_Roles>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  /** fetch data from the table: "organization_members" using primary key columns */
  organization_members_by_pk?: Maybe<Organization_Members>;
  /** fetch data from the table: "organization_supervisees" */
  organization_supervisees: Array<Organization_Supervisees>;
  /** fetch aggregated fields from the table: "organization_supervisees" */
  organization_supervisees_aggregate: Organization_Supervisees_Aggregate;
  /** fetch data from the table: "organization_supervisees" using primary key columns */
  organization_supervisees_by_pk?: Maybe<Organization_Supervisees>;
  /** An array relationship */
  organization_supervisors: Array<Organization_Supervisors>;
  /** An aggregate relationship */
  organization_supervisors_aggregate: Organization_Supervisors_Aggregate;
  /** fetch data from the table: "organization_supervisors" using primary key columns */
  organization_supervisors_by_pk?: Maybe<Organization_Supervisors>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** An array relationship */
  questionnaire_items: Array<Questionnaire_Items>;
  /** An aggregate relationship */
  questionnaire_items_aggregate: Questionnaire_Items_Aggregate;
  /** fetch data from the table: "questionnaire_items" using primary key columns */
  questionnaire_items_by_pk?: Maybe<Questionnaire_Items>;
  /** fetch data from the table: "questionnaire_response_options" */
  questionnaire_response_options: Array<Questionnaire_Response_Options>;
  /** fetch aggregated fields from the table: "questionnaire_response_options" */
  questionnaire_response_options_aggregate: Questionnaire_Response_Options_Aggregate;
  /** fetch data from the table: "questionnaire_response_options" using primary key columns */
  questionnaire_response_options_by_pk?: Maybe<Questionnaire_Response_Options>;
  /** An array relationship */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** An aggregate relationship */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  /** fetch data from the table: "questionnaire_responses" using primary key columns */
  questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** fetch data from the table: "questionnaire_risk_alert_contacts" */
  questionnaire_risk_alert_contacts: Array<Questionnaire_Risk_Alert_Contacts>;
  /** fetch aggregated fields from the table: "questionnaire_risk_alert_contacts" */
  questionnaire_risk_alert_contacts_aggregate: Questionnaire_Risk_Alert_Contacts_Aggregate;
  /** fetch data from the table: "questionnaire_risk_alert_contacts" using primary key columns */
  questionnaire_risk_alert_contacts_by_pk?: Maybe<Questionnaire_Risk_Alert_Contacts>;
  /** An array relationship */
  questionnaire_schedules: Array<Questionnaire_Schedules>;
  /** An aggregate relationship */
  questionnaire_schedules_aggregate: Questionnaire_Schedules_Aggregate;
  /** fetch data from the table: "questionnaire_schedules" using primary key columns */
  questionnaire_schedules_by_pk?: Maybe<Questionnaire_Schedules>;
  /** fetch data from the table: "questionnaire_scoring" */
  questionnaire_scoring: Array<Questionnaire_Scoring>;
  /** fetch aggregated fields from the table: "questionnaire_scoring" */
  questionnaire_scoring_aggregate: Questionnaire_Scoring_Aggregate;
  /** fetch data from the table: "questionnaire_scoring" using primary key columns */
  questionnaire_scoring_by_pk?: Maybe<Questionnaire_Scoring>;
  /** An array relationship */
  questionnaire_takes: Array<Questionnaire_Takes>;
  /** An aggregate relationship */
  questionnaire_takes_aggregate: Questionnaire_Takes_Aggregate;
  /** fetch data from the table: "questionnaire_takes" using primary key columns */
  questionnaire_takes_by_pk?: Maybe<Questionnaire_Takes>;
  /** fetch data from the table: "questionnaires" */
  questionnaires: Array<Questionnaires>;
  /** fetch aggregated fields from the table: "questionnaires" */
  questionnaires_aggregate: Questionnaires_Aggregate;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** fetch data from the table: "relapse_prevention_place_visits" */
  relapse_prevention_place_visits: Array<Relapse_Prevention_Place_Visits>;
  /** fetch aggregated fields from the table: "relapse_prevention_place_visits" */
  relapse_prevention_place_visits_aggregate: Relapse_Prevention_Place_Visits_Aggregate;
  /** fetch data from the table: "relapse_prevention_place_visits" using primary key columns */
  relapse_prevention_place_visits_by_pk?: Maybe<Relapse_Prevention_Place_Visits>;
  /** fetch data from the table: "relapse_prevention_places" */
  relapse_prevention_places: Array<Relapse_Prevention_Places>;
  /** fetch aggregated fields from the table: "relapse_prevention_places" */
  relapse_prevention_places_aggregate: Relapse_Prevention_Places_Aggregate;
  /** fetch data from the table: "relapse_prevention_places" using primary key columns */
  relapse_prevention_places_by_pk?: Maybe<Relapse_Prevention_Places>;
  /** fetch data from the table: "resources" */
  resources: Array<Resources>;
  /** fetch aggregated fields from the table: "resources" */
  resources_aggregate: Resources_Aggregate;
  /** fetch data from the table: "resources" using primary key columns */
  resources_by_pk?: Maybe<Resources>;
  /** fetch data from the table: "resources_orgs" */
  resources_orgs: Array<Resources_Orgs>;
  /** fetch aggregated fields from the table: "resources_orgs" */
  resources_orgs_aggregate: Resources_Orgs_Aggregate;
  /** fetch data from the table: "resources_orgs" using primary key columns */
  resources_orgs_by_pk?: Maybe<Resources_Orgs>;
  /** fetch data from the table: "risk_alerts_log" */
  risk_alerts_log: Array<Risk_Alerts_Log>;
  /** fetch aggregated fields from the table: "risk_alerts_log" */
  risk_alerts_log_aggregate: Risk_Alerts_Log_Aggregate;
  /** fetch data from the table: "risk_alerts_log" using primary key columns */
  risk_alerts_log_by_pk?: Maybe<Risk_Alerts_Log>;
  /** fetch data from the table: "risk_alerts_recipients_log" */
  risk_alerts_recipients_log: Array<Risk_Alerts_Recipients_Log>;
  /** fetch aggregated fields from the table: "risk_alerts_recipients_log" */
  risk_alerts_recipients_log_aggregate: Risk_Alerts_Recipients_Log_Aggregate;
  /** fetch data from the table: "risk_alerts_recipients_log" using primary key columns */
  risk_alerts_recipients_log_by_pk?: Maybe<Risk_Alerts_Recipients_Log>;
  /** fetch data from the table: "role_capabilities" */
  role_capabilities: Array<Role_Capabilities>;
  /** fetch aggregated fields from the table: "role_capabilities" */
  role_capabilities_aggregate: Role_Capabilities_Aggregate;
  /** fetch data from the table: "role_capabilities" using primary key columns */
  role_capabilities_by_pk?: Maybe<Role_Capabilities>;
  /** fetch data from the table: "safety_checklist_recipients_log" */
  safety_checklist_recipients_log: Array<Safety_Checklist_Recipients_Log>;
  /** fetch aggregated fields from the table: "safety_checklist_recipients_log" */
  safety_checklist_recipients_log_aggregate: Safety_Checklist_Recipients_Log_Aggregate;
  /** fetch data from the table: "safety_checklist_recipients_log" using primary key columns */
  safety_checklist_recipients_log_by_pk?: Maybe<Safety_Checklist_Recipients_Log>;
  /** An array relationship */
  safety_plan: Array<Safety_Plan>;
  /** An aggregate relationship */
  safety_plan_aggregate: Safety_Plan_Aggregate;
  /** fetch data from the table: "safety_plan" using primary key columns */
  safety_plan_by_pk?: Maybe<Safety_Plan>;
  /** fetch data from the table: "safety_plan_checklist_items" */
  safety_plan_checklist_items: Array<Safety_Plan_Checklist_Items>;
  /** fetch aggregated fields from the table: "safety_plan_checklist_items" */
  safety_plan_checklist_items_aggregate: Safety_Plan_Checklist_Items_Aggregate;
  /** fetch data from the table: "safety_plan_checklist_items" using primary key columns */
  safety_plan_checklist_items_by_pk?: Maybe<Safety_Plan_Checklist_Items>;
  /** fetch data from the table: "safety_plan_response_options" */
  safety_plan_response_options: Array<Safety_Plan_Response_Options>;
  /** fetch aggregated fields from the table: "safety_plan_response_options" */
  safety_plan_response_options_aggregate: Safety_Plan_Response_Options_Aggregate;
  /** fetch data from the table: "safety_plan_response_options" using primary key columns */
  safety_plan_response_options_by_pk?: Maybe<Safety_Plan_Response_Options>;
  /** An array relationship */
  safety_plan_section_category: Array<Safety_Plan_Section_Category>;
  /** An aggregate relationship */
  safety_plan_section_category_aggregate: Safety_Plan_Section_Category_Aggregate;
  /** fetch data from the table: "safety_plan_section_category" using primary key columns */
  safety_plan_section_category_by_pk?: Maybe<Safety_Plan_Section_Category>;
  /** fetch data from the table: "safety_plan_sections" */
  safety_plan_sections: Array<Safety_Plan_Sections>;
  /** fetch aggregated fields from the table: "safety_plan_sections" */
  safety_plan_sections_aggregate: Safety_Plan_Sections_Aggregate;
  /** fetch data from the table: "safety_plan_sections" using primary key columns */
  safety_plan_sections_by_pk?: Maybe<Safety_Plan_Sections>;
  /** fetch data from the table: "safety_plan_template" */
  safety_plan_template: Array<Safety_Plan_Template>;
  /** fetch aggregated fields from the table: "safety_plan_template" */
  safety_plan_template_aggregate: Safety_Plan_Template_Aggregate;
  /** fetch data from the table: "safety_plan_template" using primary key columns */
  safety_plan_template_by_pk?: Maybe<Safety_Plan_Template>;
  /** An array relationship */
  schedule_blackout_dates: Array<Schedule_Blackout_Dates>;
  /** An aggregate relationship */
  schedule_blackout_dates_aggregate: Schedule_Blackout_Dates_Aggregate;
  /** fetch data from the table: "schedule_blackout_dates" using primary key columns */
  schedule_blackout_dates_by_pk?: Maybe<Schedule_Blackout_Dates>;
  /** fetch data from the table: "transcript.action_plans" */
  transcript_action_plans: Array<Transcript_Action_Plans>;
  /** fetch aggregated fields from the table: "transcript.action_plans" */
  transcript_action_plans_aggregate: Transcript_Action_Plans_Aggregate;
  /** fetch data from the table: "transcript.action_plans" using primary key columns */
  transcript_action_plans_by_pk?: Maybe<Transcript_Action_Plans>;
  /** fetch data from the table: "transcript.progress_notes" */
  transcript_progress_notes: Array<Transcript_Progress_Notes>;
  /** fetch aggregated fields from the table: "transcript.progress_notes" */
  transcript_progress_notes_aggregate: Transcript_Progress_Notes_Aggregate;
  /** fetch data from the table: "transcript.progress_notes" using primary key columns */
  transcript_progress_notes_by_pk?: Maybe<Transcript_Progress_Notes>;
  /** fetch data from the table: "transcript.score_results" */
  transcript_score_results: Array<Transcript_Score_Results>;
  /** fetch aggregated fields from the table: "transcript.score_results" */
  transcript_score_results_aggregate: Transcript_Score_Results_Aggregate;
  /** fetch data from the table: "transcript.score_results" using primary key columns */
  transcript_score_results_by_pk?: Maybe<Transcript_Score_Results>;
  /** fetch data from the table: "transcript.sessions" */
  transcript_sessions: Array<Transcript_Sessions>;
  /** fetch aggregated fields from the table: "transcript.sessions" */
  transcript_sessions_aggregate: Transcript_Sessions_Aggregate;
  /** fetch data from the table: "transcript.sessions" using primary key columns */
  transcript_sessions_by_pk?: Maybe<Transcript_Sessions>;
  /** fetch data from the table: "transcript.transcripts" */
  transcript_transcripts: Array<Transcript_Transcripts>;
  /** fetch aggregated fields from the table: "transcript.transcripts" */
  transcript_transcripts_aggregate: Transcript_Transcripts_Aggregate;
  /** fetch data from the table: "transcript.transcripts" using primary key columns */
  transcript_transcripts_by_pk?: Maybe<Transcript_Transcripts>;
  /** fetch data from the table: "user_feature_flag" */
  user_feature_flag: Array<User_Feature_Flag>;
  /** fetch aggregated fields from the table: "user_feature_flag" */
  user_feature_flag_aggregate: User_Feature_Flag_Aggregate;
  /** fetch data from the table: "user_feature_flag" using primary key columns */
  user_feature_flag_by_pk?: Maybe<User_Feature_Flag>;
  /** fetch data from the table: "user_group_code" */
  user_group_code: Array<User_Group_Code>;
  /** fetch aggregated fields from the table: "user_group_code" */
  user_group_code_aggregate: User_Group_Code_Aggregate;
  /** fetch data from the table: "user_group_code" using primary key columns */
  user_group_code_by_pk?: Maybe<User_Group_Code>;
  /** An array relationship */
  user_insights: Array<User_Insights>;
  /** An aggregate relationship */
  user_insights_aggregate: User_Insights_Aggregate;
  /** fetch data from the table: "user_insights" using primary key columns */
  user_insights_by_pk?: Maybe<User_Insights>;
  /** An array relationship */
  user_invites: Array<User_Invites>;
  /** An aggregate relationship */
  user_invites_aggregate: User_Invites_Aggregate;
  /** fetch data from the table: "user_invites" using primary key columns */
  user_invites_by_pk?: Maybe<User_Invites>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_insights_display_status" */
  users_insights_display_status: Array<Users_Insights_Display_Status>;
  /** fetch aggregated fields from the table: "users_insights_display_status" */
  users_insights_display_status_aggregate: Users_Insights_Display_Status_Aggregate;
  /** fetch data from the table: "users_insights_display_status" using primary key columns */
  users_insights_display_status_by_pk?: Maybe<Users_Insights_Display_Status>;
  /** An array relationship */
  vw_daily_features_sleep: Array<Vw_Daily_Features_Sleep>;
  /** An aggregate relationship */
  vw_daily_features_sleep_aggregate: Vw_Daily_Features_Sleep_Aggregate;
  /** An array relationship */
  vw_daily_features_trend: Array<Vw_Daily_Features_Trend>;
  /** An aggregate relationship */
  vw_daily_features_trend_aggregate: Vw_Daily_Features_Trend_Aggregate;
  /** fetch data from the table: "vw_most_recent_scored_questionnaires" */
  vw_most_recent_scored_questionnaires: Array<Vw_Most_Recent_Scored_Questionnaires>;
  /** fetch aggregated fields from the table: "vw_most_recent_scored_questionnaires" */
  vw_most_recent_scored_questionnaires_aggregate: Vw_Most_Recent_Scored_Questionnaires_Aggregate;
  /** fetch data from the table: "vw_org_client_count" */
  vw_org_client_count: Array<Vw_Org_Client_Count>;
  /** fetch aggregated fields from the table: "vw_org_client_count" */
  vw_org_client_count_aggregate: Vw_Org_Client_Count_Aggregate;
  /** fetch data from the table: "vw_org_nudge_count" */
  vw_org_nudge_count: Array<Vw_Org_Nudge_Count>;
  /** fetch aggregated fields from the table: "vw_org_nudge_count" */
  vw_org_nudge_count_aggregate: Vw_Org_Nudge_Count_Aggregate;
  /** fetch data from the table: "vw_org_nudge_technique_counts" */
  vw_org_nudge_technique_counts: Array<Vw_Org_Nudge_Technique_Counts>;
  /** fetch aggregated fields from the table: "vw_org_nudge_technique_counts" */
  vw_org_nudge_technique_counts_aggregate: Vw_Org_Nudge_Technique_Counts_Aggregate;
  /** fetch data from the table: "vw_org_questionnaire_count" */
  vw_org_questionnaire_count: Array<Vw_Org_Questionnaire_Count>;
  /** fetch aggregated fields from the table: "vw_org_questionnaire_count" */
  vw_org_questionnaire_count_aggregate: Vw_Org_Questionnaire_Count_Aggregate;
  /** fetch data from the table: "vw_organization_summary" */
  vw_organization_summary: Array<Vw_Organization_Summary>;
  /** fetch aggregated fields from the table: "vw_organization_summary" */
  vw_organization_summary_aggregate: Vw_Organization_Summary_Aggregate;
  /** fetch data from the table: "vw_practitioner_client_count" */
  vw_practitioner_client_count: Array<Vw_Practitioner_Client_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_client_count" */
  vw_practitioner_client_count_aggregate: Vw_Practitioner_Client_Count_Aggregate;
  /** fetch data from the table: "vw_practitioner_counts" */
  vw_practitioner_counts: Array<Vw_Practitioner_Counts>;
  /** fetch aggregated fields from the table: "vw_practitioner_counts" */
  vw_practitioner_counts_aggregate: Vw_Practitioner_Counts_Aggregate;
  /** fetch data from the table: "vw_practitioner_nudge_count" */
  vw_practitioner_nudge_count: Array<Vw_Practitioner_Nudge_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_nudge_count" */
  vw_practitioner_nudge_count_aggregate: Vw_Practitioner_Nudge_Count_Aggregate;
  /** fetch data from the table: "vw_practitioner_questionnaire_count" */
  vw_practitioner_questionnaire_count: Array<Vw_Practitioner_Questionnaire_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_questionnaire_count" */
  vw_practitioner_questionnaire_count_aggregate: Vw_Practitioner_Questionnaire_Count_Aggregate;
  /** fetch data from the table: "vw_questionnaire_display_values" */
  vw_questionnaire_display_values: Array<Vw_Questionnaire_Display_Values>;
  /** fetch aggregated fields from the table: "vw_questionnaire_display_values" */
  vw_questionnaire_display_values_aggregate: Vw_Questionnaire_Display_Values_Aggregate;
  /** fetch data from the table: "vw_user_organization" */
  vw_user_organization: Array<Vw_User_Organization>;
  /** fetch aggregated fields from the table: "vw_user_organization" */
  vw_user_organization_aggregate: Vw_User_Organization_Aggregate;
  /** fetch data from the table: "vw_user_virasafe_metrics" */
  vw_user_virasafe_metrics: Array<Vw_User_Virasafe_Metrics>;
  /** fetch aggregated fields from the table: "vw_user_virasafe_metrics" */
  vw_user_virasafe_metrics_aggregate: Vw_User_Virasafe_Metrics_Aggregate;
};


export type Query_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Query_RootActivity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_RatingArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


export type Query_RootActivity_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


export type Query_RootActivity_Rating_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Order_By>>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};


export type Query_RootActivity_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Order_By>>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};


export type Query_RootActivity_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_Resource_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Category_Order_By>>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};


export type Query_RootActivity_Resource_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Category_Order_By>>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};


export type Query_RootActivity_Resource_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_Sub_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Activity_Sub_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Sub_Category_Order_By>>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};


export type Query_RootActivity_Sub_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Sub_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Sub_Category_Order_By>>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};


export type Query_RootActivity_Sub_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_Suggested_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Suggested_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Suggested_Activities_Order_By>>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};


export type Query_RootActivity_Suggested_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Suggested_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Suggested_Activities_Order_By>>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};


export type Query_RootActivity_Suggested_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


export type Query_RootAssessment_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


export type Query_RootAssessment_Answers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_Branching_RulesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Branching_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Branching_Rules_Order_By>>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};


export type Query_RootAssessment_Branching_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Branching_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Branching_Rules_Order_By>>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};


export type Query_RootAssessment_Branching_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_PagesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


export type Query_RootAssessment_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


export type Query_RootAssessment_Pages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_Question_Custom_PromptArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Order_By>>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};


export type Query_RootAssessment_Question_Custom_Prompt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Order_By>>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};


export type Query_RootAssessment_Question_Custom_Prompt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


export type Query_RootAssessment_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


export type Query_RootAssessment_Questions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessment_TakesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


export type Query_RootAssessment_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


export type Query_RootAssessment_Takes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Assessments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessments_Order_By>>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};


export type Query_RootAssessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessments_Order_By>>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};


export type Query_RootAssessments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_Account_Migration_LogArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


export type Query_RootAuth_Account_Migration_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


export type Query_RootAuth_Account_Migration_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAuth_Account_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


export type Query_RootAuth_Account_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


export type Query_RootAuth_Account_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


export type Query_RootAuth_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


export type Query_RootAuth_Account_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


export type Query_RootAuth_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


export type Query_RootAuth_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Providers_Order_By>>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};


export type Query_RootAuth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Providers_Order_By>>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};


export type Query_RootAuth_Providers_By_PkArgs = {
  provider: Scalars['String']['input'];
};


export type Query_RootAuth_Refresh_Token_Usage_LogArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


export type Query_RootAuth_Refresh_Token_Usage_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


export type Query_RootAuth_Refresh_Token_Usage_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuth_Refresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


export type Query_RootAuth_Refresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


export type Query_RootAuth_Refresh_Tokens_By_PkArgs = {
  refresh_token_hash: Scalars['String']['input'];
};


export type Query_RootAuth_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Roles_Order_By>>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};


export type Query_RootAuth_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Roles_Order_By>>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};


export type Query_RootAuth_Roles_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Query_RootCasemix_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Casemix_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casemix_Category_Order_By>>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};


export type Query_RootCasemix_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casemix_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casemix_Category_Order_By>>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};


export type Query_RootCasemix_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


export type Query_RootClient_DemographicsArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


export type Query_RootClient_Demographics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


export type Query_RootClient_Demographics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDaily_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


export type Query_RootDaily_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


export type Query_RootDaily_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEhr_Client_Invite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Client_Invite_Codes_Order_By>>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};


export type Query_RootEhr_Client_Invite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Client_Invite_Codes_Order_By>>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};


export type Query_RootEhr_Client_Invite_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEhr_Ehr_Practitioner_MapArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Order_By>>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};


export type Query_RootEhr_Ehr_Practitioner_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Order_By>>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};


export type Query_RootEhr_Ehr_Practitioner_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEhr_Xealth_Event_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Event_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Event_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEhr_Xealth_Preorder_FormArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Preorder_Form_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Preorder_Form_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEhr_Xealth_Preorder_Invite_MapArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Preorder_Invite_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};


export type Query_RootEhr_Xealth_Preorder_Invite_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnum_Activity_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Category_Order_By>>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};


export type Query_RootEnum_Activity_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Category_Order_By>>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};


export type Query_RootEnum_Activity_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Activity_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};


export type Query_RootEnum_Activity_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};


export type Query_RootEnum_Activity_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Completion_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Completion_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Completion_Status_Order_By>>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};


export type Query_RootEnum_Completion_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Completion_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Completion_Status_Order_By>>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};


export type Query_RootEnum_Completion_Status_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Query_RootEnum_Feature_DirectionArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Direction_Order_By>>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};


export type Query_RootEnum_Feature_Direction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Direction_Order_By>>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};


export type Query_RootEnum_Feature_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Feature_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Type_Order_By>>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};


export type Query_RootEnum_Feature_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Type_Order_By>>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};


export type Query_RootEnum_Feature_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_GenderArgs = {
  distinct_on?: InputMaybe<Array<Enum_Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Gender_Order_By>>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};


export type Query_RootEnum_Gender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Gender_Order_By>>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};


export type Query_RootEnum_Gender_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Insight_Content_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Insight_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Insight_Content_Type_Order_By>>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};


export type Query_RootEnum_Insight_Content_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Insight_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Insight_Content_Type_Order_By>>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};


export type Query_RootEnum_Insight_Content_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Mobile_Permission_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Status_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};


export type Query_RootEnum_Mobile_Permission_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Status_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};


export type Query_RootEnum_Mobile_Permission_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Mobile_Permission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Type_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};


export type Query_RootEnum_Mobile_Permission_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Type_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};


export type Query_RootEnum_Mobile_Permission_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_OutcomeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Outcome_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Outcome_Order_By>>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};


export type Query_RootEnum_Outcome_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Outcome_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Outcome_Order_By>>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};


export type Query_RootEnum_Outcome_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Question_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Question_Type_Order_By>>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};


export type Query_RootEnum_Question_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Question_Type_Order_By>>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};


export type Query_RootEnum_Question_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Racial_EthnicArgs = {
  distinct_on?: InputMaybe<Array<Enum_Racial_Ethnic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Racial_Ethnic_Order_By>>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};


export type Query_RootEnum_Racial_Ethnic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Racial_Ethnic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Racial_Ethnic_Order_By>>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};


export type Query_RootEnum_Racial_Ethnic_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};


export type Query_RootEnum_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};


export type Query_RootEnum_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Safety_Plan_Section_Category_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Section_Category_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Section_Category_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Safety_Plan_Section_IconsArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Section_Icons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Section_Icons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Safety_Plan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Status_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Status_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Safety_Plan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};


export type Query_RootEnum_Safety_Plan_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEnum_Trend_DirectionArgs = {
  distinct_on?: InputMaybe<Array<Enum_Trend_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Trend_Direction_Order_By>>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};


export type Query_RootEnum_Trend_Direction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Trend_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Trend_Direction_Order_By>>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};


export type Query_RootEnum_Trend_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootFeature_Report_Feature_CoefficientsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Order_By>>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};


export type Query_RootFeature_Report_Feature_Coefficients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Order_By>>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};


export type Query_RootFeature_Report_Feature_Coefficients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFeature_Report_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


export type Query_RootFeature_Report_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


export type Query_RootFeature_Report_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFeature_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


export type Query_RootFeature_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


export type Query_RootFeature_Reports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGroup_CodeArgs = {
  distinct_on?: InputMaybe<Array<Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Code_Order_By>>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};


export type Query_RootGroup_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Code_Order_By>>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};


export type Query_RootGroup_Code_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


export type Query_RootInsight_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


export type Query_RootInsight_Articles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_CombosArgs = {
  distinct_on?: InputMaybe<Array<Insight_Combos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Combos_Order_By>>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};


export type Query_RootInsight_Combos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Combos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Combos_Order_By>>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};


export type Query_RootInsight_Combos_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_HowsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


export type Query_RootInsight_Hows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


export type Query_RootInsight_Hows_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_Plan_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


export type Query_RootInsight_Plan_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


export type Query_RootInsight_Plan_Article_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_Plan_TextArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


export type Query_RootInsight_Plan_Text_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


export type Query_RootInsight_Plan_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_PlansArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


export type Query_RootInsight_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


export type Query_RootInsight_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


export type Query_RootInsight_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


export type Query_RootInsight_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_RecipesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


export type Query_RootInsight_Recipes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


export type Query_RootInsight_Recipes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_ReflectArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


export type Query_RootInsight_Reflect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


export type Query_RootInsight_Reflect_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_Reflect_TextArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


export type Query_RootInsight_Reflect_Text_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


export type Query_RootInsight_Reflect_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


export type Query_RootInsight_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


export type Query_RootInsight_Resources_By_PkArgs = {
  direction: Enum_Feature_Direction_Enum;
  feature: Enum_Feature_Type_Enum;
  resources_id: Scalars['Int']['input'];
};


export type Query_RootInsight_TextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Texts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Texts_Order_By>>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};


export type Query_RootInsight_Texts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Texts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Texts_Order_By>>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};


export type Query_RootInsight_Texts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_TipsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Tips_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Tips_Order_By>>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};


export type Query_RootInsight_Tips_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Tips_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Tips_Order_By>>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};


export type Query_RootInsight_Tips_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInsight_WhysArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


export type Query_RootInsight_Whys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


export type Query_RootInsight_Whys_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootInvite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


export type Query_RootInvite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


export type Query_RootInvite_Codes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMobile_Device_DataArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


export type Query_RootMobile_Device_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


export type Query_RootMobile_Device_Data_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMobile_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


export type Query_RootMobile_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


export type Query_RootMobile_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMobile_Upload_LogArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Upload_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Upload_Log_Order_By>>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};


export type Query_RootMobile_Upload_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Upload_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Upload_Log_Order_By>>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};


export type Query_RootMobile_Upload_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMood_MeasurementsArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


export type Query_RootMood_Measurements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


export type Query_RootMood_Measurements_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNudge_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


export type Query_RootNudge_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


export type Query_RootNudge_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNudge_TakesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


export type Query_RootNudge_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


export type Query_RootNudge_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNudgesArgs = {
  distinct_on?: InputMaybe<Array<Nudges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudges_Order_By>>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};


export type Query_RootNudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudges_Order_By>>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};


export type Query_RootNudges_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Query_RootOrganization_Admins_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganization_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Features_Order_By>>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};


export type Query_RootOrganization_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Features_Order_By>>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};


export type Query_RootOrganization_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganization_Member_RolesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Member_Roles_Order_By>>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};


export type Query_RootOrganization_Member_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Member_Roles_Order_By>>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};


export type Query_RootOrganization_Member_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Query_RootOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Query_RootOrganization_Members_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganization_SuperviseesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


export type Query_RootOrganization_Supervisees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


export type Query_RootOrganization_Supervisees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganization_SupervisorsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


export type Query_RootOrganization_Supervisors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


export type Query_RootOrganization_Supervisors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnaire_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


export type Query_RootQuestionnaire_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


export type Query_RootQuestionnaire_Items_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnaire_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


export type Query_RootQuestionnaire_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


export type Query_RootQuestionnaire_Response_Options_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Query_RootQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Query_RootQuestionnaire_Responses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnaire_Risk_Alert_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


export type Query_RootQuestionnaire_Risk_Alert_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


export type Query_RootQuestionnaire_Risk_Alert_Contacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


export type Query_RootQuestionnaire_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


export type Query_RootQuestionnaire_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnaire_ScoringArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


export type Query_RootQuestionnaire_Scoring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


export type Query_RootQuestionnaire_Scoring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuestionnaire_TakesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


export type Query_RootQuestionnaire_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


export type Query_RootQuestionnaire_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Query_RootQuestionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Query_RootQuestionnaires_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRelapse_Prevention_Place_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};


export type Query_RootRelapse_Prevention_Place_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};


export type Query_RootRelapse_Prevention_Place_Visits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRelapse_Prevention_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Places_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};


export type Query_RootRelapse_Prevention_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Places_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};


export type Query_RootRelapse_Prevention_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootResourcesArgs = {
  distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Order_By>>;
  where?: InputMaybe<Resources_Bool_Exp>;
};


export type Query_RootResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Order_By>>;
  where?: InputMaybe<Resources_Bool_Exp>;
};


export type Query_RootResources_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootResources_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


export type Query_RootResources_Orgs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


export type Query_RootResources_Orgs_By_PkArgs = {
  org_id: Scalars['Int']['input'];
  resources_id: Scalars['Int']['input'];
};


export type Query_RootRisk_Alerts_LogArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};


export type Query_RootRisk_Alerts_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};


export type Query_RootRisk_Alerts_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRisk_Alerts_Recipients_LogArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


export type Query_RootRisk_Alerts_Recipients_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


export type Query_RootRisk_Alerts_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRole_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


export type Query_RootRole_Capabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


export type Query_RootRole_Capabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Checklist_Recipients_LogArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};


export type Query_RootSafety_Checklist_Recipients_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};


export type Query_RootSafety_Checklist_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_PlanArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


export type Query_RootSafety_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


export type Query_RootSafety_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Plan_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


export type Query_RootSafety_Plan_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


export type Query_RootSafety_Plan_Checklist_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Plan_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


export type Query_RootSafety_Plan_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


export type Query_RootSafety_Plan_Response_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Plan_Section_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


export type Query_RootSafety_Plan_Section_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


export type Query_RootSafety_Plan_Section_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Plan_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


export type Query_RootSafety_Plan_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


export type Query_RootSafety_Plan_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSafety_Plan_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Template_Order_By>>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};


export type Query_RootSafety_Plan_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Template_Order_By>>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};


export type Query_RootSafety_Plan_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSchedule_Blackout_DatesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


export type Query_RootSchedule_Blackout_Dates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


export type Query_RootSchedule_Blackout_Dates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTranscript_Action_PlansArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Action_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Action_Plans_Order_By>>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};


export type Query_RootTranscript_Action_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Action_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Action_Plans_Order_By>>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};


export type Query_RootTranscript_Action_Plans_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Query_RootTranscript_Progress_NotesArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Progress_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Progress_Notes_Order_By>>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};


export type Query_RootTranscript_Progress_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Progress_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Progress_Notes_Order_By>>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};


export type Query_RootTranscript_Progress_Notes_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTranscript_Score_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Score_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Score_Results_Order_By>>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};


export type Query_RootTranscript_Score_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Score_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Score_Results_Order_By>>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};


export type Query_RootTranscript_Score_Results_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Query_RootTranscript_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Sessions_Order_By>>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};


export type Query_RootTranscript_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Sessions_Order_By>>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};


export type Query_RootTranscript_Sessions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootTranscript_TranscriptsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Transcripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Transcripts_Order_By>>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};


export type Query_RootTranscript_Transcripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Transcripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Transcripts_Order_By>>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};


export type Query_RootTranscript_Transcripts_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Query_RootUser_Feature_FlagArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feature_Flag_Order_By>>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};


export type Query_RootUser_Feature_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feature_Flag_Order_By>>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};


export type Query_RootUser_Feature_Flag_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootUser_Group_CodeArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Code_Order_By>>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};


export type Query_RootUser_Group_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Code_Order_By>>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};


export type Query_RootUser_Group_Code_By_PkArgs = {
  group_code_id: Scalars['Int']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootUser_InsightsArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


export type Query_RootUser_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


export type Query_RootUser_Insights_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_InvitesArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Query_RootUser_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Query_RootUser_Invites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsers_Insights_Display_StatusArgs = {
  distinct_on?: InputMaybe<Array<Users_Insights_Display_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Insights_Display_Status_Order_By>>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};


export type Query_RootUsers_Insights_Display_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Insights_Display_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Insights_Display_Status_Order_By>>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};


export type Query_RootUsers_Insights_Display_Status_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootVw_Daily_Features_SleepArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


export type Query_RootVw_Daily_Features_Sleep_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


export type Query_RootVw_Daily_Features_TrendArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


export type Query_RootVw_Daily_Features_Trend_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


export type Query_RootVw_Most_Recent_Scored_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


export type Query_RootVw_Most_Recent_Scored_Questionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


export type Query_RootVw_Org_Client_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
};


export type Query_RootVw_Org_Client_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
};


export type Query_RootVw_Org_Nudge_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
};


export type Query_RootVw_Org_Nudge_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
};


export type Query_RootVw_Org_Nudge_Technique_CountsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
};


export type Query_RootVw_Org_Nudge_Technique_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
};


export type Query_RootVw_Org_Questionnaire_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
};


export type Query_RootVw_Org_Questionnaire_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
};


export type Query_RootVw_Organization_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Vw_Organization_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Organization_Summary_Order_By>>;
  where?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
};


export type Query_RootVw_Organization_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Organization_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Organization_Summary_Order_By>>;
  where?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Client_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Client_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
};


export type Query_RootVw_Practitioner_CountsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Counts_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Counts_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Nudge_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Nudge_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Questionnaire_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
};


export type Query_RootVw_Practitioner_Questionnaire_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
};


export type Query_RootVw_Questionnaire_Display_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Order_By>>;
  where?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
};


export type Query_RootVw_Questionnaire_Display_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Order_By>>;
  where?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
};


export type Query_RootVw_User_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


export type Query_RootVw_User_Organization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


export type Query_RootVw_User_Virasafe_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Order_By>>;
  where?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
};


export type Query_RootVw_User_Virasafe_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Order_By>>;
  where?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
};

/** columns and relationships of "questionnaire_items" */
export type Questionnaire_Items = {
  __typename?: 'questionnaire_items';
  created_at: Scalars['timestamptz']['output'];
  display_order: Scalars['Int']['output'];
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  /** An object relationship */
  questionnaire: Questionnaires;
  questionnaire_id: Scalars['Int']['output'];
  /** An array relationship */
  questionnaire_items_questionnaire_response_options: Array<Questionnaire_Response_Options>;
  /** An aggregate relationship */
  questionnaire_items_questionnaire_response_options_aggregate: Questionnaire_Response_Options_Aggregate;
  /** An array relationship */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** An aggregate relationship */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "questionnaire_items" */
export type Questionnaire_ItemsQuestionnaire_Items_Questionnaire_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


/** columns and relationships of "questionnaire_items" */
export type Questionnaire_ItemsQuestionnaire_Items_Questionnaire_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


/** columns and relationships of "questionnaire_items" */
export type Questionnaire_ItemsQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


/** columns and relationships of "questionnaire_items" */
export type Questionnaire_ItemsQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};

/** aggregated selection of "questionnaire_items" */
export type Questionnaire_Items_Aggregate = {
  __typename?: 'questionnaire_items_aggregate';
  aggregate?: Maybe<Questionnaire_Items_Aggregate_Fields>;
  nodes: Array<Questionnaire_Items>;
};

export type Questionnaire_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questionnaire_Items_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_items" */
export type Questionnaire_Items_Aggregate_Fields = {
  __typename?: 'questionnaire_items_aggregate_fields';
  avg?: Maybe<Questionnaire_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Items_Max_Fields>;
  min?: Maybe<Questionnaire_Items_Min_Fields>;
  stddev?: Maybe<Questionnaire_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Items_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Items_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Items_Variance_Fields>;
};


/** aggregate fields of "questionnaire_items" */
export type Questionnaire_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_items" */
export type Questionnaire_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Items_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Items_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_items" */
export type Questionnaire_Items_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Items_Avg_Fields = {
  __typename?: 'questionnaire_items_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_items". All fields are combined with a logical 'AND'. */
export type Questionnaire_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Items_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Items_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  header?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_items_questionnaire_response_options?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  questionnaire_items_questionnaire_response_options_aggregate?: InputMaybe<Questionnaire_Response_Options_Aggregate_Bool_Exp>;
  questionnaire_responses?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
  questionnaire_responses_aggregate?: InputMaybe<Questionnaire_Responses_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_items" */
export enum Questionnaire_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireItemsPkey = 'questionnaire_items_pkey'
}

/** input type for incrementing numeric columns in table "questionnaire_items" */
export type Questionnaire_Items_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_items" */
export type Questionnaire_Items_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_items_questionnaire_response_options?: InputMaybe<Questionnaire_Response_Options_Arr_Rel_Insert_Input>;
  questionnaire_responses?: InputMaybe<Questionnaire_Responses_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Items_Max_Fields = {
  __typename?: 'questionnaire_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Items_Min_Fields = {
  __typename?: 'questionnaire_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_items" */
export type Questionnaire_Items_Mutation_Response = {
  __typename?: 'questionnaire_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Items>;
};

/** input type for inserting object relation for remote table "questionnaire_items" */
export type Questionnaire_Items_Obj_Rel_Insert_Input = {
  data: Questionnaire_Items_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Items_On_Conflict>;
};

/** on_conflict condition type for table "questionnaire_items" */
export type Questionnaire_Items_On_Conflict = {
  constraint: Questionnaire_Items_Constraint;
  update_columns?: Array<Questionnaire_Items_Update_Column>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_items". */
export type Questionnaire_Items_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_items_questionnaire_response_options_aggregate?: InputMaybe<Questionnaire_Response_Options_Aggregate_Order_By>;
  questionnaire_responses_aggregate?: InputMaybe<Questionnaire_Responses_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_items */
export type Questionnaire_Items_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaire_items" */
export enum Questionnaire_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "questionnaire_items" */
export type Questionnaire_Items_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Items_Stddev_Fields = {
  __typename?: 'questionnaire_items_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Items_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_items_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Items_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_items_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_items" */
export type Questionnaire_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Items_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Items_Sum_Fields = {
  __typename?: 'questionnaire_items_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_items" */
export enum Questionnaire_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Header = 'header',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Questionnaire_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Items_Var_Pop_Fields = {
  __typename?: 'questionnaire_items_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Items_Var_Samp_Fields = {
  __typename?: 'questionnaire_items_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Items_Variance_Fields = {
  __typename?: 'questionnaire_items_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_items" */
export type Questionnaire_Items_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_response_options" */
export type Questionnaire_Response_Options = {
  __typename?: 'questionnaire_response_options';
  created_at: Scalars['timestamptz']['output'];
  display_order: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  questionnaire_item_id: Scalars['Int']['output'];
  /** An object relationship */
  questionnaire_response_options_questionnaire_item: Questionnaire_Items;
  response_text: Scalars['String']['output'];
  response_value: Scalars['Int']['output'];
  triggers_risk_alert?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "questionnaire_response_options" */
export type Questionnaire_Response_Options_Aggregate = {
  __typename?: 'questionnaire_response_options_aggregate';
  aggregate?: Maybe<Questionnaire_Response_Options_Aggregate_Fields>;
  nodes: Array<Questionnaire_Response_Options>;
};

export type Questionnaire_Response_Options_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Questionnaire_Response_Options_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_And = {
  arguments: Questionnaire_Response_Options_Select_Column_Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Questionnaire_Response_Options_Select_Column_Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Response_Options_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_response_options" */
export type Questionnaire_Response_Options_Aggregate_Fields = {
  __typename?: 'questionnaire_response_options_aggregate_fields';
  avg?: Maybe<Questionnaire_Response_Options_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Response_Options_Max_Fields>;
  min?: Maybe<Questionnaire_Response_Options_Min_Fields>;
  stddev?: Maybe<Questionnaire_Response_Options_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Response_Options_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Response_Options_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Response_Options_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Response_Options_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Response_Options_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Response_Options_Variance_Fields>;
};


/** aggregate fields of "questionnaire_response_options" */
export type Questionnaire_Response_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Response_Options_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Response_Options_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Response_Options_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Response_Options_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Response_Options_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Response_Options_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Response_Options_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Response_Options_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Response_Options_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Response_Options_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Response_Options_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Response_Options_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Response_Options_Avg_Fields = {
  __typename?: 'questionnaire_response_options_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_response_options". All fields are combined with a logical 'AND'. */
export type Questionnaire_Response_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Response_Options_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Response_Options_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_item_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_response_options_questionnaire_item?: InputMaybe<Questionnaire_Items_Bool_Exp>;
  response_text?: InputMaybe<String_Comparison_Exp>;
  response_value?: InputMaybe<Int_Comparison_Exp>;
  triggers_risk_alert?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_response_options" */
export enum Questionnaire_Response_Options_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireResponseOptionsPkey = 'questionnaire_response_options_pkey',
  /** unique or primary key constraint on columns "response_value", "questionnaire_item_id" */
  UniqueQuestionnaireResponseValuesPerItemConstraint = 'unique_questionnaire_response_values_per_item_constraint'
}

/** input type for incrementing numeric columns in table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  response_value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_options_questionnaire_item?: InputMaybe<Questionnaire_Items_Obj_Rel_Insert_Input>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  response_value?: InputMaybe<Scalars['Int']['input']>;
  triggers_risk_alert?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Response_Options_Max_Fields = {
  __typename?: 'questionnaire_response_options_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  response_text?: Maybe<Scalars['String']['output']>;
  response_value?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_text?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Response_Options_Min_Fields = {
  __typename?: 'questionnaire_response_options_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  response_text?: Maybe<Scalars['String']['output']>;
  response_value?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_text?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Mutation_Response = {
  __typename?: 'questionnaire_response_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Response_Options>;
};

/** input type for inserting object relation for remote table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Obj_Rel_Insert_Input = {
  data: Questionnaire_Response_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Response_Options_On_Conflict>;
};

/** on_conflict condition type for table "questionnaire_response_options" */
export type Questionnaire_Response_Options_On_Conflict = {
  constraint: Questionnaire_Response_Options_Constraint;
  update_columns?: Array<Questionnaire_Response_Options_Update_Column>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_response_options". */
export type Questionnaire_Response_Options_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_options_questionnaire_item?: InputMaybe<Questionnaire_Items_Order_By>;
  response_text?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
  triggers_risk_alert?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_response_options */
export type Questionnaire_Response_Options_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaire_response_options" */
export enum Questionnaire_Response_Options_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireItemId = 'questionnaire_item_id',
  /** column name */
  ResponseText = 'response_text',
  /** column name */
  ResponseValue = 'response_value',
  /** column name */
  TriggersRiskAlert = 'triggers_risk_alert',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "questionnaire_response_options_aggregate_bool_exp_bool_and_arguments_columns" columns of table "questionnaire_response_options" */
export enum Questionnaire_Response_Options_Select_Column_Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  TriggersRiskAlert = 'triggers_risk_alert'
}

/** select "questionnaire_response_options_aggregate_bool_exp_bool_or_arguments_columns" columns of table "questionnaire_response_options" */
export enum Questionnaire_Response_Options_Select_Column_Questionnaire_Response_Options_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  TriggersRiskAlert = 'triggers_risk_alert'
}

/** input type for updating data in table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  response_value?: InputMaybe<Scalars['Int']['input']>;
  triggers_risk_alert?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Response_Options_Stddev_Fields = {
  __typename?: 'questionnaire_response_options_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Response_Options_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_response_options_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Response_Options_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_response_options_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Response_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Response_Options_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  response_value?: InputMaybe<Scalars['Int']['input']>;
  triggers_risk_alert?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Response_Options_Sum_Fields = {
  __typename?: 'questionnaire_response_options_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  response_value?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_response_options" */
export enum Questionnaire_Response_Options_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireItemId = 'questionnaire_item_id',
  /** column name */
  ResponseText = 'response_text',
  /** column name */
  ResponseValue = 'response_value',
  /** column name */
  TriggersRiskAlert = 'triggers_risk_alert',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Questionnaire_Response_Options_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Response_Options_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Response_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Response_Options_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Response_Options_Var_Pop_Fields = {
  __typename?: 'questionnaire_response_options_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Response_Options_Var_Samp_Fields = {
  __typename?: 'questionnaire_response_options_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Response_Options_Variance_Fields = {
  __typename?: 'questionnaire_response_options_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  response_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_response_options" */
export type Questionnaire_Response_Options_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  response_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_responses" */
export type Questionnaire_Responses = {
  __typename?: 'questionnaire_responses';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  questionnaire_item: Questionnaire_Items;
  questionnaire_item_id: Scalars['Int']['output'];
  questionnaire_response_option_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  questionnaire_response_options?: Maybe<Questionnaire_Response_Options>;
  /** An object relationship */
  questionnaire_take: Questionnaire_Takes;
  questionnaire_take_id: Scalars['Int']['output'];
  response: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate = {
  __typename?: 'questionnaire_responses_aggregate';
  aggregate?: Maybe<Questionnaire_Responses_Aggregate_Fields>;
  nodes: Array<Questionnaire_Responses>;
};

export type Questionnaire_Responses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questionnaire_Responses_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Responses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate_Fields = {
  __typename?: 'questionnaire_responses_aggregate_fields';
  avg?: Maybe<Questionnaire_Responses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Responses_Max_Fields>;
  min?: Maybe<Questionnaire_Responses_Min_Fields>;
  stddev?: Maybe<Questionnaire_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Responses_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Responses_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Responses_Variance_Fields>;
};


/** aggregate fields of "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_responses" */
export type Questionnaire_Responses_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Responses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Responses_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Responses_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Responses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Responses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Responses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Responses_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Responses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Responses_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Responses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_responses" */
export type Questionnaire_Responses_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Responses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Responses_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Responses_Avg_Fields = {
  __typename?: 'questionnaire_responses_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_responses". All fields are combined with a logical 'AND'. */
export type Questionnaire_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Responses_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_item?: InputMaybe<Questionnaire_Items_Bool_Exp>;
  questionnaire_item_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_response_option_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_response_options?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
  questionnaire_take?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  questionnaire_take_id?: InputMaybe<Int_Comparison_Exp>;
  response?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_responses" */
export enum Questionnaire_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireResponsesPkey = 'questionnaire_responses_pkey',
  /** unique or primary key constraint on columns "questionnaire_item_id", "questionnaire_take_id" */
  QuestionnaireResponsesQuestionnaireItemIdQuestionnaireTak = 'questionnaire_responses_questionnaire_item_id_questionnaire_tak'
}

/** input type for incrementing numeric columns in table "questionnaire_responses" */
export type Questionnaire_Responses_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_option_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_responses" */
export type Questionnaire_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item?: InputMaybe<Questionnaire_Items_Obj_Rel_Insert_Input>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_option_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_options?: InputMaybe<Questionnaire_Response_Options_Obj_Rel_Insert_Input>;
  questionnaire_take?: InputMaybe<Questionnaire_Takes_Obj_Rel_Insert_Input>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Responses_Max_Fields = {
  __typename?: 'questionnaire_responses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Responses_Min_Fields = {
  __typename?: 'questionnaire_responses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_responses" */
export type Questionnaire_Responses_Mutation_Response = {
  __typename?: 'questionnaire_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Responses>;
};

/** on_conflict condition type for table "questionnaire_responses" */
export type Questionnaire_Responses_On_Conflict = {
  constraint: Questionnaire_Responses_Constraint;
  update_columns?: Array<Questionnaire_Responses_Update_Column>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_responses". */
export type Questionnaire_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_item?: InputMaybe<Questionnaire_Items_Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_response_options?: InputMaybe<Questionnaire_Response_Options_Order_By>;
  questionnaire_take?: InputMaybe<Questionnaire_Takes_Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_responses */
export type Questionnaire_Responses_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaire_responses" */
export enum Questionnaire_Responses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireItemId = 'questionnaire_item_id',
  /** column name */
  QuestionnaireResponseOptionId = 'questionnaire_response_option_id',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id',
  /** column name */
  Response = 'response',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "questionnaire_responses" */
export type Questionnaire_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_option_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Responses_Stddev_Fields = {
  __typename?: 'questionnaire_responses_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Responses_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_responses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Responses_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_responses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_responses" */
export type Questionnaire_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_response_option_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Responses_Sum_Fields = {
  __typename?: 'questionnaire_responses_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_responses" */
export enum Questionnaire_Responses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireItemId = 'questionnaire_item_id',
  /** column name */
  QuestionnaireResponseOptionId = 'questionnaire_response_option_id',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id',
  /** column name */
  Response = 'response',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Questionnaire_Responses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Responses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Responses_Var_Pop_Fields = {
  __typename?: 'questionnaire_responses_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Responses_Var_Samp_Fields = {
  __typename?: 'questionnaire_responses_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Responses_Variance_Fields = {
  __typename?: 'questionnaire_responses_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_item_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_response_option_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  response?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_responses" */
export type Questionnaire_Responses_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_item_id?: InputMaybe<Order_By>;
  questionnaire_response_option_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  response?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts = {
  __typename?: 'questionnaire_risk_alert_contacts';
  id: Scalars['uuid']['output'];
  questionnaire_id: Scalars['Int']['output'];
  /** An object relationship */
  questionnaire_risk_alert_contacts_questionnaire: Questionnaires;
  /** An object relationship */
  questionnaire_risk_alert_contacts_user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Aggregate = {
  __typename?: 'questionnaire_risk_alert_contacts_aggregate';
  aggregate?: Maybe<Questionnaire_Risk_Alert_Contacts_Aggregate_Fields>;
  nodes: Array<Questionnaire_Risk_Alert_Contacts>;
};

export type Questionnaire_Risk_Alert_Contacts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Risk_Alert_Contacts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Aggregate_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_aggregate_fields';
  avg?: Maybe<Questionnaire_Risk_Alert_Contacts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Risk_Alert_Contacts_Max_Fields>;
  min?: Maybe<Questionnaire_Risk_Alert_Contacts_Min_Fields>;
  stddev?: Maybe<Questionnaire_Risk_Alert_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Risk_Alert_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Risk_Alert_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Risk_Alert_Contacts_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Risk_Alert_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Risk_Alert_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Risk_Alert_Contacts_Variance_Fields>;
};


/** aggregate fields of "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Risk_Alert_Contacts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Risk_Alert_Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Risk_Alert_Contacts_Avg_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_avg_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Avg_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_risk_alert_contacts". All fields are combined with a logical 'AND'. */
export type Questionnaire_Risk_Alert_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_risk_alert_contacts_questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_risk_alert_contacts_user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_risk_alert_contacts" */
export enum Questionnaire_Risk_Alert_Contacts_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireRiskAlertContactsPkey = 'questionnaire_risk_alert_contacts_pkey'
}

/** input type for incrementing numeric columns in table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Inc_Input = {
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_risk_alert_contacts_questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_risk_alert_contacts_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Risk_Alert_Contacts_Max_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Risk_Alert_Contacts_Min_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Mutation_Response = {
  __typename?: 'questionnaire_risk_alert_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Risk_Alert_Contacts>;
};

/** on_conflict condition type for table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_On_Conflict = {
  constraint: Questionnaire_Risk_Alert_Contacts_Constraint;
  update_columns?: Array<Questionnaire_Risk_Alert_Contacts_Update_Column>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_risk_alert_contacts". */
export type Questionnaire_Risk_Alert_Contacts_Order_By = {
  id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_risk_alert_contacts_questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_risk_alert_contacts_user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_risk_alert_contacts */
export type Questionnaire_Risk_Alert_Contacts_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "questionnaire_risk_alert_contacts" */
export enum Questionnaire_Risk_Alert_Contacts_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_stddev_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_stddev_pop_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Pop_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_stddev_samp_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Stddev_Samp_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Risk_Alert_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Risk_Alert_Contacts_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Risk_Alert_Contacts_Sum_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_sum_fields';
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Sum_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_risk_alert_contacts" */
export enum Questionnaire_Risk_Alert_Contacts_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UserId = 'user_id'
}

export type Questionnaire_Risk_Alert_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Risk_Alert_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Risk_Alert_Contacts_Var_Pop_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_var_pop_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Var_Pop_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Risk_Alert_Contacts_Var_Samp_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_var_samp_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Var_Samp_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Risk_Alert_Contacts_Variance_Fields = {
  __typename?: 'questionnaire_risk_alert_contacts_variance_fields';
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_risk_alert_contacts" */
export type Questionnaire_Risk_Alert_Contacts_Variance_Order_By = {
  questionnaire_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_schedules" */
export type Questionnaire_Schedules = {
  __typename?: 'questionnaire_schedules';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  minutes_to_expiration: Scalars['Int']['output'];
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  one_time?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  practitioner: Users;
  practitioner_id: Scalars['uuid']['output'];
  /** An object relationship */
  questionnaire: Questionnaires;
  questionnaire_id: Scalars['Int']['output'];
  /** An array relationship */
  questionnaire_takes: Array<Questionnaire_Takes>;
  /** An aggregate relationship */
  questionnaire_takes_aggregate: Questionnaire_Takes_Aggregate;
  recurring_friday: Scalars['Boolean']['output'];
  recurring_monday: Scalars['Boolean']['output'];
  recurring_saturday: Scalars['Boolean']['output'];
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  recurring_sunday: Scalars['Boolean']['output'];
  recurring_thursday: Scalars['Boolean']['output'];
  recurring_tuesday: Scalars['Boolean']['output'];
  recurring_wednesday: Scalars['Boolean']['output'];
  /** An array relationship */
  schedule_blackout_dates: Array<Schedule_Blackout_Dates>;
  /** An aggregate relationship */
  schedule_blackout_dates_aggregate: Schedule_Blackout_Dates_Aggregate;
  scheduled_at: Scalars['timestamp']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "questionnaire_schedules" */
export type Questionnaire_SchedulesQuestionnaire_TakesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


/** columns and relationships of "questionnaire_schedules" */
export type Questionnaire_SchedulesQuestionnaire_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


/** columns and relationships of "questionnaire_schedules" */
export type Questionnaire_SchedulesSchedule_Blackout_DatesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


/** columns and relationships of "questionnaire_schedules" */
export type Questionnaire_SchedulesSchedule_Blackout_Dates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};

/** aggregated selection of "questionnaire_schedules" */
export type Questionnaire_Schedules_Aggregate = {
  __typename?: 'questionnaire_schedules_aggregate';
  aggregate?: Maybe<Questionnaire_Schedules_Aggregate_Fields>;
  nodes: Array<Questionnaire_Schedules>;
};

export type Questionnaire_Schedules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_And = {
  arguments: Questionnaire_Schedules_Select_Column_Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Questionnaire_Schedules_Select_Column_Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Schedules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_schedules" */
export type Questionnaire_Schedules_Aggregate_Fields = {
  __typename?: 'questionnaire_schedules_aggregate_fields';
  avg?: Maybe<Questionnaire_Schedules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Schedules_Max_Fields>;
  min?: Maybe<Questionnaire_Schedules_Min_Fields>;
  stddev?: Maybe<Questionnaire_Schedules_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Schedules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Schedules_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Schedules_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Schedules_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Schedules_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Schedules_Variance_Fields>;
};


/** aggregate fields of "questionnaire_schedules" */
export type Questionnaire_Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Schedules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Schedules_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Schedules_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Schedules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Schedules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Schedules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Schedules_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Schedules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Schedules_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Schedules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_schedules" */
export type Questionnaire_Schedules_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Schedules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Schedules_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Schedules_Avg_Fields = {
  __typename?: 'questionnaire_schedules_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_schedules". All fields are combined with a logical 'AND'. */
export type Questionnaire_Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Schedules_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Schedules_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  minutes_to_expiration?: InputMaybe<Int_Comparison_Exp>;
  notify_connected_practitioners?: InputMaybe<Timestamp_Comparison_Exp>;
  one_time?: InputMaybe<Boolean_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_takes?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  questionnaire_takes_aggregate?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp>;
  recurring_friday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_monday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_saturday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  recurring_sunday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_thursday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_tuesday?: InputMaybe<Boolean_Comparison_Exp>;
  recurring_wednesday?: InputMaybe<Boolean_Comparison_Exp>;
  schedule_blackout_dates?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  schedule_blackout_dates_aggregate?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Bool_Exp>;
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_schedules" */
export enum Questionnaire_Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireSchedulesPkey = 'questionnaire_schedules_pkey'
}

/** input type for incrementing numeric columns in table "questionnaire_schedules" */
export type Questionnaire_Schedules_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_schedules" */
export type Questionnaire_Schedules_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_takes?: InputMaybe<Questionnaire_Takes_Arr_Rel_Insert_Input>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  schedule_blackout_dates?: InputMaybe<Schedule_Blackout_Dates_Arr_Rel_Insert_Input>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Schedules_Max_Fields = {
  __typename?: 'questionnaire_schedules_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Schedules_Min_Fields = {
  __typename?: 'questionnaire_schedules_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  recurring_start_date?: Maybe<Scalars['timestamptz']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_schedules" */
export type Questionnaire_Schedules_Mutation_Response = {
  __typename?: 'questionnaire_schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Schedules>;
};

/** input type for inserting object relation for remote table "questionnaire_schedules" */
export type Questionnaire_Schedules_Obj_Rel_Insert_Input = {
  data: Questionnaire_Schedules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Schedules_On_Conflict>;
};

/** on_conflict condition type for table "questionnaire_schedules" */
export type Questionnaire_Schedules_On_Conflict = {
  constraint: Questionnaire_Schedules_Constraint;
  update_columns?: Array<Questionnaire_Schedules_Update_Column>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_schedules". */
export type Questionnaire_Schedules_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  one_time?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  questionnaire?: InputMaybe<Questionnaires_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_takes_aggregate?: InputMaybe<Questionnaire_Takes_Aggregate_Order_By>;
  recurring_friday?: InputMaybe<Order_By>;
  recurring_monday?: InputMaybe<Order_By>;
  recurring_saturday?: InputMaybe<Order_By>;
  recurring_start_date?: InputMaybe<Order_By>;
  recurring_sunday?: InputMaybe<Order_By>;
  recurring_thursday?: InputMaybe<Order_By>;
  recurring_tuesday?: InputMaybe<Order_By>;
  recurring_wednesday?: InputMaybe<Order_By>;
  schedule_blackout_dates_aggregate?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_schedules */
export type Questionnaire_Schedules_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaire_schedules" */
export enum Questionnaire_Schedules_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  NotifyConnectedPractitioners = 'notify_connected_practitioners',
  /** column name */
  OneTime = 'one_time',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringStartDate = 'recurring_start_date',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "questionnaire_schedules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "questionnaire_schedules" */
export enum Questionnaire_Schedules_Select_Column_Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  OneTime = 'one_time',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday'
}

/** select "questionnaire_schedules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "questionnaire_schedules" */
export enum Questionnaire_Schedules_Select_Column_Questionnaire_Schedules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  OneTime = 'one_time',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday'
}

/** input type for updating data in table "questionnaire_schedules" */
export type Questionnaire_Schedules_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Schedules_Stddev_Fields = {
  __typename?: 'questionnaire_schedules_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Schedules_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_schedules_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Schedules_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_schedules_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_schedules" */
export type Questionnaire_Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Schedules_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Schedules_Sum_Fields = {
  __typename?: 'questionnaire_schedules_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_schedules" */
export enum Questionnaire_Schedules_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  NotifyConnectedPractitioners = 'notify_connected_practitioners',
  /** column name */
  OneTime = 'one_time',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  RecurringFriday = 'recurring_friday',
  /** column name */
  RecurringMonday = 'recurring_monday',
  /** column name */
  RecurringSaturday = 'recurring_saturday',
  /** column name */
  RecurringStartDate = 'recurring_start_date',
  /** column name */
  RecurringSunday = 'recurring_sunday',
  /** column name */
  RecurringThursday = 'recurring_thursday',
  /** column name */
  RecurringTuesday = 'recurring_tuesday',
  /** column name */
  RecurringWednesday = 'recurring_wednesday',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Questionnaire_Schedules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Schedules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Schedules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Schedules_Var_Pop_Fields = {
  __typename?: 'questionnaire_schedules_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Schedules_Var_Samp_Fields = {
  __typename?: 'questionnaire_schedules_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Schedules_Variance_Fields = {
  __typename?: 'questionnaire_schedules_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_schedules" */
export type Questionnaire_Schedules_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_scoring" */
export type Questionnaire_Scoring = {
  __typename?: 'questionnaire_scoring';
  casemix_category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  display_color: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lower_bound: Scalars['Int']['output'];
  questionnaire_id: Scalars['Int']['output'];
  /** An object relationship */
  questionnaire_scoring_questionnaire: Questionnaires;
  updated_at: Scalars['timestamptz']['output'];
  upper_bound: Scalars['Int']['output'];
};

/** aggregated selection of "questionnaire_scoring" */
export type Questionnaire_Scoring_Aggregate = {
  __typename?: 'questionnaire_scoring_aggregate';
  aggregate?: Maybe<Questionnaire_Scoring_Aggregate_Fields>;
  nodes: Array<Questionnaire_Scoring>;
};

export type Questionnaire_Scoring_Aggregate_Bool_Exp = {
  count?: InputMaybe<Questionnaire_Scoring_Aggregate_Bool_Exp_Count>;
};

export type Questionnaire_Scoring_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "questionnaire_scoring" */
export type Questionnaire_Scoring_Aggregate_Fields = {
  __typename?: 'questionnaire_scoring_aggregate_fields';
  avg?: Maybe<Questionnaire_Scoring_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Scoring_Max_Fields>;
  min?: Maybe<Questionnaire_Scoring_Min_Fields>;
  stddev?: Maybe<Questionnaire_Scoring_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Scoring_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Scoring_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Scoring_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Scoring_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Scoring_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Scoring_Variance_Fields>;
};


/** aggregate fields of "questionnaire_scoring" */
export type Questionnaire_Scoring_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Scoring_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Scoring_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Scoring_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Scoring_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Scoring_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Scoring_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Scoring_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Scoring_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Scoring_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Scoring_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_scoring" */
export type Questionnaire_Scoring_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Scoring_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Scoring_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Scoring_Avg_Fields = {
  __typename?: 'questionnaire_scoring_avg_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Avg_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_scoring". All fields are combined with a logical 'AND'. */
export type Questionnaire_Scoring_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Scoring_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Scoring_Bool_Exp>>;
  casemix_category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_color?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_bound?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_scoring_questionnaire?: InputMaybe<Questionnaires_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upper_bound?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_scoring" */
export enum Questionnaire_Scoring_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireScoringPkey = 'questionnaire_scoring_pkey',
  /** unique or primary key constraint on columns "display_color", "questionnaire_id" */
  QuestionnaireScoringQuestionnaireIdDisplayColorKey = 'questionnaire_scoring_questionnaire_id_display_color_key',
  /** unique or primary key constraint on columns "display_name", "questionnaire_id" */
  QuestionnaireScoringQuestionnaireIdDisplayNameKey = 'questionnaire_scoring_questionnaire_id_display_name_key'
}

/** input type for incrementing numeric columns in table "questionnaire_scoring" */
export type Questionnaire_Scoring_Inc_Input = {
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_scoring" */
export type Questionnaire_Scoring_Insert_Input = {
  casemix_category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_scoring_questionnaire?: InputMaybe<Questionnaires_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Scoring_Max_Fields = {
  __typename?: 'questionnaire_scoring_max_fields';
  casemix_category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_color?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Max_Order_By = {
  casemix_category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_color?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Scoring_Min_Fields = {
  __typename?: 'questionnaire_scoring_min_fields';
  casemix_category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_color?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Min_Order_By = {
  casemix_category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_color?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_scoring" */
export type Questionnaire_Scoring_Mutation_Response = {
  __typename?: 'questionnaire_scoring_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Scoring>;
};

/** on_conflict condition type for table "questionnaire_scoring" */
export type Questionnaire_Scoring_On_Conflict = {
  constraint: Questionnaire_Scoring_Constraint;
  update_columns?: Array<Questionnaire_Scoring_Update_Column>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_scoring". */
export type Questionnaire_Scoring_Order_By = {
  casemix_category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_color?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_scoring_questionnaire?: InputMaybe<Questionnaires_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_scoring */
export type Questionnaire_Scoring_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "questionnaire_scoring" */
export enum Questionnaire_Scoring_Select_Column {
  /** column name */
  CasemixCategory = 'casemix_category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayColor = 'display_color',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LowerBound = 'lower_bound',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpperBound = 'upper_bound'
}

/** input type for updating data in table "questionnaire_scoring" */
export type Questionnaire_Scoring_Set_Input = {
  casemix_category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Scoring_Stddev_Fields = {
  __typename?: 'questionnaire_scoring_stddev_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Stddev_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Scoring_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_scoring_stddev_pop_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Stddev_Pop_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Scoring_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_scoring_stddev_samp_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Stddev_Samp_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_scoring" */
export type Questionnaire_Scoring_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Scoring_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Scoring_Stream_Cursor_Value_Input = {
  casemix_category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_color?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Scoring_Sum_Fields = {
  __typename?: 'questionnaire_scoring_sum_fields';
  lower_bound?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Sum_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_scoring" */
export enum Questionnaire_Scoring_Update_Column {
  /** column name */
  CasemixCategory = 'casemix_category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayColor = 'display_color',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LowerBound = 'lower_bound',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpperBound = 'upper_bound'
}

export type Questionnaire_Scoring_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Scoring_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Scoring_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Scoring_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Scoring_Var_Pop_Fields = {
  __typename?: 'questionnaire_scoring_var_pop_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Var_Pop_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Scoring_Var_Samp_Fields = {
  __typename?: 'questionnaire_scoring_var_samp_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Var_Samp_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Scoring_Variance_Fields = {
  __typename?: 'questionnaire_scoring_variance_fields';
  lower_bound?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_scoring" */
export type Questionnaire_Scoring_Variance_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaire_takes" */
export type Questionnaire_Takes = {
  __typename?: 'questionnaire_takes';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  completion_status?: Maybe<Enum_Completion_Status_Enum>;
  created_at: Scalars['timestamptz']['output'];
  display_score?: Maybe<Scalars['float8']['output']>;
  id: Scalars['Int']['output'];
  is_expired?: Maybe<Scalars['Boolean']['output']>;
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  questionnaireDisplayValues?: Maybe<Vw_Questionnaire_Display_Values>;
  /** An array relationship */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** An aggregate relationship */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  /** An object relationship */
  questionnaire_schedule: Questionnaire_Schedules;
  questionnaire_schedule_id: Scalars['Int']['output'];
  rating_score?: Maybe<Scalars['String']['output']>;
  raw_score?: Maybe<Scalars['Int']['output']>;
  risk_assessed_at?: Maybe<Scalars['timestamp']['output']>;
  scheduled_at: Scalars['timestamp']['output'];
  severity_score?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "questionnaire_takes" */
export type Questionnaire_TakesQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


/** columns and relationships of "questionnaire_takes" */
export type Questionnaire_TakesQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};

/** aggregated selection of "questionnaire_takes" */
export type Questionnaire_Takes_Aggregate = {
  __typename?: 'questionnaire_takes_aggregate';
  aggregate?: Maybe<Questionnaire_Takes_Aggregate_Fields>;
  nodes: Array<Questionnaire_Takes>;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp_Var_Samp>;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Avg = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Bool_And = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Corr = {
  arguments: Questionnaire_Takes_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Max = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Min = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Sum = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Questionnaire_Takes_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "questionnaire_takes" */
export type Questionnaire_Takes_Aggregate_Fields = {
  __typename?: 'questionnaire_takes_aggregate_fields';
  avg?: Maybe<Questionnaire_Takes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaire_Takes_Max_Fields>;
  min?: Maybe<Questionnaire_Takes_Min_Fields>;
  stddev?: Maybe<Questionnaire_Takes_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaire_Takes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaire_Takes_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaire_Takes_Sum_Fields>;
  var_pop?: Maybe<Questionnaire_Takes_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaire_Takes_Var_Samp_Fields>;
  variance?: Maybe<Questionnaire_Takes_Variance_Fields>;
};


/** aggregate fields of "questionnaire_takes" */
export type Questionnaire_Takes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "questionnaire_takes" */
export type Questionnaire_Takes_Aggregate_Order_By = {
  avg?: InputMaybe<Questionnaire_Takes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Questionnaire_Takes_Max_Order_By>;
  min?: InputMaybe<Questionnaire_Takes_Min_Order_By>;
  stddev?: InputMaybe<Questionnaire_Takes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Questionnaire_Takes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Questionnaire_Takes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Questionnaire_Takes_Sum_Order_By>;
  var_pop?: InputMaybe<Questionnaire_Takes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Questionnaire_Takes_Var_Samp_Order_By>;
  variance?: InputMaybe<Questionnaire_Takes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "questionnaire_takes" */
export type Questionnaire_Takes_Arr_Rel_Insert_Input = {
  data: Array<Questionnaire_Takes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Takes_On_Conflict>;
};

/** aggregate avg on columns */
export type Questionnaire_Takes_Avg_Fields = {
  __typename?: 'questionnaire_takes_avg_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Avg_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "questionnaire_takes". All fields are combined with a logical 'AND'. */
export type Questionnaire_Takes_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaire_Takes_Bool_Exp>>;
  _not?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaire_Takes_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completion_status?: InputMaybe<Enum_Completion_Status_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_score?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_expired?: InputMaybe<Boolean_Comparison_Exp>;
  notify_connected_practitioners?: InputMaybe<Timestamp_Comparison_Exp>;
  questionnaireDisplayValues?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
  questionnaire_responses?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
  questionnaire_responses_aggregate?: InputMaybe<Questionnaire_Responses_Aggregate_Bool_Exp>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  questionnaire_schedule_id?: InputMaybe<Int_Comparison_Exp>;
  rating_score?: InputMaybe<String_Comparison_Exp>;
  raw_score?: InputMaybe<Int_Comparison_Exp>;
  risk_assessed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  scheduled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  severity_score?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaire_takes" */
export enum Questionnaire_Takes_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnaireTakesPkey = 'questionnaire_takes_pkey'
}

/** input type for incrementing numeric columns in table "questionnaire_takes" */
export type Questionnaire_Takes_Inc_Input = {
  display_score?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  raw_score?: InputMaybe<Scalars['Int']['input']>;
  severity_score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaire_takes" */
export type Questionnaire_Takes_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completion_status?: InputMaybe<Enum_Completion_Status_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_expired?: InputMaybe<Scalars['Boolean']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  questionnaireDisplayValues?: InputMaybe<Vw_Questionnaire_Display_Values_Obj_Rel_Insert_Input>;
  questionnaire_responses?: InputMaybe<Questionnaire_Responses_Arr_Rel_Insert_Input>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Obj_Rel_Insert_Input>;
  questionnaire_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  rating_score?: InputMaybe<Scalars['String']['input']>;
  raw_score?: InputMaybe<Scalars['Int']['input']>;
  risk_assessed_at?: InputMaybe<Scalars['timestamp']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  severity_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Questionnaire_Takes_Max_Fields = {
  __typename?: 'questionnaire_takes_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Int']['output']>;
  rating_score?: Maybe<Scalars['String']['output']>;
  raw_score?: Maybe<Scalars['Int']['output']>;
  risk_assessed_at?: Maybe<Scalars['timestamp']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  severity_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  rating_score?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  risk_assessed_at?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Questionnaire_Takes_Min_Fields = {
  __typename?: 'questionnaire_takes_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notify_connected_practitioners?: Maybe<Scalars['timestamp']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Int']['output']>;
  rating_score?: Maybe<Scalars['String']['output']>;
  raw_score?: Maybe<Scalars['Int']['output']>;
  risk_assessed_at?: Maybe<Scalars['timestamp']['output']>;
  scheduled_at?: Maybe<Scalars['timestamp']['output']>;
  severity_score?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  rating_score?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  risk_assessed_at?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "questionnaire_takes" */
export type Questionnaire_Takes_Mutation_Response = {
  __typename?: 'questionnaire_takes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaire_Takes>;
};

/** input type for inserting object relation for remote table "questionnaire_takes" */
export type Questionnaire_Takes_Obj_Rel_Insert_Input = {
  data: Questionnaire_Takes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaire_Takes_On_Conflict>;
};

/** on_conflict condition type for table "questionnaire_takes" */
export type Questionnaire_Takes_On_Conflict = {
  constraint: Questionnaire_Takes_Constraint;
  update_columns?: Array<Questionnaire_Takes_Update_Column>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaire_takes". */
export type Questionnaire_Takes_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  completion_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_expired?: InputMaybe<Order_By>;
  notify_connected_practitioners?: InputMaybe<Order_By>;
  questionnaireDisplayValues?: InputMaybe<Vw_Questionnaire_Display_Values_Order_By>;
  questionnaire_responses_aggregate?: InputMaybe<Questionnaire_Responses_Aggregate_Order_By>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  rating_score?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  risk_assessed_at?: InputMaybe<Order_By>;
  scheduled_at?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaire_takes */
export type Questionnaire_Takes_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletionStatus = 'completion_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayScore = 'display_score',
  /** column name */
  Id = 'id',
  /** column name */
  IsExpired = 'is_expired',
  /** column name */
  NotifyConnectedPractitioners = 'notify_connected_practitioners',
  /** column name */
  QuestionnaireScheduleId = 'questionnaire_schedule_id',
  /** column name */
  RatingScore = 'rating_score',
  /** column name */
  RawScore = 'raw_score',
  /** column name */
  RiskAssessedAt = 'risk_assessed_at',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  SeverityScore = 'severity_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "questionnaire_takes_aggregate_bool_exp_avg_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsExpired = 'is_expired'
}

/** select "questionnaire_takes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsExpired = 'is_expired'
}

/** select "questionnaire_takes_aggregate_bool_exp_corr_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_max_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_min_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_sum_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "questionnaire_takes_aggregate_bool_exp_var_samp_arguments_columns" columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Select_Column_Questionnaire_Takes_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** input type for updating data in table "questionnaire_takes" */
export type Questionnaire_Takes_Set_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completion_status?: InputMaybe<Enum_Completion_Status_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_expired?: InputMaybe<Scalars['Boolean']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  questionnaire_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  rating_score?: InputMaybe<Scalars['String']['input']>;
  raw_score?: InputMaybe<Scalars['Int']['input']>;
  risk_assessed_at?: InputMaybe<Scalars['timestamp']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  severity_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaire_Takes_Stddev_Fields = {
  __typename?: 'questionnaire_takes_stddev_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Stddev_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Questionnaire_Takes_Stddev_Pop_Fields = {
  __typename?: 'questionnaire_takes_stddev_pop_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Stddev_Pop_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Questionnaire_Takes_Stddev_Samp_Fields = {
  __typename?: 'questionnaire_takes_stddev_samp_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Stddev_Samp_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "questionnaire_takes" */
export type Questionnaire_Takes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaire_Takes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaire_Takes_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  completion_status?: InputMaybe<Enum_Completion_Status_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_expired?: InputMaybe<Scalars['Boolean']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
  questionnaire_schedule_id?: InputMaybe<Scalars['Int']['input']>;
  rating_score?: InputMaybe<Scalars['String']['input']>;
  raw_score?: InputMaybe<Scalars['Int']['input']>;
  risk_assessed_at?: InputMaybe<Scalars['timestamp']['input']>;
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
  severity_score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Questionnaire_Takes_Sum_Fields = {
  __typename?: 'questionnaire_takes_sum_fields';
  display_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Int']['output']>;
  raw_score?: Maybe<Scalars['Int']['output']>;
  severity_score?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Sum_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** update columns of table "questionnaire_takes" */
export enum Questionnaire_Takes_Update_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletionStatus = 'completion_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayScore = 'display_score',
  /** column name */
  Id = 'id',
  /** column name */
  IsExpired = 'is_expired',
  /** column name */
  NotifyConnectedPractitioners = 'notify_connected_practitioners',
  /** column name */
  QuestionnaireScheduleId = 'questionnaire_schedule_id',
  /** column name */
  RatingScore = 'rating_score',
  /** column name */
  RawScore = 'raw_score',
  /** column name */
  RiskAssessedAt = 'risk_assessed_at',
  /** column name */
  ScheduledAt = 'scheduled_at',
  /** column name */
  SeverityScore = 'severity_score',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Questionnaire_Takes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaire_Takes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaire_Takes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaire_Takes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaire_Takes_Var_Pop_Fields = {
  __typename?: 'questionnaire_takes_var_pop_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Var_Pop_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Questionnaire_Takes_Var_Samp_Fields = {
  __typename?: 'questionnaire_takes_var_samp_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Var_Samp_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Questionnaire_Takes_Variance_Fields = {
  __typename?: 'questionnaire_takes_variance_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedule_id?: Maybe<Scalars['Float']['output']>;
  raw_score?: Maybe<Scalars['Float']['output']>;
  severity_score?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "questionnaire_takes" */
export type Questionnaire_Takes_Variance_Order_By = {
  display_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_schedule_id?: InputMaybe<Order_By>;
  raw_score?: InputMaybe<Order_By>;
  severity_score?: InputMaybe<Order_By>;
};

/** columns and relationships of "questionnaires" */
export type Questionnaires = {
  __typename?: 'questionnaires';
  client_display_name: Scalars['String']['output'];
  contains_risk_questions?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  days_to_expiration?: Maybe<Scalars['Int']['output']>;
  display_score_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  minutes_to_expiration: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  public: Scalars['Boolean']['output'];
  /** An array relationship */
  questionnaire_items: Array<Questionnaire_Items>;
  /** An aggregate relationship */
  questionnaire_items_aggregate: Questionnaire_Items_Aggregate;
  /** An array relationship */
  questionnaire_schedules: Array<Questionnaire_Schedules>;
  /** An aggregate relationship */
  questionnaire_schedules_aggregate: Questionnaire_Schedules_Aggregate;
  /** An object relationship */
  questionnaires_organization?: Maybe<Organizations>;
  /** An array relationship */
  questionnaires_questionnaire_risk_alert_contacts: Array<Questionnaire_Risk_Alert_Contacts>;
  /** An aggregate relationship */
  questionnaires_questionnaire_risk_alert_contacts_aggregate: Questionnaire_Risk_Alert_Contacts_Aggregate;
  /** An array relationship */
  questionnaires_questionnaire_scorings: Array<Questionnaire_Scoring>;
  /** An aggregate relationship */
  questionnaires_questionnaire_scorings_aggregate: Questionnaire_Scoring_Aggregate;
  resource_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaire_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaire_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaire_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_Risk_Alert_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_Risk_Alert_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_ScoringsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


/** columns and relationships of "questionnaires" */
export type QuestionnairesQuestionnaires_Questionnaire_Scorings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};

/** aggregated selection of "questionnaires" */
export type Questionnaires_Aggregate = {
  __typename?: 'questionnaires_aggregate';
  aggregate?: Maybe<Questionnaires_Aggregate_Fields>;
  nodes: Array<Questionnaires>;
};

/** aggregate fields of "questionnaires" */
export type Questionnaires_Aggregate_Fields = {
  __typename?: 'questionnaires_aggregate_fields';
  avg?: Maybe<Questionnaires_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Questionnaires_Max_Fields>;
  min?: Maybe<Questionnaires_Min_Fields>;
  stddev?: Maybe<Questionnaires_Stddev_Fields>;
  stddev_pop?: Maybe<Questionnaires_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Questionnaires_Stddev_Samp_Fields>;
  sum?: Maybe<Questionnaires_Sum_Fields>;
  var_pop?: Maybe<Questionnaires_Var_Pop_Fields>;
  var_samp?: Maybe<Questionnaires_Var_Samp_Fields>;
  variance?: Maybe<Questionnaires_Variance_Fields>;
};


/** aggregate fields of "questionnaires" */
export type Questionnaires_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Questionnaires_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Questionnaires_Avg_Fields = {
  __typename?: 'questionnaires_avg_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "questionnaires". All fields are combined with a logical 'AND'. */
export type Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Questionnaires_Bool_Exp>>;
  client_display_name?: InputMaybe<String_Comparison_Exp>;
  contains_risk_questions?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  days_to_expiration?: InputMaybe<Int_Comparison_Exp>;
  display_score_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  minutes_to_expiration?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_org_id?: InputMaybe<Int_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  questionnaire_items?: InputMaybe<Questionnaire_Items_Bool_Exp>;
  questionnaire_items_aggregate?: InputMaybe<Questionnaire_Items_Aggregate_Bool_Exp>;
  questionnaire_schedules?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  questionnaire_schedules_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp>;
  questionnaires_organization?: InputMaybe<Organizations_Bool_Exp>;
  questionnaires_questionnaire_risk_alert_contacts?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
  questionnaires_questionnaire_risk_alert_contacts_aggregate?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Aggregate_Bool_Exp>;
  questionnaires_questionnaire_scorings?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
  questionnaires_questionnaire_scorings_aggregate?: InputMaybe<Questionnaire_Scoring_Aggregate_Bool_Exp>;
  resource_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "questionnaires" */
export enum Questionnaires_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuestionnairesPkey = 'questionnaires_pkey'
}

/** input type for incrementing numeric columns in table "questionnaires" */
export type Questionnaires_Inc_Input = {
  days_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "questionnaires" */
export type Questionnaires_Insert_Input = {
  client_display_name?: InputMaybe<Scalars['String']['input']>;
  contains_risk_questions?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  days_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaire_items?: InputMaybe<Questionnaire_Items_Arr_Rel_Insert_Input>;
  questionnaire_schedules?: InputMaybe<Questionnaire_Schedules_Arr_Rel_Insert_Input>;
  questionnaires_organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  questionnaires_questionnaire_risk_alert_contacts?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Arr_Rel_Insert_Input>;
  questionnaires_questionnaire_scorings?: InputMaybe<Questionnaire_Scoring_Arr_Rel_Insert_Input>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Questionnaires_Max_Fields = {
  __typename?: 'questionnaires_max_fields';
  client_display_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  days_to_expiration?: Maybe<Scalars['Int']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Questionnaires_Min_Fields = {
  __typename?: 'questionnaires_min_fields';
  client_display_name?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  days_to_expiration?: Maybe<Scalars['Int']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "questionnaires" */
export type Questionnaires_Mutation_Response = {
  __typename?: 'questionnaires_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Questionnaires>;
};

/** input type for inserting object relation for remote table "questionnaires" */
export type Questionnaires_Obj_Rel_Insert_Input = {
  data: Questionnaires_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Questionnaires_On_Conflict>;
};

/** on_conflict condition type for table "questionnaires" */
export type Questionnaires_On_Conflict = {
  constraint: Questionnaires_Constraint;
  update_columns?: Array<Questionnaires_Update_Column>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};

/** Ordering options when selecting data from "questionnaires". */
export type Questionnaires_Order_By = {
  client_display_name?: InputMaybe<Order_By>;
  contains_risk_questions?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  days_to_expiration?: InputMaybe<Order_By>;
  display_score_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  minutes_to_expiration?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  questionnaire_items_aggregate?: InputMaybe<Questionnaire_Items_Aggregate_Order_By>;
  questionnaire_schedules_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Order_By>;
  questionnaires_organization?: InputMaybe<Organizations_Order_By>;
  questionnaires_questionnaire_risk_alert_contacts_aggregate?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Aggregate_Order_By>;
  questionnaires_questionnaire_scorings_aggregate?: InputMaybe<Questionnaire_Scoring_Aggregate_Order_By>;
  resource_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: questionnaires */
export type Questionnaires_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "questionnaires" */
export enum Questionnaires_Select_Column {
  /** column name */
  ClientDisplayName = 'client_display_name',
  /** column name */
  ContainsRiskQuestions = 'contains_risk_questions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysToExpiration = 'days_to_expiration',
  /** column name */
  DisplayScoreType = 'display_score_type',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "questionnaires" */
export type Questionnaires_Set_Input = {
  client_display_name?: InputMaybe<Scalars['String']['input']>;
  contains_risk_questions?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  days_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Questionnaires_Stddev_Fields = {
  __typename?: 'questionnaires_stddev_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Questionnaires_Stddev_Pop_Fields = {
  __typename?: 'questionnaires_stddev_pop_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Questionnaires_Stddev_Samp_Fields = {
  __typename?: 'questionnaires_stddev_samp_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "questionnaires" */
export type Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Questionnaires_Stream_Cursor_Value_Input = {
  client_display_name?: InputMaybe<Scalars['String']['input']>;
  contains_risk_questions?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  days_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Questionnaires_Sum_Fields = {
  __typename?: 'questionnaires_sum_fields';
  days_to_expiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  resource_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "questionnaires" */
export enum Questionnaires_Update_Column {
  /** column name */
  ClientDisplayName = 'client_display_name',
  /** column name */
  ContainsRiskQuestions = 'contains_risk_questions',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DaysToExpiration = 'days_to_expiration',
  /** column name */
  DisplayScoreType = 'display_score_type',
  /** column name */
  Id = 'id',
  /** column name */
  MinutesToExpiration = 'minutes_to_expiration',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Questionnaires_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Questionnaires_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Questionnaires_Set_Input>;
  /** filter the rows which have to be updated */
  where: Questionnaires_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Questionnaires_Var_Pop_Fields = {
  __typename?: 'questionnaires_var_pop_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Questionnaires_Var_Samp_Fields = {
  __typename?: 'questionnaires_var_samp_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Questionnaires_Variance_Fields = {
  __typename?: 'questionnaires_variance_fields';
  days_to_expiration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minutes_to_expiration?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
  resource_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits = {
  __typename?: 'relapse_prevention_place_visits';
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  place_id: Scalars['uuid']['output'];
  /** An object relationship */
  relapse_prevention_place: Relapse_Prevention_Places;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Aggregate = {
  __typename?: 'relapse_prevention_place_visits_aggregate';
  aggregate?: Maybe<Relapse_Prevention_Place_Visits_Aggregate_Fields>;
  nodes: Array<Relapse_Prevention_Place_Visits>;
};

/** aggregate fields of "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Aggregate_Fields = {
  __typename?: 'relapse_prevention_place_visits_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Relapse_Prevention_Place_Visits_Max_Fields>;
  min?: Maybe<Relapse_Prevention_Place_Visits_Min_Fields>;
};


/** aggregate fields of "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "relapse_prevention_place_visits". All fields are combined with a logical 'AND'. */
export type Relapse_Prevention_Place_Visits_Bool_Exp = {
  _and?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Bool_Exp>>;
  _not?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
  _or?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  relapse_prevention_place?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "relapse_prevention_place_visits" */
export enum Relapse_Prevention_Place_Visits_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelapsePreventionPlaceVisitsPkey = 'relapse_prevention_place_visits_pkey'
}

/** input type for inserting data into table "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  relapse_prevention_place?: InputMaybe<Relapse_Prevention_Places_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Relapse_Prevention_Place_Visits_Max_Fields = {
  __typename?: 'relapse_prevention_place_visits_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Relapse_Prevention_Place_Visits_Min_Fields = {
  __typename?: 'relapse_prevention_place_visits_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Mutation_Response = {
  __typename?: 'relapse_prevention_place_visits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Relapse_Prevention_Place_Visits>;
};

/** on_conflict condition type for table "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_On_Conflict = {
  constraint: Relapse_Prevention_Place_Visits_Constraint;
  update_columns?: Array<Relapse_Prevention_Place_Visits_Update_Column>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};

/** Ordering options when selecting data from "relapse_prevention_place_visits". */
export type Relapse_Prevention_Place_Visits_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  relapse_prevention_place?: InputMaybe<Relapse_Prevention_Places_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relapse_prevention_place_visits */
export type Relapse_Prevention_Place_Visits_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "relapse_prevention_place_visits" */
export enum Relapse_Prevention_Place_Visits_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "relapse_prevention_place_visits" */
export type Relapse_Prevention_Place_Visits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relapse_Prevention_Place_Visits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relapse_Prevention_Place_Visits_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "relapse_prevention_place_visits" */
export enum Relapse_Prevention_Place_Visits_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UserId = 'user_id'
}

export type Relapse_Prevention_Place_Visits_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relapse_Prevention_Place_Visits_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relapse_Prevention_Place_Visits_Bool_Exp;
};

/** columns and relationships of "relapse_prevention_places" */
export type Relapse_Prevention_Places = {
  __typename?: 'relapse_prevention_places';
  address?: Maybe<Scalars['String']['output']>;
  alert_name?: Maybe<Scalars['String']['output']>;
  business_days?: Maybe<Scalars['String']['output']>;
  business_hours_end?: Maybe<Scalars['time']['output']>;
  business_hours_start?: Maybe<Scalars['time']['output']>;
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  media_items?: Maybe<Scalars['String']['output']>;
  place_type: Scalars['String']['output'];
  radius_meters: Scalars['Int']['output'];
  /** An object relationship */
  safety_plan_response_option: Safety_Plan_Response_Options;
  safety_plan_response_option_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "relapse_prevention_places" */
export type Relapse_Prevention_Places_Aggregate = {
  __typename?: 'relapse_prevention_places_aggregate';
  aggregate?: Maybe<Relapse_Prevention_Places_Aggregate_Fields>;
  nodes: Array<Relapse_Prevention_Places>;
};

/** aggregate fields of "relapse_prevention_places" */
export type Relapse_Prevention_Places_Aggregate_Fields = {
  __typename?: 'relapse_prevention_places_aggregate_fields';
  avg?: Maybe<Relapse_Prevention_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Relapse_Prevention_Places_Max_Fields>;
  min?: Maybe<Relapse_Prevention_Places_Min_Fields>;
  stddev?: Maybe<Relapse_Prevention_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Relapse_Prevention_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Relapse_Prevention_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Relapse_Prevention_Places_Sum_Fields>;
  var_pop?: Maybe<Relapse_Prevention_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Relapse_Prevention_Places_Var_Samp_Fields>;
  variance?: Maybe<Relapse_Prevention_Places_Variance_Fields>;
};


/** aggregate fields of "relapse_prevention_places" */
export type Relapse_Prevention_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relapse_Prevention_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Relapse_Prevention_Places_Avg_Fields = {
  __typename?: 'relapse_prevention_places_avg_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "relapse_prevention_places". All fields are combined with a logical 'AND'. */
export type Relapse_Prevention_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Relapse_Prevention_Places_Bool_Exp>>;
  _not?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Relapse_Prevention_Places_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  alert_name?: InputMaybe<String_Comparison_Exp>;
  business_days?: InputMaybe<String_Comparison_Exp>;
  business_hours_end?: InputMaybe<Time_Comparison_Exp>;
  business_hours_start?: InputMaybe<Time_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latitude?: InputMaybe<String_Comparison_Exp>;
  longitude?: InputMaybe<String_Comparison_Exp>;
  media_items?: InputMaybe<String_Comparison_Exp>;
  place_type?: InputMaybe<String_Comparison_Exp>;
  radius_meters?: InputMaybe<Int_Comparison_Exp>;
  safety_plan_response_option?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  safety_plan_response_option_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "relapse_prevention_places" */
export enum Relapse_Prevention_Places_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelapsePreventionPlacesPkey = 'relapse_prevention_places_pkey'
}

/** input type for incrementing numeric columns in table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Inc_Input = {
  radius_meters?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  alert_name?: InputMaybe<Scalars['String']['input']>;
  business_days?: InputMaybe<Scalars['String']['input']>;
  business_hours_end?: InputMaybe<Scalars['time']['input']>;
  business_hours_start?: InputMaybe<Scalars['time']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  media_items?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  radius_meters?: InputMaybe<Scalars['Int']['input']>;
  safety_plan_response_option?: InputMaybe<Safety_Plan_Response_Options_Obj_Rel_Insert_Input>;
  safety_plan_response_option_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Relapse_Prevention_Places_Max_Fields = {
  __typename?: 'relapse_prevention_places_max_fields';
  address?: Maybe<Scalars['String']['output']>;
  alert_name?: Maybe<Scalars['String']['output']>;
  business_days?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  media_items?: Maybe<Scalars['String']['output']>;
  place_type?: Maybe<Scalars['String']['output']>;
  radius_meters?: Maybe<Scalars['Int']['output']>;
  safety_plan_response_option_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Relapse_Prevention_Places_Min_Fields = {
  __typename?: 'relapse_prevention_places_min_fields';
  address?: Maybe<Scalars['String']['output']>;
  alert_name?: Maybe<Scalars['String']['output']>;
  business_days?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  media_items?: Maybe<Scalars['String']['output']>;
  place_type?: Maybe<Scalars['String']['output']>;
  radius_meters?: Maybe<Scalars['Int']['output']>;
  safety_plan_response_option_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Mutation_Response = {
  __typename?: 'relapse_prevention_places_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Relapse_Prevention_Places>;
};

/** input type for inserting object relation for remote table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Obj_Rel_Insert_Input = {
  data: Relapse_Prevention_Places_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Relapse_Prevention_Places_On_Conflict>;
};

/** on_conflict condition type for table "relapse_prevention_places" */
export type Relapse_Prevention_Places_On_Conflict = {
  constraint: Relapse_Prevention_Places_Constraint;
  update_columns?: Array<Relapse_Prevention_Places_Update_Column>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};

/** Ordering options when selecting data from "relapse_prevention_places". */
export type Relapse_Prevention_Places_Order_By = {
  address?: InputMaybe<Order_By>;
  alert_name?: InputMaybe<Order_By>;
  business_days?: InputMaybe<Order_By>;
  business_hours_end?: InputMaybe<Order_By>;
  business_hours_start?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
  media_items?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  radius_meters?: InputMaybe<Order_By>;
  safety_plan_response_option?: InputMaybe<Safety_Plan_Response_Options_Order_By>;
  safety_plan_response_option_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relapse_prevention_places */
export type Relapse_Prevention_Places_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "relapse_prevention_places" */
export enum Relapse_Prevention_Places_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AlertName = 'alert_name',
  /** column name */
  BusinessDays = 'business_days',
  /** column name */
  BusinessHoursEnd = 'business_hours_end',
  /** column name */
  BusinessHoursStart = 'business_hours_start',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MediaItems = 'media_items',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  RadiusMeters = 'radius_meters',
  /** column name */
  SafetyPlanResponseOptionId = 'safety_plan_response_option_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Set_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  alert_name?: InputMaybe<Scalars['String']['input']>;
  business_days?: InputMaybe<Scalars['String']['input']>;
  business_hours_end?: InputMaybe<Scalars['time']['input']>;
  business_hours_start?: InputMaybe<Scalars['time']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  media_items?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  radius_meters?: InputMaybe<Scalars['Int']['input']>;
  safety_plan_response_option_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Relapse_Prevention_Places_Stddev_Fields = {
  __typename?: 'relapse_prevention_places_stddev_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Relapse_Prevention_Places_Stddev_Pop_Fields = {
  __typename?: 'relapse_prevention_places_stddev_pop_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Relapse_Prevention_Places_Stddev_Samp_Fields = {
  __typename?: 'relapse_prevention_places_stddev_samp_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "relapse_prevention_places" */
export type Relapse_Prevention_Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relapse_Prevention_Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relapse_Prevention_Places_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  alert_name?: InputMaybe<Scalars['String']['input']>;
  business_days?: InputMaybe<Scalars['String']['input']>;
  business_hours_end?: InputMaybe<Scalars['time']['input']>;
  business_hours_start?: InputMaybe<Scalars['time']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  media_items?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  radius_meters?: InputMaybe<Scalars['Int']['input']>;
  safety_plan_response_option_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Relapse_Prevention_Places_Sum_Fields = {
  __typename?: 'relapse_prevention_places_sum_fields';
  radius_meters?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "relapse_prevention_places" */
export enum Relapse_Prevention_Places_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AlertName = 'alert_name',
  /** column name */
  BusinessDays = 'business_days',
  /** column name */
  BusinessHoursEnd = 'business_hours_end',
  /** column name */
  BusinessHoursStart = 'business_hours_start',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude',
  /** column name */
  MediaItems = 'media_items',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  RadiusMeters = 'radius_meters',
  /** column name */
  SafetyPlanResponseOptionId = 'safety_plan_response_option_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Relapse_Prevention_Places_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relapse_Prevention_Places_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relapse_Prevention_Places_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relapse_Prevention_Places_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Relapse_Prevention_Places_Var_Pop_Fields = {
  __typename?: 'relapse_prevention_places_var_pop_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Relapse_Prevention_Places_Var_Samp_Fields = {
  __typename?: 'relapse_prevention_places_var_samp_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Relapse_Prevention_Places_Variance_Fields = {
  __typename?: 'relapse_prevention_places_variance_fields';
  radius_meters?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "resources" */
export type Resources = {
  __typename?: 'resources';
  author?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  content_type: Enum_Insight_Content_Type_Enum;
  created_by?: Maybe<Scalars['uuid']['output']>;
  created_on: Scalars['timestamp']['output'];
  header_image?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  insight_plan_articles: Array<Insight_Plan_Article>;
  /** An aggregate relationship */
  insight_plan_articles_aggregate: Insight_Plan_Article_Aggregate;
  /** An array relationship */
  org_resource_access: Array<Resources_Orgs>;
  /** An aggregate relationship */
  org_resource_access_aggregate: Resources_Orgs_Aggregate;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  public: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_on: Scalars['timestamp']['output'];
  /** An array relationship */
  user_organization: Array<Vw_User_Organization>;
  /** An aggregate relationship */
  user_organization_aggregate: Vw_User_Organization_Aggregate;
};


/** columns and relationships of "resources" */
export type ResourcesInsight_Plan_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


/** columns and relationships of "resources" */
export type ResourcesInsight_Plan_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


/** columns and relationships of "resources" */
export type ResourcesOrg_Resource_AccessArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


/** columns and relationships of "resources" */
export type ResourcesOrg_Resource_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


/** columns and relationships of "resources" */
export type ResourcesUser_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "resources" */
export type ResourcesUser_Organization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};

/** aggregated selection of "resources" */
export type Resources_Aggregate = {
  __typename?: 'resources_aggregate';
  aggregate?: Maybe<Resources_Aggregate_Fields>;
  nodes: Array<Resources>;
};

/** aggregate fields of "resources" */
export type Resources_Aggregate_Fields = {
  __typename?: 'resources_aggregate_fields';
  avg?: Maybe<Resources_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Resources_Max_Fields>;
  min?: Maybe<Resources_Min_Fields>;
  stddev?: Maybe<Resources_Stddev_Fields>;
  stddev_pop?: Maybe<Resources_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resources_Stddev_Samp_Fields>;
  sum?: Maybe<Resources_Sum_Fields>;
  var_pop?: Maybe<Resources_Var_Pop_Fields>;
  var_samp?: Maybe<Resources_Var_Samp_Fields>;
  variance?: Maybe<Resources_Variance_Fields>;
};


/** aggregate fields of "resources" */
export type Resources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resources_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Resources_Avg_Fields = {
  __typename?: 'resources_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "resources". All fields are combined with a logical 'AND'. */
export type Resources_Bool_Exp = {
  _and?: InputMaybe<Array<Resources_Bool_Exp>>;
  _not?: InputMaybe<Resources_Bool_Exp>;
  _or?: InputMaybe<Array<Resources_Bool_Exp>>;
  author?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_on?: InputMaybe<Timestamp_Comparison_Exp>;
  header_image?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insight_plan_articles?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
  insight_plan_articles_aggregate?: InputMaybe<Insight_Plan_Article_Aggregate_Bool_Exp>;
  org_resource_access?: InputMaybe<Resources_Orgs_Bool_Exp>;
  org_resource_access_aggregate?: InputMaybe<Resources_Orgs_Aggregate_Bool_Exp>;
  owner_org_id?: InputMaybe<Int_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_on?: InputMaybe<Timestamp_Comparison_Exp>;
  user_organization?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  user_organization_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "resources" */
export enum Resources_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResourcesPkey = 'resources_pkey',
  /** unique or primary key constraint on columns "title", "owner_org_id" */
  ResourcesTitleOwnerOrgIdKey = 'resources_title_owner_org_id_key'
}

/** input type for incrementing numeric columns in table "resources" */
export type Resources_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "resources" */
export type Resources_Insert_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  header_image?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_plan_articles?: InputMaybe<Insight_Plan_Article_Arr_Rel_Insert_Input>;
  org_resource_access?: InputMaybe<Resources_Orgs_Arr_Rel_Insert_Input>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['timestamp']['input']>;
  user_organization?: InputMaybe<Vw_User_Organization_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Resources_Max_Fields = {
  __typename?: 'resources_max_fields';
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  created_on?: Maybe<Scalars['timestamp']['output']>;
  header_image?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Resources_Min_Fields = {
  __typename?: 'resources_min_fields';
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  created_on?: Maybe<Scalars['timestamp']['output']>;
  header_image?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_on?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "resources" */
export type Resources_Mutation_Response = {
  __typename?: 'resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Resources>;
};

/** input type for inserting object relation for remote table "resources" */
export type Resources_Obj_Rel_Insert_Input = {
  data: Resources_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Resources_On_Conflict>;
};

/** on_conflict condition type for table "resources" */
export type Resources_On_Conflict = {
  constraint: Resources_Constraint;
  update_columns?: Array<Resources_Update_Column>;
  where?: InputMaybe<Resources_Bool_Exp>;
};

/** Ordering options when selecting data from "resources". */
export type Resources_Order_By = {
  author?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_on?: InputMaybe<Order_By>;
  header_image?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_plan_articles_aggregate?: InputMaybe<Insight_Plan_Article_Aggregate_Order_By>;
  org_resource_access_aggregate?: InputMaybe<Resources_Orgs_Aggregate_Order_By>;
  owner_org_id?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_on?: InputMaybe<Order_By>;
  user_organization_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Order_By>;
};

/** columns and relationships of "resources_orgs" */
export type Resources_Orgs = {
  __typename?: 'resources_orgs';
  org_id: Scalars['Int']['output'];
  /** An object relationship */
  organization: Organizations;
  /** An object relationship */
  resource: Resources;
  resources_id: Scalars['Int']['output'];
  /** An array relationship */
  user_access: Array<Vw_User_Organization>;
  /** An aggregate relationship */
  user_access_aggregate: Vw_User_Organization_Aggregate;
};


/** columns and relationships of "resources_orgs" */
export type Resources_OrgsUser_AccessArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "resources_orgs" */
export type Resources_OrgsUser_Access_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};

/** aggregated selection of "resources_orgs" */
export type Resources_Orgs_Aggregate = {
  __typename?: 'resources_orgs_aggregate';
  aggregate?: Maybe<Resources_Orgs_Aggregate_Fields>;
  nodes: Array<Resources_Orgs>;
};

export type Resources_Orgs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Resources_Orgs_Aggregate_Bool_Exp_Count>;
};

export type Resources_Orgs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Resources_Orgs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "resources_orgs" */
export type Resources_Orgs_Aggregate_Fields = {
  __typename?: 'resources_orgs_aggregate_fields';
  avg?: Maybe<Resources_Orgs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Resources_Orgs_Max_Fields>;
  min?: Maybe<Resources_Orgs_Min_Fields>;
  stddev?: Maybe<Resources_Orgs_Stddev_Fields>;
  stddev_pop?: Maybe<Resources_Orgs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resources_Orgs_Stddev_Samp_Fields>;
  sum?: Maybe<Resources_Orgs_Sum_Fields>;
  var_pop?: Maybe<Resources_Orgs_Var_Pop_Fields>;
  var_samp?: Maybe<Resources_Orgs_Var_Samp_Fields>;
  variance?: Maybe<Resources_Orgs_Variance_Fields>;
};


/** aggregate fields of "resources_orgs" */
export type Resources_Orgs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "resources_orgs" */
export type Resources_Orgs_Aggregate_Order_By = {
  avg?: InputMaybe<Resources_Orgs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Resources_Orgs_Max_Order_By>;
  min?: InputMaybe<Resources_Orgs_Min_Order_By>;
  stddev?: InputMaybe<Resources_Orgs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Resources_Orgs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Resources_Orgs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Resources_Orgs_Sum_Order_By>;
  var_pop?: InputMaybe<Resources_Orgs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Resources_Orgs_Var_Samp_Order_By>;
  variance?: InputMaybe<Resources_Orgs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "resources_orgs" */
export type Resources_Orgs_Arr_Rel_Insert_Input = {
  data: Array<Resources_Orgs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Resources_Orgs_On_Conflict>;
};

/** aggregate avg on columns */
export type Resources_Orgs_Avg_Fields = {
  __typename?: 'resources_orgs_avg_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "resources_orgs" */
export type Resources_Orgs_Avg_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "resources_orgs". All fields are combined with a logical 'AND'. */
export type Resources_Orgs_Bool_Exp = {
  _and?: InputMaybe<Array<Resources_Orgs_Bool_Exp>>;
  _not?: InputMaybe<Resources_Orgs_Bool_Exp>;
  _or?: InputMaybe<Array<Resources_Orgs_Bool_Exp>>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  resource?: InputMaybe<Resources_Bool_Exp>;
  resources_id?: InputMaybe<Int_Comparison_Exp>;
  user_access?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  user_access_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "resources_orgs" */
export enum Resources_Orgs_Constraint {
  /** unique or primary key constraint on columns "resources_id", "org_id" */
  ResourcesOrgsPkey = 'resources_orgs_pkey'
}

/** input type for incrementing numeric columns in table "resources_orgs" */
export type Resources_Orgs_Inc_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "resources_orgs" */
export type Resources_Orgs_Insert_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  resource?: InputMaybe<Resources_Obj_Rel_Insert_Input>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
  user_access?: InputMaybe<Vw_User_Organization_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Resources_Orgs_Max_Fields = {
  __typename?: 'resources_orgs_max_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "resources_orgs" */
export type Resources_Orgs_Max_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Resources_Orgs_Min_Fields = {
  __typename?: 'resources_orgs_min_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "resources_orgs" */
export type Resources_Orgs_Min_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "resources_orgs" */
export type Resources_Orgs_Mutation_Response = {
  __typename?: 'resources_orgs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Resources_Orgs>;
};

/** on_conflict condition type for table "resources_orgs" */
export type Resources_Orgs_On_Conflict = {
  constraint: Resources_Orgs_Constraint;
  update_columns?: Array<Resources_Orgs_Update_Column>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};

/** Ordering options when selecting data from "resources_orgs". */
export type Resources_Orgs_Order_By = {
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  resource?: InputMaybe<Resources_Order_By>;
  resources_id?: InputMaybe<Order_By>;
  user_access_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Order_By>;
};

/** primary key columns input for table: resources_orgs */
export type Resources_Orgs_Pk_Columns_Input = {
  org_id: Scalars['Int']['input'];
  resources_id: Scalars['Int']['input'];
};

/** select columns of table "resources_orgs" */
export enum Resources_Orgs_Select_Column {
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ResourcesId = 'resources_id'
}

/** input type for updating data in table "resources_orgs" */
export type Resources_Orgs_Set_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Resources_Orgs_Stddev_Fields = {
  __typename?: 'resources_orgs_stddev_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "resources_orgs" */
export type Resources_Orgs_Stddev_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Resources_Orgs_Stddev_Pop_Fields = {
  __typename?: 'resources_orgs_stddev_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "resources_orgs" */
export type Resources_Orgs_Stddev_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Resources_Orgs_Stddev_Samp_Fields = {
  __typename?: 'resources_orgs_stddev_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "resources_orgs" */
export type Resources_Orgs_Stddev_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "resources_orgs" */
export type Resources_Orgs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resources_Orgs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resources_Orgs_Stream_Cursor_Value_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  resources_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Resources_Orgs_Sum_Fields = {
  __typename?: 'resources_orgs_sum_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
  resources_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "resources_orgs" */
export type Resources_Orgs_Sum_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** update columns of table "resources_orgs" */
export enum Resources_Orgs_Update_Column {
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ResourcesId = 'resources_id'
}

export type Resources_Orgs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Resources_Orgs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resources_Orgs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resources_Orgs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resources_Orgs_Var_Pop_Fields = {
  __typename?: 'resources_orgs_var_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "resources_orgs" */
export type Resources_Orgs_Var_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Resources_Orgs_Var_Samp_Fields = {
  __typename?: 'resources_orgs_var_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "resources_orgs" */
export type Resources_Orgs_Var_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Resources_Orgs_Variance_Fields = {
  __typename?: 'resources_orgs_variance_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
  resources_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "resources_orgs" */
export type Resources_Orgs_Variance_Order_By = {
  org_id?: InputMaybe<Order_By>;
  resources_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resources */
export type Resources_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "resources" */
export enum Resources_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Content = 'content',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  HeaderImage = 'header_image',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedOn = 'updated_on'
}

/** input type for updating data in table "resources" */
export type Resources_Set_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  header_image?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Resources_Stddev_Fields = {
  __typename?: 'resources_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Resources_Stddev_Pop_Fields = {
  __typename?: 'resources_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Resources_Stddev_Samp_Fields = {
  __typename?: 'resources_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "resources" */
export type Resources_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resources_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resources_Stream_Cursor_Value_Input = {
  author?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  header_image?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_on?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Resources_Sum_Fields = {
  __typename?: 'resources_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  owner_org_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "resources" */
export enum Resources_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Content = 'content',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  HeaderImage = 'header_image',
  /** column name */
  Id = 'id',
  /** column name */
  OwnerOrgId = 'owner_org_id',
  /** column name */
  Public = 'public',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedOn = 'updated_on'
}

export type Resources_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Resources_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resources_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resources_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resources_Var_Pop_Fields = {
  __typename?: 'resources_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Resources_Var_Samp_Fields = {
  __typename?: 'resources_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Resources_Variance_Fields = {
  __typename?: 'resources_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  owner_org_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risk_alerts_log" */
export type Risk_Alerts_Log = {
  __typename?: 'risk_alerts_log';
  all_alerts_sent_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  questionnaire_take_id: Scalars['Int']['output'];
  /** An object relationship */
  risk_alerts_log_questionnaire_take: Questionnaire_Takes;
  /** An array relationship */
  risk_alerts_log_risk_alerts_recipients_logs: Array<Risk_Alerts_Recipients_Log>;
  /** An aggregate relationship */
  risk_alerts_log_risk_alerts_recipients_logs_aggregate: Risk_Alerts_Recipients_Log_Aggregate;
};


/** columns and relationships of "risk_alerts_log" */
export type Risk_Alerts_LogRisk_Alerts_Log_Risk_Alerts_Recipients_LogsArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


/** columns and relationships of "risk_alerts_log" */
export type Risk_Alerts_LogRisk_Alerts_Log_Risk_Alerts_Recipients_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};

/** aggregated selection of "risk_alerts_log" */
export type Risk_Alerts_Log_Aggregate = {
  __typename?: 'risk_alerts_log_aggregate';
  aggregate?: Maybe<Risk_Alerts_Log_Aggregate_Fields>;
  nodes: Array<Risk_Alerts_Log>;
};

/** aggregate fields of "risk_alerts_log" */
export type Risk_Alerts_Log_Aggregate_Fields = {
  __typename?: 'risk_alerts_log_aggregate_fields';
  avg?: Maybe<Risk_Alerts_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Alerts_Log_Max_Fields>;
  min?: Maybe<Risk_Alerts_Log_Min_Fields>;
  stddev?: Maybe<Risk_Alerts_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Risk_Alerts_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Risk_Alerts_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Risk_Alerts_Log_Sum_Fields>;
  var_pop?: Maybe<Risk_Alerts_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Risk_Alerts_Log_Var_Samp_Fields>;
  variance?: Maybe<Risk_Alerts_Log_Variance_Fields>;
};


/** aggregate fields of "risk_alerts_log" */
export type Risk_Alerts_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Alerts_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Risk_Alerts_Log_Avg_Fields = {
  __typename?: 'risk_alerts_log_avg_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "risk_alerts_log". All fields are combined with a logical 'AND'. */
export type Risk_Alerts_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Alerts_Log_Bool_Exp>>;
  _not?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Alerts_Log_Bool_Exp>>;
  all_alerts_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaire_take_id?: InputMaybe<Int_Comparison_Exp>;
  risk_alerts_log_questionnaire_take?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  risk_alerts_log_risk_alerts_recipients_logs?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
  risk_alerts_log_risk_alerts_recipients_logs_aggregate?: InputMaybe<Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "risk_alerts_log" */
export enum Risk_Alerts_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskAlertsLogPkey = 'risk_alerts_log_pkey',
  /** unique or primary key constraint on columns "questionnaire_take_id" */
  RiskAlertsLogQuestionnaireTakeIdKey = 'risk_alerts_log_questionnaire_take_id_key'
}

/** input type for incrementing numeric columns in table "risk_alerts_log" */
export type Risk_Alerts_Log_Inc_Input = {
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risk_alerts_log" */
export type Risk_Alerts_Log_Insert_Input = {
  all_alerts_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  risk_alerts_log_questionnaire_take?: InputMaybe<Questionnaire_Takes_Obj_Rel_Insert_Input>;
  risk_alerts_log_risk_alerts_recipients_logs?: InputMaybe<Risk_Alerts_Recipients_Log_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Risk_Alerts_Log_Max_Fields = {
  __typename?: 'risk_alerts_log_max_fields';
  all_alerts_sent_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Risk_Alerts_Log_Min_Fields = {
  __typename?: 'risk_alerts_log_min_fields';
  all_alerts_sent_at?: Maybe<Scalars['timestamp']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "risk_alerts_log" */
export type Risk_Alerts_Log_Mutation_Response = {
  __typename?: 'risk_alerts_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Alerts_Log>;
};

/** input type for inserting object relation for remote table "risk_alerts_log" */
export type Risk_Alerts_Log_Obj_Rel_Insert_Input = {
  data: Risk_Alerts_Log_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Alerts_Log_On_Conflict>;
};

/** on_conflict condition type for table "risk_alerts_log" */
export type Risk_Alerts_Log_On_Conflict = {
  constraint: Risk_Alerts_Log_Constraint;
  update_columns?: Array<Risk_Alerts_Log_Update_Column>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_alerts_log". */
export type Risk_Alerts_Log_Order_By = {
  all_alerts_sent_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  risk_alerts_log_questionnaire_take?: InputMaybe<Questionnaire_Takes_Order_By>;
  risk_alerts_log_risk_alerts_recipients_logs_aggregate?: InputMaybe<Risk_Alerts_Recipients_Log_Aggregate_Order_By>;
};

/** primary key columns input for table: risk_alerts_log */
export type Risk_Alerts_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_alerts_log" */
export enum Risk_Alerts_Log_Select_Column {
  /** column name */
  AllAlertsSentAt = 'all_alerts_sent_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id'
}

/** input type for updating data in table "risk_alerts_log" */
export type Risk_Alerts_Log_Set_Input = {
  all_alerts_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Risk_Alerts_Log_Stddev_Fields = {
  __typename?: 'risk_alerts_log_stddev_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Risk_Alerts_Log_Stddev_Pop_Fields = {
  __typename?: 'risk_alerts_log_stddev_pop_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Risk_Alerts_Log_Stddev_Samp_Fields = {
  __typename?: 'risk_alerts_log_stddev_samp_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "risk_alerts_log" */
export type Risk_Alerts_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Alerts_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Alerts_Log_Stream_Cursor_Value_Input = {
  all_alerts_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Risk_Alerts_Log_Sum_Fields = {
  __typename?: 'risk_alerts_log_sum_fields';
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "risk_alerts_log" */
export enum Risk_Alerts_Log_Update_Column {
  /** column name */
  AllAlertsSentAt = 'all_alerts_sent_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id'
}

export type Risk_Alerts_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Risk_Alerts_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Alerts_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Alerts_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Risk_Alerts_Log_Var_Pop_Fields = {
  __typename?: 'risk_alerts_log_var_pop_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Risk_Alerts_Log_Var_Samp_Fields = {
  __typename?: 'risk_alerts_log_var_samp_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Risk_Alerts_Log_Variance_Fields = {
  __typename?: 'risk_alerts_log_variance_fields';
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log = {
  __typename?: 'risk_alerts_recipients_log';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email_sent: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  risk_alerts_log_id: Scalars['uuid']['output'];
  /** An object relationship */
  risk_alerts_recipients_log_risk_alerts_log: Risk_Alerts_Log;
  /** An object relationship */
  risk_alerts_recipients_log_user: Users;
  text_sent: Scalars['Boolean']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Aggregate = {
  __typename?: 'risk_alerts_recipients_log_aggregate';
  aggregate?: Maybe<Risk_Alerts_Recipients_Log_Aggregate_Fields>;
  nodes: Array<Risk_Alerts_Recipients_Log>;
};

export type Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Count>;
};

export type Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_And = {
  arguments: Risk_Alerts_Recipients_Log_Select_Column_Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Risk_Alerts_Recipients_Log_Select_Column_Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Aggregate_Fields = {
  __typename?: 'risk_alerts_recipients_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Risk_Alerts_Recipients_Log_Max_Fields>;
  min?: Maybe<Risk_Alerts_Recipients_Log_Min_Fields>;
};


/** aggregate fields of "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Risk_Alerts_Recipients_Log_Max_Order_By>;
  min?: InputMaybe<Risk_Alerts_Recipients_Log_Min_Order_By>;
};

/** input type for inserting array relation for remote table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Arr_Rel_Insert_Input = {
  data: Array<Risk_Alerts_Recipients_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Risk_Alerts_Recipients_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "risk_alerts_recipients_log". All fields are combined with a logical 'AND'. */
export type Risk_Alerts_Recipients_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Bool_Exp>>;
  _not?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email_sent?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_alerts_log_id?: InputMaybe<Uuid_Comparison_Exp>;
  risk_alerts_recipients_log_risk_alerts_log?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
  risk_alerts_recipients_log_user?: InputMaybe<Users_Bool_Exp>;
  text_sent?: InputMaybe<Boolean_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "risk_alerts_recipients_log" */
export enum Risk_Alerts_Recipients_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  RiskAlertsRecipientsLogPkey = 'risk_alerts_recipients_log_pkey'
}

/** input type for inserting data into table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk_alerts_log_id?: InputMaybe<Scalars['uuid']['input']>;
  risk_alerts_recipients_log_risk_alerts_log?: InputMaybe<Risk_Alerts_Log_Obj_Rel_Insert_Input>;
  risk_alerts_recipients_log_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  text_sent?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Risk_Alerts_Recipients_Log_Max_Fields = {
  __typename?: 'risk_alerts_recipients_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  risk_alerts_log_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_alerts_log_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Risk_Alerts_Recipients_Log_Min_Fields = {
  __typename?: 'risk_alerts_recipients_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  risk_alerts_log_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_alerts_log_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Mutation_Response = {
  __typename?: 'risk_alerts_recipients_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risk_Alerts_Recipients_Log>;
};

/** on_conflict condition type for table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_On_Conflict = {
  constraint: Risk_Alerts_Recipients_Log_Constraint;
  update_columns?: Array<Risk_Alerts_Recipients_Log_Update_Column>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "risk_alerts_recipients_log". */
export type Risk_Alerts_Recipients_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_sent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  risk_alerts_log_id?: InputMaybe<Order_By>;
  risk_alerts_recipients_log_risk_alerts_log?: InputMaybe<Risk_Alerts_Log_Order_By>;
  risk_alerts_recipients_log_user?: InputMaybe<Users_Order_By>;
  text_sent?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: risk_alerts_recipients_log */
export type Risk_Alerts_Recipients_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_alerts_recipients_log" */
export enum Risk_Alerts_Recipients_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  Id = 'id',
  /** column name */
  RiskAlertsLogId = 'risk_alerts_log_id',
  /** column name */
  TextSent = 'text_sent',
  /** column name */
  UserId = 'user_id'
}

/** select "risk_alerts_recipients_log_aggregate_bool_exp_bool_and_arguments_columns" columns of table "risk_alerts_recipients_log" */
export enum Risk_Alerts_Recipients_Log_Select_Column_Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  TextSent = 'text_sent'
}

/** select "risk_alerts_recipients_log_aggregate_bool_exp_bool_or_arguments_columns" columns of table "risk_alerts_recipients_log" */
export enum Risk_Alerts_Recipients_Log_Select_Column_Risk_Alerts_Recipients_Log_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  TextSent = 'text_sent'
}

/** input type for updating data in table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk_alerts_log_id?: InputMaybe<Scalars['uuid']['input']>;
  text_sent?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "risk_alerts_recipients_log" */
export type Risk_Alerts_Recipients_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Risk_Alerts_Recipients_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Risk_Alerts_Recipients_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk_alerts_log_id?: InputMaybe<Scalars['uuid']['input']>;
  text_sent?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risk_alerts_recipients_log" */
export enum Risk_Alerts_Recipients_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSent = 'email_sent',
  /** column name */
  Id = 'id',
  /** column name */
  RiskAlertsLogId = 'risk_alerts_log_id',
  /** column name */
  TextSent = 'text_sent',
  /** column name */
  UserId = 'user_id'
}

export type Risk_Alerts_Recipients_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Risk_Alerts_Recipients_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Risk_Alerts_Recipients_Log_Bool_Exp;
};

/** columns and relationships of "role_capabilities" */
export type Role_Capabilities = {
  __typename?: 'role_capabilities';
  create_assessments?: Maybe<Scalars['Boolean']['output']>;
  create_client_details?: Maybe<Scalars['Boolean']['output']>;
  create_nudge_schedules?: Maybe<Scalars['Boolean']['output']>;
  create_questionnaire_schedules?: Maybe<Scalars['Boolean']['output']>;
  create_safety_plans?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamp']['output'];
  delete_assessments?: Maybe<Scalars['Boolean']['output']>;
  delete_client_details?: Maybe<Scalars['Boolean']['output']>;
  delete_nudge_schedules?: Maybe<Scalars['Boolean']['output']>;
  delete_questionnaire_schedules?: Maybe<Scalars['Boolean']['output']>;
  delete_safety_plans?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  role?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  update_assessments?: Maybe<Scalars['Boolean']['output']>;
  update_client_details?: Maybe<Scalars['Boolean']['output']>;
  update_nudge_schedules?: Maybe<Scalars['Boolean']['output']>;
  update_questionnaire_schedules?: Maybe<Scalars['Boolean']['output']>;
  update_safety_plans?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamp']['output'];
  user_id: Scalars['uuid']['output'];
  view_assessments?: Maybe<Scalars['Boolean']['output']>;
  view_client_details?: Maybe<Scalars['Boolean']['output']>;
  view_nudge_schedules?: Maybe<Scalars['Boolean']['output']>;
  view_questionnaire_schedules?: Maybe<Scalars['Boolean']['output']>;
  view_safety_plans?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "role_capabilities" */
export type Role_Capabilities_Aggregate = {
  __typename?: 'role_capabilities_aggregate';
  aggregate?: Maybe<Role_Capabilities_Aggregate_Fields>;
  nodes: Array<Role_Capabilities>;
};

export type Role_Capabilities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Role_Capabilities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Role_Capabilities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Role_Capabilities_Aggregate_Bool_Exp_Count>;
};

export type Role_Capabilities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Role_Capabilities_Select_Column_Role_Capabilities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Capabilities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Capabilities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Role_Capabilities_Select_Column_Role_Capabilities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Capabilities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Role_Capabilities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Role_Capabilities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_capabilities" */
export type Role_Capabilities_Aggregate_Fields = {
  __typename?: 'role_capabilities_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Role_Capabilities_Max_Fields>;
  min?: Maybe<Role_Capabilities_Min_Fields>;
};


/** aggregate fields of "role_capabilities" */
export type Role_Capabilities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "role_capabilities" */
export type Role_Capabilities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Capabilities_Max_Order_By>;
  min?: InputMaybe<Role_Capabilities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_capabilities" */
export type Role_Capabilities_Arr_Rel_Insert_Input = {
  data: Array<Role_Capabilities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Capabilities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_capabilities". All fields are combined with a logical 'AND'. */
export type Role_Capabilities_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Capabilities_Bool_Exp>>;
  _not?: InputMaybe<Role_Capabilities_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Capabilities_Bool_Exp>>;
  create_assessments?: InputMaybe<Boolean_Comparison_Exp>;
  create_client_details?: InputMaybe<Boolean_Comparison_Exp>;
  create_nudge_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  create_questionnaire_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  create_safety_plans?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  delete_assessments?: InputMaybe<Boolean_Comparison_Exp>;
  delete_client_details?: InputMaybe<Boolean_Comparison_Exp>;
  delete_nudge_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  delete_questionnaire_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  delete_safety_plans?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  update_assessments?: InputMaybe<Boolean_Comparison_Exp>;
  update_client_details?: InputMaybe<Boolean_Comparison_Exp>;
  update_nudge_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  update_questionnaire_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  update_safety_plans?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  view_assessments?: InputMaybe<Boolean_Comparison_Exp>;
  view_client_details?: InputMaybe<Boolean_Comparison_Exp>;
  view_nudge_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  view_questionnaire_schedules?: InputMaybe<Boolean_Comparison_Exp>;
  view_safety_plans?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_capabilities" */
export enum Role_Capabilities_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoleCapabilitiesPkey = 'role_capabilities_pkey',
  /** unique or primary key constraint on columns "user_id" */
  RoleCapabilitiesUserIdKey = 'role_capabilities_user_id_key'
}

/** input type for inserting data into table "role_capabilities" */
export type Role_Capabilities_Insert_Input = {
  create_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  create_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  create_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delete_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  delete_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  delete_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  update_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  update_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  update_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  view_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  view_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  view_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Role_Capabilities_Max_Fields = {
  __typename?: 'role_capabilities_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "role_capabilities" */
export type Role_Capabilities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Capabilities_Min_Fields = {
  __typename?: 'role_capabilities_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "role_capabilities" */
export type Role_Capabilities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_capabilities" */
export type Role_Capabilities_Mutation_Response = {
  __typename?: 'role_capabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Capabilities>;
};

/** input type for inserting object relation for remote table "role_capabilities" */
export type Role_Capabilities_Obj_Rel_Insert_Input = {
  data: Role_Capabilities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Capabilities_On_Conflict>;
};

/** on_conflict condition type for table "role_capabilities" */
export type Role_Capabilities_On_Conflict = {
  constraint: Role_Capabilities_Constraint;
  update_columns?: Array<Role_Capabilities_Update_Column>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};

/** Ordering options when selecting data from "role_capabilities". */
export type Role_Capabilities_Order_By = {
  create_assessments?: InputMaybe<Order_By>;
  create_client_details?: InputMaybe<Order_By>;
  create_nudge_schedules?: InputMaybe<Order_By>;
  create_questionnaire_schedules?: InputMaybe<Order_By>;
  create_safety_plans?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delete_assessments?: InputMaybe<Order_By>;
  delete_client_details?: InputMaybe<Order_By>;
  delete_nudge_schedules?: InputMaybe<Order_By>;
  delete_questionnaire_schedules?: InputMaybe<Order_By>;
  delete_safety_plans?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  update_assessments?: InputMaybe<Order_By>;
  update_client_details?: InputMaybe<Order_By>;
  update_nudge_schedules?: InputMaybe<Order_By>;
  update_questionnaire_schedules?: InputMaybe<Order_By>;
  update_safety_plans?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  view_assessments?: InputMaybe<Order_By>;
  view_client_details?: InputMaybe<Order_By>;
  view_nudge_schedules?: InputMaybe<Order_By>;
  view_questionnaire_schedules?: InputMaybe<Order_By>;
  view_safety_plans?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_capabilities */
export type Role_Capabilities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "role_capabilities" */
export enum Role_Capabilities_Select_Column {
  /** column name */
  CreateAssessments = 'create_assessments',
  /** column name */
  CreateClientDetails = 'create_client_details',
  /** column name */
  CreateNudgeSchedules = 'create_nudge_schedules',
  /** column name */
  CreateQuestionnaireSchedules = 'create_questionnaire_schedules',
  /** column name */
  CreateSafetyPlans = 'create_safety_plans',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeleteAssessments = 'delete_assessments',
  /** column name */
  DeleteClientDetails = 'delete_client_details',
  /** column name */
  DeleteNudgeSchedules = 'delete_nudge_schedules',
  /** column name */
  DeleteQuestionnaireSchedules = 'delete_questionnaire_schedules',
  /** column name */
  DeleteSafetyPlans = 'delete_safety_plans',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Type = 'type',
  /** column name */
  UpdateAssessments = 'update_assessments',
  /** column name */
  UpdateClientDetails = 'update_client_details',
  /** column name */
  UpdateNudgeSchedules = 'update_nudge_schedules',
  /** column name */
  UpdateQuestionnaireSchedules = 'update_questionnaire_schedules',
  /** column name */
  UpdateSafetyPlans = 'update_safety_plans',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewAssessments = 'view_assessments',
  /** column name */
  ViewClientDetails = 'view_client_details',
  /** column name */
  ViewNudgeSchedules = 'view_nudge_schedules',
  /** column name */
  ViewQuestionnaireSchedules = 'view_questionnaire_schedules',
  /** column name */
  ViewSafetyPlans = 'view_safety_plans'
}

/** select "role_capabilities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "role_capabilities" */
export enum Role_Capabilities_Select_Column_Role_Capabilities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CreateAssessments = 'create_assessments',
  /** column name */
  CreateClientDetails = 'create_client_details',
  /** column name */
  CreateNudgeSchedules = 'create_nudge_schedules',
  /** column name */
  CreateQuestionnaireSchedules = 'create_questionnaire_schedules',
  /** column name */
  CreateSafetyPlans = 'create_safety_plans',
  /** column name */
  DeleteAssessments = 'delete_assessments',
  /** column name */
  DeleteClientDetails = 'delete_client_details',
  /** column name */
  DeleteNudgeSchedules = 'delete_nudge_schedules',
  /** column name */
  DeleteQuestionnaireSchedules = 'delete_questionnaire_schedules',
  /** column name */
  DeleteSafetyPlans = 'delete_safety_plans',
  /** column name */
  UpdateAssessments = 'update_assessments',
  /** column name */
  UpdateClientDetails = 'update_client_details',
  /** column name */
  UpdateNudgeSchedules = 'update_nudge_schedules',
  /** column name */
  UpdateQuestionnaireSchedules = 'update_questionnaire_schedules',
  /** column name */
  UpdateSafetyPlans = 'update_safety_plans',
  /** column name */
  ViewAssessments = 'view_assessments',
  /** column name */
  ViewClientDetails = 'view_client_details',
  /** column name */
  ViewNudgeSchedules = 'view_nudge_schedules',
  /** column name */
  ViewQuestionnaireSchedules = 'view_questionnaire_schedules',
  /** column name */
  ViewSafetyPlans = 'view_safety_plans'
}

/** select "role_capabilities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "role_capabilities" */
export enum Role_Capabilities_Select_Column_Role_Capabilities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CreateAssessments = 'create_assessments',
  /** column name */
  CreateClientDetails = 'create_client_details',
  /** column name */
  CreateNudgeSchedules = 'create_nudge_schedules',
  /** column name */
  CreateQuestionnaireSchedules = 'create_questionnaire_schedules',
  /** column name */
  CreateSafetyPlans = 'create_safety_plans',
  /** column name */
  DeleteAssessments = 'delete_assessments',
  /** column name */
  DeleteClientDetails = 'delete_client_details',
  /** column name */
  DeleteNudgeSchedules = 'delete_nudge_schedules',
  /** column name */
  DeleteQuestionnaireSchedules = 'delete_questionnaire_schedules',
  /** column name */
  DeleteSafetyPlans = 'delete_safety_plans',
  /** column name */
  UpdateAssessments = 'update_assessments',
  /** column name */
  UpdateClientDetails = 'update_client_details',
  /** column name */
  UpdateNudgeSchedules = 'update_nudge_schedules',
  /** column name */
  UpdateQuestionnaireSchedules = 'update_questionnaire_schedules',
  /** column name */
  UpdateSafetyPlans = 'update_safety_plans',
  /** column name */
  ViewAssessments = 'view_assessments',
  /** column name */
  ViewClientDetails = 'view_client_details',
  /** column name */
  ViewNudgeSchedules = 'view_nudge_schedules',
  /** column name */
  ViewQuestionnaireSchedules = 'view_questionnaire_schedules',
  /** column name */
  ViewSafetyPlans = 'view_safety_plans'
}

/** input type for updating data in table "role_capabilities" */
export type Role_Capabilities_Set_Input = {
  create_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  create_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  create_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delete_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  delete_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  delete_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  update_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  update_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  update_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  view_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  view_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  view_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "role_capabilities" */
export type Role_Capabilities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Capabilities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Capabilities_Stream_Cursor_Value_Input = {
  create_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  create_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  create_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  create_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  delete_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  delete_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  delete_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  delete_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  update_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  update_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  update_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  update_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  view_assessments?: InputMaybe<Scalars['Boolean']['input']>;
  view_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  view_nudge_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_questionnaire_schedules?: InputMaybe<Scalars['Boolean']['input']>;
  view_safety_plans?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "role_capabilities" */
export enum Role_Capabilities_Update_Column {
  /** column name */
  CreateAssessments = 'create_assessments',
  /** column name */
  CreateClientDetails = 'create_client_details',
  /** column name */
  CreateNudgeSchedules = 'create_nudge_schedules',
  /** column name */
  CreateQuestionnaireSchedules = 'create_questionnaire_schedules',
  /** column name */
  CreateSafetyPlans = 'create_safety_plans',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeleteAssessments = 'delete_assessments',
  /** column name */
  DeleteClientDetails = 'delete_client_details',
  /** column name */
  DeleteNudgeSchedules = 'delete_nudge_schedules',
  /** column name */
  DeleteQuestionnaireSchedules = 'delete_questionnaire_schedules',
  /** column name */
  DeleteSafetyPlans = 'delete_safety_plans',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  Type = 'type',
  /** column name */
  UpdateAssessments = 'update_assessments',
  /** column name */
  UpdateClientDetails = 'update_client_details',
  /** column name */
  UpdateNudgeSchedules = 'update_nudge_schedules',
  /** column name */
  UpdateQuestionnaireSchedules = 'update_questionnaire_schedules',
  /** column name */
  UpdateSafetyPlans = 'update_safety_plans',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViewAssessments = 'view_assessments',
  /** column name */
  ViewClientDetails = 'view_client_details',
  /** column name */
  ViewNudgeSchedules = 'view_nudge_schedules',
  /** column name */
  ViewQuestionnaireSchedules = 'view_questionnaire_schedules',
  /** column name */
  ViewSafetyPlans = 'view_safety_plans'
}

export type Role_Capabilities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Capabilities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Capabilities_Bool_Exp;
};

/** columns and relationships of "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log = {
  __typename?: 'safety_checklist_recipients_log';
  created_at: Scalars['timestamp']['output'];
  email_address: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Aggregate = {
  __typename?: 'safety_checklist_recipients_log_aggregate';
  aggregate?: Maybe<Safety_Checklist_Recipients_Log_Aggregate_Fields>;
  nodes: Array<Safety_Checklist_Recipients_Log>;
};

/** aggregate fields of "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Aggregate_Fields = {
  __typename?: 'safety_checklist_recipients_log_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Checklist_Recipients_Log_Max_Fields>;
  min?: Maybe<Safety_Checklist_Recipients_Log_Min_Fields>;
};


/** aggregate fields of "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "safety_checklist_recipients_log". All fields are combined with a logical 'AND'. */
export type Safety_Checklist_Recipients_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Bool_Exp>>;
  _not?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_checklist_recipients_log" */
export enum Safety_Checklist_Recipients_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyChecklistRecipientsLogPkey = 'safety_checklist_recipients_log_pkey'
}

/** input type for inserting data into table "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Safety_Checklist_Recipients_Log_Max_Fields = {
  __typename?: 'safety_checklist_recipients_log_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Safety_Checklist_Recipients_Log_Min_Fields = {
  __typename?: 'safety_checklist_recipients_log_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Mutation_Response = {
  __typename?: 'safety_checklist_recipients_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Checklist_Recipients_Log>;
};

/** on_conflict condition type for table "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_On_Conflict = {
  constraint: Safety_Checklist_Recipients_Log_Constraint;
  update_columns?: Array<Safety_Checklist_Recipients_Log_Update_Column>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_checklist_recipients_log". */
export type Safety_Checklist_Recipients_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_checklist_recipients_log */
export type Safety_Checklist_Recipients_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_checklist_recipients_log" */
export enum Safety_Checklist_Recipients_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "safety_checklist_recipients_log" */
export type Safety_Checklist_Recipients_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Checklist_Recipients_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Checklist_Recipients_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "safety_checklist_recipients_log" */
export enum Safety_Checklist_Recipients_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Safety_Checklist_Recipients_Log_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Checklist_Recipients_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Checklist_Recipients_Log_Bool_Exp;
};

/** columns and relationships of "safety_plan" */
export type Safety_Plan = {
  __typename?: 'safety_plan';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  responses: Scalars['jsonb']['output'];
  /** An object relationship */
  safety_plan_status: Enum_Safety_Plan_Status;
  /** An object relationship */
  safety_plan_template: Safety_Plan_Template;
  safety_plan_template_id: Scalars['uuid']['output'];
  status: Enum_Safety_Plan_Status_Enum;
  status_changed_at: Scalars['timestamp']['output'];
  /** An array relationship */
  updatedByUser: Array<Users>;
  /** An aggregate relationship */
  updatedByUser_aggregate: Users_Aggregate;
  updated_at: Scalars['timestamp']['output'];
  updated_by: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "safety_plan" */
export type Safety_PlanResponsesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "safety_plan" */
export type Safety_PlanUpdatedByUserArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "safety_plan" */
export type Safety_PlanUpdatedByUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "safety_plan" */
export type Safety_Plan_Aggregate = {
  __typename?: 'safety_plan_aggregate';
  aggregate?: Maybe<Safety_Plan_Aggregate_Fields>;
  nodes: Array<Safety_Plan>;
};

export type Safety_Plan_Aggregate_Bool_Exp = {
  count?: InputMaybe<Safety_Plan_Aggregate_Bool_Exp_Count>;
};

export type Safety_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_plan" */
export type Safety_Plan_Aggregate_Fields = {
  __typename?: 'safety_plan_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Max_Fields>;
  min?: Maybe<Safety_Plan_Min_Fields>;
};


/** aggregate fields of "safety_plan" */
export type Safety_Plan_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_plan" */
export type Safety_Plan_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Plan_Max_Order_By>;
  min?: InputMaybe<Safety_Plan_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Safety_Plan_Append_Input = {
  responses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "safety_plan" */
export type Safety_Plan_Arr_Rel_Insert_Input = {
  data: Array<Safety_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_On_Conflict>;
};

/** Boolean expression to filter rows from the table "safety_plan". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  responses?: InputMaybe<Jsonb_Comparison_Exp>;
  safety_plan_status?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
  safety_plan_template?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
  safety_plan_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Enum_Safety_Plan_Status_Enum_Comparison_Exp>;
  status_changed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updatedByUser?: InputMaybe<Users_Bool_Exp>;
  updatedByUser_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items = {
  __typename?: 'safety_plan_checklist_items';
  category_id: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_order: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  safety_plan_checklist_items_safety_plan_response_options: Array<Safety_Plan_Response_Options>;
  /** An aggregate relationship */
  safety_plan_checklist_items_safety_plan_response_options_aggregate: Safety_Plan_Response_Options_Aggregate;
  /** An object relationship */
  safety_plan_checklist_items_safety_plan_section_category: Safety_Plan_Section_Category;
  /** An object relationship */
  safety_plan_checklist_items_safety_plan_sections: Safety_Plan_Sections;
  section_id: Scalars['uuid']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


/** columns and relationships of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_ItemsSafety_Plan_Checklist_Items_Safety_Plan_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


/** columns and relationships of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_ItemsSafety_Plan_Checklist_Items_Safety_Plan_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};

/** aggregated selection of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Aggregate = {
  __typename?: 'safety_plan_checklist_items_aggregate';
  aggregate?: Maybe<Safety_Plan_Checklist_Items_Aggregate_Fields>;
  nodes: Array<Safety_Plan_Checklist_Items>;
};

export type Safety_Plan_Checklist_Items_Aggregate_Bool_Exp = {
  count?: InputMaybe<Safety_Plan_Checklist_Items_Aggregate_Bool_Exp_Count>;
};

export type Safety_Plan_Checklist_Items_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Aggregate_Fields = {
  __typename?: 'safety_plan_checklist_items_aggregate_fields';
  avg?: Maybe<Safety_Plan_Checklist_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Checklist_Items_Max_Fields>;
  min?: Maybe<Safety_Plan_Checklist_Items_Min_Fields>;
  stddev?: Maybe<Safety_Plan_Checklist_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Safety_Plan_Checklist_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Safety_Plan_Checklist_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Safety_Plan_Checklist_Items_Sum_Fields>;
  var_pop?: Maybe<Safety_Plan_Checklist_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Safety_Plan_Checklist_Items_Var_Samp_Fields>;
  variance?: Maybe<Safety_Plan_Checklist_Items_Variance_Fields>;
};


/** aggregate fields of "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Aggregate_Order_By = {
  avg?: InputMaybe<Safety_Plan_Checklist_Items_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Plan_Checklist_Items_Max_Order_By>;
  min?: InputMaybe<Safety_Plan_Checklist_Items_Min_Order_By>;
  stddev?: InputMaybe<Safety_Plan_Checklist_Items_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Safety_Plan_Checklist_Items_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Safety_Plan_Checklist_Items_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Safety_Plan_Checklist_Items_Sum_Order_By>;
  var_pop?: InputMaybe<Safety_Plan_Checklist_Items_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Safety_Plan_Checklist_Items_Var_Samp_Order_By>;
  variance?: InputMaybe<Safety_Plan_Checklist_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Arr_Rel_Insert_Input = {
  data: Array<Safety_Plan_Checklist_Items_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Checklist_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Safety_Plan_Checklist_Items_Avg_Fields = {
  __typename?: 'safety_plan_checklist_items_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "safety_plan_checklist_items". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Checklist_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Checklist_Items_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Checklist_Items_Bool_Exp>>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  safety_plan_checklist_items_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  safety_plan_checklist_items_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Bool_Exp>;
  safety_plan_checklist_items_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
  safety_plan_checklist_items_safety_plan_sections?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_plan_checklist_items" */
export enum Safety_Plan_Checklist_Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanChecklistItemsPkey = 'safety_plan_checklist_items_pkey'
}

/** input type for incrementing numeric columns in table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Insert_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  safety_plan_checklist_items_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Arr_Rel_Insert_Input>;
  safety_plan_checklist_items_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Obj_Rel_Insert_Input>;
  safety_plan_checklist_items_safety_plan_sections?: InputMaybe<Safety_Plan_Sections_Obj_Rel_Insert_Input>;
  section_id?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Safety_Plan_Checklist_Items_Max_Fields = {
  __typename?: 'safety_plan_checklist_items_max_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Plan_Checklist_Items_Min_Fields = {
  __typename?: 'safety_plan_checklist_items_min_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  section_id?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Mutation_Response = {
  __typename?: 'safety_plan_checklist_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan_Checklist_Items>;
};

/** input type for inserting object relation for remote table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Obj_Rel_Insert_Input = {
  data: Safety_Plan_Checklist_Items_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Checklist_Items_On_Conflict>;
};

/** on_conflict condition type for table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_On_Conflict = {
  constraint: Safety_Plan_Checklist_Items_Constraint;
  update_columns?: Array<Safety_Plan_Checklist_Items_Update_Column>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan_checklist_items". */
export type Safety_Plan_Checklist_Items_Order_By = {
  category_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_checklist_items_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Order_By>;
  safety_plan_checklist_items_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Order_By>;
  safety_plan_checklist_items_safety_plan_sections?: InputMaybe<Safety_Plan_Sections_Order_By>;
  section_id?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_plan_checklist_items */
export type Safety_Plan_Checklist_Items_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_plan_checklist_items" */
export enum Safety_Plan_Checklist_Items_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Safety_Plan_Checklist_Items_Stddev_Fields = {
  __typename?: 'safety_plan_checklist_items_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Safety_Plan_Checklist_Items_Stddev_Pop_Fields = {
  __typename?: 'safety_plan_checklist_items_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Safety_Plan_Checklist_Items_Stddev_Samp_Fields = {
  __typename?: 'safety_plan_checklist_items_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Checklist_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Checklist_Items_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  section_id?: InputMaybe<Scalars['uuid']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Safety_Plan_Checklist_Items_Sum_Fields = {
  __typename?: 'safety_plan_checklist_items_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "safety_plan_checklist_items" */
export enum Safety_Plan_Checklist_Items_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  SectionId = 'section_id',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  Title = 'title'
}

export type Safety_Plan_Checklist_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Safety_Plan_Checklist_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Checklist_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Checklist_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Safety_Plan_Checklist_Items_Var_Pop_Fields = {
  __typename?: 'safety_plan_checklist_items_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Safety_Plan_Checklist_Items_Var_Samp_Fields = {
  __typename?: 'safety_plan_checklist_items_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Safety_Plan_Checklist_Items_Variance_Fields = {
  __typename?: 'safety_plan_checklist_items_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "safety_plan_checklist_items" */
export type Safety_Plan_Checklist_Items_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "safety_plan" */
export enum Safety_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanPkey = 'safety_plan_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Safety_Plan_Delete_At_Path_Input = {
  responses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Safety_Plan_Delete_Elem_Input = {
  responses?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Safety_Plan_Delete_Key_Input = {
  responses?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "safety_plan" */
export type Safety_Plan_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  responses?: InputMaybe<Scalars['jsonb']['input']>;
  safety_plan_status?: InputMaybe<Enum_Safety_Plan_Status_Obj_Rel_Insert_Input>;
  safety_plan_template?: InputMaybe<Safety_Plan_Template_Obj_Rel_Insert_Input>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Enum_Safety_Plan_Status_Enum>;
  status_changed_at?: InputMaybe<Scalars['timestamp']['input']>;
  updatedByUser?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Safety_Plan_Max_Fields = {
  __typename?: 'safety_plan_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  safety_plan_template_id?: Maybe<Scalars['uuid']['output']>;
  status_changed_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "safety_plan" */
export type Safety_Plan_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  status_changed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Plan_Min_Fields = {
  __typename?: 'safety_plan_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  safety_plan_template_id?: Maybe<Scalars['uuid']['output']>;
  status_changed_at?: Maybe<Scalars['timestamp']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "safety_plan" */
export type Safety_Plan_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  status_changed_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_plan" */
export type Safety_Plan_Mutation_Response = {
  __typename?: 'safety_plan_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan>;
};

/** on_conflict condition type for table "safety_plan" */
export type Safety_Plan_On_Conflict = {
  constraint: Safety_Plan_Constraint;
  update_columns?: Array<Safety_Plan_Update_Column>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan". */
export type Safety_Plan_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  responses?: InputMaybe<Order_By>;
  safety_plan_status?: InputMaybe<Enum_Safety_Plan_Status_Order_By>;
  safety_plan_template?: InputMaybe<Safety_Plan_Template_Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_changed_at?: InputMaybe<Order_By>;
  updatedByUser_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_plan */
export type Safety_Plan_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Safety_Plan_Prepend_Input = {
  responses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "safety_plan_response_options" */
export type Safety_Plan_Response_Options = {
  __typename?: 'safety_plan_response_options';
  category_id: Scalars['uuid']['output'];
  checklist_item_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamp']['output'];
  display_order: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  response_text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  safety_plan_response_options_safety_plan_checklist_item?: Maybe<Safety_Plan_Checklist_Items>;
  /** An object relationship */
  safety_plan_response_options_safety_plan_section: Safety_Plan_Sections;
  /** An object relationship */
  safety_plan_response_options_safety_plan_section_category: Safety_Plan_Section_Category;
  safety_plan_section_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamp']['output'];
};

/** aggregated selection of "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Aggregate = {
  __typename?: 'safety_plan_response_options_aggregate';
  aggregate?: Maybe<Safety_Plan_Response_Options_Aggregate_Fields>;
  nodes: Array<Safety_Plan_Response_Options>;
};

export type Safety_Plan_Response_Options_Aggregate_Bool_Exp = {
  count?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Bool_Exp_Count>;
};

export type Safety_Plan_Response_Options_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Aggregate_Fields = {
  __typename?: 'safety_plan_response_options_aggregate_fields';
  avg?: Maybe<Safety_Plan_Response_Options_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Response_Options_Max_Fields>;
  min?: Maybe<Safety_Plan_Response_Options_Min_Fields>;
  stddev?: Maybe<Safety_Plan_Response_Options_Stddev_Fields>;
  stddev_pop?: Maybe<Safety_Plan_Response_Options_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Safety_Plan_Response_Options_Stddev_Samp_Fields>;
  sum?: Maybe<Safety_Plan_Response_Options_Sum_Fields>;
  var_pop?: Maybe<Safety_Plan_Response_Options_Var_Pop_Fields>;
  var_samp?: Maybe<Safety_Plan_Response_Options_Var_Samp_Fields>;
  variance?: Maybe<Safety_Plan_Response_Options_Variance_Fields>;
};


/** aggregate fields of "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Aggregate_Order_By = {
  avg?: InputMaybe<Safety_Plan_Response_Options_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Plan_Response_Options_Max_Order_By>;
  min?: InputMaybe<Safety_Plan_Response_Options_Min_Order_By>;
  stddev?: InputMaybe<Safety_Plan_Response_Options_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Safety_Plan_Response_Options_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Safety_Plan_Response_Options_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Safety_Plan_Response_Options_Sum_Order_By>;
  var_pop?: InputMaybe<Safety_Plan_Response_Options_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Safety_Plan_Response_Options_Var_Samp_Order_By>;
  variance?: InputMaybe<Safety_Plan_Response_Options_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Arr_Rel_Insert_Input = {
  data: Array<Safety_Plan_Response_Options_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Response_Options_On_Conflict>;
};

/** aggregate avg on columns */
export type Safety_Plan_Response_Options_Avg_Fields = {
  __typename?: 'safety_plan_response_options_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "safety_plan_response_options". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Response_Options_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Response_Options_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Response_Options_Bool_Exp>>;
  category_id?: InputMaybe<Uuid_Comparison_Exp>;
  checklist_item_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  response_text?: InputMaybe<String_Comparison_Exp>;
  safety_plan_response_options_safety_plan_checklist_item?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
  safety_plan_response_options_safety_plan_section?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  safety_plan_response_options_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
  safety_plan_section_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_plan_response_options" */
export enum Safety_Plan_Response_Options_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanResponseOptionsPkey = 'safety_plan_response_options_pkey',
  /** unique or primary key constraint on columns "category_id", "response_text", "safety_plan_section_id" */
  SafetyPlanResponseOptionsUniqueNoChecklistItem = 'safety_plan_response_options_unique_no_checklist_item',
  /** unique or primary key constraint on columns "category_id", "response_text", "safety_plan_section_id", "checklist_item_id" */
  SafetyPlanResponseOptionsUniqueWithChecklistItem = 'safety_plan_response_options_unique_with_checklist_item'
}

/** input type for incrementing numeric columns in table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Insert_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  checklist_item_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  safety_plan_response_options_safety_plan_checklist_item?: InputMaybe<Safety_Plan_Checklist_Items_Obj_Rel_Insert_Input>;
  safety_plan_response_options_safety_plan_section?: InputMaybe<Safety_Plan_Sections_Obj_Rel_Insert_Input>;
  safety_plan_response_options_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Obj_Rel_Insert_Input>;
  safety_plan_section_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Safety_Plan_Response_Options_Max_Fields = {
  __typename?: 'safety_plan_response_options_max_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  checklist_item_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  response_text?: Maybe<Scalars['String']['output']>;
  safety_plan_section_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Max_Order_By = {
  category_id?: InputMaybe<Order_By>;
  checklist_item_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_text?: InputMaybe<Order_By>;
  safety_plan_section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Plan_Response_Options_Min_Fields = {
  __typename?: 'safety_plan_response_options_min_fields';
  category_id?: Maybe<Scalars['uuid']['output']>;
  checklist_item_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  response_text?: Maybe<Scalars['String']['output']>;
  safety_plan_section_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Min_Order_By = {
  category_id?: InputMaybe<Order_By>;
  checklist_item_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_text?: InputMaybe<Order_By>;
  safety_plan_section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Mutation_Response = {
  __typename?: 'safety_plan_response_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan_Response_Options>;
};

/** input type for inserting object relation for remote table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Obj_Rel_Insert_Input = {
  data: Safety_Plan_Response_Options_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Response_Options_On_Conflict>;
};

/** on_conflict condition type for table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_On_Conflict = {
  constraint: Safety_Plan_Response_Options_Constraint;
  update_columns?: Array<Safety_Plan_Response_Options_Update_Column>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan_response_options". */
export type Safety_Plan_Response_Options_Order_By = {
  category_id?: InputMaybe<Order_By>;
  checklist_item_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  response_text?: InputMaybe<Order_By>;
  safety_plan_response_options_safety_plan_checklist_item?: InputMaybe<Safety_Plan_Checklist_Items_Order_By>;
  safety_plan_response_options_safety_plan_section?: InputMaybe<Safety_Plan_Sections_Order_By>;
  safety_plan_response_options_safety_plan_section_category?: InputMaybe<Safety_Plan_Section_Category_Order_By>;
  safety_plan_section_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_plan_response_options */
export type Safety_Plan_Response_Options_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_plan_response_options" */
export enum Safety_Plan_Response_Options_Select_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ChecklistItemId = 'checklist_item_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ResponseText = 'response_text',
  /** column name */
  SafetyPlanSectionId = 'safety_plan_section_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Set_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  checklist_item_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  safety_plan_section_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Safety_Plan_Response_Options_Stddev_Fields = {
  __typename?: 'safety_plan_response_options_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Safety_Plan_Response_Options_Stddev_Pop_Fields = {
  __typename?: 'safety_plan_response_options_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Safety_Plan_Response_Options_Stddev_Samp_Fields = {
  __typename?: 'safety_plan_response_options_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Response_Options_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Response_Options_Stream_Cursor_Value_Input = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  checklist_item_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  safety_plan_section_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Safety_Plan_Response_Options_Sum_Fields = {
  __typename?: 'safety_plan_response_options_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "safety_plan_response_options" */
export enum Safety_Plan_Response_Options_Update_Column {
  /** column name */
  CategoryId = 'category_id',
  /** column name */
  ChecklistItemId = 'checklist_item_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  ResponseText = 'response_text',
  /** column name */
  SafetyPlanSectionId = 'safety_plan_section_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Safety_Plan_Response_Options_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Safety_Plan_Response_Options_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Response_Options_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Response_Options_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Safety_Plan_Response_Options_Var_Pop_Fields = {
  __typename?: 'safety_plan_response_options_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Safety_Plan_Response_Options_Var_Samp_Fields = {
  __typename?: 'safety_plan_response_options_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Safety_Plan_Response_Options_Variance_Fields = {
  __typename?: 'safety_plan_response_options_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "safety_plan_response_options" */
export type Safety_Plan_Response_Options_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "safety_plan_section_category" */
export type Safety_Plan_Section_Category = {
  __typename?: 'safety_plan_section_category';
  category_type: Enum_Safety_Plan_Section_Category_Type_Enum;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  safety_plan_section_category_enum_safety_plan_section_category_type: Enum_Safety_Plan_Section_Category_Type;
  /** An array relationship */
  safety_plan_section_category_safety_plan_checklist_items: Array<Safety_Plan_Checklist_Items>;
  /** An aggregate relationship */
  safety_plan_section_category_safety_plan_checklist_items_aggregate: Safety_Plan_Checklist_Items_Aggregate;
  /** An array relationship */
  safety_plan_section_category_safety_plan_response_options: Array<Safety_Plan_Response_Options>;
  /** An aggregate relationship */
  safety_plan_section_category_safety_plan_response_options_aggregate: Safety_Plan_Response_Options_Aggregate;
};


/** columns and relationships of "safety_plan_section_category" */
export type Safety_Plan_Section_CategorySafety_Plan_Section_Category_Safety_Plan_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


/** columns and relationships of "safety_plan_section_category" */
export type Safety_Plan_Section_CategorySafety_Plan_Section_Category_Safety_Plan_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


/** columns and relationships of "safety_plan_section_category" */
export type Safety_Plan_Section_CategorySafety_Plan_Section_Category_Safety_Plan_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


/** columns and relationships of "safety_plan_section_category" */
export type Safety_Plan_Section_CategorySafety_Plan_Section_Category_Safety_Plan_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};

/** aggregated selection of "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Aggregate = {
  __typename?: 'safety_plan_section_category_aggregate';
  aggregate?: Maybe<Safety_Plan_Section_Category_Aggregate_Fields>;
  nodes: Array<Safety_Plan_Section_Category>;
};

export type Safety_Plan_Section_Category_Aggregate_Bool_Exp = {
  count?: InputMaybe<Safety_Plan_Section_Category_Aggregate_Bool_Exp_Count>;
};

export type Safety_Plan_Section_Category_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Aggregate_Fields = {
  __typename?: 'safety_plan_section_category_aggregate_fields';
  avg?: Maybe<Safety_Plan_Section_Category_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Section_Category_Max_Fields>;
  min?: Maybe<Safety_Plan_Section_Category_Min_Fields>;
  stddev?: Maybe<Safety_Plan_Section_Category_Stddev_Fields>;
  stddev_pop?: Maybe<Safety_Plan_Section_Category_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Safety_Plan_Section_Category_Stddev_Samp_Fields>;
  sum?: Maybe<Safety_Plan_Section_Category_Sum_Fields>;
  var_pop?: Maybe<Safety_Plan_Section_Category_Var_Pop_Fields>;
  var_samp?: Maybe<Safety_Plan_Section_Category_Var_Samp_Fields>;
  variance?: Maybe<Safety_Plan_Section_Category_Variance_Fields>;
};


/** aggregate fields of "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Aggregate_Order_By = {
  avg?: InputMaybe<Safety_Plan_Section_Category_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Plan_Section_Category_Max_Order_By>;
  min?: InputMaybe<Safety_Plan_Section_Category_Min_Order_By>;
  stddev?: InputMaybe<Safety_Plan_Section_Category_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Safety_Plan_Section_Category_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Safety_Plan_Section_Category_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Safety_Plan_Section_Category_Sum_Order_By>;
  var_pop?: InputMaybe<Safety_Plan_Section_Category_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Safety_Plan_Section_Category_Var_Samp_Order_By>;
  variance?: InputMaybe<Safety_Plan_Section_Category_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Arr_Rel_Insert_Input = {
  data: Array<Safety_Plan_Section_Category_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Section_Category_On_Conflict>;
};

/** aggregate avg on columns */
export type Safety_Plan_Section_Category_Avg_Fields = {
  __typename?: 'safety_plan_section_category_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "safety_plan_section_category". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Section_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Section_Category_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Section_Category_Bool_Exp>>;
  category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  safety_plan_section_category_enum_safety_plan_section_category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
  safety_plan_section_category_safety_plan_checklist_items?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
  safety_plan_section_category_safety_plan_checklist_items_aggregate?: InputMaybe<Safety_Plan_Checklist_Items_Aggregate_Bool_Exp>;
  safety_plan_section_category_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  safety_plan_section_category_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "safety_plan_section_category" */
export enum Safety_Plan_Section_Category_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanSectionCategoryPkey = 'safety_plan_section_category_pkey'
}

/** input type for incrementing numeric columns in table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Insert_Input = {
  category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  safety_plan_section_category_enum_safety_plan_section_category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Obj_Rel_Insert_Input>;
  safety_plan_section_category_safety_plan_checklist_items?: InputMaybe<Safety_Plan_Checklist_Items_Arr_Rel_Insert_Input>;
  safety_plan_section_category_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Safety_Plan_Section_Category_Max_Fields = {
  __typename?: 'safety_plan_section_category_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Plan_Section_Category_Min_Fields = {
  __typename?: 'safety_plan_section_category_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Mutation_Response = {
  __typename?: 'safety_plan_section_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan_Section_Category>;
};

/** input type for inserting object relation for remote table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Obj_Rel_Insert_Input = {
  data: Safety_Plan_Section_Category_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Section_Category_On_Conflict>;
};

/** on_conflict condition type for table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_On_Conflict = {
  constraint: Safety_Plan_Section_Category_Constraint;
  update_columns?: Array<Safety_Plan_Section_Category_Update_Column>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan_section_category". */
export type Safety_Plan_Section_Category_Order_By = {
  category_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  safety_plan_section_category_enum_safety_plan_section_category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Order_By>;
  safety_plan_section_category_safety_plan_checklist_items_aggregate?: InputMaybe<Safety_Plan_Checklist_Items_Aggregate_Order_By>;
  safety_plan_section_category_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Order_By>;
};

/** primary key columns input for table: safety_plan_section_category */
export type Safety_Plan_Section_Category_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_plan_section_category" */
export enum Safety_Plan_Section_Category_Select_Column {
  /** column name */
  CategoryType = 'category_type',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Set_Input = {
  category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Safety_Plan_Section_Category_Stddev_Fields = {
  __typename?: 'safety_plan_section_category_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Safety_Plan_Section_Category_Stddev_Pop_Fields = {
  __typename?: 'safety_plan_section_category_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Safety_Plan_Section_Category_Stddev_Samp_Fields = {
  __typename?: 'safety_plan_section_category_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Section_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Section_Category_Stream_Cursor_Value_Input = {
  category_type?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Safety_Plan_Section_Category_Sum_Fields = {
  __typename?: 'safety_plan_section_category_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "safety_plan_section_category" */
export enum Safety_Plan_Section_Category_Update_Column {
  /** column name */
  CategoryType = 'category_type',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Safety_Plan_Section_Category_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Safety_Plan_Section_Category_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Section_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Section_Category_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Safety_Plan_Section_Category_Var_Pop_Fields = {
  __typename?: 'safety_plan_section_category_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Safety_Plan_Section_Category_Var_Samp_Fields = {
  __typename?: 'safety_plan_section_category_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Safety_Plan_Section_Category_Variance_Fields = {
  __typename?: 'safety_plan_section_category_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "safety_plan_section_category" */
export type Safety_Plan_Section_Category_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** columns and relationships of "safety_plan_sections" */
export type Safety_Plan_Sections = {
  __typename?: 'safety_plan_sections';
  created_at: Scalars['timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_order: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  header_image_path?: Maybe<Scalars['String']['output']>;
  help_text?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Enum_Safety_Plan_Section_Icons_Enum>;
  icon_color?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  safety_plan_sections_safety_plan_checklist_items: Array<Safety_Plan_Checklist_Items>;
  /** An aggregate relationship */
  safety_plan_sections_safety_plan_checklist_items_aggregate: Safety_Plan_Checklist_Items_Aggregate;
  /** An array relationship */
  safety_plan_sections_safety_plan_response_options: Array<Safety_Plan_Response_Options>;
  /** An aggregate relationship */
  safety_plan_sections_safety_plan_response_options_aggregate: Safety_Plan_Response_Options_Aggregate;
  safety_plan_template_id: Scalars['uuid']['output'];
  show_support_card: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "safety_plan_sections" */
export type Safety_Plan_SectionsSafety_Plan_Sections_Safety_Plan_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


/** columns and relationships of "safety_plan_sections" */
export type Safety_Plan_SectionsSafety_Plan_Sections_Safety_Plan_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


/** columns and relationships of "safety_plan_sections" */
export type Safety_Plan_SectionsSafety_Plan_Sections_Safety_Plan_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


/** columns and relationships of "safety_plan_sections" */
export type Safety_Plan_SectionsSafety_Plan_Sections_Safety_Plan_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};

/** aggregated selection of "safety_plan_sections" */
export type Safety_Plan_Sections_Aggregate = {
  __typename?: 'safety_plan_sections_aggregate';
  aggregate?: Maybe<Safety_Plan_Sections_Aggregate_Fields>;
  nodes: Array<Safety_Plan_Sections>;
};

export type Safety_Plan_Sections_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Safety_Plan_Sections_Aggregate_Bool_Exp_Count>;
};

export type Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_And = {
  arguments: Safety_Plan_Sections_Select_Column_Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Safety_Plan_Sections_Select_Column_Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Safety_Plan_Sections_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "safety_plan_sections" */
export type Safety_Plan_Sections_Aggregate_Fields = {
  __typename?: 'safety_plan_sections_aggregate_fields';
  avg?: Maybe<Safety_Plan_Sections_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Sections_Max_Fields>;
  min?: Maybe<Safety_Plan_Sections_Min_Fields>;
  stddev?: Maybe<Safety_Plan_Sections_Stddev_Fields>;
  stddev_pop?: Maybe<Safety_Plan_Sections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Safety_Plan_Sections_Stddev_Samp_Fields>;
  sum?: Maybe<Safety_Plan_Sections_Sum_Fields>;
  var_pop?: Maybe<Safety_Plan_Sections_Var_Pop_Fields>;
  var_samp?: Maybe<Safety_Plan_Sections_Var_Samp_Fields>;
  variance?: Maybe<Safety_Plan_Sections_Variance_Fields>;
};


/** aggregate fields of "safety_plan_sections" */
export type Safety_Plan_Sections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "safety_plan_sections" */
export type Safety_Plan_Sections_Aggregate_Order_By = {
  avg?: InputMaybe<Safety_Plan_Sections_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Safety_Plan_Sections_Max_Order_By>;
  min?: InputMaybe<Safety_Plan_Sections_Min_Order_By>;
  stddev?: InputMaybe<Safety_Plan_Sections_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Safety_Plan_Sections_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Safety_Plan_Sections_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Safety_Plan_Sections_Sum_Order_By>;
  var_pop?: InputMaybe<Safety_Plan_Sections_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Safety_Plan_Sections_Var_Samp_Order_By>;
  variance?: InputMaybe<Safety_Plan_Sections_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "safety_plan_sections" */
export type Safety_Plan_Sections_Arr_Rel_Insert_Input = {
  data: Array<Safety_Plan_Sections_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Sections_On_Conflict>;
};

/** aggregate avg on columns */
export type Safety_Plan_Sections_Avg_Fields = {
  __typename?: 'safety_plan_sections_avg_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Avg_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "safety_plan_sections". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Sections_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Sections_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Sections_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_order?: InputMaybe<Int_Comparison_Exp>;
  header?: InputMaybe<String_Comparison_Exp>;
  header_image_path?: InputMaybe<String_Comparison_Exp>;
  help_text?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum_Comparison_Exp>;
  icon_color?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  safety_plan_sections_safety_plan_checklist_items?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
  safety_plan_sections_safety_plan_checklist_items_aggregate?: InputMaybe<Safety_Plan_Checklist_Items_Aggregate_Bool_Exp>;
  safety_plan_sections_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
  safety_plan_sections_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Bool_Exp>;
  safety_plan_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  show_support_card?: InputMaybe<Boolean_Comparison_Exp>;
  subtitle?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_plan_sections" */
export enum Safety_Plan_Sections_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanSectionsPkey = 'safety_plan_sections_pkey',
  /** unique or primary key constraint on columns "safety_plan_template_id", "display_order" */
  SafetyPlanSectionsSafetyPlanTemplateIdDisplayOrderKey = 'safety_plan_sections_safety_plan_template_id_display_order_key'
}

/** input type for incrementing numeric columns in table "safety_plan_sections" */
export type Safety_Plan_Sections_Inc_Input = {
  display_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "safety_plan_sections" */
export type Safety_Plan_Sections_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_image_path?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum>;
  icon_color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  safety_plan_sections_safety_plan_checklist_items?: InputMaybe<Safety_Plan_Checklist_Items_Arr_Rel_Insert_Input>;
  safety_plan_sections_safety_plan_response_options?: InputMaybe<Safety_Plan_Response_Options_Arr_Rel_Insert_Input>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  show_support_card?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Safety_Plan_Sections_Max_Fields = {
  __typename?: 'safety_plan_sections_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  header_image_path?: Maybe<Scalars['String']['output']>;
  help_text?: Maybe<Scalars['String']['output']>;
  icon_color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  safety_plan_template_id?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  header_image_path?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  icon_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Safety_Plan_Sections_Min_Fields = {
  __typename?: 'safety_plan_sections_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  header_image_path?: Maybe<Scalars['String']['output']>;
  help_text?: Maybe<Scalars['String']['output']>;
  icon_color?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  safety_plan_template_id?: Maybe<Scalars['uuid']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  header_image_path?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  icon_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "safety_plan_sections" */
export type Safety_Plan_Sections_Mutation_Response = {
  __typename?: 'safety_plan_sections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan_Sections>;
};

/** input type for inserting object relation for remote table "safety_plan_sections" */
export type Safety_Plan_Sections_Obj_Rel_Insert_Input = {
  data: Safety_Plan_Sections_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Sections_On_Conflict>;
};

/** on_conflict condition type for table "safety_plan_sections" */
export type Safety_Plan_Sections_On_Conflict = {
  constraint: Safety_Plan_Sections_Constraint;
  update_columns?: Array<Safety_Plan_Sections_Update_Column>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan_sections". */
export type Safety_Plan_Sections_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_order?: InputMaybe<Order_By>;
  header?: InputMaybe<Order_By>;
  header_image_path?: InputMaybe<Order_By>;
  help_text?: InputMaybe<Order_By>;
  icon?: InputMaybe<Order_By>;
  icon_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  safety_plan_sections_safety_plan_checklist_items_aggregate?: InputMaybe<Safety_Plan_Checklist_Items_Aggregate_Order_By>;
  safety_plan_sections_safety_plan_response_options_aggregate?: InputMaybe<Safety_Plan_Response_Options_Aggregate_Order_By>;
  safety_plan_template_id?: InputMaybe<Order_By>;
  show_support_card?: InputMaybe<Order_By>;
  subtitle?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_plan_sections */
export type Safety_Plan_Sections_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_plan_sections" */
export enum Safety_Plan_Sections_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Header = 'header',
  /** column name */
  HeaderImagePath = 'header_image_path',
  /** column name */
  HelpText = 'help_text',
  /** column name */
  Icon = 'icon',
  /** column name */
  IconColor = 'icon_color',
  /** column name */
  Id = 'id',
  /** column name */
  SafetyPlanTemplateId = 'safety_plan_template_id',
  /** column name */
  ShowSupportCard = 'show_support_card',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "safety_plan_sections_aggregate_bool_exp_bool_and_arguments_columns" columns of table "safety_plan_sections" */
export enum Safety_Plan_Sections_Select_Column_Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ShowSupportCard = 'show_support_card'
}

/** select "safety_plan_sections_aggregate_bool_exp_bool_or_arguments_columns" columns of table "safety_plan_sections" */
export enum Safety_Plan_Sections_Select_Column_Safety_Plan_Sections_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ShowSupportCard = 'show_support_card'
}

/** input type for updating data in table "safety_plan_sections" */
export type Safety_Plan_Sections_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_image_path?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum>;
  icon_color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  show_support_card?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate stddev on columns */
export type Safety_Plan_Sections_Stddev_Fields = {
  __typename?: 'safety_plan_sections_stddev_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Stddev_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Safety_Plan_Sections_Stddev_Pop_Fields = {
  __typename?: 'safety_plan_sections_stddev_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Stddev_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Safety_Plan_Sections_Stddev_Samp_Fields = {
  __typename?: 'safety_plan_sections_stddev_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Stddev_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "safety_plan_sections" */
export type Safety_Plan_Sections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Sections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Sections_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  header_image_path?: InputMaybe<Scalars['String']['input']>;
  help_text?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Enum_Safety_Plan_Section_Icons_Enum>;
  icon_color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  show_support_card?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate sum on columns */
export type Safety_Plan_Sections_Sum_Fields = {
  __typename?: 'safety_plan_sections_sum_fields';
  display_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Sum_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** update columns of table "safety_plan_sections" */
export enum Safety_Plan_Sections_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOrder = 'display_order',
  /** column name */
  Header = 'header',
  /** column name */
  HeaderImagePath = 'header_image_path',
  /** column name */
  HelpText = 'help_text',
  /** column name */
  Icon = 'icon',
  /** column name */
  IconColor = 'icon_color',
  /** column name */
  Id = 'id',
  /** column name */
  SafetyPlanTemplateId = 'safety_plan_template_id',
  /** column name */
  ShowSupportCard = 'show_support_card',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Safety_Plan_Sections_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Safety_Plan_Sections_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Sections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Sections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Safety_Plan_Sections_Var_Pop_Fields = {
  __typename?: 'safety_plan_sections_var_pop_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Var_Pop_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Safety_Plan_Sections_Var_Samp_Fields = {
  __typename?: 'safety_plan_sections_var_samp_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Var_Samp_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Safety_Plan_Sections_Variance_Fields = {
  __typename?: 'safety_plan_sections_variance_fields';
  display_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "safety_plan_sections" */
export type Safety_Plan_Sections_Variance_Order_By = {
  display_order?: InputMaybe<Order_By>;
};

/** select columns of table "safety_plan" */
export enum Safety_Plan_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Responses = 'responses',
  /** column name */
  SafetyPlanTemplateId = 'safety_plan_template_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'status_changed_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "safety_plan" */
export type Safety_Plan_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  responses?: InputMaybe<Scalars['jsonb']['input']>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Enum_Safety_Plan_Status_Enum>;
  status_changed_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "safety_plan" */
export type Safety_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  responses?: InputMaybe<Scalars['jsonb']['input']>;
  safety_plan_template_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Enum_Safety_Plan_Status_Enum>;
  status_changed_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "safety_plan_template" */
export type Safety_Plan_Template = {
  __typename?: 'safety_plan_template';
  created_at: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  is_read_only?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  plan_type: Enum_Safety_Plan_Type_Enum;
  /** An array relationship */
  safety_plan_template_safety_plan_sections: Array<Safety_Plan_Sections>;
  /** An aggregate relationship */
  safety_plan_template_safety_plan_sections_aggregate: Safety_Plan_Sections_Aggregate;
  /** An array relationship */
  safety_plan_template_safety_plans: Array<Safety_Plan>;
  /** An aggregate relationship */
  safety_plan_template_safety_plans_aggregate: Safety_Plan_Aggregate;
  updated_at: Scalars['timestamp']['output'];
};


/** columns and relationships of "safety_plan_template" */
export type Safety_Plan_TemplateSafety_Plan_Template_Safety_Plan_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


/** columns and relationships of "safety_plan_template" */
export type Safety_Plan_TemplateSafety_Plan_Template_Safety_Plan_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


/** columns and relationships of "safety_plan_template" */
export type Safety_Plan_TemplateSafety_Plan_Template_Safety_PlansArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


/** columns and relationships of "safety_plan_template" */
export type Safety_Plan_TemplateSafety_Plan_Template_Safety_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};

/** aggregated selection of "safety_plan_template" */
export type Safety_Plan_Template_Aggregate = {
  __typename?: 'safety_plan_template_aggregate';
  aggregate?: Maybe<Safety_Plan_Template_Aggregate_Fields>;
  nodes: Array<Safety_Plan_Template>;
};

/** aggregate fields of "safety_plan_template" */
export type Safety_Plan_Template_Aggregate_Fields = {
  __typename?: 'safety_plan_template_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Safety_Plan_Template_Max_Fields>;
  min?: Maybe<Safety_Plan_Template_Min_Fields>;
};


/** aggregate fields of "safety_plan_template" */
export type Safety_Plan_Template_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safety_Plan_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "safety_plan_template". All fields are combined with a logical 'AND'. */
export type Safety_Plan_Template_Bool_Exp = {
  _and?: InputMaybe<Array<Safety_Plan_Template_Bool_Exp>>;
  _not?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
  _or?: InputMaybe<Array<Safety_Plan_Template_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_read_only?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  plan_type?: InputMaybe<Enum_Safety_Plan_Type_Enum_Comparison_Exp>;
  safety_plan_template_safety_plan_sections?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
  safety_plan_template_safety_plan_sections_aggregate?: InputMaybe<Safety_Plan_Sections_Aggregate_Bool_Exp>;
  safety_plan_template_safety_plans?: InputMaybe<Safety_Plan_Bool_Exp>;
  safety_plan_template_safety_plans_aggregate?: InputMaybe<Safety_Plan_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "safety_plan_template" */
export enum Safety_Plan_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  SafetyPlanTemplatePkey = 'safety_plan_template_pkey',
  /** unique or primary key constraint on columns "name" */
  UniqueTemplateName = 'unique_template_name'
}

/** input type for inserting data into table "safety_plan_template" */
export type Safety_Plan_Template_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_read_only?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Enum_Safety_Plan_Type_Enum>;
  safety_plan_template_safety_plan_sections?: InputMaybe<Safety_Plan_Sections_Arr_Rel_Insert_Input>;
  safety_plan_template_safety_plans?: InputMaybe<Safety_Plan_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Safety_Plan_Template_Max_Fields = {
  __typename?: 'safety_plan_template_max_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Safety_Plan_Template_Min_Fields = {
  __typename?: 'safety_plan_template_min_fields';
  created_at?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "safety_plan_template" */
export type Safety_Plan_Template_Mutation_Response = {
  __typename?: 'safety_plan_template_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Safety_Plan_Template>;
};

/** input type for inserting object relation for remote table "safety_plan_template" */
export type Safety_Plan_Template_Obj_Rel_Insert_Input = {
  data: Safety_Plan_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Safety_Plan_Template_On_Conflict>;
};

/** on_conflict condition type for table "safety_plan_template" */
export type Safety_Plan_Template_On_Conflict = {
  constraint: Safety_Plan_Template_Constraint;
  update_columns?: Array<Safety_Plan_Template_Update_Column>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "safety_plan_template". */
export type Safety_Plan_Template_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_read_only?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  plan_type?: InputMaybe<Order_By>;
  safety_plan_template_safety_plan_sections_aggregate?: InputMaybe<Safety_Plan_Sections_Aggregate_Order_By>;
  safety_plan_template_safety_plans_aggregate?: InputMaybe<Safety_Plan_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: safety_plan_template */
export type Safety_Plan_Template_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "safety_plan_template" */
export enum Safety_Plan_Template_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsReadOnly = 'is_read_only',
  /** column name */
  Name = 'name',
  /** column name */
  PlanType = 'plan_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "safety_plan_template" */
export type Safety_Plan_Template_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_read_only?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Enum_Safety_Plan_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "safety_plan_template" */
export type Safety_Plan_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safety_Plan_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safety_Plan_Template_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_read_only?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan_type?: InputMaybe<Enum_Safety_Plan_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "safety_plan_template" */
export enum Safety_Plan_Template_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsReadOnly = 'is_read_only',
  /** column name */
  Name = 'name',
  /** column name */
  PlanType = 'plan_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Safety_Plan_Template_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Template_Bool_Exp;
};

/** update columns of table "safety_plan" */
export enum Safety_Plan_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Responses = 'responses',
  /** column name */
  SafetyPlanTemplateId = 'safety_plan_template_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'status_changed_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by',
  /** column name */
  UserId = 'user_id'
}

export type Safety_Plan_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Safety_Plan_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Safety_Plan_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Safety_Plan_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Safety_Plan_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Safety_Plan_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safety_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safety_Plan_Bool_Exp;
};

/** columns and relationships of "schedule_blackout_dates" */
export type Schedule_Blackout_Dates = {
  __typename?: 'schedule_blackout_dates';
  blackout_date?: Maybe<Scalars['date']['output']>;
  blackout_following?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  nudge_schedule?: Maybe<Nudge_Schedules>;
  nudge_schedules_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  questionnaire_schedule?: Maybe<Questionnaire_Schedules>;
  questionnaire_schedules_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Aggregate = {
  __typename?: 'schedule_blackout_dates_aggregate';
  aggregate?: Maybe<Schedule_Blackout_Dates_Aggregate_Fields>;
  nodes: Array<Schedule_Blackout_Dates>;
};

export type Schedule_Blackout_Dates_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Schedule_Blackout_Dates_Aggregate_Bool_Exp_Count>;
};

export type Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_And = {
  arguments: Schedule_Blackout_Dates_Select_Column_Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Schedule_Blackout_Dates_Select_Column_Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Schedule_Blackout_Dates_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Aggregate_Fields = {
  __typename?: 'schedule_blackout_dates_aggregate_fields';
  avg?: Maybe<Schedule_Blackout_Dates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Schedule_Blackout_Dates_Max_Fields>;
  min?: Maybe<Schedule_Blackout_Dates_Min_Fields>;
  stddev?: Maybe<Schedule_Blackout_Dates_Stddev_Fields>;
  stddev_pop?: Maybe<Schedule_Blackout_Dates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Schedule_Blackout_Dates_Stddev_Samp_Fields>;
  sum?: Maybe<Schedule_Blackout_Dates_Sum_Fields>;
  var_pop?: Maybe<Schedule_Blackout_Dates_Var_Pop_Fields>;
  var_samp?: Maybe<Schedule_Blackout_Dates_Var_Samp_Fields>;
  variance?: Maybe<Schedule_Blackout_Dates_Variance_Fields>;
};


/** aggregate fields of "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Aggregate_Order_By = {
  avg?: InputMaybe<Schedule_Blackout_Dates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Schedule_Blackout_Dates_Max_Order_By>;
  min?: InputMaybe<Schedule_Blackout_Dates_Min_Order_By>;
  stddev?: InputMaybe<Schedule_Blackout_Dates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Schedule_Blackout_Dates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Schedule_Blackout_Dates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Schedule_Blackout_Dates_Sum_Order_By>;
  var_pop?: InputMaybe<Schedule_Blackout_Dates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Schedule_Blackout_Dates_Var_Samp_Order_By>;
  variance?: InputMaybe<Schedule_Blackout_Dates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Arr_Rel_Insert_Input = {
  data: Array<Schedule_Blackout_Dates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Schedule_Blackout_Dates_On_Conflict>;
};

/** aggregate avg on columns */
export type Schedule_Blackout_Dates_Avg_Fields = {
  __typename?: 'schedule_blackout_dates_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "schedule_blackout_dates". All fields are combined with a logical 'AND'. */
export type Schedule_Blackout_Dates_Bool_Exp = {
  _and?: InputMaybe<Array<Schedule_Blackout_Dates_Bool_Exp>>;
  _not?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
  _or?: InputMaybe<Array<Schedule_Blackout_Dates_Bool_Exp>>;
  blackout_date?: InputMaybe<Date_Comparison_Exp>;
  blackout_following?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  nudge_schedules_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  questionnaire_schedules_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "schedule_blackout_dates" */
export enum Schedule_Blackout_Dates_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScheduleBlackoutDatesPkey = 'schedule_blackout_dates_pkey'
}

/** input type for incrementing numeric columns in table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedules_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedules_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Insert_Input = {
  blackout_date?: InputMaybe<Scalars['date']['input']>;
  blackout_following?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Obj_Rel_Insert_Input>;
  nudge_schedules_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Obj_Rel_Insert_Input>;
  questionnaire_schedules_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Schedule_Blackout_Dates_Max_Fields = {
  __typename?: 'schedule_blackout_dates_max_fields';
  blackout_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Max_Order_By = {
  blackout_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Schedule_Blackout_Dates_Min_Fields = {
  __typename?: 'schedule_blackout_dates_min_fields';
  blackout_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Min_Order_By = {
  blackout_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Mutation_Response = {
  __typename?: 'schedule_blackout_dates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Schedule_Blackout_Dates>;
};

/** on_conflict condition type for table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_On_Conflict = {
  constraint: Schedule_Blackout_Dates_Constraint;
  update_columns?: Array<Schedule_Blackout_Dates_Update_Column>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};

/** Ordering options when selecting data from "schedule_blackout_dates". */
export type Schedule_Blackout_Dates_Order_By = {
  blackout_date?: InputMaybe<Order_By>;
  blackout_following?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nudge_schedule?: InputMaybe<Nudge_Schedules_Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedule?: InputMaybe<Questionnaire_Schedules_Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: schedule_blackout_dates */
export type Schedule_Blackout_Dates_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "schedule_blackout_dates" */
export enum Schedule_Blackout_Dates_Select_Column {
  /** column name */
  BlackoutDate = 'blackout_date',
  /** column name */
  BlackoutFollowing = 'blackout_following',
  /** column name */
  Id = 'id',
  /** column name */
  NudgeSchedulesId = 'nudge_schedules_id',
  /** column name */
  QuestionnaireSchedulesId = 'questionnaire_schedules_id'
}

/** select "schedule_blackout_dates_aggregate_bool_exp_bool_and_arguments_columns" columns of table "schedule_blackout_dates" */
export enum Schedule_Blackout_Dates_Select_Column_Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BlackoutFollowing = 'blackout_following'
}

/** select "schedule_blackout_dates_aggregate_bool_exp_bool_or_arguments_columns" columns of table "schedule_blackout_dates" */
export enum Schedule_Blackout_Dates_Select_Column_Schedule_Blackout_Dates_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BlackoutFollowing = 'blackout_following'
}

/** input type for updating data in table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Set_Input = {
  blackout_date?: InputMaybe<Scalars['date']['input']>;
  blackout_following?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedules_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedules_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Schedule_Blackout_Dates_Stddev_Fields = {
  __typename?: 'schedule_blackout_dates_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Schedule_Blackout_Dates_Stddev_Pop_Fields = {
  __typename?: 'schedule_blackout_dates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Schedule_Blackout_Dates_Stddev_Samp_Fields = {
  __typename?: 'schedule_blackout_dates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Schedule_Blackout_Dates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Schedule_Blackout_Dates_Stream_Cursor_Value_Input = {
  blackout_date?: InputMaybe<Scalars['date']['input']>;
  blackout_following?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nudge_schedules_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedules_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Schedule_Blackout_Dates_Sum_Fields = {
  __typename?: 'schedule_blackout_dates_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** update columns of table "schedule_blackout_dates" */
export enum Schedule_Blackout_Dates_Update_Column {
  /** column name */
  BlackoutDate = 'blackout_date',
  /** column name */
  BlackoutFollowing = 'blackout_following',
  /** column name */
  Id = 'id',
  /** column name */
  NudgeSchedulesId = 'nudge_schedules_id',
  /** column name */
  QuestionnaireSchedulesId = 'questionnaire_schedules_id'
}

export type Schedule_Blackout_Dates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Schedule_Blackout_Dates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Schedule_Blackout_Dates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Schedule_Blackout_Dates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Schedule_Blackout_Dates_Var_Pop_Fields = {
  __typename?: 'schedule_blackout_dates_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Schedule_Blackout_Dates_Var_Samp_Fields = {
  __typename?: 'schedule_blackout_dates_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Schedule_Blackout_Dates_Variance_Fields = {
  __typename?: 'schedule_blackout_dates_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  nudge_schedules_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_schedules_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "schedule_blackout_dates" */
export type Schedule_Blackout_Dates_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  nudge_schedules_id?: InputMaybe<Order_By>;
  questionnaire_schedules_id?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "activity" */
  activity: Array<Activity>;
  /** fetch aggregated fields from the table: "activity" */
  activity_aggregate: Activity_Aggregate;
  /** fetch data from the table: "activity" using primary key columns */
  activity_by_pk?: Maybe<Activity>;
  /** An array relationship */
  activity_rating: Array<Activity_Rating>;
  /** An aggregate relationship */
  activity_rating_aggregate: Activity_Rating_Aggregate;
  /** fetch data from the table: "activity_rating" using primary key columns */
  activity_rating_by_pk?: Maybe<Activity_Rating>;
  /** fetch data from the table in a streaming manner: "activity_rating" */
  activity_rating_stream: Array<Activity_Rating>;
  /** fetch data from the table: "activity_resource" */
  activity_resource: Array<Activity_Resource>;
  /** fetch aggregated fields from the table: "activity_resource" */
  activity_resource_aggregate: Activity_Resource_Aggregate;
  /** fetch data from the table: "activity_resource" using primary key columns */
  activity_resource_by_pk?: Maybe<Activity_Resource>;
  /** fetch data from the table: "activity_resource_category" */
  activity_resource_category: Array<Activity_Resource_Category>;
  /** fetch aggregated fields from the table: "activity_resource_category" */
  activity_resource_category_aggregate: Activity_Resource_Category_Aggregate;
  /** fetch data from the table: "activity_resource_category" using primary key columns */
  activity_resource_category_by_pk?: Maybe<Activity_Resource_Category>;
  /** fetch data from the table in a streaming manner: "activity_resource_category" */
  activity_resource_category_stream: Array<Activity_Resource_Category>;
  /** fetch data from the table in a streaming manner: "activity_resource" */
  activity_resource_stream: Array<Activity_Resource>;
  /** fetch data from the table in a streaming manner: "activity" */
  activity_stream: Array<Activity>;
  /** fetch data from the table: "activity_sub_category" */
  activity_sub_category: Array<Activity_Sub_Category>;
  /** fetch aggregated fields from the table: "activity_sub_category" */
  activity_sub_category_aggregate: Activity_Sub_Category_Aggregate;
  /** fetch data from the table: "activity_sub_category" using primary key columns */
  activity_sub_category_by_pk?: Maybe<Activity_Sub_Category>;
  /** fetch data from the table in a streaming manner: "activity_sub_category" */
  activity_sub_category_stream: Array<Activity_Sub_Category>;
  /** fetch data from the table: "activity_suggested_activities" */
  activity_suggested_activities: Array<Activity_Suggested_Activities>;
  /** fetch aggregated fields from the table: "activity_suggested_activities" */
  activity_suggested_activities_aggregate: Activity_Suggested_Activities_Aggregate;
  /** fetch data from the table: "activity_suggested_activities" using primary key columns */
  activity_suggested_activities_by_pk?: Maybe<Activity_Suggested_Activities>;
  /** fetch data from the table in a streaming manner: "activity_suggested_activities" */
  activity_suggested_activities_stream: Array<Activity_Suggested_Activities>;
  /** fetch data from the table: "assessment_answers" */
  assessment_answers: Array<Assessment_Answers>;
  /** fetch aggregated fields from the table: "assessment_answers" */
  assessment_answers_aggregate: Assessment_Answers_Aggregate;
  /** fetch data from the table: "assessment_answers" using primary key columns */
  assessment_answers_by_pk?: Maybe<Assessment_Answers>;
  /** fetch data from the table in a streaming manner: "assessment_answers" */
  assessment_answers_stream: Array<Assessment_Answers>;
  /** fetch data from the table: "assessment_branching_rules" */
  assessment_branching_rules: Array<Assessment_Branching_Rules>;
  /** fetch aggregated fields from the table: "assessment_branching_rules" */
  assessment_branching_rules_aggregate: Assessment_Branching_Rules_Aggregate;
  /** fetch data from the table: "assessment_branching_rules" using primary key columns */
  assessment_branching_rules_by_pk?: Maybe<Assessment_Branching_Rules>;
  /** fetch data from the table in a streaming manner: "assessment_branching_rules" */
  assessment_branching_rules_stream: Array<Assessment_Branching_Rules>;
  /** fetch data from the table: "assessment_pages" */
  assessment_pages: Array<Assessment_Pages>;
  /** fetch aggregated fields from the table: "assessment_pages" */
  assessment_pages_aggregate: Assessment_Pages_Aggregate;
  /** fetch data from the table: "assessment_pages" using primary key columns */
  assessment_pages_by_pk?: Maybe<Assessment_Pages>;
  /** fetch data from the table in a streaming manner: "assessment_pages" */
  assessment_pages_stream: Array<Assessment_Pages>;
  /** fetch data from the table: "assessment_question_custom_prompt" */
  assessment_question_custom_prompt: Array<Assessment_Question_Custom_Prompt>;
  /** fetch aggregated fields from the table: "assessment_question_custom_prompt" */
  assessment_question_custom_prompt_aggregate: Assessment_Question_Custom_Prompt_Aggregate;
  /** fetch data from the table: "assessment_question_custom_prompt" using primary key columns */
  assessment_question_custom_prompt_by_pk?: Maybe<Assessment_Question_Custom_Prompt>;
  /** fetch data from the table in a streaming manner: "assessment_question_custom_prompt" */
  assessment_question_custom_prompt_stream: Array<Assessment_Question_Custom_Prompt>;
  /** fetch data from the table: "assessment_questions" */
  assessment_questions: Array<Assessment_Questions>;
  /** fetch aggregated fields from the table: "assessment_questions" */
  assessment_questions_aggregate: Assessment_Questions_Aggregate;
  /** fetch data from the table: "assessment_questions" using primary key columns */
  assessment_questions_by_pk?: Maybe<Assessment_Questions>;
  /** fetch data from the table in a streaming manner: "assessment_questions" */
  assessment_questions_stream: Array<Assessment_Questions>;
  /** fetch data from the table: "assessment_takes" */
  assessment_takes: Array<Assessment_Takes>;
  /** fetch aggregated fields from the table: "assessment_takes" */
  assessment_takes_aggregate: Assessment_Takes_Aggregate;
  /** fetch data from the table: "assessment_takes" using primary key columns */
  assessment_takes_by_pk?: Maybe<Assessment_Takes>;
  /** fetch data from the table in a streaming manner: "assessment_takes" */
  assessment_takes_stream: Array<Assessment_Takes>;
  /** fetch data from the table: "assessments" */
  assessments: Array<Assessments>;
  /** fetch aggregated fields from the table: "assessments" */
  assessments_aggregate: Assessments_Aggregate;
  /** fetch data from the table: "assessments" using primary key columns */
  assessments_by_pk?: Maybe<Assessments>;
  /** fetch data from the table in a streaming manner: "assessments" */
  assessments_stream: Array<Assessments>;
  /** fetch data from the table: "auth.account_migration_log" */
  auth_account_migration_log: Array<Auth_Account_Migration_Log>;
  /** fetch aggregated fields from the table: "auth.account_migration_log" */
  auth_account_migration_log_aggregate: Auth_Account_Migration_Log_Aggregate;
  /** fetch data from the table: "auth.account_migration_log" using primary key columns */
  auth_account_migration_log_by_pk?: Maybe<Auth_Account_Migration_Log>;
  /** fetch data from the table in a streaming manner: "auth.account_migration_log" */
  auth_account_migration_log_stream: Array<Auth_Account_Migration_Log>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: Array<Auth_Account_Providers>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: Auth_Account_Providers_Aggregate;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: Maybe<Auth_Account_Providers>;
  /** fetch data from the table in a streaming manner: "auth.account_providers" */
  auth_account_providers_stream: Array<Auth_Account_Providers>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: Array<Auth_Account_Roles>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: Auth_Account_Roles_Aggregate;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: Maybe<Auth_Account_Roles>;
  /** fetch data from the table in a streaming manner: "auth.account_roles" */
  auth_account_roles_stream: Array<Auth_Account_Roles>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: Array<Auth_Accounts>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: Auth_Accounts_Aggregate;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: Maybe<Auth_Accounts>;
  /** fetch data from the table in a streaming manner: "auth.accounts" */
  auth_accounts_stream: Array<Auth_Accounts>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: Array<Auth_Providers>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: Auth_Providers_Aggregate;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: Maybe<Auth_Providers>;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  auth_providers_stream: Array<Auth_Providers>;
  /** fetch data from the table: "auth.refresh_token_usage_log" */
  auth_refresh_token_usage_log: Array<Auth_Refresh_Token_Usage_Log>;
  /** fetch aggregated fields from the table: "auth.refresh_token_usage_log" */
  auth_refresh_token_usage_log_aggregate: Auth_Refresh_Token_Usage_Log_Aggregate;
  /** fetch data from the table: "auth.refresh_token_usage_log" using primary key columns */
  auth_refresh_token_usage_log_by_pk?: Maybe<Auth_Refresh_Token_Usage_Log>;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_usage_log" */
  auth_refresh_token_usage_log_stream: Array<Auth_Refresh_Token_Usage_Log>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: Array<Auth_Refresh_Tokens>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: Auth_Refresh_Tokens_Aggregate;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: Maybe<Auth_Refresh_Tokens>;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  auth_refresh_tokens_stream: Array<Auth_Refresh_Tokens>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: Array<Auth_Roles>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: Auth_Roles_Aggregate;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: Maybe<Auth_Roles>;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  auth_roles_stream: Array<Auth_Roles>;
  /** fetch data from the table: "casemix_category" */
  casemix_category: Array<Casemix_Category>;
  /** fetch aggregated fields from the table: "casemix_category" */
  casemix_category_aggregate: Casemix_Category_Aggregate;
  /** fetch data from the table: "casemix_category" using primary key columns */
  casemix_category_by_pk?: Maybe<Casemix_Category>;
  /** fetch data from the table in a streaming manner: "casemix_category" */
  casemix_category_stream: Array<Casemix_Category>;
  /** An array relationship */
  client_demographics: Array<Client_Demographics>;
  /** An aggregate relationship */
  client_demographics_aggregate: Client_Demographics_Aggregate;
  /** fetch data from the table: "client_demographics" using primary key columns */
  client_demographics_by_pk?: Maybe<Client_Demographics>;
  /** fetch data from the table in a streaming manner: "client_demographics" */
  client_demographics_stream: Array<Client_Demographics>;
  /** An array relationship */
  daily_features: Array<Daily_Features>;
  /** An aggregate relationship */
  daily_features_aggregate: Daily_Features_Aggregate;
  /** fetch data from the table: "daily_features" using primary key columns */
  daily_features_by_pk?: Maybe<Daily_Features>;
  /** fetch data from the table in a streaming manner: "daily_features" */
  daily_features_stream: Array<Daily_Features>;
  /** fetch data from the table: "ehr.client_invite_codes" */
  ehr_client_invite_codes: Array<Ehr_Client_Invite_Codes>;
  /** fetch aggregated fields from the table: "ehr.client_invite_codes" */
  ehr_client_invite_codes_aggregate: Ehr_Client_Invite_Codes_Aggregate;
  /** fetch data from the table: "ehr.client_invite_codes" using primary key columns */
  ehr_client_invite_codes_by_pk?: Maybe<Ehr_Client_Invite_Codes>;
  /** fetch data from the table in a streaming manner: "ehr.client_invite_codes" */
  ehr_client_invite_codes_stream: Array<Ehr_Client_Invite_Codes>;
  /** fetch data from the table: "ehr.ehr_practitioner_map" */
  ehr_ehr_practitioner_map: Array<Ehr_Ehr_Practitioner_Map>;
  /** fetch aggregated fields from the table: "ehr.ehr_practitioner_map" */
  ehr_ehr_practitioner_map_aggregate: Ehr_Ehr_Practitioner_Map_Aggregate;
  /** fetch data from the table: "ehr.ehr_practitioner_map" using primary key columns */
  ehr_ehr_practitioner_map_by_pk?: Maybe<Ehr_Ehr_Practitioner_Map>;
  /** fetch data from the table in a streaming manner: "ehr.ehr_practitioner_map" */
  ehr_ehr_practitioner_map_stream: Array<Ehr_Ehr_Practitioner_Map>;
  /** fetch data from the table: "ehr.xealth_event_notification" */
  ehr_xealth_event_notification: Array<Ehr_Xealth_Event_Notification>;
  /** fetch aggregated fields from the table: "ehr.xealth_event_notification" */
  ehr_xealth_event_notification_aggregate: Ehr_Xealth_Event_Notification_Aggregate;
  /** fetch data from the table: "ehr.xealth_event_notification" using primary key columns */
  ehr_xealth_event_notification_by_pk?: Maybe<Ehr_Xealth_Event_Notification>;
  /** fetch data from the table in a streaming manner: "ehr.xealth_event_notification" */
  ehr_xealth_event_notification_stream: Array<Ehr_Xealth_Event_Notification>;
  /** fetch data from the table: "ehr.xealth_preorder_form" */
  ehr_xealth_preorder_form: Array<Ehr_Xealth_Preorder_Form>;
  /** fetch aggregated fields from the table: "ehr.xealth_preorder_form" */
  ehr_xealth_preorder_form_aggregate: Ehr_Xealth_Preorder_Form_Aggregate;
  /** fetch data from the table: "ehr.xealth_preorder_form" using primary key columns */
  ehr_xealth_preorder_form_by_pk?: Maybe<Ehr_Xealth_Preorder_Form>;
  /** fetch data from the table in a streaming manner: "ehr.xealth_preorder_form" */
  ehr_xealth_preorder_form_stream: Array<Ehr_Xealth_Preorder_Form>;
  /** fetch data from the table: "ehr.xealth_preorder_invite_map" */
  ehr_xealth_preorder_invite_map: Array<Ehr_Xealth_Preorder_Invite_Map>;
  /** fetch aggregated fields from the table: "ehr.xealth_preorder_invite_map" */
  ehr_xealth_preorder_invite_map_aggregate: Ehr_Xealth_Preorder_Invite_Map_Aggregate;
  /** fetch data from the table: "ehr.xealth_preorder_invite_map" using primary key columns */
  ehr_xealth_preorder_invite_map_by_pk?: Maybe<Ehr_Xealth_Preorder_Invite_Map>;
  /** fetch data from the table in a streaming manner: "ehr.xealth_preorder_invite_map" */
  ehr_xealth_preorder_invite_map_stream: Array<Ehr_Xealth_Preorder_Invite_Map>;
  /** fetch data from the table: "enum_activity_category" */
  enum_activity_category: Array<Enum_Activity_Category>;
  /** fetch aggregated fields from the table: "enum_activity_category" */
  enum_activity_category_aggregate: Enum_Activity_Category_Aggregate;
  /** fetch data from the table: "enum_activity_category" using primary key columns */
  enum_activity_category_by_pk?: Maybe<Enum_Activity_Category>;
  /** fetch data from the table in a streaming manner: "enum_activity_category" */
  enum_activity_category_stream: Array<Enum_Activity_Category>;
  /** fetch data from the table: "enum_activity_resource_type" */
  enum_activity_resource_type: Array<Enum_Activity_Resource_Type>;
  /** fetch aggregated fields from the table: "enum_activity_resource_type" */
  enum_activity_resource_type_aggregate: Enum_Activity_Resource_Type_Aggregate;
  /** fetch data from the table: "enum_activity_resource_type" using primary key columns */
  enum_activity_resource_type_by_pk?: Maybe<Enum_Activity_Resource_Type>;
  /** fetch data from the table in a streaming manner: "enum_activity_resource_type" */
  enum_activity_resource_type_stream: Array<Enum_Activity_Resource_Type>;
  /** fetch data from the table: "enum_completion_status" */
  enum_completion_status: Array<Enum_Completion_Status>;
  /** fetch aggregated fields from the table: "enum_completion_status" */
  enum_completion_status_aggregate: Enum_Completion_Status_Aggregate;
  /** fetch data from the table: "enum_completion_status" using primary key columns */
  enum_completion_status_by_pk?: Maybe<Enum_Completion_Status>;
  /** fetch data from the table in a streaming manner: "enum_completion_status" */
  enum_completion_status_stream: Array<Enum_Completion_Status>;
  /** fetch data from the table: "enum_feature_direction" */
  enum_feature_direction: Array<Enum_Feature_Direction>;
  /** fetch aggregated fields from the table: "enum_feature_direction" */
  enum_feature_direction_aggregate: Enum_Feature_Direction_Aggregate;
  /** fetch data from the table: "enum_feature_direction" using primary key columns */
  enum_feature_direction_by_pk?: Maybe<Enum_Feature_Direction>;
  /** fetch data from the table in a streaming manner: "enum_feature_direction" */
  enum_feature_direction_stream: Array<Enum_Feature_Direction>;
  /** fetch data from the table: "enum_feature_type" */
  enum_feature_type: Array<Enum_Feature_Type>;
  /** fetch aggregated fields from the table: "enum_feature_type" */
  enum_feature_type_aggregate: Enum_Feature_Type_Aggregate;
  /** fetch data from the table: "enum_feature_type" using primary key columns */
  enum_feature_type_by_pk?: Maybe<Enum_Feature_Type>;
  /** fetch data from the table in a streaming manner: "enum_feature_type" */
  enum_feature_type_stream: Array<Enum_Feature_Type>;
  /** fetch data from the table: "enum_gender" */
  enum_gender: Array<Enum_Gender>;
  /** fetch aggregated fields from the table: "enum_gender" */
  enum_gender_aggregate: Enum_Gender_Aggregate;
  /** fetch data from the table: "enum_gender" using primary key columns */
  enum_gender_by_pk?: Maybe<Enum_Gender>;
  /** fetch data from the table in a streaming manner: "enum_gender" */
  enum_gender_stream: Array<Enum_Gender>;
  /** fetch data from the table: "enum_insight_content_type" */
  enum_insight_content_type: Array<Enum_Insight_Content_Type>;
  /** fetch aggregated fields from the table: "enum_insight_content_type" */
  enum_insight_content_type_aggregate: Enum_Insight_Content_Type_Aggregate;
  /** fetch data from the table: "enum_insight_content_type" using primary key columns */
  enum_insight_content_type_by_pk?: Maybe<Enum_Insight_Content_Type>;
  /** fetch data from the table in a streaming manner: "enum_insight_content_type" */
  enum_insight_content_type_stream: Array<Enum_Insight_Content_Type>;
  /** fetch data from the table: "enum_mobile_permission_status" */
  enum_mobile_permission_status: Array<Enum_Mobile_Permission_Status>;
  /** fetch aggregated fields from the table: "enum_mobile_permission_status" */
  enum_mobile_permission_status_aggregate: Enum_Mobile_Permission_Status_Aggregate;
  /** fetch data from the table: "enum_mobile_permission_status" using primary key columns */
  enum_mobile_permission_status_by_pk?: Maybe<Enum_Mobile_Permission_Status>;
  /** fetch data from the table in a streaming manner: "enum_mobile_permission_status" */
  enum_mobile_permission_status_stream: Array<Enum_Mobile_Permission_Status>;
  /** fetch data from the table: "enum_mobile_permission_type" */
  enum_mobile_permission_type: Array<Enum_Mobile_Permission_Type>;
  /** fetch aggregated fields from the table: "enum_mobile_permission_type" */
  enum_mobile_permission_type_aggregate: Enum_Mobile_Permission_Type_Aggregate;
  /** fetch data from the table: "enum_mobile_permission_type" using primary key columns */
  enum_mobile_permission_type_by_pk?: Maybe<Enum_Mobile_Permission_Type>;
  /** fetch data from the table in a streaming manner: "enum_mobile_permission_type" */
  enum_mobile_permission_type_stream: Array<Enum_Mobile_Permission_Type>;
  /** fetch data from the table: "enum_outcome" */
  enum_outcome: Array<Enum_Outcome>;
  /** fetch aggregated fields from the table: "enum_outcome" */
  enum_outcome_aggregate: Enum_Outcome_Aggregate;
  /** fetch data from the table: "enum_outcome" using primary key columns */
  enum_outcome_by_pk?: Maybe<Enum_Outcome>;
  /** fetch data from the table in a streaming manner: "enum_outcome" */
  enum_outcome_stream: Array<Enum_Outcome>;
  /** fetch data from the table: "enum_question_type" */
  enum_question_type: Array<Enum_Question_Type>;
  /** fetch aggregated fields from the table: "enum_question_type" */
  enum_question_type_aggregate: Enum_Question_Type_Aggregate;
  /** fetch data from the table: "enum_question_type" using primary key columns */
  enum_question_type_by_pk?: Maybe<Enum_Question_Type>;
  /** fetch data from the table in a streaming manner: "enum_question_type" */
  enum_question_type_stream: Array<Enum_Question_Type>;
  /** fetch data from the table: "enum_racial_ethnic" */
  enum_racial_ethnic: Array<Enum_Racial_Ethnic>;
  /** fetch aggregated fields from the table: "enum_racial_ethnic" */
  enum_racial_ethnic_aggregate: Enum_Racial_Ethnic_Aggregate;
  /** fetch data from the table: "enum_racial_ethnic" using primary key columns */
  enum_racial_ethnic_by_pk?: Maybe<Enum_Racial_Ethnic>;
  /** fetch data from the table in a streaming manner: "enum_racial_ethnic" */
  enum_racial_ethnic_stream: Array<Enum_Racial_Ethnic>;
  /** fetch data from the table: "enum_resource_type" */
  enum_resource_type: Array<Enum_Resource_Type>;
  /** fetch aggregated fields from the table: "enum_resource_type" */
  enum_resource_type_aggregate: Enum_Resource_Type_Aggregate;
  /** fetch data from the table: "enum_resource_type" using primary key columns */
  enum_resource_type_by_pk?: Maybe<Enum_Resource_Type>;
  /** fetch data from the table in a streaming manner: "enum_resource_type" */
  enum_resource_type_stream: Array<Enum_Resource_Type>;
  /** fetch data from the table: "enum_safety_plan_section_category_type" */
  enum_safety_plan_section_category_type: Array<Enum_Safety_Plan_Section_Category_Type>;
  /** fetch aggregated fields from the table: "enum_safety_plan_section_category_type" */
  enum_safety_plan_section_category_type_aggregate: Enum_Safety_Plan_Section_Category_Type_Aggregate;
  /** fetch data from the table: "enum_safety_plan_section_category_type" using primary key columns */
  enum_safety_plan_section_category_type_by_pk?: Maybe<Enum_Safety_Plan_Section_Category_Type>;
  /** fetch data from the table in a streaming manner: "enum_safety_plan_section_category_type" */
  enum_safety_plan_section_category_type_stream: Array<Enum_Safety_Plan_Section_Category_Type>;
  /** fetch data from the table: "enum_safety_plan_section_icons" */
  enum_safety_plan_section_icons: Array<Enum_Safety_Plan_Section_Icons>;
  /** fetch aggregated fields from the table: "enum_safety_plan_section_icons" */
  enum_safety_plan_section_icons_aggregate: Enum_Safety_Plan_Section_Icons_Aggregate;
  /** fetch data from the table: "enum_safety_plan_section_icons" using primary key columns */
  enum_safety_plan_section_icons_by_pk?: Maybe<Enum_Safety_Plan_Section_Icons>;
  /** fetch data from the table in a streaming manner: "enum_safety_plan_section_icons" */
  enum_safety_plan_section_icons_stream: Array<Enum_Safety_Plan_Section_Icons>;
  /** fetch data from the table: "enum_safety_plan_status" */
  enum_safety_plan_status: Array<Enum_Safety_Plan_Status>;
  /** fetch aggregated fields from the table: "enum_safety_plan_status" */
  enum_safety_plan_status_aggregate: Enum_Safety_Plan_Status_Aggregate;
  /** fetch data from the table: "enum_safety_plan_status" using primary key columns */
  enum_safety_plan_status_by_pk?: Maybe<Enum_Safety_Plan_Status>;
  /** fetch data from the table in a streaming manner: "enum_safety_plan_status" */
  enum_safety_plan_status_stream: Array<Enum_Safety_Plan_Status>;
  /** fetch data from the table: "enum_safety_plan_type" */
  enum_safety_plan_type: Array<Enum_Safety_Plan_Type>;
  /** fetch aggregated fields from the table: "enum_safety_plan_type" */
  enum_safety_plan_type_aggregate: Enum_Safety_Plan_Type_Aggregate;
  /** fetch data from the table: "enum_safety_plan_type" using primary key columns */
  enum_safety_plan_type_by_pk?: Maybe<Enum_Safety_Plan_Type>;
  /** fetch data from the table in a streaming manner: "enum_safety_plan_type" */
  enum_safety_plan_type_stream: Array<Enum_Safety_Plan_Type>;
  /** fetch data from the table: "enum_trend_direction" */
  enum_trend_direction: Array<Enum_Trend_Direction>;
  /** fetch aggregated fields from the table: "enum_trend_direction" */
  enum_trend_direction_aggregate: Enum_Trend_Direction_Aggregate;
  /** fetch data from the table: "enum_trend_direction" using primary key columns */
  enum_trend_direction_by_pk?: Maybe<Enum_Trend_Direction>;
  /** fetch data from the table in a streaming manner: "enum_trend_direction" */
  enum_trend_direction_stream: Array<Enum_Trend_Direction>;
  /** fetch data from the table: "feature_report_feature_coefficients" */
  feature_report_feature_coefficients: Array<Feature_Report_Feature_Coefficients>;
  /** fetch aggregated fields from the table: "feature_report_feature_coefficients" */
  feature_report_feature_coefficients_aggregate: Feature_Report_Feature_Coefficients_Aggregate;
  /** fetch data from the table: "feature_report_feature_coefficients" using primary key columns */
  feature_report_feature_coefficients_by_pk?: Maybe<Feature_Report_Feature_Coefficients>;
  /** fetch data from the table in a streaming manner: "feature_report_feature_coefficients" */
  feature_report_feature_coefficients_stream: Array<Feature_Report_Feature_Coefficients>;
  /** An array relationship */
  feature_report_features: Array<Feature_Report_Features>;
  /** An aggregate relationship */
  feature_report_features_aggregate: Feature_Report_Features_Aggregate;
  /** fetch data from the table: "feature_report_features" using primary key columns */
  feature_report_features_by_pk?: Maybe<Feature_Report_Features>;
  /** fetch data from the table in a streaming manner: "feature_report_features" */
  feature_report_features_stream: Array<Feature_Report_Features>;
  /** An array relationship */
  feature_reports: Array<Feature_Reports>;
  /** An aggregate relationship */
  feature_reports_aggregate: Feature_Reports_Aggregate;
  /** fetch data from the table: "feature_reports" using primary key columns */
  feature_reports_by_pk?: Maybe<Feature_Reports>;
  /** fetch data from the table in a streaming manner: "feature_reports" */
  feature_reports_stream: Array<Feature_Reports>;
  /** fetch data from the table: "group_code" */
  group_code: Array<Group_Code>;
  /** fetch aggregated fields from the table: "group_code" */
  group_code_aggregate: Group_Code_Aggregate;
  /** fetch data from the table: "group_code" using primary key columns */
  group_code_by_pk?: Maybe<Group_Code>;
  /** fetch data from the table in a streaming manner: "group_code" */
  group_code_stream: Array<Group_Code>;
  /** An array relationship */
  insight_articles: Array<Insight_Articles>;
  /** An aggregate relationship */
  insight_articles_aggregate: Insight_Articles_Aggregate;
  /** fetch data from the table: "insight_articles" using primary key columns */
  insight_articles_by_pk?: Maybe<Insight_Articles>;
  /** fetch data from the table in a streaming manner: "insight_articles" */
  insight_articles_stream: Array<Insight_Articles>;
  /** fetch data from the table: "insight_combos" */
  insight_combos: Array<Insight_Combos>;
  /** fetch aggregated fields from the table: "insight_combos" */
  insight_combos_aggregate: Insight_Combos_Aggregate;
  /** fetch data from the table: "insight_combos" using primary key columns */
  insight_combos_by_pk?: Maybe<Insight_Combos>;
  /** fetch data from the table in a streaming manner: "insight_combos" */
  insight_combos_stream: Array<Insight_Combos>;
  /** An array relationship */
  insight_hows: Array<Insight_Hows>;
  /** An aggregate relationship */
  insight_hows_aggregate: Insight_Hows_Aggregate;
  /** fetch data from the table: "insight_hows" using primary key columns */
  insight_hows_by_pk?: Maybe<Insight_Hows>;
  /** fetch data from the table in a streaming manner: "insight_hows" */
  insight_hows_stream: Array<Insight_Hows>;
  /** fetch data from the table: "insight_plan_article" */
  insight_plan_article: Array<Insight_Plan_Article>;
  /** fetch aggregated fields from the table: "insight_plan_article" */
  insight_plan_article_aggregate: Insight_Plan_Article_Aggregate;
  /** fetch data from the table: "insight_plan_article" using primary key columns */
  insight_plan_article_by_pk?: Maybe<Insight_Plan_Article>;
  /** fetch data from the table in a streaming manner: "insight_plan_article" */
  insight_plan_article_stream: Array<Insight_Plan_Article>;
  /** fetch data from the table: "insight_plan_text" */
  insight_plan_text: Array<Insight_Plan_Text>;
  /** fetch aggregated fields from the table: "insight_plan_text" */
  insight_plan_text_aggregate: Insight_Plan_Text_Aggregate;
  /** fetch data from the table: "insight_plan_text" using primary key columns */
  insight_plan_text_by_pk?: Maybe<Insight_Plan_Text>;
  /** fetch data from the table in a streaming manner: "insight_plan_text" */
  insight_plan_text_stream: Array<Insight_Plan_Text>;
  /** An array relationship */
  insight_plans: Array<Insight_Plans>;
  /** An aggregate relationship */
  insight_plans_aggregate: Insight_Plans_Aggregate;
  /** fetch data from the table: "insight_plans" using primary key columns */
  insight_plans_by_pk?: Maybe<Insight_Plans>;
  /** fetch data from the table in a streaming manner: "insight_plans" */
  insight_plans_stream: Array<Insight_Plans>;
  /** An array relationship */
  insight_questions: Array<Insight_Questions>;
  /** An aggregate relationship */
  insight_questions_aggregate: Insight_Questions_Aggregate;
  /** fetch data from the table: "insight_questions" using primary key columns */
  insight_questions_by_pk?: Maybe<Insight_Questions>;
  /** fetch data from the table in a streaming manner: "insight_questions" */
  insight_questions_stream: Array<Insight_Questions>;
  /** An array relationship */
  insight_recipes: Array<Insight_Recipes>;
  /** An aggregate relationship */
  insight_recipes_aggregate: Insight_Recipes_Aggregate;
  /** fetch data from the table: "insight_recipes" using primary key columns */
  insight_recipes_by_pk?: Maybe<Insight_Recipes>;
  /** fetch data from the table in a streaming manner: "insight_recipes" */
  insight_recipes_stream: Array<Insight_Recipes>;
  /** fetch data from the table: "insight_reflect" */
  insight_reflect: Array<Insight_Reflect>;
  /** fetch aggregated fields from the table: "insight_reflect" */
  insight_reflect_aggregate: Insight_Reflect_Aggregate;
  /** fetch data from the table: "insight_reflect" using primary key columns */
  insight_reflect_by_pk?: Maybe<Insight_Reflect>;
  /** fetch data from the table in a streaming manner: "insight_reflect" */
  insight_reflect_stream: Array<Insight_Reflect>;
  /** fetch data from the table: "insight_reflect_text" */
  insight_reflect_text: Array<Insight_Reflect_Text>;
  /** fetch aggregated fields from the table: "insight_reflect_text" */
  insight_reflect_text_aggregate: Insight_Reflect_Text_Aggregate;
  /** fetch data from the table: "insight_reflect_text" using primary key columns */
  insight_reflect_text_by_pk?: Maybe<Insight_Reflect_Text>;
  /** fetch data from the table in a streaming manner: "insight_reflect_text" */
  insight_reflect_text_stream: Array<Insight_Reflect_Text>;
  /** An array relationship */
  insight_resources: Array<Insight_Resources>;
  /** An aggregate relationship */
  insight_resources_aggregate: Insight_Resources_Aggregate;
  /** fetch data from the table: "insight_resources" using primary key columns */
  insight_resources_by_pk?: Maybe<Insight_Resources>;
  /** fetch data from the table in a streaming manner: "insight_resources" */
  insight_resources_stream: Array<Insight_Resources>;
  /** fetch data from the table: "insight_texts" */
  insight_texts: Array<Insight_Texts>;
  /** fetch aggregated fields from the table: "insight_texts" */
  insight_texts_aggregate: Insight_Texts_Aggregate;
  /** fetch data from the table: "insight_texts" using primary key columns */
  insight_texts_by_pk?: Maybe<Insight_Texts>;
  /** fetch data from the table in a streaming manner: "insight_texts" */
  insight_texts_stream: Array<Insight_Texts>;
  /** fetch data from the table: "insight_tips" */
  insight_tips: Array<Insight_Tips>;
  /** fetch aggregated fields from the table: "insight_tips" */
  insight_tips_aggregate: Insight_Tips_Aggregate;
  /** fetch data from the table: "insight_tips" using primary key columns */
  insight_tips_by_pk?: Maybe<Insight_Tips>;
  /** fetch data from the table in a streaming manner: "insight_tips" */
  insight_tips_stream: Array<Insight_Tips>;
  /** An array relationship */
  insight_whys: Array<Insight_Whys>;
  /** An aggregate relationship */
  insight_whys_aggregate: Insight_Whys_Aggregate;
  /** fetch data from the table: "insight_whys" using primary key columns */
  insight_whys_by_pk?: Maybe<Insight_Whys>;
  /** fetch data from the table in a streaming manner: "insight_whys" */
  insight_whys_stream: Array<Insight_Whys>;
  /** fetch data from the table: "invite_codes" */
  invite_codes: Array<Invite_Codes>;
  /** fetch aggregated fields from the table: "invite_codes" */
  invite_codes_aggregate: Invite_Codes_Aggregate;
  /** fetch data from the table: "invite_codes" using primary key columns */
  invite_codes_by_pk?: Maybe<Invite_Codes>;
  /** fetch data from the table in a streaming manner: "invite_codes" */
  invite_codes_stream: Array<Invite_Codes>;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table in a streaming manner: "logs" */
  logs_stream: Array<Logs>;
  /** An array relationship */
  mobile_device_data: Array<Mobile_Device_Data>;
  /** An aggregate relationship */
  mobile_device_data_aggregate: Mobile_Device_Data_Aggregate;
  /** fetch data from the table: "mobile_device_data" using primary key columns */
  mobile_device_data_by_pk?: Maybe<Mobile_Device_Data>;
  /** fetch data from the table in a streaming manner: "mobile_device_data" */
  mobile_device_data_stream: Array<Mobile_Device_Data>;
  /** fetch data from the table: "mobile_permissions" */
  mobile_permissions: Array<Mobile_Permissions>;
  /** fetch aggregated fields from the table: "mobile_permissions" */
  mobile_permissions_aggregate: Mobile_Permissions_Aggregate;
  /** fetch data from the table: "mobile_permissions" using primary key columns */
  mobile_permissions_by_pk?: Maybe<Mobile_Permissions>;
  /** fetch data from the table in a streaming manner: "mobile_permissions" */
  mobile_permissions_stream: Array<Mobile_Permissions>;
  /** fetch data from the table: "mobile_upload_log" */
  mobile_upload_log: Array<Mobile_Upload_Log>;
  /** fetch aggregated fields from the table: "mobile_upload_log" */
  mobile_upload_log_aggregate: Mobile_Upload_Log_Aggregate;
  /** fetch data from the table: "mobile_upload_log" using primary key columns */
  mobile_upload_log_by_pk?: Maybe<Mobile_Upload_Log>;
  /** fetch data from the table in a streaming manner: "mobile_upload_log" */
  mobile_upload_log_stream: Array<Mobile_Upload_Log>;
  /** An array relationship */
  mood_measurements: Array<Mood_Measurements>;
  /** An aggregate relationship */
  mood_measurements_aggregate: Mood_Measurements_Aggregate;
  /** fetch data from the table: "mood_measurements" using primary key columns */
  mood_measurements_by_pk?: Maybe<Mood_Measurements>;
  /** fetch data from the table in a streaming manner: "mood_measurements" */
  mood_measurements_stream: Array<Mood_Measurements>;
  /** An array relationship */
  nudge_schedules: Array<Nudge_Schedules>;
  /** An aggregate relationship */
  nudge_schedules_aggregate: Nudge_Schedules_Aggregate;
  /** fetch data from the table: "nudge_schedules" using primary key columns */
  nudge_schedules_by_pk?: Maybe<Nudge_Schedules>;
  /** fetch data from the table in a streaming manner: "nudge_schedules" */
  nudge_schedules_stream: Array<Nudge_Schedules>;
  /** An array relationship */
  nudge_takes: Array<Nudge_Takes>;
  /** An aggregate relationship */
  nudge_takes_aggregate: Nudge_Takes_Aggregate;
  /** fetch data from the table: "nudge_takes" using primary key columns */
  nudge_takes_by_pk?: Maybe<Nudge_Takes>;
  /** fetch data from the table in a streaming manner: "nudge_takes" */
  nudge_takes_stream: Array<Nudge_Takes>;
  /** fetch data from the table: "nudges" */
  nudges: Array<Nudges>;
  /** fetch aggregated fields from the table: "nudges" */
  nudges_aggregate: Nudges_Aggregate;
  /** fetch data from the table: "nudges" using primary key columns */
  nudges_by_pk?: Maybe<Nudges>;
  /** fetch data from the table in a streaming manner: "nudges" */
  nudges_stream: Array<Nudges>;
  /** An array relationship */
  organization_admins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** fetch data from the table: "organization_admins" using primary key columns */
  organization_admins_by_pk?: Maybe<Organization_Admins>;
  /** fetch data from the table in a streaming manner: "organization_admins" */
  organization_admins_stream: Array<Organization_Admins>;
  /** fetch data from the table: "organization_features" */
  organization_features: Array<Organization_Features>;
  /** fetch aggregated fields from the table: "organization_features" */
  organization_features_aggregate: Organization_Features_Aggregate;
  /** fetch data from the table: "organization_features" using primary key columns */
  organization_features_by_pk?: Maybe<Organization_Features>;
  /** fetch data from the table in a streaming manner: "organization_features" */
  organization_features_stream: Array<Organization_Features>;
  /** fetch data from the table: "organization_member_roles" */
  organization_member_roles: Array<Organization_Member_Roles>;
  /** fetch aggregated fields from the table: "organization_member_roles" */
  organization_member_roles_aggregate: Organization_Member_Roles_Aggregate;
  /** fetch data from the table: "organization_member_roles" using primary key columns */
  organization_member_roles_by_pk?: Maybe<Organization_Member_Roles>;
  /** fetch data from the table in a streaming manner: "organization_member_roles" */
  organization_member_roles_stream: Array<Organization_Member_Roles>;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  /** fetch data from the table: "organization_members" using primary key columns */
  organization_members_by_pk?: Maybe<Organization_Members>;
  /** fetch data from the table in a streaming manner: "organization_members" */
  organization_members_stream: Array<Organization_Members>;
  /** fetch data from the table: "organization_supervisees" */
  organization_supervisees: Array<Organization_Supervisees>;
  /** fetch aggregated fields from the table: "organization_supervisees" */
  organization_supervisees_aggregate: Organization_Supervisees_Aggregate;
  /** fetch data from the table: "organization_supervisees" using primary key columns */
  organization_supervisees_by_pk?: Maybe<Organization_Supervisees>;
  /** fetch data from the table in a streaming manner: "organization_supervisees" */
  organization_supervisees_stream: Array<Organization_Supervisees>;
  /** An array relationship */
  organization_supervisors: Array<Organization_Supervisors>;
  /** An aggregate relationship */
  organization_supervisors_aggregate: Organization_Supervisors_Aggregate;
  /** fetch data from the table: "organization_supervisors" using primary key columns */
  organization_supervisors_by_pk?: Maybe<Organization_Supervisors>;
  /** fetch data from the table in a streaming manner: "organization_supervisors" */
  organization_supervisors_stream: Array<Organization_Supervisors>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** An array relationship */
  questionnaire_items: Array<Questionnaire_Items>;
  /** An aggregate relationship */
  questionnaire_items_aggregate: Questionnaire_Items_Aggregate;
  /** fetch data from the table: "questionnaire_items" using primary key columns */
  questionnaire_items_by_pk?: Maybe<Questionnaire_Items>;
  /** fetch data from the table in a streaming manner: "questionnaire_items" */
  questionnaire_items_stream: Array<Questionnaire_Items>;
  /** fetch data from the table: "questionnaire_response_options" */
  questionnaire_response_options: Array<Questionnaire_Response_Options>;
  /** fetch aggregated fields from the table: "questionnaire_response_options" */
  questionnaire_response_options_aggregate: Questionnaire_Response_Options_Aggregate;
  /** fetch data from the table: "questionnaire_response_options" using primary key columns */
  questionnaire_response_options_by_pk?: Maybe<Questionnaire_Response_Options>;
  /** fetch data from the table in a streaming manner: "questionnaire_response_options" */
  questionnaire_response_options_stream: Array<Questionnaire_Response_Options>;
  /** An array relationship */
  questionnaire_responses: Array<Questionnaire_Responses>;
  /** An aggregate relationship */
  questionnaire_responses_aggregate: Questionnaire_Responses_Aggregate;
  /** fetch data from the table: "questionnaire_responses" using primary key columns */
  questionnaire_responses_by_pk?: Maybe<Questionnaire_Responses>;
  /** fetch data from the table in a streaming manner: "questionnaire_responses" */
  questionnaire_responses_stream: Array<Questionnaire_Responses>;
  /** fetch data from the table: "questionnaire_risk_alert_contacts" */
  questionnaire_risk_alert_contacts: Array<Questionnaire_Risk_Alert_Contacts>;
  /** fetch aggregated fields from the table: "questionnaire_risk_alert_contacts" */
  questionnaire_risk_alert_contacts_aggregate: Questionnaire_Risk_Alert_Contacts_Aggregate;
  /** fetch data from the table: "questionnaire_risk_alert_contacts" using primary key columns */
  questionnaire_risk_alert_contacts_by_pk?: Maybe<Questionnaire_Risk_Alert_Contacts>;
  /** fetch data from the table in a streaming manner: "questionnaire_risk_alert_contacts" */
  questionnaire_risk_alert_contacts_stream: Array<Questionnaire_Risk_Alert_Contacts>;
  /** An array relationship */
  questionnaire_schedules: Array<Questionnaire_Schedules>;
  /** An aggregate relationship */
  questionnaire_schedules_aggregate: Questionnaire_Schedules_Aggregate;
  /** fetch data from the table: "questionnaire_schedules" using primary key columns */
  questionnaire_schedules_by_pk?: Maybe<Questionnaire_Schedules>;
  /** fetch data from the table in a streaming manner: "questionnaire_schedules" */
  questionnaire_schedules_stream: Array<Questionnaire_Schedules>;
  /** fetch data from the table: "questionnaire_scoring" */
  questionnaire_scoring: Array<Questionnaire_Scoring>;
  /** fetch aggregated fields from the table: "questionnaire_scoring" */
  questionnaire_scoring_aggregate: Questionnaire_Scoring_Aggregate;
  /** fetch data from the table: "questionnaire_scoring" using primary key columns */
  questionnaire_scoring_by_pk?: Maybe<Questionnaire_Scoring>;
  /** fetch data from the table in a streaming manner: "questionnaire_scoring" */
  questionnaire_scoring_stream: Array<Questionnaire_Scoring>;
  /** An array relationship */
  questionnaire_takes: Array<Questionnaire_Takes>;
  /** An aggregate relationship */
  questionnaire_takes_aggregate: Questionnaire_Takes_Aggregate;
  /** fetch data from the table: "questionnaire_takes" using primary key columns */
  questionnaire_takes_by_pk?: Maybe<Questionnaire_Takes>;
  /** fetch data from the table in a streaming manner: "questionnaire_takes" */
  questionnaire_takes_stream: Array<Questionnaire_Takes>;
  /** fetch data from the table: "questionnaires" */
  questionnaires: Array<Questionnaires>;
  /** fetch aggregated fields from the table: "questionnaires" */
  questionnaires_aggregate: Questionnaires_Aggregate;
  /** fetch data from the table: "questionnaires" using primary key columns */
  questionnaires_by_pk?: Maybe<Questionnaires>;
  /** fetch data from the table in a streaming manner: "questionnaires" */
  questionnaires_stream: Array<Questionnaires>;
  /** fetch data from the table: "relapse_prevention_place_visits" */
  relapse_prevention_place_visits: Array<Relapse_Prevention_Place_Visits>;
  /** fetch aggregated fields from the table: "relapse_prevention_place_visits" */
  relapse_prevention_place_visits_aggregate: Relapse_Prevention_Place_Visits_Aggregate;
  /** fetch data from the table: "relapse_prevention_place_visits" using primary key columns */
  relapse_prevention_place_visits_by_pk?: Maybe<Relapse_Prevention_Place_Visits>;
  /** fetch data from the table in a streaming manner: "relapse_prevention_place_visits" */
  relapse_prevention_place_visits_stream: Array<Relapse_Prevention_Place_Visits>;
  /** fetch data from the table: "relapse_prevention_places" */
  relapse_prevention_places: Array<Relapse_Prevention_Places>;
  /** fetch aggregated fields from the table: "relapse_prevention_places" */
  relapse_prevention_places_aggregate: Relapse_Prevention_Places_Aggregate;
  /** fetch data from the table: "relapse_prevention_places" using primary key columns */
  relapse_prevention_places_by_pk?: Maybe<Relapse_Prevention_Places>;
  /** fetch data from the table in a streaming manner: "relapse_prevention_places" */
  relapse_prevention_places_stream: Array<Relapse_Prevention_Places>;
  /** fetch data from the table: "resources" */
  resources: Array<Resources>;
  /** fetch aggregated fields from the table: "resources" */
  resources_aggregate: Resources_Aggregate;
  /** fetch data from the table: "resources" using primary key columns */
  resources_by_pk?: Maybe<Resources>;
  /** fetch data from the table: "resources_orgs" */
  resources_orgs: Array<Resources_Orgs>;
  /** fetch aggregated fields from the table: "resources_orgs" */
  resources_orgs_aggregate: Resources_Orgs_Aggregate;
  /** fetch data from the table: "resources_orgs" using primary key columns */
  resources_orgs_by_pk?: Maybe<Resources_Orgs>;
  /** fetch data from the table in a streaming manner: "resources_orgs" */
  resources_orgs_stream: Array<Resources_Orgs>;
  /** fetch data from the table in a streaming manner: "resources" */
  resources_stream: Array<Resources>;
  /** fetch data from the table: "risk_alerts_log" */
  risk_alerts_log: Array<Risk_Alerts_Log>;
  /** fetch aggregated fields from the table: "risk_alerts_log" */
  risk_alerts_log_aggregate: Risk_Alerts_Log_Aggregate;
  /** fetch data from the table: "risk_alerts_log" using primary key columns */
  risk_alerts_log_by_pk?: Maybe<Risk_Alerts_Log>;
  /** fetch data from the table in a streaming manner: "risk_alerts_log" */
  risk_alerts_log_stream: Array<Risk_Alerts_Log>;
  /** fetch data from the table: "risk_alerts_recipients_log" */
  risk_alerts_recipients_log: Array<Risk_Alerts_Recipients_Log>;
  /** fetch aggregated fields from the table: "risk_alerts_recipients_log" */
  risk_alerts_recipients_log_aggregate: Risk_Alerts_Recipients_Log_Aggregate;
  /** fetch data from the table: "risk_alerts_recipients_log" using primary key columns */
  risk_alerts_recipients_log_by_pk?: Maybe<Risk_Alerts_Recipients_Log>;
  /** fetch data from the table in a streaming manner: "risk_alerts_recipients_log" */
  risk_alerts_recipients_log_stream: Array<Risk_Alerts_Recipients_Log>;
  /** fetch data from the table: "role_capabilities" */
  role_capabilities: Array<Role_Capabilities>;
  /** fetch aggregated fields from the table: "role_capabilities" */
  role_capabilities_aggregate: Role_Capabilities_Aggregate;
  /** fetch data from the table: "role_capabilities" using primary key columns */
  role_capabilities_by_pk?: Maybe<Role_Capabilities>;
  /** fetch data from the table in a streaming manner: "role_capabilities" */
  role_capabilities_stream: Array<Role_Capabilities>;
  /** fetch data from the table: "safety_checklist_recipients_log" */
  safety_checklist_recipients_log: Array<Safety_Checklist_Recipients_Log>;
  /** fetch aggregated fields from the table: "safety_checklist_recipients_log" */
  safety_checklist_recipients_log_aggregate: Safety_Checklist_Recipients_Log_Aggregate;
  /** fetch data from the table: "safety_checklist_recipients_log" using primary key columns */
  safety_checklist_recipients_log_by_pk?: Maybe<Safety_Checklist_Recipients_Log>;
  /** fetch data from the table in a streaming manner: "safety_checklist_recipients_log" */
  safety_checklist_recipients_log_stream: Array<Safety_Checklist_Recipients_Log>;
  /** An array relationship */
  safety_plan: Array<Safety_Plan>;
  /** An aggregate relationship */
  safety_plan_aggregate: Safety_Plan_Aggregate;
  /** fetch data from the table: "safety_plan" using primary key columns */
  safety_plan_by_pk?: Maybe<Safety_Plan>;
  /** fetch data from the table: "safety_plan_checklist_items" */
  safety_plan_checklist_items: Array<Safety_Plan_Checklist_Items>;
  /** fetch aggregated fields from the table: "safety_plan_checklist_items" */
  safety_plan_checklist_items_aggregate: Safety_Plan_Checklist_Items_Aggregate;
  /** fetch data from the table: "safety_plan_checklist_items" using primary key columns */
  safety_plan_checklist_items_by_pk?: Maybe<Safety_Plan_Checklist_Items>;
  /** fetch data from the table in a streaming manner: "safety_plan_checklist_items" */
  safety_plan_checklist_items_stream: Array<Safety_Plan_Checklist_Items>;
  /** fetch data from the table: "safety_plan_response_options" */
  safety_plan_response_options: Array<Safety_Plan_Response_Options>;
  /** fetch aggregated fields from the table: "safety_plan_response_options" */
  safety_plan_response_options_aggregate: Safety_Plan_Response_Options_Aggregate;
  /** fetch data from the table: "safety_plan_response_options" using primary key columns */
  safety_plan_response_options_by_pk?: Maybe<Safety_Plan_Response_Options>;
  /** fetch data from the table in a streaming manner: "safety_plan_response_options" */
  safety_plan_response_options_stream: Array<Safety_Plan_Response_Options>;
  /** An array relationship */
  safety_plan_section_category: Array<Safety_Plan_Section_Category>;
  /** An aggregate relationship */
  safety_plan_section_category_aggregate: Safety_Plan_Section_Category_Aggregate;
  /** fetch data from the table: "safety_plan_section_category" using primary key columns */
  safety_plan_section_category_by_pk?: Maybe<Safety_Plan_Section_Category>;
  /** fetch data from the table in a streaming manner: "safety_plan_section_category" */
  safety_plan_section_category_stream: Array<Safety_Plan_Section_Category>;
  /** fetch data from the table: "safety_plan_sections" */
  safety_plan_sections: Array<Safety_Plan_Sections>;
  /** fetch aggregated fields from the table: "safety_plan_sections" */
  safety_plan_sections_aggregate: Safety_Plan_Sections_Aggregate;
  /** fetch data from the table: "safety_plan_sections" using primary key columns */
  safety_plan_sections_by_pk?: Maybe<Safety_Plan_Sections>;
  /** fetch data from the table in a streaming manner: "safety_plan_sections" */
  safety_plan_sections_stream: Array<Safety_Plan_Sections>;
  /** fetch data from the table in a streaming manner: "safety_plan" */
  safety_plan_stream: Array<Safety_Plan>;
  /** fetch data from the table: "safety_plan_template" */
  safety_plan_template: Array<Safety_Plan_Template>;
  /** fetch aggregated fields from the table: "safety_plan_template" */
  safety_plan_template_aggregate: Safety_Plan_Template_Aggregate;
  /** fetch data from the table: "safety_plan_template" using primary key columns */
  safety_plan_template_by_pk?: Maybe<Safety_Plan_Template>;
  /** fetch data from the table in a streaming manner: "safety_plan_template" */
  safety_plan_template_stream: Array<Safety_Plan_Template>;
  /** An array relationship */
  schedule_blackout_dates: Array<Schedule_Blackout_Dates>;
  /** An aggregate relationship */
  schedule_blackout_dates_aggregate: Schedule_Blackout_Dates_Aggregate;
  /** fetch data from the table: "schedule_blackout_dates" using primary key columns */
  schedule_blackout_dates_by_pk?: Maybe<Schedule_Blackout_Dates>;
  /** fetch data from the table in a streaming manner: "schedule_blackout_dates" */
  schedule_blackout_dates_stream: Array<Schedule_Blackout_Dates>;
  /** fetch data from the table: "transcript.action_plans" */
  transcript_action_plans: Array<Transcript_Action_Plans>;
  /** fetch aggregated fields from the table: "transcript.action_plans" */
  transcript_action_plans_aggregate: Transcript_Action_Plans_Aggregate;
  /** fetch data from the table: "transcript.action_plans" using primary key columns */
  transcript_action_plans_by_pk?: Maybe<Transcript_Action_Plans>;
  /** fetch data from the table in a streaming manner: "transcript.action_plans" */
  transcript_action_plans_stream: Array<Transcript_Action_Plans>;
  /** fetch data from the table: "transcript.progress_notes" */
  transcript_progress_notes: Array<Transcript_Progress_Notes>;
  /** fetch aggregated fields from the table: "transcript.progress_notes" */
  transcript_progress_notes_aggregate: Transcript_Progress_Notes_Aggregate;
  /** fetch data from the table: "transcript.progress_notes" using primary key columns */
  transcript_progress_notes_by_pk?: Maybe<Transcript_Progress_Notes>;
  /** fetch data from the table in a streaming manner: "transcript.progress_notes" */
  transcript_progress_notes_stream: Array<Transcript_Progress_Notes>;
  /** fetch data from the table: "transcript.score_results" */
  transcript_score_results: Array<Transcript_Score_Results>;
  /** fetch aggregated fields from the table: "transcript.score_results" */
  transcript_score_results_aggregate: Transcript_Score_Results_Aggregate;
  /** fetch data from the table: "transcript.score_results" using primary key columns */
  transcript_score_results_by_pk?: Maybe<Transcript_Score_Results>;
  /** fetch data from the table in a streaming manner: "transcript.score_results" */
  transcript_score_results_stream: Array<Transcript_Score_Results>;
  /** fetch data from the table: "transcript.sessions" */
  transcript_sessions: Array<Transcript_Sessions>;
  /** fetch aggregated fields from the table: "transcript.sessions" */
  transcript_sessions_aggregate: Transcript_Sessions_Aggregate;
  /** fetch data from the table: "transcript.sessions" using primary key columns */
  transcript_sessions_by_pk?: Maybe<Transcript_Sessions>;
  /** fetch data from the table in a streaming manner: "transcript.sessions" */
  transcript_sessions_stream: Array<Transcript_Sessions>;
  /** fetch data from the table: "transcript.transcripts" */
  transcript_transcripts: Array<Transcript_Transcripts>;
  /** fetch aggregated fields from the table: "transcript.transcripts" */
  transcript_transcripts_aggregate: Transcript_Transcripts_Aggregate;
  /** fetch data from the table: "transcript.transcripts" using primary key columns */
  transcript_transcripts_by_pk?: Maybe<Transcript_Transcripts>;
  /** fetch data from the table in a streaming manner: "transcript.transcripts" */
  transcript_transcripts_stream: Array<Transcript_Transcripts>;
  /** fetch data from the table: "user_feature_flag" */
  user_feature_flag: Array<User_Feature_Flag>;
  /** fetch aggregated fields from the table: "user_feature_flag" */
  user_feature_flag_aggregate: User_Feature_Flag_Aggregate;
  /** fetch data from the table: "user_feature_flag" using primary key columns */
  user_feature_flag_by_pk?: Maybe<User_Feature_Flag>;
  /** fetch data from the table in a streaming manner: "user_feature_flag" */
  user_feature_flag_stream: Array<User_Feature_Flag>;
  /** fetch data from the table: "user_group_code" */
  user_group_code: Array<User_Group_Code>;
  /** fetch aggregated fields from the table: "user_group_code" */
  user_group_code_aggregate: User_Group_Code_Aggregate;
  /** fetch data from the table: "user_group_code" using primary key columns */
  user_group_code_by_pk?: Maybe<User_Group_Code>;
  /** fetch data from the table in a streaming manner: "user_group_code" */
  user_group_code_stream: Array<User_Group_Code>;
  /** An array relationship */
  user_insights: Array<User_Insights>;
  /** An aggregate relationship */
  user_insights_aggregate: User_Insights_Aggregate;
  /** fetch data from the table: "user_insights" using primary key columns */
  user_insights_by_pk?: Maybe<User_Insights>;
  /** fetch data from the table in a streaming manner: "user_insights" */
  user_insights_stream: Array<User_Insights>;
  /** An array relationship */
  user_invites: Array<User_Invites>;
  /** An aggregate relationship */
  user_invites_aggregate: User_Invites_Aggregate;
  /** fetch data from the table: "user_invites" using primary key columns */
  user_invites_by_pk?: Maybe<User_Invites>;
  /** fetch data from the table in a streaming manner: "user_invites" */
  user_invites_stream: Array<User_Invites>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_insights_display_status" */
  users_insights_display_status: Array<Users_Insights_Display_Status>;
  /** fetch aggregated fields from the table: "users_insights_display_status" */
  users_insights_display_status_aggregate: Users_Insights_Display_Status_Aggregate;
  /** fetch data from the table: "users_insights_display_status" using primary key columns */
  users_insights_display_status_by_pk?: Maybe<Users_Insights_Display_Status>;
  /** fetch data from the table in a streaming manner: "users_insights_display_status" */
  users_insights_display_status_stream: Array<Users_Insights_Display_Status>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  vw_daily_features_sleep: Array<Vw_Daily_Features_Sleep>;
  /** An aggregate relationship */
  vw_daily_features_sleep_aggregate: Vw_Daily_Features_Sleep_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_daily_features_sleep" */
  vw_daily_features_sleep_stream: Array<Vw_Daily_Features_Sleep>;
  /** An array relationship */
  vw_daily_features_trend: Array<Vw_Daily_Features_Trend>;
  /** An aggregate relationship */
  vw_daily_features_trend_aggregate: Vw_Daily_Features_Trend_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_daily_features_trend" */
  vw_daily_features_trend_stream: Array<Vw_Daily_Features_Trend>;
  /** fetch data from the table: "vw_most_recent_scored_questionnaires" */
  vw_most_recent_scored_questionnaires: Array<Vw_Most_Recent_Scored_Questionnaires>;
  /** fetch aggregated fields from the table: "vw_most_recent_scored_questionnaires" */
  vw_most_recent_scored_questionnaires_aggregate: Vw_Most_Recent_Scored_Questionnaires_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_most_recent_scored_questionnaires" */
  vw_most_recent_scored_questionnaires_stream: Array<Vw_Most_Recent_Scored_Questionnaires>;
  /** fetch data from the table: "vw_org_client_count" */
  vw_org_client_count: Array<Vw_Org_Client_Count>;
  /** fetch aggregated fields from the table: "vw_org_client_count" */
  vw_org_client_count_aggregate: Vw_Org_Client_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_org_client_count" */
  vw_org_client_count_stream: Array<Vw_Org_Client_Count>;
  /** fetch data from the table: "vw_org_nudge_count" */
  vw_org_nudge_count: Array<Vw_Org_Nudge_Count>;
  /** fetch aggregated fields from the table: "vw_org_nudge_count" */
  vw_org_nudge_count_aggregate: Vw_Org_Nudge_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_org_nudge_count" */
  vw_org_nudge_count_stream: Array<Vw_Org_Nudge_Count>;
  /** fetch data from the table: "vw_org_nudge_technique_counts" */
  vw_org_nudge_technique_counts: Array<Vw_Org_Nudge_Technique_Counts>;
  /** fetch aggregated fields from the table: "vw_org_nudge_technique_counts" */
  vw_org_nudge_technique_counts_aggregate: Vw_Org_Nudge_Technique_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_org_nudge_technique_counts" */
  vw_org_nudge_technique_counts_stream: Array<Vw_Org_Nudge_Technique_Counts>;
  /** fetch data from the table: "vw_org_questionnaire_count" */
  vw_org_questionnaire_count: Array<Vw_Org_Questionnaire_Count>;
  /** fetch aggregated fields from the table: "vw_org_questionnaire_count" */
  vw_org_questionnaire_count_aggregate: Vw_Org_Questionnaire_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_org_questionnaire_count" */
  vw_org_questionnaire_count_stream: Array<Vw_Org_Questionnaire_Count>;
  /** fetch data from the table: "vw_organization_summary" */
  vw_organization_summary: Array<Vw_Organization_Summary>;
  /** fetch aggregated fields from the table: "vw_organization_summary" */
  vw_organization_summary_aggregate: Vw_Organization_Summary_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_organization_summary" */
  vw_organization_summary_stream: Array<Vw_Organization_Summary>;
  /** fetch data from the table: "vw_practitioner_client_count" */
  vw_practitioner_client_count: Array<Vw_Practitioner_Client_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_client_count" */
  vw_practitioner_client_count_aggregate: Vw_Practitioner_Client_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_practitioner_client_count" */
  vw_practitioner_client_count_stream: Array<Vw_Practitioner_Client_Count>;
  /** fetch data from the table: "vw_practitioner_counts" */
  vw_practitioner_counts: Array<Vw_Practitioner_Counts>;
  /** fetch aggregated fields from the table: "vw_practitioner_counts" */
  vw_practitioner_counts_aggregate: Vw_Practitioner_Counts_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_practitioner_counts" */
  vw_practitioner_counts_stream: Array<Vw_Practitioner_Counts>;
  /** fetch data from the table: "vw_practitioner_nudge_count" */
  vw_practitioner_nudge_count: Array<Vw_Practitioner_Nudge_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_nudge_count" */
  vw_practitioner_nudge_count_aggregate: Vw_Practitioner_Nudge_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_practitioner_nudge_count" */
  vw_practitioner_nudge_count_stream: Array<Vw_Practitioner_Nudge_Count>;
  /** fetch data from the table: "vw_practitioner_questionnaire_count" */
  vw_practitioner_questionnaire_count: Array<Vw_Practitioner_Questionnaire_Count>;
  /** fetch aggregated fields from the table: "vw_practitioner_questionnaire_count" */
  vw_practitioner_questionnaire_count_aggregate: Vw_Practitioner_Questionnaire_Count_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_practitioner_questionnaire_count" */
  vw_practitioner_questionnaire_count_stream: Array<Vw_Practitioner_Questionnaire_Count>;
  /** fetch data from the table: "vw_questionnaire_display_values" */
  vw_questionnaire_display_values: Array<Vw_Questionnaire_Display_Values>;
  /** fetch aggregated fields from the table: "vw_questionnaire_display_values" */
  vw_questionnaire_display_values_aggregate: Vw_Questionnaire_Display_Values_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_questionnaire_display_values" */
  vw_questionnaire_display_values_stream: Array<Vw_Questionnaire_Display_Values>;
  /** fetch data from the table: "vw_user_organization" */
  vw_user_organization: Array<Vw_User_Organization>;
  /** fetch aggregated fields from the table: "vw_user_organization" */
  vw_user_organization_aggregate: Vw_User_Organization_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_user_organization" */
  vw_user_organization_stream: Array<Vw_User_Organization>;
  /** fetch data from the table: "vw_user_virasafe_metrics" */
  vw_user_virasafe_metrics: Array<Vw_User_Virasafe_Metrics>;
  /** fetch aggregated fields from the table: "vw_user_virasafe_metrics" */
  vw_user_virasafe_metrics_aggregate: Vw_User_Virasafe_Metrics_Aggregate;
  /** fetch data from the table in a streaming manner: "vw_user_virasafe_metrics" */
  vw_user_virasafe_metrics_stream: Array<Vw_User_Virasafe_Metrics>;
};


export type Subscription_RootActivityArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_RatingArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


export type Subscription_RootActivity_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


export type Subscription_RootActivity_Rating_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Rating_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


export type Subscription_RootActivity_ResourceArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Order_By>>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};


export type Subscription_RootActivity_Resource_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Order_By>>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};


export type Subscription_RootActivity_Resource_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Resource_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Category_Order_By>>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Resource_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Resource_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Resource_Category_Order_By>>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Resource_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Resource_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Resource_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Resource_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Resource_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Resource_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Resource_Bool_Exp>;
};


export type Subscription_RootActivity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Bool_Exp>;
};


export type Subscription_RootActivity_Sub_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Activity_Sub_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Sub_Category_Order_By>>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Sub_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Sub_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Sub_Category_Order_By>>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Sub_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Sub_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Sub_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Sub_Category_Bool_Exp>;
};


export type Subscription_RootActivity_Suggested_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activity_Suggested_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Suggested_Activities_Order_By>>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};


export type Subscription_RootActivity_Suggested_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Suggested_Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Suggested_Activities_Order_By>>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};


export type Subscription_RootActivity_Suggested_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Suggested_Activities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Suggested_Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Suggested_Activities_Bool_Exp>;
};


export type Subscription_RootAssessment_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


export type Subscription_RootAssessment_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Answers_Order_By>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


export type Subscription_RootAssessment_Answers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Answers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Answers_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Answers_Bool_Exp>;
};


export type Subscription_RootAssessment_Branching_RulesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Branching_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Branching_Rules_Order_By>>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};


export type Subscription_RootAssessment_Branching_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Branching_Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Branching_Rules_Order_By>>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};


export type Subscription_RootAssessment_Branching_Rules_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Branching_Rules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Branching_Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Branching_Rules_Bool_Exp>;
};


export type Subscription_RootAssessment_PagesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


export type Subscription_RootAssessment_Pages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Pages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Pages_Order_By>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


export type Subscription_RootAssessment_Pages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Pages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Pages_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Pages_Bool_Exp>;
};


export type Subscription_RootAssessment_Question_Custom_PromptArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Order_By>>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};


export type Subscription_RootAssessment_Question_Custom_Prompt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Question_Custom_Prompt_Order_By>>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};


export type Subscription_RootAssessment_Question_Custom_Prompt_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Question_Custom_Prompt_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Question_Custom_Prompt_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Question_Custom_Prompt_Bool_Exp>;
};


export type Subscription_RootAssessment_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


export type Subscription_RootAssessment_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Questions_Order_By>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


export type Subscription_RootAssessment_Questions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Questions_Bool_Exp>;
};


export type Subscription_RootAssessment_TakesArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


export type Subscription_RootAssessment_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessment_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessment_Takes_Order_By>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


export type Subscription_RootAssessment_Takes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessment_Takes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessment_Takes_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessment_Takes_Bool_Exp>;
};


export type Subscription_RootAssessmentsArgs = {
  distinct_on?: InputMaybe<Array<Assessments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessments_Order_By>>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};


export type Subscription_RootAssessments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assessments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Assessments_Order_By>>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};


export type Subscription_RootAssessments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAssessments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Assessments_Stream_Cursor_Input>>;
  where?: InputMaybe<Assessments_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Migration_LogArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Migration_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Migration_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Migration_Log_Order_By>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Migration_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAuth_Account_Migration_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Account_Migration_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Account_Migration_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Account_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Providers_Order_By>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Providers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuth_Account_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Account_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Account_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Account_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Account_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Account_Roles_Order_By>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


export type Subscription_RootAuth_Account_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuth_Account_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Account_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Account_Roles_Bool_Exp>;
};


export type Subscription_RootAuth_AccountsArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


export type Subscription_RootAuth_Accounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Accounts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Accounts_Order_By>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


export type Subscription_RootAuth_Accounts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuth_Accounts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Accounts_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Accounts_Bool_Exp>;
};


export type Subscription_RootAuth_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Providers_Order_By>>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Providers_Order_By>>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Providers_By_PkArgs = {
  provider: Scalars['String']['input'];
};


export type Subscription_RootAuth_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Providers_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_Token_Usage_LogArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_Token_Usage_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Token_Usage_Log_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_Token_Usage_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuth_Refresh_Token_Usage_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Refresh_Token_Usage_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Refresh_Token_Usage_Log_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_TokensArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Refresh_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Refresh_Tokens_Order_By>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootAuth_Refresh_Tokens_By_PkArgs = {
  refresh_token_hash: Scalars['String']['input'];
};


export type Subscription_RootAuth_Refresh_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Refresh_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Refresh_Tokens_Bool_Exp>;
};


export type Subscription_RootAuth_RolesArgs = {
  distinct_on?: InputMaybe<Array<Auth_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Roles_Order_By>>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};


export type Subscription_RootAuth_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Auth_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Auth_Roles_Order_By>>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};


export type Subscription_RootAuth_Roles_By_PkArgs = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuth_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Auth_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Auth_Roles_Bool_Exp>;
};


export type Subscription_RootCasemix_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Casemix_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casemix_Category_Order_By>>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};


export type Subscription_RootCasemix_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Casemix_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Casemix_Category_Order_By>>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};


export type Subscription_RootCasemix_Category_By_PkArgs = {
  category: Scalars['String']['input'];
};


export type Subscription_RootCasemix_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Casemix_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Casemix_Category_Bool_Exp>;
};


export type Subscription_RootClient_DemographicsArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


export type Subscription_RootClient_Demographics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


export type Subscription_RootClient_Demographics_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootClient_Demographics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Client_Demographics_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


export type Subscription_RootDaily_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


export type Subscription_RootDaily_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


export type Subscription_RootDaily_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDaily_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Daily_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


export type Subscription_RootEhr_Client_Invite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Client_Invite_Codes_Order_By>>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};


export type Subscription_RootEhr_Client_Invite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Client_Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Client_Invite_Codes_Order_By>>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};


export type Subscription_RootEhr_Client_Invite_Codes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEhr_Client_Invite_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ehr_Client_Invite_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Client_Invite_Codes_Bool_Exp>;
};


export type Subscription_RootEhr_Ehr_Practitioner_MapArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Order_By>>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};


export type Subscription_RootEhr_Ehr_Practitioner_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Ehr_Practitioner_Map_Order_By>>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};


export type Subscription_RootEhr_Ehr_Practitioner_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEhr_Ehr_Practitioner_Map_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ehr_Ehr_Practitioner_Map_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Ehr_Practitioner_Map_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Event_NotificationArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Event_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Event_Notification_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Event_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEhr_Xealth_Event_Notification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ehr_Xealth_Event_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Xealth_Event_Notification_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_FormArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_Form_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Form_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_Form_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEhr_Xealth_Preorder_Form_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ehr_Xealth_Preorder_Form_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Form_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_Invite_MapArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_Invite_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ehr_Xealth_Preorder_Invite_Map_Order_By>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};


export type Subscription_RootEhr_Xealth_Preorder_Invite_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEhr_Xealth_Preorder_Invite_Map_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Stream_Cursor_Input>>;
  where?: InputMaybe<Ehr_Xealth_Preorder_Invite_Map_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Category_Order_By>>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Category_Order_By>>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_Category_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Activity_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Activity_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Activity_Category_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Activity_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Activity_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Activity_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Activity_Resource_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Activity_Resource_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Activity_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Completion_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Completion_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Completion_Status_Order_By>>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Completion_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Completion_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Completion_Status_Order_By>>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Completion_Status_By_PkArgs = {
  text: Scalars['String']['input'];
};


export type Subscription_RootEnum_Completion_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Completion_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Completion_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_DirectionArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Direction_Order_By>>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_Direction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Direction_Order_By>>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Feature_Direction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Feature_Direction_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Feature_Direction_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Type_Order_By>>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Feature_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Feature_Type_Order_By>>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Feature_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Feature_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Feature_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Feature_Type_Bool_Exp>;
};


export type Subscription_RootEnum_GenderArgs = {
  distinct_on?: InputMaybe<Array<Enum_Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Gender_Order_By>>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};


export type Subscription_RootEnum_Gender_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Gender_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Gender_Order_By>>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};


export type Subscription_RootEnum_Gender_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Gender_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Gender_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Gender_Bool_Exp>;
};


export type Subscription_RootEnum_Insight_Content_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Insight_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Insight_Content_Type_Order_By>>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Insight_Content_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Insight_Content_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Insight_Content_Type_Order_By>>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Insight_Content_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Insight_Content_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Insight_Content_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Insight_Content_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Status_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Status_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Mobile_Permission_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Mobile_Permission_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Mobile_Permission_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Type_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Mobile_Permission_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Mobile_Permission_Type_Order_By>>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Mobile_Permission_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Mobile_Permission_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Mobile_Permission_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Mobile_Permission_Type_Bool_Exp>;
};


export type Subscription_RootEnum_OutcomeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Outcome_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Outcome_Order_By>>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};


export type Subscription_RootEnum_Outcome_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Outcome_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Outcome_Order_By>>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};


export type Subscription_RootEnum_Outcome_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Outcome_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Outcome_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Outcome_Bool_Exp>;
};


export type Subscription_RootEnum_Question_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Question_Type_Order_By>>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Question_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Question_Type_Order_By>>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Question_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Question_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Question_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Question_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Racial_EthnicArgs = {
  distinct_on?: InputMaybe<Array<Enum_Racial_Ethnic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Racial_Ethnic_Order_By>>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};


export type Subscription_RootEnum_Racial_Ethnic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Racial_Ethnic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Racial_Ethnic_Order_By>>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};


export type Subscription_RootEnum_Racial_Ethnic_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Racial_Ethnic_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Racial_Ethnic_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Racial_Ethnic_Bool_Exp>;
};


export type Subscription_RootEnum_Resource_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Resource_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Resource_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Resource_Type_Order_By>>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Resource_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Resource_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Resource_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Resource_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_Category_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_Category_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Category_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_Category_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Safety_Plan_Section_Category_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Safety_Plan_Section_Category_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Category_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_IconsArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_Icons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Section_Icons_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Section_Icons_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Safety_Plan_Section_Icons_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Safety_Plan_Section_Icons_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Safety_Plan_Section_Icons_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_StatusArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Status_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Status_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Safety_Plan_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Safety_Plan_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Safety_Plan_Status_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_TypeArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Safety_Plan_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Safety_Plan_Type_Order_By>>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Safety_Plan_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Safety_Plan_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Safety_Plan_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Safety_Plan_Type_Bool_Exp>;
};


export type Subscription_RootEnum_Trend_DirectionArgs = {
  distinct_on?: InputMaybe<Array<Enum_Trend_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Trend_Direction_Order_By>>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};


export type Subscription_RootEnum_Trend_Direction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Trend_Direction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enum_Trend_Direction_Order_By>>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};


export type Subscription_RootEnum_Trend_Direction_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnum_Trend_Direction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enum_Trend_Direction_Stream_Cursor_Input>>;
  where?: InputMaybe<Enum_Trend_Direction_Bool_Exp>;
};


export type Subscription_RootFeature_Report_Feature_CoefficientsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Order_By>>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};


export type Subscription_RootFeature_Report_Feature_Coefficients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Feature_Coefficients_Order_By>>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};


export type Subscription_RootFeature_Report_Feature_Coefficients_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFeature_Report_Feature_Coefficients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Report_Feature_Coefficients_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Report_Feature_Coefficients_Bool_Exp>;
};


export type Subscription_RootFeature_Report_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


export type Subscription_RootFeature_Report_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Report_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Report_Features_Order_By>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


export type Subscription_RootFeature_Report_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFeature_Report_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Report_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Report_Features_Bool_Exp>;
};


export type Subscription_RootFeature_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


export type Subscription_RootFeature_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


export type Subscription_RootFeature_Reports_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFeature_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Feature_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


export type Subscription_RootGroup_CodeArgs = {
  distinct_on?: InputMaybe<Array<Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Code_Order_By>>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};


export type Subscription_RootGroup_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Group_Code_Order_By>>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};


export type Subscription_RootGroup_Code_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGroup_Code_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Group_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Group_Code_Bool_Exp>;
};


export type Subscription_RootInsight_ArticlesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


export type Subscription_RootInsight_Articles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Articles_Order_By>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


export type Subscription_RootInsight_Articles_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Articles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Articles_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Articles_Bool_Exp>;
};


export type Subscription_RootInsight_CombosArgs = {
  distinct_on?: InputMaybe<Array<Insight_Combos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Combos_Order_By>>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};


export type Subscription_RootInsight_Combos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Combos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Combos_Order_By>>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};


export type Subscription_RootInsight_Combos_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Combos_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Combos_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Combos_Bool_Exp>;
};


export type Subscription_RootInsight_HowsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


export type Subscription_RootInsight_Hows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Hows_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Hows_Order_By>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


export type Subscription_RootInsight_Hows_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Hows_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Hows_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Hows_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_ArticleArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_Article_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Article_Order_By>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_Article_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Plan_Article_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Plan_Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Plan_Article_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_TextArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_Text_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plan_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plan_Text_Order_By>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


export type Subscription_RootInsight_Plan_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Plan_Text_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Plan_Text_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Plan_Text_Bool_Exp>;
};


export type Subscription_RootInsight_PlansArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


export type Subscription_RootInsight_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Plans_Order_By>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


export type Subscription_RootInsight_Plans_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Plans_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Plans_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Plans_Bool_Exp>;
};


export type Subscription_RootInsight_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


export type Subscription_RootInsight_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Questions_Order_By>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


export type Subscription_RootInsight_Questions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Questions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Questions_Bool_Exp>;
};


export type Subscription_RootInsight_RecipesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


export type Subscription_RootInsight_Recipes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Recipes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Recipes_Order_By>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


export type Subscription_RootInsight_Recipes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Recipes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Recipes_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Recipes_Bool_Exp>;
};


export type Subscription_RootInsight_ReflectArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


export type Subscription_RootInsight_Reflect_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


export type Subscription_RootInsight_Reflect_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Reflect_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Reflect_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Reflect_Bool_Exp>;
};


export type Subscription_RootInsight_Reflect_TextArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


export type Subscription_RootInsight_Reflect_Text_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Reflect_Text_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Reflect_Text_Order_By>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


export type Subscription_RootInsight_Reflect_Text_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Reflect_Text_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Reflect_Text_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Reflect_Text_Bool_Exp>;
};


export type Subscription_RootInsight_ResourcesArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


export type Subscription_RootInsight_Resources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Resources_Order_By>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


export type Subscription_RootInsight_Resources_By_PkArgs = {
  direction: Enum_Feature_Direction_Enum;
  feature: Enum_Feature_Type_Enum;
  resources_id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Resources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Resources_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Resources_Bool_Exp>;
};


export type Subscription_RootInsight_TextsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Texts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Texts_Order_By>>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};


export type Subscription_RootInsight_Texts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Texts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Texts_Order_By>>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};


export type Subscription_RootInsight_Texts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Texts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Texts_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Texts_Bool_Exp>;
};


export type Subscription_RootInsight_TipsArgs = {
  distinct_on?: InputMaybe<Array<Insight_Tips_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Tips_Order_By>>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};


export type Subscription_RootInsight_Tips_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Tips_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Tips_Order_By>>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};


export type Subscription_RootInsight_Tips_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Tips_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Tips_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Tips_Bool_Exp>;
};


export type Subscription_RootInsight_WhysArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


export type Subscription_RootInsight_Whys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Insight_Whys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Insight_Whys_Order_By>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


export type Subscription_RootInsight_Whys_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInsight_Whys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Insight_Whys_Stream_Cursor_Input>>;
  where?: InputMaybe<Insight_Whys_Bool_Exp>;
};


export type Subscription_RootInvite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


export type Subscription_RootInvite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


export type Subscription_RootInvite_Codes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootInvite_Codes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invite_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


export type Subscription_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLogs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootMobile_Device_DataArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


export type Subscription_RootMobile_Device_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


export type Subscription_RootMobile_Device_Data_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMobile_Device_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mobile_Device_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


export type Subscription_RootMobile_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


export type Subscription_RootMobile_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Permissions_Order_By>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


export type Subscription_RootMobile_Permissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMobile_Permissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mobile_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Permissions_Bool_Exp>;
};


export type Subscription_RootMobile_Upload_LogArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Upload_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Upload_Log_Order_By>>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};


export type Subscription_RootMobile_Upload_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Upload_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Upload_Log_Order_By>>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};


export type Subscription_RootMobile_Upload_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMobile_Upload_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mobile_Upload_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Upload_Log_Bool_Exp>;
};


export type Subscription_RootMood_MeasurementsArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


export type Subscription_RootMood_Measurements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


export type Subscription_RootMood_Measurements_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootMood_Measurements_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mood_Measurements_Stream_Cursor_Input>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


export type Subscription_RootNudge_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


export type Subscription_RootNudge_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


export type Subscription_RootNudge_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNudge_Schedules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nudge_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


export type Subscription_RootNudge_TakesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


export type Subscription_RootNudge_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


export type Subscription_RootNudge_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNudge_Takes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nudge_Takes_Stream_Cursor_Input>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


export type Subscription_RootNudgesArgs = {
  distinct_on?: InputMaybe<Array<Nudges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudges_Order_By>>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};


export type Subscription_RootNudges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudges_Order_By>>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};


export type Subscription_RootNudges_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNudges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nudges_Stream_Cursor_Input>>;
  where?: InputMaybe<Nudges_Bool_Exp>;
};


export type Subscription_RootOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_Admins_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganization_Admins_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Admins_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


export type Subscription_RootOrganization_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Features_Order_By>>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};


export type Subscription_RootOrganization_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Features_Order_By>>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};


export type Subscription_RootOrganization_Features_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganization_Features_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Features_Bool_Exp>;
};


export type Subscription_RootOrganization_Member_RolesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Member_Roles_Order_By>>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};


export type Subscription_RootOrganization_Member_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Member_Roles_Order_By>>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};


export type Subscription_RootOrganization_Member_Roles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Member_Roles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Member_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Member_Roles_Bool_Exp>;
};


export type Subscription_RootOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Subscription_RootOrganization_Members_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganization_Members_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


export type Subscription_RootOrganization_SuperviseesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


export type Subscription_RootOrganization_Supervisees_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisees_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisees_Order_By>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


export type Subscription_RootOrganization_Supervisees_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Supervisees_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Supervisees_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Supervisees_Bool_Exp>;
};


export type Subscription_RootOrganization_SupervisorsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


export type Subscription_RootOrganization_Supervisors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


export type Subscription_RootOrganization_Supervisors_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganization_Supervisors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organization_Supervisors_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganizations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Items_Order_By>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Items_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaire_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Items_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Response_Options_Order_By>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Response_Options_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaire_Response_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Response_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Response_Options_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Responses_Order_By>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Responses_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaire_Responses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Responses_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Risk_Alert_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Risk_Alert_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Risk_Alert_Contacts_Order_By>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Risk_Alert_Contacts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionnaire_Risk_Alert_Contacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Risk_Alert_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Risk_Alert_Contacts_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Schedules_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaire_Schedules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_ScoringArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Scoring_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Scoring_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Scoring_Order_By>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Scoring_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionnaire_Scoring_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Scoring_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Scoring_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_TakesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


export type Subscription_RootQuestionnaire_Takes_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaire_Takes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaire_Takes_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


export type Subscription_RootQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootQuestionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaires_Order_By>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootQuestionnaires_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootQuestionnaires_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Questionnaires_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_Place_VisitsArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_Place_Visits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Place_Visits_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_Place_Visits_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRelapse_Prevention_Place_Visits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relapse_Prevention_Place_Visits_Stream_Cursor_Input>>;
  where?: InputMaybe<Relapse_Prevention_Place_Visits_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Places_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relapse_Prevention_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relapse_Prevention_Places_Order_By>>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};


export type Subscription_RootRelapse_Prevention_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRelapse_Prevention_Places_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relapse_Prevention_Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Relapse_Prevention_Places_Bool_Exp>;
};


export type Subscription_RootResourcesArgs = {
  distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Order_By>>;
  where?: InputMaybe<Resources_Bool_Exp>;
};


export type Subscription_RootResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resources_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Order_By>>;
  where?: InputMaybe<Resources_Bool_Exp>;
};


export type Subscription_RootResources_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootResources_OrgsArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


export type Subscription_RootResources_Orgs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resources_Orgs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Resources_Orgs_Order_By>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


export type Subscription_RootResources_Orgs_By_PkArgs = {
  org_id: Scalars['Int']['input'];
  resources_id: Scalars['Int']['input'];
};


export type Subscription_RootResources_Orgs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Resources_Orgs_Stream_Cursor_Input>>;
  where?: InputMaybe<Resources_Orgs_Bool_Exp>;
};


export type Subscription_RootResources_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Resources_Stream_Cursor_Input>>;
  where?: InputMaybe<Resources_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_LogArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Alerts_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Alerts_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Alerts_Log_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_Recipients_LogArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_Recipients_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Risk_Alerts_Recipients_Log_Order_By>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootRisk_Alerts_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRisk_Alerts_Recipients_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Risk_Alerts_Recipients_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Risk_Alerts_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootRole_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


export type Subscription_RootRole_Capabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


export type Subscription_RootRole_Capabilities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRole_Capabilities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Role_Capabilities_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_Recipients_LogArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_Recipients_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Checklist_Recipients_Log_Order_By>>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootSafety_Checklist_Recipients_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Checklist_Recipients_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Checklist_Recipients_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Checklist_Recipients_Log_Bool_Exp>;
};


export type Subscription_RootSafety_PlanArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Checklist_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Checklist_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Checklist_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Checklist_Items_Order_By>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Checklist_Items_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Checklist_Items_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Checklist_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Checklist_Items_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Response_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Response_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Response_Options_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Response_Options_Order_By>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Response_Options_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Response_Options_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Response_Options_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Response_Options_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Section_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Section_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Section_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Section_Category_Order_By>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Section_Category_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Section_Category_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Section_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Section_Category_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_SectionsArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Sections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Sections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Sections_Order_By>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Sections_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Sections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Sections_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Sections_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_TemplateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Template_Order_By>>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Template_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Template_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Template_Order_By>>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};


export type Subscription_RootSafety_Plan_Template_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSafety_Plan_Template_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Safety_Plan_Template_Stream_Cursor_Input>>;
  where?: InputMaybe<Safety_Plan_Template_Bool_Exp>;
};


export type Subscription_RootSchedule_Blackout_DatesArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


export type Subscription_RootSchedule_Blackout_Dates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedule_Blackout_Dates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Schedule_Blackout_Dates_Order_By>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


export type Subscription_RootSchedule_Blackout_Dates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSchedule_Blackout_Dates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Schedule_Blackout_Dates_Stream_Cursor_Input>>;
  where?: InputMaybe<Schedule_Blackout_Dates_Bool_Exp>;
};


export type Subscription_RootTranscript_Action_PlansArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Action_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Action_Plans_Order_By>>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};


export type Subscription_RootTranscript_Action_Plans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Action_Plans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Action_Plans_Order_By>>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};


export type Subscription_RootTranscript_Action_Plans_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Subscription_RootTranscript_Action_Plans_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Action_Plans_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};


export type Subscription_RootTranscript_Progress_NotesArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Progress_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Progress_Notes_Order_By>>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};


export type Subscription_RootTranscript_Progress_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Progress_Notes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Progress_Notes_Order_By>>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};


export type Subscription_RootTranscript_Progress_Notes_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTranscript_Progress_Notes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Progress_Notes_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};


export type Subscription_RootTranscript_Score_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Score_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Score_Results_Order_By>>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};


export type Subscription_RootTranscript_Score_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Score_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Score_Results_Order_By>>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};


export type Subscription_RootTranscript_Score_Results_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Subscription_RootTranscript_Score_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Score_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};


export type Subscription_RootTranscript_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Sessions_Order_By>>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};


export type Subscription_RootTranscript_Sessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Sessions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Sessions_Order_By>>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};


export type Subscription_RootTranscript_Sessions_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTranscript_Sessions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Sessions_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};


export type Subscription_RootTranscript_TranscriptsArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Transcripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Transcripts_Order_By>>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};


export type Subscription_RootTranscript_Transcripts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transcript_Transcripts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transcript_Transcripts_Order_By>>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};


export type Subscription_RootTranscript_Transcripts_By_PkArgs = {
  session_id: Scalars['String']['input'];
};


export type Subscription_RootTranscript_Transcripts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transcript_Transcripts_Stream_Cursor_Input>>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};


export type Subscription_RootUser_Feature_FlagArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feature_Flag_Order_By>>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootUser_Feature_Flag_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Feature_Flag_Order_By>>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootUser_Feature_Flag_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Feature_Flag_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Feature_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};


export type Subscription_RootUser_Group_CodeArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Code_Order_By>>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};


export type Subscription_RootUser_Group_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Group_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Group_Code_Order_By>>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};


export type Subscription_RootUser_Group_Code_By_PkArgs = {
  group_code_id: Scalars['Int']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Group_Code_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Group_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};


export type Subscription_RootUser_InsightsArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


export type Subscription_RootUser_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


export type Subscription_RootUser_Insights_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Insights_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Insights_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


export type Subscription_RootUser_InvitesArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUser_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUser_Invites_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Invites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Invites_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_Insights_Display_StatusArgs = {
  distinct_on?: InputMaybe<Array<Users_Insights_Display_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Insights_Display_Status_Order_By>>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};


export type Subscription_RootUsers_Insights_Display_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Insights_Display_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Insights_Display_Status_Order_By>>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};


export type Subscription_RootUsers_Insights_Display_Status_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUsers_Insights_Display_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Insights_Display_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_SleepArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_Sleep_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_Sleep_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Daily_Features_Sleep_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_TrendArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_Trend_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


export type Subscription_RootVw_Daily_Features_Trend_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Daily_Features_Trend_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


export type Subscription_RootVw_Most_Recent_Scored_QuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


export type Subscription_RootVw_Most_Recent_Scored_Questionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


export type Subscription_RootVw_Most_Recent_Scored_Questionnaires_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


export type Subscription_RootVw_Org_Client_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Client_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Client_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Org_Client_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Org_Nudge_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_Technique_CountsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_Technique_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Order_By>>;
  where?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Org_Nudge_Technique_Counts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Org_Nudge_Technique_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Org_Questionnaire_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Questionnaire_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Org_Questionnaire_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Org_Questionnaire_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Organization_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Vw_Organization_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Organization_Summary_Order_By>>;
  where?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
};


export type Subscription_RootVw_Organization_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Organization_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Organization_Summary_Order_By>>;
  where?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
};


export type Subscription_RootVw_Organization_Summary_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Organization_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Client_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Client_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Client_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Client_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Client_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Practitioner_Client_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_CountsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Counts_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Counts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Counts_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Counts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Practitioner_Counts_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Nudge_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Nudge_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Nudge_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Practitioner_Nudge_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Questionnaire_CountArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Questionnaire_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Order_By>>;
  where?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Practitioner_Questionnaire_Count_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Practitioner_Questionnaire_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
};


export type Subscription_RootVw_Questionnaire_Display_ValuesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Order_By>>;
  where?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
};


export type Subscription_RootVw_Questionnaire_Display_Values_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Order_By>>;
  where?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
};


export type Subscription_RootVw_Questionnaire_Display_Values_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_Questionnaire_Display_Values_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
};


export type Subscription_RootVw_User_OrganizationArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


export type Subscription_RootVw_User_Organization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


export type Subscription_RootVw_User_Organization_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_User_Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


export type Subscription_RootVw_User_Virasafe_MetricsArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Order_By>>;
  where?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
};


export type Subscription_RootVw_User_Virasafe_Metrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Order_By>>;
  where?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
};


export type Subscription_RootVw_User_Virasafe_Metrics_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Vw_User_Virasafe_Metrics_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "transcript.action_plans" */
export type Transcript_Action_Plans = {
  __typename?: 'transcript_action_plans';
  data: Scalars['jsonb']['output'];
  /** An object relationship */
  session: Transcript_Sessions;
  session_id: Scalars['String']['output'];
};


/** columns and relationships of "transcript.action_plans" */
export type Transcript_Action_PlansDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript.action_plans" */
export type Transcript_Action_Plans_Aggregate = {
  __typename?: 'transcript_action_plans_aggregate';
  aggregate?: Maybe<Transcript_Action_Plans_Aggregate_Fields>;
  nodes: Array<Transcript_Action_Plans>;
};

/** aggregate fields of "transcript.action_plans" */
export type Transcript_Action_Plans_Aggregate_Fields = {
  __typename?: 'transcript_action_plans_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Action_Plans_Max_Fields>;
  min?: Maybe<Transcript_Action_Plans_Min_Fields>;
};


/** aggregate fields of "transcript.action_plans" */
export type Transcript_Action_Plans_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Action_Plans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Action_Plans_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript.action_plans". All fields are combined with a logical 'AND'. */
export type Transcript_Action_Plans_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Action_Plans_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Action_Plans_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  session?: InputMaybe<Transcript_Sessions_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript.action_plans" */
export enum Transcript_Action_Plans_Constraint {
  /** unique or primary key constraint on columns "session_id" */
  ActionPlansPkey = 'action_plans_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Action_Plans_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Action_Plans_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Action_Plans_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript.action_plans" */
export type Transcript_Action_Plans_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session?: InputMaybe<Transcript_Sessions_Obj_Rel_Insert_Input>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Transcript_Action_Plans_Max_Fields = {
  __typename?: 'transcript_action_plans_max_fields';
  session_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transcript_Action_Plans_Min_Fields = {
  __typename?: 'transcript_action_plans_min_fields';
  session_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transcript.action_plans" */
export type Transcript_Action_Plans_Mutation_Response = {
  __typename?: 'transcript_action_plans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Action_Plans>;
};

/** input type for inserting object relation for remote table "transcript.action_plans" */
export type Transcript_Action_Plans_Obj_Rel_Insert_Input = {
  data: Transcript_Action_Plans_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transcript_Action_Plans_On_Conflict>;
};

/** on_conflict condition type for table "transcript.action_plans" */
export type Transcript_Action_Plans_On_Conflict = {
  constraint: Transcript_Action_Plans_Constraint;
  update_columns?: Array<Transcript_Action_Plans_Update_Column>;
  where?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript.action_plans". */
export type Transcript_Action_Plans_Order_By = {
  data?: InputMaybe<Order_By>;
  session?: InputMaybe<Transcript_Sessions_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript.action_plans */
export type Transcript_Action_Plans_Pk_Columns_Input = {
  session_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Action_Plans_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript.action_plans" */
export enum Transcript_Action_Plans_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

/** input type for updating data in table "transcript.action_plans" */
export type Transcript_Action_Plans_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transcript_action_plans" */
export type Transcript_Action_Plans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Action_Plans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Action_Plans_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transcript.action_plans" */
export enum Transcript_Action_Plans_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

export type Transcript_Action_Plans_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Action_Plans_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Action_Plans_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Action_Plans_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Action_Plans_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Action_Plans_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Action_Plans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Action_Plans_Bool_Exp;
};

/** columns and relationships of "transcript.progress_notes" */
export type Transcript_Progress_Notes = {
  __typename?: 'transcript_progress_notes';
  /** An object relationship */
  client: Users;
  client_id: Scalars['uuid']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  practitioner: Users;
  practitioner_id: Scalars['uuid']['output'];
  /** An object relationship */
  session?: Maybe<Transcript_Sessions>;
  session_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "transcript.progress_notes" */
export type Transcript_Progress_NotesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript.progress_notes" */
export type Transcript_Progress_Notes_Aggregate = {
  __typename?: 'transcript_progress_notes_aggregate';
  aggregate?: Maybe<Transcript_Progress_Notes_Aggregate_Fields>;
  nodes: Array<Transcript_Progress_Notes>;
};

/** aggregate fields of "transcript.progress_notes" */
export type Transcript_Progress_Notes_Aggregate_Fields = {
  __typename?: 'transcript_progress_notes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Progress_Notes_Max_Fields>;
  min?: Maybe<Transcript_Progress_Notes_Min_Fields>;
};


/** aggregate fields of "transcript.progress_notes" */
export type Transcript_Progress_Notes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Progress_Notes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Progress_Notes_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript.progress_notes". All fields are combined with a logical 'AND'. */
export type Transcript_Progress_Notes_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Progress_Notes_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Progress_Notes_Bool_Exp>>;
  client?: InputMaybe<Users_Bool_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  session?: InputMaybe<Transcript_Sessions_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript.progress_notes" */
export enum Transcript_Progress_Notes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProgressNotesPkey = 'progress_notes_pkey',
  /** unique or primary key constraint on columns "session_id" */
  ProgressNotesSessionIdUidx = 'progress_notes_session_id_uidx'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Progress_Notes_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Progress_Notes_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Progress_Notes_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript.progress_notes" */
export type Transcript_Progress_Notes_Insert_Input = {
  client?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  session?: InputMaybe<Transcript_Sessions_Obj_Rel_Insert_Input>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Transcript_Progress_Notes_Max_Fields = {
  __typename?: 'transcript_progress_notes_max_fields';
  client_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transcript_Progress_Notes_Min_Fields = {
  __typename?: 'transcript_progress_notes_min_fields';
  client_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transcript.progress_notes" */
export type Transcript_Progress_Notes_Mutation_Response = {
  __typename?: 'transcript_progress_notes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Progress_Notes>;
};

/** input type for inserting object relation for remote table "transcript.progress_notes" */
export type Transcript_Progress_Notes_Obj_Rel_Insert_Input = {
  data: Transcript_Progress_Notes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transcript_Progress_Notes_On_Conflict>;
};

/** on_conflict condition type for table "transcript.progress_notes" */
export type Transcript_Progress_Notes_On_Conflict = {
  constraint: Transcript_Progress_Notes_Constraint;
  update_columns?: Array<Transcript_Progress_Notes_Update_Column>;
  where?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript.progress_notes". */
export type Transcript_Progress_Notes_Order_By = {
  client?: InputMaybe<Users_Order_By>;
  client_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  session?: InputMaybe<Transcript_Sessions_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript.progress_notes */
export type Transcript_Progress_Notes_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Progress_Notes_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript.progress_notes" */
export enum Transcript_Progress_Notes_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  SessionId = 'session_id'
}

/** input type for updating data in table "transcript.progress_notes" */
export type Transcript_Progress_Notes_Set_Input = {
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transcript_progress_notes" */
export type Transcript_Progress_Notes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Progress_Notes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Progress_Notes_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transcript.progress_notes" */
export enum Transcript_Progress_Notes_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  SessionId = 'session_id'
}

export type Transcript_Progress_Notes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Progress_Notes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Progress_Notes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Progress_Notes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Progress_Notes_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Progress_Notes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Progress_Notes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Progress_Notes_Bool_Exp;
};

/** columns and relationships of "transcript.score_results" */
export type Transcript_Score_Results = {
  __typename?: 'transcript_score_results';
  data: Scalars['jsonb']['output'];
  /** An object relationship */
  session: Transcript_Sessions;
  session_id: Scalars['String']['output'];
};


/** columns and relationships of "transcript.score_results" */
export type Transcript_Score_ResultsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript.score_results" */
export type Transcript_Score_Results_Aggregate = {
  __typename?: 'transcript_score_results_aggregate';
  aggregate?: Maybe<Transcript_Score_Results_Aggregate_Fields>;
  nodes: Array<Transcript_Score_Results>;
};

/** aggregate fields of "transcript.score_results" */
export type Transcript_Score_Results_Aggregate_Fields = {
  __typename?: 'transcript_score_results_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Score_Results_Max_Fields>;
  min?: Maybe<Transcript_Score_Results_Min_Fields>;
};


/** aggregate fields of "transcript.score_results" */
export type Transcript_Score_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Score_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Score_Results_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript.score_results". All fields are combined with a logical 'AND'. */
export type Transcript_Score_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Score_Results_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Score_Results_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  session?: InputMaybe<Transcript_Sessions_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript.score_results" */
export enum Transcript_Score_Results_Constraint {
  /** unique or primary key constraint on columns "session_id" */
  ScoreResultsPkey = 'score_results_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Score_Results_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Score_Results_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Score_Results_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript.score_results" */
export type Transcript_Score_Results_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session?: InputMaybe<Transcript_Sessions_Obj_Rel_Insert_Input>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Transcript_Score_Results_Max_Fields = {
  __typename?: 'transcript_score_results_max_fields';
  session_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transcript_Score_Results_Min_Fields = {
  __typename?: 'transcript_score_results_min_fields';
  session_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transcript.score_results" */
export type Transcript_Score_Results_Mutation_Response = {
  __typename?: 'transcript_score_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Score_Results>;
};

/** input type for inserting object relation for remote table "transcript.score_results" */
export type Transcript_Score_Results_Obj_Rel_Insert_Input = {
  data: Transcript_Score_Results_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transcript_Score_Results_On_Conflict>;
};

/** on_conflict condition type for table "transcript.score_results" */
export type Transcript_Score_Results_On_Conflict = {
  constraint: Transcript_Score_Results_Constraint;
  update_columns?: Array<Transcript_Score_Results_Update_Column>;
  where?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript.score_results". */
export type Transcript_Score_Results_Order_By = {
  data?: InputMaybe<Order_By>;
  session?: InputMaybe<Transcript_Sessions_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript.score_results */
export type Transcript_Score_Results_Pk_Columns_Input = {
  session_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Score_Results_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript.score_results" */
export enum Transcript_Score_Results_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

/** input type for updating data in table "transcript.score_results" */
export type Transcript_Score_Results_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transcript_score_results" */
export type Transcript_Score_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Score_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Score_Results_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transcript.score_results" */
export enum Transcript_Score_Results_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  SessionId = 'session_id'
}

export type Transcript_Score_Results_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Score_Results_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Score_Results_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Score_Results_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Score_Results_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Score_Results_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Score_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Score_Results_Bool_Exp;
};

/** columns and relationships of "transcript.sessions" */
export type Transcript_Sessions = {
  __typename?: 'transcript_sessions';
  /** An object relationship */
  action_plan?: Maybe<Transcript_Action_Plans>;
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['String']['output'];
  /** An object relationship */
  progress_note?: Maybe<Transcript_Progress_Notes>;
  /** An object relationship */
  score_result?: Maybe<Transcript_Score_Results>;
  /** An object relationship */
  transcript?: Maybe<Transcript_Transcripts>;
  user_id?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "transcript.sessions" */
export type Transcript_SessionsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript.sessions" */
export type Transcript_Sessions_Aggregate = {
  __typename?: 'transcript_sessions_aggregate';
  aggregate?: Maybe<Transcript_Sessions_Aggregate_Fields>;
  nodes: Array<Transcript_Sessions>;
};

/** aggregate fields of "transcript.sessions" */
export type Transcript_Sessions_Aggregate_Fields = {
  __typename?: 'transcript_sessions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Sessions_Max_Fields>;
  min?: Maybe<Transcript_Sessions_Min_Fields>;
};


/** aggregate fields of "transcript.sessions" */
export type Transcript_Sessions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Sessions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Sessions_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript.sessions". All fields are combined with a logical 'AND'. */
export type Transcript_Sessions_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Sessions_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Sessions_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Sessions_Bool_Exp>>;
  action_plan?: InputMaybe<Transcript_Action_Plans_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  progress_note?: InputMaybe<Transcript_Progress_Notes_Bool_Exp>;
  score_result?: InputMaybe<Transcript_Score_Results_Bool_Exp>;
  transcript?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript.sessions" */
export enum Transcript_Sessions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SessionsPkey = 'sessions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Sessions_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Sessions_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Sessions_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript.sessions" */
export type Transcript_Sessions_Insert_Input = {
  action_plan?: InputMaybe<Transcript_Action_Plans_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  progress_note?: InputMaybe<Transcript_Progress_Notes_Obj_Rel_Insert_Input>;
  score_result?: InputMaybe<Transcript_Score_Results_Obj_Rel_Insert_Input>;
  transcript?: InputMaybe<Transcript_Transcripts_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Transcript_Sessions_Max_Fields = {
  __typename?: 'transcript_sessions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Transcript_Sessions_Min_Fields = {
  __typename?: 'transcript_sessions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "transcript.sessions" */
export type Transcript_Sessions_Mutation_Response = {
  __typename?: 'transcript_sessions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Sessions>;
};

/** input type for inserting object relation for remote table "transcript.sessions" */
export type Transcript_Sessions_Obj_Rel_Insert_Input = {
  data: Transcript_Sessions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transcript_Sessions_On_Conflict>;
};

/** on_conflict condition type for table "transcript.sessions" */
export type Transcript_Sessions_On_Conflict = {
  constraint: Transcript_Sessions_Constraint;
  update_columns?: Array<Transcript_Sessions_Update_Column>;
  where?: InputMaybe<Transcript_Sessions_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript.sessions". */
export type Transcript_Sessions_Order_By = {
  action_plan?: InputMaybe<Transcript_Action_Plans_Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  progress_note?: InputMaybe<Transcript_Progress_Notes_Order_By>;
  score_result?: InputMaybe<Transcript_Score_Results_Order_By>;
  transcript?: InputMaybe<Transcript_Transcripts_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript.sessions */
export type Transcript_Sessions_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Sessions_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript.sessions" */
export enum Transcript_Sessions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "transcript.sessions" */
export type Transcript_Sessions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "transcript_sessions" */
export type Transcript_Sessions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Sessions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Sessions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "transcript.sessions" */
export enum Transcript_Sessions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Transcript_Sessions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Sessions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Sessions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Sessions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Sessions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Sessions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Sessions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Sessions_Bool_Exp;
};

/** columns and relationships of "transcript.transcripts" */
export type Transcript_Transcripts = {
  __typename?: 'transcript_transcripts';
  /** An object relationship */
  client?: Maybe<Users>;
  client_id?: Maybe<Scalars['uuid']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  format_source: Scalars['String']['output'];
  /** An object relationship */
  practitioner?: Maybe<Users>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  raw_text: Scalars['String']['output'];
  segments: Scalars['jsonb']['output'];
  /** An object relationship */
  session: Transcript_Sessions;
  session_id: Scalars['String']['output'];
  started_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "transcript.transcripts" */
export type Transcript_TranscriptsSegmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "transcript.transcripts" */
export type Transcript_Transcripts_Aggregate = {
  __typename?: 'transcript_transcripts_aggregate';
  aggregate?: Maybe<Transcript_Transcripts_Aggregate_Fields>;
  nodes: Array<Transcript_Transcripts>;
};

/** aggregate fields of "transcript.transcripts" */
export type Transcript_Transcripts_Aggregate_Fields = {
  __typename?: 'transcript_transcripts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Transcript_Transcripts_Max_Fields>;
  min?: Maybe<Transcript_Transcripts_Min_Fields>;
};


/** aggregate fields of "transcript.transcripts" */
export type Transcript_Transcripts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transcript_Transcripts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Transcripts_Append_Input = {
  segments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "transcript.transcripts". All fields are combined with a logical 'AND'. */
export type Transcript_Transcripts_Bool_Exp = {
  _and?: InputMaybe<Array<Transcript_Transcripts_Bool_Exp>>;
  _not?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
  _or?: InputMaybe<Array<Transcript_Transcripts_Bool_Exp>>;
  client?: InputMaybe<Users_Bool_Exp>;
  client_id?: InputMaybe<Uuid_Comparison_Exp>;
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  format_source?: InputMaybe<String_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_text?: InputMaybe<String_Comparison_Exp>;
  segments?: InputMaybe<Jsonb_Comparison_Exp>;
  session?: InputMaybe<Transcript_Sessions_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "transcript.transcripts" */
export enum Transcript_Transcripts_Constraint {
  /** unique or primary key constraint on columns "session_id" */
  TranscriptsPkey = 'transcripts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Transcript_Transcripts_Delete_At_Path_Input = {
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Transcript_Transcripts_Delete_Elem_Input = {
  segments?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Transcript_Transcripts_Delete_Key_Input = {
  segments?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "transcript.transcripts" */
export type Transcript_Transcripts_Insert_Input = {
  client?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  format_source?: InputMaybe<Scalars['String']['input']>;
  practitioner?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_text?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  session?: InputMaybe<Transcript_Sessions_Obj_Rel_Insert_Input>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Transcript_Transcripts_Max_Fields = {
  __typename?: 'transcript_transcripts_max_fields';
  client_id?: Maybe<Scalars['uuid']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  format_source?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  raw_text?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Transcript_Transcripts_Min_Fields = {
  __typename?: 'transcript_transcripts_min_fields';
  client_id?: Maybe<Scalars['uuid']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  format_source?: Maybe<Scalars['String']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  raw_text?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "transcript.transcripts" */
export type Transcript_Transcripts_Mutation_Response = {
  __typename?: 'transcript_transcripts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transcript_Transcripts>;
};

/** input type for inserting object relation for remote table "transcript.transcripts" */
export type Transcript_Transcripts_Obj_Rel_Insert_Input = {
  data: Transcript_Transcripts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Transcript_Transcripts_On_Conflict>;
};

/** on_conflict condition type for table "transcript.transcripts" */
export type Transcript_Transcripts_On_Conflict = {
  constraint: Transcript_Transcripts_Constraint;
  update_columns?: Array<Transcript_Transcripts_Update_Column>;
  where?: InputMaybe<Transcript_Transcripts_Bool_Exp>;
};

/** Ordering options when selecting data from "transcript.transcripts". */
export type Transcript_Transcripts_Order_By = {
  client?: InputMaybe<Users_Order_By>;
  client_id?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  format_source?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  raw_text?: InputMaybe<Order_By>;
  segments?: InputMaybe<Order_By>;
  session?: InputMaybe<Transcript_Sessions_Order_By>;
  session_id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: transcript.transcripts */
export type Transcript_Transcripts_Pk_Columns_Input = {
  session_id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Transcript_Transcripts_Prepend_Input = {
  segments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "transcript.transcripts" */
export enum Transcript_Transcripts_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FormatSource = 'format_source',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RawText = 'raw_text',
  /** column name */
  Segments = 'segments',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  StartedAt = 'started_at'
}

/** input type for updating data in table "transcript.transcripts" */
export type Transcript_Transcripts_Set_Input = {
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  format_source?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_text?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "transcript_transcripts" */
export type Transcript_Transcripts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transcript_Transcripts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transcript_Transcripts_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['uuid']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  format_source?: InputMaybe<Scalars['String']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_text?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Scalars['jsonb']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "transcript.transcripts" */
export enum Transcript_Transcripts_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  FormatSource = 'format_source',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  RawText = 'raw_text',
  /** column name */
  Segments = 'segments',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  StartedAt = 'started_at'
}

export type Transcript_Transcripts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Transcript_Transcripts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Transcript_Transcripts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Transcript_Transcripts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Transcript_Transcripts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Transcript_Transcripts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Transcript_Transcripts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Transcript_Transcripts_Bool_Exp;
};

/** columns and relationships of "user_feature_flag" */
export type User_Feature_Flag = {
  __typename?: 'user_feature_flag';
  dbt_diary_enabled: Scalars['Boolean']['output'];
  jitai_features_enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  vira_path_enabled: Scalars['Boolean']['output'];
};

/** aggregated selection of "user_feature_flag" */
export type User_Feature_Flag_Aggregate = {
  __typename?: 'user_feature_flag_aggregate';
  aggregate?: Maybe<User_Feature_Flag_Aggregate_Fields>;
  nodes: Array<User_Feature_Flag>;
};

/** aggregate fields of "user_feature_flag" */
export type User_Feature_Flag_Aggregate_Fields = {
  __typename?: 'user_feature_flag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Feature_Flag_Max_Fields>;
  min?: Maybe<User_Feature_Flag_Min_Fields>;
};


/** aggregate fields of "user_feature_flag" */
export type User_Feature_Flag_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Feature_Flag_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_feature_flag". All fields are combined with a logical 'AND'. */
export type User_Feature_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<User_Feature_Flag_Bool_Exp>>;
  _not?: InputMaybe<User_Feature_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<User_Feature_Flag_Bool_Exp>>;
  dbt_diary_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  jitai_features_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vira_path_enabled?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_feature_flag" */
export enum User_Feature_Flag_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserFeatureFlagPkey = 'user_feature_flag_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UsersUserFeatureFlagsUserIdKey = 'users_user_feature_flags_user_id_key'
}

/** input type for inserting data into table "user_feature_flag" */
export type User_Feature_Flag_Insert_Input = {
  dbt_diary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  jitai_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vira_path_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type User_Feature_Flag_Max_Fields = {
  __typename?: 'user_feature_flag_max_fields';
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Feature_Flag_Min_Fields = {
  __typename?: 'user_feature_flag_min_fields';
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_feature_flag" */
export type User_Feature_Flag_Mutation_Response = {
  __typename?: 'user_feature_flag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Feature_Flag>;
};

/** input type for inserting object relation for remote table "user_feature_flag" */
export type User_Feature_Flag_Obj_Rel_Insert_Input = {
  data: User_Feature_Flag_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Feature_Flag_On_Conflict>;
};

/** on_conflict condition type for table "user_feature_flag" */
export type User_Feature_Flag_On_Conflict = {
  constraint: User_Feature_Flag_Constraint;
  update_columns?: Array<User_Feature_Flag_Update_Column>;
  where?: InputMaybe<User_Feature_Flag_Bool_Exp>;
};

/** Ordering options when selecting data from "user_feature_flag". */
export type User_Feature_Flag_Order_By = {
  dbt_diary_enabled?: InputMaybe<Order_By>;
  jitai_features_enabled?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  vira_path_enabled?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_feature_flag */
export type User_Feature_Flag_Pk_Columns_Input = {
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "user_feature_flag" */
export enum User_Feature_Flag_Select_Column {
  /** column name */
  DbtDiaryEnabled = 'dbt_diary_enabled',
  /** column name */
  JitaiFeaturesEnabled = 'jitai_features_enabled',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViraPathEnabled = 'vira_path_enabled'
}

/** input type for updating data in table "user_feature_flag" */
export type User_Feature_Flag_Set_Input = {
  dbt_diary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  jitai_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vira_path_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "user_feature_flag" */
export type User_Feature_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Feature_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Feature_Flag_Stream_Cursor_Value_Input = {
  dbt_diary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  jitai_features_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vira_path_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "user_feature_flag" */
export enum User_Feature_Flag_Update_Column {
  /** column name */
  DbtDiaryEnabled = 'dbt_diary_enabled',
  /** column name */
  JitaiFeaturesEnabled = 'jitai_features_enabled',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ViraPathEnabled = 'vira_path_enabled'
}

export type User_Feature_Flag_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Feature_Flag_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Feature_Flag_Bool_Exp;
};

/** columns and relationships of "user_group_code" */
export type User_Group_Code = {
  __typename?: 'user_group_code';
  created_at: Scalars['timestamptz']['output'];
  group_code_id: Scalars['Int']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_group_code" */
export type User_Group_Code_Aggregate = {
  __typename?: 'user_group_code_aggregate';
  aggregate?: Maybe<User_Group_Code_Aggregate_Fields>;
  nodes: Array<User_Group_Code>;
};

/** aggregate fields of "user_group_code" */
export type User_Group_Code_Aggregate_Fields = {
  __typename?: 'user_group_code_aggregate_fields';
  avg?: Maybe<User_Group_Code_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Group_Code_Max_Fields>;
  min?: Maybe<User_Group_Code_Min_Fields>;
  stddev?: Maybe<User_Group_Code_Stddev_Fields>;
  stddev_pop?: Maybe<User_Group_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Group_Code_Stddev_Samp_Fields>;
  sum?: Maybe<User_Group_Code_Sum_Fields>;
  var_pop?: Maybe<User_Group_Code_Var_Pop_Fields>;
  var_samp?: Maybe<User_Group_Code_Var_Samp_Fields>;
  variance?: Maybe<User_Group_Code_Variance_Fields>;
};


/** aggregate fields of "user_group_code" */
export type User_Group_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Group_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type User_Group_Code_Avg_Fields = {
  __typename?: 'user_group_code_avg_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_group_code". All fields are combined with a logical 'AND'. */
export type User_Group_Code_Bool_Exp = {
  _and?: InputMaybe<Array<User_Group_Code_Bool_Exp>>;
  _not?: InputMaybe<User_Group_Code_Bool_Exp>;
  _or?: InputMaybe<Array<User_Group_Code_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_code_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_group_code" */
export enum User_Group_Code_Constraint {
  /** unique or primary key constraint on columns "user_id", "group_code_id" */
  UserGroupCodePkey = 'user_group_code_pkey'
}

/** input type for incrementing numeric columns in table "user_group_code" */
export type User_Group_Code_Inc_Input = {
  group_code_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_group_code" */
export type User_Group_Code_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_code_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Group_Code_Max_Fields = {
  __typename?: 'user_group_code_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_code_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Group_Code_Min_Fields = {
  __typename?: 'user_group_code_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_code_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_group_code" */
export type User_Group_Code_Mutation_Response = {
  __typename?: 'user_group_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Group_Code>;
};

/** on_conflict condition type for table "user_group_code" */
export type User_Group_Code_On_Conflict = {
  constraint: User_Group_Code_Constraint;
  update_columns?: Array<User_Group_Code_Update_Column>;
  where?: InputMaybe<User_Group_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "user_group_code". */
export type User_Group_Code_Order_By = {
  created_at?: InputMaybe<Order_By>;
  group_code_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_group_code */
export type User_Group_Code_Pk_Columns_Input = {
  group_code_id: Scalars['Int']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "user_group_code" */
export enum User_Group_Code_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupCodeId = 'group_code_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_group_code" */
export type User_Group_Code_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_code_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Group_Code_Stddev_Fields = {
  __typename?: 'user_group_code_stddev_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Group_Code_Stddev_Pop_Fields = {
  __typename?: 'user_group_code_stddev_pop_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Group_Code_Stddev_Samp_Fields = {
  __typename?: 'user_group_code_stddev_samp_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_group_code" */
export type User_Group_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Group_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Group_Code_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_code_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Group_Code_Sum_Fields = {
  __typename?: 'user_group_code_sum_fields';
  group_code_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_group_code" */
export enum User_Group_Code_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupCodeId = 'group_code_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Group_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Group_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Group_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Group_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Group_Code_Var_Pop_Fields = {
  __typename?: 'user_group_code_var_pop_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Group_Code_Var_Samp_Fields = {
  __typename?: 'user_group_code_var_samp_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Group_Code_Variance_Fields = {
  __typename?: 'user_group_code_variance_fields';
  group_code_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "user_insights" */
export type User_Insights = {
  __typename?: 'user_insights';
  created_on: Scalars['timestamp']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  insightRecipe?: Maybe<Insight_Recipes>;
  /** An object relationship */
  insight_combo?: Maybe<Insight_Combos>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  insight_recipe?: Maybe<Scalars['Int']['output']>;
  seen?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_insights" */
export type User_Insights_Aggregate = {
  __typename?: 'user_insights_aggregate';
  aggregate?: Maybe<User_Insights_Aggregate_Fields>;
  nodes: Array<User_Insights>;
};

export type User_Insights_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Insights_Aggregate_Bool_Exp_Count>;
};

export type User_Insights_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Insights_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_insights" */
export type User_Insights_Aggregate_Fields = {
  __typename?: 'user_insights_aggregate_fields';
  avg?: Maybe<User_Insights_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Insights_Max_Fields>;
  min?: Maybe<User_Insights_Min_Fields>;
  stddev?: Maybe<User_Insights_Stddev_Fields>;
  stddev_pop?: Maybe<User_Insights_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Insights_Stddev_Samp_Fields>;
  sum?: Maybe<User_Insights_Sum_Fields>;
  var_pop?: Maybe<User_Insights_Var_Pop_Fields>;
  var_samp?: Maybe<User_Insights_Var_Samp_Fields>;
  variance?: Maybe<User_Insights_Variance_Fields>;
};


/** aggregate fields of "user_insights" */
export type User_Insights_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Insights_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_insights" */
export type User_Insights_Aggregate_Order_By = {
  avg?: InputMaybe<User_Insights_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Insights_Max_Order_By>;
  min?: InputMaybe<User_Insights_Min_Order_By>;
  stddev?: InputMaybe<User_Insights_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Insights_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Insights_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Insights_Sum_Order_By>;
  var_pop?: InputMaybe<User_Insights_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Insights_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Insights_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_insights" */
export type User_Insights_Arr_Rel_Insert_Input = {
  data: Array<User_Insights_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Insights_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Insights_Avg_Fields = {
  __typename?: 'user_insights_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_insights" */
export type User_Insights_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_insights". All fields are combined with a logical 'AND'. */
export type User_Insights_Bool_Exp = {
  _and?: InputMaybe<Array<User_Insights_Bool_Exp>>;
  _not?: InputMaybe<User_Insights_Bool_Exp>;
  _or?: InputMaybe<Array<User_Insights_Bool_Exp>>;
  created_on?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  insightRecipe?: InputMaybe<Insight_Recipes_Bool_Exp>;
  insight_combo?: InputMaybe<Insight_Combos_Bool_Exp>;
  insight_combo_id?: InputMaybe<Int_Comparison_Exp>;
  insight_recipe?: InputMaybe<Int_Comparison_Exp>;
  seen?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_insights" */
export enum User_Insights_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserInsightsPkey = 'user_insights_pkey'
}

/** input type for incrementing numeric columns in table "user_insights" */
export type User_Insights_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_insights" */
export type User_Insights_Insert_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insightRecipe?: InputMaybe<Insight_Recipes_Obj_Rel_Insert_Input>;
  insight_combo?: InputMaybe<Insight_Combos_Obj_Rel_Insert_Input>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['timestamp']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Insights_Max_Fields = {
  __typename?: 'user_insights_max_fields';
  created_on?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  insight_recipe?: Maybe<Scalars['Int']['output']>;
  seen?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_insights" */
export type User_Insights_Max_Order_By = {
  created_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
  seen?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Insights_Min_Fields = {
  __typename?: 'user_insights_min_fields';
  created_on?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  insight_recipe?: Maybe<Scalars['Int']['output']>;
  seen?: Maybe<Scalars['timestamp']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_insights" */
export type User_Insights_Min_Order_By = {
  created_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
  seen?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_insights" */
export type User_Insights_Mutation_Response = {
  __typename?: 'user_insights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Insights>;
};

/** on_conflict condition type for table "user_insights" */
export type User_Insights_On_Conflict = {
  constraint: User_Insights_Constraint;
  update_columns?: Array<User_Insights_Update_Column>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};

/** Ordering options when selecting data from "user_insights". */
export type User_Insights_Order_By = {
  created_on?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  insightRecipe?: InputMaybe<Insight_Recipes_Order_By>;
  insight_combo?: InputMaybe<Insight_Combos_Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
  seen?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_insights */
export type User_Insights_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_insights" */
export enum User_Insights_Select_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Id = 'id',
  /** column name */
  InsightComboId = 'insight_combo_id',
  /** column name */
  InsightRecipe = 'insight_recipe',
  /** column name */
  Seen = 'seen',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_insights" */
export type User_Insights_Set_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Insights_Stddev_Fields = {
  __typename?: 'user_insights_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_insights" */
export type User_Insights_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Insights_Stddev_Pop_Fields = {
  __typename?: 'user_insights_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_insights" */
export type User_Insights_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Insights_Stddev_Samp_Fields = {
  __typename?: 'user_insights_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_insights" */
export type User_Insights_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_insights" */
export type User_Insights_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Insights_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Insights_Stream_Cursor_Value_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  insight_combo_id?: InputMaybe<Scalars['Int']['input']>;
  insight_recipe?: InputMaybe<Scalars['Int']['input']>;
  seen?: InputMaybe<Scalars['timestamp']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Insights_Sum_Fields = {
  __typename?: 'user_insights_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  insight_combo_id?: Maybe<Scalars['Int']['output']>;
  insight_recipe?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_insights" */
export type User_Insights_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** update columns of table "user_insights" */
export enum User_Insights_Update_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Id = 'id',
  /** column name */
  InsightComboId = 'insight_combo_id',
  /** column name */
  InsightRecipe = 'insight_recipe',
  /** column name */
  Seen = 'seen',
  /** column name */
  UserId = 'user_id'
}

export type User_Insights_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Insights_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Insights_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Insights_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Insights_Var_Pop_Fields = {
  __typename?: 'user_insights_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_insights" */
export type User_Insights_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Insights_Var_Samp_Fields = {
  __typename?: 'user_insights_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_insights" */
export type User_Insights_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Insights_Variance_Fields = {
  __typename?: 'user_insights_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  insight_combo_id?: Maybe<Scalars['Float']['output']>;
  insight_recipe?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_insights" */
export type User_Insights_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  insight_combo_id?: InputMaybe<Order_By>;
  insight_recipe?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_invites" */
export type User_Invites = {
  __typename?: 'user_invites';
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  last_name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_invites" */
export type User_Invites_Aggregate = {
  __typename?: 'user_invites_aggregate';
  aggregate?: Maybe<User_Invites_Aggregate_Fields>;
  nodes: Array<User_Invites>;
};

export type User_Invites_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Invites_Aggregate_Bool_Exp_Count>;
};

export type User_Invites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_invites" */
export type User_Invites_Aggregate_Fields = {
  __typename?: 'user_invites_aggregate_fields';
  avg?: Maybe<User_Invites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Invites_Max_Fields>;
  min?: Maybe<User_Invites_Min_Fields>;
  stddev?: Maybe<User_Invites_Stddev_Fields>;
  stddev_pop?: Maybe<User_Invites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Invites_Stddev_Samp_Fields>;
  sum?: Maybe<User_Invites_Sum_Fields>;
  var_pop?: Maybe<User_Invites_Var_Pop_Fields>;
  var_samp?: Maybe<User_Invites_Var_Samp_Fields>;
  variance?: Maybe<User_Invites_Variance_Fields>;
};


/** aggregate fields of "user_invites" */
export type User_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_invites" */
export type User_Invites_Aggregate_Order_By = {
  avg?: InputMaybe<User_Invites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Invites_Max_Order_By>;
  min?: InputMaybe<User_Invites_Min_Order_By>;
  stddev?: InputMaybe<User_Invites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Invites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Invites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Invites_Sum_Order_By>;
  var_pop?: InputMaybe<User_Invites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Invites_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Invites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_invites" */
export type User_Invites_Arr_Rel_Insert_Input = {
  data: Array<User_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Invites_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Invites_Avg_Fields = {
  __typename?: 'user_invites_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_invites" */
export type User_Invites_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_invites". All fields are combined with a logical 'AND'. */
export type User_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<User_Invites_Bool_Exp>>;
  _not?: InputMaybe<User_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<User_Invites_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_invites" */
export enum User_Invites_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserInvitesPkey = 'user_invites_pkey'
}

/** input type for incrementing numeric columns in table "user_invites" */
export type User_Invites_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_invites" */
export type User_Invites_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Invites_Max_Fields = {
  __typename?: 'user_invites_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "user_invites" */
export type User_Invites_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Invites_Min_Fields = {
  __typename?: 'user_invites_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "user_invites" */
export type User_Invites_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_invites" */
export type User_Invites_Mutation_Response = {
  __typename?: 'user_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Invites>;
};

/** on_conflict condition type for table "user_invites" */
export type User_Invites_On_Conflict = {
  constraint: User_Invites_Constraint;
  update_columns?: Array<User_Invites_Update_Column>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "user_invites". */
export type User_Invites_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_invites */
export type User_Invites_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_invites" */
export enum User_Invites_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_invites" */
export type User_Invites_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type User_Invites_Stddev_Fields = {
  __typename?: 'user_invites_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_invites" */
export type User_Invites_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Invites_Stddev_Pop_Fields = {
  __typename?: 'user_invites_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_invites" */
export type User_Invites_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Invites_Stddev_Samp_Fields = {
  __typename?: 'user_invites_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_invites" */
export type User_Invites_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_invites" */
export type User_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Invites_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type User_Invites_Sum_Fields = {
  __typename?: 'user_invites_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_invites" */
export type User_Invites_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_invites" */
export enum User_Invites_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Role = 'role',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Invites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Invites_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Invites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Invites_Var_Pop_Fields = {
  __typename?: 'user_invites_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_invites" */
export type User_Invites_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Invites_Var_Samp_Fields = {
  __typename?: 'user_invites_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_invites" */
export type User_Invites_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Invites_Variance_Fields = {
  __typename?: 'user_invites_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_invites" */
export type User_Invites_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An object relationship */
  account?: Maybe<Auth_Accounts>;
  /** An array relationship */
  activity_rating: Array<Activity_Rating>;
  /** An aggregate relationship */
  activity_rating_aggregate: Activity_Rating_Aggregate;
  avatar_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  clientToOrganizations: Array<Vw_User_Organization>;
  /** An aggregate relationship */
  clientToOrganizations_aggregate: Vw_User_Organization_Aggregate;
  /** An array relationship */
  client_demographics: Array<Client_Demographics>;
  /** An aggregate relationship */
  client_demographics_aggregate: Client_Demographics_Aggregate;
  /** An array relationship */
  client_invite_codes: Array<Invite_Codes>;
  /** An aggregate relationship */
  client_invite_codes_aggregate: Invite_Codes_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  daily_features: Array<Daily_Features>;
  /** An aggregate relationship */
  daily_features_aggregate: Daily_Features_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  feature_reports: Array<Feature_Reports>;
  /** An aggregate relationship */
  feature_reports_aggregate: Feature_Reports_Aggregate;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_derived_data: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_onboarded: Scalars['Boolean']['output'];
  last_check_in_notification?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  logs: Array<Logs>;
  /** An aggregate relationship */
  logs_aggregate: Logs_Aggregate;
  /** An array relationship */
  mobile_device_data: Array<Mobile_Device_Data>;
  /** An aggregate relationship */
  mobile_device_data_aggregate: Mobile_Device_Data_Aggregate;
  /** An array relationship */
  mood_measurements: Array<Mood_Measurements>;
  /** An aggregate relationship */
  mood_measurements_aggregate: Mood_Measurements_Aggregate;
  /** An array relationship */
  mostRecentScoredQuestionnaires: Array<Vw_Most_Recent_Scored_Questionnaires>;
  /** An aggregate relationship */
  mostRecentScoredQuestionnaires_aggregate: Vw_Most_Recent_Scored_Questionnaires_Aggregate;
  most_recent_timezone?: Maybe<Scalars['String']['output']>;
  notification_time?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  nudgeSchedulesByPractitionerId: Array<Nudge_Schedules>;
  /** An aggregate relationship */
  nudgeSchedulesByPractitionerId_aggregate: Nudge_Schedules_Aggregate;
  /** An array relationship */
  nudge_schedules: Array<Nudge_Schedules>;
  /** An aggregate relationship */
  nudge_schedules_aggregate: Nudge_Schedules_Aggregate;
  /** An array relationship */
  nudge_takes: Array<Nudge_Takes>;
  /** An aggregate relationship */
  nudge_takes_aggregate: Nudge_Takes_Aggregate;
  /** An array relationship */
  organization_admins: Array<Organization_Admins>;
  /** An aggregate relationship */
  organization_admins_aggregate: Organization_Admins_Aggregate;
  /** An array relationship */
  organization_members: Array<Organization_Members>;
  /** An aggregate relationship */
  organization_members_aggregate: Organization_Members_Aggregate;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  practitioner_invite_codes: Array<Invite_Codes>;
  /** An aggregate relationship */
  practitioner_invite_codes_aggregate: Invite_Codes_Aggregate;
  push_notification_ids: Scalars['jsonb']['output'];
  /** An array relationship */
  questionnaireSchedulesByPractitionerId: Array<Questionnaire_Schedules>;
  /** An aggregate relationship */
  questionnaireSchedulesByPractitionerId_aggregate: Questionnaire_Schedules_Aggregate;
  /** An array relationship */
  questionnaire_schedules: Array<Questionnaire_Schedules>;
  /** An aggregate relationship */
  questionnaire_schedules_aggregate: Questionnaire_Schedules_Aggregate;
  /** An array relationship */
  questionnaire_takes: Array<Questionnaire_Takes>;
  /** An aggregate relationship */
  questionnaire_takes_aggregate: Questionnaire_Takes_Aggregate;
  /** An array relationship */
  safety_plan: Array<Safety_Plan>;
  /** An aggregate relationship */
  safety_plan_aggregate: Safety_Plan_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_insights: Array<User_Insights>;
  /** An aggregate relationship */
  user_insights_aggregate: User_Insights_Aggregate;
  user_requested_deletion: Scalars['Boolean']['output'];
  user_requested_deletion_at?: Maybe<Scalars['timestamp']['output']>;
  /** An array relationship */
  users_organization_supervisors: Array<Organization_Supervisors>;
  /** An aggregate relationship */
  users_organization_supervisors_aggregate: Organization_Supervisors_Aggregate;
  /** An array relationship */
  users_role_capabilities: Array<Role_Capabilities>;
  /** An aggregate relationship */
  users_role_capabilities_aggregate: Role_Capabilities_Aggregate;
  /** An object relationship */
  users_user_feature_flags?: Maybe<User_Feature_Flag>;
  /** An array relationship */
  vw_daily_features_sleep: Array<Vw_Daily_Features_Sleep>;
  /** An aggregate relationship */
  vw_daily_features_sleep_aggregate: Vw_Daily_Features_Sleep_Aggregate;
  /** An array relationship */
  vw_daily_features_trend: Array<Vw_Daily_Features_Trend>;
  /** An aggregate relationship */
  vw_daily_features_trend_aggregate: Vw_Daily_Features_Trend_Aggregate;
};


/** columns and relationships of "users" */
export type UsersActivity_RatingArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersActivity_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Rating_Order_By>>;
  where?: InputMaybe<Activity_Rating_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClientToOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClientToOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_User_Organization_Order_By>>;
  where?: InputMaybe<Vw_User_Organization_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClient_DemographicsArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClient_Demographics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Client_Demographics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Demographics_Order_By>>;
  where?: InputMaybe<Client_Demographics_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClient_Invite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClient_Invite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDaily_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersDaily_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Daily_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Daily_Features_Order_By>>;
  where?: InputMaybe<Daily_Features_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFeature_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFeature_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feature_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Feature_Reports_Order_By>>;
  where?: InputMaybe<Feature_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMobile_Device_DataArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMobile_Device_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Device_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mobile_Device_Data_Order_By>>;
  where?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMood_MeasurementsArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMood_Measurements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mood_Measurements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mood_Measurements_Order_By>>;
  where?: InputMaybe<Mood_Measurements_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMostRecentScoredQuestionnairesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersMostRecentScoredQuestionnaires_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Order_By>>;
  where?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudgeSchedulesByPractitionerIdArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudgeSchedulesByPractitionerId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudge_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudge_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Schedules_Order_By>>;
  where?: InputMaybe<Nudge_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudge_TakesArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNudge_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nudge_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nudge_Takes_Order_By>>;
  where?: InputMaybe<Nudge_Takes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Admins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Admins_Order_By>>;
  where?: InputMaybe<Organization_Admins_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_MembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganization_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Members_Order_By>>;
  where?: InputMaybe<Organization_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPractitioner_Invite_CodesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPractitioner_Invite_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invite_Codes_Order_By>>;
  where?: InputMaybe<Invite_Codes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPush_Notification_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaireSchedulesByPractitionerIdArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaireSchedulesByPractitionerId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaire_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaire_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Schedules_Order_By>>;
  where?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaire_TakesArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersQuestionnaire_Takes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Questionnaire_Takes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Questionnaire_Takes_Order_By>>;
  where?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSafety_PlanArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersSafety_Plan_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safety_Plan_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Safety_Plan_Order_By>>;
  where?: InputMaybe<Safety_Plan_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_InsightsArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Insights_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Insights_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Insights_Order_By>>;
  where?: InputMaybe<User_Insights_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Organization_SupervisorsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Organization_Supervisors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Supervisors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organization_Supervisors_Order_By>>;
  where?: InputMaybe<Organization_Supervisors_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Role_CapabilitiesArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Role_Capabilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Capabilities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Role_Capabilities_Order_By>>;
  where?: InputMaybe<Role_Capabilities_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVw_Daily_Features_SleepArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVw_Daily_Features_Sleep_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Sleep_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVw_Daily_Features_TrendArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVw_Daily_Features_Trend_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Vw_Daily_Features_Trend_Order_By>>;
  where?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account?: InputMaybe<Auth_Accounts_Bool_Exp>;
  activity_rating?: InputMaybe<Activity_Rating_Bool_Exp>;
  activity_rating_aggregate?: InputMaybe<Activity_Rating_Aggregate_Bool_Exp>;
  avatar_url?: InputMaybe<String_Comparison_Exp>;
  clientToOrganizations?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  clientToOrganizations_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Bool_Exp>;
  client_demographics?: InputMaybe<Client_Demographics_Bool_Exp>;
  client_demographics_aggregate?: InputMaybe<Client_Demographics_Aggregate_Bool_Exp>;
  client_invite_codes?: InputMaybe<Invite_Codes_Bool_Exp>;
  client_invite_codes_aggregate?: InputMaybe<Invite_Codes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  daily_features?: InputMaybe<Daily_Features_Bool_Exp>;
  daily_features_aggregate?: InputMaybe<Daily_Features_Aggregate_Bool_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  feature_reports?: InputMaybe<Feature_Reports_Bool_Exp>;
  feature_reports_aggregate?: InputMaybe<Feature_Reports_Aggregate_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  has_derived_data?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_onboarded?: InputMaybe<Boolean_Comparison_Exp>;
  last_check_in_notification?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  logs?: InputMaybe<Logs_Bool_Exp>;
  logs_aggregate?: InputMaybe<Logs_Aggregate_Bool_Exp>;
  mobile_device_data?: InputMaybe<Mobile_Device_Data_Bool_Exp>;
  mobile_device_data_aggregate?: InputMaybe<Mobile_Device_Data_Aggregate_Bool_Exp>;
  mood_measurements?: InputMaybe<Mood_Measurements_Bool_Exp>;
  mood_measurements_aggregate?: InputMaybe<Mood_Measurements_Aggregate_Bool_Exp>;
  mostRecentScoredQuestionnaires?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  mostRecentScoredQuestionnaires_aggregate?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp>;
  most_recent_timezone?: InputMaybe<String_Comparison_Exp>;
  notification_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  nudgeSchedulesByPractitionerId?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  nudgeSchedulesByPractitionerId_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp>;
  nudge_schedules?: InputMaybe<Nudge_Schedules_Bool_Exp>;
  nudge_schedules_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Bool_Exp>;
  nudge_takes?: InputMaybe<Nudge_Takes_Bool_Exp>;
  nudge_takes_aggregate?: InputMaybe<Nudge_Takes_Aggregate_Bool_Exp>;
  organization_admins?: InputMaybe<Organization_Admins_Bool_Exp>;
  organization_admins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Bool_Exp>;
  organization_members?: InputMaybe<Organization_Members_Bool_Exp>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Bool_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  practitioner_invite_codes?: InputMaybe<Invite_Codes_Bool_Exp>;
  practitioner_invite_codes_aggregate?: InputMaybe<Invite_Codes_Aggregate_Bool_Exp>;
  push_notification_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  questionnaireSchedulesByPractitionerId?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  questionnaireSchedulesByPractitionerId_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp>;
  questionnaire_schedules?: InputMaybe<Questionnaire_Schedules_Bool_Exp>;
  questionnaire_schedules_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Bool_Exp>;
  questionnaire_takes?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  questionnaire_takes_aggregate?: InputMaybe<Questionnaire_Takes_Aggregate_Bool_Exp>;
  safety_plan?: InputMaybe<Safety_Plan_Bool_Exp>;
  safety_plan_aggregate?: InputMaybe<Safety_Plan_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_insights?: InputMaybe<User_Insights_Bool_Exp>;
  user_insights_aggregate?: InputMaybe<User_Insights_Aggregate_Bool_Exp>;
  user_requested_deletion?: InputMaybe<Boolean_Comparison_Exp>;
  user_requested_deletion_at?: InputMaybe<Timestamp_Comparison_Exp>;
  users_organization_supervisors?: InputMaybe<Organization_Supervisors_Bool_Exp>;
  users_organization_supervisors_aggregate?: InputMaybe<Organization_Supervisors_Aggregate_Bool_Exp>;
  users_role_capabilities?: InputMaybe<Role_Capabilities_Bool_Exp>;
  users_role_capabilities_aggregate?: InputMaybe<Role_Capabilities_Aggregate_Bool_Exp>;
  users_user_feature_flags?: InputMaybe<User_Feature_Flag_Bool_Exp>;
  vw_daily_features_sleep?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
  vw_daily_features_sleep_aggregate?: InputMaybe<Vw_Daily_Features_Sleep_Aggregate_Bool_Exp>;
  vw_daily_features_trend?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
  vw_daily_features_trend_aggregate?: InputMaybe<Vw_Daily_Features_Trend_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  push_notification_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  push_notification_ids?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  push_notification_ids?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account?: InputMaybe<Auth_Accounts_Obj_Rel_Insert_Input>;
  activity_rating?: InputMaybe<Activity_Rating_Arr_Rel_Insert_Input>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  clientToOrganizations?: InputMaybe<Vw_User_Organization_Arr_Rel_Insert_Input>;
  client_demographics?: InputMaybe<Client_Demographics_Arr_Rel_Insert_Input>;
  client_invite_codes?: InputMaybe<Invite_Codes_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  daily_features?: InputMaybe<Daily_Features_Arr_Rel_Insert_Input>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  feature_reports?: InputMaybe<Feature_Reports_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_derived_data?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  last_check_in_notification?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  logs?: InputMaybe<Logs_Arr_Rel_Insert_Input>;
  mobile_device_data?: InputMaybe<Mobile_Device_Data_Arr_Rel_Insert_Input>;
  mood_measurements?: InputMaybe<Mood_Measurements_Arr_Rel_Insert_Input>;
  mostRecentScoredQuestionnaires?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Arr_Rel_Insert_Input>;
  most_recent_timezone?: InputMaybe<Scalars['String']['input']>;
  notification_time?: InputMaybe<Scalars['timestamptz']['input']>;
  nudgeSchedulesByPractitionerId?: InputMaybe<Nudge_Schedules_Arr_Rel_Insert_Input>;
  nudge_schedules?: InputMaybe<Nudge_Schedules_Arr_Rel_Insert_Input>;
  nudge_takes?: InputMaybe<Nudge_Takes_Arr_Rel_Insert_Input>;
  organization_admins?: InputMaybe<Organization_Admins_Arr_Rel_Insert_Input>;
  organization_members?: InputMaybe<Organization_Members_Arr_Rel_Insert_Input>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  practitioner_invite_codes?: InputMaybe<Invite_Codes_Arr_Rel_Insert_Input>;
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
  questionnaireSchedulesByPractitionerId?: InputMaybe<Questionnaire_Schedules_Arr_Rel_Insert_Input>;
  questionnaire_schedules?: InputMaybe<Questionnaire_Schedules_Arr_Rel_Insert_Input>;
  questionnaire_takes?: InputMaybe<Questionnaire_Takes_Arr_Rel_Insert_Input>;
  safety_plan?: InputMaybe<Safety_Plan_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_insights?: InputMaybe<User_Insights_Arr_Rel_Insert_Input>;
  user_requested_deletion?: InputMaybe<Scalars['Boolean']['input']>;
  user_requested_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
  users_organization_supervisors?: InputMaybe<Organization_Supervisors_Arr_Rel_Insert_Input>;
  users_role_capabilities?: InputMaybe<Role_Capabilities_Arr_Rel_Insert_Input>;
  users_user_feature_flags?: InputMaybe<User_Feature_Flag_Obj_Rel_Insert_Input>;
  vw_daily_features_sleep?: InputMaybe<Vw_Daily_Features_Sleep_Arr_Rel_Insert_Input>;
  vw_daily_features_trend?: InputMaybe<Vw_Daily_Features_Trend_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "users_insights_display_status" */
export type Users_Insights_Display_Status = {
  __typename?: 'users_insights_display_status';
  created_on: Scalars['timestamp']['output'];
  direction: Enum_Feature_Direction_Enum;
  disabled: Scalars['Boolean']['output'];
  feature: Enum_Feature_Type_Enum;
  id: Scalars['Int']['output'];
  practitioner_id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "users_insights_display_status" */
export type Users_Insights_Display_Status_Aggregate = {
  __typename?: 'users_insights_display_status_aggregate';
  aggregate?: Maybe<Users_Insights_Display_Status_Aggregate_Fields>;
  nodes: Array<Users_Insights_Display_Status>;
};

/** aggregate fields of "users_insights_display_status" */
export type Users_Insights_Display_Status_Aggregate_Fields = {
  __typename?: 'users_insights_display_status_aggregate_fields';
  avg?: Maybe<Users_Insights_Display_Status_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Insights_Display_Status_Max_Fields>;
  min?: Maybe<Users_Insights_Display_Status_Min_Fields>;
  stddev?: Maybe<Users_Insights_Display_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Insights_Display_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Insights_Display_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Insights_Display_Status_Sum_Fields>;
  var_pop?: Maybe<Users_Insights_Display_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Insights_Display_Status_Var_Samp_Fields>;
  variance?: Maybe<Users_Insights_Display_Status_Variance_Fields>;
};


/** aggregate fields of "users_insights_display_status" */
export type Users_Insights_Display_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Insights_Display_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Insights_Display_Status_Avg_Fields = {
  __typename?: 'users_insights_display_status_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users_insights_display_status". All fields are combined with a logical 'AND'. */
export type Users_Insights_Display_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Insights_Display_Status_Bool_Exp>>;
  _not?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Insights_Display_Status_Bool_Exp>>;
  created_on?: InputMaybe<Timestamp_Comparison_Exp>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  feature?: InputMaybe<Enum_Feature_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_insights_display_status" */
export enum Users_Insights_Display_Status_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersInsightsDisplayStatusPkey = 'users_insights_display_status_pkey'
}

/** input type for incrementing numeric columns in table "users_insights_display_status" */
export type Users_Insights_Display_Status_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_insights_display_status" */
export type Users_Insights_Display_Status_Insert_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Users_Insights_Display_Status_Max_Fields = {
  __typename?: 'users_insights_display_status_max_fields';
  created_on?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Users_Insights_Display_Status_Min_Fields = {
  __typename?: 'users_insights_display_status_min_fields';
  created_on?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "users_insights_display_status" */
export type Users_Insights_Display_Status_Mutation_Response = {
  __typename?: 'users_insights_display_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Insights_Display_Status>;
};

/** on_conflict condition type for table "users_insights_display_status" */
export type Users_Insights_Display_Status_On_Conflict = {
  constraint: Users_Insights_Display_Status_Constraint;
  update_columns?: Array<Users_Insights_Display_Status_Update_Column>;
  where?: InputMaybe<Users_Insights_Display_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "users_insights_display_status". */
export type Users_Insights_Display_Status_Order_By = {
  created_on?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  feature?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_insights_display_status */
export type Users_Insights_Display_Status_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_insights_display_status" */
export enum Users_Insights_Display_Status_Select_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Direction = 'direction',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_insights_display_status" */
export type Users_Insights_Display_Status_Set_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Users_Insights_Display_Status_Stddev_Fields = {
  __typename?: 'users_insights_display_status_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Insights_Display_Status_Stddev_Pop_Fields = {
  __typename?: 'users_insights_display_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Insights_Display_Status_Stddev_Samp_Fields = {
  __typename?: 'users_insights_display_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users_insights_display_status" */
export type Users_Insights_Display_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Insights_Display_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Insights_Display_Status_Stream_Cursor_Value_Input = {
  created_on?: InputMaybe<Scalars['timestamp']['input']>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Users_Insights_Display_Status_Sum_Fields = {
  __typename?: 'users_insights_display_status_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "users_insights_display_status" */
export enum Users_Insights_Display_Status_Update_Column {
  /** column name */
  CreatedOn = 'created_on',
  /** column name */
  Direction = 'direction',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  UserId = 'user_id'
}

export type Users_Insights_Display_Status_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Insights_Display_Status_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Insights_Display_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Insights_Display_Status_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Insights_Display_Status_Var_Pop_Fields = {
  __typename?: 'users_insights_display_status_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Insights_Display_Status_Var_Samp_Fields = {
  __typename?: 'users_insights_display_status_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Insights_Display_Status_Variance_Fields = {
  __typename?: 'users_insights_display_status_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_check_in_notification?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  most_recent_timezone?: Maybe<Scalars['String']['output']>;
  notification_time?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_requested_deletion_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  avatar_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_check_in_notification?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  most_recent_timezone?: InputMaybe<Order_By>;
  notification_time?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_requested_deletion_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_check_in_notification?: Maybe<Scalars['timestamptz']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  most_recent_timezone?: Maybe<Scalars['String']['output']>;
  notification_time?: Maybe<Scalars['timestamptz']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_requested_deletion_at?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  avatar_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_check_in_notification?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  most_recent_timezone?: InputMaybe<Order_By>;
  notification_time?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_requested_deletion_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account?: InputMaybe<Auth_Accounts_Order_By>;
  activity_rating_aggregate?: InputMaybe<Activity_Rating_Aggregate_Order_By>;
  avatar_url?: InputMaybe<Order_By>;
  clientToOrganizations_aggregate?: InputMaybe<Vw_User_Organization_Aggregate_Order_By>;
  client_demographics_aggregate?: InputMaybe<Client_Demographics_Aggregate_Order_By>;
  client_invite_codes_aggregate?: InputMaybe<Invite_Codes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  daily_features_aggregate?: InputMaybe<Daily_Features_Aggregate_Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  feature_reports_aggregate?: InputMaybe<Feature_Reports_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  has_derived_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_onboarded?: InputMaybe<Order_By>;
  last_check_in_notification?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  logs_aggregate?: InputMaybe<Logs_Aggregate_Order_By>;
  mobile_device_data_aggregate?: InputMaybe<Mobile_Device_Data_Aggregate_Order_By>;
  mood_measurements_aggregate?: InputMaybe<Mood_Measurements_Aggregate_Order_By>;
  mostRecentScoredQuestionnaires_aggregate?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Order_By>;
  most_recent_timezone?: InputMaybe<Order_By>;
  notification_time?: InputMaybe<Order_By>;
  nudgeSchedulesByPractitionerId_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Order_By>;
  nudge_schedules_aggregate?: InputMaybe<Nudge_Schedules_Aggregate_Order_By>;
  nudge_takes_aggregate?: InputMaybe<Nudge_Takes_Aggregate_Order_By>;
  organization_admins_aggregate?: InputMaybe<Organization_Admins_Aggregate_Order_By>;
  organization_members_aggregate?: InputMaybe<Organization_Members_Aggregate_Order_By>;
  phone_number?: InputMaybe<Order_By>;
  practitioner_invite_codes_aggregate?: InputMaybe<Invite_Codes_Aggregate_Order_By>;
  push_notification_ids?: InputMaybe<Order_By>;
  questionnaireSchedulesByPractitionerId_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Order_By>;
  questionnaire_schedules_aggregate?: InputMaybe<Questionnaire_Schedules_Aggregate_Order_By>;
  questionnaire_takes_aggregate?: InputMaybe<Questionnaire_Takes_Aggregate_Order_By>;
  safety_plan_aggregate?: InputMaybe<Safety_Plan_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_insights_aggregate?: InputMaybe<User_Insights_Aggregate_Order_By>;
  user_requested_deletion?: InputMaybe<Order_By>;
  user_requested_deletion_at?: InputMaybe<Order_By>;
  users_organization_supervisors_aggregate?: InputMaybe<Organization_Supervisors_Aggregate_Order_By>;
  users_role_capabilities_aggregate?: InputMaybe<Role_Capabilities_Aggregate_Order_By>;
  users_user_feature_flags?: InputMaybe<User_Feature_Flag_Order_By>;
  vw_daily_features_sleep_aggregate?: InputMaybe<Vw_Daily_Features_Sleep_Aggregate_Order_By>;
  vw_daily_features_trend_aggregate?: InputMaybe<Vw_Daily_Features_Trend_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HasDerivedData = 'has_derived_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnboarded = 'is_onboarded',
  /** column name */
  LastCheckInNotification = 'last_check_in_notification',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MostRecentTimezone = 'most_recent_timezone',
  /** column name */
  NotificationTime = 'notification_time',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PushNotificationIds = 'push_notification_ids',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserRequestedDeletion = 'user_requested_deletion',
  /** column name */
  UserRequestedDeletionAt = 'user_requested_deletion_at'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasDerivedData = 'has_derived_data',
  /** column name */
  IsOnboarded = 'is_onboarded',
  /** column name */
  UserRequestedDeletion = 'user_requested_deletion'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasDerivedData = 'has_derived_data',
  /** column name */
  IsOnboarded = 'is_onboarded',
  /** column name */
  UserRequestedDeletion = 'user_requested_deletion'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_derived_data?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  last_check_in_notification?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  most_recent_timezone?: InputMaybe<Scalars['String']['input']>;
  notification_time?: InputMaybe<Scalars['timestamptz']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_requested_deletion?: InputMaybe<Scalars['Boolean']['input']>;
  user_requested_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  has_derived_data?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  last_check_in_notification?: InputMaybe<Scalars['timestamptz']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  most_recent_timezone?: InputMaybe<Scalars['String']['input']>;
  notification_time?: InputMaybe<Scalars['timestamptz']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_requested_deletion?: InputMaybe<Scalars['Boolean']['input']>;
  user_requested_deletion_at?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AvatarUrl = 'avatar_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HasDerivedData = 'has_derived_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsOnboarded = 'is_onboarded',
  /** column name */
  LastCheckInNotification = 'last_check_in_notification',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MostRecentTimezone = 'most_recent_timezone',
  /** column name */
  NotificationTime = 'notification_time',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PushNotificationIds = 'push_notification_ids',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserRequestedDeletion = 'user_requested_deletion',
  /** column name */
  UserRequestedDeletionAt = 'user_requested_deletion_at'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep = {
  __typename?: 'vw_daily_features_sleep';
  amt_sleep_day_min?: Maybe<Scalars['numeric']['output']>;
  feature_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['numeric']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Aggregate = {
  __typename?: 'vw_daily_features_sleep_aggregate';
  aggregate?: Maybe<Vw_Daily_Features_Sleep_Aggregate_Fields>;
  nodes: Array<Vw_Daily_Features_Sleep>;
};

export type Vw_Daily_Features_Sleep_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vw_Daily_Features_Sleep_Aggregate_Bool_Exp_Count>;
};

export type Vw_Daily_Features_Sleep_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Aggregate_Fields = {
  __typename?: 'vw_daily_features_sleep_aggregate_fields';
  avg?: Maybe<Vw_Daily_Features_Sleep_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Daily_Features_Sleep_Max_Fields>;
  min?: Maybe<Vw_Daily_Features_Sleep_Min_Fields>;
  stddev?: Maybe<Vw_Daily_Features_Sleep_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Daily_Features_Sleep_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Daily_Features_Sleep_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Daily_Features_Sleep_Sum_Fields>;
  var_pop?: Maybe<Vw_Daily_Features_Sleep_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Daily_Features_Sleep_Var_Samp_Fields>;
  variance?: Maybe<Vw_Daily_Features_Sleep_Variance_Fields>;
};


/** aggregate fields of "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Daily_Features_Sleep_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Aggregate_Order_By = {
  avg?: InputMaybe<Vw_Daily_Features_Sleep_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vw_Daily_Features_Sleep_Max_Order_By>;
  min?: InputMaybe<Vw_Daily_Features_Sleep_Min_Order_By>;
  stddev?: InputMaybe<Vw_Daily_Features_Sleep_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vw_Daily_Features_Sleep_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vw_Daily_Features_Sleep_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vw_Daily_Features_Sleep_Sum_Order_By>;
  var_pop?: InputMaybe<Vw_Daily_Features_Sleep_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vw_Daily_Features_Sleep_Var_Samp_Order_By>;
  variance?: InputMaybe<Vw_Daily_Features_Sleep_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Arr_Rel_Insert_Input = {
  data: Array<Vw_Daily_Features_Sleep_Insert_Input>;
};

/** aggregate avg on columns */
export type Vw_Daily_Features_Sleep_Avg_Fields = {
  __typename?: 'vw_daily_features_sleep_avg_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Avg_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_daily_features_sleep". All fields are combined with a logical 'AND'. */
export type Vw_Daily_Features_Sleep_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Daily_Features_Sleep_Bool_Exp>>;
  _not?: InputMaybe<Vw_Daily_Features_Sleep_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Daily_Features_Sleep_Bool_Exp>>;
  amt_sleep_day_min?: InputMaybe<Numeric_Comparison_Exp>;
  feature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  val_bedtime_offset_hour?: InputMaybe<Numeric_Comparison_Exp>;
  val_waketime_offset_hour?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for inserting data into table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Insert_Input = {
  amt_sleep_day_min?: InputMaybe<Scalars['numeric']['input']>;
  feature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  val_bedtime_offset_hour?: InputMaybe<Scalars['numeric']['input']>;
  val_waketime_offset_hour?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Vw_Daily_Features_Sleep_Max_Fields = {
  __typename?: 'vw_daily_features_sleep_max_fields';
  amt_sleep_day_min?: Maybe<Scalars['numeric']['output']>;
  feature_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['numeric']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Max_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vw_Daily_Features_Sleep_Min_Fields = {
  __typename?: 'vw_daily_features_sleep_min_fields';
  amt_sleep_day_min?: Maybe<Scalars['numeric']['output']>;
  feature_date?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['numeric']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Min_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vw_daily_features_sleep". */
export type Vw_Daily_Features_Sleep_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  feature_date?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** select columns of table "vw_daily_features_sleep" */
export enum Vw_Daily_Features_Sleep_Select_Column {
  /** column name */
  AmtSleepDayMin = 'amt_sleep_day_min',
  /** column name */
  FeatureDate = 'feature_date',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValBedtimeOffsetHour = 'val_bedtime_offset_hour',
  /** column name */
  ValWaketimeOffsetHour = 'val_waketime_offset_hour'
}

/** aggregate stddev on columns */
export type Vw_Daily_Features_Sleep_Stddev_Fields = {
  __typename?: 'vw_daily_features_sleep_stddev_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Stddev_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vw_Daily_Features_Sleep_Stddev_Pop_Fields = {
  __typename?: 'vw_daily_features_sleep_stddev_pop_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Stddev_Pop_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vw_Daily_Features_Sleep_Stddev_Samp_Fields = {
  __typename?: 'vw_daily_features_sleep_stddev_samp_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Stddev_Samp_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Daily_Features_Sleep_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Daily_Features_Sleep_Stream_Cursor_Value_Input = {
  amt_sleep_day_min?: InputMaybe<Scalars['numeric']['input']>;
  feature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  val_bedtime_offset_hour?: InputMaybe<Scalars['numeric']['input']>;
  val_waketime_offset_hour?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Vw_Daily_Features_Sleep_Sum_Fields = {
  __typename?: 'vw_daily_features_sleep_sum_fields';
  amt_sleep_day_min?: Maybe<Scalars['numeric']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['numeric']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Sum_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vw_Daily_Features_Sleep_Var_Pop_Fields = {
  __typename?: 'vw_daily_features_sleep_var_pop_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Var_Pop_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vw_Daily_Features_Sleep_Var_Samp_Fields = {
  __typename?: 'vw_daily_features_sleep_var_samp_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Var_Samp_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vw_Daily_Features_Sleep_Variance_Fields = {
  __typename?: 'vw_daily_features_sleep_variance_fields';
  amt_sleep_day_min?: Maybe<Scalars['Float']['output']>;
  val_bedtime_offset_hour?: Maybe<Scalars['Float']['output']>;
  val_waketime_offset_hour?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vw_daily_features_sleep" */
export type Vw_Daily_Features_Sleep_Variance_Order_By = {
  amt_sleep_day_min?: InputMaybe<Order_By>;
  val_bedtime_offset_hour?: InputMaybe<Order_By>;
  val_waketime_offset_hour?: InputMaybe<Order_By>;
};

/** columns and relationships of "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend = {
  __typename?: 'vw_daily_features_trend';
  avg_last_week?: Maybe<Scalars['numeric']['output']>;
  avg_this_week?: Maybe<Scalars['numeric']['output']>;
  count_last_week?: Maybe<Scalars['bigint']['output']>;
  count_this_week?: Maybe<Scalars['bigint']['output']>;
  delta?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  stddev_last_week?: Maybe<Scalars['numeric']['output']>;
  stddev_this_week?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Aggregate = {
  __typename?: 'vw_daily_features_trend_aggregate';
  aggregate?: Maybe<Vw_Daily_Features_Trend_Aggregate_Fields>;
  nodes: Array<Vw_Daily_Features_Trend>;
};

export type Vw_Daily_Features_Trend_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vw_Daily_Features_Trend_Aggregate_Bool_Exp_Count>;
};

export type Vw_Daily_Features_Trend_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Aggregate_Fields = {
  __typename?: 'vw_daily_features_trend_aggregate_fields';
  avg?: Maybe<Vw_Daily_Features_Trend_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Daily_Features_Trend_Max_Fields>;
  min?: Maybe<Vw_Daily_Features_Trend_Min_Fields>;
  stddev?: Maybe<Vw_Daily_Features_Trend_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Daily_Features_Trend_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Daily_Features_Trend_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Daily_Features_Trend_Sum_Fields>;
  var_pop?: Maybe<Vw_Daily_Features_Trend_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Daily_Features_Trend_Var_Samp_Fields>;
  variance?: Maybe<Vw_Daily_Features_Trend_Variance_Fields>;
};


/** aggregate fields of "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Daily_Features_Trend_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Aggregate_Order_By = {
  avg?: InputMaybe<Vw_Daily_Features_Trend_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vw_Daily_Features_Trend_Max_Order_By>;
  min?: InputMaybe<Vw_Daily_Features_Trend_Min_Order_By>;
  stddev?: InputMaybe<Vw_Daily_Features_Trend_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vw_Daily_Features_Trend_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vw_Daily_Features_Trend_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vw_Daily_Features_Trend_Sum_Order_By>;
  var_pop?: InputMaybe<Vw_Daily_Features_Trend_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vw_Daily_Features_Trend_Var_Samp_Order_By>;
  variance?: InputMaybe<Vw_Daily_Features_Trend_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Arr_Rel_Insert_Input = {
  data: Array<Vw_Daily_Features_Trend_Insert_Input>;
};

/** aggregate avg on columns */
export type Vw_Daily_Features_Trend_Avg_Fields = {
  __typename?: 'vw_daily_features_trend_avg_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Avg_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_daily_features_trend". All fields are combined with a logical 'AND'. */
export type Vw_Daily_Features_Trend_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Daily_Features_Trend_Bool_Exp>>;
  _not?: InputMaybe<Vw_Daily_Features_Trend_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Daily_Features_Trend_Bool_Exp>>;
  avg_last_week?: InputMaybe<Numeric_Comparison_Exp>;
  avg_this_week?: InputMaybe<Numeric_Comparison_Exp>;
  count_last_week?: InputMaybe<Bigint_Comparison_Exp>;
  count_this_week?: InputMaybe<Bigint_Comparison_Exp>;
  delta?: InputMaybe<Numeric_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  stddev_last_week?: InputMaybe<Numeric_Comparison_Exp>;
  stddev_this_week?: InputMaybe<Numeric_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Insert_Input = {
  avg_last_week?: InputMaybe<Scalars['numeric']['input']>;
  avg_this_week?: InputMaybe<Scalars['numeric']['input']>;
  count_last_week?: InputMaybe<Scalars['bigint']['input']>;
  count_this_week?: InputMaybe<Scalars['bigint']['input']>;
  delta?: InputMaybe<Scalars['numeric']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  stddev_last_week?: InputMaybe<Scalars['numeric']['input']>;
  stddev_this_week?: InputMaybe<Scalars['numeric']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vw_Daily_Features_Trend_Max_Fields = {
  __typename?: 'vw_daily_features_trend_max_fields';
  avg_last_week?: Maybe<Scalars['numeric']['output']>;
  avg_this_week?: Maybe<Scalars['numeric']['output']>;
  count_last_week?: Maybe<Scalars['bigint']['output']>;
  count_this_week?: Maybe<Scalars['bigint']['output']>;
  delta?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  stddev_last_week?: Maybe<Scalars['numeric']['output']>;
  stddev_this_week?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Max_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vw_Daily_Features_Trend_Min_Fields = {
  __typename?: 'vw_daily_features_trend_min_fields';
  avg_last_week?: Maybe<Scalars['numeric']['output']>;
  avg_this_week?: Maybe<Scalars['numeric']['output']>;
  count_last_week?: Maybe<Scalars['bigint']['output']>;
  count_this_week?: Maybe<Scalars['bigint']['output']>;
  delta?: Maybe<Scalars['numeric']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  stddev_last_week?: Maybe<Scalars['numeric']['output']>;
  stddev_this_week?: Maybe<Scalars['numeric']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Min_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vw_daily_features_trend". */
export type Vw_Daily_Features_Trend_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_daily_features_trend" */
export enum Vw_Daily_Features_Trend_Select_Column {
  /** column name */
  AvgLastWeek = 'avg_last_week',
  /** column name */
  AvgThisWeek = 'avg_this_week',
  /** column name */
  CountLastWeek = 'count_last_week',
  /** column name */
  CountThisWeek = 'count_this_week',
  /** column name */
  Delta = 'delta',
  /** column name */
  Direction = 'direction',
  /** column name */
  Key = 'key',
  /** column name */
  StddevLastWeek = 'stddev_last_week',
  /** column name */
  StddevThisWeek = 'stddev_this_week',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Vw_Daily_Features_Trend_Stddev_Fields = {
  __typename?: 'vw_daily_features_trend_stddev_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Stddev_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vw_Daily_Features_Trend_Stddev_Pop_Fields = {
  __typename?: 'vw_daily_features_trend_stddev_pop_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Stddev_Pop_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vw_Daily_Features_Trend_Stddev_Samp_Fields = {
  __typename?: 'vw_daily_features_trend_stddev_samp_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Stddev_Samp_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Daily_Features_Trend_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Daily_Features_Trend_Stream_Cursor_Value_Input = {
  avg_last_week?: InputMaybe<Scalars['numeric']['input']>;
  avg_this_week?: InputMaybe<Scalars['numeric']['input']>;
  count_last_week?: InputMaybe<Scalars['bigint']['input']>;
  count_this_week?: InputMaybe<Scalars['bigint']['input']>;
  delta?: InputMaybe<Scalars['numeric']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  stddev_last_week?: InputMaybe<Scalars['numeric']['input']>;
  stddev_this_week?: InputMaybe<Scalars['numeric']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vw_Daily_Features_Trend_Sum_Fields = {
  __typename?: 'vw_daily_features_trend_sum_fields';
  avg_last_week?: Maybe<Scalars['numeric']['output']>;
  avg_this_week?: Maybe<Scalars['numeric']['output']>;
  count_last_week?: Maybe<Scalars['bigint']['output']>;
  count_this_week?: Maybe<Scalars['bigint']['output']>;
  delta?: Maybe<Scalars['numeric']['output']>;
  stddev_last_week?: Maybe<Scalars['numeric']['output']>;
  stddev_this_week?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Sum_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vw_Daily_Features_Trend_Var_Pop_Fields = {
  __typename?: 'vw_daily_features_trend_var_pop_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Var_Pop_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vw_Daily_Features_Trend_Var_Samp_Fields = {
  __typename?: 'vw_daily_features_trend_var_samp_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Var_Samp_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vw_Daily_Features_Trend_Variance_Fields = {
  __typename?: 'vw_daily_features_trend_variance_fields';
  avg_last_week?: Maybe<Scalars['Float']['output']>;
  avg_this_week?: Maybe<Scalars['Float']['output']>;
  count_last_week?: Maybe<Scalars['Float']['output']>;
  count_this_week?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  stddev_last_week?: Maybe<Scalars['Float']['output']>;
  stddev_this_week?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vw_daily_features_trend" */
export type Vw_Daily_Features_Trend_Variance_Order_By = {
  avg_last_week?: InputMaybe<Order_By>;
  avg_this_week?: InputMaybe<Order_By>;
  count_last_week?: InputMaybe<Order_By>;
  count_this_week?: InputMaybe<Order_By>;
  delta?: InputMaybe<Order_By>;
  stddev_last_week?: InputMaybe<Order_By>;
  stddev_this_week?: InputMaybe<Order_By>;
};

/** columns and relationships of "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires = {
  __typename?: 'vw_most_recent_scored_questionnaires';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  questionnaireTake?: Maybe<Questionnaire_Takes>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Aggregate = {
  __typename?: 'vw_most_recent_scored_questionnaires_aggregate';
  aggregate?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Fields>;
  nodes: Array<Vw_Most_Recent_Scored_Questionnaires>;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Var_Samp>;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Avg = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Max = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Min = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Sum = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_aggregate_fields';
  avg?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Max_Fields>;
  min?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Min_Fields>;
  stddev?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Sum_Fields>;
  var_pop?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Var_Samp_Fields>;
  variance?: Maybe<Vw_Most_Recent_Scored_Questionnaires_Variance_Fields>;
};


/** aggregate fields of "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Aggregate_Order_By = {
  avg?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Max_Order_By>;
  min?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Min_Order_By>;
  stddev?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Sum_Order_By>;
  var_pop?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Var_Samp_Order_By>;
  variance?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Arr_Rel_Insert_Input = {
  data: Array<Vw_Most_Recent_Scored_Questionnaires_Insert_Input>;
};

/** aggregate avg on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Avg_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_avg_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Avg_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_most_recent_scored_questionnaires". All fields are combined with a logical 'AND'. */
export type Vw_Most_Recent_Scored_Questionnaires_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>>;
  _not?: InputMaybe<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Most_Recent_Scored_Questionnaires_Bool_Exp>>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_score?: InputMaybe<Float8_Comparison_Exp>;
  display_score_type?: InputMaybe<String_Comparison_Exp>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_name?: InputMaybe<String_Comparison_Exp>;
  questionnaire_take_id?: InputMaybe<Int_Comparison_Exp>;
  scoring_display_color?: InputMaybe<String_Comparison_Exp>;
  scoring_display_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Insert_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_name?: InputMaybe<Scalars['String']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  scoring_display_color?: InputMaybe<Scalars['String']['input']>;
  scoring_display_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Max_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_max_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  display_score_type?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_name?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  scoring_display_color?: InputMaybe<Order_By>;
  scoring_display_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Min_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_min_fields';
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  display_score_type?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_name?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  scoring_display_color?: InputMaybe<Order_By>;
  scoring_display_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vw_most_recent_scored_questionnaires". */
export type Vw_Most_Recent_Scored_Questionnaires_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  display_score_type?: InputMaybe<Order_By>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_name?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  scoring_display_color?: InputMaybe<Order_By>;
  scoring_display_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column {
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  DisplayScore = 'display_score',
  /** column name */
  DisplayScoreType = 'display_score_type',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  QuestionnaireName = 'questionnaire_name',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id',
  /** column name */
  ScoringDisplayColor = 'scoring_display_color',
  /** column name */
  ScoringDisplayName = 'scoring_display_name',
  /** column name */
  UserId = 'user_id'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_avg_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_corr_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_max_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_min_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_sum_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** select "vw_most_recent_scored_questionnaires_aggregate_bool_exp_var_samp_arguments_columns" columns of table "vw_most_recent_scored_questionnaires" */
export enum Vw_Most_Recent_Scored_Questionnaires_Select_Column_Vw_Most_Recent_Scored_Questionnaires_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DisplayScore = 'display_score'
}

/** aggregate stddev on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_stddev_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Pop_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_stddev_pop_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Pop_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Samp_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_stddev_samp_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Stddev_Samp_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Most_Recent_Scored_Questionnaires_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Most_Recent_Scored_Questionnaires_Stream_Cursor_Value_Input = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_name?: InputMaybe<Scalars['String']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  scoring_display_color?: InputMaybe<Scalars['String']['input']>;
  scoring_display_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Sum_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_sum_fields';
  display_score?: Maybe<Scalars['float8']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Sum_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Var_Pop_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_var_pop_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Var_Pop_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Var_Samp_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_var_samp_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Var_Samp_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vw_Most_Recent_Scored_Questionnaires_Variance_Fields = {
  __typename?: 'vw_most_recent_scored_questionnaires_variance_fields';
  display_score?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vw_most_recent_scored_questionnaires" */
export type Vw_Most_Recent_Scored_Questionnaires_Variance_Order_By = {
  display_score?: InputMaybe<Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vw_org_client_count" */
export type Vw_Org_Client_Count = {
  __typename?: 'vw_org_client_count';
  client_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "vw_org_client_count" */
export type Vw_Org_Client_Count_Aggregate = {
  __typename?: 'vw_org_client_count_aggregate';
  aggregate?: Maybe<Vw_Org_Client_Count_Aggregate_Fields>;
  nodes: Array<Vw_Org_Client_Count>;
};

/** aggregate fields of "vw_org_client_count" */
export type Vw_Org_Client_Count_Aggregate_Fields = {
  __typename?: 'vw_org_client_count_aggregate_fields';
  avg?: Maybe<Vw_Org_Client_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Org_Client_Count_Max_Fields>;
  min?: Maybe<Vw_Org_Client_Count_Min_Fields>;
  stddev?: Maybe<Vw_Org_Client_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Org_Client_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Org_Client_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Org_Client_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Org_Client_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Org_Client_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Org_Client_Count_Variance_Fields>;
};


/** aggregate fields of "vw_org_client_count" */
export type Vw_Org_Client_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Org_Client_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Org_Client_Count_Avg_Fields = {
  __typename?: 'vw_org_client_count_avg_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_org_client_count". All fields are combined with a logical 'AND'. */
export type Vw_Org_Client_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Org_Client_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Org_Client_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Org_Client_Count_Bool_Exp>>;
  client_count?: InputMaybe<Bigint_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Org_Client_Count_Max_Fields = {
  __typename?: 'vw_org_client_count_max_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Vw_Org_Client_Count_Min_Fields = {
  __typename?: 'vw_org_client_count_min_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "vw_org_client_count". */
export type Vw_Org_Client_Count_Order_By = {
  client_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_org_client_count" */
export enum Vw_Org_Client_Count_Select_Column {
  /** column name */
  ClientCount = 'client_count',
  /** column name */
  OrganizationId = 'organization_id'
}

/** aggregate stddev on columns */
export type Vw_Org_Client_Count_Stddev_Fields = {
  __typename?: 'vw_org_client_count_stddev_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Org_Client_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_org_client_count_stddev_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Org_Client_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_org_client_count_stddev_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_org_client_count" */
export type Vw_Org_Client_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Org_Client_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Org_Client_Count_Stream_Cursor_Value_Input = {
  client_count?: InputMaybe<Scalars['bigint']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Vw_Org_Client_Count_Sum_Fields = {
  __typename?: 'vw_org_client_count_sum_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Org_Client_Count_Var_Pop_Fields = {
  __typename?: 'vw_org_client_count_var_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Org_Client_Count_Var_Samp_Fields = {
  __typename?: 'vw_org_client_count_var_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Org_Client_Count_Variance_Fields = {
  __typename?: 'vw_org_client_count_variance_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_org_nudge_count" */
export type Vw_Org_Nudge_Count = {
  __typename?: 'vw_org_nudge_count';
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "vw_org_nudge_count" */
export type Vw_Org_Nudge_Count_Aggregate = {
  __typename?: 'vw_org_nudge_count_aggregate';
  aggregate?: Maybe<Vw_Org_Nudge_Count_Aggregate_Fields>;
  nodes: Array<Vw_Org_Nudge_Count>;
};

/** aggregate fields of "vw_org_nudge_count" */
export type Vw_Org_Nudge_Count_Aggregate_Fields = {
  __typename?: 'vw_org_nudge_count_aggregate_fields';
  avg?: Maybe<Vw_Org_Nudge_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Org_Nudge_Count_Max_Fields>;
  min?: Maybe<Vw_Org_Nudge_Count_Min_Fields>;
  stddev?: Maybe<Vw_Org_Nudge_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Org_Nudge_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Org_Nudge_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Org_Nudge_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Org_Nudge_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Org_Nudge_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Org_Nudge_Count_Variance_Fields>;
};


/** aggregate fields of "vw_org_nudge_count" */
export type Vw_Org_Nudge_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Org_Nudge_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Org_Nudge_Count_Avg_Fields = {
  __typename?: 'vw_org_nudge_count_avg_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_org_nudge_count". All fields are combined with a logical 'AND'. */
export type Vw_Org_Nudge_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Org_Nudge_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Org_Nudge_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Org_Nudge_Count_Bool_Exp>>;
  nudge_count?: InputMaybe<Bigint_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Org_Nudge_Count_Max_Fields = {
  __typename?: 'vw_org_nudge_count_max_fields';
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Vw_Org_Nudge_Count_Min_Fields = {
  __typename?: 'vw_org_nudge_count_min_fields';
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "vw_org_nudge_count". */
export type Vw_Org_Nudge_Count_Order_By = {
  nudge_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_org_nudge_count" */
export enum Vw_Org_Nudge_Count_Select_Column {
  /** column name */
  NudgeCount = 'nudge_count',
  /** column name */
  OrganizationId = 'organization_id'
}

/** aggregate stddev on columns */
export type Vw_Org_Nudge_Count_Stddev_Fields = {
  __typename?: 'vw_org_nudge_count_stddev_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Org_Nudge_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_org_nudge_count_stddev_pop_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Org_Nudge_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_org_nudge_count_stddev_samp_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_org_nudge_count" */
export type Vw_Org_Nudge_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Org_Nudge_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Org_Nudge_Count_Stream_Cursor_Value_Input = {
  nudge_count?: InputMaybe<Scalars['bigint']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Vw_Org_Nudge_Count_Sum_Fields = {
  __typename?: 'vw_org_nudge_count_sum_fields';
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Org_Nudge_Count_Var_Pop_Fields = {
  __typename?: 'vw_org_nudge_count_var_pop_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Org_Nudge_Count_Var_Samp_Fields = {
  __typename?: 'vw_org_nudge_count_var_samp_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Org_Nudge_Count_Variance_Fields = {
  __typename?: 'vw_org_nudge_count_variance_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_org_nudge_technique_counts" */
export type Vw_Org_Nudge_Technique_Counts = {
  __typename?: 'vw_org_nudge_technique_counts';
  active?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['bigint']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "vw_org_nudge_technique_counts" */
export type Vw_Org_Nudge_Technique_Counts_Aggregate = {
  __typename?: 'vw_org_nudge_technique_counts_aggregate';
  aggregate?: Maybe<Vw_Org_Nudge_Technique_Counts_Aggregate_Fields>;
  nodes: Array<Vw_Org_Nudge_Technique_Counts>;
};

/** aggregate fields of "vw_org_nudge_technique_counts" */
export type Vw_Org_Nudge_Technique_Counts_Aggregate_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_aggregate_fields';
  avg?: Maybe<Vw_Org_Nudge_Technique_Counts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Org_Nudge_Technique_Counts_Max_Fields>;
  min?: Maybe<Vw_Org_Nudge_Technique_Counts_Min_Fields>;
  stddev?: Maybe<Vw_Org_Nudge_Technique_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Org_Nudge_Technique_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Org_Nudge_Technique_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Org_Nudge_Technique_Counts_Sum_Fields>;
  var_pop?: Maybe<Vw_Org_Nudge_Technique_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Org_Nudge_Technique_Counts_Var_Samp_Fields>;
  variance?: Maybe<Vw_Org_Nudge_Technique_Counts_Variance_Fields>;
};


/** aggregate fields of "vw_org_nudge_technique_counts" */
export type Vw_Org_Nudge_Technique_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Org_Nudge_Technique_Counts_Avg_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_avg_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_org_nudge_technique_counts". All fields are combined with a logical 'AND'. */
export type Vw_Org_Nudge_Technique_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Bool_Exp>>;
  _not?: InputMaybe<Vw_Org_Nudge_Technique_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Org_Nudge_Technique_Counts_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  technique?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Org_Nudge_Technique_Counts_Max_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_max_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Vw_Org_Nudge_Technique_Counts_Min_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_min_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  technique?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "vw_org_nudge_technique_counts". */
export type Vw_Org_Nudge_Technique_Counts_Order_By = {
  active?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  technique?: InputMaybe<Order_By>;
};

/** select columns of table "vw_org_nudge_technique_counts" */
export enum Vw_Org_Nudge_Technique_Counts_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Count = 'count',
  /** column name */
  Domain = 'domain',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Technique = 'technique'
}

/** aggregate stddev on columns */
export type Vw_Org_Nudge_Technique_Counts_Stddev_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_stddev_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Org_Nudge_Technique_Counts_Stddev_Pop_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_stddev_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Org_Nudge_Technique_Counts_Stddev_Samp_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_stddev_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_org_nudge_technique_counts" */
export type Vw_Org_Nudge_Technique_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Org_Nudge_Technique_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Org_Nudge_Technique_Counts_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['bigint']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Vw_Org_Nudge_Technique_Counts_Sum_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_sum_fields';
  count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Org_Nudge_Technique_Counts_Var_Pop_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_var_pop_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Org_Nudge_Technique_Counts_Var_Samp_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_var_samp_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Org_Nudge_Technique_Counts_Variance_Fields = {
  __typename?: 'vw_org_nudge_technique_counts_variance_fields';
  count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_org_questionnaire_count" */
export type Vw_Org_Questionnaire_Count = {
  __typename?: 'vw_org_questionnaire_count';
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "vw_org_questionnaire_count" */
export type Vw_Org_Questionnaire_Count_Aggregate = {
  __typename?: 'vw_org_questionnaire_count_aggregate';
  aggregate?: Maybe<Vw_Org_Questionnaire_Count_Aggregate_Fields>;
  nodes: Array<Vw_Org_Questionnaire_Count>;
};

/** aggregate fields of "vw_org_questionnaire_count" */
export type Vw_Org_Questionnaire_Count_Aggregate_Fields = {
  __typename?: 'vw_org_questionnaire_count_aggregate_fields';
  avg?: Maybe<Vw_Org_Questionnaire_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Org_Questionnaire_Count_Max_Fields>;
  min?: Maybe<Vw_Org_Questionnaire_Count_Min_Fields>;
  stddev?: Maybe<Vw_Org_Questionnaire_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Org_Questionnaire_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Org_Questionnaire_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Org_Questionnaire_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Org_Questionnaire_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Org_Questionnaire_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Org_Questionnaire_Count_Variance_Fields>;
};


/** aggregate fields of "vw_org_questionnaire_count" */
export type Vw_Org_Questionnaire_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Org_Questionnaire_Count_Avg_Fields = {
  __typename?: 'vw_org_questionnaire_count_avg_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_org_questionnaire_count". All fields are combined with a logical 'AND'. */
export type Vw_Org_Questionnaire_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Org_Questionnaire_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Org_Questionnaire_Count_Bool_Exp>>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Org_Questionnaire_Count_Max_Fields = {
  __typename?: 'vw_org_questionnaire_count_max_fields';
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Vw_Org_Questionnaire_Count_Min_Fields = {
  __typename?: 'vw_org_questionnaire_count_min_fields';
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "vw_org_questionnaire_count". */
export type Vw_Org_Questionnaire_Count_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  questionnaire_count?: InputMaybe<Order_By>;
};

/** select columns of table "vw_org_questionnaire_count" */
export enum Vw_Org_Questionnaire_Count_Select_Column {
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  QuestionnaireCount = 'questionnaire_count'
}

/** aggregate stddev on columns */
export type Vw_Org_Questionnaire_Count_Stddev_Fields = {
  __typename?: 'vw_org_questionnaire_count_stddev_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Org_Questionnaire_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_org_questionnaire_count_stddev_pop_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Org_Questionnaire_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_org_questionnaire_count_stddev_samp_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_org_questionnaire_count" */
export type Vw_Org_Questionnaire_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Org_Questionnaire_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Org_Questionnaire_Count_Stream_Cursor_Value_Input = {
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vw_Org_Questionnaire_Count_Sum_Fields = {
  __typename?: 'vw_org_questionnaire_count_sum_fields';
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Org_Questionnaire_Count_Var_Pop_Fields = {
  __typename?: 'vw_org_questionnaire_count_var_pop_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Org_Questionnaire_Count_Var_Samp_Fields = {
  __typename?: 'vw_org_questionnaire_count_var_samp_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Org_Questionnaire_Count_Variance_Fields = {
  __typename?: 'vw_org_questionnaire_count_variance_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_organization_summary" */
export type Vw_Organization_Summary = {
  __typename?: 'vw_organization_summary';
  id?: Maybe<Scalars['Int']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['bigint']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_licenses?: Maybe<Scalars['Int']['output']>;
  total_clients?: Maybe<Scalars['bigint']['output']>;
  total_members?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "vw_organization_summary" */
export type Vw_Organization_Summary_Aggregate = {
  __typename?: 'vw_organization_summary_aggregate';
  aggregate?: Maybe<Vw_Organization_Summary_Aggregate_Fields>;
  nodes: Array<Vw_Organization_Summary>;
};

/** aggregate fields of "vw_organization_summary" */
export type Vw_Organization_Summary_Aggregate_Fields = {
  __typename?: 'vw_organization_summary_aggregate_fields';
  avg?: Maybe<Vw_Organization_Summary_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Organization_Summary_Max_Fields>;
  min?: Maybe<Vw_Organization_Summary_Min_Fields>;
  stddev?: Maybe<Vw_Organization_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Organization_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Organization_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Organization_Summary_Sum_Fields>;
  var_pop?: Maybe<Vw_Organization_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Organization_Summary_Var_Samp_Fields>;
  variance?: Maybe<Vw_Organization_Summary_Variance_Fields>;
};


/** aggregate fields of "vw_organization_summary" */
export type Vw_Organization_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Organization_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Organization_Summary_Avg_Fields = {
  __typename?: 'vw_organization_summary_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_organization_summary". All fields are combined with a logical 'AND'. */
export type Vw_Organization_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Organization_Summary_Bool_Exp>>;
  _not?: InputMaybe<Vw_Organization_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Organization_Summary_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_month_avg_nudges_per_client?: InputMaybe<Bigint_Comparison_Exp>;
  last_month_avg_questionnaires_per_client?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_licenses?: InputMaybe<Int_Comparison_Exp>;
  total_clients?: InputMaybe<Bigint_Comparison_Exp>;
  total_members?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Organization_Summary_Max_Fields = {
  __typename?: 'vw_organization_summary_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['bigint']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_licenses?: Maybe<Scalars['Int']['output']>;
  total_clients?: Maybe<Scalars['bigint']['output']>;
  total_members?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Vw_Organization_Summary_Min_Fields = {
  __typename?: 'vw_organization_summary_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['bigint']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  num_licenses?: Maybe<Scalars['Int']['output']>;
  total_clients?: Maybe<Scalars['bigint']['output']>;
  total_members?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "vw_organization_summary". */
export type Vw_Organization_Summary_Order_By = {
  id?: InputMaybe<Order_By>;
  last_month_avg_nudges_per_client?: InputMaybe<Order_By>;
  last_month_avg_questionnaires_per_client?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_licenses?: InputMaybe<Order_By>;
  total_clients?: InputMaybe<Order_By>;
  total_members?: InputMaybe<Order_By>;
};

/** select columns of table "vw_organization_summary" */
export enum Vw_Organization_Summary_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LastMonthAvgNudgesPerClient = 'last_month_avg_nudges_per_client',
  /** column name */
  LastMonthAvgQuestionnairesPerClient = 'last_month_avg_questionnaires_per_client',
  /** column name */
  Name = 'name',
  /** column name */
  NumLicenses = 'num_licenses',
  /** column name */
  TotalClients = 'total_clients',
  /** column name */
  TotalMembers = 'total_members'
}

/** aggregate stddev on columns */
export type Vw_Organization_Summary_Stddev_Fields = {
  __typename?: 'vw_organization_summary_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Organization_Summary_Stddev_Pop_Fields = {
  __typename?: 'vw_organization_summary_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Organization_Summary_Stddev_Samp_Fields = {
  __typename?: 'vw_organization_summary_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_organization_summary" */
export type Vw_Organization_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Organization_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Organization_Summary_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  last_month_avg_nudges_per_client?: InputMaybe<Scalars['bigint']['input']>;
  last_month_avg_questionnaires_per_client?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  num_licenses?: InputMaybe<Scalars['Int']['input']>;
  total_clients?: InputMaybe<Scalars['bigint']['input']>;
  total_members?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vw_Organization_Summary_Sum_Fields = {
  __typename?: 'vw_organization_summary_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['bigint']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['bigint']['output']>;
  num_licenses?: Maybe<Scalars['Int']['output']>;
  total_clients?: Maybe<Scalars['bigint']['output']>;
  total_members?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Organization_Summary_Var_Pop_Fields = {
  __typename?: 'vw_organization_summary_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Organization_Summary_Var_Samp_Fields = {
  __typename?: 'vw_organization_summary_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Organization_Summary_Variance_Fields = {
  __typename?: 'vw_organization_summary_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  last_month_avg_nudges_per_client?: Maybe<Scalars['Float']['output']>;
  last_month_avg_questionnaires_per_client?: Maybe<Scalars['Float']['output']>;
  num_licenses?: Maybe<Scalars['Float']['output']>;
  total_clients?: Maybe<Scalars['Float']['output']>;
  total_members?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_practitioner_client_count" */
export type Vw_Practitioner_Client_Count = {
  __typename?: 'vw_practitioner_client_count';
  client_count?: Maybe<Scalars['bigint']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "vw_practitioner_client_count" */
export type Vw_Practitioner_Client_Count_Aggregate = {
  __typename?: 'vw_practitioner_client_count_aggregate';
  aggregate?: Maybe<Vw_Practitioner_Client_Count_Aggregate_Fields>;
  nodes: Array<Vw_Practitioner_Client_Count>;
};

/** aggregate fields of "vw_practitioner_client_count" */
export type Vw_Practitioner_Client_Count_Aggregate_Fields = {
  __typename?: 'vw_practitioner_client_count_aggregate_fields';
  avg?: Maybe<Vw_Practitioner_Client_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Practitioner_Client_Count_Max_Fields>;
  min?: Maybe<Vw_Practitioner_Client_Count_Min_Fields>;
  stddev?: Maybe<Vw_Practitioner_Client_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Practitioner_Client_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Practitioner_Client_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Practitioner_Client_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Practitioner_Client_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Practitioner_Client_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Practitioner_Client_Count_Variance_Fields>;
};


/** aggregate fields of "vw_practitioner_client_count" */
export type Vw_Practitioner_Client_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Practitioner_Client_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Practitioner_Client_Count_Avg_Fields = {
  __typename?: 'vw_practitioner_client_count_avg_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_practitioner_client_count". All fields are combined with a logical 'AND'. */
export type Vw_Practitioner_Client_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Practitioner_Client_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Practitioner_Client_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Practitioner_Client_Count_Bool_Exp>>;
  client_count?: InputMaybe<Bigint_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Practitioner_Client_Count_Max_Fields = {
  __typename?: 'vw_practitioner_client_count_max_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Vw_Practitioner_Client_Count_Min_Fields = {
  __typename?: 'vw_practitioner_client_count_min_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "vw_practitioner_client_count". */
export type Vw_Practitioner_Client_Count_Order_By = {
  client_count?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_practitioner_client_count" */
export enum Vw_Practitioner_Client_Count_Select_Column {
  /** column name */
  ClientCount = 'client_count',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id'
}

/** aggregate stddev on columns */
export type Vw_Practitioner_Client_Count_Stddev_Fields = {
  __typename?: 'vw_practitioner_client_count_stddev_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Practitioner_Client_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_practitioner_client_count_stddev_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Practitioner_Client_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_practitioner_client_count_stddev_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_practitioner_client_count" */
export type Vw_Practitioner_Client_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Practitioner_Client_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Practitioner_Client_Count_Stream_Cursor_Value_Input = {
  client_count?: InputMaybe<Scalars['bigint']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Vw_Practitioner_Client_Count_Sum_Fields = {
  __typename?: 'vw_practitioner_client_count_sum_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Practitioner_Client_Count_Var_Pop_Fields = {
  __typename?: 'vw_practitioner_client_count_var_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Practitioner_Client_Count_Var_Samp_Fields = {
  __typename?: 'vw_practitioner_client_count_var_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Practitioner_Client_Count_Variance_Fields = {
  __typename?: 'vw_practitioner_client_count_variance_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_practitioner_counts" */
export type Vw_Practitioner_Counts = {
  __typename?: 'vw_practitioner_counts';
  client_count?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  practitioner?: Maybe<Users>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "vw_practitioner_counts" */
export type Vw_Practitioner_Counts_Aggregate = {
  __typename?: 'vw_practitioner_counts_aggregate';
  aggregate?: Maybe<Vw_Practitioner_Counts_Aggregate_Fields>;
  nodes: Array<Vw_Practitioner_Counts>;
};

/** aggregate fields of "vw_practitioner_counts" */
export type Vw_Practitioner_Counts_Aggregate_Fields = {
  __typename?: 'vw_practitioner_counts_aggregate_fields';
  avg?: Maybe<Vw_Practitioner_Counts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Practitioner_Counts_Max_Fields>;
  min?: Maybe<Vw_Practitioner_Counts_Min_Fields>;
  stddev?: Maybe<Vw_Practitioner_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Practitioner_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Practitioner_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Practitioner_Counts_Sum_Fields>;
  var_pop?: Maybe<Vw_Practitioner_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Practitioner_Counts_Var_Samp_Fields>;
  variance?: Maybe<Vw_Practitioner_Counts_Variance_Fields>;
};


/** aggregate fields of "vw_practitioner_counts" */
export type Vw_Practitioner_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Practitioner_Counts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Practitioner_Counts_Avg_Fields = {
  __typename?: 'vw_practitioner_counts_avg_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_practitioner_counts". All fields are combined with a logical 'AND'. */
export type Vw_Practitioner_Counts_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Practitioner_Counts_Bool_Exp>>;
  _not?: InputMaybe<Vw_Practitioner_Counts_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Practitioner_Counts_Bool_Exp>>;
  client_count?: InputMaybe<Bigint_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  nudge_count?: InputMaybe<Bigint_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  practitioner?: InputMaybe<Users_Bool_Exp>;
  questionnaire_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Practitioner_Counts_Max_Fields = {
  __typename?: 'vw_practitioner_counts_max_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Vw_Practitioner_Counts_Min_Fields = {
  __typename?: 'vw_practitioner_counts_min_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "vw_practitioner_counts". */
export type Vw_Practitioner_Counts_Order_By = {
  client_count?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  nudge_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner?: InputMaybe<Users_Order_By>;
  questionnaire_count?: InputMaybe<Order_By>;
};

/** select columns of table "vw_practitioner_counts" */
export enum Vw_Practitioner_Counts_Select_Column {
  /** column name */
  ClientCount = 'client_count',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NudgeCount = 'nudge_count',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  QuestionnaireCount = 'questionnaire_count'
}

/** aggregate stddev on columns */
export type Vw_Practitioner_Counts_Stddev_Fields = {
  __typename?: 'vw_practitioner_counts_stddev_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Practitioner_Counts_Stddev_Pop_Fields = {
  __typename?: 'vw_practitioner_counts_stddev_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Practitioner_Counts_Stddev_Samp_Fields = {
  __typename?: 'vw_practitioner_counts_stddev_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_practitioner_counts" */
export type Vw_Practitioner_Counts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Practitioner_Counts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Practitioner_Counts_Stream_Cursor_Value_Input = {
  client_count?: InputMaybe<Scalars['bigint']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nudge_count?: InputMaybe<Scalars['bigint']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vw_Practitioner_Counts_Sum_Fields = {
  __typename?: 'vw_practitioner_counts_sum_fields';
  client_count?: Maybe<Scalars['bigint']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Practitioner_Counts_Var_Pop_Fields = {
  __typename?: 'vw_practitioner_counts_var_pop_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Practitioner_Counts_Var_Samp_Fields = {
  __typename?: 'vw_practitioner_counts_var_samp_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Practitioner_Counts_Variance_Fields = {
  __typename?: 'vw_practitioner_counts_variance_fields';
  client_count?: Maybe<Scalars['Float']['output']>;
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_practitioner_nudge_count" */
export type Vw_Practitioner_Nudge_Count = {
  __typename?: 'vw_practitioner_nudge_count';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "vw_practitioner_nudge_count" */
export type Vw_Practitioner_Nudge_Count_Aggregate = {
  __typename?: 'vw_practitioner_nudge_count_aggregate';
  aggregate?: Maybe<Vw_Practitioner_Nudge_Count_Aggregate_Fields>;
  nodes: Array<Vw_Practitioner_Nudge_Count>;
};

/** aggregate fields of "vw_practitioner_nudge_count" */
export type Vw_Practitioner_Nudge_Count_Aggregate_Fields = {
  __typename?: 'vw_practitioner_nudge_count_aggregate_fields';
  avg?: Maybe<Vw_Practitioner_Nudge_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Practitioner_Nudge_Count_Max_Fields>;
  min?: Maybe<Vw_Practitioner_Nudge_Count_Min_Fields>;
  stddev?: Maybe<Vw_Practitioner_Nudge_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Practitioner_Nudge_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Practitioner_Nudge_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Practitioner_Nudge_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Practitioner_Nudge_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Practitioner_Nudge_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Practitioner_Nudge_Count_Variance_Fields>;
};


/** aggregate fields of "vw_practitioner_nudge_count" */
export type Vw_Practitioner_Nudge_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Practitioner_Nudge_Count_Avg_Fields = {
  __typename?: 'vw_practitioner_nudge_count_avg_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_practitioner_nudge_count". All fields are combined with a logical 'AND'. */
export type Vw_Practitioner_Nudge_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Practitioner_Nudge_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Practitioner_Nudge_Count_Bool_Exp>>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  nudge_count?: InputMaybe<Bigint_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Practitioner_Nudge_Count_Max_Fields = {
  __typename?: 'vw_practitioner_nudge_count_max_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Vw_Practitioner_Nudge_Count_Min_Fields = {
  __typename?: 'vw_practitioner_nudge_count_min_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "vw_practitioner_nudge_count". */
export type Vw_Practitioner_Nudge_Count_Order_By = {
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  nudge_count?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_practitioner_nudge_count" */
export enum Vw_Practitioner_Nudge_Count_Select_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NudgeCount = 'nudge_count',
  /** column name */
  OrganizationId = 'organization_id'
}

/** aggregate stddev on columns */
export type Vw_Practitioner_Nudge_Count_Stddev_Fields = {
  __typename?: 'vw_practitioner_nudge_count_stddev_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Practitioner_Nudge_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_practitioner_nudge_count_stddev_pop_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Practitioner_Nudge_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_practitioner_nudge_count_stddev_samp_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_practitioner_nudge_count" */
export type Vw_Practitioner_Nudge_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Practitioner_Nudge_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Practitioner_Nudge_Count_Stream_Cursor_Value_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nudge_count?: InputMaybe<Scalars['bigint']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Vw_Practitioner_Nudge_Count_Sum_Fields = {
  __typename?: 'vw_practitioner_nudge_count_sum_fields';
  nudge_count?: Maybe<Scalars['bigint']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Practitioner_Nudge_Count_Var_Pop_Fields = {
  __typename?: 'vw_practitioner_nudge_count_var_pop_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Practitioner_Nudge_Count_Var_Samp_Fields = {
  __typename?: 'vw_practitioner_nudge_count_var_samp_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Practitioner_Nudge_Count_Variance_Fields = {
  __typename?: 'vw_practitioner_nudge_count_variance_fields';
  nudge_count?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_practitioner_questionnaire_count" */
export type Vw_Practitioner_Questionnaire_Count = {
  __typename?: 'vw_practitioner_questionnaire_count';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "vw_practitioner_questionnaire_count" */
export type Vw_Practitioner_Questionnaire_Count_Aggregate = {
  __typename?: 'vw_practitioner_questionnaire_count_aggregate';
  aggregate?: Maybe<Vw_Practitioner_Questionnaire_Count_Aggregate_Fields>;
  nodes: Array<Vw_Practitioner_Questionnaire_Count>;
};

/** aggregate fields of "vw_practitioner_questionnaire_count" */
export type Vw_Practitioner_Questionnaire_Count_Aggregate_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_aggregate_fields';
  avg?: Maybe<Vw_Practitioner_Questionnaire_Count_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Practitioner_Questionnaire_Count_Max_Fields>;
  min?: Maybe<Vw_Practitioner_Questionnaire_Count_Min_Fields>;
  stddev?: Maybe<Vw_Practitioner_Questionnaire_Count_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Practitioner_Questionnaire_Count_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Practitioner_Questionnaire_Count_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Practitioner_Questionnaire_Count_Sum_Fields>;
  var_pop?: Maybe<Vw_Practitioner_Questionnaire_Count_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Practitioner_Questionnaire_Count_Var_Samp_Fields>;
  variance?: Maybe<Vw_Practitioner_Questionnaire_Count_Variance_Fields>;
};


/** aggregate fields of "vw_practitioner_questionnaire_count" */
export type Vw_Practitioner_Questionnaire_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Practitioner_Questionnaire_Count_Avg_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_avg_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_practitioner_questionnaire_count". All fields are combined with a logical 'AND'. */
export type Vw_Practitioner_Questionnaire_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Bool_Exp>>;
  _not?: InputMaybe<Vw_Practitioner_Questionnaire_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Practitioner_Questionnaire_Count_Bool_Exp>>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Vw_Practitioner_Questionnaire_Count_Max_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_max_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Vw_Practitioner_Questionnaire_Count_Min_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_min_fields';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "vw_practitioner_questionnaire_count". */
export type Vw_Practitioner_Questionnaire_Count_Order_By = {
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  questionnaire_count?: InputMaybe<Order_By>;
};

/** select columns of table "vw_practitioner_questionnaire_count" */
export enum Vw_Practitioner_Questionnaire_Count_Select_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  QuestionnaireCount = 'questionnaire_count'
}

/** aggregate stddev on columns */
export type Vw_Practitioner_Questionnaire_Count_Stddev_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_stddev_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Practitioner_Questionnaire_Count_Stddev_Pop_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_stddev_pop_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Practitioner_Questionnaire_Count_Stddev_Samp_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_stddev_samp_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_practitioner_questionnaire_count" */
export type Vw_Practitioner_Questionnaire_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Practitioner_Questionnaire_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Practitioner_Questionnaire_Count_Stream_Cursor_Value_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Vw_Practitioner_Questionnaire_Count_Sum_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_sum_fields';
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Practitioner_Questionnaire_Count_Var_Pop_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_var_pop_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Practitioner_Questionnaire_Count_Var_Samp_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_var_samp_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Practitioner_Questionnaire_Count_Variance_Fields = {
  __typename?: 'vw_practitioner_questionnaire_count_variance_fields';
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values = {
  __typename?: 'vw_questionnaire_display_values';
  casemix_category?: Maybe<Scalars['String']['output']>;
  casemix_display_color?: Maybe<Scalars['String']['output']>;
  casemix_display_order?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  questionnaireTake?: Maybe<Questionnaire_Takes>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  scheduledByOrg?: Maybe<Organizations>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Aggregate = {
  __typename?: 'vw_questionnaire_display_values_aggregate';
  aggregate?: Maybe<Vw_Questionnaire_Display_Values_Aggregate_Fields>;
  nodes: Array<Vw_Questionnaire_Display_Values>;
};

/** aggregate fields of "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Aggregate_Fields = {
  __typename?: 'vw_questionnaire_display_values_aggregate_fields';
  avg?: Maybe<Vw_Questionnaire_Display_Values_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_Questionnaire_Display_Values_Max_Fields>;
  min?: Maybe<Vw_Questionnaire_Display_Values_Min_Fields>;
  stddev?: Maybe<Vw_Questionnaire_Display_Values_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_Questionnaire_Display_Values_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_Questionnaire_Display_Values_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_Questionnaire_Display_Values_Sum_Fields>;
  var_pop?: Maybe<Vw_Questionnaire_Display_Values_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_Questionnaire_Display_Values_Var_Samp_Fields>;
  variance?: Maybe<Vw_Questionnaire_Display_Values_Variance_Fields>;
};


/** aggregate fields of "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_Questionnaire_Display_Values_Avg_Fields = {
  __typename?: 'vw_questionnaire_display_values_avg_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_questionnaire_display_values". All fields are combined with a logical 'AND'. */
export type Vw_Questionnaire_Display_Values_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Bool_Exp>>;
  _not?: InputMaybe<Vw_Questionnaire_Display_Values_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Questionnaire_Display_Values_Bool_Exp>>;
  casemix_category?: InputMaybe<String_Comparison_Exp>;
  casemix_display_color?: InputMaybe<String_Comparison_Exp>;
  casemix_display_order?: InputMaybe<Int_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_score?: InputMaybe<Float8_Comparison_Exp>;
  display_score_type?: InputMaybe<String_Comparison_Exp>;
  lower_bound?: InputMaybe<Int_Comparison_Exp>;
  organization_id?: InputMaybe<Int_Comparison_Exp>;
  practitioner_id?: InputMaybe<Uuid_Comparison_Exp>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Bool_Exp>;
  questionnaire_id?: InputMaybe<Int_Comparison_Exp>;
  questionnaire_name?: InputMaybe<String_Comparison_Exp>;
  questionnaire_take_id?: InputMaybe<Int_Comparison_Exp>;
  scheduledByOrg?: InputMaybe<Organizations_Bool_Exp>;
  scoring_display_color?: InputMaybe<String_Comparison_Exp>;
  scoring_display_name?: InputMaybe<String_Comparison_Exp>;
  upper_bound?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Insert_Input = {
  casemix_category?: InputMaybe<Scalars['String']['input']>;
  casemix_display_color?: InputMaybe<Scalars['String']['input']>;
  casemix_display_order?: InputMaybe<Scalars['Int']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Obj_Rel_Insert_Input>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_name?: InputMaybe<Scalars['String']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  scheduledByOrg?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  scoring_display_color?: InputMaybe<Scalars['String']['input']>;
  scoring_display_name?: InputMaybe<Scalars['String']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Vw_Questionnaire_Display_Values_Max_Fields = {
  __typename?: 'vw_questionnaire_display_values_max_fields';
  casemix_category?: Maybe<Scalars['String']['output']>;
  casemix_display_color?: Maybe<Scalars['String']['output']>;
  casemix_display_order?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Vw_Questionnaire_Display_Values_Min_Fields = {
  __typename?: 'vw_questionnaire_display_values_min_fields';
  casemix_category?: Maybe<Scalars['String']['output']>;
  casemix_display_color?: Maybe<Scalars['String']['output']>;
  casemix_display_order?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  display_score_type?: Maybe<Scalars['String']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practitioner_id?: Maybe<Scalars['uuid']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_name?: Maybe<Scalars['String']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  scoring_display_color?: Maybe<Scalars['String']['output']>;
  scoring_display_name?: Maybe<Scalars['String']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Obj_Rel_Insert_Input = {
  data: Vw_Questionnaire_Display_Values_Insert_Input;
};

/** Ordering options when selecting data from "vw_questionnaire_display_values". */
export type Vw_Questionnaire_Display_Values_Order_By = {
  casemix_category?: InputMaybe<Order_By>;
  casemix_display_color?: InputMaybe<Order_By>;
  casemix_display_order?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  display_score?: InputMaybe<Order_By>;
  display_score_type?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  practitioner_id?: InputMaybe<Order_By>;
  questionnaireTake?: InputMaybe<Questionnaire_Takes_Order_By>;
  questionnaire_id?: InputMaybe<Order_By>;
  questionnaire_name?: InputMaybe<Order_By>;
  questionnaire_take_id?: InputMaybe<Order_By>;
  scheduledByOrg?: InputMaybe<Organizations_Order_By>;
  scoring_display_color?: InputMaybe<Order_By>;
  scoring_display_name?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "vw_questionnaire_display_values" */
export enum Vw_Questionnaire_Display_Values_Select_Column {
  /** column name */
  CasemixCategory = 'casemix_category',
  /** column name */
  CasemixDisplayColor = 'casemix_display_color',
  /** column name */
  CasemixDisplayOrder = 'casemix_display_order',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  DisplayScore = 'display_score',
  /** column name */
  DisplayScoreType = 'display_score_type',
  /** column name */
  LowerBound = 'lower_bound',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PractitionerId = 'practitioner_id',
  /** column name */
  QuestionnaireId = 'questionnaire_id',
  /** column name */
  QuestionnaireName = 'questionnaire_name',
  /** column name */
  QuestionnaireTakeId = 'questionnaire_take_id',
  /** column name */
  ScoringDisplayColor = 'scoring_display_color',
  /** column name */
  ScoringDisplayName = 'scoring_display_name',
  /** column name */
  UpperBound = 'upper_bound',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Vw_Questionnaire_Display_Values_Stddev_Fields = {
  __typename?: 'vw_questionnaire_display_values_stddev_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_Questionnaire_Display_Values_Stddev_Pop_Fields = {
  __typename?: 'vw_questionnaire_display_values_stddev_pop_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_Questionnaire_Display_Values_Stddev_Samp_Fields = {
  __typename?: 'vw_questionnaire_display_values_stddev_samp_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_questionnaire_display_values" */
export type Vw_Questionnaire_Display_Values_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Questionnaire_Display_Values_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Questionnaire_Display_Values_Stream_Cursor_Value_Input = {
  casemix_category?: InputMaybe<Scalars['String']['input']>;
  casemix_display_color?: InputMaybe<Scalars['String']['input']>;
  casemix_display_order?: InputMaybe<Scalars['Int']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_score?: InputMaybe<Scalars['float8']['input']>;
  display_score_type?: InputMaybe<Scalars['String']['input']>;
  lower_bound?: InputMaybe<Scalars['Int']['input']>;
  organization_id?: InputMaybe<Scalars['Int']['input']>;
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_name?: InputMaybe<Scalars['String']['input']>;
  questionnaire_take_id?: InputMaybe<Scalars['Int']['input']>;
  scoring_display_color?: InputMaybe<Scalars['String']['input']>;
  scoring_display_name?: InputMaybe<Scalars['String']['input']>;
  upper_bound?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vw_Questionnaire_Display_Values_Sum_Fields = {
  __typename?: 'vw_questionnaire_display_values_sum_fields';
  casemix_display_order?: Maybe<Scalars['Int']['output']>;
  display_score?: Maybe<Scalars['float8']['output']>;
  lower_bound?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_id?: Maybe<Scalars['Int']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Int']['output']>;
  upper_bound?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_Questionnaire_Display_Values_Var_Pop_Fields = {
  __typename?: 'vw_questionnaire_display_values_var_pop_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_Questionnaire_Display_Values_Var_Samp_Fields = {
  __typename?: 'vw_questionnaire_display_values_var_samp_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_Questionnaire_Display_Values_Variance_Fields = {
  __typename?: 'vw_questionnaire_display_values_variance_fields';
  casemix_display_order?: Maybe<Scalars['Float']['output']>;
  display_score?: Maybe<Scalars['Float']['output']>;
  lower_bound?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_id?: Maybe<Scalars['Float']['output']>;
  questionnaire_take_id?: Maybe<Scalars['Float']['output']>;
  upper_bound?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "vw_user_organization" */
export type Vw_User_Organization = {
  __typename?: 'vw_user_organization';
  /** An object relationship */
  org?: Maybe<Organizations>;
  org_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  users?: Maybe<Users>;
};

/** aggregated selection of "vw_user_organization" */
export type Vw_User_Organization_Aggregate = {
  __typename?: 'vw_user_organization_aggregate';
  aggregate?: Maybe<Vw_User_Organization_Aggregate_Fields>;
  nodes: Array<Vw_User_Organization>;
};

export type Vw_User_Organization_Aggregate_Bool_Exp = {
  count?: InputMaybe<Vw_User_Organization_Aggregate_Bool_Exp_Count>;
};

export type Vw_User_Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vw_user_organization" */
export type Vw_User_Organization_Aggregate_Fields = {
  __typename?: 'vw_user_organization_aggregate_fields';
  avg?: Maybe<Vw_User_Organization_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_User_Organization_Max_Fields>;
  min?: Maybe<Vw_User_Organization_Min_Fields>;
  stddev?: Maybe<Vw_User_Organization_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_User_Organization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_User_Organization_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_User_Organization_Sum_Fields>;
  var_pop?: Maybe<Vw_User_Organization_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_User_Organization_Var_Samp_Fields>;
  variance?: Maybe<Vw_User_Organization_Variance_Fields>;
};


/** aggregate fields of "vw_user_organization" */
export type Vw_User_Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_User_Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "vw_user_organization" */
export type Vw_User_Organization_Aggregate_Order_By = {
  avg?: InputMaybe<Vw_User_Organization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vw_User_Organization_Max_Order_By>;
  min?: InputMaybe<Vw_User_Organization_Min_Order_By>;
  stddev?: InputMaybe<Vw_User_Organization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vw_User_Organization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vw_User_Organization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vw_User_Organization_Sum_Order_By>;
  var_pop?: InputMaybe<Vw_User_Organization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vw_User_Organization_Var_Samp_Order_By>;
  variance?: InputMaybe<Vw_User_Organization_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vw_user_organization" */
export type Vw_User_Organization_Arr_Rel_Insert_Input = {
  data: Array<Vw_User_Organization_Insert_Input>;
};

/** aggregate avg on columns */
export type Vw_User_Organization_Avg_Fields = {
  __typename?: 'vw_user_organization_avg_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Avg_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_user_organization". All fields are combined with a logical 'AND'. */
export type Vw_User_Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_User_Organization_Bool_Exp>>;
  _not?: InputMaybe<Vw_User_Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_User_Organization_Bool_Exp>>;
  org?: InputMaybe<Organizations_Bool_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** input type for inserting data into table "vw_user_organization" */
export type Vw_User_Organization_Insert_Input = {
  org?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  users?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Vw_User_Organization_Max_Fields = {
  __typename?: 'vw_user_organization_max_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Max_Order_By = {
  org_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vw_User_Organization_Min_Fields = {
  __typename?: 'vw_user_organization_min_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Min_Order_By = {
  org_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "vw_user_organization". */
export type Vw_User_Organization_Order_By = {
  org?: InputMaybe<Organizations_Order_By>;
  org_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** select columns of table "vw_user_organization" */
export enum Vw_User_Organization_Select_Column {
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Vw_User_Organization_Stddev_Fields = {
  __typename?: 'vw_user_organization_stddev_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Stddev_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vw_User_Organization_Stddev_Pop_Fields = {
  __typename?: 'vw_user_organization_stddev_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Stddev_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vw_User_Organization_Stddev_Samp_Fields = {
  __typename?: 'vw_user_organization_stddev_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Stddev_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vw_user_organization" */
export type Vw_User_Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_User_Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_User_Organization_Stream_Cursor_Value_Input = {
  org_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vw_User_Organization_Sum_Fields = {
  __typename?: 'vw_user_organization_sum_fields';
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Sum_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Vw_User_Organization_Var_Pop_Fields = {
  __typename?: 'vw_user_organization_var_pop_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Var_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vw_User_Organization_Var_Samp_Fields = {
  __typename?: 'vw_user_organization_var_samp_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Var_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vw_User_Organization_Variance_Fields = {
  __typename?: 'vw_user_organization_variance_fields';
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "vw_user_organization" */
export type Vw_User_Organization_Variance_Order_By = {
  org_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "vw_user_virasafe_metrics" */
export type Vw_User_Virasafe_Metrics = {
  __typename?: 'vw_user_virasafe_metrics';
  least_distressed_activity_1?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_2?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_3?: Maybe<Scalars['String']['output']>;
  n_day_streak?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['numeric']['output']>;
  top_engaged_activity_1?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_2?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_3?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_4?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  users?: Maybe<Users>;
};

/** aggregated selection of "vw_user_virasafe_metrics" */
export type Vw_User_Virasafe_Metrics_Aggregate = {
  __typename?: 'vw_user_virasafe_metrics_aggregate';
  aggregate?: Maybe<Vw_User_Virasafe_Metrics_Aggregate_Fields>;
  nodes: Array<Vw_User_Virasafe_Metrics>;
};

/** aggregate fields of "vw_user_virasafe_metrics" */
export type Vw_User_Virasafe_Metrics_Aggregate_Fields = {
  __typename?: 'vw_user_virasafe_metrics_aggregate_fields';
  avg?: Maybe<Vw_User_Virasafe_Metrics_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Vw_User_Virasafe_Metrics_Max_Fields>;
  min?: Maybe<Vw_User_Virasafe_Metrics_Min_Fields>;
  stddev?: Maybe<Vw_User_Virasafe_Metrics_Stddev_Fields>;
  stddev_pop?: Maybe<Vw_User_Virasafe_Metrics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vw_User_Virasafe_Metrics_Stddev_Samp_Fields>;
  sum?: Maybe<Vw_User_Virasafe_Metrics_Sum_Fields>;
  var_pop?: Maybe<Vw_User_Virasafe_Metrics_Var_Pop_Fields>;
  var_samp?: Maybe<Vw_User_Virasafe_Metrics_Var_Samp_Fields>;
  variance?: Maybe<Vw_User_Virasafe_Metrics_Variance_Fields>;
};


/** aggregate fields of "vw_user_virasafe_metrics" */
export type Vw_User_Virasafe_Metrics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Vw_User_Virasafe_Metrics_Avg_Fields = {
  __typename?: 'vw_user_virasafe_metrics_avg_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "vw_user_virasafe_metrics". All fields are combined with a logical 'AND'. */
export type Vw_User_Virasafe_Metrics_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Bool_Exp>>;
  _not?: InputMaybe<Vw_User_Virasafe_Metrics_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_User_Virasafe_Metrics_Bool_Exp>>;
  least_distressed_activity_1?: InputMaybe<String_Comparison_Exp>;
  least_distressed_activity_2?: InputMaybe<String_Comparison_Exp>;
  least_distressed_activity_3?: InputMaybe<String_Comparison_Exp>;
  n_day_streak?: InputMaybe<Numeric_Comparison_Exp>;
  n_weekly_keep_me_calm?: InputMaybe<Numeric_Comparison_Exp>;
  n_weekly_keep_me_safe?: InputMaybe<Numeric_Comparison_Exp>;
  top_engaged_activity_1?: InputMaybe<String_Comparison_Exp>;
  top_engaged_activity_2?: InputMaybe<String_Comparison_Exp>;
  top_engaged_activity_3?: InputMaybe<String_Comparison_Exp>;
  top_engaged_activity_4?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** aggregate max on columns */
export type Vw_User_Virasafe_Metrics_Max_Fields = {
  __typename?: 'vw_user_virasafe_metrics_max_fields';
  least_distressed_activity_1?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_2?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_3?: Maybe<Scalars['String']['output']>;
  n_day_streak?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['numeric']['output']>;
  top_engaged_activity_1?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_2?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_3?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_4?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Vw_User_Virasafe_Metrics_Min_Fields = {
  __typename?: 'vw_user_virasafe_metrics_min_fields';
  least_distressed_activity_1?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_2?: Maybe<Scalars['String']['output']>;
  least_distressed_activity_3?: Maybe<Scalars['String']['output']>;
  n_day_streak?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['numeric']['output']>;
  top_engaged_activity_1?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_2?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_3?: Maybe<Scalars['String']['output']>;
  top_engaged_activity_4?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "vw_user_virasafe_metrics". */
export type Vw_User_Virasafe_Metrics_Order_By = {
  least_distressed_activity_1?: InputMaybe<Order_By>;
  least_distressed_activity_2?: InputMaybe<Order_By>;
  least_distressed_activity_3?: InputMaybe<Order_By>;
  n_day_streak?: InputMaybe<Order_By>;
  n_weekly_keep_me_calm?: InputMaybe<Order_By>;
  n_weekly_keep_me_safe?: InputMaybe<Order_By>;
  top_engaged_activity_1?: InputMaybe<Order_By>;
  top_engaged_activity_2?: InputMaybe<Order_By>;
  top_engaged_activity_3?: InputMaybe<Order_By>;
  top_engaged_activity_4?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** select columns of table "vw_user_virasafe_metrics" */
export enum Vw_User_Virasafe_Metrics_Select_Column {
  /** column name */
  LeastDistressedActivity_1 = 'least_distressed_activity_1',
  /** column name */
  LeastDistressedActivity_2 = 'least_distressed_activity_2',
  /** column name */
  LeastDistressedActivity_3 = 'least_distressed_activity_3',
  /** column name */
  NDayStreak = 'n_day_streak',
  /** column name */
  NWeeklyKeepMeCalm = 'n_weekly_keep_me_calm',
  /** column name */
  NWeeklyKeepMeSafe = 'n_weekly_keep_me_safe',
  /** column name */
  TopEngagedActivity_1 = 'top_engaged_activity_1',
  /** column name */
  TopEngagedActivity_2 = 'top_engaged_activity_2',
  /** column name */
  TopEngagedActivity_3 = 'top_engaged_activity_3',
  /** column name */
  TopEngagedActivity_4 = 'top_engaged_activity_4',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Vw_User_Virasafe_Metrics_Stddev_Fields = {
  __typename?: 'vw_user_virasafe_metrics_stddev_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Vw_User_Virasafe_Metrics_Stddev_Pop_Fields = {
  __typename?: 'vw_user_virasafe_metrics_stddev_pop_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Vw_User_Virasafe_Metrics_Stddev_Samp_Fields = {
  __typename?: 'vw_user_virasafe_metrics_stddev_samp_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "vw_user_virasafe_metrics" */
export type Vw_User_Virasafe_Metrics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_User_Virasafe_Metrics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_User_Virasafe_Metrics_Stream_Cursor_Value_Input = {
  least_distressed_activity_1?: InputMaybe<Scalars['String']['input']>;
  least_distressed_activity_2?: InputMaybe<Scalars['String']['input']>;
  least_distressed_activity_3?: InputMaybe<Scalars['String']['input']>;
  n_day_streak?: InputMaybe<Scalars['numeric']['input']>;
  n_weekly_keep_me_calm?: InputMaybe<Scalars['numeric']['input']>;
  n_weekly_keep_me_safe?: InputMaybe<Scalars['numeric']['input']>;
  top_engaged_activity_1?: InputMaybe<Scalars['String']['input']>;
  top_engaged_activity_2?: InputMaybe<Scalars['String']['input']>;
  top_engaged_activity_3?: InputMaybe<Scalars['String']['input']>;
  top_engaged_activity_4?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Vw_User_Virasafe_Metrics_Sum_Fields = {
  __typename?: 'vw_user_virasafe_metrics_sum_fields';
  n_day_streak?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['numeric']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Vw_User_Virasafe_Metrics_Var_Pop_Fields = {
  __typename?: 'vw_user_virasafe_metrics_var_pop_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Vw_User_Virasafe_Metrics_Var_Samp_Fields = {
  __typename?: 'vw_user_virasafe_metrics_var_samp_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Vw_User_Virasafe_Metrics_Variance_Fields = {
  __typename?: 'vw_user_virasafe_metrics_variance_fields';
  n_day_streak?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_calm?: Maybe<Scalars['Float']['output']>;
  n_weekly_keep_me_safe?: Maybe<Scalars['Float']['output']>;
};

export type PractitionerCountsFragment = { __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, last_name?: string | null, first_name?: string | null, email?: string | null, account?: { __typename?: 'auth_accounts', user: { __typename?: 'users', organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, users_role_capabilities: Array<{ __typename?: 'role_capabilities', role?: string | null }> } } | null, client_count: { __typename?: 'invite_codes_aggregate', aggregate?: { __typename?: 'invite_codes_aggregate_fields', count: number } | null }, nudge_count: { __typename?: 'nudge_schedules_aggregate', aggregate?: { __typename?: 'nudge_schedules_aggregate_fields', count: number } | null }, questionnaire_count: { __typename?: 'questionnaire_schedules_aggregate', aggregate?: { __typename?: 'questionnaire_schedules_aggregate_fields', count: number } | null }, totalActiveClients: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any } }> } };

export type UserFeatureReportFieldsFragment = { __typename?: 'feature_reports', id: number, outcome: Enum_Outcome_Enum, created_on: any, displayable_on: any, feature_report_features: Array<{ __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any }> };

export type UserFeatureReportFeaturesFieldsFragment = { __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any };

export type InviteCodeFragment = { __typename?: 'invite_codes', code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } };

export type DailyFeaturesSleepFragment = { __typename?: 'vw_daily_features_sleep', val_bedtime_offset_hour?: any | null, val_waketime_offset_hour?: any | null, feature_date?: any | null };

export type DailyFeaturesTrendFragment = { __typename?: 'vw_daily_features_trend', key?: string | null, avg_this_week?: any | null, direction?: string | null };

export type ClientFragment = { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, phone_number?: string | null, most_recent_timezone?: string | null, display_name?: string | null, client_demographics: Array<{ __typename?: 'client_demographics', id: any, user_id: any, practitioner_id: any, created_at: any, first_name?: string | null, last_name?: string | null, birth_year?: number | null, gender?: Enum_Gender_Enum | null, racial_ethnic?: Enum_Racial_Ethnic_Enum | null, description?: string | null }>, mood_measurements: Array<{ __typename?: 'mood_measurements', id: number, enjoyment: number, growth?: number | null, cravings?: number | null, created_on: any, client_created_on?: string | null }>, growth_reports: Array<{ __typename?: 'feature_reports', id: number, outcome: Enum_Outcome_Enum, created_on: any, displayable_on: any, feature_report_features: Array<{ __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any }> }>, enjoy_reports: Array<{ __typename?: 'feature_reports', id: number, outcome: Enum_Outcome_Enum, created_on: any, displayable_on: any, feature_report_features: Array<{ __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any }> }>, daily_features: Array<{ __typename?: 'daily_features', key: Enum_Feature_Type_Enum, value: any, direction: Enum_Trend_Direction_Enum, feature_date: any }>, activity_rating: Array<{ __typename?: 'activity_rating', id: any, client_created_at: any, transaction_id?: any | null, value: number, user_id: any, activity_id: any, activity_selected: { __typename?: 'activity', id: any, display_name: string } }>, vw_daily_features_sleep: Array<{ __typename?: 'vw_daily_features_sleep', val_bedtime_offset_hour?: any | null, val_waketime_offset_hour?: any | null, feature_date?: any | null }>, vw_daily_features_trend: Array<{ __typename?: 'vw_daily_features_trend', key?: string | null, avg_this_week?: any | null, direction?: string | null }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }>, users_user_feature_flags?: { __typename?: 'user_feature_flag', user_id: any, dbt_diary_enabled: boolean, jitai_features_enabled: boolean, vira_path_enabled: boolean } | null };

export type NudgeScheduleFragment = { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> };

export type NudgeTakeFragment = { __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } };

export type NudgeFragment = { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null };

export type QuestionnaireScheduleFragment = { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> };

export type QuestionnaireItemFragment = { __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> };

export type QuestionnaireFragment = { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> };

export type QuestionnaireResponseOptionFragment = { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any };

export type QuestionnaireResponseFragment = { __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null };

export type QuestionnaireTakeFragment = { __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> };

export type OrganizationMemberFragment = { __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, display_name?: string | null, account?: { __typename?: 'auth_accounts', default_role: string } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, practitioner_invite_codes: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } }> } };

export type OrganizationMemberClientFragment = { __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } };

export type UserInviteFragment = { __typename?: 'user_invites', id: number, first_name: string, last_name: string, email: string, role: string };

export type OrganizationFragment = { __typename?: 'organizations', id: number, name?: string | null, location?: string | null, user_invites: Array<{ __typename?: 'user_invites', id: number, first_name: string, last_name: string, email: string, role: string }>, organization_members: Array<{ __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, display_name?: string | null, account?: { __typename?: 'auth_accounts', default_role: string } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, practitioner_invite_codes: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } }> } }> };

export type PractitionerFragment = { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, display_name?: string | null, account?: { __typename?: 'auth_accounts', default_role: string } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, practitioner_invite_codes: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } }> };

export type MobileDeviceDataFragment = { __typename?: 'mobile_device_data', device_make: string, device_model: string, os_version: string, app_version?: string | null };

export type MobileUserFragment = { __typename?: 'users', id: any, display_name?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, is_onboarded: boolean, notification_time?: any | null, phone_number?: string | null, most_recent_timezone?: string | null, has_derived_data: boolean, created_at: any, clientToOrganizations: Array<{ __typename?: 'vw_user_organization', user_id?: any | null, org_id?: number | null }>, account?: { __typename?: 'auth_accounts', account_providers: Array<{ __typename?: 'auth_account_providers', id: any }> } | null, client_invite_codes: Array<{ __typename?: 'invite_codes', code: string, practitioner_id?: any | null, expiration_code?: any | null }>, practitioners: Array<{ __typename?: 'invite_codes', code: string, status?: string | null, practitioner?: { __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null } | null }>, mobile_device_data: Array<{ __typename?: 'mobile_device_data', device_make: string, device_model: string, os_version: string, app_version?: string | null }> };

export type ResourcesFragment = { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any };

export type NudgeScheduleQueryFragment = { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', resource_id?: number | null, activity_id?: any | null, default_messaging: string }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', scheduled_at: any }> };

export type QuestionnaireScheduleQueryFragment = { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, notify_connected_practitioners?: any | null, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', scheduled_at: any }> };

export type ClientDemographicsFragment = { __typename?: 'client_demographics', id: any, user_id: any, practitioner_id: any, created_at: any, first_name?: string | null, last_name?: string | null, birth_year?: number | null, gender?: Enum_Gender_Enum | null, racial_ethnic?: Enum_Racial_Ethnic_Enum | null, description?: string | null };

export type SafetyPlanSectionCategoryFragment = { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null };

export type SafetyPlanResponseOptionsFragment = { __typename?: 'safety_plan_response_options', display_order: number, id: any, response_text?: string | null, category_id: any, checklist_item_id?: any | null, safety_plan_section_id: any, safety_plan_response_options_safety_plan_section_category: { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null } };

export type SafetyPlanSectionsFragment = { __typename?: 'safety_plan_sections', description?: string | null, display_order: number, header: string, help_text?: string | null, id: any, icon?: Enum_Safety_Plan_Section_Icons_Enum | null, icon_color?: string | null, header_image_path?: string | null, subtitle?: string | null, show_support_card: boolean, safety_plan_sections_safety_plan_response_options: Array<{ __typename?: 'safety_plan_response_options', display_order: number, id: any, response_text?: string | null, category_id: any, checklist_item_id?: any | null, safety_plan_section_id: any, safety_plan_response_options_safety_plan_section_category: { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null } }>, safety_plan_sections_safety_plan_checklist_items: Array<{ __typename?: 'safety_plan_checklist_items', id: any, category_id: any, section_id: any, title: string, description?: string | null, subtitle?: string | null, display_order: number }> };

export type MobilePermissionsFragment = { __typename?: 'mobile_permissions', user_id: any, permission_type: Enum_Mobile_Permission_Type_Enum, permission_status: Enum_Mobile_Permission_Status_Enum, client_created_at: any };

export type ActivityRatingFragment = { __typename?: 'activity_rating', id: any, client_created_at: any, transaction_id?: any | null, value: number, user_id: any, activity_id: any, activity_selected: { __typename?: 'activity', id: any, display_name: string } };

export type AssessmentFragment = { __typename?: 'assessments', id: any, title: string, subtitle?: string | null, schema_version: number, first_page_id: any, assessment_length: number, created_at: any, updated_at: any, deleted_at?: any | null };

export type AssessmentPageFragment = { __typename?: 'assessment_pages', id: any, assessment_id: any, display_order: number, show_caution_modal: boolean, created_at: any, updated_at: any };

export type AssessmentQuestionFragment = { __typename?: 'assessment_questions', id: any, page_id: any, question_type: Enum_Question_Type_Enum, display_order: number, text: string, explanation_text?: string | null, properties?: any | null, created_at: any, updated_at: any };

export type AssessmentBranchingRuleFragment = { __typename?: 'assessment_branching_rules', id: any, page_id: any, question_id: any, rule_type: string, rule_value: string, next_page_id: any, priority: number, created_at: any, updated_at: any };

export type AssessmentTakeFragment = { __typename?: 'assessment_takes', id: any, assessment_id: any, user_id: any, started_at: any, completed_at: any, created_at: any, updated_at: any };

export type AssessmentAnswerFragment = { __typename?: 'assessment_answers', id: any, take_id: any, question_id: any, answer: string, client_created_at?: any | null, created_at: any, updated_at: any, custom_prompt_id?: any | null };

export type SafetyPlanChecklistItemsFragment = { __typename?: 'safety_plan_checklist_items', id: any, category_id: any, section_id: any, title: string, description?: string | null, subtitle?: string | null, display_order: number };

export type RelapsePreventionPlaceFragment = { __typename?: 'relapse_prevention_places', id: any, safety_plan_response_option_id: any, place_type: string, category: string, radius_meters: number, business_days?: string | null, business_hours_start?: any | null, business_hours_end?: any | null, deleted_at?: any | null };

export type RelapsePreventionPlaceVisitFragment = { __typename?: 'relapse_prevention_place_visits', id: any, place_id: any, created_at: any, deleted_at?: any | null };

export type RecordUserMoodMeasurementMutationVariables = Exact<{
  enjoyment: Scalars['Int']['input'];
  growth?: InputMaybe<Scalars['Int']['input']>;
  cravings?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['uuid']['input'];
  client_created_on: Scalars['String']['input'];
}>;


export type RecordUserMoodMeasurementMutation = { __typename?: 'mutation_root', insert_mood_measurements_one?: { __typename?: 'mood_measurements', enjoyment: number, growth?: number | null, cravings?: number | null, user_id: any, created_on: any, client_created_on?: string | null, id: number } | null };

export type OnboardUserMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  is_onboarded?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OnboardUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: any }> } | null };

export type UpdateUserFullNameMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  fullName: Scalars['String']['input'];
}>;


export type UpdateUserFullNameMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any } | null };

export type UpdateUserEmailMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateUserEmailMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, display_name?: string | null } | null };

export type UpdateUserNotificationTimeMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  notificationTime: Scalars['timestamptz']['input'];
}>;


export type UpdateUserNotificationTimeMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, notification_time?: any | null } | null };

export type InsertInviteCodeMutationVariables = Exact<{
  client_id: Scalars['uuid']['input'];
  code: Scalars['String']['input'];
}>;


export type InsertInviteCodeMutation = { __typename?: 'mutation_root', insert_invite_codes_one?: { __typename?: 'invite_codes', id: number, code: string } | null };

export type UpdateInviteCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type UpdateInviteCodeMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', returning: Array<{ __typename?: 'invite_codes', code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } }> } | null };

export type DeleteInviteCodeMutationVariables = Exact<{
  practitioner_id: Scalars['uuid']['input'];
  client_id: Scalars['uuid']['input'];
}>;


export type DeleteInviteCodeMutation = { __typename?: 'mutation_root', delete_invite_codes?: { __typename?: 'invite_codes_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invite_codes', code: string }> } | null };

export type InsertDailyFeatureMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  key: Enum_Feature_Type_Enum;
  value: Scalars['numeric']['input'];
  direction: Enum_Trend_Direction_Enum;
  feature_date: Scalars['timestamptz']['input'];
}>;


export type InsertDailyFeatureMutation = { __typename?: 'mutation_root', insert_daily_features_one?: { __typename?: 'daily_features', id: number } | null };

export type ScheduleNudgeMutationVariables = Exact<{
  nudge_id: Scalars['Int']['input'];
  practitioner_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  message: Scalars['String']['input'];
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled_at: Scalars['timestamp']['input'];
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScheduleNudgeMutation = { __typename?: 'mutation_root', insert_nudge_schedules_one?: { __typename?: 'nudge_schedules', id: number } | null };

export type ScheduleQuestionnaireMutationVariables = Exact<{
  questionnaire_id: Scalars['Int']['input'];
  practitioner_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  scheduled_at: Scalars['timestamp']['input'];
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  minutes_to_expiration: Scalars['Int']['input'];
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type ScheduleQuestionnaireMutation = { __typename?: 'mutation_root', insert_questionnaire_schedules_one?: { __typename?: 'questionnaire_schedules', id: number } | null };

export type DeleteNudgeScheduleByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteNudgeScheduleByIdMutation = { __typename?: 'mutation_root', delete_nudge_schedules_by_pk?: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } | null, delete_schedule_blackout_dates?: { __typename?: 'schedule_blackout_dates_mutation_response', affected_rows: number } | null };

export type DeleteQuestionnaireScheduleByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteQuestionnaireScheduleByIdMutation = { __typename?: 'mutation_root', delete_questionnaire_schedules_by_pk?: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> } | null, delete_schedule_blackout_dates?: { __typename?: 'schedule_blackout_dates_mutation_response', affected_rows: number } | null };

export type InsertQuestionnaireResponseMutationVariables = Exact<{
  questionnaire_item_id: Scalars['Int']['input'];
  questionnaire_take_id: Scalars['Int']['input'];
  questionnaire_response_option_id?: InputMaybe<Scalars['Int']['input']>;
  response: Scalars['Int']['input'];
}>;


export type InsertQuestionnaireResponseMutation = { __typename?: 'mutation_root', insert_questionnaire_responses_one?: { __typename?: 'questionnaire_responses', id: number, questionnaire_item_id: number, questionnaire_take_id: number, questionnaire_response_option_id?: number | null } | null };

export type UpdateQuestionnaireResponseByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  response: Scalars['Int']['input'];
}>;


export type UpdateQuestionnaireResponseByIdMutation = { __typename?: 'mutation_root', update_questionnaire_responses_by_pk?: { __typename?: 'questionnaire_responses', id: number } | null };

export type CompleteQuestionnaireMutationVariables = Exact<{
  questionnaire_take_id: Scalars['Int']['input'];
  completed_at: Scalars['timestamptz']['input'];
  is_expired: Scalars['Boolean']['input'];
}>;


export type CompleteQuestionnaireMutation = { __typename?: 'mutation_root', update_questionnaire_takes_by_pk?: { __typename?: 'questionnaire_takes', id: number } | null };

export type CompleteNudgeMutationVariables = Exact<{
  nudge_take_id: Scalars['Int']['input'];
  completed_at: Scalars['timestamptz']['input'];
}>;


export type CompleteNudgeMutation = { __typename?: 'mutation_root', update_nudge_takes_by_pk?: { __typename?: 'nudge_takes', id: number } | null };

export type EditScheduledNudgeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  nudge_id: Scalars['Int']['input'];
  scheduled_at: Scalars['timestamp']['input'];
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditScheduledNudgeMutation = { __typename?: 'mutation_root', update_nudge_schedules_by_pk?: { __typename?: 'nudge_schedules', id: number } | null };

export type EditScheduledQuestionnaireMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  questionnaire_id: Scalars['Int']['input'];
  scheduled_at: Scalars['timestamp']['input'];
  one_time?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_friday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_monday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_saturday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_sunday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_thursday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  recurring_wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  minutes_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  notify_connected_practitioners?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type EditScheduledQuestionnaireMutation = { __typename?: 'mutation_root', update_questionnaire_schedules_by_pk?: { __typename?: 'questionnaire_schedules', id: number } | null };

export type InsertBlackoutDateMutationVariables = Exact<{
  blackout_date: Scalars['date']['input'];
  blackout_following?: InputMaybe<Scalars['Boolean']['input']>;
  nudge_schedules_id?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_schedules_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertBlackoutDateMutation = { __typename?: 'mutation_root', insert_schedule_blackout_dates_one?: { __typename?: 'schedule_blackout_dates', id: number } | null };

export type UpdateUserPushNotificationIdsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  push_notification_ids?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateUserPushNotificationIdsMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', push_notification_ids: any } | null };

export type InsertNudgeTakeMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  nudgeScheduleId: Scalars['Int']['input'];
  nudgeScheduledAt?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type InsertNudgeTakeMutation = { __typename?: 'mutation_root', insert_nudge_takes_one?: { __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } } | null };

export type InsertQuestionnaireTakeMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  questionnaireScheduleId: Scalars['Int']['input'];
  questionnaireScheduledAt?: InputMaybe<Scalars['timestamp']['input']>;
  notify_connected_practitioners: Scalars['timestamp']['input'];
}>;


export type InsertQuestionnaireTakeMutation = { __typename?: 'mutation_root', insert_questionnaire_takes_one?: { __typename?: 'questionnaire_takes', id: number } | null };

export type InsertOrganizationMemberMutationVariables = Exact<{
  organization_id: Scalars['Int']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type InsertOrganizationMemberMutation = { __typename?: 'mutation_root', insert_organization_members_one?: { __typename?: 'organization_members', id: number } | null };

export type InsertOrganizationAdminMutationVariables = Exact<{
  organization_id: Scalars['Int']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type InsertOrganizationAdminMutation = { __typename?: 'mutation_root', insert_organization_admins_one?: { __typename?: 'organization_admins', id: number } | null };

export type InsertUserInviteMutationVariables = Exact<{
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  organization_id: Scalars['Int']['input'];
}>;


export type InsertUserInviteMutation = { __typename?: 'mutation_root', insert_user_invites_one?: { __typename?: 'user_invites', id: number } | null };

export type UpdateUserInviteStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateUserInviteStatusMutation = { __typename?: 'mutation_root', update_user_invites_by_pk?: { __typename?: 'user_invites', id: number } | null };

export type UpdateUserInviteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
}>;


export type UpdateUserInviteMutation = { __typename?: 'mutation_root', update_user_invites_by_pk?: { __typename?: 'user_invites', id: number } | null };

export type UpdateOrganizationNameMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateOrganizationNameMutation = { __typename?: 'mutation_root', update_organizations_by_pk?: { __typename?: 'organizations', id: number } | null };

export type UpdateOrganizationLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  location: Scalars['String']['input'];
}>;


export type UpdateOrganizationLocationMutation = { __typename?: 'mutation_root', update_organizations_by_pk?: { __typename?: 'organizations', id: number } | null };

export type UpdatePractitionerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  display_name: Scalars['String']['input'];
}>;


export type UpdatePractitionerMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any } | null };

export type UpdateAccountMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  email: Scalars['citext']['input'];
}>;


export type UpdateAccountMutation = { __typename?: 'mutation_root', update_auth_accounts?: { __typename?: 'auth_accounts_mutation_response', returning: Array<{ __typename?: 'auth_accounts', user_id: any }> } | null };

export type UpdateUserTimeZoneMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  tz: Scalars['String']['input'];
}>;


export type UpdateUserTimeZoneMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', most_recent_timezone?: string | null } | null };

export type DeleteUserInviteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteUserInviteMutation = { __typename?: 'mutation_root', delete_user_invites_by_pk?: { __typename?: 'user_invites', id: number } | null };

export type DeleteUserInviteByEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DeleteUserInviteByEmailMutation = { __typename?: 'mutation_root', delete_user_invites?: { __typename?: 'user_invites_mutation_response', affected_rows: number } | null };

export type DeletePractitionerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePractitionerMutation = { __typename?: 'mutation_root', delete_users_by_pk?: { __typename?: 'users', id: any } | null };

export type DeletePractitionerByEmailMutationVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type DeletePractitionerByEmailMutation = { __typename?: 'mutation_root', delete_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type DeleteOrganizationAdminMutationVariables = Exact<{
  practitioner_id: Scalars['uuid']['input'];
  organization_id: Scalars['Int']['input'];
}>;


export type DeleteOrganizationAdminMutation = { __typename?: 'mutation_root', delete_organization_admins?: { __typename?: 'organization_admins_mutation_response', affected_rows: number } | null };

export type DeleteOrganizationMemberMutationVariables = Exact<{
  practitioner_id: Scalars['uuid']['input'];
  organization_id: Scalars['Int']['input'];
}>;


export type DeleteOrganizationMemberMutation = { __typename?: 'mutation_root', delete_organization_members?: { __typename?: 'organization_members_mutation_response', affected_rows: number } | null };

export type ActivateAccountMutationVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type ActivateAccountMutation = { __typename?: 'mutation_root', update_auth_accounts?: { __typename?: 'auth_accounts_mutation_response', affected_rows: number } | null };

export type DeactivateAccountMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type DeactivateAccountMutation = { __typename?: 'mutation_root', update_auth_accounts?: { __typename?: 'auth_accounts_mutation_response', affected_rows: number } | null };

export type SetUserRequestedDeletionMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type SetUserRequestedDeletionMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any } | null };

export type UpdateUserFirstNameMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  firstName: Scalars['String']['input'];
}>;


export type UpdateUserFirstNameMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, first_name?: string | null } | null };

export type UpdateUserLastNameMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  lastName: Scalars['String']['input'];
}>;


export type UpdateUserLastNameMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, last_name?: string | null } | null };

export type UpdateUserPhoneNumberMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  mobile: Scalars['String']['input'];
}>;


export type UpdateUserPhoneNumberMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, phone_number?: string | null } | null };

export type InsertOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  location: Scalars['String']['input'];
}>;


export type InsertOrganizationMutation = { __typename?: 'mutation_root', insert_organizations_one?: { __typename?: 'organizations', id: number } | null };

export type InsertFeatureReportFeatureMutationVariables = Exact<{
  feature_report_id: Scalars['Int']['input'];
  key: Enum_Feature_Type_Enum;
  value: Scalars['numeric']['input'];
  more_less: Enum_Feature_Direction_Enum;
}>;


export type InsertFeatureReportFeatureMutation = { __typename?: 'mutation_root', insert_feature_report_features_one?: { __typename?: 'feature_report_features', id: number } | null };

export type InsertFeatureReportMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  outcome: Enum_Outcome_Enum;
  displayable_on: Scalars['timestamptz']['input'];
}>;


export type InsertFeatureReportMutation = { __typename?: 'mutation_root', insert_feature_reports_one?: { __typename?: 'feature_reports', id: number } | null };

export type UpdateLastCheckInNotificationMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  last_check_in_notification: Scalars['timestamptz']['input'];
}>;


export type UpdateLastCheckInNotificationMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', last_check_in_notification?: any | null } | null };

export type UpdateInviteCodeStatusMutationVariables = Exact<{
  code: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateInviteCodeStatusMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', returning: Array<{ __typename?: 'invite_codes', status?: string | null, code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } }> } | null };

export type AddClientMutationVariables = Exact<{
  code: Scalars['String']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type AddClientMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', returning: Array<{ __typename?: 'invite_codes', code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } }> } | null };

export type UpdatePhoneNumberMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  phone_number: Scalars['String']['input'];
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', phone_number?: string | null }> } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', delete_users_by_pk?: { __typename?: 'users', id: any } | null };

export type InsertLogMutationVariables = Exact<{
  type: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type InsertLogMutation = { __typename?: 'mutation_root', insert_logs_one?: { __typename?: 'logs', id: number } | null };

export type InsertMobileDeviceDataMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  device_make: Scalars['String']['input'];
  device_model: Scalars['String']['input'];
  os_version: Scalars['String']['input'];
  app_version: Scalars['String']['input'];
}>;


export type InsertMobileDeviceDataMutation = { __typename?: 'mutation_root', insert_mobile_device_data_one?: { __typename?: 'mobile_device_data', id: number } | null };

export type DeleteQuestionnaireResponsesMutationVariables = Exact<{
  questionnaire_take_id: Scalars['Int']['input'];
}>;


export type DeleteQuestionnaireResponsesMutation = { __typename?: 'mutation_root', delete_questionnaire_responses?: { __typename?: 'questionnaire_responses_mutation_response', affected_rows: number } | null };

export type InsertNudgeMutationVariables = Exact<{
  resource?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  technique: Scalars['String']['input'];
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  domain: Scalars['String']['input'];
  default_messaging: Scalars['String']['input'];
  created_by?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertNudgeMutation = { __typename?: 'mutation_root', insert_nudges_one?: { __typename?: 'nudges', id: number } | null };

export type UpdateNudgeMutationVariables = Exact<{
  resource?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  default_messaging?: InputMaybe<Scalars['String']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  technique?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateNudgeMutation = { __typename?: 'mutation_root', update_nudges_by_pk?: { __typename?: 'nudges', id: number } | null };

export type InsertQuestionnaireMutationVariables = Exact<{
  name: Scalars['String']['input'];
  created_by: Scalars['uuid']['input'];
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  contains_risk_questions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertQuestionnaireMutation = { __typename?: 'mutation_root', insert_questionnaires_one?: { __typename?: 'questionnaires', id: number } | null };

export type UpdateQuestionnaireMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateQuestionnaireMutation = { __typename?: 'mutation_root', update_questionnaires_by_pk?: { __typename?: 'questionnaires', id: number } | null };

export type InsertResourceAndInsightResourceMutationVariables = Exact<{
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Enum_Feature_Direction_Enum>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Enum_Feature_Type_Enum>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertResourceAndInsightResourceMutation = { __typename?: 'mutation_root', insert_insight_resources_one?: { __typename?: 'insight_resources', resources_id: number } | null };

export type InsertResourceMutationVariables = Exact<{
  author?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  created_by: Scalars['uuid']['input'];
  owner_org_id: Scalars['Int']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  header_image?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertResourceMutation = { __typename?: 'mutation_root', insert_resources_one?: { __typename?: 'resources', id: number } | null };

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  author?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  header_image?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResourceMutation = { __typename?: 'mutation_root', update_resources_by_pk?: { __typename?: 'resources', id: number } | null };

export type DeleteResourceByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteResourceByIdMutation = { __typename?: 'mutation_root', delete_resources_by_pk?: { __typename?: 'resources', id: number } | null };

export type DeleteNudgeByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteNudgeByIdMutation = { __typename?: 'mutation_root', delete_nudges_by_pk?: { __typename?: 'nudges', id: number } | null };

export type InsertResourceAccessAndResourceMutationVariables = Exact<{
  author?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Enum_Insight_Content_Type_Enum>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  header_image?: InputMaybe<Scalars['String']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertResourceAccessAndResourceMutation = { __typename?: 'mutation_root', insert_resources_orgs_one?: { __typename?: 'resources_orgs', resources_id: number } | null };

export type SetNudgeInactiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetNudgeInactiveMutation = { __typename?: 'mutation_root', update_nudges?: { __typename?: 'nudges_mutation_response', returning: Array<{ __typename?: 'nudges', id: number }> } | null };

export type UpdateIsUserDataAccurateMutationVariables = Exact<{
  feedback?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
}>;


export type UpdateIsUserDataAccurateMutation = { __typename?: 'mutation_root', update_daily_features_by_pk?: { __typename?: 'daily_features', id: number, user_id: any, key: Enum_Feature_Type_Enum, value: any, create_date: any, feature_date: any, is_user_reported_accurate?: boolean | null } | null };

export type UpsertV2RecipeMutationVariables = Exact<{
  recipes: Array<Insight_Recipes_Insert_Input> | Insight_Recipes_Insert_Input;
}>;


export type UpsertV2RecipeMutation = { __typename?: 'mutation_root', insert_insight_recipes?: { __typename?: 'insight_recipes_mutation_response', returning: Array<{ __typename?: 'insight_recipes', id: number }> } | null };

export type InsertUserGroupCodeMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  group_code_id: Scalars['Int']['input'];
}>;


export type InsertUserGroupCodeMutation = { __typename?: 'mutation_root', insert_user_group_code_one?: { __typename?: 'user_group_code', user_id: any, group_code_id: number } | null };

export type AddMobileUploadLogMutationVariables = Exact<{
  startTime: Scalars['timestamptz']['input'];
  endTime?: InputMaybe<Scalars['timestamptz']['input']>;
  dataType: Scalars['citext']['input'];
  totalRecordsAtStart: Scalars['Int']['input'];
  totalRecordsAtEnd?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['uuid']['input'];
  completed: Scalars['Boolean']['input'];
}>;


export type AddMobileUploadLogMutation = { __typename?: 'mutation_root', insert_mobile_upload_log_one?: { __typename?: 'mobile_upload_log', id: number } | null };

export type InsertQuestionnaireOneMutationVariables = Exact<{
  client_display_name?: InputMaybe<Scalars['String']['input']>;
  days_to_expiration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  owner_org_id?: InputMaybe<Scalars['Int']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  contains_risk_questions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertQuestionnaireOneMutation = { __typename?: 'mutation_root', insert_questionnaires_one?: { __typename?: 'questionnaires', id: number } | null };

export type InsertQuestionnaireItemOneMutationVariables = Exact<{
  header?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionnaire_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertQuestionnaireItemOneMutation = { __typename?: 'mutation_root', insert_questionnaire_items_one?: { __typename?: 'questionnaire_items', id: number } | null };

export type InsertQuestionnaireResponseOptionOneMutationVariables = Exact<{
  display_order?: InputMaybe<Scalars['Int']['input']>;
  questionnaire_item_id?: InputMaybe<Scalars['Int']['input']>;
  response_text?: InputMaybe<Scalars['String']['input']>;
  response_value?: InputMaybe<Scalars['Int']['input']>;
  triggers_risk_alert?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertQuestionnaireResponseOptionOneMutation = { __typename?: 'mutation_root', insert_questionnaire_response_options_one?: { __typename?: 'questionnaire_response_options', id: number } | null };

export type InsertRiskAlertRecipientLogMutationVariables = Exact<{
  risk_alerts_log_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  text_sent?: InputMaybe<Scalars['Boolean']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertRiskAlertRecipientLogMutation = { __typename?: 'mutation_root', insert_risk_alerts_recipients_log_one?: { __typename?: 'risk_alerts_recipients_log', id: any } | null };

export type SetRiskAlertLogCompleteMutationVariables = Exact<{
  all_alerts_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SetRiskAlertLogCompleteMutation = { __typename?: 'mutation_root', update_risk_alerts_log?: { __typename?: 'risk_alerts_log_mutation_response', returning: Array<{ __typename?: 'risk_alerts_log', id: any }> } | null };

export type InsertSafetyPlanMutationVariables = Exact<{
  status: Enum_Safety_Plan_Status_Enum;
  userId: Scalars['uuid']['input'];
  safetyPlanTemplateId: Scalars['uuid']['input'];
  updatedBy: Scalars['uuid']['input'];
  responses: Scalars['jsonb']['input'];
}>;


export type InsertSafetyPlanMutation = { __typename?: 'mutation_root', insert_safety_plan_one?: { __typename?: 'safety_plan', id: any, responses: any, safety_plan_template_id: any, status: Enum_Safety_Plan_Status_Enum, status_changed_at: any, updated_at: any, updated_by: any, user_id: any, created_at: any } | null };

export type InsertMobilePermissionMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  permission_type: Enum_Mobile_Permission_Type_Enum;
  permission_status: Enum_Mobile_Permission_Status_Enum;
  client_created_at: Scalars['timestamp']['input'];
}>;


export type InsertMobilePermissionMutation = { __typename?: 'mutation_root', insert_mobile_permissions_one?: { __typename?: 'mobile_permissions', id: any, permission_type: Enum_Mobile_Permission_Type_Enum, permission_status: Enum_Mobile_Permission_Status_Enum, client_created_at: any } | null };

export type InsertClientDemographicsMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Enum_Gender_Enum>;
  racialEthnic?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertClientDemographicsMutation = { __typename?: 'mutation_root', insert_client_demographics_one?: { __typename?: 'client_demographics', id: any } | null };

export type InsertActivityRatingMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  value: Scalars['Int']['input'];
  activity_id: Scalars['uuid']['input'];
  client_created_at: Scalars['timestamp']['input'];
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertActivityRatingMutation = { __typename?: 'mutation_root', insert_activity_rating_one?: { __typename?: 'activity_rating', id: any, user_id: any, activity_id: any, client_created_at: any } | null };

export type InsertSafetyChecklistRecipientsLogMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertSafetyChecklistRecipientsLogMutation = { __typename?: 'mutation_root', insert_safety_checklist_recipients_log_one?: { __typename?: 'safety_checklist_recipients_log', id: any } | null };

export type UpdateClientDemographicsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Enum_Gender_Enum>;
  racialEthnic?: InputMaybe<Enum_Racial_Ethnic_Enum>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClientDemographicsMutation = { __typename?: 'mutation_root', update_client_demographics?: { __typename?: 'client_demographics_mutation_response', returning: Array<{ __typename?: 'client_demographics', id: any }> } | null };

export type InsertOrgMemberRoleMutationVariables = Exact<{
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertOrgMemberRoleMutation = { __typename?: 'mutation_root', insert_organization_member_roles?: { __typename?: 'organization_member_roles_mutation_response', affected_rows: number } | null };

export type InsertSuperviseesMutationVariables = Exact<{
  supervisees: Array<Organization_Supervisees_Insert_Input> | Organization_Supervisees_Insert_Input;
}>;


export type InsertSuperviseesMutation = { __typename?: 'mutation_root', insert_organization_supervisees?: { __typename?: 'organization_supervisees_mutation_response', affected_rows: number } | null };

export type InsertSupervisorMutationVariables = Exact<{
  supervisor: Array<Organization_Supervisors_Insert_Input> | Organization_Supervisors_Insert_Input;
}>;


export type InsertSupervisorMutation = { __typename?: 'mutation_root', insert_organization_supervisors?: { __typename?: 'organization_supervisors_mutation_response', returning: Array<{ __typename?: 'organization_supervisors', id: any }> } | null };

export type DeleteOrganizationMemberRoleMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteOrganizationMemberRoleMutation = { __typename?: 'mutation_root', delete_organization_member_roles?: { __typename?: 'organization_member_roles_mutation_response', affected_rows: number } | null, delete_role_capabilities?: { __typename?: 'role_capabilities_mutation_response', affected_rows: number } | null };

export type UpdateSupervisorEndDateMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type UpdateSupervisorEndDateMutation = { __typename?: 'mutation_root', update_organization_supervisors?: { __typename?: 'organization_supervisors_mutation_response', affected_rows: number } | null };

export type UpdateAccountRoleMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateAccountRoleMutation = { __typename?: 'mutation_root', update_auth_accounts?: { __typename?: 'auth_accounts_mutation_response', returning: Array<{ __typename?: 'auth_accounts', user_id: any }> } | null };

export type InsertUserFeatureFlagsMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  jitai_features_enabled: Scalars['Boolean']['input'];
}>;


export type InsertUserFeatureFlagsMutation = { __typename?: 'mutation_root', insert_user_feature_flag?: { __typename?: 'user_feature_flag_mutation_response', returning: Array<{ __typename?: 'user_feature_flag', user_id: any, jitai_features_enabled: boolean }> } | null };

export type UpdateInviteCodeByClientAndPractitionerMutationVariables = Exact<{
  client_id: Scalars['uuid']['input'];
  practitioner_id: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
  ended_at: Scalars['timestamp']['input'];
}>;


export type UpdateInviteCodeByClientAndPractitionerMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'invite_codes', id: number, code: string, client_id: any, practitioner_id?: any | null, status?: string | null, ended_at?: any | null, created_at?: any | null }> } | null };

export type InsertScheduleBlackoutDatesMutationVariables = Exact<{
  objects: Array<Schedule_Blackout_Dates_Insert_Input> | Schedule_Blackout_Dates_Insert_Input;
}>;


export type InsertScheduleBlackoutDatesMutation = { __typename?: 'mutation_root', insert_schedule_blackout_dates?: { __typename?: 'schedule_blackout_dates_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, nudge_schedules_id?: number | null, questionnaire_schedules_id?: number | null, blackout_following?: boolean | null }> } | null };

export type SetUserRequestedDeletionAndTimestampMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  deletion_at: Scalars['timestamp']['input'];
}>;


export type SetUserRequestedDeletionAndTimestampMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any } | null };

export type UpdateInviteCodeStatusAndEndedAtMutationVariables = Exact<{
  code: Scalars['String']['input'];
  status: Scalars['String']['input'];
  ended_at: Scalars['timestamp']['input'];
}>;


export type UpdateInviteCodeStatusAndEndedAtMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', returning: Array<{ __typename?: 'invite_codes', status?: string | null, code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } }> } | null };

export type UpdateInviteCodesEndedAtOnAccountDeletionMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
  endedAt?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type UpdateInviteCodesEndedAtOnAccountDeletionMutation = { __typename?: 'mutation_root', update_invite_codes?: { __typename?: 'invite_codes_mutation_response', returning: Array<{ __typename?: 'invite_codes', client_id: any, practitioner_id?: any | null }> } | null };

export type InsertAssessmentTakeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  startedAt: Scalars['timestamptz']['input'];
  completedAt: Scalars['timestamptz']['input'];
}>;


export type InsertAssessmentTakeMutation = { __typename?: 'mutation_root', insert_assessment_takes_one?: { __typename?: 'assessment_takes', id: any, assessment_id: any, user_id: any, started_at: any, completed_at: any } | null };

export type InsertAssessmentAnswerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  takeId: Scalars['uuid']['input'];
  questionId: Scalars['uuid']['input'];
  answer: Scalars['String']['input'];
  clientCreatedAt: Scalars['timestamptz']['input'];
  customPromptId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertAssessmentAnswerMutation = { __typename?: 'mutation_root', insert_assessment_answers_one?: { __typename?: 'assessment_answers', id: any, take_id: any, question_id: any, answer: string, client_created_at?: any | null, custom_prompt_id?: any | null } | null };

export type UpsertDbtDiaryFeatureFlagMutationVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  dbt_diary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertDbtDiaryFeatureFlagMutation = { __typename?: 'mutation_root', insert_user_feature_flag?: { __typename?: 'user_feature_flag_mutation_response', affected_rows: number } | null };

export type UpsertViraPathFeatureFlagMutationVariables = Exact<{
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  vira_path_enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertViraPathFeatureFlagMutation = { __typename?: 'mutation_root', insert_user_feature_flag?: { __typename?: 'user_feature_flag_mutation_response', affected_rows: number } | null };

export type UpdateAssessmentQuestionCustomPromptHeaderMutationVariables = Exact<{
  assessment_question_id: Scalars['uuid']['input'];
  client_id: Scalars['uuid']['input'];
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAssessmentQuestionCustomPromptHeaderMutation = { __typename?: 'mutation_root', update_assessment_question_custom_prompt?: { __typename?: 'assessment_question_custom_prompt_mutation_response', affected_rows: number } | null };

export type DeleteAssessmentQuestionCustomPromptMutationVariables = Exact<{
  assessment_question_id: Scalars['uuid']['input'];
  client_id: Scalars['uuid']['input'];
  deleted_at: Scalars['timestamptz']['input'];
}>;


export type DeleteAssessmentQuestionCustomPromptMutation = { __typename?: 'mutation_root', update_assessment_question_custom_prompt?: { __typename?: 'assessment_question_custom_prompt_mutation_response', affected_rows: number } | null };

export type UpsertAssessmentQuestionCustomPromptMutationVariables = Exact<{
  assessment_question_id: Scalars['uuid']['input'];
  client_id: Scalars['uuid']['input'];
  practitioner_id: Scalars['uuid']['input'];
  text: Scalars['String']['input'];
  explanation_text?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  deleted_at: Scalars['timestamptz']['input'];
}>;


export type UpsertAssessmentQuestionCustomPromptMutation = { __typename?: 'mutation_root', update_assessment_question_custom_prompt?: { __typename?: 'assessment_question_custom_prompt_mutation_response', affected_rows: number } | null, insert_assessment_question_custom_prompt_one?: { __typename?: 'assessment_question_custom_prompt', id: any } | null };

export type InsertClientInviteCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  practitioner_id: Scalars['uuid']['input'];
  org_id?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  phone_contacted_at?: InputMaybe<Scalars['timestamp']['input']>;
  minutes_to_expire?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertClientInviteCodeMutation = { __typename?: 'mutation_root', insert_ehr_client_invite_codes_one?: { __typename?: 'ehr_client_invite_codes', id: any } | null };

export type UpdateClientInviteCodeSentAtMutationVariables = Exact<{
  code: Scalars['String']['input'];
  practitioner_id: Scalars['uuid']['input'];
  email_sent_at?: InputMaybe<Scalars['timestamp']['input']>;
  phone_contacted_at?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type UpdateClientInviteCodeSentAtMutation = { __typename?: 'mutation_root', update_ehr_client_invite_codes?: { __typename?: 'ehr_client_invite_codes_mutation_response', affected_rows: number } | null };

export type DeleteClientInviteCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  practitioner_id: Scalars['uuid']['input'];
  deleted_at?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type DeleteClientInviteCodeMutation = { __typename?: 'mutation_root', update_ehr_client_invite_codes?: { __typename?: 'ehr_client_invite_codes_mutation_response', affected_rows: number } | null };

export type InsertNewPasswordResetTicketMutationVariables = Exact<{
  email: Scalars['citext']['input'];
  ticket: Scalars['uuid']['input'];
  expiresAt: Scalars['timestamptz']['input'];
}>;


export type InsertNewPasswordResetTicketMutation = { __typename?: 'mutation_root', update_auth_accounts?: { __typename?: 'auth_accounts_mutation_response', affected_rows: number } | null };

export type InsertRelapsePreventionPlaceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  safety_plan_response_option_id: Scalars['uuid']['input'];
  place_type: Scalars['String']['input'];
  category: Scalars['String']['input'];
  alert_name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  radius_meters: Scalars['Int']['input'];
  business_days: Scalars['String']['input'];
  business_hours_start?: InputMaybe<Scalars['time']['input']>;
  business_hours_end?: InputMaybe<Scalars['time']['input']>;
  media_items?: InputMaybe<Scalars['String']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type InsertRelapsePreventionPlaceMutation = { __typename?: 'mutation_root', insert_relapse_prevention_places_one?: { __typename?: 'relapse_prevention_places', id: any } | null };

export type InsertRelapsePreventionPlaceVisitMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  place_id: Scalars['uuid']['input'];
  created_at: Scalars['timestamptz']['input'];
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type InsertRelapsePreventionPlaceVisitMutation = { __typename?: 'mutation_root', insert_relapse_prevention_place_visits_one?: { __typename?: 'relapse_prevention_place_visits', id: any } | null };

export type GetClientDataQueryVariables = Exact<{
  clientId: Scalars['uuid']['input'];
  feature_report_limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClientDataQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, phone_number?: string | null, most_recent_timezone?: string | null, display_name?: string | null, client_demographics: Array<{ __typename?: 'client_demographics', id: any, user_id: any, practitioner_id: any, created_at: any, first_name?: string | null, last_name?: string | null, birth_year?: number | null, gender?: Enum_Gender_Enum | null, racial_ethnic?: Enum_Racial_Ethnic_Enum | null, description?: string | null }>, mood_measurements: Array<{ __typename?: 'mood_measurements', id: number, enjoyment: number, growth?: number | null, cravings?: number | null, created_on: any, client_created_on?: string | null }>, growth_reports: Array<{ __typename?: 'feature_reports', id: number, outcome: Enum_Outcome_Enum, created_on: any, displayable_on: any, feature_report_features: Array<{ __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any }> }>, enjoy_reports: Array<{ __typename?: 'feature_reports', id: number, outcome: Enum_Outcome_Enum, created_on: any, displayable_on: any, feature_report_features: Array<{ __typename?: 'feature_report_features', key: Enum_Feature_Type_Enum, more_less: Enum_Feature_Direction_Enum, value: any }> }>, daily_features: Array<{ __typename?: 'daily_features', key: Enum_Feature_Type_Enum, value: any, direction: Enum_Trend_Direction_Enum, feature_date: any }>, activity_rating: Array<{ __typename?: 'activity_rating', id: any, client_created_at: any, transaction_id?: any | null, value: number, user_id: any, activity_id: any, activity_selected: { __typename?: 'activity', id: any, display_name: string } }>, vw_daily_features_sleep: Array<{ __typename?: 'vw_daily_features_sleep', val_bedtime_offset_hour?: any | null, val_waketime_offset_hour?: any | null, feature_date?: any | null }>, vw_daily_features_trend: Array<{ __typename?: 'vw_daily_features_trend', key?: string | null, avg_this_week?: any | null, direction?: string | null }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }>, users_user_feature_flags?: { __typename?: 'user_feature_flag', user_id: any, dbt_diary_enabled: boolean, jitai_features_enabled: boolean, vira_path_enabled: boolean } | null } | null };

export type GetFeatureTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureTypesQuery = { __typename?: 'query_root', enum_feature_type: Array<{ __typename?: 'enum_feature_type', value: string }> };

export type GetInviteCodesQueryVariables = Exact<{
  practitionerId: Scalars['uuid']['input'];
}>;


export type GetInviteCodesQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', code: string, client_id: any, practitioner_id?: any | null, expiration_code?: any | null, user: { __typename?: 'users', first_name?: string | null, last_name?: string | null } }> };

export type CheckClientPractitionerUniquenessQueryVariables = Exact<{
  clientId: Scalars['uuid']['input'];
  practitionerId: Scalars['uuid']['input'];
}>;


export type CheckClientPractitionerUniquenessQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', id: number }> };

export type GetDataFromInviteCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetDataFromInviteCodeQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', client_id: any, practitioner_id?: any | null }> };

export type GetAllActiveNudgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveNudgesQuery = { __typename?: 'query_root', nudges: Array<{ __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }> };

export type GetQuestionnairesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnairesQuery = { __typename?: 'query_root', questionnaires: Array<{ __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }> };

export type GetNudgeSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNudgeSchedulesQuery = { __typename?: 'query_root', nudge_schedules: Array<{ __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> }> };

export type GetQuestionnaireSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnaireSchedulesQuery = { __typename?: 'query_root', questionnaire_schedules: Array<{ __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }> };

export type GetUserPushNotificationIdsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserPushNotificationIdsQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', push_notification_ids: any } | null };

export type GetOneTimeNudgesBetweenDatesQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
  blackoutDate: Scalars['date']['input'];
}>;


export type GetOneTimeNudgesBetweenDatesQuery = { __typename?: 'query_root', nudge_schedules: Array<{ __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', resource_id?: number | null, activity_id?: any | null, default_messaging: string }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', scheduled_at: any }> }> };

export type GetUserCarePlanNudgeTakesBetweenQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
}>;


export type GetUserCarePlanNudgeTakesBetweenQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', scheduled_at: any }> };

export type GetRecurringNudgesQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
  blackoutDate: Scalars['date']['input'];
}>;


export type GetRecurringNudgesQuery = { __typename?: 'query_root', nudge_schedules: Array<{ __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', resource_id?: number | null, activity_id?: any | null, default_messaging: string }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', scheduled_at: any }> }> };

export type GetRecurringQuestionnairesQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
  blackoutDate: Scalars['date']['input'];
}>;


export type GetRecurringQuestionnairesQuery = { __typename?: 'query_root', questionnaire_schedules: Array<{ __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, notify_connected_practitioners?: any | null, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', scheduled_at: any }> }> };

export type GetOneTimeQuestionnairesBetweenDatesQueryVariables = Exact<{
  startDate: Scalars['timestamp']['input'];
  endDate: Scalars['timestamp']['input'];
  blackoutDate: Scalars['date']['input'];
}>;


export type GetOneTimeQuestionnairesBetweenDatesQuery = { __typename?: 'query_root', questionnaire_schedules: Array<{ __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, notify_connected_practitioners?: any | null, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', blackout_date?: any | null, blackout_following?: boolean | null }>, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', scheduled_at: any }> }> };

export type GetUserOrganizationAdminsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserOrganizationAdminsQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }> } | null };

export type GetPendingUserInviteQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetPendingUserInviteQuery = { __typename?: 'query_root', user_invites: Array<{ __typename?: 'user_invites', id: number, role: string, organization_id: number }> };

export type GetPractitionerDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPractitionerDataQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, display_name?: string | null, account?: { __typename?: 'auth_accounts', default_role: string } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, practitioner_invite_codes: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } }> } | null };

export type GetUserInviteByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserInviteByEmailQuery = { __typename?: 'query_root', user_invites: Array<{ __typename?: 'user_invites', id: number }> };

export type AuthAccountsByEmailQueryVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type AuthAccountsByEmailQuery = { __typename?: 'query_root', auth_accounts: Array<{ __typename?: 'auth_accounts', user_id: any }> };

export type GetClientsForNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientsForNotificationQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, last_check_in_notification?: any | null, notification_time?: any | null, push_notification_ids: any, mood_measurements: Array<{ __typename?: 'mood_measurements', client_created_on?: string | null }> }> };

export type GetPractitionerQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetPractitionerQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, phone_number?: string | null, account?: { __typename?: 'auth_accounts', email?: any | null, account_providers: Array<{ __typename?: 'auth_account_providers', id: any }> } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, organization_members: Array<{ __typename?: 'organization_members', organization_id: number, organization: { __typename?: 'organizations', id: number, name?: string | null, location?: string | null } }> } | null };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'query_root', organizations_by_pk?: { __typename?: 'organizations', id: number, name?: string | null, location?: string | null, user_invites: Array<{ __typename?: 'user_invites', id: number, first_name: string, last_name: string, email: string, role: string }>, organization_members: Array<{ __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, full_name?: string | null, first_name?: string | null, last_name?: string | null, display_name?: string | null, account?: { __typename?: 'auth_accounts', default_role: string } | null, organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, practitioner_invite_codes: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, created_at: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }>, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> } }> } }> } | null };

export type GetOrgPractitionerCountsQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrgPractitionerCountsQuery = { __typename?: 'query_root', active: Array<{ __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, last_name?: string | null, first_name?: string | null, email?: string | null, account?: { __typename?: 'auth_accounts', user: { __typename?: 'users', organization_admins: Array<{ __typename?: 'organization_admins', organization_id: number }>, users_role_capabilities: Array<{ __typename?: 'role_capabilities', role?: string | null }> } } | null, client_count: { __typename?: 'invite_codes_aggregate', aggregate?: { __typename?: 'invite_codes_aggregate_fields', count: number } | null }, nudge_count: { __typename?: 'nudge_schedules_aggregate', aggregate?: { __typename?: 'nudge_schedules_aggregate_fields', count: number } | null }, questionnaire_count: { __typename?: 'questionnaire_schedules_aggregate', aggregate?: { __typename?: 'questionnaire_schedules_aggregate_fields', count: number } | null }, totalActiveClients: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any } }> } }>, pending: Array<{ __typename?: 'user_invites', id: number, email: string, last_name: string, first_name: string, status: string, role: string }> };

export type MyOrganizationQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type MyOrganizationQuery = { __typename?: 'query_root', allActiveNudges: Array<{ __typename?: 'vw_org_nudge_technique_counts', active?: boolean | null, domain?: string | null, technique?: string | null, count?: any | null }>, topTenActiveNudges: Array<{ __typename?: 'vw_org_nudge_technique_counts', active?: boolean | null, domain?: string | null, technique?: string | null, count?: any | null }>, mostActiveNudges: Array<{ __typename?: 'vw_org_nudge_technique_counts', active?: boolean | null, domain?: string | null, technique?: string | null, count?: any | null }>, leastActiveNudges: Array<{ __typename?: 'vw_org_nudge_technique_counts', active?: boolean | null, domain?: string | null, technique?: string | null, count?: any | null }>, clientCount: Array<{ __typename?: 'vw_org_client_count', count?: any | null }>, nudgeCount: Array<{ __typename?: 'vw_org_nudge_count', count?: any | null }>, questionnaireCount: Array<{ __typename?: 'vw_org_questionnaire_count', count?: any | null }>, activeClientsWithRecentQuestionnaire: Array<{ __typename?: 'users', id: any, questionnaire_takes_aggregate: { __typename?: 'questionnaire_takes_aggregate', aggregate?: { __typename?: 'questionnaire_takes_aggregate_fields', max?: { __typename?: 'questionnaire_takes_max_fields', severity_score?: number | null } | null } | null } }>, totalActiveClients: Array<{ __typename?: 'users', id: any }> };

export type OrgWithPractCountsWithCasemixQueryVariables = Exact<{
  date?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type OrgWithPractCountsWithCasemixQuery = { __typename?: 'query_root', organization_members: Array<{ __typename?: 'organization_members', practitioner: { __typename?: 'users', id: any, last_name?: string | null, first_name?: string | null, email?: string | null, client_count: { __typename?: 'invite_codes_aggregate', aggregate?: { __typename?: 'invite_codes_aggregate_fields', count: number } | null }, nudge_count: { __typename?: 'nudge_schedules_aggregate', aggregate?: { __typename?: 'nudge_schedules_aggregate_fields', count: number } | null }, questionnaire_count: { __typename?: 'questionnaire_schedules_aggregate', aggregate?: { __typename?: 'questionnaire_schedules_aggregate_fields', count: number } | null }, activeClientsWithRecentQuestionnaire: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any, questionnaire_takes_aggregate: { __typename?: 'questionnaire_takes_aggregate', aggregate?: { __typename?: 'questionnaire_takes_aggregate_fields', max?: { __typename?: 'questionnaire_takes_max_fields', severity_score?: number | null } | null } | null } } }>, totalActiveClients: Array<{ __typename?: 'invite_codes', user: { __typename?: 'users', id: any } }> } }> };

export type GetUsersByPractitionerQueryVariables = Exact<{
  practitioner_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetUsersByPractitionerQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, display_name?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, is_onboarded: boolean, notification_time?: any | null, phone_number?: string | null, client_invite_codes: Array<{ __typename?: 'invite_codes', status?: string | null, code: string, ended_at?: any | null, created_at?: any | null }>, mood_measurements_aggregate: { __typename?: 'mood_measurements_aggregate', aggregate?: { __typename?: 'mood_measurements_aggregate_fields', count: number } | null }, mostRecentScoredQuestionnaires: Array<{ __typename?: 'vw_most_recent_scored_questionnaires', completed_at?: any | null, questionnaire_id?: number | null, questionnaire_name?: string | null, questionnaire_take_id?: number | null, display_score?: any | null, display_score_type?: string | null, scoring_display_color?: string | null, scoring_display_name?: string | null }>, client_demographics: Array<{ __typename?: 'client_demographics', id: any, user_id: any, practitioner_id: any, created_at: any, first_name?: string | null, last_name?: string | null, birth_year?: number | null, gender?: Enum_Gender_Enum | null, racial_ethnic?: Enum_Racial_Ethnic_Enum | null, description?: string | null }> }> };

export type GetPractionersForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPractionersForUserQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', code: string, status?: string | null, practitioner_id?: any | null, userByPractitionerId?: { __typename?: 'users', first_name?: string | null, last_name?: string | null } | null }> };

export type NudgesScheduleByUserQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type NudgesScheduleByUserQuery = { __typename?: 'query_root', nudge_schedules: Array<{ __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }>, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null } }> };

export type QuestionnairesScheduleByUserQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type QuestionnairesScheduleByUserQuery = { __typename?: 'query_root', questionnaire_schedules: Array<{ __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, completion_status?: Enum_Completion_Status_Enum | null, scheduled_at: any, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }>, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null } }> };

export type GetClientNotificationTokensQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetClientNotificationTokensQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', push_notification_ids: any }> };

export type GetPendingPractitionerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPendingPractitionerQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null } | null };

export type GetQuestionnaireTakeByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireTakeByIdQuery = { __typename?: 'query_root', questionnaire_takes_by_pk?: { __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> } | null };

export type GetQuestionnaireTakeByScheduleIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireTakeByScheduleIdQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> };

export type GetQuestionnaireResponseQueryVariables = Exact<{
  takeId: Scalars['Int']['input'];
  itemId: Scalars['Int']['input'];
}>;


export type GetQuestionnaireResponseQuery = { __typename?: 'query_root', questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number }> };

export type InitialGetUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type InitialGetUserQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, display_name?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, is_onboarded: boolean, notification_time?: any | null, phone_number?: string | null, most_recent_timezone?: string | null, has_derived_data: boolean, created_at: any, clientToOrganizations: Array<{ __typename?: 'vw_user_organization', user_id?: any | null, org_id?: number | null }>, account?: { __typename?: 'auth_accounts', account_providers: Array<{ __typename?: 'auth_account_providers', id: any }> } | null, client_invite_codes: Array<{ __typename?: 'invite_codes', code: string, practitioner_id?: any | null, expiration_code?: any | null }>, practitioners: Array<{ __typename?: 'invite_codes', code: string, status?: string | null, practitioner?: { __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null } | null }>, mobile_device_data: Array<{ __typename?: 'mobile_device_data', device_make: string, device_model: string, os_version: string, app_version?: string | null }> }> };

export type GetMobileDeviceDataQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetMobileDeviceDataQuery = { __typename?: 'query_root', mobile_device_data: Array<{ __typename?: 'mobile_device_data', device_make: string, device_model: string, os_version: string, app_version?: string | null }> };

export type GetInviteCodeForClientQueryVariables = Exact<{
  client_id: Scalars['uuid']['input'];
}>;


export type GetInviteCodeForClientQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', code: string }> };

export type GetOrgInAppResourcesQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrgInAppResourcesQuery = { __typename?: 'query_root', resources: Array<{ __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, id: number, owner_org_id?: number | null, header_image?: string | null, public: boolean, title?: string | null, updated_on: any }> };

export type GetOrgActiveTechniquesAndInterventionsQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetOrgActiveTechniquesAndInterventionsQuery = { __typename?: 'query_root', nudges: Array<{ __typename?: 'nudges', created_at: any, created_by?: any | null, default_messaging: string, owner_org_id?: number | null, domain: string, id: number, active: boolean, technique: string, resource_id?: number | null, updated_at: any, public?: boolean | null }> };

export type GetResourceByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetResourceByIdQuery = { __typename?: 'query_root', resources_by_pk?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null };

export type GetAllInAppResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllInAppResourcesQuery = { __typename?: 'query_root', resources: Array<{ __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, id: number, header_image?: string | null, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any }> };

export type GetMoodMeasurementsByUserIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetMoodMeasurementsByUserIdQuery = { __typename?: 'query_root', mood_measurements: Array<{ __typename?: 'mood_measurements', client_created_on?: string | null, created_on: any, enjoyment: number, growth?: number | null, cravings?: number | null, user_id: any }> };

export type GetUserInsightsWithResourcesQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetUserInsightsWithResourcesQuery = { __typename?: 'query_root', user_insights: Array<{ __typename?: 'user_insights', created_on: any, id: number, seen?: any | null, insight_combo?: { __typename?: 'insight_combos', direction: Enum_Feature_Direction_Enum, feature: Enum_Feature_Type_Enum, id: number, outcome: Enum_Outcome_Enum, display_text?: string | null, observe_text?: string | null } | null, insightRecipe?: { __typename?: 'insight_recipes', id: number, schema_version?: number | null, planImageURL?: string | null, observeText?: { __typename?: 'insight_texts', content: string, imageURL?: string | null } | null, planText?: { __typename?: 'insight_texts', content: string } | null, reflectText?: { __typename?: 'insight_texts', content: string } | null, insight_reflects: Array<{ __typename?: 'insight_reflect', reflectHeading?: { __typename?: 'insight_texts', content: string } | null, insight_reflect_texts: Array<{ __typename?: 'insight_reflect_text', insight_text: { __typename?: 'insight_texts', content: string } }> }>, insight_plans: Array<{ __typename?: 'insight_plans', id: number, type?: string | null, responseText?: { __typename?: 'insight_texts', content: string } | null, insight_plan_texts: Array<{ __typename?: 'insight_plan_text', insight_text: { __typename?: 'insight_texts', content: string } }>, insight_plan_articles: Array<{ __typename?: 'insight_plan_article', resource: { __typename?: 'resources', created_on: any, content: string, title?: string | null, author?: string | null, content_type: Enum_Insight_Content_Type_Enum, header_image?: string | null, id: number } }> }> } | null }> };

export type GetActiveTechniquesAndInterventionsQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetActiveTechniquesAndInterventionsQuery = { __typename?: 'query_root', nudges: Array<{ __typename?: 'nudges', created_at: any, created_by?: any | null, default_messaging: string, owner_org_id?: number | null, domain: string, id: number, active: boolean, technique: string, resource_id?: number | null, updated_at: any, public?: boolean | null }>, questionnaires: Array<{ __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }> };

export type GetNudgeTakesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNudgeTakesQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }> };

export type GetNudgeTakesByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNudgeTakesByIdQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }> };

export type GetNudgeTakesAfterQueryVariables = Exact<{
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type GetNudgeTakesAfterQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }> };

export type GetDailyFeatureDataQueryVariables = Exact<{
  create_date?: InputMaybe<Order_By>;
  key: Enum_Feature_Type_Enum;
}>;


export type GetDailyFeatureDataQuery = { __typename?: 'query_root', daily_features: Array<{ __typename?: 'daily_features', create_date: any, feature_date: any, id: number, is_user_reported_accurate?: boolean | null, key: Enum_Feature_Type_Enum, user_id: any, value: any }> };

export type GetQuestionnaireTakesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionnaireTakesQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> };

export type GetQuestionnaireTakesAfterQueryVariables = Exact<{
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type GetQuestionnaireTakesAfterQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }> };

export type RecentQuestionnaireTakesByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentQuestionnaireTakesByUserIdQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', rating_score?: string | null, raw_score?: number | null, severity_score?: number | null, completed_at?: any | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', questionnaire: { __typename?: 'questionnaires', id: number, name: string } } }> };

export type QuestionnaireTakesSinceDateByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  sinceDate?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type QuestionnaireTakesSinceDateByUserIdQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', rating_score?: string | null, raw_score?: number | null, severity_score?: number | null, completed_at?: any | null, completion_status?: Enum_Completion_Status_Enum | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', response_text: string, response_value: number, triggers_risk_alert?: boolean | null } | null }>, questionnaireDisplayValues?: { __typename?: 'vw_questionnaire_display_values', questionnaire_id?: number | null, questionnaire_name?: string | null, display_score?: any | null, display_score_type?: string | null, scoring_display_color?: string | null, scoring_display_name?: string | null } | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', questionnaire: { __typename?: 'questionnaires', contains_risk_questions?: boolean | null, name: string, id: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', questionnaire_id: number, question: string, display_order: number, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', response_text: string, triggers_risk_alert?: boolean | null, response_value: number }> }> } } }> };

export type GetRiskAlertLogByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRiskAlertLogByIdQuery = { __typename?: 'query_root', risk_alerts_log: Array<{ __typename?: 'risk_alerts_log', risk_alerts_log_questionnaire_take: { __typename?: 'questionnaire_takes', completed_at?: any | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', created_at: any, id: number, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', response_value: number, triggers_risk_alert?: boolean | null, response_text: string } | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number } }>, user: { __typename?: 'users', display_name?: string | null, first_name?: string | null, last_name?: string | null, id: any }, questionnaire_schedule: { __typename?: 'questionnaire_schedules', questionnaire: { __typename?: 'questionnaires', id: number, name: string } } } }> };

export type GetDailyFeatureByDateQueryVariables = Exact<{
  feature_date?: InputMaybe<Order_By>;
  feature_date_stamp: Scalars['timestamptz']['input'];
}>;


export type GetDailyFeatureByDateQuery = { __typename?: 'query_root', daily_features: Array<{ __typename?: 'daily_features', create_date: any, feature_date: any, id: number, is_user_reported_accurate?: boolean | null, key: Enum_Feature_Type_Enum, user_id: any, value: any }> };

export type GetDailyFeaturesSinceQueryVariables = Exact<{
  feature_date: Scalars['timestamptz']['input'];
  feature_date_order?: InputMaybe<Order_By>;
}>;


export type GetDailyFeaturesSinceQuery = { __typename?: 'query_root', daily_features: Array<{ __typename?: 'daily_features', create_date: any, feature_date: any, id: number, is_user_reported_accurate?: boolean | null, key: Enum_Feature_Type_Enum, user_id: any, value: any }> };

export type InsightV2QueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type InsightV2Query = { __typename?: 'query_root', insight_recipes_by_pk?: { __typename?: 'insight_recipes', id: number, owner_org_id?: number | null, schema_version?: number | null, public: boolean, planImageURL?: string | null, insight_combo: { __typename?: 'insight_combos', id: number, feature: Enum_Feature_Type_Enum, display_text?: string | null }, observeText?: { __typename?: 'insight_texts', content: string, imageURL?: string | null } | null, reflectText?: { __typename?: 'insight_texts', content: string } | null, insight_reflects: Array<{ __typename?: 'insight_reflect', reflectHeading?: { __typename?: 'insight_texts', content: string } | null, insight_reflect_texts: Array<{ __typename?: 'insight_reflect_text', insight_text: { __typename?: 'insight_texts', content: string } }> }>, planText?: { __typename?: 'insight_texts', content: string } | null, insight_plans: Array<{ __typename?: 'insight_plans', type?: string | null, responseText?: { __typename?: 'insight_texts', content: string } | null, insight_plan_texts: Array<{ __typename?: 'insight_plan_text', insight_text: { __typename?: 'insight_texts', content: string } }>, insight_plan_articles: Array<{ __typename?: 'insight_plan_article', resource: { __typename?: 'resources', header_image?: string | null, content: string, title?: string | null } }> }> } | null };

export type AllSchema2RecipePKsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSchema2RecipePKsQuery = { __typename?: 'query_root', insight_recipes: Array<{ __typename?: 'insight_recipes', id: number, insight_combo: { __typename?: 'insight_combos', display_text?: string | null, outcome: Enum_Outcome_Enum, feature: Enum_Feature_Type_Enum, id: number } }> };

export type CheckGroupCodeQueryVariables = Exact<{
  code: Scalars['citext']['input'];
}>;


export type CheckGroupCodeQuery = { __typename?: 'query_root', group_code: Array<{ __typename?: 'group_code', id: number, code: any }> };

export type GetLastTenMoodMeasurementsByUserIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLastTenMoodMeasurementsByUserIdQuery = { __typename?: 'query_root', mood_measurements: Array<{ __typename?: 'mood_measurements', client_created_on?: string | null, created_on: any, enjoyment: number, growth?: number | null, cravings?: number | null, user_id: any }> };

export type GetOrganizationFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationFeaturesQuery = { __typename?: 'query_root', organization_features: Array<{ __typename?: 'organization_features', org_id: number, second_checkin_question: boolean, brite_features?: boolean | null, mvp2_features?: boolean | null, vira_path?: boolean | null, vira_scribe?: boolean | null, vira_loop?: boolean | null }> };

export type GetQuestionnaireExpirationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireExpirationQuery = { __typename?: 'query_root', questionnaires_by_pk?: { __typename?: 'questionnaires', minutes_to_expiration: number } | null };

export type GetQuestionnaireSchedulesExpirationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireSchedulesExpirationQuery = { __typename?: 'query_root', questionnaire_schedules_by_pk?: { __typename?: 'questionnaire_schedules', minutes_to_expiration: number } | null };

export type GetRiskAlertContactsQueryVariables = Exact<{
  RiskAlertId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetRiskAlertContactsQuery = { __typename?: 'query_root', risk_alerts_log: Array<{ __typename?: 'risk_alerts_log', risk_alerts_log_questionnaire_take: { __typename?: 'questionnaire_takes', completed_at?: any | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', practitioner: { __typename?: 'users', first_name?: string | null, last_name?: string | null, phone_number?: string | null, most_recent_timezone?: string | null, id: any, account?: { __typename?: 'auth_accounts', email?: any | null } | null }, questionnaire: { __typename?: 'questionnaires', name: string, questionnaires_questionnaire_risk_alert_contacts: Array<{ __typename?: 'questionnaire_risk_alert_contacts', questionnaire_risk_alert_contacts_user: { __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null, phone_number?: string | null, most_recent_timezone?: string | null, account?: { __typename?: 'auth_accounts', email?: any | null } | null } }>, questionnaires_organization?: { __typename?: 'organizations', name?: string | null } | null }, user: { __typename?: 'users', most_recent_timezone?: string | null } } } }> };

export type GetQuestionnaireDisplayValuesQueryVariables = Exact<{
  questionnaire_id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireDisplayValuesQuery = { __typename?: 'query_root', questionnaire_scoring: Array<{ __typename?: 'questionnaire_scoring', display_color: string, display_name: string, lower_bound: number, id: any, upper_bound: number }> };

export type GetPractitionerCasemixQueryVariables = Exact<{
  completed_after: Scalars['timestamptz']['input'];
}>;


export type GetPractitionerCasemixQuery = { __typename?: 'query_root', vw_questionnaire_display_values: Array<{ __typename?: 'vw_questionnaire_display_values', casemix_display_order?: number | null, user_id?: any | null, practitioner_id?: any | null }> };

export type GetCasemixCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCasemixCategoriesQuery = { __typename?: 'query_root', casemix_category: Array<{ __typename?: 'casemix_category', category: string, display_color: string, display_order: number }> };

export type GetQuestionnaireScoringBoundsQueryVariables = Exact<{
  questionnaireId: Scalars['Int']['input'];
}>;


export type GetQuestionnaireScoringBoundsQuery = { __typename?: 'query_root', questionnaire_scoring: Array<{ __typename?: 'questionnaire_scoring', lower_bound: number, upper_bound: number }> };

export type GetNotifyAllPractitionersFromQuestionnaireTakeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNotifyAllPractitionersFromQuestionnaireTakeQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', notify_connected_practitioners?: any | null, user_id: any }> };

export type GetAllConnectedPractitionersContactInfoQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetAllConnectedPractitionersContactInfoQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', userByPractitionerId?: { __typename?: 'users', phone_number?: string | null, display_name?: string | null, first_name?: string | null, last_name?: string | null, id: any } | null }> };

export type GetQuestionnaireScheduleNotifyAllQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireScheduleNotifyAllQuery = { __typename?: 'query_root', questionnaire_schedules_by_pk?: { __typename?: 'questionnaire_schedules', notify_connected_practitioners?: any | null } | null };

export type GetOrganizationFeaturesByOrgIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrganizationFeaturesByOrgIdQuery = { __typename?: 'query_root', organization_features: Array<{ __typename?: 'organization_features', org_id: number, second_checkin_question: boolean, brite_features?: boolean | null, mvp2_features?: boolean | null, dbt_diary?: boolean | null, vira_path?: boolean | null, vira_scribe?: boolean | null, vira_loop?: boolean | null }> };

export type GetSafetyPlanByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  status: Enum_Safety_Plan_Status_Enum;
}>;


export type GetSafetyPlanByUserIdQuery = { __typename?: 'query_root', safety_plan: Array<{ __typename?: 'safety_plan', user_id: any, created_at: any, id: any, safety_plan_template_id: any, status: Enum_Safety_Plan_Status_Enum, status_changed_at: any, updated_at: any, updated_by: any, responses: any }> };

export type GetSafetyPlanSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSafetyPlanSectionsQuery = { __typename?: 'query_root', safety_plan_sections: Array<{ __typename?: 'safety_plan_sections', safety_plan_template_id: any, description?: string | null, display_order: number, header: string, help_text?: string | null, id: any, icon?: Enum_Safety_Plan_Section_Icons_Enum | null, icon_color?: string | null, header_image_path?: string | null, subtitle?: string | null, show_support_card: boolean, safety_plan_sections_safety_plan_response_options: Array<{ __typename?: 'safety_plan_response_options', display_order: number, id: any, response_text?: string | null, category_id: any, checklist_item_id?: any | null, safety_plan_section_id: any, safety_plan_response_options_safety_plan_section_category: { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null } }>, safety_plan_sections_safety_plan_checklist_items: Array<{ __typename?: 'safety_plan_checklist_items', id: any, category_id: any, section_id: any, title: string, description?: string | null, subtitle?: string | null, display_order: number }> }> };

export type GetSafetyPlanTemplateIdQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSafetyPlanTemplateIdQuery = { __typename?: 'query_root', safety_plan_template: Array<{ __typename?: 'safety_plan_template', id: any, name: string, plan_type: Enum_Safety_Plan_Type_Enum }> };

export type GetClientMobileDeviceDetailsQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetClientMobileDeviceDetailsQuery = { __typename?: 'query_root', mobile_device_data: Array<{ __typename?: 'mobile_device_data', os_version: string, device_model: string, device_make: string, created_at: any, app_version?: string | null, user: { __typename?: 'users', notification_time?: any | null }, devicePermissionsByUser: Array<{ __typename?: 'mobile_permissions', permission_status: Enum_Mobile_Permission_Status_Enum, permission_type: Enum_Mobile_Permission_Type_Enum, created_at: any, id: any }> }> };

export type GetOrganizationAiMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationAiMembersQuery = { __typename?: 'query_root', organization_features: Array<{ __typename?: 'organization_features', org_id: number, ai_services_org_members?: any | null }> };

export type GetSafetyPlanSectionsWithQueryVariables = Exact<{
  template_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetSafetyPlanSectionsWithQuery = { __typename?: 'query_root', safety_plan_sections: Array<{ __typename?: 'safety_plan_sections', safety_plan_template_id: any, description?: string | null, display_order: number, header: string, help_text?: string | null, id: any, icon?: Enum_Safety_Plan_Section_Icons_Enum | null, icon_color?: string | null, header_image_path?: string | null, subtitle?: string | null, show_support_card: boolean, safety_plan_sections_safety_plan_response_options: Array<{ __typename?: 'safety_plan_response_options', display_order: number, id: any, response_text?: string | null, category_id: any, checklist_item_id?: any | null, safety_plan_section_id: any, safety_plan_response_options_safety_plan_section_category: { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null } }>, safety_plan_sections_safety_plan_checklist_items: Array<{ __typename?: 'safety_plan_checklist_items', id: any, category_id: any, section_id: any, title: string, description?: string | null, subtitle?: string | null, display_order: number }> }> };

export type GetSafetyPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSafetyPlansQuery = { __typename?: 'query_root', safety_plan: Array<{ __typename?: 'safety_plan', user_id: any, created_at: any, id: any, safety_plan_template_id: any, status: Enum_Safety_Plan_Status_Enum, status_changed_at: any, updated_at: any, updated_by: any, responses: any }> };

export type GetLastSafetyChecklistRecipientsLogByRecipientQueryVariables = Exact<{
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLastSafetyChecklistRecipientsLogByRecipientQuery = { __typename?: 'query_root', safety_checklist_recipients_log: Array<{ __typename?: 'safety_checklist_recipients_log', id: any, user_id: any, created_at: any, email_address: string }> };

export type GetActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivitiesQuery = { __typename?: 'query_root', activity: Array<{ __typename?: 'activity', id: any, category: Enum_Activity_Category_Enum, sub_category_id: any, display_name: string, description: string, icon_uri?: string | null, header_uri?: string | null, created_at: any, updated_at: any, display_order?: number | null }> };

export type GetActivitySubCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivitySubCategoriesQuery = { __typename?: 'query_root', activity_sub_category: Array<{ __typename?: 'activity_sub_category', id: any, display_name: string, description: string, icon?: string | null }> };

export type GetActivityResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityResourcesQuery = { __typename?: 'query_root', activity_resource: Array<{ __typename?: 'activity_resource', id: any, display_name?: string | null, description?: string | null, uri: string, activity_id: any, activity_resource_category_id: any, created_at: any, updated_at: any }> };

export type GetQuestionnaireTakesByUserIdAndDateRangeQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  start: Scalars['timestamptz']['input'];
  end: Scalars['timestamptz']['input'];
}>;


export type GetQuestionnaireTakesByUserIdAndDateRangeQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', rating_score?: string | null, raw_score?: number | null, severity_score?: number | null, completed_at?: any | null, completion_status?: Enum_Completion_Status_Enum | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', response_text: string, response_value: number, triggers_risk_alert?: boolean | null } | null }>, questionnaireDisplayValues?: { __typename?: 'vw_questionnaire_display_values', questionnaire_id?: number | null, questionnaire_name?: string | null, display_score?: any | null, display_score_type?: string | null, scoring_display_color?: string | null, scoring_display_name?: string | null } | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', questionnaire: { __typename?: 'questionnaires', contains_risk_questions?: boolean | null, name: string, id: number } } }> };

export type GetActivityResourceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityResourceCategoriesQuery = { __typename?: 'query_root', activity_resource_category: Array<{ __typename?: 'activity_resource_category', id: any, display_name?: string | null, description?: string | null, icon_uri?: string | null, icon_name?: string | null, resource_type: Enum_Activity_Resource_Type_Enum }> };

export type GetVirasafeMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVirasafeMetricsQuery = { __typename?: 'query_root', vw_user_virasafe_metrics: Array<{ __typename?: 'vw_user_virasafe_metrics', user_id?: any | null, n_day_streak?: any | null, n_weekly_keep_me_calm?: any | null, n_weekly_keep_me_safe?: any | null, top_engaged_activity_1?: string | null, top_engaged_activity_2?: string | null, top_engaged_activity_3?: string | null, top_engaged_activity_4?: string | null, least_distressed_activity_1?: string | null, least_distressed_activity_2?: string | null, least_distressed_activity_3?: string | null }> };

export type ImportNudgeTakesAfterQueryVariables = Exact<{
  scheduled_at?: InputMaybe<Scalars['timestamp']['input']>;
}>;


export type ImportNudgeTakesAfterQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, practitioner_id: any, message: string, user: { __typename?: 'users', id: any }, nudge: { __typename?: 'nudges', id: number, resource_id?: number | null, domain: string, resource?: { __typename?: 'resources', id: number, author?: string | null, content: string, header_image?: string | null, content_type: Enum_Insight_Content_Type_Enum, title?: string | null, updated_on: any } | null } } }> };

export type GetSuperviseesBySupervisorIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetSuperviseesBySupervisorIdQuery = { __typename?: 'query_root', organization_supervisors: Array<{ __typename?: 'organization_supervisors', id: any, organization_supervisors_organization_supervisees: Array<{ __typename?: 'organization_supervisees', started_at?: any | null, supervisees: { __typename?: 'users', first_name?: string | null, last_name?: string | null, display_name?: string | null, id: any } }>, supervisor: { __typename?: 'users', first_name?: string | null, last_name?: string | null, display_name?: string | null, id: any } }> };

export type GetSupervisorsByOrgIdQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSupervisorsByOrgIdQuery = { __typename?: 'query_root', organization_supervisors: Array<{ __typename?: 'organization_supervisors', id: any, organization_supervisors_organization_supervisees: Array<{ __typename?: 'organization_supervisees', supervisees: { __typename?: 'users', first_name?: string | null, last_name?: string | null, display_name?: string | null, id: any } }>, supervisor: { __typename?: 'users', first_name?: string | null, last_name?: string | null, display_name?: string | null, id: any } }> };

export type GetInviteCodeByClientAndPractitionerQueryVariables = Exact<{
  client_id: Scalars['uuid']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type GetInviteCodeByClientAndPractitionerQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', code: string, status?: string | null, client_id: any, practitioner_id?: any | null, ended_at?: any | null }> };

export type GetSchedulesForDisconnectionQueryVariables = Exact<{
  client_id: Scalars['uuid']['input'];
  practitioner_id: Scalars['uuid']['input'];
}>;


export type GetSchedulesForDisconnectionQuery = { __typename?: 'query_root', nudge_schedules: Array<{ __typename?: 'nudge_schedules', id: number }>, questionnaire_schedules: Array<{ __typename?: 'questionnaire_schedules', id: number }> };

export type GetEndedAtFromInviteCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetEndedAtFromInviteCodeQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', client_id: any, practitioner_id?: any | null, ended_at?: any | null }> };

export type GetAssessmentsWithFilterQueryVariables = Exact<{
  where?: InputMaybe<Assessments_Bool_Exp>;
}>;


export type GetAssessmentsWithFilterQuery = { __typename?: 'query_root', assessments: Array<{ __typename?: 'assessments', id: any, title: string, subtitle?: string | null, schema_version: number, first_page_id: any, assessment_length: number, created_at: any, updated_at: any, deleted_at?: any | null }> };

export type GetAssessmentPagesInAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentPagesInAssessmentQuery = { __typename?: 'query_root', assessment_pages: Array<{ __typename?: 'assessment_pages', id: any, assessment_id: any, display_order: number, show_caution_modal: boolean, created_at: any, updated_at: any }> };

export type GetAssessmentQuestionsByPageIdQueryVariables = Exact<{
  pageId: Scalars['uuid']['input'];
}>;


export type GetAssessmentQuestionsByPageIdQuery = { __typename?: 'query_root', assessment_questions: Array<{ __typename?: 'assessment_questions', id: any, page_id: any, question_type: Enum_Question_Type_Enum, display_order: number, text: string, explanation_text?: string | null, properties?: any | null, created_at: any, updated_at: any }> };

export type GetAssessmentResultsQueryVariables = Exact<{
  where: Assessment_Takes_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAssessmentResultsQuery = { __typename?: 'query_root', assessment_takes: Array<{ __typename?: 'assessment_takes', id: any, assessment_id: any, user_id: any, started_at: any, completed_at: any, answers: Array<{ __typename?: 'assessment_answers', id: any, answer: string, question_id: any, custom_prompt_id?: any | null, question: { __typename?: 'assessment_questions', id: any, question_type: Enum_Question_Type_Enum, properties?: any | null } }> }> };

export type GetPopulatedAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetPopulatedAssessmentQuery = { __typename?: 'query_root', assessments_by_pk?: { __typename?: 'assessments', updated_at: any, title: string, subtitle?: string | null, schema_version: number, id: any, first_page_id: any, assessment_length: number, deleted_at?: any | null, created_at: any, assessments_assessment_pages: Array<{ __typename?: 'assessment_pages', assessment_id: any, display_order: number, id: any, updated_at: any, show_caution_modal: boolean, created_at: any, questions: Array<{ __typename?: 'assessment_questions', display_order: number, explanation_text?: string | null, id: any, page_id: any, properties?: any | null, question_type: Enum_Question_Type_Enum, text: string, updated_at: any, created_at: any }> }> } | null };

export type GetAssessmentQuestionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetAssessmentQuestionQuery = { __typename?: 'query_root', assessment_questions_by_pk?: { __typename?: 'assessment_questions', properties?: any | null, question_type: Enum_Question_Type_Enum, text: string, updated_at: any, page_id: any, id: any, explanation_text?: string | null, display_order: number, created_at: any } | null };

export type GetAssessmentQuestionsWithIdsInQueryVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetAssessmentQuestionsWithIdsInQuery = { __typename?: 'query_root', assessment_questions: Array<{ __typename?: 'assessment_questions', created_at: any, display_order: number, explanation_text?: string | null, id: any, page_id: any, properties?: any | null, question_type: Enum_Question_Type_Enum, text: string, updated_at: any }> };

export type GetAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentsQuery = { __typename?: 'query_root', assessments: Array<{ __typename?: 'assessments', id: any, title: string, subtitle?: string | null, schema_version: number, first_page_id: any, assessment_length: number, created_at: any, updated_at: any, deleted_at?: any | null }> };

export type GetAssessmentPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentPagesQuery = { __typename?: 'query_root', assessment_pages: Array<{ __typename?: 'assessment_pages', id: any, assessment_id: any, display_order: number, show_caution_modal: boolean, created_at: any, updated_at: any }> };

export type GetAssessmentQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentQuestionsQuery = { __typename?: 'query_root', assessment_questions: Array<{ __typename?: 'assessment_questions', id: any, page_id: any, question_type: Enum_Question_Type_Enum, display_order: number, text: string, explanation_text?: string | null, properties?: any | null, created_at: any, updated_at: any }> };

export type GetAssessmentBranchingRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentBranchingRulesQuery = { __typename?: 'query_root', assessment_branching_rules: Array<{ __typename?: 'assessment_branching_rules', id: any, page_id: any, question_id: any, rule_type: string, rule_value: string, next_page_id: any, priority: number, created_at: any, updated_at: any }> };

export type GetAssessmentTakesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentTakesQuery = { __typename?: 'query_root', assessment_takes: Array<{ __typename?: 'assessment_takes', id: any, assessment_id: any, user_id: any, started_at: any, completed_at: any, created_at: any, updated_at: any }> };

export type GetAssessmentAnswersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentAnswersQuery = { __typename?: 'query_root', assessment_answers: Array<{ __typename?: 'assessment_answers', id: any, take_id: any, question_id: any, answer: string, client_created_at?: any | null, created_at: any, updated_at: any, custom_prompt_id?: any | null }> };

export type GetUserFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFeatureFlagsQuery = { __typename?: 'query_root', user_feature_flag: Array<{ __typename?: 'user_feature_flag', user_id: any, jitai_features_enabled: boolean, dbt_diary_enabled: boolean, vira_path_enabled: boolean }> };

export type GetDataFromEhrInviteCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetDataFromEhrInviteCodeQuery = { __typename?: 'query_root', ehr_client_invite_codes: Array<{ __typename?: 'ehr_client_invite_codes', user_id?: any | null, practitioner_id: any }> };

export type GetAssessmentQuestionCustomPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentQuestionCustomPromptsQuery = { __typename?: 'query_root', assessment_question_custom_prompt: Array<{ __typename?: 'assessment_question_custom_prompt', id: any, assessment_question_id: any, text: string, explanation_text?: string | null, header?: string | null, created_at: any, updated_at: any, deleted_at?: any | null }> };

export type GetAssessmentQuestionCustomPromptsByClientIdQueryVariables = Exact<{
  clientId: Scalars['uuid']['input'];
}>;


export type GetAssessmentQuestionCustomPromptsByClientIdQuery = { __typename?: 'query_root', assessment_question_custom_prompt: Array<{ __typename?: 'assessment_question_custom_prompt', id: any, assessment_question_id: any, text: string, explanation_text?: string | null, header?: string | null, client_id: any, created_at: any, updated_at: any, deleted_at?: any | null }> };

export type GetInviteCodesForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInviteCodesForCurrentUserQuery = { __typename?: 'query_root', invite_codes: Array<{ __typename?: 'invite_codes', id: number, code: string, client_id: any, practitioner_id?: any | null, status?: string | null, created_at?: any | null, ended_at?: any | null, expiration_code?: any | null }> };

export type GetLastPasswordResetTicketCreationDateTimeQueryVariables = Exact<{
  email: Scalars['citext']['input'];
}>;


export type GetLastPasswordResetTicketCreationDateTimeQuery = { __typename?: 'query_root', auth_accounts: Array<{ __typename?: 'auth_accounts', updated_at: any }> };

export type GetNudgeTakesByScheduleIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetNudgeTakesByScheduleIdQuery = { __typename?: 'query_root', nudge_takes: Array<{ __typename?: 'nudge_takes', id: number }> };

export type GetQuestionnaireTakesByScheduleIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetQuestionnaireTakesByScheduleIdQuery = { __typename?: 'query_root', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number }> };

export type GetPlanByUserIdAndTemplateNameQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  excludedStatus: Enum_Safety_Plan_Status_Enum;
  templateName: Scalars['String']['input'];
}>;


export type GetPlanByUserIdAndTemplateNameQuery = { __typename?: 'query_root', safety_plan_template: Array<{ __typename?: 'safety_plan_template', id: any, plan_type: Enum_Safety_Plan_Type_Enum, name: string, is_read_only?: boolean | null, sections: Array<{ __typename?: 'safety_plan_sections', safety_plan_template_id: any, description?: string | null, display_order: number, header: string, help_text?: string | null, id: any, icon?: Enum_Safety_Plan_Section_Icons_Enum | null, icon_color?: string | null, header_image_path?: string | null, subtitle?: string | null, show_support_card: boolean, safety_plan_sections_safety_plan_response_options: Array<{ __typename?: 'safety_plan_response_options', display_order: number, id: any, response_text?: string | null, category_id: any, checklist_item_id?: any | null, safety_plan_section_id: any, safety_plan_response_options_safety_plan_section_category: { __typename?: 'safety_plan_section_category', id: any, name: string, category_type: Enum_Safety_Plan_Section_Category_Type_Enum, display_order?: number | null, description?: string | null } }>, safety_plan_sections_safety_plan_checklist_items: Array<{ __typename?: 'safety_plan_checklist_items', id: any, category_id: any, section_id: any, title: string, description?: string | null, subtitle?: string | null, display_order: number }> }>, safety_plans: Array<{ __typename?: 'safety_plan', user_id: any, created_at: any, id: any, safety_plan_template_id: any, status: Enum_Safety_Plan_Status_Enum, status_changed_at: any, updated_at: any, updated_by: any, responses: any }> }> };

export type GetRelapsePreventionPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelapsePreventionPlacesQuery = { __typename?: 'query_root', relapse_prevention_places: Array<{ __typename?: 'relapse_prevention_places', alert_name?: string | null, description?: string | null, address?: string | null, latitude?: string | null, longitude?: string | null, media_items?: string | null, id: any, safety_plan_response_option_id: any, place_type: string, category: string, radius_meters: number, business_days?: string | null, business_hours_start?: any | null, business_hours_end?: any | null, deleted_at?: any | null }> };

export type GetRelapsePreventionPlaceVisitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelapsePreventionPlaceVisitsQuery = { __typename?: 'query_root', relapse_prevention_place_visits: Array<{ __typename?: 'relapse_prevention_place_visits', id: any, place_id: any, created_at: any, deleted_at?: any | null }> };

export type GetClientMyPlacesTrendQueryVariables = Exact<{
  clientId: Scalars['uuid']['input'];
}>;


export type GetClientMyPlacesTrendQuery = { __typename?: 'query_root', relapse_prevention_place_visits: Array<{ __typename?: 'relapse_prevention_place_visits', created_at: any, relapse_prevention_place: { __typename?: 'relapse_prevention_places', category: string, place_type: string } }> };

export type GetRelapsePreventionPlacesByUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetRelapsePreventionPlacesByUserQuery = { __typename?: 'query_root', relapse_prevention_places: Array<{ __typename?: 'relapse_prevention_places', id: any, safety_plan_response_option_id: any, place_type: string, category: string, radius_meters: number, business_days?: string | null, business_hours_start?: any | null, business_hours_end?: any | null, deleted_at?: any | null }> };

export type GetUserSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserSubscription = { __typename?: 'subscription_root', users_by_pk?: { __typename?: 'users', id: any, display_name?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, is_onboarded: boolean, notification_time?: any | null, phone_number?: string | null, most_recent_timezone?: string | null, has_derived_data: boolean, created_at: any, clientToOrganizations: Array<{ __typename?: 'vw_user_organization', user_id?: any | null, org_id?: number | null }>, account?: { __typename?: 'auth_accounts', account_providers: Array<{ __typename?: 'auth_account_providers', id: any }> } | null, client_invite_codes: Array<{ __typename?: 'invite_codes', code: string, practitioner_id?: any | null, expiration_code?: any | null }>, practitioners: Array<{ __typename?: 'invite_codes', code: string, status?: string | null, practitioner?: { __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null } | null }>, mobile_device_data: Array<{ __typename?: 'mobile_device_data', device_make: string, device_model: string, os_version: string, app_version?: string | null }> } | null };

export type GetUserScheduledItemsSubscriptionVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserScheduledItemsSubscription = { __typename?: 'subscription_root', users_by_pk?: { __typename?: 'users', questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null, is_expired?: boolean | null, questionnaire_schedule: { __typename?: 'questionnaire_schedules', id: number, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, minutes_to_expiration: number, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, questionnaire: { __typename?: 'questionnaires', id: number, name: string, public: boolean, created_by?: any | null, created_at: any, owner_org_id?: number | null, resource_id?: number | null, client_display_name: string, days_to_expiration?: number | null, contains_risk_questions?: boolean | null, minutes_to_expiration: number, questionnaire_items: Array<{ __typename?: 'questionnaire_items', id: number, question: string, display_order: number, header?: string | null, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', response: number }>, questionnaire_items_questionnaire_response_options: Array<{ __typename?: 'questionnaire_response_options', id: number, updated_at: any, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number }> }> }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, questionnaire_takes: Array<{ __typename?: 'questionnaire_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, completion_status?: Enum_Completion_Status_Enum | null }> }, questionnaire_responses: Array<{ __typename?: 'questionnaire_responses', id: number, response: number, questionnaire_item_id: number, updated_at: any, questionnaire_response_option_id?: number | null, questionnaire_item: { __typename?: 'questionnaire_items', question: string, header?: string | null, display_order: number }, questionnaire_response_options?: { __typename?: 'questionnaire_response_options', id: number, questionnaire_item_id: number, response_text: string, response_value: number, display_order: number, updated_at: any } | null }> }>, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any, nudge_schedule: { __typename?: 'nudge_schedules', id: number, message: string, one_time?: boolean | null, recurring_friday: boolean, recurring_monday: boolean, recurring_saturday: boolean, recurring_sunday: boolean, recurring_thursday: boolean, recurring_tuesday: boolean, recurring_wednesday: boolean, scheduled_at: any, practitioner_id: any, schedule_blackout_dates: Array<{ __typename?: 'schedule_blackout_dates', id: number, blackout_date?: any | null, blackout_following?: boolean | null }>, nudge: { __typename?: 'nudges', id: number, active: boolean, domain: string, technique: string, default_messaging: string, created_by?: any | null, public?: boolean | null, owner_org_id?: number | null, resource_id?: number | null, created_at: any, activity_id?: any | null, resource?: { __typename?: 'resources', author?: string | null, content: string, content_type: Enum_Insight_Content_Type_Enum, created_by?: any | null, created_on: any, header_image?: string | null, id: number, owner_org_id?: number | null, public: boolean, title?: string | null, updated_on: any } | null }, user: { __typename?: 'users', id: any, push_notification_ids: any, most_recent_timezone?: string | null }, nudge_takes: Array<{ __typename?: 'nudge_takes', id: number, created_at: any, completed_at?: any | null, scheduled_at: any }> } }> } | null };


export const PractitionerCountsFragmentDoc = `
    fragment practitionerCounts on organization_members {
  practitioner {
    id
    email: display_name
    last_name
    first_name
    account {
      user {
        organization_admins {
          organization_id
        }
        users_role_capabilities {
          role
        }
      }
    }
    client_count: practitioner_invite_codes_aggregate {
      aggregate {
        count
      }
    }
    nudge_count: nudgeSchedulesByPractitionerId_aggregate {
      aggregate {
        count
      }
    }
    questionnaire_count: questionnaireSchedulesByPractitionerId_aggregate {
      aggregate {
        count
      }
    }
    totalActiveClients: practitioner_invite_codes(
      where: {user: {is_onboarded: {_eq: true}, client_invite_codes: {status: {_eq: "connected"}}}}
    ) {
      user {
        id
      }
    }
  }
}
    `;
export const InviteCodeFragmentDoc = `
    fragment inviteCode on invite_codes {
  code
  client_id
  practitioner_id
  expiration_code
  user {
    first_name
    last_name
  }
}
    `;
export const ClientDemographicsFragmentDoc = `
    fragment ClientDemographics on client_demographics {
  id
  user_id
  practitioner_id
  created_at
  first_name
  last_name
  birth_year
  gender
  racial_ethnic
  description
}
    `;
export const UserFeatureReportFeaturesFieldsFragmentDoc = `
    fragment userFeatureReportFeaturesFields on feature_report_features {
  key
  more_less
  value
}
    `;
export const UserFeatureReportFieldsFragmentDoc = `
    fragment userFeatureReportFields on feature_reports {
  id
  outcome
  created_on
  displayable_on
  feature_report_features(order_by: {value: desc}, limit: $feature_report_limit) {
    ...userFeatureReportFeaturesFields
  }
}
    ${UserFeatureReportFeaturesFieldsFragmentDoc}`;
export const ActivityRatingFragmentDoc = `
    fragment ActivityRating on activity_rating {
  id
  client_created_at
  transaction_id
  value
  user_id
  activity_id
  activity_selected {
    id
    display_name
  }
}
    `;
export const DailyFeaturesSleepFragmentDoc = `
    fragment dailyFeaturesSleep on vw_daily_features_sleep {
  val_bedtime_offset_hour
  val_waketime_offset_hour
  feature_date
}
    `;
export const DailyFeaturesTrendFragmentDoc = `
    fragment dailyFeaturesTrend on vw_daily_features_trend {
  key
  avg_this_week
  direction
}
    `;
export const QuestionnaireItemFragmentDoc = `
    fragment QuestionnaireItem on questionnaire_items {
  id
  question
  questionnaire_responses {
    response
  }
  display_order
  header
  questionnaire_items_questionnaire_response_options {
    id
    updated_at
    questionnaire_item_id
    response_text
    response_value
    display_order
  }
}
    `;
export const QuestionnaireFragmentDoc = `
    fragment Questionnaire on questionnaires {
  id
  name
  public
  created_by
  created_at
  owner_org_id
  resource_id
  client_display_name
  days_to_expiration
  contains_risk_questions
  minutes_to_expiration
  questionnaire_items {
    id
    ...QuestionnaireItem
  }
}
    ${QuestionnaireItemFragmentDoc}`;
export const QuestionnaireScheduleFragmentDoc = `
    fragment QuestionnaireSchedule on questionnaire_schedules {
  id
  one_time
  recurring_friday
  recurring_monday
  recurring_saturday
  recurring_sunday
  recurring_thursday
  recurring_tuesday
  recurring_wednesday
  schedule_blackout_dates {
    id
    blackout_date
    blackout_following
  }
  scheduled_at
  questionnaire {
    id
    ...Questionnaire
  }
  user {
    id
    push_notification_ids
    most_recent_timezone
  }
  practitioner_id
  questionnaire_takes {
    id
    created_at
    completed_at
    scheduled_at
    completion_status
  }
  minutes_to_expiration
}
    ${QuestionnaireFragmentDoc}`;
export const QuestionnaireResponseOptionFragmentDoc = `
    fragment QuestionnaireResponseOption on questionnaire_response_options {
  id
  questionnaire_item_id
  response_text
  response_value
  display_order
  updated_at
}
    `;
export const QuestionnaireResponseFragmentDoc = `
    fragment QuestionnaireResponse on questionnaire_responses {
  id
  response
  questionnaire_item_id
  updated_at
  questionnaire_response_option_id
  questionnaire_item {
    question
    header
    display_order
  }
  questionnaire_response_options {
    ...QuestionnaireResponseOption
  }
}
    ${QuestionnaireResponseOptionFragmentDoc}`;
export const QuestionnaireTakeFragmentDoc = `
    fragment QuestionnaireTake on questionnaire_takes {
  id
  created_at
  completed_at
  scheduled_at
  completion_status
  questionnaire_schedule {
    ...QuestionnaireSchedule
  }
  questionnaire_responses {
    ...QuestionnaireResponse
  }
  is_expired
}
    ${QuestionnaireScheduleFragmentDoc}
${QuestionnaireResponseFragmentDoc}`;
export const ClientFragmentDoc = `
    fragment Client on users {
  id
  full_name
  first_name
  last_name
  phone_number
  most_recent_timezone
  display_name
  client_demographics {
    ...ClientDemographics
  }
  mood_measurements(order_by: {client_created_on: asc}) {
    id
    enjoyment
    growth
    cravings
    created_on
    client_created_on
  }
  growth_reports: feature_reports(
    order_by: {displayable_on: desc}
    where: {outcome: {_eq: GROWTH}}
    limit: 1
  ) {
    ...userFeatureReportFields
  }
  enjoy_reports: feature_reports(
    order_by: {displayable_on: desc}
    where: {outcome: {_eq: ENJOYMENT}}
    limit: 1
  ) {
    ...userFeatureReportFields
  }
  daily_features(order_by: {feature_date: desc}) {
    key
    value
    direction
    feature_date
  }
  activity_rating(
    where: {transaction_id: {_is_null: false}}
    order_by: {client_created_at: asc}
  ) {
    ...ActivityRating
  }
  vw_daily_features_sleep {
    ...dailyFeaturesSleep
  }
  vw_daily_features_trend {
    ...dailyFeaturesTrend
  }
  questionnaire_takes {
    ...QuestionnaireTake
  }
  users_user_feature_flags {
    user_id
    dbt_diary_enabled
    jitai_features_enabled
    vira_path_enabled
  }
}
    ${ClientDemographicsFragmentDoc}
${UserFeatureReportFieldsFragmentDoc}
${ActivityRatingFragmentDoc}
${DailyFeaturesSleepFragmentDoc}
${DailyFeaturesTrendFragmentDoc}
${QuestionnaireTakeFragmentDoc}`;
export const UserInviteFragmentDoc = `
    fragment UserInvite on user_invites {
  id
  first_name
  last_name
  email
  role
}
    `;
export const ResourcesFragmentDoc = `
    fragment Resources on resources {
  author
  content
  content_type
  created_by
  created_on
  header_image
  id
  owner_org_id
  public
  title
  updated_on
}
    `;
export const NudgeFragmentDoc = `
    fragment Nudge on nudges {
  id
  active
  domain
  technique
  default_messaging
  created_by
  public
  active
  owner_org_id
  resource_id
  created_at
  activity_id
  resource {
    ...Resources
  }
}
    ${ResourcesFragmentDoc}`;
export const NudgeScheduleFragmentDoc = `
    fragment NudgeSchedule on nudge_schedules {
  id
  message
  one_time
  recurring_friday
  recurring_monday
  recurring_saturday
  recurring_sunday
  recurring_thursday
  recurring_tuesday
  recurring_wednesday
  schedule_blackout_dates {
    id
    blackout_date
    blackout_following
  }
  scheduled_at
  nudge {
    id
    ...Nudge
  }
  practitioner_id
  user {
    id
    push_notification_ids
    most_recent_timezone
  }
  nudge_takes {
    id
    created_at
    completed_at
    scheduled_at
  }
}
    ${NudgeFragmentDoc}`;
export const NudgeTakeFragmentDoc = `
    fragment NudgeTake on nudge_takes {
  id
  created_at
  completed_at
  scheduled_at
  nudge_schedule {
    ...NudgeSchedule
  }
}
    ${NudgeScheduleFragmentDoc}`;
export const OrganizationMemberClientFragmentDoc = `
    fragment OrganizationMemberClient on invite_codes {
  user {
    id
    created_at
    nudge_takes {
      ...NudgeTake
    }
    questionnaire_takes {
      ...QuestionnaireTake
    }
  }
}
    ${NudgeTakeFragmentDoc}
${QuestionnaireTakeFragmentDoc}`;
export const OrganizationMemberFragmentDoc = `
    fragment OrganizationMember on organization_members {
  practitioner {
    id
    full_name
    first_name
    last_name
    display_name
    account {
      default_role
    }
    organization_admins {
      organization_id
    }
    practitioner_invite_codes {
      ...OrganizationMemberClient
    }
  }
}
    ${OrganizationMemberClientFragmentDoc}`;
export const OrganizationFragmentDoc = `
    fragment Organization on organizations {
  id
  name
  location
  user_invites(where: {status: {_eq: "pending"}}) {
    ...UserInvite
  }
  organization_members {
    ...OrganizationMember
  }
}
    ${UserInviteFragmentDoc}
${OrganizationMemberFragmentDoc}`;
export const PractitionerFragmentDoc = `
    fragment Practitioner on users {
  id
  full_name
  first_name
  last_name
  display_name
  account {
    default_role
  }
  organization_admins {
    organization_id
  }
  practitioner_invite_codes {
    ...OrganizationMemberClient
  }
}
    ${OrganizationMemberClientFragmentDoc}`;
export const MobileDeviceDataFragmentDoc = `
    fragment MobileDeviceData on mobile_device_data {
  device_make
  device_model
  os_version
  app_version
}
    `;
export const MobileUserFragmentDoc = `
    fragment MobileUser on users {
  id
  display_name
  full_name
  first_name
  last_name
  is_onboarded
  clientToOrganizations {
    user_id
    org_id
  }
  notification_time
  phone_number
  most_recent_timezone
  account {
    account_providers {
      id
    }
  }
  client_invite_codes(
    where: {practitioner_id: {_is_null: true}, expiration_code: {_is_null: true}}
  ) {
    code
    practitioner_id
    expiration_code
  }
  practitioners: client_invite_codes(
    where: {practitioner_id: {_is_null: false}, code: {_neq: "disconnected_acknowledged"}}
  ) {
    code
    status
    practitioner: userByPractitionerId {
      id
      first_name
      last_name
    }
  }
  mobile_device_data {
    ...MobileDeviceData
  }
  has_derived_data
  created_at
}
    ${MobileDeviceDataFragmentDoc}`;
export const NudgeScheduleQueryFragmentDoc = `
    fragment NudgeScheduleQuery on nudge_schedules {
  id
  message
  one_time
  recurring_friday
  recurring_monday
  recurring_saturday
  recurring_sunday
  recurring_thursday
  recurring_tuesday
  recurring_wednesday
  schedule_blackout_dates(
    where: {_or: [{blackout_following: {_eq: true}}, {_and: [{_or: [{blackout_following: {_eq: false}}, {blackout_following: {_is_null: true}}]}, {blackout_date: {_gte: $blackoutDate}}]}]}
  ) {
    blackout_date
    blackout_following
  }
  scheduled_at
  nudge {
    resource_id
    activity_id
    default_messaging
  }
  user {
    id
    push_notification_ids
    most_recent_timezone
  }
  nudge_takes(where: {scheduled_at: {_gte: $startDate, _lte: $endDate}}) {
    scheduled_at
  }
}
    `;
export const QuestionnaireScheduleQueryFragmentDoc = `
    fragment QuestionnaireScheduleQuery on questionnaire_schedules {
  id
  one_time
  recurring_friday
  recurring_monday
  recurring_saturday
  recurring_sunday
  recurring_thursday
  recurring_tuesday
  recurring_wednesday
  schedule_blackout_dates(
    where: {_or: [{blackout_following: {_eq: true}}, {_and: [{_or: [{blackout_following: {_eq: false}}, {blackout_following: {_is_null: true}}]}, {blackout_date: {_gte: $blackoutDate}}]}]}
  ) {
    blackout_date
    blackout_following
  }
  scheduled_at
  user {
    id
    push_notification_ids
    most_recent_timezone
  }
  questionnaire_takes(where: {scheduled_at: {_gte: $startDate, _lte: $endDate}}) {
    scheduled_at
  }
  notify_connected_practitioners
}
    `;
export const SafetyPlanSectionCategoryFragmentDoc = `
    fragment SafetyPlanSectionCategory on safety_plan_section_category {
  id
  name
  category_type
  display_order
  description
}
    `;
export const SafetyPlanResponseOptionsFragmentDoc = `
    fragment SafetyPlanResponseOptions on safety_plan_response_options {
  display_order
  id
  response_text
  category_id
  checklist_item_id
  safety_plan_response_options_safety_plan_section_category {
    ...SafetyPlanSectionCategory
  }
  safety_plan_section_id
}
    ${SafetyPlanSectionCategoryFragmentDoc}`;
export const SafetyPlanChecklistItemsFragmentDoc = `
    fragment SafetyPlanChecklistItems on safety_plan_checklist_items {
  id
  category_id
  section_id
  title
  description
  subtitle
  display_order
}
    `;
export const SafetyPlanSectionsFragmentDoc = `
    fragment SafetyPlanSections on safety_plan_sections {
  description
  display_order
  header
  help_text
  id
  icon
  icon_color
  header_image_path
  subtitle
  show_support_card
  safety_plan_sections_safety_plan_response_options {
    ...SafetyPlanResponseOptions
  }
  safety_plan_sections_safety_plan_checklist_items {
    ...SafetyPlanChecklistItems
  }
}
    ${SafetyPlanResponseOptionsFragmentDoc}
${SafetyPlanChecklistItemsFragmentDoc}`;
export const MobilePermissionsFragmentDoc = `
    fragment MobilePermissions on mobile_permissions {
  user_id
  permission_type
  permission_status
  client_created_at
}
    `;
export const AssessmentFragmentDoc = `
    fragment Assessment on assessments {
  id
  title
  subtitle
  schema_version
  first_page_id
  assessment_length
  created_at
  updated_at
  deleted_at
}
    `;
export const AssessmentPageFragmentDoc = `
    fragment AssessmentPage on assessment_pages {
  id
  assessment_id
  display_order
  show_caution_modal
  created_at
  updated_at
}
    `;
export const AssessmentQuestionFragmentDoc = `
    fragment AssessmentQuestion on assessment_questions {
  id
  page_id
  question_type
  display_order
  text
  explanation_text
  properties
  created_at
  updated_at
}
    `;
export const AssessmentBranchingRuleFragmentDoc = `
    fragment AssessmentBranchingRule on assessment_branching_rules {
  id
  page_id
  question_id
  rule_type
  rule_value
  next_page_id
  priority
  created_at
  updated_at
}
    `;
export const AssessmentTakeFragmentDoc = `
    fragment AssessmentTake on assessment_takes {
  id
  assessment_id
  user_id
  started_at
  completed_at
  created_at
  updated_at
}
    `;
export const AssessmentAnswerFragmentDoc = `
    fragment AssessmentAnswer on assessment_answers {
  id
  take_id
  question_id
  answer
  client_created_at
  created_at
  updated_at
  custom_prompt_id
}
    `;
export const RelapsePreventionPlaceFragmentDoc = `
    fragment RelapsePreventionPlace on relapse_prevention_places {
  id
  safety_plan_response_option_id
  place_type
  category
  radius_meters
  business_days
  business_hours_start
  business_hours_end
  deleted_at
}
    `;
export const RelapsePreventionPlaceVisitFragmentDoc = `
    fragment RelapsePreventionPlaceVisit on relapse_prevention_place_visits {
  id
  place_id
  created_at
  deleted_at
}
    `;
export const RecordUserMoodMeasurementDocument = `
    mutation RecordUserMoodMeasurement($enjoyment: Int!, $growth: Int, $cravings: Int, $user_id: uuid!, $client_created_on: String!) {
  insert_mood_measurements_one(
    object: {enjoyment: $enjoyment, growth: $growth, cravings: $cravings, user_id: $user_id, client_created_on: $client_created_on}
    on_conflict: {constraint: mood_measurements_client_created_on_user_id_key, update_columns: []}
  ) {
    enjoyment
    growth
    cravings
    user_id
    created_on
    client_created_on
    id
  }
}
    `;

export const useRecordUserMoodMeasurementMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RecordUserMoodMeasurementMutation, TError, RecordUserMoodMeasurementMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RecordUserMoodMeasurementMutation, TError, RecordUserMoodMeasurementMutationVariables, TContext>(
      {
    mutationKey: ['RecordUserMoodMeasurement'],
    mutationFn: (variables?: RecordUserMoodMeasurementMutationVariables) => fetcher<RecordUserMoodMeasurementMutation, RecordUserMoodMeasurementMutationVariables>(client, RecordUserMoodMeasurementDocument, variables, headers)(),
    ...options
  }
    )};

export const OnboardUserDocument = `
    mutation OnboardUser($userId: uuid!, $is_onboarded: Boolean = true) {
  update_users(where: {id: {_eq: $userId}}, _set: {is_onboarded: $is_onboarded}) {
    affected_rows
    returning {
      id
    }
  }
}
    `;

export const useOnboardUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<OnboardUserMutation, TError, OnboardUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<OnboardUserMutation, TError, OnboardUserMutationVariables, TContext>(
      {
    mutationKey: ['OnboardUser'],
    mutationFn: (variables?: OnboardUserMutationVariables) => fetcher<OnboardUserMutation, OnboardUserMutationVariables>(client, OnboardUserDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserFullNameDocument = `
    mutation UpdateUserFullName($userId: uuid!, $fullName: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {full_name: $fullName}) {
    id
  }
}
    `;

export const useUpdateUserFullNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserFullNameMutation, TError, UpdateUserFullNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserFullNameMutation, TError, UpdateUserFullNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserFullName'],
    mutationFn: (variables?: UpdateUserFullNameMutationVariables) => fetcher<UpdateUserFullNameMutation, UpdateUserFullNameMutationVariables>(client, UpdateUserFullNameDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserEmailDocument = `
    mutation UpdateUserEmail($userId: uuid!, $email: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {display_name: $email}) {
    id
    display_name
  }
}
    `;

export const useUpdateUserEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserEmailMutation, TError, UpdateUserEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserEmailMutation, TError, UpdateUserEmailMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserEmail'],
    mutationFn: (variables?: UpdateUserEmailMutationVariables) => fetcher<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>(client, UpdateUserEmailDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserNotificationTimeDocument = `
    mutation UpdateUserNotificationTime($userId: uuid!, $notificationTime: timestamptz!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {notification_time: $notificationTime}
  ) {
    id
    notification_time
  }
}
    `;

export const useUpdateUserNotificationTimeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserNotificationTimeMutation, TError, UpdateUserNotificationTimeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserNotificationTimeMutation, TError, UpdateUserNotificationTimeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserNotificationTime'],
    mutationFn: (variables?: UpdateUserNotificationTimeMutationVariables) => fetcher<UpdateUserNotificationTimeMutation, UpdateUserNotificationTimeMutationVariables>(client, UpdateUserNotificationTimeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertInviteCodeDocument = `
    mutation InsertInviteCode($client_id: uuid!, $code: String!) {
  insert_invite_codes_one(object: {client_id: $client_id, code: $code}) {
    id
    code
  }
}
    `;

export const useInsertInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertInviteCodeMutation, TError, InsertInviteCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertInviteCodeMutation, TError, InsertInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['InsertInviteCode'],
    mutationFn: (variables?: InsertInviteCodeMutationVariables) => fetcher<InsertInviteCodeMutation, InsertInviteCodeMutationVariables>(client, InsertInviteCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateInviteCodeDocument = `
    mutation UpdateInviteCode($code: String!, $practitioner_id: uuid!) {
  update_invite_codes(
    where: {code: {_eq: $code}, practitioner_id: {_is_null: true}}
    _set: {practitioner_id: $practitioner_id, status: "pending"}
  ) {
    returning {
      ...inviteCode
    }
  }
}
    ${InviteCodeFragmentDoc}`;

export const useUpdateInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInviteCodeMutation, TError, UpdateInviteCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateInviteCodeMutation, TError, UpdateInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInviteCode'],
    mutationFn: (variables?: UpdateInviteCodeMutationVariables) => fetcher<UpdateInviteCodeMutation, UpdateInviteCodeMutationVariables>(client, UpdateInviteCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteInviteCodeDocument = `
    mutation DeleteInviteCode($practitioner_id: uuid!, $client_id: uuid!) {
  delete_invite_codes(
    where: {practitioner_id: {_eq: $practitioner_id}, client_id: {_eq: $client_id}}
  ) {
    affected_rows
    returning {
      code
    }
  }
}
    `;

export const useDeleteInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInviteCodeMutation, TError, DeleteInviteCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteInviteCodeMutation, TError, DeleteInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['DeleteInviteCode'],
    mutationFn: (variables?: DeleteInviteCodeMutationVariables) => fetcher<DeleteInviteCodeMutation, DeleteInviteCodeMutationVariables>(client, DeleteInviteCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertDailyFeatureDocument = `
    mutation InsertDailyFeature($user_id: uuid!, $key: enum_feature_type_enum!, $value: numeric!, $direction: enum_trend_direction_enum!, $feature_date: timestamptz!) {
  insert_daily_features_one(
    object: {user_id: $user_id, key: $key, value: $value, direction: $direction, feature_date: $feature_date}
  ) {
    id
  }
}
    `;

export const useInsertDailyFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertDailyFeatureMutation, TError, InsertDailyFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertDailyFeatureMutation, TError, InsertDailyFeatureMutationVariables, TContext>(
      {
    mutationKey: ['InsertDailyFeature'],
    mutationFn: (variables?: InsertDailyFeatureMutationVariables) => fetcher<InsertDailyFeatureMutation, InsertDailyFeatureMutationVariables>(client, InsertDailyFeatureDocument, variables, headers)(),
    ...options
  }
    )};

export const ScheduleNudgeDocument = `
    mutation ScheduleNudge($nudge_id: Int!, $practitioner_id: uuid!, $user_id: uuid!, $message: String!, $one_time: Boolean, $scheduled_at: timestamp!, $recurring_monday: Boolean, $recurring_sunday: Boolean, $recurring_tuesday: Boolean, $recurring_wednesday: Boolean, $recurring_thursday: Boolean, $recurring_friday: Boolean, $recurring_saturday: Boolean) {
  insert_nudge_schedules_one(
    object: {nudge_id: $nudge_id, practitioner_id: $practitioner_id, user_id: $user_id, message: $message, scheduled_at: $scheduled_at, one_time: $one_time, recurring_sunday: $recurring_sunday, recurring_monday: $recurring_monday, recurring_tuesday: $recurring_tuesday, recurring_wednesday: $recurring_wednesday, recurring_thursday: $recurring_thursday, recurring_friday: $recurring_friday, recurring_saturday: $recurring_saturday}
  ) {
    id
  }
}
    `;

export const useScheduleNudgeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ScheduleNudgeMutation, TError, ScheduleNudgeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ScheduleNudgeMutation, TError, ScheduleNudgeMutationVariables, TContext>(
      {
    mutationKey: ['ScheduleNudge'],
    mutationFn: (variables?: ScheduleNudgeMutationVariables) => fetcher<ScheduleNudgeMutation, ScheduleNudgeMutationVariables>(client, ScheduleNudgeDocument, variables, headers)(),
    ...options
  }
    )};

export const ScheduleQuestionnaireDocument = `
    mutation ScheduleQuestionnaire($questionnaire_id: Int!, $practitioner_id: uuid!, $user_id: uuid!, $scheduled_at: timestamp!, $one_time: Boolean, $recurring_monday: Boolean, $recurring_sunday: Boolean, $recurring_tuesday: Boolean, $recurring_wednesday: Boolean, $recurring_thursday: Boolean, $recurring_friday: Boolean, $recurring_saturday: Boolean, $minutes_to_expiration: Int!, $notify_connected_practitioners: timestamp) {
  insert_questionnaire_schedules_one(
    object: {questionnaire_id: $questionnaire_id, practitioner_id: $practitioner_id, user_id: $user_id, scheduled_at: $scheduled_at, one_time: $one_time, recurring_sunday: $recurring_sunday, recurring_monday: $recurring_monday, recurring_tuesday: $recurring_tuesday, recurring_wednesday: $recurring_wednesday, recurring_thursday: $recurring_thursday, recurring_friday: $recurring_friday, recurring_saturday: $recurring_saturday, minutes_to_expiration: $minutes_to_expiration, notify_connected_practitioners: $notify_connected_practitioners}
  ) {
    id
  }
}
    `;

export const useScheduleQuestionnaireMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ScheduleQuestionnaireMutation, TError, ScheduleQuestionnaireMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ScheduleQuestionnaireMutation, TError, ScheduleQuestionnaireMutationVariables, TContext>(
      {
    mutationKey: ['ScheduleQuestionnaire'],
    mutationFn: (variables?: ScheduleQuestionnaireMutationVariables) => fetcher<ScheduleQuestionnaireMutation, ScheduleQuestionnaireMutationVariables>(client, ScheduleQuestionnaireDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteNudgeScheduleByIdDocument = `
    mutation DeleteNudgeScheduleById($id: Int!) {
  delete_nudge_schedules_by_pk(id: $id) {
    ...NudgeSchedule
  }
  delete_schedule_blackout_dates(where: {nudge_schedules_id: {_eq: $id}}) {
    affected_rows
  }
}
    ${NudgeScheduleFragmentDoc}`;

export const useDeleteNudgeScheduleByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteNudgeScheduleByIdMutation, TError, DeleteNudgeScheduleByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteNudgeScheduleByIdMutation, TError, DeleteNudgeScheduleByIdMutationVariables, TContext>(
      {
    mutationKey: ['DeleteNudgeScheduleById'],
    mutationFn: (variables?: DeleteNudgeScheduleByIdMutationVariables) => fetcher<DeleteNudgeScheduleByIdMutation, DeleteNudgeScheduleByIdMutationVariables>(client, DeleteNudgeScheduleByIdDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteQuestionnaireScheduleByIdDocument = `
    mutation DeleteQuestionnaireScheduleById($id: Int!) {
  delete_questionnaire_schedules_by_pk(id: $id) {
    ...QuestionnaireSchedule
  }
  delete_schedule_blackout_dates(where: {questionnaire_schedules_id: {_eq: $id}}) {
    affected_rows
  }
}
    ${QuestionnaireScheduleFragmentDoc}`;

export const useDeleteQuestionnaireScheduleByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteQuestionnaireScheduleByIdMutation, TError, DeleteQuestionnaireScheduleByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteQuestionnaireScheduleByIdMutation, TError, DeleteQuestionnaireScheduleByIdMutationVariables, TContext>(
      {
    mutationKey: ['DeleteQuestionnaireScheduleById'],
    mutationFn: (variables?: DeleteQuestionnaireScheduleByIdMutationVariables) => fetcher<DeleteQuestionnaireScheduleByIdMutation, DeleteQuestionnaireScheduleByIdMutationVariables>(client, DeleteQuestionnaireScheduleByIdDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireResponseDocument = `
    mutation InsertQuestionnaireResponse($questionnaire_item_id: Int!, $questionnaire_take_id: Int!, $questionnaire_response_option_id: Int, $response: Int!) {
  insert_questionnaire_responses_one(
    object: {questionnaire_item_id: $questionnaire_item_id, questionnaire_take_id: $questionnaire_take_id, questionnaire_response_option_id: $questionnaire_response_option_id, response: $response}
    on_conflict: {constraint: questionnaire_responses_questionnaire_item_id_questionnaire_tak, update_columns: []}
  ) {
    id
    questionnaire_item_id
    questionnaire_take_id
    questionnaire_response_option_id
  }
}
    `;

export const useInsertQuestionnaireResponseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireResponseMutation, TError, InsertQuestionnaireResponseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireResponseMutation, TError, InsertQuestionnaireResponseMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaireResponse'],
    mutationFn: (variables?: InsertQuestionnaireResponseMutationVariables) => fetcher<InsertQuestionnaireResponseMutation, InsertQuestionnaireResponseMutationVariables>(client, InsertQuestionnaireResponseDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateQuestionnaireResponseByIdDocument = `
    mutation UpdateQuestionnaireResponseById($id: Int!, $response: Int!) {
  update_questionnaire_responses_by_pk(
    pk_columns: {id: $id}
    _set: {response: $response}
  ) {
    id
  }
}
    `;

export const useUpdateQuestionnaireResponseByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateQuestionnaireResponseByIdMutation, TError, UpdateQuestionnaireResponseByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateQuestionnaireResponseByIdMutation, TError, UpdateQuestionnaireResponseByIdMutationVariables, TContext>(
      {
    mutationKey: ['UpdateQuestionnaireResponseById'],
    mutationFn: (variables?: UpdateQuestionnaireResponseByIdMutationVariables) => fetcher<UpdateQuestionnaireResponseByIdMutation, UpdateQuestionnaireResponseByIdMutationVariables>(client, UpdateQuestionnaireResponseByIdDocument, variables, headers)(),
    ...options
  }
    )};

export const CompleteQuestionnaireDocument = `
    mutation CompleteQuestionnaire($questionnaire_take_id: Int!, $completed_at: timestamptz!, $is_expired: Boolean!) {
  update_questionnaire_takes_by_pk(
    pk_columns: {id: $questionnaire_take_id}
    _set: {completed_at: $completed_at, is_expired: $is_expired}
  ) {
    id
  }
}
    `;

export const useCompleteQuestionnaireMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteQuestionnaireMutation, TError, CompleteQuestionnaireMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CompleteQuestionnaireMutation, TError, CompleteQuestionnaireMutationVariables, TContext>(
      {
    mutationKey: ['CompleteQuestionnaire'],
    mutationFn: (variables?: CompleteQuestionnaireMutationVariables) => fetcher<CompleteQuestionnaireMutation, CompleteQuestionnaireMutationVariables>(client, CompleteQuestionnaireDocument, variables, headers)(),
    ...options
  }
    )};

export const CompleteNudgeDocument = `
    mutation CompleteNudge($nudge_take_id: Int!, $completed_at: timestamptz!) {
  update_nudge_takes_by_pk(
    pk_columns: {id: $nudge_take_id}
    _set: {completed_at: $completed_at}
  ) {
    id
  }
}
    `;

export const useCompleteNudgeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteNudgeMutation, TError, CompleteNudgeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CompleteNudgeMutation, TError, CompleteNudgeMutationVariables, TContext>(
      {
    mutationKey: ['CompleteNudge'],
    mutationFn: (variables?: CompleteNudgeMutationVariables) => fetcher<CompleteNudgeMutation, CompleteNudgeMutationVariables>(client, CompleteNudgeDocument, variables, headers)(),
    ...options
  }
    )};

export const EditScheduledNudgeDocument = `
    mutation EditScheduledNudge($id: Int!, $message: String!, $nudge_id: Int!, $scheduled_at: timestamp!, $one_time: Boolean, $recurring_friday: Boolean, $recurring_monday: Boolean, $recurring_saturday: Boolean, $recurring_sunday: Boolean, $recurring_thursday: Boolean, $recurring_tuesday: Boolean, $recurring_wednesday: Boolean) {
  update_nudge_schedules_by_pk(
    pk_columns: {id: $id}
    _set: {message: $message, nudge_id: $nudge_id, scheduled_at: $scheduled_at, one_time: $one_time, recurring_friday: $recurring_friday, recurring_monday: $recurring_monday, recurring_saturday: $recurring_saturday, recurring_sunday: $recurring_sunday, recurring_thursday: $recurring_thursday, recurring_tuesday: $recurring_tuesday, recurring_wednesday: $recurring_wednesday}
  ) {
    id
  }
}
    `;

export const useEditScheduledNudgeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditScheduledNudgeMutation, TError, EditScheduledNudgeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EditScheduledNudgeMutation, TError, EditScheduledNudgeMutationVariables, TContext>(
      {
    mutationKey: ['EditScheduledNudge'],
    mutationFn: (variables?: EditScheduledNudgeMutationVariables) => fetcher<EditScheduledNudgeMutation, EditScheduledNudgeMutationVariables>(client, EditScheduledNudgeDocument, variables, headers)(),
    ...options
  }
    )};

export const EditScheduledQuestionnaireDocument = `
    mutation EditScheduledQuestionnaire($id: Int!, $questionnaire_id: Int!, $scheduled_at: timestamp!, $one_time: Boolean, $recurring_friday: Boolean, $recurring_monday: Boolean, $recurring_saturday: Boolean, $recurring_sunday: Boolean, $recurring_thursday: Boolean, $recurring_tuesday: Boolean, $recurring_wednesday: Boolean, $minutes_to_expiration: Int = 10, $notify_connected_practitioners: timestamp) {
  update_questionnaire_schedules_by_pk(
    pk_columns: {id: $id}
    _set: {one_time: $one_time, questionnaire_id: $questionnaire_id, scheduled_at: $scheduled_at, recurring_friday: $recurring_friday, recurring_monday: $recurring_monday, recurring_saturday: $recurring_saturday, recurring_sunday: $recurring_sunday, recurring_thursday: $recurring_thursday, recurring_tuesday: $recurring_tuesday, recurring_wednesday: $recurring_wednesday, minutes_to_expiration: $minutes_to_expiration, notify_connected_practitioners: $notify_connected_practitioners}
  ) {
    id
  }
}
    `;

export const useEditScheduledQuestionnaireMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditScheduledQuestionnaireMutation, TError, EditScheduledQuestionnaireMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EditScheduledQuestionnaireMutation, TError, EditScheduledQuestionnaireMutationVariables, TContext>(
      {
    mutationKey: ['EditScheduledQuestionnaire'],
    mutationFn: (variables?: EditScheduledQuestionnaireMutationVariables) => fetcher<EditScheduledQuestionnaireMutation, EditScheduledQuestionnaireMutationVariables>(client, EditScheduledQuestionnaireDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertBlackoutDateDocument = `
    mutation InsertBlackoutDate($blackout_date: date!, $blackout_following: Boolean, $nudge_schedules_id: Int, $questionnaire_schedules_id: Int) {
  insert_schedule_blackout_dates_one(
    object: {blackout_date: $blackout_date, blackout_following: $blackout_following, nudge_schedules_id: $nudge_schedules_id, questionnaire_schedules_id: $questionnaire_schedules_id}
  ) {
    id
  }
}
    `;

export const useInsertBlackoutDateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertBlackoutDateMutation, TError, InsertBlackoutDateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertBlackoutDateMutation, TError, InsertBlackoutDateMutationVariables, TContext>(
      {
    mutationKey: ['InsertBlackoutDate'],
    mutationFn: (variables?: InsertBlackoutDateMutationVariables) => fetcher<InsertBlackoutDateMutation, InsertBlackoutDateMutationVariables>(client, InsertBlackoutDateDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserPushNotificationIdsDocument = `
    mutation UpdateUserPushNotificationIds($id: uuid!, $push_notification_ids: jsonb) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {push_notification_ids: $push_notification_ids}
  ) {
    push_notification_ids
  }
}
    `;

export const useUpdateUserPushNotificationIdsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserPushNotificationIdsMutation, TError, UpdateUserPushNotificationIdsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserPushNotificationIdsMutation, TError, UpdateUserPushNotificationIdsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserPushNotificationIds'],
    mutationFn: (variables?: UpdateUserPushNotificationIdsMutationVariables) => fetcher<UpdateUserPushNotificationIdsMutation, UpdateUserPushNotificationIdsMutationVariables>(client, UpdateUserPushNotificationIdsDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertNudgeTakeDocument = `
    mutation InsertNudgeTake($userId: uuid!, $nudgeScheduleId: Int!, $nudgeScheduledAt: timestamp) {
  insert_nudge_takes_one(
    object: {user_id: $userId, nudge_schedule_id: $nudgeScheduleId, scheduled_at: $nudgeScheduledAt}
  ) {
    ...NudgeTake
  }
}
    ${NudgeTakeFragmentDoc}`;

export const useInsertNudgeTakeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertNudgeTakeMutation, TError, InsertNudgeTakeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertNudgeTakeMutation, TError, InsertNudgeTakeMutationVariables, TContext>(
      {
    mutationKey: ['InsertNudgeTake'],
    mutationFn: (variables?: InsertNudgeTakeMutationVariables) => fetcher<InsertNudgeTakeMutation, InsertNudgeTakeMutationVariables>(client, InsertNudgeTakeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireTakeDocument = `
    mutation InsertQuestionnaireTake($userId: uuid!, $questionnaireScheduleId: Int!, $questionnaireScheduledAt: timestamp, $notify_connected_practitioners: timestamp!) {
  insert_questionnaire_takes_one(
    object: {user_id: $userId, questionnaire_schedule_id: $questionnaireScheduleId, scheduled_at: $questionnaireScheduledAt, notify_connected_practitioners: $notify_connected_practitioners}
  ) {
    id
  }
}
    `;

export const useInsertQuestionnaireTakeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireTakeMutation, TError, InsertQuestionnaireTakeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireTakeMutation, TError, InsertQuestionnaireTakeMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaireTake'],
    mutationFn: (variables?: InsertQuestionnaireTakeMutationVariables) => fetcher<InsertQuestionnaireTakeMutation, InsertQuestionnaireTakeMutationVariables>(client, InsertQuestionnaireTakeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertOrganizationMemberDocument = `
    mutation InsertOrganizationMember($organization_id: Int!, $practitioner_id: uuid!) {
  insert_organization_members_one(
    object: {organization_id: $organization_id, practitioner_id: $practitioner_id}
  ) {
    id
  }
}
    `;

export const useInsertOrganizationMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertOrganizationMemberMutation, TError, InsertOrganizationMemberMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertOrganizationMemberMutation, TError, InsertOrganizationMemberMutationVariables, TContext>(
      {
    mutationKey: ['InsertOrganizationMember'],
    mutationFn: (variables?: InsertOrganizationMemberMutationVariables) => fetcher<InsertOrganizationMemberMutation, InsertOrganizationMemberMutationVariables>(client, InsertOrganizationMemberDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertOrganizationAdminDocument = `
    mutation InsertOrganizationAdmin($organization_id: Int!, $practitioner_id: uuid!) {
  insert_organization_admins_one(
    object: {organization_id: $organization_id, practitioner_id: $practitioner_id}
  ) {
    id
  }
}
    `;

export const useInsertOrganizationAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertOrganizationAdminMutation, TError, InsertOrganizationAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertOrganizationAdminMutation, TError, InsertOrganizationAdminMutationVariables, TContext>(
      {
    mutationKey: ['InsertOrganizationAdmin'],
    mutationFn: (variables?: InsertOrganizationAdminMutationVariables) => fetcher<InsertOrganizationAdminMutation, InsertOrganizationAdminMutationVariables>(client, InsertOrganizationAdminDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertUserInviteDocument = `
    mutation InsertUserInvite($first_name: String!, $last_name: String!, $email: String!, $role: String = "", $status: String!, $organization_id: Int!) {
  insert_user_invites_one(
    object: {first_name: $first_name, last_name: $last_name, email: $email, role: $role, status: $status, organization_id: $organization_id}
  ) {
    id
  }
}
    `;

export const useInsertUserInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertUserInviteMutation, TError, InsertUserInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertUserInviteMutation, TError, InsertUserInviteMutationVariables, TContext>(
      {
    mutationKey: ['InsertUserInvite'],
    mutationFn: (variables?: InsertUserInviteMutationVariables) => fetcher<InsertUserInviteMutation, InsertUserInviteMutationVariables>(client, InsertUserInviteDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserInviteStatusDocument = `
    mutation UpdateUserInviteStatus($id: Int!, $status: String!) {
  update_user_invites_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
  }
}
    `;

export const useUpdateUserInviteStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserInviteStatusMutation, TError, UpdateUserInviteStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserInviteStatusMutation, TError, UpdateUserInviteStatusMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserInviteStatus'],
    mutationFn: (variables?: UpdateUserInviteStatusMutationVariables) => fetcher<UpdateUserInviteStatusMutation, UpdateUserInviteStatusMutationVariables>(client, UpdateUserInviteStatusDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserInviteDocument = `
    mutation UpdateUserInvite($id: Int!, $first_name: String!, $last_name: String!, $role: String = "", $email: String!) {
  update_user_invites_by_pk(
    pk_columns: {id: $id}
    _set: {first_name: $first_name, last_name: $last_name, role: $role, email: $email}
  ) {
    id
  }
}
    `;

export const useUpdateUserInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserInviteMutation, TError, UpdateUserInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserInviteMutation, TError, UpdateUserInviteMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserInvite'],
    mutationFn: (variables?: UpdateUserInviteMutationVariables) => fetcher<UpdateUserInviteMutation, UpdateUserInviteMutationVariables>(client, UpdateUserInviteDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateOrganizationNameDocument = `
    mutation UpdateOrganizationName($id: Int!, $name: String!) {
  update_organizations_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
  }
}
    `;

export const useUpdateOrganizationNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationNameMutation, TError, UpdateOrganizationNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateOrganizationNameMutation, TError, UpdateOrganizationNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrganizationName'],
    mutationFn: (variables?: UpdateOrganizationNameMutationVariables) => fetcher<UpdateOrganizationNameMutation, UpdateOrganizationNameMutationVariables>(client, UpdateOrganizationNameDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateOrganizationLocationDocument = `
    mutation UpdateOrganizationLocation($id: Int!, $location: String!) {
  update_organizations_by_pk(pk_columns: {id: $id}, _set: {location: $location}) {
    id
  }
}
    `;

export const useUpdateOrganizationLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationLocationMutation, TError, UpdateOrganizationLocationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateOrganizationLocationMutation, TError, UpdateOrganizationLocationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrganizationLocation'],
    mutationFn: (variables?: UpdateOrganizationLocationMutationVariables) => fetcher<UpdateOrganizationLocationMutation, UpdateOrganizationLocationMutationVariables>(client, UpdateOrganizationLocationDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdatePractitionerDocument = `
    mutation UpdatePractitioner($id: uuid!, $first_name: String!, $last_name: String!, $display_name: String!) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {display_name: $display_name, first_name: $first_name, last_name: $last_name}
  ) {
    id
  }
}
    `;

export const useUpdatePractitionerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePractitionerMutation, TError, UpdatePractitionerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdatePractitionerMutation, TError, UpdatePractitionerMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePractitioner'],
    mutationFn: (variables?: UpdatePractitionerMutationVariables) => fetcher<UpdatePractitionerMutation, UpdatePractitionerMutationVariables>(client, UpdatePractitionerDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateAccountDocument = `
    mutation UpdateAccount($userId: uuid!, $email: citext!) {
  update_auth_accounts(where: {user_id: {_eq: $userId}}, _set: {email: $email}) {
    returning {
      user_id
    }
  }
}
    `;

export const useUpdateAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAccountMutation, TError, UpdateAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateAccountMutation, TError, UpdateAccountMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAccount'],
    mutationFn: (variables?: UpdateAccountMutationVariables) => fetcher<UpdateAccountMutation, UpdateAccountMutationVariables>(client, UpdateAccountDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserTimeZoneDocument = `
    mutation UpdateUserTimeZone($userId: uuid!, $tz: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {most_recent_timezone: $tz}) {
    most_recent_timezone
  }
}
    `;

export const useUpdateUserTimeZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserTimeZoneMutation, TError, UpdateUserTimeZoneMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserTimeZoneMutation, TError, UpdateUserTimeZoneMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserTimeZone'],
    mutationFn: (variables?: UpdateUserTimeZoneMutationVariables) => fetcher<UpdateUserTimeZoneMutation, UpdateUserTimeZoneMutationVariables>(client, UpdateUserTimeZoneDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteUserInviteDocument = `
    mutation DeleteUserInvite($id: Int!) {
  delete_user_invites_by_pk(id: $id) {
    id
  }
}
    `;

export const useDeleteUserInviteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUserInviteMutation, TError, DeleteUserInviteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteUserInviteMutation, TError, DeleteUserInviteMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUserInvite'],
    mutationFn: (variables?: DeleteUserInviteMutationVariables) => fetcher<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>(client, DeleteUserInviteDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteUserInviteByEmailDocument = `
    mutation DeleteUserInviteByEmail($email: String!) {
  delete_user_invites(where: {email: {_eq: $email}}) {
    affected_rows
  }
}
    `;

export const useDeleteUserInviteByEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUserInviteByEmailMutation, TError, DeleteUserInviteByEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteUserInviteByEmailMutation, TError, DeleteUserInviteByEmailMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUserInviteByEmail'],
    mutationFn: (variables?: DeleteUserInviteByEmailMutationVariables) => fetcher<DeleteUserInviteByEmailMutation, DeleteUserInviteByEmailMutationVariables>(client, DeleteUserInviteByEmailDocument, variables, headers)(),
    ...options
  }
    )};

export const DeletePractitionerDocument = `
    mutation DeletePractitioner($id: uuid!) {
  delete_users_by_pk(id: $id) {
    id
  }
}
    `;

export const useDeletePractitionerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePractitionerMutation, TError, DeletePractitionerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeletePractitionerMutation, TError, DeletePractitionerMutationVariables, TContext>(
      {
    mutationKey: ['DeletePractitioner'],
    mutationFn: (variables?: DeletePractitionerMutationVariables) => fetcher<DeletePractitionerMutation, DeletePractitionerMutationVariables>(client, DeletePractitionerDocument, variables, headers)(),
    ...options
  }
    )};

export const DeletePractitionerByEmailDocument = `
    mutation DeletePractitionerByEmail($email: citext!) {
  delete_users(where: {account: {email: {_eq: $email}}}) {
    affected_rows
  }
}
    `;

export const useDeletePractitionerByEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePractitionerByEmailMutation, TError, DeletePractitionerByEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeletePractitionerByEmailMutation, TError, DeletePractitionerByEmailMutationVariables, TContext>(
      {
    mutationKey: ['DeletePractitionerByEmail'],
    mutationFn: (variables?: DeletePractitionerByEmailMutationVariables) => fetcher<DeletePractitionerByEmailMutation, DeletePractitionerByEmailMutationVariables>(client, DeletePractitionerByEmailDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteOrganizationAdminDocument = `
    mutation DeleteOrganizationAdmin($practitioner_id: uuid!, $organization_id: Int!) {
  delete_organization_admins(
    where: {practitioner_id: {_eq: $practitioner_id}, organization_id: {_eq: $organization_id}}
  ) {
    affected_rows
  }
}
    `;

export const useDeleteOrganizationAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrganizationAdminMutation, TError, DeleteOrganizationAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteOrganizationAdminMutation, TError, DeleteOrganizationAdminMutationVariables, TContext>(
      {
    mutationKey: ['DeleteOrganizationAdmin'],
    mutationFn: (variables?: DeleteOrganizationAdminMutationVariables) => fetcher<DeleteOrganizationAdminMutation, DeleteOrganizationAdminMutationVariables>(client, DeleteOrganizationAdminDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteOrganizationMemberDocument = `
    mutation DeleteOrganizationMember($practitioner_id: uuid!, $organization_id: Int!) {
  delete_organization_members(
    where: {practitioner_id: {_eq: $practitioner_id}, organization_id: {_eq: $organization_id}}
  ) {
    affected_rows
  }
}
    `;

export const useDeleteOrganizationMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrganizationMemberMutation, TError, DeleteOrganizationMemberMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteOrganizationMemberMutation, TError, DeleteOrganizationMemberMutationVariables, TContext>(
      {
    mutationKey: ['DeleteOrganizationMember'],
    mutationFn: (variables?: DeleteOrganizationMemberMutationVariables) => fetcher<DeleteOrganizationMemberMutation, DeleteOrganizationMemberMutationVariables>(client, DeleteOrganizationMemberDocument, variables, headers)(),
    ...options
  }
    )};

export const ActivateAccountDocument = `
    mutation ActivateAccount($email: citext!) {
  update_auth_accounts(where: {email: {_eq: $email}}, _set: {active: true}) {
    affected_rows
  }
}
    `;

export const useActivateAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ActivateAccountMutation, TError, ActivateAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ActivateAccountMutation, TError, ActivateAccountMutationVariables, TContext>(
      {
    mutationKey: ['ActivateAccount'],
    mutationFn: (variables?: ActivateAccountMutationVariables) => fetcher<ActivateAccountMutation, ActivateAccountMutationVariables>(client, ActivateAccountDocument, variables, headers)(),
    ...options
  }
    )};

export const DeactivateAccountDocument = `
    mutation DeactivateAccount($userId: uuid!) {
  update_auth_accounts(where: {user_id: {_eq: $userId}}, _set: {active: false}) {
    affected_rows
  }
}
    `;

export const useDeactivateAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeactivateAccountMutation, TError, DeactivateAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeactivateAccountMutation, TError, DeactivateAccountMutationVariables, TContext>(
      {
    mutationKey: ['DeactivateAccount'],
    mutationFn: (variables?: DeactivateAccountMutationVariables) => fetcher<DeactivateAccountMutation, DeactivateAccountMutationVariables>(client, DeactivateAccountDocument, variables, headers)(),
    ...options
  }
    )};

export const SetUserRequestedDeletionDocument = `
    mutation SetUserRequestedDeletion($userId: uuid!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {user_requested_deletion: true}
  ) {
    id
  }
}
    `;

export const useSetUserRequestedDeletionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetUserRequestedDeletionMutation, TError, SetUserRequestedDeletionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SetUserRequestedDeletionMutation, TError, SetUserRequestedDeletionMutationVariables, TContext>(
      {
    mutationKey: ['SetUserRequestedDeletion'],
    mutationFn: (variables?: SetUserRequestedDeletionMutationVariables) => fetcher<SetUserRequestedDeletionMutation, SetUserRequestedDeletionMutationVariables>(client, SetUserRequestedDeletionDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserFirstNameDocument = `
    mutation UpdateUserFirstName($userId: uuid!, $firstName: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {first_name: $firstName}) {
    id
    first_name
  }
}
    `;

export const useUpdateUserFirstNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserFirstNameMutation, TError, UpdateUserFirstNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserFirstNameMutation, TError, UpdateUserFirstNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserFirstName'],
    mutationFn: (variables?: UpdateUserFirstNameMutationVariables) => fetcher<UpdateUserFirstNameMutation, UpdateUserFirstNameMutationVariables>(client, UpdateUserFirstNameDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserLastNameDocument = `
    mutation UpdateUserLastName($userId: uuid!, $lastName: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {last_name: $lastName}) {
    id
    last_name
  }
}
    `;

export const useUpdateUserLastNameMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserLastNameMutation, TError, UpdateUserLastNameMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserLastNameMutation, TError, UpdateUserLastNameMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserLastName'],
    mutationFn: (variables?: UpdateUserLastNameMutationVariables) => fetcher<UpdateUserLastNameMutation, UpdateUserLastNameMutationVariables>(client, UpdateUserLastNameDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateUserPhoneNumberDocument = `
    mutation UpdateUserPhoneNumber($userId: uuid!, $mobile: String!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {phone_number: $mobile}) {
    id
    phone_number
  }
}
    `;

export const useUpdateUserPhoneNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserPhoneNumberMutation, TError, UpdateUserPhoneNumberMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateUserPhoneNumberMutation, TError, UpdateUserPhoneNumberMutationVariables, TContext>(
      {
    mutationKey: ['UpdateUserPhoneNumber'],
    mutationFn: (variables?: UpdateUserPhoneNumberMutationVariables) => fetcher<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables>(client, UpdateUserPhoneNumberDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertOrganizationDocument = `
    mutation InsertOrganization($name: String!, $location: String!) {
  insert_organizations_one(object: {name: $name, location: $location}) {
    id
  }
}
    `;

export const useInsertOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertOrganizationMutation, TError, InsertOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertOrganizationMutation, TError, InsertOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['InsertOrganization'],
    mutationFn: (variables?: InsertOrganizationMutationVariables) => fetcher<InsertOrganizationMutation, InsertOrganizationMutationVariables>(client, InsertOrganizationDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertFeatureReportFeatureDocument = `
    mutation InsertFeatureReportFeature($feature_report_id: Int!, $key: enum_feature_type_enum!, $value: numeric!, $more_less: enum_feature_direction_enum!) {
  insert_feature_report_features_one(
    object: {feature_report_id: $feature_report_id, key: $key, value: $value, more_less: $more_less}
  ) {
    id
  }
}
    `;

export const useInsertFeatureReportFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertFeatureReportFeatureMutation, TError, InsertFeatureReportFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertFeatureReportFeatureMutation, TError, InsertFeatureReportFeatureMutationVariables, TContext>(
      {
    mutationKey: ['InsertFeatureReportFeature'],
    mutationFn: (variables?: InsertFeatureReportFeatureMutationVariables) => fetcher<InsertFeatureReportFeatureMutation, InsertFeatureReportFeatureMutationVariables>(client, InsertFeatureReportFeatureDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertFeatureReportDocument = `
    mutation InsertFeatureReport($user_id: uuid!, $outcome: enum_outcome_enum!, $displayable_on: timestamptz!) {
  insert_feature_reports_one(
    object: {user_id: $user_id, outcome: $outcome, displayable_on: $displayable_on}
  ) {
    id
  }
}
    `;

export const useInsertFeatureReportMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertFeatureReportMutation, TError, InsertFeatureReportMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertFeatureReportMutation, TError, InsertFeatureReportMutationVariables, TContext>(
      {
    mutationKey: ['InsertFeatureReport'],
    mutationFn: (variables?: InsertFeatureReportMutationVariables) => fetcher<InsertFeatureReportMutation, InsertFeatureReportMutationVariables>(client, InsertFeatureReportDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateLastCheckInNotificationDocument = `
    mutation UpdateLastCheckInNotification($userId: uuid!, $last_check_in_notification: timestamptz!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {last_check_in_notification: $last_check_in_notification}
  ) {
    last_check_in_notification
  }
}
    `;

export const useUpdateLastCheckInNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateLastCheckInNotificationMutation, TError, UpdateLastCheckInNotificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateLastCheckInNotificationMutation, TError, UpdateLastCheckInNotificationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLastCheckInNotification'],
    mutationFn: (variables?: UpdateLastCheckInNotificationMutationVariables) => fetcher<UpdateLastCheckInNotificationMutation, UpdateLastCheckInNotificationMutationVariables>(client, UpdateLastCheckInNotificationDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateInviteCodeStatusDocument = `
    mutation UpdateInviteCodeStatus($code: String!, $status: String!) {
  update_invite_codes(where: {code: {_eq: $code}}, _set: {status: $status}) {
    returning {
      ...inviteCode
      status
    }
  }
}
    ${InviteCodeFragmentDoc}`;

export const useUpdateInviteCodeStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInviteCodeStatusMutation, TError, UpdateInviteCodeStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateInviteCodeStatusMutation, TError, UpdateInviteCodeStatusMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInviteCodeStatus'],
    mutationFn: (variables?: UpdateInviteCodeStatusMutationVariables) => fetcher<UpdateInviteCodeStatusMutation, UpdateInviteCodeStatusMutationVariables>(client, UpdateInviteCodeStatusDocument, variables, headers)(),
    ...options
  }
    )};

export const AddClientDocument = `
    mutation AddClient($code: String!, $practitioner_id: uuid!) {
  update_invite_codes(
    where: {code: {_eq: $code}}
    _set: {status: "pending", practitioner_id: $practitioner_id}
  ) {
    returning {
      ...inviteCode
    }
  }
}
    ${InviteCodeFragmentDoc}`;

export const useAddClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddClientMutation, TError, AddClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddClientMutation, TError, AddClientMutationVariables, TContext>(
      {
    mutationKey: ['AddClient'],
    mutationFn: (variables?: AddClientMutationVariables) => fetcher<AddClientMutation, AddClientMutationVariables>(client, AddClientDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdatePhoneNumberDocument = `
    mutation UpdatePhoneNumber($user_id: uuid!, $phone_number: String!) {
  update_users(where: {id: {_eq: $user_id}}, _set: {phone_number: $phone_number}) {
    affected_rows
    returning {
      phone_number
    }
  }
}
    `;

export const useUpdatePhoneNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePhoneNumberMutation, TError, UpdatePhoneNumberMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdatePhoneNumberMutation, TError, UpdatePhoneNumberMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePhoneNumber'],
    mutationFn: (variables?: UpdatePhoneNumberMutationVariables) => fetcher<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>(client, UpdatePhoneNumberDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteUserDocument = `
    mutation DeleteUser($id: uuid!) {
  delete_users_by_pk(id: $id) {
    id
  }
}
    `;

export const useDeleteUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteUserMutation, TError, DeleteUserMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUser'],
    mutationFn: (variables?: DeleteUserMutationVariables) => fetcher<DeleteUserMutation, DeleteUserMutationVariables>(client, DeleteUserDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertLogDocument = `
    mutation InsertLog($type: String!, $user_id: uuid!) {
  insert_logs_one(object: {type: $type, user_id: $user_id}) {
    id
  }
}
    `;

export const useInsertLogMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertLogMutation, TError, InsertLogMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertLogMutation, TError, InsertLogMutationVariables, TContext>(
      {
    mutationKey: ['InsertLog'],
    mutationFn: (variables?: InsertLogMutationVariables) => fetcher<InsertLogMutation, InsertLogMutationVariables>(client, InsertLogDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertMobileDeviceDataDocument = `
    mutation InsertMobileDeviceData($user_id: uuid!, $device_make: String!, $device_model: String!, $os_version: String!, $app_version: String!) {
  insert_mobile_device_data_one(
    object: {user_id: $user_id, device_make: $device_make, device_model: $device_model, os_version: $os_version, app_version: $app_version}
  ) {
    id
  }
}
    `;

export const useInsertMobileDeviceDataMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertMobileDeviceDataMutation, TError, InsertMobileDeviceDataMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertMobileDeviceDataMutation, TError, InsertMobileDeviceDataMutationVariables, TContext>(
      {
    mutationKey: ['InsertMobileDeviceData'],
    mutationFn: (variables?: InsertMobileDeviceDataMutationVariables) => fetcher<InsertMobileDeviceDataMutation, InsertMobileDeviceDataMutationVariables>(client, InsertMobileDeviceDataDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteQuestionnaireResponsesDocument = `
    mutation DeleteQuestionnaireResponses($questionnaire_take_id: Int!) {
  delete_questionnaire_responses(
    where: {questionnaire_take_id: {_eq: $questionnaire_take_id}}
  ) {
    affected_rows
  }
}
    `;

export const useDeleteQuestionnaireResponsesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteQuestionnaireResponsesMutation, TError, DeleteQuestionnaireResponsesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteQuestionnaireResponsesMutation, TError, DeleteQuestionnaireResponsesMutationVariables, TContext>(
      {
    mutationKey: ['DeleteQuestionnaireResponses'],
    mutationFn: (variables?: DeleteQuestionnaireResponsesMutationVariables) => fetcher<DeleteQuestionnaireResponsesMutation, DeleteQuestionnaireResponsesMutationVariables>(client, DeleteQuestionnaireResponsesDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertNudgeDocument = `
    mutation InsertNudge($resource: Int, $public: Boolean = false, $technique: String!, $owner_org_id: Int, $domain: String!, $default_messaging: String!, $created_by: uuid) {
  insert_nudges_one(
    object: {resource_id: $resource, default_messaging: $default_messaging, domain: $domain, owner_org_id: $owner_org_id, public: $public, technique: $technique, created_by: $created_by}
  ) {
    id
  }
}
    `;

export const useInsertNudgeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertNudgeMutation, TError, InsertNudgeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertNudgeMutation, TError, InsertNudgeMutationVariables, TContext>(
      {
    mutationKey: ['InsertNudge'],
    mutationFn: (variables?: InsertNudgeMutationVariables) => fetcher<InsertNudgeMutation, InsertNudgeMutationVariables>(client, InsertNudgeDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateNudgeDocument = `
    mutation UpdateNudge($resource: Int, $id: Int!, $default_messaging: String, $owner_org_id: Int, $created_by: uuid, $public: Boolean = false, $technique: String, $domain: String) {
  update_nudges_by_pk(
    pk_columns: {id: $id}
    _set: {resource_id: $resource, default_messaging: $default_messaging, owner_org_id: $owner_org_id, created_by: $created_by, public: $public, technique: $technique, domain: $domain}
  ) {
    id
  }
}
    `;

export const useUpdateNudgeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateNudgeMutation, TError, UpdateNudgeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateNudgeMutation, TError, UpdateNudgeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateNudge'],
    mutationFn: (variables?: UpdateNudgeMutationVariables) => fetcher<UpdateNudgeMutation, UpdateNudgeMutationVariables>(client, UpdateNudgeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireDocument = `
    mutation InsertQuestionnaire($name: String!, $created_by: uuid!, $owner_org_id: Int, $public: Boolean = false, $contains_risk_questions: Boolean = false) {
  insert_questionnaires_one(
    object: {created_by: $created_by, name: $name, owner_org_id: $owner_org_id, public: $public, contains_risk_questions: $contains_risk_questions}
  ) {
    id
  }
}
    `;

export const useInsertQuestionnaireMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireMutation, TError, InsertQuestionnaireMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireMutation, TError, InsertQuestionnaireMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaire'],
    mutationFn: (variables?: InsertQuestionnaireMutationVariables) => fetcher<InsertQuestionnaireMutation, InsertQuestionnaireMutationVariables>(client, InsertQuestionnaireDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateQuestionnaireDocument = `
    mutation UpdateQuestionnaire($id: Int!, $name: String, $created_by: uuid, $owner_org_id: Int, $public: Boolean) {
  update_questionnaires_by_pk(
    pk_columns: {id: $id}
    _set: {created_by: $created_by, name: $name, owner_org_id: $owner_org_id, public: $public}
  ) {
    id
  }
}
    `;

export const useUpdateQuestionnaireMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateQuestionnaireMutation, TError, UpdateQuestionnaireMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateQuestionnaireMutation, TError, UpdateQuestionnaireMutationVariables, TContext>(
      {
    mutationKey: ['UpdateQuestionnaire'],
    mutationFn: (variables?: UpdateQuestionnaireMutationVariables) => fetcher<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(client, UpdateQuestionnaireDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertResourceAndInsightResourceDocument = `
    mutation InsertResourceAndInsightResource($created_by: uuid, $owner_org_id: Int, $content: String, $direction: enum_feature_direction_enum, $content_type: enum_insight_content_type_enum, $title: String, $author: String, $feature: enum_feature_type_enum, $public: Boolean = false) {
  insert_insight_resources_one(
    object: {feature: $feature, direction: $direction, resource: {data: {content: $content, created_by: $created_by, owner_org_id: $owner_org_id, public: $public, content_type: $content_type, title: $title, author: $author}}}
  ) {
    resources_id
  }
}
    `;

export const useInsertResourceAndInsightResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertResourceAndInsightResourceMutation, TError, InsertResourceAndInsightResourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertResourceAndInsightResourceMutation, TError, InsertResourceAndInsightResourceMutationVariables, TContext>(
      {
    mutationKey: ['InsertResourceAndInsightResource'],
    mutationFn: (variables?: InsertResourceAndInsightResourceMutationVariables) => fetcher<InsertResourceAndInsightResourceMutation, InsertResourceAndInsightResourceMutationVariables>(client, InsertResourceAndInsightResourceDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertResourceDocument = `
    mutation InsertResource($author: String, $content: String!, $content_type: enum_insight_content_type_enum, $created_by: uuid!, $owner_org_id: Int!, $public: Boolean = false, $title: String!, $header_image: String) {
  insert_resources_one(
    object: {author: $author, content: $content, content_type: $content_type, created_by: $created_by, owner_org_id: $owner_org_id, public: $public, title: $title, header_image: $header_image}
  ) {
    id
  }
}
    `;

export const useInsertResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertResourceMutation, TError, InsertResourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertResourceMutation, TError, InsertResourceMutationVariables, TContext>(
      {
    mutationKey: ['InsertResource'],
    mutationFn: (variables?: InsertResourceMutationVariables) => fetcher<InsertResourceMutation, InsertResourceMutationVariables>(client, InsertResourceDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateResourceDocument = `
    mutation UpdateResource($id: Int!, $author: String, $content: String, $content_type: enum_insight_content_type_enum, $public: Boolean, $title: String, $header_image: String) {
  update_resources_by_pk(
    pk_columns: {id: $id}
    _set: {author: $author, content: $content, content_type: $content_type, public: $public, title: $title, header_image: $header_image}
  ) {
    id
  }
}
    `;

export const useUpdateResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>(
      {
    mutationKey: ['UpdateResource'],
    mutationFn: (variables?: UpdateResourceMutationVariables) => fetcher<UpdateResourceMutation, UpdateResourceMutationVariables>(client, UpdateResourceDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteResourceByIdDocument = `
    mutation DeleteResourceById($id: Int!) {
  delete_resources_by_pk(id: $id) {
    id
  }
}
    `;

export const useDeleteResourceByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteResourceByIdMutation, TError, DeleteResourceByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteResourceByIdMutation, TError, DeleteResourceByIdMutationVariables, TContext>(
      {
    mutationKey: ['DeleteResourceById'],
    mutationFn: (variables?: DeleteResourceByIdMutationVariables) => fetcher<DeleteResourceByIdMutation, DeleteResourceByIdMutationVariables>(client, DeleteResourceByIdDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteNudgeByIdDocument = `
    mutation DeleteNudgeById($id: Int!) {
  delete_nudges_by_pk(id: $id) {
    id
  }
}
    `;

export const useDeleteNudgeByIdMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteNudgeByIdMutation, TError, DeleteNudgeByIdMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteNudgeByIdMutation, TError, DeleteNudgeByIdMutationVariables, TContext>(
      {
    mutationKey: ['DeleteNudgeById'],
    mutationFn: (variables?: DeleteNudgeByIdMutationVariables) => fetcher<DeleteNudgeByIdMutation, DeleteNudgeByIdMutationVariables>(client, DeleteNudgeByIdDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertResourceAccessAndResourceDocument = `
    mutation InsertResourceAccessAndResource($author: String, $content: String, $content_type: enum_insight_content_type_enum, $created_by: uuid, $header_image: String, $owner_org_id: Int, $public: Boolean = false, $title: String) {
  insert_resources_orgs_one(
    object: {org_id: $owner_org_id, resource: {data: {author: $author, content: $content, content_type: $content_type, created_by: $created_by, header_image: $header_image, owner_org_id: $owner_org_id, public: $public, title: $title}}}
  ) {
    resources_id
  }
}
    `;

export const useInsertResourceAccessAndResourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertResourceAccessAndResourceMutation, TError, InsertResourceAccessAndResourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertResourceAccessAndResourceMutation, TError, InsertResourceAccessAndResourceMutationVariables, TContext>(
      {
    mutationKey: ['InsertResourceAccessAndResource'],
    mutationFn: (variables?: InsertResourceAccessAndResourceMutationVariables) => fetcher<InsertResourceAccessAndResourceMutation, InsertResourceAccessAndResourceMutationVariables>(client, InsertResourceAccessAndResourceDocument, variables, headers)(),
    ...options
  }
    )};

export const SetNudgeInactiveDocument = `
    mutation SetNudgeInactive($id: Int!, $active: Boolean = false) {
  update_nudges(where: {id: {_eq: $id}}, _set: {active: $active}) {
    returning {
      id
    }
  }
}
    `;

export const useSetNudgeInactiveMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetNudgeInactiveMutation, TError, SetNudgeInactiveMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SetNudgeInactiveMutation, TError, SetNudgeInactiveMutationVariables, TContext>(
      {
    mutationKey: ['SetNudgeInactive'],
    mutationFn: (variables?: SetNudgeInactiveMutationVariables) => fetcher<SetNudgeInactiveMutation, SetNudgeInactiveMutationVariables>(client, SetNudgeInactiveDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateIsUserDataAccurateDocument = `
    mutation UpdateIsUserDataAccurate($feedback: Boolean, $id: Int!) {
  update_daily_features_by_pk(
    pk_columns: {id: $id}
    _set: {is_user_reported_accurate: $feedback}
  ) {
    id
    user_id
    key
    value
    create_date
    feature_date
    is_user_reported_accurate
  }
}
    `;

export const useUpdateIsUserDataAccurateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateIsUserDataAccurateMutation, TError, UpdateIsUserDataAccurateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateIsUserDataAccurateMutation, TError, UpdateIsUserDataAccurateMutationVariables, TContext>(
      {
    mutationKey: ['UpdateIsUserDataAccurate'],
    mutationFn: (variables?: UpdateIsUserDataAccurateMutationVariables) => fetcher<UpdateIsUserDataAccurateMutation, UpdateIsUserDataAccurateMutationVariables>(client, UpdateIsUserDataAccurateDocument, variables, headers)(),
    ...options
  }
    )};

export const UpsertV2RecipeDocument = `
    mutation upsertV2Recipe($recipes: [insight_recipes_insert_input!]!) {
  insert_insight_recipes(
    objects: $recipes
    on_conflict: {constraint: insight_recipes_insight_combo_id_owner_org_id_schema_version_ke, update_columns: [insight_combo_id, owner_org_id, schema_version]}
  ) {
    returning {
      id
    }
  }
}
    `;

export const useUpsertV2RecipeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertV2RecipeMutation, TError, UpsertV2RecipeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpsertV2RecipeMutation, TError, UpsertV2RecipeMutationVariables, TContext>(
      {
    mutationKey: ['upsertV2Recipe'],
    mutationFn: (variables?: UpsertV2RecipeMutationVariables) => fetcher<UpsertV2RecipeMutation, UpsertV2RecipeMutationVariables>(client, UpsertV2RecipeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertUserGroupCodeDocument = `
    mutation InsertUserGroupCode($user_id: uuid!, $group_code_id: Int!) {
  insert_user_group_code_one(
    object: {user_id: $user_id, group_code_id: $group_code_id}
    on_conflict: {constraint: user_group_code_pkey, update_columns: [user_id, group_code_id]}
  ) {
    user_id
    group_code_id
  }
}
    `;

export const useInsertUserGroupCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertUserGroupCodeMutation, TError, InsertUserGroupCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertUserGroupCodeMutation, TError, InsertUserGroupCodeMutationVariables, TContext>(
      {
    mutationKey: ['InsertUserGroupCode'],
    mutationFn: (variables?: InsertUserGroupCodeMutationVariables) => fetcher<InsertUserGroupCodeMutation, InsertUserGroupCodeMutationVariables>(client, InsertUserGroupCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const AddMobileUploadLogDocument = `
    mutation AddMobileUploadLog($startTime: timestamptz!, $endTime: timestamptz, $dataType: citext!, $totalRecordsAtStart: Int!, $totalRecordsAtEnd: Int, $errorMessage: String, $userId: uuid!, $completed: Boolean!) {
  insert_mobile_upload_log_one(
    object: {dataType: $dataType, startTime: $startTime, endTime: $endTime, totalRecordsAtStart: $totalRecordsAtStart, totalRecordsAtEnd: $totalRecordsAtEnd, errorMessage: $errorMessage, userId: $userId, completed: $completed}
  ) {
    id
  }
}
    `;

export const useAddMobileUploadLogMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMobileUploadLogMutation, TError, AddMobileUploadLogMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AddMobileUploadLogMutation, TError, AddMobileUploadLogMutationVariables, TContext>(
      {
    mutationKey: ['AddMobileUploadLog'],
    mutationFn: (variables?: AddMobileUploadLogMutationVariables) => fetcher<AddMobileUploadLogMutation, AddMobileUploadLogMutationVariables>(client, AddMobileUploadLogDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireOneDocument = `
    mutation InsertQuestionnaireOne($client_display_name: String, $days_to_expiration: Int = 7, $name: String, $public: Boolean = false, $owner_org_id: Int, $created_by: uuid, $contains_risk_questions: Boolean = false) {
  insert_questionnaires_one(
    object: {client_display_name: $client_display_name, days_to_expiration: $days_to_expiration, name: $name, public: $public, owner_org_id: $owner_org_id, created_by: $created_by, contains_risk_questions: $contains_risk_questions}
  ) {
    id
  }
}
    `;

export const useInsertQuestionnaireOneMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireOneMutation, TError, InsertQuestionnaireOneMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireOneMutation, TError, InsertQuestionnaireOneMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaireOne'],
    mutationFn: (variables?: InsertQuestionnaireOneMutationVariables) => fetcher<InsertQuestionnaireOneMutation, InsertQuestionnaireOneMutationVariables>(client, InsertQuestionnaireOneDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireItemOneDocument = `
    mutation InsertQuestionnaireItemOne($header: String, $display_order: Int, $question: String, $questionnaire_id: Int) {
  insert_questionnaire_items_one(
    object: {header: $header, display_order: $display_order, question: $question, questionnaire_id: $questionnaire_id}
  ) {
    id
  }
}
    `;

export const useInsertQuestionnaireItemOneMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireItemOneMutation, TError, InsertQuestionnaireItemOneMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireItemOneMutation, TError, InsertQuestionnaireItemOneMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaireItemOne'],
    mutationFn: (variables?: InsertQuestionnaireItemOneMutationVariables) => fetcher<InsertQuestionnaireItemOneMutation, InsertQuestionnaireItemOneMutationVariables>(client, InsertQuestionnaireItemOneDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertQuestionnaireResponseOptionOneDocument = `
    mutation InsertQuestionnaireResponseOptionOne($display_order: Int, $questionnaire_item_id: Int, $response_text: String, $response_value: Int, $triggers_risk_alert: Boolean) {
  insert_questionnaire_response_options_one(
    object: {display_order: $display_order, questionnaire_item_id: $questionnaire_item_id, response_text: $response_text, response_value: $response_value, triggers_risk_alert: $triggers_risk_alert}
  ) {
    id
  }
}
    `;

export const useInsertQuestionnaireResponseOptionOneMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertQuestionnaireResponseOptionOneMutation, TError, InsertQuestionnaireResponseOptionOneMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertQuestionnaireResponseOptionOneMutation, TError, InsertQuestionnaireResponseOptionOneMutationVariables, TContext>(
      {
    mutationKey: ['InsertQuestionnaireResponseOptionOne'],
    mutationFn: (variables?: InsertQuestionnaireResponseOptionOneMutationVariables) => fetcher<InsertQuestionnaireResponseOptionOneMutation, InsertQuestionnaireResponseOptionOneMutationVariables>(client, InsertQuestionnaireResponseOptionOneDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertRiskAlertRecipientLogDocument = `
    mutation InsertRiskAlertRecipientLog($risk_alerts_log_id: uuid, $user_id: uuid, $text_sent: Boolean, $email_sent: Boolean) {
  insert_risk_alerts_recipients_log_one(
    object: {email_sent: $email_sent, risk_alerts_log_id: $risk_alerts_log_id, user_id: $user_id, text_sent: $text_sent}
  ) {
    id
  }
}
    `;

export const useInsertRiskAlertRecipientLogMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertRiskAlertRecipientLogMutation, TError, InsertRiskAlertRecipientLogMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertRiskAlertRecipientLogMutation, TError, InsertRiskAlertRecipientLogMutationVariables, TContext>(
      {
    mutationKey: ['InsertRiskAlertRecipientLog'],
    mutationFn: (variables?: InsertRiskAlertRecipientLogMutationVariables) => fetcher<InsertRiskAlertRecipientLogMutation, InsertRiskAlertRecipientLogMutationVariables>(client, InsertRiskAlertRecipientLogDocument, variables, headers)(),
    ...options
  }
    )};

export const SetRiskAlertLogCompleteDocument = `
    mutation SetRiskAlertLogComplete($all_alerts_sent_at: timestamp = "", $id: uuid = "") {
  update_risk_alerts_log(
    where: {id: {_eq: $id}}
    _set: {all_alerts_sent_at: $all_alerts_sent_at}
  ) {
    returning {
      id
    }
  }
}
    `;

export const useSetRiskAlertLogCompleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetRiskAlertLogCompleteMutation, TError, SetRiskAlertLogCompleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SetRiskAlertLogCompleteMutation, TError, SetRiskAlertLogCompleteMutationVariables, TContext>(
      {
    mutationKey: ['SetRiskAlertLogComplete'],
    mutationFn: (variables?: SetRiskAlertLogCompleteMutationVariables) => fetcher<SetRiskAlertLogCompleteMutation, SetRiskAlertLogCompleteMutationVariables>(client, SetRiskAlertLogCompleteDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertSafetyPlanDocument = `
    mutation InsertSafetyPlan($status: enum_safety_plan_status_enum!, $userId: uuid!, $safetyPlanTemplateId: uuid!, $updatedBy: uuid!, $responses: jsonb!) {
  insert_safety_plan_one(
    object: {status: $status, user_id: $userId, safety_plan_template_id: $safetyPlanTemplateId, updated_by: $updatedBy, responses: $responses}
  ) {
    id
    responses
    safety_plan_template_id
    status
    status_changed_at
    updated_at
    updated_by
    user_id
    created_at
  }
}
    `;

export const useInsertSafetyPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertSafetyPlanMutation, TError, InsertSafetyPlanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertSafetyPlanMutation, TError, InsertSafetyPlanMutationVariables, TContext>(
      {
    mutationKey: ['InsertSafetyPlan'],
    mutationFn: (variables?: InsertSafetyPlanMutationVariables) => fetcher<InsertSafetyPlanMutation, InsertSafetyPlanMutationVariables>(client, InsertSafetyPlanDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertMobilePermissionDocument = `
    mutation InsertMobilePermission($user_id: uuid!, $permission_type: enum_mobile_permission_type_enum!, $permission_status: enum_mobile_permission_status_enum!, $client_created_at: timestamp!) {
  insert_mobile_permissions_one(
    object: {user_id: $user_id, permission_type: $permission_type, permission_status: $permission_status, client_created_at: $client_created_at}
  ) {
    id
    permission_type
    permission_status
    client_created_at
  }
}
    `;

export const useInsertMobilePermissionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertMobilePermissionMutation, TError, InsertMobilePermissionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertMobilePermissionMutation, TError, InsertMobilePermissionMutationVariables, TContext>(
      {
    mutationKey: ['InsertMobilePermission'],
    mutationFn: (variables?: InsertMobilePermissionMutationVariables) => fetcher<InsertMobilePermissionMutation, InsertMobilePermissionMutationVariables>(client, InsertMobilePermissionDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertClientDemographicsDocument = `
    mutation InsertClientDemographics($userId: uuid!, $firstName: String, $lastName: String, $birthYear: Int, $gender: enum_gender_enum, $racialEthnic: enum_racial_ethnic_enum, $description: String) {
  insert_client_demographics_one(
    object: {user_id: $userId, first_name: $firstName, last_name: $lastName, birth_year: $birthYear, gender: $gender, racial_ethnic: $racialEthnic, description: $description}
  ) {
    id
  }
}
    `;

export const useInsertClientDemographicsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertClientDemographicsMutation, TError, InsertClientDemographicsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertClientDemographicsMutation, TError, InsertClientDemographicsMutationVariables, TContext>(
      {
    mutationKey: ['InsertClientDemographics'],
    mutationFn: (variables?: InsertClientDemographicsMutationVariables) => fetcher<InsertClientDemographicsMutation, InsertClientDemographicsMutationVariables>(client, InsertClientDemographicsDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertActivityRatingDocument = `
    mutation InsertActivityRating($user_id: uuid!, $value: Int!, $activity_id: uuid!, $client_created_at: timestamp!, $transaction_id: uuid) {
  insert_activity_rating_one(
    object: {user_id: $user_id, value: $value, activity_id: $activity_id, client_created_at: $client_created_at, transaction_id: $transaction_id}
  ) {
    id
    user_id
    activity_id
    client_created_at
  }
}
    `;

export const useInsertActivityRatingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertActivityRatingMutation, TError, InsertActivityRatingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertActivityRatingMutation, TError, InsertActivityRatingMutationVariables, TContext>(
      {
    mutationKey: ['InsertActivityRating'],
    mutationFn: (variables?: InsertActivityRatingMutationVariables) => fetcher<InsertActivityRatingMutation, InsertActivityRatingMutationVariables>(client, InsertActivityRatingDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertSafetyChecklistRecipientsLogDocument = `
    mutation InsertSafetyChecklistRecipientsLog($user_id: uuid, $created_at: timestamp, $email_address: String) {
  insert_safety_checklist_recipients_log_one(
    object: {user_id: $user_id, created_at: $created_at, email_address: $email_address}
  ) {
    id
  }
}
    `;

export const useInsertSafetyChecklistRecipientsLogMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertSafetyChecklistRecipientsLogMutation, TError, InsertSafetyChecklistRecipientsLogMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertSafetyChecklistRecipientsLogMutation, TError, InsertSafetyChecklistRecipientsLogMutationVariables, TContext>(
      {
    mutationKey: ['InsertSafetyChecklistRecipientsLog'],
    mutationFn: (variables?: InsertSafetyChecklistRecipientsLogMutationVariables) => fetcher<InsertSafetyChecklistRecipientsLogMutation, InsertSafetyChecklistRecipientsLogMutationVariables>(client, InsertSafetyChecklistRecipientsLogDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateClientDemographicsDocument = `
    mutation UpdateClientDemographics($id: uuid!, $firstName: String, $lastName: String, $birthYear: Int, $gender: enum_gender_enum, $racialEthnic: enum_racial_ethnic_enum, $description: String) {
  update_client_demographics(
    where: {id: {_eq: $id}}
    _set: {first_name: $firstName, last_name: $lastName, birth_year: $birthYear, gender: $gender, racial_ethnic: $racialEthnic, description: $description}
  ) {
    returning {
      id
    }
  }
}
    `;

export const useUpdateClientDemographicsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateClientDemographicsMutation, TError, UpdateClientDemographicsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateClientDemographicsMutation, TError, UpdateClientDemographicsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateClientDemographics'],
    mutationFn: (variables?: UpdateClientDemographicsMutationVariables) => fetcher<UpdateClientDemographicsMutation, UpdateClientDemographicsMutationVariables>(client, UpdateClientDemographicsDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertOrgMemberRoleDocument = `
    mutation InsertOrgMemberRole($practitioner_id: uuid, $org_id: Int, $role: String, $type: String) {
  insert_organization_member_roles(
    objects: {practitioner_id: $practitioner_id, org_id: $org_id, organization_member_roles_role_capability: {data: {create_client_details: false, create_nudge_schedules: false, create_questionnaire_schedules: false, create_safety_plans: false, delete_client_details: false, delete_nudge_schedules: false, delete_questionnaire_schedules: false, delete_safety_plans: false, role: $role, type: $type, update_client_details: false, update_nudge_schedules: false, update_questionnaire_schedules: false, update_safety_plans: false, user_id: $practitioner_id, view_client_details: true, view_nudge_schedules: true, view_questionnaire_schedules: true, view_safety_plans: true}, on_conflict: {constraint: role_capabilities_user_id_key, update_columns: []}}}
    on_conflict: {constraint: organization_member_roles_practitioner_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;

export const useInsertOrgMemberRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertOrgMemberRoleMutation, TError, InsertOrgMemberRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertOrgMemberRoleMutation, TError, InsertOrgMemberRoleMutationVariables, TContext>(
      {
    mutationKey: ['InsertOrgMemberRole'],
    mutationFn: (variables?: InsertOrgMemberRoleMutationVariables) => fetcher<InsertOrgMemberRoleMutation, InsertOrgMemberRoleMutationVariables>(client, InsertOrgMemberRoleDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertSuperviseesDocument = `
    mutation InsertSupervisees($supervisees: [organization_supervisees_insert_input!]!) {
  insert_organization_supervisees(
    objects: $supervisees
    on_conflict: {constraint: organization_supervisees_organization_supervisor_id_practitione, update_columns: [practitioner_id, organization_supervisor_id, started_at, ended_at]}
  ) {
    affected_rows
  }
}
    `;

export const useInsertSuperviseesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertSuperviseesMutation, TError, InsertSuperviseesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertSuperviseesMutation, TError, InsertSuperviseesMutationVariables, TContext>(
      {
    mutationKey: ['InsertSupervisees'],
    mutationFn: (variables?: InsertSuperviseesMutationVariables) => fetcher<InsertSuperviseesMutation, InsertSuperviseesMutationVariables>(client, InsertSuperviseesDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertSupervisorDocument = `
    mutation InsertSupervisor($supervisor: [organization_supervisors_insert_input!]!) {
  insert_organization_supervisors(
    objects: $supervisor
    on_conflict: {constraint: organization_supervisors_supervisor_id_org_id_k, update_columns: [supervisor_id, org_id, started_at, ended_at]}
  ) {
    returning {
      id
    }
  }
}
    `;

export const useInsertSupervisorMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertSupervisorMutation, TError, InsertSupervisorMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertSupervisorMutation, TError, InsertSupervisorMutationVariables, TContext>(
      {
    mutationKey: ['InsertSupervisor'],
    mutationFn: (variables?: InsertSupervisorMutationVariables) => fetcher<InsertSupervisorMutation, InsertSupervisorMutationVariables>(client, InsertSupervisorDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteOrganizationMemberRoleDocument = `
    mutation DeleteOrganizationMemberRole($userId: uuid) {
  delete_organization_member_roles(where: {practitioner_id: {_eq: $userId}}) {
    affected_rows
  }
  delete_role_capabilities(where: {user_id: {_eq: $userId}}) {
    affected_rows
  }
}
    `;

export const useDeleteOrganizationMemberRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrganizationMemberRoleMutation, TError, DeleteOrganizationMemberRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteOrganizationMemberRoleMutation, TError, DeleteOrganizationMemberRoleMutationVariables, TContext>(
      {
    mutationKey: ['DeleteOrganizationMemberRole'],
    mutationFn: (variables?: DeleteOrganizationMemberRoleMutationVariables) => fetcher<DeleteOrganizationMemberRoleMutation, DeleteOrganizationMemberRoleMutationVariables>(client, DeleteOrganizationMemberRoleDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateSupervisorEndDateDocument = `
    mutation UpdateSupervisorEndDate($userId: uuid, $orgId: Int, $endDate: timestamp) {
  update_organization_supervisors(
    where: {supervisor_id: {_eq: $userId}, org_id: {_eq: $orgId}}
    _set: {ended_at: $endDate}
  ) {
    affected_rows
  }
}
    `;

export const useUpdateSupervisorEndDateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateSupervisorEndDateMutation, TError, UpdateSupervisorEndDateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateSupervisorEndDateMutation, TError, UpdateSupervisorEndDateMutationVariables, TContext>(
      {
    mutationKey: ['UpdateSupervisorEndDate'],
    mutationFn: (variables?: UpdateSupervisorEndDateMutationVariables) => fetcher<UpdateSupervisorEndDateMutation, UpdateSupervisorEndDateMutationVariables>(client, UpdateSupervisorEndDateDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateAccountRoleDocument = `
    mutation UpdateAccountRole($userId: uuid!, $role: String!) {
  update_auth_accounts(
    where: {user_id: {_eq: $userId}}
    _set: {default_role: $role}
  ) {
    returning {
      user_id
    }
  }
}
    `;

export const useUpdateAccountRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAccountRoleMutation, TError, UpdateAccountRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateAccountRoleMutation, TError, UpdateAccountRoleMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAccountRole'],
    mutationFn: (variables?: UpdateAccountRoleMutationVariables) => fetcher<UpdateAccountRoleMutation, UpdateAccountRoleMutationVariables>(client, UpdateAccountRoleDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertUserFeatureFlagsDocument = `
    mutation InsertUserFeatureFlags($user_id: uuid!, $jitai_features_enabled: Boolean!) {
  insert_user_feature_flag(
    objects: {user_id: $user_id, jitai_features_enabled: $jitai_features_enabled}
  ) {
    returning {
      user_id
      jitai_features_enabled
    }
  }
}
    `;

export const useInsertUserFeatureFlagsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertUserFeatureFlagsMutation, TError, InsertUserFeatureFlagsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertUserFeatureFlagsMutation, TError, InsertUserFeatureFlagsMutationVariables, TContext>(
      {
    mutationKey: ['InsertUserFeatureFlags'],
    mutationFn: (variables?: InsertUserFeatureFlagsMutationVariables) => fetcher<InsertUserFeatureFlagsMutation, InsertUserFeatureFlagsMutationVariables>(client, InsertUserFeatureFlagsDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateInviteCodeByClientAndPractitionerDocument = `
    mutation UpdateInviteCodeByClientAndPractitioner($client_id: uuid!, $practitioner_id: uuid!, $status: String!, $ended_at: timestamp!) {
  update_invite_codes(
    where: {client_id: {_eq: $client_id}, practitioner_id: {_eq: $practitioner_id}}
    _set: {status: $status, ended_at: $ended_at}
  ) {
    affected_rows
    returning {
      id
      code
      client_id
      practitioner_id
      status
      ended_at
      created_at
    }
  }
}
    `;

export const useUpdateInviteCodeByClientAndPractitionerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInviteCodeByClientAndPractitionerMutation, TError, UpdateInviteCodeByClientAndPractitionerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateInviteCodeByClientAndPractitionerMutation, TError, UpdateInviteCodeByClientAndPractitionerMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInviteCodeByClientAndPractitioner'],
    mutationFn: (variables?: UpdateInviteCodeByClientAndPractitionerMutationVariables) => fetcher<UpdateInviteCodeByClientAndPractitionerMutation, UpdateInviteCodeByClientAndPractitionerMutationVariables>(client, UpdateInviteCodeByClientAndPractitionerDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertScheduleBlackoutDatesDocument = `
    mutation InsertScheduleBlackoutDates($objects: [schedule_blackout_dates_insert_input!]!) {
  insert_schedule_blackout_dates(objects: $objects) {
    affected_rows
    returning {
      id
      blackout_date
      nudge_schedules_id
      questionnaire_schedules_id
      blackout_following
    }
  }
}
    `;

export const useInsertScheduleBlackoutDatesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertScheduleBlackoutDatesMutation, TError, InsertScheduleBlackoutDatesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertScheduleBlackoutDatesMutation, TError, InsertScheduleBlackoutDatesMutationVariables, TContext>(
      {
    mutationKey: ['InsertScheduleBlackoutDates'],
    mutationFn: (variables?: InsertScheduleBlackoutDatesMutationVariables) => fetcher<InsertScheduleBlackoutDatesMutation, InsertScheduleBlackoutDatesMutationVariables>(client, InsertScheduleBlackoutDatesDocument, variables, headers)(),
    ...options
  }
    )};

export const SetUserRequestedDeletionAndTimestampDocument = `
    mutation SetUserRequestedDeletionAndTimestamp($userId: uuid!, $deletion_at: timestamp!) {
  update_users_by_pk(
    pk_columns: {id: $userId}
    _set: {user_requested_deletion: true, user_requested_deletion_at: $deletion_at}
  ) {
    id
  }
}
    `;

export const useSetUserRequestedDeletionAndTimestampMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetUserRequestedDeletionAndTimestampMutation, TError, SetUserRequestedDeletionAndTimestampMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SetUserRequestedDeletionAndTimestampMutation, TError, SetUserRequestedDeletionAndTimestampMutationVariables, TContext>(
      {
    mutationKey: ['SetUserRequestedDeletionAndTimestamp'],
    mutationFn: (variables?: SetUserRequestedDeletionAndTimestampMutationVariables) => fetcher<SetUserRequestedDeletionAndTimestampMutation, SetUserRequestedDeletionAndTimestampMutationVariables>(client, SetUserRequestedDeletionAndTimestampDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateInviteCodeStatusAndEndedAtDocument = `
    mutation UpdateInviteCodeStatusAndEndedAt($code: String!, $status: String!, $ended_at: timestamp!) {
  update_invite_codes(
    where: {code: {_eq: $code}}
    _set: {status: $status, ended_at: $ended_at}
  ) {
    returning {
      ...inviteCode
      status
    }
  }
}
    ${InviteCodeFragmentDoc}`;

export const useUpdateInviteCodeStatusAndEndedAtMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInviteCodeStatusAndEndedAtMutation, TError, UpdateInviteCodeStatusAndEndedAtMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateInviteCodeStatusAndEndedAtMutation, TError, UpdateInviteCodeStatusAndEndedAtMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInviteCodeStatusAndEndedAt'],
    mutationFn: (variables?: UpdateInviteCodeStatusAndEndedAtMutationVariables) => fetcher<UpdateInviteCodeStatusAndEndedAtMutation, UpdateInviteCodeStatusAndEndedAtMutationVariables>(client, UpdateInviteCodeStatusAndEndedAtDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateInviteCodesEndedAtOnAccountDeletionDocument = `
    mutation UpdateInviteCodesEndedAtOnAccountDeletion($userId: uuid, $endedAt: timestamp) {
  update_invite_codes(
    where: {_and: {client_id: {_eq: $userId}, ended_at: {_is_null: true}, practitioner_id: {_is_null: false}}}
    _set: {ended_at: $endedAt, status: "account deleted"}
  ) {
    returning {
      client_id
      practitioner_id
    }
  }
}
    `;

export const useUpdateInviteCodesEndedAtOnAccountDeletionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInviteCodesEndedAtOnAccountDeletionMutation, TError, UpdateInviteCodesEndedAtOnAccountDeletionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateInviteCodesEndedAtOnAccountDeletionMutation, TError, UpdateInviteCodesEndedAtOnAccountDeletionMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInviteCodesEndedAtOnAccountDeletion'],
    mutationFn: (variables?: UpdateInviteCodesEndedAtOnAccountDeletionMutationVariables) => fetcher<UpdateInviteCodesEndedAtOnAccountDeletionMutation, UpdateInviteCodesEndedAtOnAccountDeletionMutationVariables>(client, UpdateInviteCodesEndedAtOnAccountDeletionDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertAssessmentTakeDocument = `
    mutation InsertAssessmentTake($id: uuid!, $assessmentId: uuid!, $userId: uuid!, $startedAt: timestamptz!, $completedAt: timestamptz!) {
  insert_assessment_takes_one(
    object: {id: $id, assessment_id: $assessmentId, user_id: $userId, started_at: $startedAt, completed_at: $completedAt}
    on_conflict: {constraint: assessment_takes_pkey, update_columns: [assessment_id, user_id, started_at, completed_at]}
  ) {
    id
    assessment_id
    user_id
    started_at
    completed_at
  }
}
    `;

export const useInsertAssessmentTakeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertAssessmentTakeMutation, TError, InsertAssessmentTakeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertAssessmentTakeMutation, TError, InsertAssessmentTakeMutationVariables, TContext>(
      {
    mutationKey: ['InsertAssessmentTake'],
    mutationFn: (variables?: InsertAssessmentTakeMutationVariables) => fetcher<InsertAssessmentTakeMutation, InsertAssessmentTakeMutationVariables>(client, InsertAssessmentTakeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertAssessmentAnswerDocument = `
    mutation InsertAssessmentAnswer($id: uuid!, $takeId: uuid!, $questionId: uuid!, $answer: String!, $clientCreatedAt: timestamptz!, $customPromptId: uuid) {
  insert_assessment_answers_one(
    object: {id: $id, take_id: $takeId, question_id: $questionId, answer: $answer, client_created_at: $clientCreatedAt, custom_prompt_id: $customPromptId}
    on_conflict: {constraint: assessment_answers_pkey, update_columns: [answer, client_created_at, custom_prompt_id]}
  ) {
    id
    take_id
    question_id
    answer
    client_created_at
    custom_prompt_id
  }
}
    `;

export const useInsertAssessmentAnswerMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertAssessmentAnswerMutation, TError, InsertAssessmentAnswerMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertAssessmentAnswerMutation, TError, InsertAssessmentAnswerMutationVariables, TContext>(
      {
    mutationKey: ['InsertAssessmentAnswer'],
    mutationFn: (variables?: InsertAssessmentAnswerMutationVariables) => fetcher<InsertAssessmentAnswerMutation, InsertAssessmentAnswerMutationVariables>(client, InsertAssessmentAnswerDocument, variables, headers)(),
    ...options
  }
    )};

export const UpsertDbtDiaryFeatureFlagDocument = `
    mutation UpsertDBTDiaryFeatureFlag($_eq: uuid = "", $dbt_diary_enabled: Boolean = false) {
  insert_user_feature_flag(
    objects: {user_id: $_eq, dbt_diary_enabled: $dbt_diary_enabled}
    on_conflict: {constraint: users_user_feature_flags_user_id_key, update_columns: dbt_diary_enabled, where: {user_id: {_eq: $_eq}}}
  ) {
    affected_rows
  }
}
    `;

export const useUpsertDbtDiaryFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertDbtDiaryFeatureFlagMutation, TError, UpsertDbtDiaryFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpsertDbtDiaryFeatureFlagMutation, TError, UpsertDbtDiaryFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['UpsertDBTDiaryFeatureFlag'],
    mutationFn: (variables?: UpsertDbtDiaryFeatureFlagMutationVariables) => fetcher<UpsertDbtDiaryFeatureFlagMutation, UpsertDbtDiaryFeatureFlagMutationVariables>(client, UpsertDbtDiaryFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

export const UpsertViraPathFeatureFlagDocument = `
    mutation UpsertViraPathFeatureFlag($_eq: uuid = "", $vira_path_enabled: Boolean = false) {
  insert_user_feature_flag(
    objects: {user_id: $_eq, vira_path_enabled: $vira_path_enabled}
    on_conflict: {constraint: users_user_feature_flags_user_id_key, update_columns: vira_path_enabled, where: {user_id: {_eq: $_eq}}}
  ) {
    affected_rows
  }
}
    `;

export const useUpsertViraPathFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertViraPathFeatureFlagMutation, TError, UpsertViraPathFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpsertViraPathFeatureFlagMutation, TError, UpsertViraPathFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['UpsertViraPathFeatureFlag'],
    mutationFn: (variables?: UpsertViraPathFeatureFlagMutationVariables) => fetcher<UpsertViraPathFeatureFlagMutation, UpsertViraPathFeatureFlagMutationVariables>(client, UpsertViraPathFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateAssessmentQuestionCustomPromptHeaderDocument = `
    mutation UpdateAssessmentQuestionCustomPromptHeader($assessment_question_id: uuid!, $client_id: uuid!, $explanation_text: String, $header: String) {
  update_assessment_question_custom_prompt(
    where: {assessment_question_id: {_eq: $assessment_question_id}, client_id: {_eq: $client_id}, deleted_at: {_is_null: true}}
    _set: {header: $header, explanation_text: $explanation_text}
  ) {
    affected_rows
  }
}
    `;

export const useUpdateAssessmentQuestionCustomPromptHeaderMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAssessmentQuestionCustomPromptHeaderMutation, TError, UpdateAssessmentQuestionCustomPromptHeaderMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateAssessmentQuestionCustomPromptHeaderMutation, TError, UpdateAssessmentQuestionCustomPromptHeaderMutationVariables, TContext>(
      {
    mutationKey: ['UpdateAssessmentQuestionCustomPromptHeader'],
    mutationFn: (variables?: UpdateAssessmentQuestionCustomPromptHeaderMutationVariables) => fetcher<UpdateAssessmentQuestionCustomPromptHeaderMutation, UpdateAssessmentQuestionCustomPromptHeaderMutationVariables>(client, UpdateAssessmentQuestionCustomPromptHeaderDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteAssessmentQuestionCustomPromptDocument = `
    mutation DeleteAssessmentQuestionCustomPrompt($assessment_question_id: uuid!, $client_id: uuid!, $deleted_at: timestamptz!) {
  update_assessment_question_custom_prompt(
    where: {assessment_question_id: {_eq: $assessment_question_id}, client_id: {_eq: $client_id}, deleted_at: {_is_null: true}}
    _set: {deleted_at: $deleted_at}
  ) {
    affected_rows
  }
}
    `;

export const useDeleteAssessmentQuestionCustomPromptMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAssessmentQuestionCustomPromptMutation, TError, DeleteAssessmentQuestionCustomPromptMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteAssessmentQuestionCustomPromptMutation, TError, DeleteAssessmentQuestionCustomPromptMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAssessmentQuestionCustomPrompt'],
    mutationFn: (variables?: DeleteAssessmentQuestionCustomPromptMutationVariables) => fetcher<DeleteAssessmentQuestionCustomPromptMutation, DeleteAssessmentQuestionCustomPromptMutationVariables>(client, DeleteAssessmentQuestionCustomPromptDocument, variables, headers)(),
    ...options
  }
    )};

export const UpsertAssessmentQuestionCustomPromptDocument = `
    mutation UpsertAssessmentQuestionCustomPrompt($assessment_question_id: uuid!, $client_id: uuid!, $practitioner_id: uuid!, $text: String!, $explanation_text: String, $header: String, $deleted_at: timestamptz!) {
  update_assessment_question_custom_prompt(
    where: {assessment_question_id: {_eq: $assessment_question_id}, client_id: {_eq: $client_id}, deleted_at: {_is_null: true}}
    _set: {deleted_at: $deleted_at}
  ) {
    affected_rows
  }
  insert_assessment_question_custom_prompt_one(
    object: {assessment_question_id: $assessment_question_id, client_id: $client_id, practitioner_id: $practitioner_id, text: $text, explanation_text: $explanation_text, header: $header}
  ) {
    id
  }
}
    `;

export const useUpsertAssessmentQuestionCustomPromptMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpsertAssessmentQuestionCustomPromptMutation, TError, UpsertAssessmentQuestionCustomPromptMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpsertAssessmentQuestionCustomPromptMutation, TError, UpsertAssessmentQuestionCustomPromptMutationVariables, TContext>(
      {
    mutationKey: ['UpsertAssessmentQuestionCustomPrompt'],
    mutationFn: (variables?: UpsertAssessmentQuestionCustomPromptMutationVariables) => fetcher<UpsertAssessmentQuestionCustomPromptMutation, UpsertAssessmentQuestionCustomPromptMutationVariables>(client, UpsertAssessmentQuestionCustomPromptDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertClientInviteCodeDocument = `
    mutation InsertClientInviteCode($code: String!, $practitioner_id: uuid!, $org_id: Int, $email: String, $email_sent_at: timestamp, $phone_number: String, $phone_contacted_at: timestamp, $minutes_to_expire: Int) {
  insert_ehr_client_invite_codes_one(
    object: {code: $code, practitioner_id: $practitioner_id, org_id: $org_id, phone_number: $phone_number, phone_contacted_at: $phone_contacted_at, minutes_to_expiration: $minutes_to_expire, email: $email, email_sent_at: $email_sent_at}
  ) {
    id
  }
}
    `;

export const useInsertClientInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertClientInviteCodeMutation, TError, InsertClientInviteCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertClientInviteCodeMutation, TError, InsertClientInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['InsertClientInviteCode'],
    mutationFn: (variables?: InsertClientInviteCodeMutationVariables) => fetcher<InsertClientInviteCodeMutation, InsertClientInviteCodeMutationVariables>(client, InsertClientInviteCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const UpdateClientInviteCodeSentAtDocument = `
    mutation UpdateClientInviteCodeSentAt($code: String!, $practitioner_id: uuid!, $email_sent_at: timestamp, $phone_contacted_at: timestamp) {
  update_ehr_client_invite_codes(
    where: {code: {_eq: $code}, practitioner_id: {_eq: $practitioner_id}}
    _set: {email_sent_at: $email_sent_at, phone_contacted_at: $phone_contacted_at}
  ) {
    affected_rows
  }
}
    `;

export const useUpdateClientInviteCodeSentAtMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateClientInviteCodeSentAtMutation, TError, UpdateClientInviteCodeSentAtMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateClientInviteCodeSentAtMutation, TError, UpdateClientInviteCodeSentAtMutationVariables, TContext>(
      {
    mutationKey: ['UpdateClientInviteCodeSentAt'],
    mutationFn: (variables?: UpdateClientInviteCodeSentAtMutationVariables) => fetcher<UpdateClientInviteCodeSentAtMutation, UpdateClientInviteCodeSentAtMutationVariables>(client, UpdateClientInviteCodeSentAtDocument, variables, headers)(),
    ...options
  }
    )};

export const DeleteClientInviteCodeDocument = `
    mutation DeleteClientInviteCode($code: String!, $practitioner_id: uuid!, $deleted_at: timestamp) {
  update_ehr_client_invite_codes(
    where: {code: {_eq: $code}, practitioner_id: {_eq: $practitioner_id}}
    _set: {deleted_at: $deleted_at}
  ) {
    affected_rows
  }
}
    `;

export const useDeleteClientInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteClientInviteCodeMutation, TError, DeleteClientInviteCodeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteClientInviteCodeMutation, TError, DeleteClientInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['DeleteClientInviteCode'],
    mutationFn: (variables?: DeleteClientInviteCodeMutationVariables) => fetcher<DeleteClientInviteCodeMutation, DeleteClientInviteCodeMutationVariables>(client, DeleteClientInviteCodeDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertNewPasswordResetTicketDocument = `
    mutation InsertNewPasswordResetTicket($email: citext!, $ticket: uuid!, $expiresAt: timestamptz!) {
  update_auth_accounts(
    where: {email: {_eq: $email}}
    _set: {ticket: $ticket, ticket_expires_at: $expiresAt}
  ) {
    affected_rows
  }
}
    `;

export const useInsertNewPasswordResetTicketMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertNewPasswordResetTicketMutation, TError, InsertNewPasswordResetTicketMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertNewPasswordResetTicketMutation, TError, InsertNewPasswordResetTicketMutationVariables, TContext>(
      {
    mutationKey: ['InsertNewPasswordResetTicket'],
    mutationFn: (variables?: InsertNewPasswordResetTicketMutationVariables) => fetcher<InsertNewPasswordResetTicketMutation, InsertNewPasswordResetTicketMutationVariables>(client, InsertNewPasswordResetTicketDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertRelapsePreventionPlaceDocument = `
    mutation InsertRelapsePreventionPlace($id: uuid!, $safety_plan_response_option_id: uuid!, $place_type: String!, $category: String!, $alert_name: String, $description: String, $address: String, $latitude: String, $longitude: String, $radius_meters: Int!, $business_days: String!, $business_hours_start: time, $business_hours_end: time, $media_items: String, $deleted_at: timestamptz) {
  insert_relapse_prevention_places_one(
    object: {id: $id, safety_plan_response_option_id: $safety_plan_response_option_id, place_type: $place_type, category: $category, alert_name: $alert_name, description: $description, address: $address, latitude: $latitude, longitude: $longitude, radius_meters: $radius_meters, business_days: $business_days, business_hours_start: $business_hours_start, business_hours_end: $business_hours_end, media_items: $media_items, deleted_at: $deleted_at}
    on_conflict: {constraint: relapse_prevention_places_pkey, update_columns: [alert_name, description, address, latitude, longitude, radius_meters, business_days, business_hours_start, business_hours_end, media_items, deleted_at]}
  ) {
    id
  }
}
    `;

export const useInsertRelapsePreventionPlaceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertRelapsePreventionPlaceMutation, TError, InsertRelapsePreventionPlaceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertRelapsePreventionPlaceMutation, TError, InsertRelapsePreventionPlaceMutationVariables, TContext>(
      {
    mutationKey: ['InsertRelapsePreventionPlace'],
    mutationFn: (variables?: InsertRelapsePreventionPlaceMutationVariables) => fetcher<InsertRelapsePreventionPlaceMutation, InsertRelapsePreventionPlaceMutationVariables>(client, InsertRelapsePreventionPlaceDocument, variables, headers)(),
    ...options
  }
    )};

export const InsertRelapsePreventionPlaceVisitDocument = `
    mutation InsertRelapsePreventionPlaceVisit($id: uuid!, $place_id: uuid!, $created_at: timestamptz!, $deleted_at: timestamptz) {
  insert_relapse_prevention_place_visits_one(
    object: {id: $id, place_id: $place_id, created_at: $created_at, deleted_at: $deleted_at}
    on_conflict: {constraint: relapse_prevention_place_visits_pkey, update_columns: [deleted_at]}
  ) {
    id
  }
}
    `;

export const useInsertRelapsePreventionPlaceVisitMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InsertRelapsePreventionPlaceVisitMutation, TError, InsertRelapsePreventionPlaceVisitMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<InsertRelapsePreventionPlaceVisitMutation, TError, InsertRelapsePreventionPlaceVisitMutationVariables, TContext>(
      {
    mutationKey: ['InsertRelapsePreventionPlaceVisit'],
    mutationFn: (variables?: InsertRelapsePreventionPlaceVisitMutationVariables) => fetcher<InsertRelapsePreventionPlaceVisitMutation, InsertRelapsePreventionPlaceVisitMutationVariables>(client, InsertRelapsePreventionPlaceVisitDocument, variables, headers)(),
    ...options
  }
    )};

export const GetClientDataDocument = `
    query GetClientData($clientId: uuid!, $feature_report_limit: Int = 5) {
  users_by_pk(id: $clientId) {
    ...Client
  }
}
    ${ClientFragmentDoc}`;

export const useGetClientDataQuery = <
      TData = GetClientDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClientDataQueryVariables,
      options?: Omit<UseQueryOptions<GetClientDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientDataQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetClientDataQuery, TError, TData>(
      {
    queryKey: ['GetClientData', variables],
    queryFn: fetcher<GetClientDataQuery, GetClientDataQueryVariables>(client, GetClientDataDocument, variables, headers),
    ...options
  }
    )};

export const GetFeatureTypesDocument = `
    query GetFeatureTypes {
  enum_feature_type {
    value
  }
}
    `;

export const useGetFeatureTypesQuery = <
      TData = GetFeatureTypesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetFeatureTypesQueryVariables,
      options?: Omit<UseQueryOptions<GetFeatureTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFeatureTypesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFeatureTypesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetFeatureTypes'] : ['GetFeatureTypes', variables],
    queryFn: fetcher<GetFeatureTypesQuery, GetFeatureTypesQueryVariables>(client, GetFeatureTypesDocument, variables, headers),
    ...options
  }
    )};

export const GetInviteCodesDocument = `
    query GetInviteCodes($practitionerId: uuid!) {
  invite_codes(
    where: {practitioner_id: {_eq: $practitionerId}, expiration_code: {_is_null: true}}
  ) {
    ...inviteCode
  }
}
    ${InviteCodeFragmentDoc}`;

export const useGetInviteCodesQuery = <
      TData = GetInviteCodesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInviteCodesQueryVariables,
      options?: Omit<UseQueryOptions<GetInviteCodesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInviteCodesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetInviteCodesQuery, TError, TData>(
      {
    queryKey: ['GetInviteCodes', variables],
    queryFn: fetcher<GetInviteCodesQuery, GetInviteCodesQueryVariables>(client, GetInviteCodesDocument, variables, headers),
    ...options
  }
    )};

export const CheckClientPractitionerUniquenessDocument = `
    query CheckClientPractitionerUniqueness($clientId: uuid!, $practitionerId: uuid!) {
  invite_codes(
    where: {client_id: {_eq: $clientId}, practitioner_id: {_eq: $practitionerId}}
  ) {
    id
  }
}
    `;

export const useCheckClientPractitionerUniquenessQuery = <
      TData = CheckClientPractitionerUniquenessQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckClientPractitionerUniquenessQueryVariables,
      options?: Omit<UseQueryOptions<CheckClientPractitionerUniquenessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckClientPractitionerUniquenessQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<CheckClientPractitionerUniquenessQuery, TError, TData>(
      {
    queryKey: ['CheckClientPractitionerUniqueness', variables],
    queryFn: fetcher<CheckClientPractitionerUniquenessQuery, CheckClientPractitionerUniquenessQueryVariables>(client, CheckClientPractitionerUniquenessDocument, variables, headers),
    ...options
  }
    )};

export const GetDataFromInviteCodeDocument = `
    query GetDataFromInviteCode($code: String!) {
  invite_codes(where: {code: {_eq: $code}}) {
    client_id
    practitioner_id
  }
}
    `;

export const useGetDataFromInviteCodeQuery = <
      TData = GetDataFromInviteCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDataFromInviteCodeQueryVariables,
      options?: Omit<UseQueryOptions<GetDataFromInviteCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDataFromInviteCodeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDataFromInviteCodeQuery, TError, TData>(
      {
    queryKey: ['GetDataFromInviteCode', variables],
    queryFn: fetcher<GetDataFromInviteCodeQuery, GetDataFromInviteCodeQueryVariables>(client, GetDataFromInviteCodeDocument, variables, headers),
    ...options
  }
    )};

export const GetAllActiveNudgesDocument = `
    query GetAllActiveNudges {
  nudges(where: {active: {_eq: true}}) {
    ...Nudge
  }
}
    ${NudgeFragmentDoc}`;

export const useGetAllActiveNudgesQuery = <
      TData = GetAllActiveNudgesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllActiveNudgesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllActiveNudgesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllActiveNudgesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllActiveNudgesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllActiveNudges'] : ['GetAllActiveNudges', variables],
    queryFn: fetcher<GetAllActiveNudgesQuery, GetAllActiveNudgesQueryVariables>(client, GetAllActiveNudgesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnairesDocument = `
    query GetQuestionnaires {
  questionnaires {
    ...Questionnaire
  }
}
    ${QuestionnaireFragmentDoc}`;

export const useGetQuestionnairesQuery = <
      TData = GetQuestionnairesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetQuestionnairesQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnairesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnairesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnairesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetQuestionnaires'] : ['GetQuestionnaires', variables],
    queryFn: fetcher<GetQuestionnairesQuery, GetQuestionnairesQueryVariables>(client, GetQuestionnairesDocument, variables, headers),
    ...options
  }
    )};

export const GetNudgeSchedulesDocument = `
    query GetNudgeSchedules {
  nudge_schedules {
    ...NudgeSchedule
  }
}
    ${NudgeScheduleFragmentDoc}`;

export const useGetNudgeSchedulesQuery = <
      TData = GetNudgeSchedulesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNudgeSchedulesQueryVariables,
      options?: Omit<UseQueryOptions<GetNudgeSchedulesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNudgeSchedulesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNudgeSchedulesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetNudgeSchedules'] : ['GetNudgeSchedules', variables],
    queryFn: fetcher<GetNudgeSchedulesQuery, GetNudgeSchedulesQueryVariables>(client, GetNudgeSchedulesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireSchedulesDocument = `
    query GetQuestionnaireSchedules {
  questionnaire_schedules {
    ...QuestionnaireSchedule
  }
}
    ${QuestionnaireScheduleFragmentDoc}`;

export const useGetQuestionnaireSchedulesQuery = <
      TData = GetQuestionnaireSchedulesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetQuestionnaireSchedulesQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireSchedulesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireSchedulesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireSchedulesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetQuestionnaireSchedules'] : ['GetQuestionnaireSchedules', variables],
    queryFn: fetcher<GetQuestionnaireSchedulesQuery, GetQuestionnaireSchedulesQueryVariables>(client, GetQuestionnaireSchedulesDocument, variables, headers),
    ...options
  }
    )};

export const GetUserPushNotificationIdsDocument = `
    query GetUserPushNotificationIds($id: uuid!) {
  users_by_pk(id: $id) {
    push_notification_ids
  }
}
    `;

export const useGetUserPushNotificationIdsQuery = <
      TData = GetUserPushNotificationIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserPushNotificationIdsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserPushNotificationIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserPushNotificationIdsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserPushNotificationIdsQuery, TError, TData>(
      {
    queryKey: ['GetUserPushNotificationIds', variables],
    queryFn: fetcher<GetUserPushNotificationIdsQuery, GetUserPushNotificationIdsQueryVariables>(client, GetUserPushNotificationIdsDocument, variables, headers),
    ...options
  }
    )};

export const GetOneTimeNudgesBetweenDatesDocument = `
    query GetOneTimeNudgesBetweenDates($startDate: timestamp!, $endDate: timestamp!, $blackoutDate: date!) {
  nudge_schedules(
    where: {scheduled_at: {_gte: $startDate, _lte: $endDate}, one_time: {_eq: true}}
  ) {
    ...NudgeScheduleQuery
  }
}
    ${NudgeScheduleQueryFragmentDoc}`;

export const useGetOneTimeNudgesBetweenDatesQuery = <
      TData = GetOneTimeNudgesBetweenDatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOneTimeNudgesBetweenDatesQueryVariables,
      options?: Omit<UseQueryOptions<GetOneTimeNudgesBetweenDatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOneTimeNudgesBetweenDatesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOneTimeNudgesBetweenDatesQuery, TError, TData>(
      {
    queryKey: ['GetOneTimeNudgesBetweenDates', variables],
    queryFn: fetcher<GetOneTimeNudgesBetweenDatesQuery, GetOneTimeNudgesBetweenDatesQueryVariables>(client, GetOneTimeNudgesBetweenDatesDocument, variables, headers),
    ...options
  }
    )};

export const GetUserCarePlanNudgeTakesBetweenDocument = `
    query GetUserCarePlanNudgeTakesBetween($userId: uuid!, $startDate: timestamp!, $endDate: timestamp!) {
  nudge_takes(
    where: {user_id: {_eq: $userId}, scheduled_at: {_gte: $startDate, _lte: $endDate}, nudge_schedule: {nudge: {default_messaging: {_like: "[care_plan:%"}}}}
    order_by: {scheduled_at: desc}
  ) {
    scheduled_at
  }
}
    `;

export const useGetUserCarePlanNudgeTakesBetweenQuery = <
      TData = GetUserCarePlanNudgeTakesBetweenQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserCarePlanNudgeTakesBetweenQueryVariables,
      options?: Omit<UseQueryOptions<GetUserCarePlanNudgeTakesBetweenQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserCarePlanNudgeTakesBetweenQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserCarePlanNudgeTakesBetweenQuery, TError, TData>(
      {
    queryKey: ['GetUserCarePlanNudgeTakesBetween', variables],
    queryFn: fetcher<GetUserCarePlanNudgeTakesBetweenQuery, GetUserCarePlanNudgeTakesBetweenQueryVariables>(client, GetUserCarePlanNudgeTakesBetweenDocument, variables, headers),
    ...options
  }
    )};

export const GetRecurringNudgesDocument = `
    query GetRecurringNudges($startDate: timestamp!, $endDate: timestamp!, $blackoutDate: date!) {
  nudge_schedules(where: {one_time: {_eq: false}}) {
    ...NudgeScheduleQuery
  }
}
    ${NudgeScheduleQueryFragmentDoc}`;

export const useGetRecurringNudgesQuery = <
      TData = GetRecurringNudgesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRecurringNudgesQueryVariables,
      options?: Omit<UseQueryOptions<GetRecurringNudgesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecurringNudgesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRecurringNudgesQuery, TError, TData>(
      {
    queryKey: ['GetRecurringNudges', variables],
    queryFn: fetcher<GetRecurringNudgesQuery, GetRecurringNudgesQueryVariables>(client, GetRecurringNudgesDocument, variables, headers),
    ...options
  }
    )};

export const GetRecurringQuestionnairesDocument = `
    query GetRecurringQuestionnaires($startDate: timestamp!, $endDate: timestamp!, $blackoutDate: date!) {
  questionnaire_schedules(where: {one_time: {_eq: false}}) {
    ...QuestionnaireScheduleQuery
  }
}
    ${QuestionnaireScheduleQueryFragmentDoc}`;

export const useGetRecurringQuestionnairesQuery = <
      TData = GetRecurringQuestionnairesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRecurringQuestionnairesQueryVariables,
      options?: Omit<UseQueryOptions<GetRecurringQuestionnairesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRecurringQuestionnairesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRecurringQuestionnairesQuery, TError, TData>(
      {
    queryKey: ['GetRecurringQuestionnaires', variables],
    queryFn: fetcher<GetRecurringQuestionnairesQuery, GetRecurringQuestionnairesQueryVariables>(client, GetRecurringQuestionnairesDocument, variables, headers),
    ...options
  }
    )};

export const GetOneTimeQuestionnairesBetweenDatesDocument = `
    query GetOneTimeQuestionnairesBetweenDates($startDate: timestamp!, $endDate: timestamp!, $blackoutDate: date!) {
  questionnaire_schedules(
    where: {scheduled_at: {_gte: $startDate, _lte: $endDate}, one_time: {_eq: true}}
  ) {
    ...QuestionnaireScheduleQuery
  }
}
    ${QuestionnaireScheduleQueryFragmentDoc}`;

export const useGetOneTimeQuestionnairesBetweenDatesQuery = <
      TData = GetOneTimeQuestionnairesBetweenDatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOneTimeQuestionnairesBetweenDatesQueryVariables,
      options?: Omit<UseQueryOptions<GetOneTimeQuestionnairesBetweenDatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOneTimeQuestionnairesBetweenDatesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOneTimeQuestionnairesBetweenDatesQuery, TError, TData>(
      {
    queryKey: ['GetOneTimeQuestionnairesBetweenDates', variables],
    queryFn: fetcher<GetOneTimeQuestionnairesBetweenDatesQuery, GetOneTimeQuestionnairesBetweenDatesQueryVariables>(client, GetOneTimeQuestionnairesBetweenDatesDocument, variables, headers),
    ...options
  }
    )};

export const GetUserOrganizationAdminsDocument = `
    query GetUserOrganizationAdmins($id: uuid!) {
  users_by_pk(id: $id) {
    organization_admins {
      organization_id
    }
  }
}
    `;

export const useGetUserOrganizationAdminsQuery = <
      TData = GetUserOrganizationAdminsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserOrganizationAdminsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserOrganizationAdminsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserOrganizationAdminsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserOrganizationAdminsQuery, TError, TData>(
      {
    queryKey: ['GetUserOrganizationAdmins', variables],
    queryFn: fetcher<GetUserOrganizationAdminsQuery, GetUserOrganizationAdminsQueryVariables>(client, GetUserOrganizationAdminsDocument, variables, headers),
    ...options
  }
    )};

export const GetPendingUserInviteDocument = `
    query GetPendingUserInvite($email: String!) {
  user_invites(where: {email: {_eq: $email}, status: {_eq: "pending"}}) {
    id
    role
    organization_id
  }
}
    `;

export const useGetPendingUserInviteQuery = <
      TData = GetPendingUserInviteQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPendingUserInviteQueryVariables,
      options?: Omit<UseQueryOptions<GetPendingUserInviteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPendingUserInviteQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPendingUserInviteQuery, TError, TData>(
      {
    queryKey: ['GetPendingUserInvite', variables],
    queryFn: fetcher<GetPendingUserInviteQuery, GetPendingUserInviteQueryVariables>(client, GetPendingUserInviteDocument, variables, headers),
    ...options
  }
    )};

export const GetPractitionerDataDocument = `
    query GetPractitionerData($id: uuid!) {
  users_by_pk(id: $id) {
    ...Practitioner
  }
}
    ${PractitionerFragmentDoc}`;

export const useGetPractitionerDataQuery = <
      TData = GetPractitionerDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPractitionerDataQueryVariables,
      options?: Omit<UseQueryOptions<GetPractitionerDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPractitionerDataQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPractitionerDataQuery, TError, TData>(
      {
    queryKey: ['GetPractitionerData', variables],
    queryFn: fetcher<GetPractitionerDataQuery, GetPractitionerDataQueryVariables>(client, GetPractitionerDataDocument, variables, headers),
    ...options
  }
    )};

export const GetUserInviteByEmailDocument = `
    query GetUserInviteByEmail($email: String!) {
  user_invites(where: {email: {_eq: $email}}) {
    id
  }
}
    `;

export const useGetUserInviteByEmailQuery = <
      TData = GetUserInviteByEmailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserInviteByEmailQueryVariables,
      options?: Omit<UseQueryOptions<GetUserInviteByEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserInviteByEmailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserInviteByEmailQuery, TError, TData>(
      {
    queryKey: ['GetUserInviteByEmail', variables],
    queryFn: fetcher<GetUserInviteByEmailQuery, GetUserInviteByEmailQueryVariables>(client, GetUserInviteByEmailDocument, variables, headers),
    ...options
  }
    )};

export const AuthAccountsByEmailDocument = `
    query AuthAccountsByEmail($email: citext!) {
  auth_accounts(where: {email: {_eq: $email}}) {
    user_id
  }
}
    `;

export const useAuthAccountsByEmailQuery = <
      TData = AuthAccountsByEmailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AuthAccountsByEmailQueryVariables,
      options?: Omit<UseQueryOptions<AuthAccountsByEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AuthAccountsByEmailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<AuthAccountsByEmailQuery, TError, TData>(
      {
    queryKey: ['AuthAccountsByEmail', variables],
    queryFn: fetcher<AuthAccountsByEmailQuery, AuthAccountsByEmailQueryVariables>(client, AuthAccountsByEmailDocument, variables, headers),
    ...options
  }
    )};

export const GetClientsForNotificationDocument = `
    query GetClientsForNotification {
  users(where: {account: {default_role: {_eq: "user"}}}) {
    id
    last_check_in_notification
    notification_time
    push_notification_ids
    mood_measurements(order_by: {client_created_on: desc}, limit: 1) {
      client_created_on
    }
  }
}
    `;

export const useGetClientsForNotificationQuery = <
      TData = GetClientsForNotificationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClientsForNotificationQueryVariables,
      options?: Omit<UseQueryOptions<GetClientsForNotificationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientsForNotificationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetClientsForNotificationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetClientsForNotification'] : ['GetClientsForNotification', variables],
    queryFn: fetcher<GetClientsForNotificationQuery, GetClientsForNotificationQueryVariables>(client, GetClientsForNotificationDocument, variables, headers),
    ...options
  }
    )};

export const GetPractitionerDocument = `
    query GetPractitioner($userId: uuid!) {
  users_by_pk(id: $userId) {
    id
    full_name
    first_name
    last_name
    phone_number
    account {
      email
      account_providers {
        id
      }
    }
    organization_admins {
      organization_id
    }
    organization_members {
      organization_id
      organization {
        id
        name
        location
      }
    }
  }
}
    `;

export const useGetPractitionerQuery = <
      TData = GetPractitionerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPractitionerQueryVariables,
      options?: Omit<UseQueryOptions<GetPractitionerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPractitionerQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPractitionerQuery, TError, TData>(
      {
    queryKey: ['GetPractitioner', variables],
    queryFn: fetcher<GetPractitionerQuery, GetPractitionerQueryVariables>(client, GetPractitionerDocument, variables, headers),
    ...options
  }
    )};

export const GetOrganizationDocument = `
    query GetOrganization($id: Int!) {
  organizations_by_pk(id: $id) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

export const useGetOrganizationQuery = <
      TData = GetOrganizationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrganizationQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrganizationQuery, TError, TData>(
      {
    queryKey: ['GetOrganization', variables],
    queryFn: fetcher<GetOrganizationQuery, GetOrganizationQueryVariables>(client, GetOrganizationDocument, variables, headers),
    ...options
  }
    )};

export const GetOrgPractitionerCountsDocument = `
    query GetOrgPractitionerCounts($orgId: Int = -1) {
  active: organization_members {
    ...practitionerCounts
  }
  pending: user_invites(
    where: {organization_id: {_eq: $orgId}, status: {_eq: "pending"}}
  ) {
    id
    email
    last_name
    first_name
    status
    role
  }
}
    ${PractitionerCountsFragmentDoc}`;

export const useGetOrgPractitionerCountsQuery = <
      TData = GetOrgPractitionerCountsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrgPractitionerCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetOrgPractitionerCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrgPractitionerCountsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrgPractitionerCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetOrgPractitionerCounts'] : ['GetOrgPractitionerCounts', variables],
    queryFn: fetcher<GetOrgPractitionerCountsQuery, GetOrgPractitionerCountsQueryVariables>(client, GetOrgPractitionerCountsDocument, variables, headers),
    ...options
  }
    )};

export const MyOrganizationDocument = `
    query MyOrganization($orgId: Int = -1, $date: timestamptz = "1999-12-31") {
  allActiveNudges: vw_org_nudge_technique_counts(
    where: {organization_id: {_eq: $orgId}, active: {_eq: true}}
    order_by: {count: desc}
  ) {
    active
    domain
    technique
    count
  }
  topTenActiveNudges: vw_org_nudge_technique_counts(
    where: {organization_id: {_eq: $orgId}, active: {_eq: true}}
    order_by: {count: desc}
    limit: 10
  ) {
    active
    domain
    technique
    count
  }
  mostActiveNudges: vw_org_nudge_technique_counts(
    where: {organization_id: {_eq: $orgId}, active: {_eq: true}}
    order_by: {count: desc}
    limit: 3
  ) {
    active
    domain
    technique
    count
  }
  leastActiveNudges: vw_org_nudge_technique_counts(
    where: {organization_id: {_eq: $orgId}, active: {_eq: true}}
    order_by: {count: asc}
    limit: 3
  ) {
    active
    domain
    technique
    count
  }
  clientCount: vw_org_client_count(where: {organization_id: {_eq: $orgId}}) {
    count: client_count
  }
  nudgeCount: vw_org_nudge_count(where: {organization_id: {_eq: $orgId}}) {
    count: nudge_count
  }
  questionnaireCount: vw_org_questionnaire_count(
    where: {organization_id: {_eq: $orgId}}
  ) {
    count: questionnaire_count
  }
  activeClientsWithRecentQuestionnaire: users(
    where: {client_invite_codes: {status: {_eq: "connected"}}, questionnaire_takes: {completed_at: {_gte: $date}}}
    order_by: {questionnaire_takes_aggregate: {max: {severity_score: desc_nulls_last}}}
  ) {
    id
    questionnaire_takes_aggregate {
      aggregate {
        max {
          severity_score
        }
      }
    }
  }
  totalActiveClients: users(
    where: {client_invite_codes: {status: {_eq: "connected"}}}
  ) {
    id
  }
}
    `;

export const useMyOrganizationQuery = <
      TData = MyOrganizationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MyOrganizationQueryVariables,
      options?: Omit<UseQueryOptions<MyOrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MyOrganizationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<MyOrganizationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MyOrganization'] : ['MyOrganization', variables],
    queryFn: fetcher<MyOrganizationQuery, MyOrganizationQueryVariables>(client, MyOrganizationDocument, variables, headers),
    ...options
  }
    )};

export const OrgWithPractCountsWithCasemixDocument = `
    query OrgWithPractCountsWithCasemix($date: timestamptz = "1999-12-31") {
  organization_members {
    practitioner {
      id
      email: display_name
      last_name
      first_name
      client_count: practitioner_invite_codes_aggregate {
        aggregate {
          count
        }
      }
      nudge_count: nudgeSchedulesByPractitionerId_aggregate {
        aggregate {
          count
        }
      }
      questionnaire_count: questionnaireSchedulesByPractitionerId_aggregate {
        aggregate {
          count
        }
      }
      activeClientsWithRecentQuestionnaire: practitioner_invite_codes(
        where: {user: {is_onboarded: {_eq: true}, client_invite_codes: {status: {_eq: "connected"}}, questionnaire_takes: {completed_at: {_gte: $date}}}}
        order_by: {user: {questionnaire_takes_aggregate: {max: {severity_score: desc_nulls_last}}}}
      ) {
        user {
          id
          questionnaire_takes_aggregate {
            aggregate {
              max {
                severity_score
              }
            }
          }
        }
      }
      totalActiveClients: practitioner_invite_codes(
        where: {user: {is_onboarded: {_eq: true}, client_invite_codes: {status: {_eq: "connected"}}}}
      ) {
        user {
          id
        }
      }
    }
  }
}
    `;

export const useOrgWithPractCountsWithCasemixQuery = <
      TData = OrgWithPractCountsWithCasemixQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: OrgWithPractCountsWithCasemixQueryVariables,
      options?: Omit<UseQueryOptions<OrgWithPractCountsWithCasemixQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrgWithPractCountsWithCasemixQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<OrgWithPractCountsWithCasemixQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['OrgWithPractCountsWithCasemix'] : ['OrgWithPractCountsWithCasemix', variables],
    queryFn: fetcher<OrgWithPractCountsWithCasemixQuery, OrgWithPractCountsWithCasemixQueryVariables>(client, OrgWithPractCountsWithCasemixDocument, variables, headers),
    ...options
  }
    )};

export const GetUsersByPractitionerDocument = `
    query GetUsersByPractitioner($practitioner_id: uuid) {
  users(where: {client_invite_codes: {practitioner_id: {_eq: $practitioner_id}}}) {
    id
    display_name
    full_name
    first_name
    last_name
    is_onboarded
    notification_time
    phone_number
    client_invite_codes(where: {practitioner_id: {_eq: $practitioner_id}}) {
      status
      code
      ended_at
      created_at
    }
    mood_measurements_aggregate {
      aggregate {
        count
      }
    }
    mostRecentScoredQuestionnaires {
      completed_at
      questionnaire_id
      questionnaire_name
      questionnaire_take_id
      display_score
      display_score_type
      scoring_display_color
      scoring_display_name
    }
    client_demographics(where: {practitioner_id: {_eq: $practitioner_id}}) {
      ...ClientDemographics
    }
  }
}
    ${ClientDemographicsFragmentDoc}`;

export const useGetUsersByPractitionerQuery = <
      TData = GetUsersByPractitionerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUsersByPractitionerQueryVariables,
      options?: Omit<UseQueryOptions<GetUsersByPractitionerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUsersByPractitionerQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUsersByPractitionerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUsersByPractitioner'] : ['GetUsersByPractitioner', variables],
    queryFn: fetcher<GetUsersByPractitionerQuery, GetUsersByPractitionerQueryVariables>(client, GetUsersByPractitionerDocument, variables, headers),
    ...options
  }
    )};

export const GetPractionersForUserDocument = `
    query GetPractionersForUser {
  invite_codes {
    code
    status
    practitioner_id
    userByPractitionerId {
      first_name
      last_name
    }
  }
}
    `;

export const useGetPractionersForUserQuery = <
      TData = GetPractionersForUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetPractionersForUserQueryVariables,
      options?: Omit<UseQueryOptions<GetPractionersForUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPractionersForUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPractionersForUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPractionersForUser'] : ['GetPractionersForUser', variables],
    queryFn: fetcher<GetPractionersForUserQuery, GetPractionersForUserQueryVariables>(client, GetPractionersForUserDocument, variables, headers),
    ...options
  }
    )};

export const NudgesScheduleByUserDocument = `
    query NudgesScheduleByUser($user_id: uuid) {
  nudge_schedules(where: {user_id: {_eq: $user_id}}) {
    id
    ...NudgeSchedule
    nudge_takes {
      id
      created_at
      completed_at
    }
  }
}
    ${NudgeScheduleFragmentDoc}`;

export const useNudgesScheduleByUserQuery = <
      TData = NudgesScheduleByUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: NudgesScheduleByUserQueryVariables,
      options?: Omit<UseQueryOptions<NudgesScheduleByUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NudgesScheduleByUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<NudgesScheduleByUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['NudgesScheduleByUser'] : ['NudgesScheduleByUser', variables],
    queryFn: fetcher<NudgesScheduleByUserQuery, NudgesScheduleByUserQueryVariables>(client, NudgesScheduleByUserDocument, variables, headers),
    ...options
  }
    )};

export const QuestionnairesScheduleByUserDocument = `
    query QuestionnairesScheduleByUser($user_id: uuid) {
  questionnaire_schedules(where: {user_id: {_eq: $user_id}}) {
    id
    ...QuestionnaireSchedule
    questionnaire_takes {
      id
      created_at
      completed_at
      completion_status
      questionnaire_responses {
        ...QuestionnaireResponse
      }
    }
  }
}
    ${QuestionnaireScheduleFragmentDoc}
${QuestionnaireResponseFragmentDoc}`;

export const useQuestionnairesScheduleByUserQuery = <
      TData = QuestionnairesScheduleByUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: QuestionnairesScheduleByUserQueryVariables,
      options?: Omit<UseQueryOptions<QuestionnairesScheduleByUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<QuestionnairesScheduleByUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<QuestionnairesScheduleByUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['QuestionnairesScheduleByUser'] : ['QuestionnairesScheduleByUser', variables],
    queryFn: fetcher<QuestionnairesScheduleByUserQuery, QuestionnairesScheduleByUserQueryVariables>(client, QuestionnairesScheduleByUserDocument, variables, headers),
    ...options
  }
    )};

export const GetClientNotificationTokensDocument = `
    query GetClientNotificationTokens($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    push_notification_ids
  }
}
    `;

export const useGetClientNotificationTokensQuery = <
      TData = GetClientNotificationTokensQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClientNotificationTokensQueryVariables,
      options?: Omit<UseQueryOptions<GetClientNotificationTokensQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientNotificationTokensQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetClientNotificationTokensQuery, TError, TData>(
      {
    queryKey: ['GetClientNotificationTokens', variables],
    queryFn: fetcher<GetClientNotificationTokensQuery, GetClientNotificationTokensQueryVariables>(client, GetClientNotificationTokensDocument, variables, headers),
    ...options
  }
    )};

export const GetPendingPractitionerDocument = `
    query GetPendingPractitioner($id: uuid!) {
  users_by_pk(id: $id) {
    id
    first_name
    last_name
  }
}
    `;

export const useGetPendingPractitionerQuery = <
      TData = GetPendingPractitionerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPendingPractitionerQueryVariables,
      options?: Omit<UseQueryOptions<GetPendingPractitionerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPendingPractitionerQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPendingPractitionerQuery, TError, TData>(
      {
    queryKey: ['GetPendingPractitioner', variables],
    queryFn: fetcher<GetPendingPractitionerQuery, GetPendingPractitionerQueryVariables>(client, GetPendingPractitionerDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakeByIdDocument = `
    query GetQuestionnaireTakeById($id: Int!) {
  questionnaire_takes_by_pk(id: $id) {
    ...QuestionnaireTake
  }
}
    ${QuestionnaireTakeFragmentDoc}`;

export const useGetQuestionnaireTakeByIdQuery = <
      TData = GetQuestionnaireTakeByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireTakeByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakeByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakeByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakeByIdQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireTakeById', variables],
    queryFn: fetcher<GetQuestionnaireTakeByIdQuery, GetQuestionnaireTakeByIdQueryVariables>(client, GetQuestionnaireTakeByIdDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakeByScheduleIdDocument = `
    query GetQuestionnaireTakeByScheduleId($id: Int!) {
  questionnaire_takes(where: {questionnaire_schedule_id: {_eq: $id}}) {
    ...QuestionnaireTake
  }
}
    ${QuestionnaireTakeFragmentDoc}`;

export const useGetQuestionnaireTakeByScheduleIdQuery = <
      TData = GetQuestionnaireTakeByScheduleIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireTakeByScheduleIdQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakeByScheduleIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakeByScheduleIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakeByScheduleIdQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireTakeByScheduleId', variables],
    queryFn: fetcher<GetQuestionnaireTakeByScheduleIdQuery, GetQuestionnaireTakeByScheduleIdQueryVariables>(client, GetQuestionnaireTakeByScheduleIdDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireResponseDocument = `
    query GetQuestionnaireResponse($takeId: Int!, $itemId: Int!) {
  questionnaire_responses(
    where: {questionnaire_take_id: {_eq: $takeId}, questionnaire_item_id: {_eq: $itemId}}
  ) {
    id
  }
}
    `;

export const useGetQuestionnaireResponseQuery = <
      TData = GetQuestionnaireResponseQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireResponseQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireResponseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireResponseQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireResponseQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireResponse', variables],
    queryFn: fetcher<GetQuestionnaireResponseQuery, GetQuestionnaireResponseQueryVariables>(client, GetQuestionnaireResponseDocument, variables, headers),
    ...options
  }
    )};

export const InitialGetUserDocument = `
    query InitialGetUser($userId: uuid!) {
  users(where: {id: {_eq: $userId}}) {
    ...MobileUser
  }
}
    ${MobileUserFragmentDoc}`;

export const useInitialGetUserQuery = <
      TData = InitialGetUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InitialGetUserQueryVariables,
      options?: Omit<UseQueryOptions<InitialGetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InitialGetUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<InitialGetUserQuery, TError, TData>(
      {
    queryKey: ['InitialGetUser', variables],
    queryFn: fetcher<InitialGetUserQuery, InitialGetUserQueryVariables>(client, InitialGetUserDocument, variables, headers),
    ...options
  }
    )};

export const GetMobileDeviceDataDocument = `
    query GetMobileDeviceData($user_id: uuid!) {
  mobile_device_data(where: {user_id: {_eq: $user_id}}) {
    ...MobileDeviceData
  }
}
    ${MobileDeviceDataFragmentDoc}`;

export const useGetMobileDeviceDataQuery = <
      TData = GetMobileDeviceDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMobileDeviceDataQueryVariables,
      options?: Omit<UseQueryOptions<GetMobileDeviceDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMobileDeviceDataQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMobileDeviceDataQuery, TError, TData>(
      {
    queryKey: ['GetMobileDeviceData', variables],
    queryFn: fetcher<GetMobileDeviceDataQuery, GetMobileDeviceDataQueryVariables>(client, GetMobileDeviceDataDocument, variables, headers),
    ...options
  }
    )};

export const GetInviteCodeForClientDocument = `
    query GetInviteCodeForClient($client_id: uuid!) {
  invite_codes(
    where: {client_id: {_eq: $client_id}, practitioner_id: {_is_null: true}}
  ) {
    code
  }
}
    `;

export const useGetInviteCodeForClientQuery = <
      TData = GetInviteCodeForClientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInviteCodeForClientQueryVariables,
      options?: Omit<UseQueryOptions<GetInviteCodeForClientQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInviteCodeForClientQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetInviteCodeForClientQuery, TError, TData>(
      {
    queryKey: ['GetInviteCodeForClient', variables],
    queryFn: fetcher<GetInviteCodeForClientQuery, GetInviteCodeForClientQueryVariables>(client, GetInviteCodeForClientDocument, variables, headers),
    ...options
  }
    )};

export const GetOrgInAppResourcesDocument = `
    query GetOrgInAppResources($org_id: Int) {
  resources(
    where: {_or: [{owner_org_id: {_is_null: true}}, {owner_org_id: {_eq: $org_id}}, {public: {_eq: true}}], title: {_is_null: false}}
  ) {
    author
    content
    content_type
    created_by
    created_on
    id
    owner_org_id
    header_image
    public
    title
    updated_on
  }
}
    `;

export const useGetOrgInAppResourcesQuery = <
      TData = GetOrgInAppResourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrgInAppResourcesQueryVariables,
      options?: Omit<UseQueryOptions<GetOrgInAppResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrgInAppResourcesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrgInAppResourcesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetOrgInAppResources'] : ['GetOrgInAppResources', variables],
    queryFn: fetcher<GetOrgInAppResourcesQuery, GetOrgInAppResourcesQueryVariables>(client, GetOrgInAppResourcesDocument, variables, headers),
    ...options
  }
    )};

export const GetOrgActiveTechniquesAndInterventionsDocument = `
    query GetOrgActiveTechniquesAndInterventions($org_id: Int, $user_id: uuid) {
  nudges(
    where: {_or: [{created_by: {_is_null: true}}, {owner_org_id: {_eq: $org_id}}, {public: {_eq: true}}, {created_by: {_eq: $user_id}}], _and: {active: {_eq: true}}}
    order_by: {created_at: desc}
  ) {
    created_at
    created_by
    default_messaging
    owner_org_id
    domain
    id
    active
    technique
    resource_id
    updated_at
    public
  }
}
    `;

export const useGetOrgActiveTechniquesAndInterventionsQuery = <
      TData = GetOrgActiveTechniquesAndInterventionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrgActiveTechniquesAndInterventionsQueryVariables,
      options?: Omit<UseQueryOptions<GetOrgActiveTechniquesAndInterventionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrgActiveTechniquesAndInterventionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrgActiveTechniquesAndInterventionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetOrgActiveTechniquesAndInterventions'] : ['GetOrgActiveTechniquesAndInterventions', variables],
    queryFn: fetcher<GetOrgActiveTechniquesAndInterventionsQuery, GetOrgActiveTechniquesAndInterventionsQueryVariables>(client, GetOrgActiveTechniquesAndInterventionsDocument, variables, headers),
    ...options
  }
    )};

export const GetResourceByIdDocument = `
    query GetResourceById($id: Int!) {
  resources_by_pk(id: $id) {
    ...Resources
  }
}
    ${ResourcesFragmentDoc}`;

export const useGetResourceByIdQuery = <
      TData = GetResourceByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetResourceByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetResourceByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResourceByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetResourceByIdQuery, TError, TData>(
      {
    queryKey: ['GetResourceById', variables],
    queryFn: fetcher<GetResourceByIdQuery, GetResourceByIdQueryVariables>(client, GetResourceByIdDocument, variables, headers),
    ...options
  }
    )};

export const GetAllInAppResourcesDocument = `
    query GetAllInAppResources {
  resources(where: {title: {_is_null: false}}) {
    author
    content
    content_type
    created_by
    created_on
    id
    header_image
    owner_org_id
    public
    title
    updated_on
  }
}
    `;

export const useGetAllInAppResourcesQuery = <
      TData = GetAllInAppResourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllInAppResourcesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllInAppResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllInAppResourcesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllInAppResourcesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAllInAppResources'] : ['GetAllInAppResources', variables],
    queryFn: fetcher<GetAllInAppResourcesQuery, GetAllInAppResourcesQueryVariables>(client, GetAllInAppResourcesDocument, variables, headers),
    ...options
  }
    )};

export const GetMoodMeasurementsByUserIdDocument = `
    query GetMoodMeasurementsByUserId($id: uuid) {
  mood_measurements(where: {user_id: {_eq: $id}}) {
    client_created_on
    created_on
    enjoyment
    growth
    cravings
    user_id
  }
}
    `;

export const useGetMoodMeasurementsByUserIdQuery = <
      TData = GetMoodMeasurementsByUserIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMoodMeasurementsByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<GetMoodMeasurementsByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMoodMeasurementsByUserIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMoodMeasurementsByUserIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMoodMeasurementsByUserId'] : ['GetMoodMeasurementsByUserId', variables],
    queryFn: fetcher<GetMoodMeasurementsByUserIdQuery, GetMoodMeasurementsByUserIdQueryVariables>(client, GetMoodMeasurementsByUserIdDocument, variables, headers),
    ...options
  }
    )};

export const GetUserInsightsWithResourcesDocument = `
    query GetUserInsightsWithResources($user_id: uuid!) {
  user_insights(
    where: {user_id: {_eq: $user_id}, insightRecipe: {schema_version: {_eq: 2}}}
    order_by: {created_on: desc}
  ) {
    created_on
    id
    seen
    insight_combo {
      direction
      feature
      id
      outcome
      display_text
      observe_text
    }
    insightRecipe {
      id
      schema_version
      planImageURL
      observeText {
        content
        imageURL
      }
      planText {
        content
      }
      reflectText {
        content
      }
      insight_reflects {
        reflectHeading {
          content
        }
        insight_reflect_texts {
          insight_text {
            content
          }
        }
      }
      insight_plans {
        id
        type
        responseText {
          content
        }
        insight_plan_texts {
          insight_text {
            content
          }
        }
        insight_plan_articles {
          resource {
            created_on
            content
            title
            author
            content_type
            header_image
            id
          }
        }
      }
    }
  }
}
    `;

export const useGetUserInsightsWithResourcesQuery = <
      TData = GetUserInsightsWithResourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserInsightsWithResourcesQueryVariables,
      options?: Omit<UseQueryOptions<GetUserInsightsWithResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserInsightsWithResourcesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserInsightsWithResourcesQuery, TError, TData>(
      {
    queryKey: ['GetUserInsightsWithResources', variables],
    queryFn: fetcher<GetUserInsightsWithResourcesQuery, GetUserInsightsWithResourcesQueryVariables>(client, GetUserInsightsWithResourcesDocument, variables, headers),
    ...options
  }
    )};

export const GetActiveTechniquesAndInterventionsDocument = `
    query GetActiveTechniquesAndInterventions($org_id: Int, $user_id: uuid) {
  nudges(
    where: {_and: {_or: [{created_by: {_is_null: true}}, {owner_org_id: {_eq: $org_id}}, {public: {_eq: true}}, {created_by: {_eq: $user_id}}]}, active: {_eq: true}}
  ) {
    created_at
    created_by
    default_messaging
    owner_org_id
    domain
    id
    active
    technique
    resource_id
    updated_at
    public
  }
  questionnaires(
    where: {_or: [{owner_org_id: {_eq: $org_id}}, {public: {_eq: true}}, {created_by: {_eq: $user_id}}]}
  ) {
    ...Questionnaire
  }
}
    ${QuestionnaireFragmentDoc}`;

export const useGetActiveTechniquesAndInterventionsQuery = <
      TData = GetActiveTechniquesAndInterventionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActiveTechniquesAndInterventionsQueryVariables,
      options?: Omit<UseQueryOptions<GetActiveTechniquesAndInterventionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActiveTechniquesAndInterventionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActiveTechniquesAndInterventionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActiveTechniquesAndInterventions'] : ['GetActiveTechniquesAndInterventions', variables],
    queryFn: fetcher<GetActiveTechniquesAndInterventionsQuery, GetActiveTechniquesAndInterventionsQueryVariables>(client, GetActiveTechniquesAndInterventionsDocument, variables, headers),
    ...options
  }
    )};

export const GetNudgeTakesDocument = `
    query GetNudgeTakes {
  nudge_takes {
    ...NudgeTake
  }
}
    ${NudgeTakeFragmentDoc}`;

export const useGetNudgeTakesQuery = <
      TData = GetNudgeTakesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNudgeTakesQueryVariables,
      options?: Omit<UseQueryOptions<GetNudgeTakesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNudgeTakesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNudgeTakesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetNudgeTakes'] : ['GetNudgeTakes', variables],
    queryFn: fetcher<GetNudgeTakesQuery, GetNudgeTakesQueryVariables>(client, GetNudgeTakesDocument, variables, headers),
    ...options
  }
    )};

export const GetNudgeTakesByIdDocument = `
    query GetNudgeTakesById($id: Int) {
  nudge_takes(where: {id: {_eq: $id}}) {
    ...NudgeTake
  }
}
    ${NudgeTakeFragmentDoc}`;

export const useGetNudgeTakesByIdQuery = <
      TData = GetNudgeTakesByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNudgeTakesByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetNudgeTakesByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNudgeTakesByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNudgeTakesByIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetNudgeTakesById'] : ['GetNudgeTakesById', variables],
    queryFn: fetcher<GetNudgeTakesByIdQuery, GetNudgeTakesByIdQueryVariables>(client, GetNudgeTakesByIdDocument, variables, headers),
    ...options
  }
    )};

export const GetNudgeTakesAfterDocument = `
    query GetNudgeTakesAfter($scheduled_at: timestamp) {
  nudge_takes(where: {scheduled_at: {_gte: $scheduled_at}}) {
    ...NudgeTake
  }
}
    ${NudgeTakeFragmentDoc}`;

export const useGetNudgeTakesAfterQuery = <
      TData = GetNudgeTakesAfterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetNudgeTakesAfterQueryVariables,
      options?: Omit<UseQueryOptions<GetNudgeTakesAfterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNudgeTakesAfterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNudgeTakesAfterQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetNudgeTakesAfter'] : ['GetNudgeTakesAfter', variables],
    queryFn: fetcher<GetNudgeTakesAfterQuery, GetNudgeTakesAfterQueryVariables>(client, GetNudgeTakesAfterDocument, variables, headers),
    ...options
  }
    )};

export const GetDailyFeatureDataDocument = `
    query GetDailyFeatureData($create_date: order_by = desc, $key: enum_feature_type_enum!) {
  daily_features(
    where: {key: {_eq: $key}}
    order_by: {create_date: $create_date}
    limit: 1
  ) {
    create_date
    feature_date
    id
    is_user_reported_accurate
    key
    user_id
    value
  }
}
    `;

export const useGetDailyFeatureDataQuery = <
      TData = GetDailyFeatureDataQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDailyFeatureDataQueryVariables,
      options?: Omit<UseQueryOptions<GetDailyFeatureDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDailyFeatureDataQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDailyFeatureDataQuery, TError, TData>(
      {
    queryKey: ['GetDailyFeatureData', variables],
    queryFn: fetcher<GetDailyFeatureDataQuery, GetDailyFeatureDataQueryVariables>(client, GetDailyFeatureDataDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakesDocument = `
    query GetQuestionnaireTakes {
  questionnaire_takes {
    ...QuestionnaireTake
  }
}
    ${QuestionnaireTakeFragmentDoc}`;

export const useGetQuestionnaireTakesQuery = <
      TData = GetQuestionnaireTakesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetQuestionnaireTakesQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetQuestionnaireTakes'] : ['GetQuestionnaireTakes', variables],
    queryFn: fetcher<GetQuestionnaireTakesQuery, GetQuestionnaireTakesQueryVariables>(client, GetQuestionnaireTakesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakesAfterDocument = `
    query GetQuestionnaireTakesAfter($scheduled_at: timestamp) {
  questionnaire_takes(where: {scheduled_at: {_gte: $scheduled_at}}) {
    ...QuestionnaireTake
  }
}
    ${QuestionnaireTakeFragmentDoc}`;

export const useGetQuestionnaireTakesAfterQuery = <
      TData = GetQuestionnaireTakesAfterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetQuestionnaireTakesAfterQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakesAfterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakesAfterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakesAfterQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetQuestionnaireTakesAfter'] : ['GetQuestionnaireTakesAfter', variables],
    queryFn: fetcher<GetQuestionnaireTakesAfterQuery, GetQuestionnaireTakesAfterQueryVariables>(client, GetQuestionnaireTakesAfterDocument, variables, headers),
    ...options
  }
    )};

export const RecentQuestionnaireTakesByUserIdDocument = `
    query RecentQuestionnaireTakesByUserId($userId: uuid!, $count: Int = 5) {
  questionnaire_takes(
    where: {user_id: {_eq: $userId}}
    order_by: {completed_at: desc_nulls_last}
  ) {
    rating_score
    raw_score
    severity_score
    completed_at
    questionnaire_schedule {
      questionnaire {
        id
        name
      }
    }
  }
}
    `;

export const useRecentQuestionnaireTakesByUserIdQuery = <
      TData = RecentQuestionnaireTakesByUserIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RecentQuestionnaireTakesByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<RecentQuestionnaireTakesByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RecentQuestionnaireTakesByUserIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<RecentQuestionnaireTakesByUserIdQuery, TError, TData>(
      {
    queryKey: ['RecentQuestionnaireTakesByUserId', variables],
    queryFn: fetcher<RecentQuestionnaireTakesByUserIdQuery, RecentQuestionnaireTakesByUserIdQueryVariables>(client, RecentQuestionnaireTakesByUserIdDocument, variables, headers),
    ...options
  }
    )};

export const QuestionnaireTakesSinceDateByUserIdDocument = `
    query QuestionnaireTakesSinceDateByUserId($userId: uuid!, $sinceDate: timestamptz = "2022-05-01") {
  questionnaire_takes(
    where: {user_id: {_eq: $userId}, completed_at: {_gt: $sinceDate}}
    order_by: {completed_at: desc_nulls_last}
  ) {
    rating_score
    raw_score
    severity_score
    completed_at
    completion_status
    questionnaire_responses {
      questionnaire_item {
        question
        header
        display_order
      }
      questionnaire_response_options {
        response_text
        response_value
        triggers_risk_alert
      }
    }
    questionnaireDisplayValues {
      questionnaire_id
      questionnaire_name
      display_score
      display_score_type
      scoring_display_color
      scoring_display_name
    }
    questionnaire_schedule {
      questionnaire {
        contains_risk_questions
        name
        id
        questionnaire_items {
          questionnaire_id
          question
          questionnaire_items_questionnaire_response_options {
            response_text
            triggers_risk_alert
            response_value
          }
          display_order
        }
      }
    }
  }
}
    `;

export const useQuestionnaireTakesSinceDateByUserIdQuery = <
      TData = QuestionnaireTakesSinceDateByUserIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: QuestionnaireTakesSinceDateByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<QuestionnaireTakesSinceDateByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<QuestionnaireTakesSinceDateByUserIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<QuestionnaireTakesSinceDateByUserIdQuery, TError, TData>(
      {
    queryKey: ['QuestionnaireTakesSinceDateByUserId', variables],
    queryFn: fetcher<QuestionnaireTakesSinceDateByUserIdQuery, QuestionnaireTakesSinceDateByUserIdQueryVariables>(client, QuestionnaireTakesSinceDateByUserIdDocument, variables, headers),
    ...options
  }
    )};

export const GetRiskAlertLogByIdDocument = `
    query GetRiskAlertLogById($id: uuid!) {
  risk_alerts_log(where: {id: {_eq: $id}}) {
    risk_alerts_log_questionnaire_take {
      questionnaire_responses {
        created_at
        id
        questionnaire_response_options {
          response_value
          triggers_risk_alert
          response_text
        }
        questionnaire_item {
          question
          header
          display_order
        }
      }
      user {
        display_name
        first_name
        last_name
        id
      }
      questionnaire_schedule {
        questionnaire {
          id
          name
        }
      }
      completed_at
    }
  }
}
    `;

export const useGetRiskAlertLogByIdQuery = <
      TData = GetRiskAlertLogByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRiskAlertLogByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetRiskAlertLogByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRiskAlertLogByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRiskAlertLogByIdQuery, TError, TData>(
      {
    queryKey: ['GetRiskAlertLogById', variables],
    queryFn: fetcher<GetRiskAlertLogByIdQuery, GetRiskAlertLogByIdQueryVariables>(client, GetRiskAlertLogByIdDocument, variables, headers),
    ...options
  }
    )};

export const GetDailyFeatureByDateDocument = `
    query GetDailyFeatureByDate($feature_date: order_by = desc, $feature_date_stamp: timestamptz!) {
  daily_features(
    where: {feature_date: {_eq: $feature_date_stamp}}
    order_by: {feature_date: $feature_date}
  ) {
    create_date
    feature_date
    id
    is_user_reported_accurate
    key
    user_id
    value
  }
}
    `;

export const useGetDailyFeatureByDateQuery = <
      TData = GetDailyFeatureByDateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDailyFeatureByDateQueryVariables,
      options?: Omit<UseQueryOptions<GetDailyFeatureByDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDailyFeatureByDateQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDailyFeatureByDateQuery, TError, TData>(
      {
    queryKey: ['GetDailyFeatureByDate', variables],
    queryFn: fetcher<GetDailyFeatureByDateQuery, GetDailyFeatureByDateQueryVariables>(client, GetDailyFeatureByDateDocument, variables, headers),
    ...options
  }
    )};

export const GetDailyFeaturesSinceDocument = `
    query GetDailyFeaturesSince($feature_date: timestamptz!, $feature_date_order: order_by = desc) {
  daily_features(
    where: {feature_date: {_gt: $feature_date}}
    order_by: {feature_date: $feature_date_order}
  ) {
    create_date
    feature_date
    id
    is_user_reported_accurate
    key
    user_id
    value
  }
}
    `;

export const useGetDailyFeaturesSinceQuery = <
      TData = GetDailyFeaturesSinceQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDailyFeaturesSinceQueryVariables,
      options?: Omit<UseQueryOptions<GetDailyFeaturesSinceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDailyFeaturesSinceQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDailyFeaturesSinceQuery, TError, TData>(
      {
    queryKey: ['GetDailyFeaturesSince', variables],
    queryFn: fetcher<GetDailyFeaturesSinceQuery, GetDailyFeaturesSinceQueryVariables>(client, GetDailyFeaturesSinceDocument, variables, headers),
    ...options
  }
    )};

export const InsightV2Document = `
    query InsightV2($id: Int!) {
  insight_recipes_by_pk(id: $id) {
    id
    owner_org_id
    schema_version
    public
    planImageURL
    insight_combo {
      id
      feature
      display_text
    }
    observeText {
      content
      imageURL
    }
    reflectText {
      content
    }
    insight_reflects {
      reflectHeading {
        content
      }
      insight_reflect_texts {
        insight_text {
          content
        }
      }
    }
    planText {
      content
    }
    insight_plans {
      type
      responseText {
        content
      }
      insight_plan_texts {
        insight_text {
          content
        }
      }
      insight_plan_articles {
        resource {
          header_image
          content
          title
        }
      }
    }
  }
}
    `;

export const useInsightV2Query = <
      TData = InsightV2Query,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InsightV2QueryVariables,
      options?: Omit<UseQueryOptions<InsightV2Query, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InsightV2Query, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<InsightV2Query, TError, TData>(
      {
    queryKey: ['InsightV2', variables],
    queryFn: fetcher<InsightV2Query, InsightV2QueryVariables>(client, InsightV2Document, variables, headers),
    ...options
  }
    )};

export const AllSchema2RecipePKsDocument = `
    query AllSchema2RecipePKs {
  insight_recipes(
    where: {schema_version: {_eq: 2}}
    order_by: {insight_combo: {display_text: asc}}
  ) {
    id
    insight_combo {
      display_text
      outcome
      feature
      id
    }
  }
}
    `;

export const useAllSchema2RecipePKsQuery = <
      TData = AllSchema2RecipePKsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: AllSchema2RecipePKsQueryVariables,
      options?: Omit<UseQueryOptions<AllSchema2RecipePKsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllSchema2RecipePKsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<AllSchema2RecipePKsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['AllSchema2RecipePKs'] : ['AllSchema2RecipePKs', variables],
    queryFn: fetcher<AllSchema2RecipePKsQuery, AllSchema2RecipePKsQueryVariables>(client, AllSchema2RecipePKsDocument, variables, headers),
    ...options
  }
    )};

export const CheckGroupCodeDocument = `
    query CheckGroupCode($code: citext!) {
  group_code(where: {code: {_eq: $code}}) {
    id
    code
  }
}
    `;

export const useCheckGroupCodeQuery = <
      TData = CheckGroupCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CheckGroupCodeQueryVariables,
      options?: Omit<UseQueryOptions<CheckGroupCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckGroupCodeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<CheckGroupCodeQuery, TError, TData>(
      {
    queryKey: ['CheckGroupCode', variables],
    queryFn: fetcher<CheckGroupCodeQuery, CheckGroupCodeQueryVariables>(client, CheckGroupCodeDocument, variables, headers),
    ...options
  }
    )};

export const GetLastTenMoodMeasurementsByUserIdDocument = `
    query GetLastTenMoodMeasurementsByUserId($id: uuid) {
  mood_measurements(
    where: {user_id: {_eq: $id}}
    order_by: {client_created_on: desc_nulls_last}
    limit: 10
  ) {
    client_created_on
    created_on
    enjoyment
    growth
    cravings
    user_id
  }
}
    `;

export const useGetLastTenMoodMeasurementsByUserIdQuery = <
      TData = GetLastTenMoodMeasurementsByUserIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetLastTenMoodMeasurementsByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<GetLastTenMoodMeasurementsByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLastTenMoodMeasurementsByUserIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetLastTenMoodMeasurementsByUserIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetLastTenMoodMeasurementsByUserId'] : ['GetLastTenMoodMeasurementsByUserId', variables],
    queryFn: fetcher<GetLastTenMoodMeasurementsByUserIdQuery, GetLastTenMoodMeasurementsByUserIdQueryVariables>(client, GetLastTenMoodMeasurementsByUserIdDocument, variables, headers),
    ...options
  }
    )};

export const GetOrganizationFeaturesDocument = `
    query GetOrganizationFeatures {
  organization_features {
    org_id
    second_checkin_question
    brite_features
    mvp2_features
    vira_path
    vira_scribe
    vira_loop
  }
}
    `;

export const useGetOrganizationFeaturesQuery = <
      TData = GetOrganizationFeaturesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrganizationFeaturesQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationFeaturesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationFeaturesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrganizationFeaturesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetOrganizationFeatures'] : ['GetOrganizationFeatures', variables],
    queryFn: fetcher<GetOrganizationFeaturesQuery, GetOrganizationFeaturesQueryVariables>(client, GetOrganizationFeaturesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireExpirationDocument = `
    query GetQuestionnaireExpiration($id: Int!) {
  questionnaires_by_pk(id: $id) {
    minutes_to_expiration
  }
}
    `;

export const useGetQuestionnaireExpirationQuery = <
      TData = GetQuestionnaireExpirationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireExpirationQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireExpirationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireExpirationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireExpirationQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireExpiration', variables],
    queryFn: fetcher<GetQuestionnaireExpirationQuery, GetQuestionnaireExpirationQueryVariables>(client, GetQuestionnaireExpirationDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireSchedulesExpirationDocument = `
    query GetQuestionnaireSchedulesExpiration($id: Int!) {
  questionnaire_schedules_by_pk(id: $id) {
    minutes_to_expiration
  }
}
    `;

export const useGetQuestionnaireSchedulesExpirationQuery = <
      TData = GetQuestionnaireSchedulesExpirationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireSchedulesExpirationQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireSchedulesExpirationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireSchedulesExpirationQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireSchedulesExpirationQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireSchedulesExpiration', variables],
    queryFn: fetcher<GetQuestionnaireSchedulesExpirationQuery, GetQuestionnaireSchedulesExpirationQueryVariables>(client, GetQuestionnaireSchedulesExpirationDocument, variables, headers),
    ...options
  }
    )};

export const GetRiskAlertContactsDocument = `
    query GetRiskAlertContacts($RiskAlertId: uuid = "") {
  risk_alerts_log(where: {id: {_eq: $RiskAlertId}}) {
    risk_alerts_log_questionnaire_take {
      questionnaire_schedule {
        practitioner {
          account {
            email
          }
          first_name
          last_name
          phone_number
          most_recent_timezone
          id
        }
        questionnaire {
          questionnaires_questionnaire_risk_alert_contacts {
            questionnaire_risk_alert_contacts_user {
              id
              first_name
              last_name
              phone_number
              most_recent_timezone
              account {
                email
              }
            }
          }
          name
          questionnaires_organization {
            name
          }
        }
        user {
          most_recent_timezone
        }
      }
      completed_at
    }
  }
}
    `;

export const useGetRiskAlertContactsQuery = <
      TData = GetRiskAlertContactsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRiskAlertContactsQueryVariables,
      options?: Omit<UseQueryOptions<GetRiskAlertContactsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRiskAlertContactsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRiskAlertContactsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRiskAlertContacts'] : ['GetRiskAlertContacts', variables],
    queryFn: fetcher<GetRiskAlertContactsQuery, GetRiskAlertContactsQueryVariables>(client, GetRiskAlertContactsDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireDisplayValuesDocument = `
    query GetQuestionnaireDisplayValues($questionnaire_id: Int!) {
  questionnaire_scoring(where: {questionnaire_id: {_eq: $questionnaire_id}}) {
    display_color
    display_name
    lower_bound
    id
    upper_bound
  }
}
    `;

export const useGetQuestionnaireDisplayValuesQuery = <
      TData = GetQuestionnaireDisplayValuesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireDisplayValuesQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireDisplayValuesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireDisplayValuesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireDisplayValuesQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireDisplayValues', variables],
    queryFn: fetcher<GetQuestionnaireDisplayValuesQuery, GetQuestionnaireDisplayValuesQueryVariables>(client, GetQuestionnaireDisplayValuesDocument, variables, headers),
    ...options
  }
    )};

export const GetPractitionerCasemixDocument = `
    query GetPractitionerCasemix($completed_after: timestamptz!) {
  vw_questionnaire_display_values(where: {completed_at: {_gte: $completed_after}}) {
    casemix_display_order
    user_id
    practitioner_id
  }
}
    `;

export const useGetPractitionerCasemixQuery = <
      TData = GetPractitionerCasemixQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPractitionerCasemixQueryVariables,
      options?: Omit<UseQueryOptions<GetPractitionerCasemixQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPractitionerCasemixQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPractitionerCasemixQuery, TError, TData>(
      {
    queryKey: ['GetPractitionerCasemix', variables],
    queryFn: fetcher<GetPractitionerCasemixQuery, GetPractitionerCasemixQueryVariables>(client, GetPractitionerCasemixDocument, variables, headers),
    ...options
  }
    )};

export const GetCasemixCategoriesDocument = `
    query GetCasemixCategories {
  casemix_category(order_by: {display_order: asc}) {
    category
    display_color
    display_order
  }
}
    `;

export const useGetCasemixCategoriesQuery = <
      TData = GetCasemixCategoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCasemixCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetCasemixCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCasemixCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetCasemixCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetCasemixCategories'] : ['GetCasemixCategories', variables],
    queryFn: fetcher<GetCasemixCategoriesQuery, GetCasemixCategoriesQueryVariables>(client, GetCasemixCategoriesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireScoringBoundsDocument = `
    query GetQuestionnaireScoringBounds($questionnaireId: Int!) {
  questionnaire_scoring(
    where: {questionnaire_id: {_eq: $questionnaireId}}
    order_by: {lower_bound: asc}
  ) {
    lower_bound
    upper_bound
  }
}
    `;

export const useGetQuestionnaireScoringBoundsQuery = <
      TData = GetQuestionnaireScoringBoundsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireScoringBoundsQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireScoringBoundsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireScoringBoundsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireScoringBoundsQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireScoringBounds', variables],
    queryFn: fetcher<GetQuestionnaireScoringBoundsQuery, GetQuestionnaireScoringBoundsQueryVariables>(client, GetQuestionnaireScoringBoundsDocument, variables, headers),
    ...options
  }
    )};

export const GetNotifyAllPractitionersFromQuestionnaireTakeDocument = `
    query GetNotifyAllPractitionersFromQuestionnaireTake($id: Int!) {
  questionnaire_takes(where: {id: {_eq: $id}}) {
    notify_connected_practitioners
    user_id
  }
}
    `;

export const useGetNotifyAllPractitionersFromQuestionnaireTakeQuery = <
      TData = GetNotifyAllPractitionersFromQuestionnaireTakeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetNotifyAllPractitionersFromQuestionnaireTakeQueryVariables,
      options?: Omit<UseQueryOptions<GetNotifyAllPractitionersFromQuestionnaireTakeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNotifyAllPractitionersFromQuestionnaireTakeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNotifyAllPractitionersFromQuestionnaireTakeQuery, TError, TData>(
      {
    queryKey: ['GetNotifyAllPractitionersFromQuestionnaireTake', variables],
    queryFn: fetcher<GetNotifyAllPractitionersFromQuestionnaireTakeQuery, GetNotifyAllPractitionersFromQuestionnaireTakeQueryVariables>(client, GetNotifyAllPractitionersFromQuestionnaireTakeDocument, variables, headers),
    ...options
  }
    )};

export const GetAllConnectedPractitionersContactInfoDocument = `
    query GetAllConnectedPractitionersContactInfo($userId: uuid!) {
  invite_codes(where: {status: {_eq: "connected"}, client_id: {_eq: $userId}}) {
    userByPractitionerId {
      phone_number
      display_name
      first_name
      last_name
      id
    }
  }
}
    `;

export const useGetAllConnectedPractitionersContactInfoQuery = <
      TData = GetAllConnectedPractitionersContactInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllConnectedPractitionersContactInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetAllConnectedPractitionersContactInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllConnectedPractitionersContactInfoQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllConnectedPractitionersContactInfoQuery, TError, TData>(
      {
    queryKey: ['GetAllConnectedPractitionersContactInfo', variables],
    queryFn: fetcher<GetAllConnectedPractitionersContactInfoQuery, GetAllConnectedPractitionersContactInfoQueryVariables>(client, GetAllConnectedPractitionersContactInfoDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireScheduleNotifyAllDocument = `
    query GetQuestionnaireScheduleNotifyAll($id: Int!) {
  questionnaire_schedules_by_pk(id: $id) {
    notify_connected_practitioners
  }
}
    `;

export const useGetQuestionnaireScheduleNotifyAllQuery = <
      TData = GetQuestionnaireScheduleNotifyAllQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireScheduleNotifyAllQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireScheduleNotifyAllQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireScheduleNotifyAllQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireScheduleNotifyAllQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireScheduleNotifyAll', variables],
    queryFn: fetcher<GetQuestionnaireScheduleNotifyAllQuery, GetQuestionnaireScheduleNotifyAllQueryVariables>(client, GetQuestionnaireScheduleNotifyAllDocument, variables, headers),
    ...options
  }
    )};

export const GetOrganizationFeaturesByOrgIdDocument = `
    query GetOrganizationFeaturesByOrgId($id: Int!) {
  organization_features(where: {org_id: {_eq: $id}}) {
    org_id
    second_checkin_question
    brite_features
    mvp2_features
    dbt_diary
    vira_path
    vira_scribe
    vira_loop
  }
}
    `;

export const useGetOrganizationFeaturesByOrgIdQuery = <
      TData = GetOrganizationFeaturesByOrgIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrganizationFeaturesByOrgIdQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationFeaturesByOrgIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationFeaturesByOrgIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrganizationFeaturesByOrgIdQuery, TError, TData>(
      {
    queryKey: ['GetOrganizationFeaturesByOrgId', variables],
    queryFn: fetcher<GetOrganizationFeaturesByOrgIdQuery, GetOrganizationFeaturesByOrgIdQueryVariables>(client, GetOrganizationFeaturesByOrgIdDocument, variables, headers),
    ...options
  }
    )};

export const GetSafetyPlanByUserIdDocument = `
    query GetSafetyPlanByUserId($userId: uuid!, $status: enum_safety_plan_status_enum!) {
  safety_plan(
    where: {user_id: {_eq: $userId}, status: {_neq: $status}}
    order_by: {created_at: desc}
  ) {
    user_id
    created_at
    id
    safety_plan_template_id
    status
    status_changed_at
    updated_at
    updated_by
    responses
  }
}
    `;

export const useGetSafetyPlanByUserIdQuery = <
      TData = GetSafetyPlanByUserIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSafetyPlanByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSafetyPlanByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSafetyPlanByUserIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSafetyPlanByUserIdQuery, TError, TData>(
      {
    queryKey: ['GetSafetyPlanByUserId', variables],
    queryFn: fetcher<GetSafetyPlanByUserIdQuery, GetSafetyPlanByUserIdQueryVariables>(client, GetSafetyPlanByUserIdDocument, variables, headers),
    ...options
  }
    )};

export const GetSafetyPlanSectionsDocument = `
    query GetSafetyPlanSections {
  safety_plan_sections {
    safety_plan_template_id
    ...SafetyPlanSections
  }
}
    ${SafetyPlanSectionsFragmentDoc}`;

export const useGetSafetyPlanSectionsQuery = <
      TData = GetSafetyPlanSectionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSafetyPlanSectionsQueryVariables,
      options?: Omit<UseQueryOptions<GetSafetyPlanSectionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSafetyPlanSectionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSafetyPlanSectionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSafetyPlanSections'] : ['GetSafetyPlanSections', variables],
    queryFn: fetcher<GetSafetyPlanSectionsQuery, GetSafetyPlanSectionsQueryVariables>(client, GetSafetyPlanSectionsDocument, variables, headers),
    ...options
  }
    )};

export const GetSafetyPlanTemplateIdDocument = `
    query GetSafetyPlanTemplateId($name: String) {
  safety_plan_template(where: {name: {_eq: $name}}) {
    id
    name
    plan_type
  }
}
    `;

export const useGetSafetyPlanTemplateIdQuery = <
      TData = GetSafetyPlanTemplateIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSafetyPlanTemplateIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSafetyPlanTemplateIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSafetyPlanTemplateIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSafetyPlanTemplateIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSafetyPlanTemplateId'] : ['GetSafetyPlanTemplateId', variables],
    queryFn: fetcher<GetSafetyPlanTemplateIdQuery, GetSafetyPlanTemplateIdQueryVariables>(client, GetSafetyPlanTemplateIdDocument, variables, headers),
    ...options
  }
    )};

export const GetClientMobileDeviceDetailsDocument = `
    query GetClientMobileDeviceDetails($user_id: uuid) {
  mobile_device_data(
    where: {user_id: {_eq: $user_id}}
    limit: 1
    order_by: {created_at: desc}
  ) {
    os_version
    device_model
    device_make
    created_at
    app_version
    user {
      notification_time
    }
    devicePermissionsByUser {
      permission_status
      permission_type
      created_at
      id
    }
  }
}
    `;

export const useGetClientMobileDeviceDetailsQuery = <
      TData = GetClientMobileDeviceDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetClientMobileDeviceDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetClientMobileDeviceDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientMobileDeviceDetailsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetClientMobileDeviceDetailsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetClientMobileDeviceDetails'] : ['GetClientMobileDeviceDetails', variables],
    queryFn: fetcher<GetClientMobileDeviceDetailsQuery, GetClientMobileDeviceDetailsQueryVariables>(client, GetClientMobileDeviceDetailsDocument, variables, headers),
    ...options
  }
    )};

export const GetOrganizationAiMembersDocument = `
    query GetOrganizationAiMembers {
  organization_features {
    org_id
    ai_services_org_members
  }
}
    `;

export const useGetOrganizationAiMembersQuery = <
      TData = GetOrganizationAiMembersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrganizationAiMembersQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationAiMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationAiMembersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrganizationAiMembersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetOrganizationAiMembers'] : ['GetOrganizationAiMembers', variables],
    queryFn: fetcher<GetOrganizationAiMembersQuery, GetOrganizationAiMembersQueryVariables>(client, GetOrganizationAiMembersDocument, variables, headers),
    ...options
  }
    )};

export const GetSafetyPlanSectionsWithDocument = `
    query GetSafetyPlanSectionsWith($template_id: uuid) {
  safety_plan_sections(
    where: {safety_plan_template_id: {_eq: $template_id}}
    order_by: {display_order: asc}
  ) {
    safety_plan_template_id
    ...SafetyPlanSections
  }
}
    ${SafetyPlanSectionsFragmentDoc}`;

export const useGetSafetyPlanSectionsWithQuery = <
      TData = GetSafetyPlanSectionsWithQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSafetyPlanSectionsWithQueryVariables,
      options?: Omit<UseQueryOptions<GetSafetyPlanSectionsWithQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSafetyPlanSectionsWithQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSafetyPlanSectionsWithQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSafetyPlanSectionsWith'] : ['GetSafetyPlanSectionsWith', variables],
    queryFn: fetcher<GetSafetyPlanSectionsWithQuery, GetSafetyPlanSectionsWithQueryVariables>(client, GetSafetyPlanSectionsWithDocument, variables, headers),
    ...options
  }
    )};

export const GetSafetyPlansDocument = `
    query GetSafetyPlans {
  safety_plan(order_by: {created_at: desc}) {
    user_id
    created_at
    id
    safety_plan_template_id
    status
    status_changed_at
    updated_at
    updated_by
    responses
  }
}
    `;

export const useGetSafetyPlansQuery = <
      TData = GetSafetyPlansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSafetyPlansQueryVariables,
      options?: Omit<UseQueryOptions<GetSafetyPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSafetyPlansQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSafetyPlansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSafetyPlans'] : ['GetSafetyPlans', variables],
    queryFn: fetcher<GetSafetyPlansQuery, GetSafetyPlansQueryVariables>(client, GetSafetyPlansDocument, variables, headers),
    ...options
  }
    )};

export const GetLastSafetyChecklistRecipientsLogByRecipientDocument = `
    query GetLastSafetyChecklistRecipientsLogByRecipient($user_id: uuid, $email_address: String) {
  safety_checklist_recipients_log(
    where: {user_id: {_eq: $user_id}, email_address: {_eq: $email_address}}
    order_by: {created_at: desc_nulls_last}
    limit: 1
  ) {
    id
    user_id
    created_at
    email_address
  }
}
    `;

export const useGetLastSafetyChecklistRecipientsLogByRecipientQuery = <
      TData = GetLastSafetyChecklistRecipientsLogByRecipientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetLastSafetyChecklistRecipientsLogByRecipientQueryVariables,
      options?: Omit<UseQueryOptions<GetLastSafetyChecklistRecipientsLogByRecipientQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLastSafetyChecklistRecipientsLogByRecipientQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetLastSafetyChecklistRecipientsLogByRecipientQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetLastSafetyChecklistRecipientsLogByRecipient'] : ['GetLastSafetyChecklistRecipientsLogByRecipient', variables],
    queryFn: fetcher<GetLastSafetyChecklistRecipientsLogByRecipientQuery, GetLastSafetyChecklistRecipientsLogByRecipientQueryVariables>(client, GetLastSafetyChecklistRecipientsLogByRecipientDocument, variables, headers),
    ...options
  }
    )};

export const GetActivitiesDocument = `
    query getActivities {
  activity(order_by: {display_order: asc}) {
    id
    category
    sub_category_id
    display_name
    description
    icon_uri
    header_uri
    created_at
    updated_at
    display_order
  }
}
    `;

export const useGetActivitiesQuery = <
      TData = GetActivitiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActivitiesQueryVariables,
      options?: Omit<UseQueryOptions<GetActivitiesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActivitiesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActivitiesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getActivities'] : ['getActivities', variables],
    queryFn: fetcher<GetActivitiesQuery, GetActivitiesQueryVariables>(client, GetActivitiesDocument, variables, headers),
    ...options
  }
    )};

export const GetActivitySubCategoriesDocument = `
    query GetActivitySubCategories {
  activity_sub_category {
    id
    display_name
    description
    icon
  }
}
    `;

export const useGetActivitySubCategoriesQuery = <
      TData = GetActivitySubCategoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActivitySubCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetActivitySubCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActivitySubCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActivitySubCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActivitySubCategories'] : ['GetActivitySubCategories', variables],
    queryFn: fetcher<GetActivitySubCategoriesQuery, GetActivitySubCategoriesQueryVariables>(client, GetActivitySubCategoriesDocument, variables, headers),
    ...options
  }
    )};

export const GetActivityResourcesDocument = `
    query GetActivityResources {
  activity_resource {
    id
    display_name
    description
    uri
    activity_id
    activity_resource_category_id
    created_at
    updated_at
  }
}
    `;

export const useGetActivityResourcesQuery = <
      TData = GetActivityResourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActivityResourcesQueryVariables,
      options?: Omit<UseQueryOptions<GetActivityResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActivityResourcesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActivityResourcesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActivityResources'] : ['GetActivityResources', variables],
    queryFn: fetcher<GetActivityResourcesQuery, GetActivityResourcesQueryVariables>(client, GetActivityResourcesDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakesByUserIdAndDateRangeDocument = `
    query GetQuestionnaireTakesByUserIdAndDateRange($userId: uuid!, $start: timestamptz!, $end: timestamptz!) {
  questionnaire_takes(
    where: {_and: {user_id: {_eq: $userId}, completed_at: {_gte: $start, _lte: $end}}}
    order_by: {completed_at: desc_nulls_last}
  ) {
    rating_score
    raw_score
    severity_score
    completed_at
    completion_status
    questionnaire_responses {
      questionnaire_item {
        question
        header
        display_order
      }
      questionnaire_response_options {
        response_text
        response_value
        triggers_risk_alert
      }
    }
    questionnaireDisplayValues {
      questionnaire_id
      questionnaire_name
      display_score
      display_score_type
      scoring_display_color
      scoring_display_name
    }
    questionnaire_schedule {
      questionnaire {
        contains_risk_questions
        name
        id
      }
    }
  }
}
    `;

export const useGetQuestionnaireTakesByUserIdAndDateRangeQuery = <
      TData = GetQuestionnaireTakesByUserIdAndDateRangeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireTakesByUserIdAndDateRangeQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakesByUserIdAndDateRangeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakesByUserIdAndDateRangeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakesByUserIdAndDateRangeQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireTakesByUserIdAndDateRange', variables],
    queryFn: fetcher<GetQuestionnaireTakesByUserIdAndDateRangeQuery, GetQuestionnaireTakesByUserIdAndDateRangeQueryVariables>(client, GetQuestionnaireTakesByUserIdAndDateRangeDocument, variables, headers),
    ...options
  }
    )};

export const GetActivityResourceCategoriesDocument = `
    query GetActivityResourceCategories {
  activity_resource_category {
    id
    display_name
    description
    icon_uri
    icon_name
    resource_type
  }
}
    `;

export const useGetActivityResourceCategoriesQuery = <
      TData = GetActivityResourceCategoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActivityResourceCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetActivityResourceCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActivityResourceCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActivityResourceCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActivityResourceCategories'] : ['GetActivityResourceCategories', variables],
    queryFn: fetcher<GetActivityResourceCategoriesQuery, GetActivityResourceCategoriesQueryVariables>(client, GetActivityResourceCategoriesDocument, variables, headers),
    ...options
  }
    )};

export const GetVirasafeMetricsDocument = `
    query getVirasafeMetrics {
  vw_user_virasafe_metrics {
    user_id
    n_day_streak
    n_weekly_keep_me_calm
    n_weekly_keep_me_safe
    top_engaged_activity_1
    top_engaged_activity_2
    top_engaged_activity_3
    top_engaged_activity_4
    least_distressed_activity_1
    least_distressed_activity_2
    least_distressed_activity_3
  }
}
    `;

export const useGetVirasafeMetricsQuery = <
      TData = GetVirasafeMetricsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetVirasafeMetricsQueryVariables,
      options?: Omit<UseQueryOptions<GetVirasafeMetricsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetVirasafeMetricsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetVirasafeMetricsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getVirasafeMetrics'] : ['getVirasafeMetrics', variables],
    queryFn: fetcher<GetVirasafeMetricsQuery, GetVirasafeMetricsQueryVariables>(client, GetVirasafeMetricsDocument, variables, headers),
    ...options
  }
    )};

export const ImportNudgeTakesAfterDocument = `
    query ImportNudgeTakesAfter($scheduled_at: timestamp) {
  nudge_takes(where: {scheduled_at: {_gte: $scheduled_at}}) {
    id
    created_at
    completed_at
    scheduled_at
    nudge_schedule {
      id
      practitioner_id
      message
      user {
        id
      }
      nudge {
        id
        resource_id
        domain
        resource {
          id
          author
          content
          header_image
          content_type
          title
          updated_on
        }
      }
    }
  }
}
    `;

export const useImportNudgeTakesAfterQuery = <
      TData = ImportNudgeTakesAfterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ImportNudgeTakesAfterQueryVariables,
      options?: Omit<UseQueryOptions<ImportNudgeTakesAfterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ImportNudgeTakesAfterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<ImportNudgeTakesAfterQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ImportNudgeTakesAfter'] : ['ImportNudgeTakesAfter', variables],
    queryFn: fetcher<ImportNudgeTakesAfterQuery, ImportNudgeTakesAfterQueryVariables>(client, ImportNudgeTakesAfterDocument, variables, headers),
    ...options
  }
    )};

export const GetSuperviseesBySupervisorIdDocument = `
    query GetSuperviseesBySupervisorId($userId: uuid) {
  organization_supervisors(
    where: {supervisor_id: {_eq: $userId}, ended_at: {_is_null: true}}
  ) {
    id
    organization_supervisors_organization_supervisees(
      where: {ended_at: {_is_null: true}}
    ) {
      supervisees {
        first_name
        last_name
        display_name
        id
      }
      started_at
    }
    supervisor {
      first_name
      last_name
      display_name
      id
    }
  }
}
    `;

export const useGetSuperviseesBySupervisorIdQuery = <
      TData = GetSuperviseesBySupervisorIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSuperviseesBySupervisorIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSuperviseesBySupervisorIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSuperviseesBySupervisorIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSuperviseesBySupervisorIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSuperviseesBySupervisorId'] : ['GetSuperviseesBySupervisorId', variables],
    queryFn: fetcher<GetSuperviseesBySupervisorIdQuery, GetSuperviseesBySupervisorIdQueryVariables>(client, GetSuperviseesBySupervisorIdDocument, variables, headers),
    ...options
  }
    )};

export const GetSupervisorsByOrgIdDocument = `
    query GetSupervisorsByOrgId($org_id: Int) {
  organization_supervisors(
    where: {org_id: {_eq: $org_id}, ended_at: {_is_null: true}}
  ) {
    id
    organization_supervisors_organization_supervisees(
      where: {ended_at: {_is_null: true}}
    ) {
      supervisees {
        first_name
        last_name
        display_name
        id
      }
    }
    supervisor {
      first_name
      last_name
      display_name
      id
    }
  }
}
    `;

export const useGetSupervisorsByOrgIdQuery = <
      TData = GetSupervisorsByOrgIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSupervisorsByOrgIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSupervisorsByOrgIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSupervisorsByOrgIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSupervisorsByOrgIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSupervisorsByOrgId'] : ['GetSupervisorsByOrgId', variables],
    queryFn: fetcher<GetSupervisorsByOrgIdQuery, GetSupervisorsByOrgIdQueryVariables>(client, GetSupervisorsByOrgIdDocument, variables, headers),
    ...options
  }
    )};

export const GetInviteCodeByClientAndPractitionerDocument = `
    query GetInviteCodeByClientAndPractitioner($client_id: uuid!, $practitioner_id: uuid!) {
  invite_codes(
    where: {client_id: {_eq: $client_id}, practitioner_id: {_eq: $practitioner_id}}
    limit: 1
  ) {
    code
    status
    client_id
    practitioner_id
    ended_at
  }
}
    `;

export const useGetInviteCodeByClientAndPractitionerQuery = <
      TData = GetInviteCodeByClientAndPractitionerQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInviteCodeByClientAndPractitionerQueryVariables,
      options?: Omit<UseQueryOptions<GetInviteCodeByClientAndPractitionerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInviteCodeByClientAndPractitionerQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetInviteCodeByClientAndPractitionerQuery, TError, TData>(
      {
    queryKey: ['GetInviteCodeByClientAndPractitioner', variables],
    queryFn: fetcher<GetInviteCodeByClientAndPractitionerQuery, GetInviteCodeByClientAndPractitionerQueryVariables>(client, GetInviteCodeByClientAndPractitionerDocument, variables, headers),
    ...options
  }
    )};

export const GetSchedulesForDisconnectionDocument = `
    query GetSchedulesForDisconnection($client_id: uuid!, $practitioner_id: uuid!) {
  nudge_schedules(
    where: {user_id: {_eq: $client_id}, practitioner_id: {_eq: $practitioner_id}}
  ) {
    id
  }
  questionnaire_schedules(
    where: {user_id: {_eq: $client_id}, practitioner_id: {_eq: $practitioner_id}}
  ) {
    id
  }
}
    `;

export const useGetSchedulesForDisconnectionQuery = <
      TData = GetSchedulesForDisconnectionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSchedulesForDisconnectionQueryVariables,
      options?: Omit<UseQueryOptions<GetSchedulesForDisconnectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSchedulesForDisconnectionQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSchedulesForDisconnectionQuery, TError, TData>(
      {
    queryKey: ['GetSchedulesForDisconnection', variables],
    queryFn: fetcher<GetSchedulesForDisconnectionQuery, GetSchedulesForDisconnectionQueryVariables>(client, GetSchedulesForDisconnectionDocument, variables, headers),
    ...options
  }
    )};

export const GetEndedAtFromInviteCodeDocument = `
    query GetEndedAtFromInviteCode($code: String!) {
  invite_codes(where: {code: {_eq: $code}}) {
    client_id
    practitioner_id
    ended_at
  }
}
    `;

export const useGetEndedAtFromInviteCodeQuery = <
      TData = GetEndedAtFromInviteCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEndedAtFromInviteCodeQueryVariables,
      options?: Omit<UseQueryOptions<GetEndedAtFromInviteCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEndedAtFromInviteCodeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEndedAtFromInviteCodeQuery, TError, TData>(
      {
    queryKey: ['GetEndedAtFromInviteCode', variables],
    queryFn: fetcher<GetEndedAtFromInviteCodeQuery, GetEndedAtFromInviteCodeQueryVariables>(client, GetEndedAtFromInviteCodeDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentsWithFilterDocument = `
    query GetAssessmentsWithFilter($where: assessments_bool_exp) {
  assessments(where: $where, order_by: {created_at: desc}) {
    id
    title
    subtitle
    schema_version
    first_page_id
    assessment_length
    created_at
    updated_at
    deleted_at
  }
}
    `;

export const useGetAssessmentsWithFilterQuery = <
      TData = GetAssessmentsWithFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentsWithFilterQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentsWithFilterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentsWithFilterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentsWithFilterQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentsWithFilter'] : ['GetAssessmentsWithFilter', variables],
    queryFn: fetcher<GetAssessmentsWithFilterQuery, GetAssessmentsWithFilterQueryVariables>(client, GetAssessmentsWithFilterDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentPagesInAssessmentDocument = `
    query GetAssessmentPagesInAssessment($assessmentId: uuid!) {
  assessment_pages(
    where: {assessment_id: {_eq: $assessmentId}}
    order_by: {display_order: asc}
  ) {
    id
    assessment_id
    display_order
    show_caution_modal
    created_at
    updated_at
  }
}
    `;

export const useGetAssessmentPagesInAssessmentQuery = <
      TData = GetAssessmentPagesInAssessmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAssessmentPagesInAssessmentQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentPagesInAssessmentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentPagesInAssessmentQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentPagesInAssessmentQuery, TError, TData>(
      {
    queryKey: ['GetAssessmentPagesInAssessment', variables],
    queryFn: fetcher<GetAssessmentPagesInAssessmentQuery, GetAssessmentPagesInAssessmentQueryVariables>(client, GetAssessmentPagesInAssessmentDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionsByPageIdDocument = `
    query GetAssessmentQuestionsByPageId($pageId: uuid!) {
  assessment_questions(
    where: {page_id: {_eq: $pageId}}
    order_by: {display_order: asc}
  ) {
    id
    page_id
    question_type
    display_order
    text
    explanation_text
    properties
    created_at
    updated_at
  }
}
    `;

export const useGetAssessmentQuestionsByPageIdQuery = <
      TData = GetAssessmentQuestionsByPageIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAssessmentQuestionsByPageIdQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionsByPageIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionsByPageIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionsByPageIdQuery, TError, TData>(
      {
    queryKey: ['GetAssessmentQuestionsByPageId', variables],
    queryFn: fetcher<GetAssessmentQuestionsByPageIdQuery, GetAssessmentQuestionsByPageIdQueryVariables>(client, GetAssessmentQuestionsByPageIdDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentResultsDocument = `
    query GetAssessmentResults($where: assessment_takes_bool_exp!, $limit: Int = 50, $offset: Int = 0) {
  assessment_takes(
    where: $where
    order_by: {completed_at: desc}
    limit: $limit
    offset: $offset
  ) {
    id
    assessment_id
    user_id
    started_at
    completed_at
    answers(order_by: {created_at: asc}) {
      id
      answer
      question_id
      custom_prompt_id
      question {
        id
        question_type
        properties
      }
    }
  }
}
    `;

export const useGetAssessmentResultsQuery = <
      TData = GetAssessmentResultsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAssessmentResultsQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentResultsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentResultsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentResultsQuery, TError, TData>(
      {
    queryKey: ['GetAssessmentResults', variables],
    queryFn: fetcher<GetAssessmentResultsQuery, GetAssessmentResultsQueryVariables>(client, GetAssessmentResultsDocument, variables, headers),
    ...options
  }
    )};

export const GetPopulatedAssessmentDocument = `
    query GetPopulatedAssessment($assessmentId: uuid!) {
  assessments_by_pk(id: $assessmentId) {
    updated_at
    title
    subtitle
    schema_version
    id
    first_page_id
    assessment_length
    assessments_assessment_pages {
      assessment_id
      display_order
      id
      updated_at
      show_caution_modal
      questions {
        display_order
        explanation_text
        id
        page_id
        properties
        question_type
        text
        updated_at
        created_at
      }
      created_at
    }
    deleted_at
    created_at
  }
}
    `;

export const useGetPopulatedAssessmentQuery = <
      TData = GetPopulatedAssessmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPopulatedAssessmentQueryVariables,
      options?: Omit<UseQueryOptions<GetPopulatedAssessmentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPopulatedAssessmentQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPopulatedAssessmentQuery, TError, TData>(
      {
    queryKey: ['GetPopulatedAssessment', variables],
    queryFn: fetcher<GetPopulatedAssessmentQuery, GetPopulatedAssessmentQueryVariables>(client, GetPopulatedAssessmentDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionDocument = `
    query GetAssessmentQuestion($id: uuid = "") {
  assessment_questions_by_pk(id: $id) {
    properties
    question_type
    text
    updated_at
    page_id
    id
    explanation_text
    display_order
    created_at
  }
}
    `;

export const useGetAssessmentQuestionQuery = <
      TData = GetAssessmentQuestionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentQuestionQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentQuestion'] : ['GetAssessmentQuestion', variables],
    queryFn: fetcher<GetAssessmentQuestionQuery, GetAssessmentQuestionQueryVariables>(client, GetAssessmentQuestionDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionsWithIdsInDocument = `
    query GetAssessmentQuestionsWithIdsIn($_in: [uuid!] = "") {
  assessment_questions(where: {id: {_in: $_in}}) {
    created_at
    display_order
    explanation_text
    id
    page_id
    properties
    question_type
    text
    updated_at
  }
}
    `;

export const useGetAssessmentQuestionsWithIdsInQuery = <
      TData = GetAssessmentQuestionsWithIdsInQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentQuestionsWithIdsInQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionsWithIdsInQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionsWithIdsInQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionsWithIdsInQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentQuestionsWithIdsIn'] : ['GetAssessmentQuestionsWithIdsIn', variables],
    queryFn: fetcher<GetAssessmentQuestionsWithIdsInQuery, GetAssessmentQuestionsWithIdsInQueryVariables>(client, GetAssessmentQuestionsWithIdsInDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentsDocument = `
    query GetAssessments {
  assessments {
    ...Assessment
  }
}
    ${AssessmentFragmentDoc}`;

export const useGetAssessmentsQuery = <
      TData = GetAssessmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentsQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessments'] : ['GetAssessments', variables],
    queryFn: fetcher<GetAssessmentsQuery, GetAssessmentsQueryVariables>(client, GetAssessmentsDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentPagesDocument = `
    query GetAssessmentPages {
  assessment_pages {
    ...AssessmentPage
  }
}
    ${AssessmentPageFragmentDoc}`;

export const useGetAssessmentPagesQuery = <
      TData = GetAssessmentPagesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentPagesQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentPagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentPagesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentPagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentPages'] : ['GetAssessmentPages', variables],
    queryFn: fetcher<GetAssessmentPagesQuery, GetAssessmentPagesQueryVariables>(client, GetAssessmentPagesDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionsDocument = `
    query GetAssessmentQuestions {
  assessment_questions {
    ...AssessmentQuestion
  }
}
    ${AssessmentQuestionFragmentDoc}`;

export const useGetAssessmentQuestionsQuery = <
      TData = GetAssessmentQuestionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentQuestionsQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentQuestions'] : ['GetAssessmentQuestions', variables],
    queryFn: fetcher<GetAssessmentQuestionsQuery, GetAssessmentQuestionsQueryVariables>(client, GetAssessmentQuestionsDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentBranchingRulesDocument = `
    query GetAssessmentBranchingRules {
  assessment_branching_rules {
    ...AssessmentBranchingRule
  }
}
    ${AssessmentBranchingRuleFragmentDoc}`;

export const useGetAssessmentBranchingRulesQuery = <
      TData = GetAssessmentBranchingRulesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentBranchingRulesQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentBranchingRulesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentBranchingRulesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentBranchingRulesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentBranchingRules'] : ['GetAssessmentBranchingRules', variables],
    queryFn: fetcher<GetAssessmentBranchingRulesQuery, GetAssessmentBranchingRulesQueryVariables>(client, GetAssessmentBranchingRulesDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentTakesDocument = `
    query GetAssessmentTakes {
  assessment_takes {
    ...AssessmentTake
  }
}
    ${AssessmentTakeFragmentDoc}`;

export const useGetAssessmentTakesQuery = <
      TData = GetAssessmentTakesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentTakesQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentTakesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentTakesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentTakesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentTakes'] : ['GetAssessmentTakes', variables],
    queryFn: fetcher<GetAssessmentTakesQuery, GetAssessmentTakesQueryVariables>(client, GetAssessmentTakesDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentAnswersDocument = `
    query GetAssessmentAnswers {
  assessment_answers {
    ...AssessmentAnswer
  }
}
    ${AssessmentAnswerFragmentDoc}`;

export const useGetAssessmentAnswersQuery = <
      TData = GetAssessmentAnswersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentAnswersQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentAnswersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentAnswersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentAnswersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentAnswers'] : ['GetAssessmentAnswers', variables],
    queryFn: fetcher<GetAssessmentAnswersQuery, GetAssessmentAnswersQueryVariables>(client, GetAssessmentAnswersDocument, variables, headers),
    ...options
  }
    )};

export const GetUserFeatureFlagsDocument = `
    query GetUserFeatureFlags {
  user_feature_flag {
    user_id
    jitai_features_enabled
    dbt_diary_enabled
    vira_path_enabled
  }
}
    `;

export const useGetUserFeatureFlagsQuery = <
      TData = GetUserFeatureFlagsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUserFeatureFlagsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserFeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserFeatureFlagsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserFeatureFlagsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserFeatureFlags'] : ['GetUserFeatureFlags', variables],
    queryFn: fetcher<GetUserFeatureFlagsQuery, GetUserFeatureFlagsQueryVariables>(client, GetUserFeatureFlagsDocument, variables, headers),
    ...options
  }
    )};

export const GetDataFromEhrInviteCodeDocument = `
    query GetDataFromEhrInviteCode($code: String!) {
  ehr_client_invite_codes(where: {code: {_eq: $code}}) {
    user_id
    practitioner_id
  }
}
    `;

export const useGetDataFromEhrInviteCodeQuery = <
      TData = GetDataFromEhrInviteCodeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDataFromEhrInviteCodeQueryVariables,
      options?: Omit<UseQueryOptions<GetDataFromEhrInviteCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDataFromEhrInviteCodeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDataFromEhrInviteCodeQuery, TError, TData>(
      {
    queryKey: ['GetDataFromEhrInviteCode', variables],
    queryFn: fetcher<GetDataFromEhrInviteCodeQuery, GetDataFromEhrInviteCodeQueryVariables>(client, GetDataFromEhrInviteCodeDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionCustomPromptsDocument = `
    query GetAssessmentQuestionCustomPrompts {
  assessment_question_custom_prompt {
    id
    assessment_question_id
    text
    explanation_text
    header
    created_at
    updated_at
    deleted_at
  }
}
    `;

export const useGetAssessmentQuestionCustomPromptsQuery = <
      TData = GetAssessmentQuestionCustomPromptsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAssessmentQuestionCustomPromptsQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionCustomPromptsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionCustomPromptsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionCustomPromptsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAssessmentQuestionCustomPrompts'] : ['GetAssessmentQuestionCustomPrompts', variables],
    queryFn: fetcher<GetAssessmentQuestionCustomPromptsQuery, GetAssessmentQuestionCustomPromptsQueryVariables>(client, GetAssessmentQuestionCustomPromptsDocument, variables, headers),
    ...options
  }
    )};

export const GetAssessmentQuestionCustomPromptsByClientIdDocument = `
    query GetAssessmentQuestionCustomPromptsByClientId($clientId: uuid!) {
  assessment_question_custom_prompt(where: {client_id: {_eq: $clientId}}) {
    id
    assessment_question_id
    text
    explanation_text
    header
    client_id
    created_at
    updated_at
    deleted_at
  }
}
    `;

export const useGetAssessmentQuestionCustomPromptsByClientIdQuery = <
      TData = GetAssessmentQuestionCustomPromptsByClientIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAssessmentQuestionCustomPromptsByClientIdQueryVariables,
      options?: Omit<UseQueryOptions<GetAssessmentQuestionCustomPromptsByClientIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAssessmentQuestionCustomPromptsByClientIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAssessmentQuestionCustomPromptsByClientIdQuery, TError, TData>(
      {
    queryKey: ['GetAssessmentQuestionCustomPromptsByClientId', variables],
    queryFn: fetcher<GetAssessmentQuestionCustomPromptsByClientIdQuery, GetAssessmentQuestionCustomPromptsByClientIdQueryVariables>(client, GetAssessmentQuestionCustomPromptsByClientIdDocument, variables, headers),
    ...options
  }
    )};

export const GetInviteCodesForCurrentUserDocument = `
    query GetInviteCodesForCurrentUser {
  invite_codes {
    id
    code
    client_id
    practitioner_id
    status
    created_at
    ended_at
    expiration_code
  }
}
    `;

export const useGetInviteCodesForCurrentUserQuery = <
      TData = GetInviteCodesForCurrentUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetInviteCodesForCurrentUserQueryVariables,
      options?: Omit<UseQueryOptions<GetInviteCodesForCurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInviteCodesForCurrentUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetInviteCodesForCurrentUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetInviteCodesForCurrentUser'] : ['GetInviteCodesForCurrentUser', variables],
    queryFn: fetcher<GetInviteCodesForCurrentUserQuery, GetInviteCodesForCurrentUserQueryVariables>(client, GetInviteCodesForCurrentUserDocument, variables, headers),
    ...options
  }
    )};

export const GetLastPasswordResetTicketCreationDateTimeDocument = `
    query GetLastPasswordResetTicketCreationDateTime($email: citext!) {
  auth_accounts(
    where: {email: {_eq: $email}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    updated_at
  }
}
    `;

export const useGetLastPasswordResetTicketCreationDateTimeQuery = <
      TData = GetLastPasswordResetTicketCreationDateTimeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLastPasswordResetTicketCreationDateTimeQueryVariables,
      options?: Omit<UseQueryOptions<GetLastPasswordResetTicketCreationDateTimeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLastPasswordResetTicketCreationDateTimeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetLastPasswordResetTicketCreationDateTimeQuery, TError, TData>(
      {
    queryKey: ['GetLastPasswordResetTicketCreationDateTime', variables],
    queryFn: fetcher<GetLastPasswordResetTicketCreationDateTimeQuery, GetLastPasswordResetTicketCreationDateTimeQueryVariables>(client, GetLastPasswordResetTicketCreationDateTimeDocument, variables, headers),
    ...options
  }
    )};

export const GetNudgeTakesByScheduleIdDocument = `
    query GetNudgeTakesByScheduleId($id: Int!) {
  nudge_takes(where: {nudge_schedule_id: {_eq: $id}}) {
    id
  }
}
    `;

export const useGetNudgeTakesByScheduleIdQuery = <
      TData = GetNudgeTakesByScheduleIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetNudgeTakesByScheduleIdQueryVariables,
      options?: Omit<UseQueryOptions<GetNudgeTakesByScheduleIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNudgeTakesByScheduleIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetNudgeTakesByScheduleIdQuery, TError, TData>(
      {
    queryKey: ['GetNudgeTakesByScheduleId', variables],
    queryFn: fetcher<GetNudgeTakesByScheduleIdQuery, GetNudgeTakesByScheduleIdQueryVariables>(client, GetNudgeTakesByScheduleIdDocument, variables, headers),
    ...options
  }
    )};

export const GetQuestionnaireTakesByScheduleIdDocument = `
    query GetQuestionnaireTakesByScheduleId($id: Int!) {
  questionnaire_takes(where: {questionnaire_schedule_id: {_eq: $id}}) {
    id
  }
}
    `;

export const useGetQuestionnaireTakesByScheduleIdQuery = <
      TData = GetQuestionnaireTakesByScheduleIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetQuestionnaireTakesByScheduleIdQueryVariables,
      options?: Omit<UseQueryOptions<GetQuestionnaireTakesByScheduleIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetQuestionnaireTakesByScheduleIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetQuestionnaireTakesByScheduleIdQuery, TError, TData>(
      {
    queryKey: ['GetQuestionnaireTakesByScheduleId', variables],
    queryFn: fetcher<GetQuestionnaireTakesByScheduleIdQuery, GetQuestionnaireTakesByScheduleIdQueryVariables>(client, GetQuestionnaireTakesByScheduleIdDocument, variables, headers),
    ...options
  }
    )};

export const GetPlanByUserIdAndTemplateNameDocument = `
    query GetPlanByUserIdAndTemplateName($userId: uuid!, $excludedStatus: enum_safety_plan_status_enum!, $templateName: String!) {
  safety_plan_template(where: {name: {_eq: $templateName}}, limit: 1) {
    id
    plan_type
    name
    is_read_only
    sections: safety_plan_template_safety_plan_sections(
      order_by: {display_order: asc}
    ) {
      safety_plan_template_id
      ...SafetyPlanSections
    }
    safety_plans: safety_plan_template_safety_plans(
      where: {user_id: {_eq: $userId}, status: {_neq: $excludedStatus}}
      order_by: {created_at: desc}
      limit: 1
    ) {
      user_id
      created_at
      id
      safety_plan_template_id
      status
      status_changed_at
      updated_at
      updated_by
      responses
    }
  }
}
    ${SafetyPlanSectionsFragmentDoc}`;

export const useGetPlanByUserIdAndTemplateNameQuery = <
      TData = GetPlanByUserIdAndTemplateNameQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPlanByUserIdAndTemplateNameQueryVariables,
      options?: Omit<UseQueryOptions<GetPlanByUserIdAndTemplateNameQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPlanByUserIdAndTemplateNameQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetPlanByUserIdAndTemplateNameQuery, TError, TData>(
      {
    queryKey: ['GetPlanByUserIdAndTemplateName', variables],
    queryFn: fetcher<GetPlanByUserIdAndTemplateNameQuery, GetPlanByUserIdAndTemplateNameQueryVariables>(client, GetPlanByUserIdAndTemplateNameDocument, variables, headers),
    ...options
  }
    )};

export const GetRelapsePreventionPlacesDocument = `
    query GetRelapsePreventionPlaces {
  relapse_prevention_places(where: {deleted_at: {_is_null: true}}) {
    ...RelapsePreventionPlace
    alert_name
    description
    address
    latitude
    longitude
    media_items
  }
}
    ${RelapsePreventionPlaceFragmentDoc}`;

export const useGetRelapsePreventionPlacesQuery = <
      TData = GetRelapsePreventionPlacesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRelapsePreventionPlacesQueryVariables,
      options?: Omit<UseQueryOptions<GetRelapsePreventionPlacesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRelapsePreventionPlacesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRelapsePreventionPlacesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRelapsePreventionPlaces'] : ['GetRelapsePreventionPlaces', variables],
    queryFn: fetcher<GetRelapsePreventionPlacesQuery, GetRelapsePreventionPlacesQueryVariables>(client, GetRelapsePreventionPlacesDocument, variables, headers),
    ...options
  }
    )};

export const GetRelapsePreventionPlaceVisitsDocument = `
    query GetRelapsePreventionPlaceVisits {
  relapse_prevention_place_visits {
    ...RelapsePreventionPlaceVisit
  }
}
    ${RelapsePreventionPlaceVisitFragmentDoc}`;

export const useGetRelapsePreventionPlaceVisitsQuery = <
      TData = GetRelapsePreventionPlaceVisitsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetRelapsePreventionPlaceVisitsQueryVariables,
      options?: Omit<UseQueryOptions<GetRelapsePreventionPlaceVisitsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRelapsePreventionPlaceVisitsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRelapsePreventionPlaceVisitsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRelapsePreventionPlaceVisits'] : ['GetRelapsePreventionPlaceVisits', variables],
    queryFn: fetcher<GetRelapsePreventionPlaceVisitsQuery, GetRelapsePreventionPlaceVisitsQueryVariables>(client, GetRelapsePreventionPlaceVisitsDocument, variables, headers),
    ...options
  }
    )};

export const GetClientMyPlacesTrendDocument = `
    query GetClientMyPlacesTrend($clientId: uuid!) {
  relapse_prevention_place_visits(
    where: {user_id: {_eq: $clientId}, deleted_at: {_is_null: true}, relapse_prevention_place: {deleted_at: {_is_null: true}}}
    order_by: {created_at: asc}
  ) {
    created_at
    relapse_prevention_place {
      category
      place_type
    }
  }
}
    `;

export const useGetClientMyPlacesTrendQuery = <
      TData = GetClientMyPlacesTrendQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClientMyPlacesTrendQueryVariables,
      options?: Omit<UseQueryOptions<GetClientMyPlacesTrendQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientMyPlacesTrendQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetClientMyPlacesTrendQuery, TError, TData>(
      {
    queryKey: ['GetClientMyPlacesTrend', variables],
    queryFn: fetcher<GetClientMyPlacesTrendQuery, GetClientMyPlacesTrendQueryVariables>(client, GetClientMyPlacesTrendDocument, variables, headers),
    ...options
  }
    )};

export const GetRelapsePreventionPlacesByUserDocument = `
    query GetRelapsePreventionPlacesByUser($userId: uuid!) {
  relapse_prevention_places(
    where: {user_id: {_eq: $userId}, deleted_at: {_is_null: true}}
  ) {
    ...RelapsePreventionPlace
  }
}
    ${RelapsePreventionPlaceFragmentDoc}`;

export const useGetRelapsePreventionPlacesByUserQuery = <
      TData = GetRelapsePreventionPlacesByUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRelapsePreventionPlacesByUserQueryVariables,
      options?: Omit<UseQueryOptions<GetRelapsePreventionPlacesByUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRelapsePreventionPlacesByUserQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetRelapsePreventionPlacesByUserQuery, TError, TData>(
      {
    queryKey: ['GetRelapsePreventionPlacesByUser', variables],
    queryFn: fetcher<GetRelapsePreventionPlacesByUserQuery, GetRelapsePreventionPlacesByUserQueryVariables>(client, GetRelapsePreventionPlacesByUserDocument, variables, headers),
    ...options
  }
    )};

export const GetUserDocument = `
    subscription GetUser($userId: uuid!) {
  users_by_pk(id: $userId) {
    ...MobileUser
  }
}
    ${MobileUserFragmentDoc}`;
export const GetUserScheduledItemsDocument = `
    subscription GetUserScheduledItems($userId: uuid!) {
  users_by_pk(id: $userId) {
    questionnaire_takes {
      ...QuestionnaireTake
    }
    nudge_takes {
      ...NudgeTake
    }
  }
}
    ${QuestionnaireTakeFragmentDoc}
${NudgeTakeFragmentDoc}`;